const australiaShape = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "id": "AU",
      "properties": {
        "name": "Australia",
        "density": 0
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                131.5358993007469,
                -31.605564094355746
              ],
              [
                131.34555099503777,
                -31.530938448567156
              ],
              [
                131.17750087179192,
                -31.47763442760775
              ],
              [
                131.13542727256944,
                -31.474786049625145
              ],
              [
                131.09229575797193,
                -31.491957265711633
              ],
              [
                130.99350021162252,
                -31.554294563318653
              ],
              [
                130.83375082433565,
                -31.60173914127655
              ],
              [
                130.79004964584985,
                -31.608086783047177
              ],
              [
                130.69678797264646,
                -31.605564094355746
              ],
              [
                130.5476994004247,
                -31.585625876925768
              ],
              [
                130.3118595512591,
                -31.58554448547952
              ],
              [
                130.26742594725604,
                -31.574476755366124
              ],
              [
                130.15691165813487,
                -31.57390716592348
              ],
              [
                130.13672934403635,
                -31.57683680511732
              ],
              [
                130.07878664204313,
                -31.59433356339761
              ],
              [
                129.943614139428,
                -31.589288042049862
              ],
              [
                129.75318447425985,
                -31.615492519523077
              ],
              [
                129.53687583520667,
                -31.622246976895735
              ],
              [
                129.4710392833248,
                -31.640801744816855
              ],
              [
                129.4511824717857,
                -31.64332444112607
              ],
              [
                129.36548911279638,
                -31.64332444112607
              ],
              [
                129.30836019801743,
                -31.654717652912193
              ],
              [
                129.2866317261058,
                -31.65642673329551
              ],
              [
                129.22136480274708,
                -31.654392235387384
              ],
              [
                129.20045008509302,
                -31.65642673329551
              ],
              [
                129.13835694299587,
                -31.67750411185819
              ],
              [
                129.12370852972904,
                -31.678887627399895
              ],
              [
                129.09310954199444,
                -31.677422719763086
              ],
              [
                129.00009199896073,
                -31.68922292820195
              ],
              [
                128.9900008718694,
                -31.69052505308285
              ],
              [
                128.9316512182248,
                -31.708103079220432
              ],
              [
                128.77068118468253,
                -31.77825286009014
              ],
              [
                128.75538171214788,
                -31.793633733361226
              ],
              [
                128.72388754149623,
                -31.80364343393418
              ],
              [
                128.65528404892797,
                -31.845798432638286
              ],
              [
                128.21892338845012,
                -32.017673468849814
              ],
              [
                128.0173446081623,
                -32.084242470411745
              ],
              [
                127.76628664823235,
                -32.12314217019903
              ],
              [
                127.58594810118952,
                -32.18238695121025
              ],
              [
                127.56609134586851,
                -32.18466563144751
              ],
              [
                127.55543053965226,
                -32.188897404157714
              ],
              [
                127.5378524241791,
                -32.20712659093504
              ],
              [
                127.53199305747188,
                -32.211358380019604
              ],
              [
                127.2887476231586,
                -32.27337011788904
              ],
              [
                127.11011804796192,
                -32.29338960925346
              ],
              [
                127.09009847331956,
                -32.30071373313846
              ],
              [
                127.0832625617941,
                -32.293877853830374
              ],
              [
                127.05298915479266,
                -32.303806304217346
              ],
              [
                126.93580159835682,
                -32.30071373313846
              ],
              [
                126.8206486564763,
                -32.31080499506187
              ],
              [
                126.78891032139227,
                -32.30071373313846
              ],
              [
                126.76026449045413,
                -32.3109676436598
              ],
              [
                126.67774501648235,
                -32.31658300322427
              ],
              [
                126.37232505807543,
                -32.28281013661652
              ],
              [
                126.27759847701799,
                -32.256280146689775
              ],
              [
                126.24878989131356,
                -32.24163172788525
              ],
              [
                126.20362390364662,
                -32.23853934223542
              ],
              [
                126.1857202649398,
                -32.23251722230699
              ],
              [
                126.17408286068756,
                -32.23691167667489
              ],
              [
                126.13786870619646,
                -32.24537530246758
              ],
              [
                126.1269637637028,
                -32.252129872577136
              ],
              [
                126.1108504252221,
                -32.26816164709643
              ],
              [
                126.1037704098685,
                -32.27337011788904
              ],
              [
                126.07878668177047,
                -32.28053156686702
              ],
              [
                126.00757900284496,
                -32.27337011788904
              ],
              [
                125.97744895630426,
                -32.284340046860194
              ],
              [
                125.92676914223499,
                -32.30694333134296
              ],
              [
                125.87000007098065,
                -32.33298307147092
              ],
              [
                125.8031185335306,
                -32.374478330549266
              ],
              [
                125.67333548854926,
                -32.458971014190254
              ],
              [
                125.53727465291932,
                -32.54837869727459
              ],
              [
                125.47422759686333,
                -32.56386038887062
              ],
              [
                125.33782714414411,
                -32.601515011261775
              ],
              [
                125.25626477423488,
                -32.639120099905995
              ],
              [
                125.09644613168138,
                -32.71217207153825
              ],
              [
                125.03630619316334,
                -32.72991303454132
              ],
              [
                125.01758880132479,
                -32.732110421394005
              ],
              [
                125.0002547648823,
                -32.737237261608605
              ],
              [
                124.9019135563197,
                -32.83365898927019
              ],
              [
                124.83399152781722,
                -32.86769807383026
              ],
              [
                124.74586019957908,
                -32.89218510561325
              ],
              [
                124.70883228088893,
                -32.903904020268946
              ],
              [
                124.51847721740005,
                -32.92780669967731
              ],
              [
                124.35694427538161,
                -32.952813556619326
              ],
              [
                124.31495198073883,
                -32.966078300425956
              ],
              [
                124.29656002498045,
                -32.97812250941992
              ],
              [
                124.25489336024401,
                -33.01336014448335
              ],
              [
                124.24293059911533,
                -33.02068464110272
              ],
              [
                124.2226668930898,
                -33.025648760808146
              ],
              [
                124.20118251003711,
                -33.03801853544524
              ],
              [
                124.16480550895878,
                -33.067966347994236
              ],
              [
                124.11654700944919,
                -33.121514448898125
              ],
              [
                124.094737188525,
                -33.15569429798741
              ],
              [
                124.08155363310802,
                -33.190850628374555
              ],
              [
                124.0755314620729,
                -33.23308688133309
              ],
              [
                124.0696720346807,
                -33.253594581486595
              ],
              [
                124.05836029127448,
                -33.27019636974961
              ],
              [
                124.0456649030195,
                -33.284600504119915
              ],
              [
                124.00831133301011,
                -33.35418046735567
              ],
              [
                124.00709069217503,
                -33.36199309949671
              ],
              [
                124.00749760935417,
                -33.3684221698659
              ],
              [
                124.00709070647483,
                -33.37704846786104
              ],
              [
                124.00391682749597,
                -33.388278828641916
              ],
              [
                123.99463948559996,
                -33.41090253117363
              ],
              [
                123.98878017470811,
                -33.43564225004918
              ],
              [
                123.97071377891858,
                -33.47975034452199
              ],
              [
                123.96550538521315,
                -33.499769748195675
              ],
              [
                123.96111083394833,
                -33.54713298866281
              ],
              [
                123.95248461287342,
                -33.56731545121442
              ],
              [
                123.9344181247068,
                -33.57561605913284
              ],
              [
                123.910899214319,
                -33.57903396412291
              ],
              [
                123.89161212918191,
                -33.58814859951548
              ],
              [
                123.87574303357232,
                -33.60125090599477
              ],
              [
                123.86304769678807,
                -33.61646895496154
              ],
              [
                123.8634546900143,
                -33.618259513966294
              ],
              [
                123.8645125819719,
                -33.62151461459219
              ],
              [
                123.86475676858655,
                -33.62558372150622
              ],
              [
                123.86304766585496,
                -33.62957110395491
              ],
              [
                123.85816485875375,
                -33.63396564527098
              ],
              [
                123.81519620041759,
                -33.65837990090448
              ],
              [
                123.75684652878111,
                -33.71412521351185
              ],
              [
                123.74317467582675,
                -33.73805104173144
              ],
              [
                123.73487390238509,
                -33.757989208550015
              ],
              [
                123.73267657876974,
                -33.766778147904134
              ],
              [
                123.734629737057,
                -33.780694233572106
              ],
              [
                123.73861744526074,
                -33.7880186160518
              ],
              [
                123.73878015639751,
                -33.794040648907256
              ],
              [
                123.72901451127314,
                -33.804945554858904
              ],
              [
                123.71078536578263,
                -33.816338828781035
              ],
              [
                123.66667721080063,
                -33.83294021854747
              ],
              [
                123.64958739739222,
                -33.84246176642841
              ],
              [
                123.64161222526246,
                -33.85125101386118
              ],
              [
                123.62769620215165,
                -33.87151466887402
              ],
              [
                123.62281327709123,
                -33.87664138828609
              ],
              [
                123.61207119802818,
                -33.877374035268026
              ],
              [
                123.58106523422063,
                -33.87623449584438
              ],
              [
                123.56666100620572,
                -33.88437265859798
              ],
              [
                123.52662198656049,
                -33.93865334778833
              ],
              [
                123.51124104340721,
                -33.939629735700954
              ],
              [
                123.49333743831286,
                -33.93124765881467
              ],
              [
                123.47836342277328,
                -33.91887775004302
              ],
              [
                123.47201585343662,
                -33.907647461602586
              ],
              [
                123.45972741838283,
                -33.90016043247816
              ],
              [
                123.38331134500865,
                -33.89088296874864
              ],
              [
                123.34359787300927,
                -33.90349704683953
              ],
              [
                123.31413827593416,
                -33.93059673586516
              ],
              [
                123.26661224440069,
                -33.986504960400715
              ],
              [
                123.23194419174358,
                -34.000746320265925
              ],
              [
                123.22877039866867,
                -33.99928154891484
              ],
              [
                123.22388753607846,
                -33.99602623774586
              ],
              [
                123.21778400869921,
                -33.99325928705624
              ],
              [
                123.21127362284376,
                -33.99334072978354
              ],
              [
                123.20573984628122,
                -33.99667747991943
              ],
              [
                123.19410235345062,
                -34.005303526362106
              ],
              [
                123.18751061458448,
                -34.00701263129589
              ],
              [
                123.15463305329803,
                -34.00945412616525
              ],
              [
                123.14698333340597,
                -34.00212995005058
              ],
              [
                123.13282315955466,
                -33.93906025116469
              ],
              [
                123.11361731411301,
                -33.90447341990154
              ],
              [
                123.08497149191646,
                -33.878350397413534
              ],
              [
                123.04688561371029,
                -33.86296966048805
              ],
              [
                123.02312265216901,
                -33.86060975910983
              ],
              [
                123.00757902253599,
                -33.863539426919985
              ],
              [
                122.99341883928527,
                -33.868096661800436
              ],
              [
                122.95411223102197,
                -33.87281678242278
              ],
              [
                122.87712646583385,
                -33.89714927960643
              ],
              [
                122.84083088726526,
                -33.90374106493788
              ],
              [
                122.81788166570762,
                -33.90455485947065
              ],
              [
                122.80762780833864,
                -33.90016043247816
              ],
              [
                122.78785241265031,
                -33.88103607156058
              ],
              [
                122.77662187156973,
                -33.87664138828609
              ],
              [
                122.76343836903631,
                -33.87900160624795
              ],
              [
                122.73560626726581,
                -33.89088296874864
              ],
              [
                122.64828537133069,
                -33.88941826758983
              ],
              [
                122.60743249888206,
                -33.89478934385194
              ],
              [
                122.57455487691384,
                -33.910821207125196
              ],
              [
                122.58423912847498,
                -33.92392343389854
              ],
              [
                122.58301843706242,
                -33.93694429429049
              ],
              [
                122.57398521989738,
                -33.94898853559329
              ],
              [
                122.56031340502498,
                -33.95916118756725
              ],
              [
                122.54086341475328,
                -33.941175909468
              ],
              [
                122.5366317521954,
                -33.93865334778833
              ],
              [
                122.53077237204002,
                -33.93661883198716
              ],
              [
                122.52637780453394,
                -33.93287526751192
              ],
              [
                122.52182045362036,
                -33.93108477780082
              ],
              [
                122.50196377756498,
                -33.945489273979064
              ],
              [
                122.48894296557323,
                -33.94353619306363
              ],
              [
                122.39014734077976,
                -33.91578543345345
              ],
              [
                122.3498641105625,
                -33.91529709423358
              ],
              [
                122.31226652816724,
                -33.92490011608441
              ],
              [
                122.27963304849305,
                -33.945489273979064
              ],
              [
                122.26775144207302,
                -33.959242328547994
              ],
              [
                122.26400802051414,
                -33.97096122016953
              ],
              [
                122.26612387112125,
                -34.0038387520416
              ],
              [
                122.25782310853965,
                -34.022067957656596
              ],
              [
                122.24024495447775,
                -34.01620852175253
              ],
              [
                122.22339928277017,
                -34.001560149323716
              ],
              [
                122.21762127893375,
                -33.99334072978354
              ],
              [
                122.20728593868192,
                -33.99749100697859
              ],
              [
                122.1992293344237,
                -34.00693118807365
              ],
              [
                122.19271897313031,
                -34.01637140887437
              ],
              [
                122.18726652595485,
                -34.020684616092424
              ],
              [
                122.09473722698338,
                -34.019138388049626
              ],
              [
                122.07357833998562,
                -34.01441826684236
              ],
              [
                122.07357832257009,
                -34.00701263129589
              ],
              [
                122.10279386602785,
                -33.98015726411235
              ],
              [
                122.10580483552977,
                -33.96404377609359
              ],
              [
                122.08236738309849,
                -33.92717864210123
              ],
              [
                122.07422939526859,
                -33.891534181068714
              ],
              [
                122.06739335597089,
                -33.87664138828609
              ],
              [
                122.06104570493231,
                -33.87078202371848
              ],
              [
                122.03956137226209,
                -33.856133676062605
              ],
              [
                122.0156356068187,
                -33.82537198991757
              ],
              [
                122.00570725974627,
                -33.82073340032383
              ],
              [
                121.99545334610839,
                -33.82244236915507
              ],
              [
                121.98145590772175,
                -33.82878993542696
              ],
              [
                121.93702231472805,
                -33.82878993542696
              ],
              [
                121.913747535818,
                -33.838555478063114
              ],
              [
                121.87924244361848,
                -33.86988710307917
              ],
              [
                121.86475663808548,
                -33.87664138828609
              ],
              [
                121.84848064773881,
                -33.88014084650325
              ],
              [
                121.81299887426044,
                -33.8951148002772
              ],
              [
                121.79371175311749,
                -33.89714927960643
              ],
              [
                121.7757267414625,
                -33.89055751291326
              ],
              [
                121.74382568545154,
                -33.86793378520249
              ],
              [
                121.7282820977026,
                -33.86296966048805
              ],
              [
                121.71697031863826,
                -33.86191186663319
              ],
              [
                121.6972762865305,
                -33.85719176783943
              ],
              [
                121.68726645032476,
                -33.856133676062605
              ],
              [
                121.67514076028802,
                -33.85898190033325
              ],
              [
                121.66521246588785,
                -33.865166988329584
              ],
              [
                121.65691163248468,
                -33.872165575302866
              ],
              [
                121.649668747207,
                -33.87664138828609
              ],
              [
                121.62842857209574,
                -33.87639737301716
              ],
              [
                121.61475663757075,
                -33.864027454817084
              ],
              [
                121.60222420183982,
                -33.84954202436682
              ],
              [
                121.58423909103708,
                -33.84246176642841
              ],
              [
                121.57642662539428,
                -33.84042733434611
              ],
              [
                121.55062912273507,
                -33.82976657804345
              ],
              [
                121.53288827533265,
                -33.81951275197708
              ],
              [
                121.52149505496187,
                -33.81910586933298
              ],
              [
                121.49830166240677,
                -33.82203548601343
              ],
              [
                121.33375091376588,
                -33.815199619159756
              ],
              [
                121.31421965522767,
                -33.81951275197708
              ],
              [
                121.27849370614061,
                -33.83277764487112
              ],
              [
                121.22852616947185,
                -33.83766026910087
              ],
              [
                121.21168053765376,
                -33.843438414649185
              ],
              [
                121.16635172760114,
                -33.86793378520249
              ],
              [
                121.16211992449593,
                -33.868259237899295
              ],
              [
                121.15674887902993,
                -33.86419033114509
              ],
              [
                121.13257904184451,
                -33.851739339729946
              ],
              [
                121.1085718069832,
                -33.843845301441746
              ],
              [
                121.09766682518907,
                -33.84246176642841
              ],
              [
                121.07960039964905,
                -33.84539141178761
              ],
              [
                121.03956136626715,
                -33.85865644891619
              ],
              [
                121.01905358269859,
                -33.86296966048805
              ],
              [
                120.9934188166984,
                -33.86296966048805
              ],
              [
                120.98170001922496,
                -33.86451578332502
              ],
              [
                120.97055091799858,
                -33.87037513229094
              ],
              [
                120.94971766016631,
                -33.86174899046241
              ],
              [
                120.92017665052927,
                -33.85711032991533
              ],
              [
                120.86768637247081,
                -33.856133676062605
              ],
              [
                120.84229578634755,
                -33.863864879010094
              ],
              [
                120.81625403367835,
                -33.87664138828609
              ],
              [
                120.79037518495004,
                -33.886000234437276
              ],
              [
                120.76531007337226,
                -33.8834774322661
              ],
              [
                120.74708087705541,
                -33.89088296874864
              ],
              [
                120.57227626987157,
                -33.891534181068714
              ],
              [
                120.56218505807985,
                -33.8929988835541
              ],
              [
                120.55298909744226,
                -33.89714927960643
              ],
              [
                120.5451766393219,
                -33.9059384310361
              ],
              [
                120.54428148615955,
                -33.91423927670721
              ],
              [
                120.54517660130999,
                -33.92180749092406
              ],
              [
                120.54273527810321,
                -33.92815532566476
              ],
              [
                120.5273543183908,
                -33.93678141287347
              ],
              [
                120.42269947317122,
                -33.96990337698094
              ],
              [
                120.39429776075895,
                -33.97380958561317
              ],
              [
                120.38160240741632,
                -33.9625790284897
              ],
              [
                120.27857511036251,
                -33.93865334778833
              ],
              [
                120.17896569325083,
                -33.93124765881467
              ],
              [
                120.1584579148286,
                -33.934991220642445
              ],
              [
                120.12256926817263,
                -33.950372133811044
              ],
              [
                120.1004338332785,
                -33.952325220555906
              ],
              [
                120.08448328979843,
                -33.94784926149393
              ],
              [
                120.05543056503575,
                -33.93092219731694
              ],
              [
                120.03907308412467,
                -33.92506269614377
              ],
              [
                120.02027428462476,
                -33.92351653319591
              ],
              [
                120.00220790598028,
                -33.92603937881163
              ],
              [
                119.98536223326703,
                -33.93141053984003
              ],
              [
                119.97022550124882,
                -33.93865334778833
              ],
              [
                119.94337005217085,
                -33.95598737539495
              ],
              [
                119.9284773529405,
                -33.96282305285076
              ],
              [
                119.90870195899377,
                -33.96599687453851
              ],
              [
                119.85889740072851,
                -33.967950275182694
              ],
              [
                119.80616289317067,
                -33.98495845534608
              ],
              [
                119.79363044664487,
                -33.993096702137116
              ],
              [
                119.73047939570402,
                -34.04851660387447
              ],
              [
                119.70264728854791,
                -34.06340902019709
              ],
              [
                119.64063562566383,
                -34.08521903503586
              ],
              [
                119.6131290723333,
                -34.1032039706969
              ],
              [
                119.62338305377003,
                -34.1110980104909
              ],
              [
                119.6181746538266,
                -34.120049692853286
              ],
              [
                119.606211850276,
                -34.12753685615358
              ],
              [
                119.58204180033478,
                -34.133721479418945
              ],
              [
                119.57203203918931,
                -34.14202227079924
              ],
              [
                119.53882891696698,
                -34.20907956801051
              ],
              [
                119.53272546119824,
                -34.216485292922165
              ],
              [
                119.49708089163715,
                -34.23902753113943
              ],
              [
                119.4848738985668,
                -34.25945404369221
              ],
              [
                119.4749455181542,
                -34.28590262140907
              ],
              [
                119.46949310050029,
                -34.31340925172749
              ],
              [
                119.46989993408621,
                -34.33603280595025
              ],
              [
                119.48389734569463,
                -34.35857515694787
              ],
              [
                119.50782309446952,
                -34.36679448985048
              ],
              [
                119.53500406233486,
                -34.371514497234465
              ],
              [
                119.55925544766711,
                -34.38372170304213
              ],
              [
                119.54656009604845,
                -34.38836029254279
              ],
              [
                119.53321377212815,
                -34.390313481018374
              ],
              [
                119.51140382598038,
                -34.398044495199
              ],
              [
                119.47950276025769,
                -34.4045548621445
              ],
              [
                119.44239341879302,
                -34.37444425588315
              ],
              [
                119.408457894047,
                -34.370049769812006
              ],
              [
                119.38502036707732,
                -34.38486090980345
              ],
              [
                119.37647541749647,
                -34.41171632060051
              ],
              [
                119.38209066139899,
                -34.440118034581154
              ],
              [
                119.4015405537319,
                -34.4587541496878
              ],
              [
                119.39087975358542,
                -34.463311455126565
              ],
              [
                119.36744226916272,
                -34.47991305092587
              ],
              [
                119.3654890703193,
                -34.48455156746525
              ],
              [
                119.36622148772804,
                -34.490817835938564
              ],
              [
                119.36402425165731,
                -34.4950496678355
              ],
              [
                119.3532006952113,
                -34.49358484814212
              ],
              [
                119.34937581067709,
                -34.48967856753827
              ],
              [
                119.34115638911013,
                -34.47405352416049
              ],
              [
                119.33366953094682,
                -34.45191836183315
              ],
              [
                119.31918386032524,
                -34.44491967734197
              ],
              [
                119.3014428608142,
                -34.44589599878541
              ],
              [
                119.28484128315567,
                -34.4525691448777
              ],
              [
                119.27418058047594,
                -34.460381864902075
              ],
              [
                119.26954193383474,
                -34.46648543334934
              ],
              [
                119.26441490118489,
                -34.486748937428175
              ],
              [
                119.2649846205467,
                -34.50945413828947
              ],
              [
                119.26059010539646,
                -34.5221494845864
              ],
              [
                119.2470808703237,
                -34.52776446597999
              ],
              [
                119.22999103152482,
                -34.532159006821146
              ],
              [
                119.2207136712292,
                -34.531833451529266
              ],
              [
                119.21656335554694,
                -34.52467215098644
              ],
              [
                119.21485433265039,
                -34.511651236096526
              ],
              [
                119.2094832286602,
                -34.503350434029336
              ],
              [
                119.20093829268801,
                -34.497979310566066
              ],
              [
                119.18930095524115,
                -34.49358484814212
              ],
              [
                119.17839608484714,
                -34.49195740561092
              ],
              [
                119.15967854871445,
                -34.4950496678355
              ],
              [
                119.14771566924874,
                -34.49358484814212
              ],
              [
                119.1389266317266,
                -34.48886484774991
              ],
              [
                119.12354572062499,
                -34.47527424491587
              ],
              [
                119.11695399951822,
                -34.472426098080334
              ],
              [
                118.93197671495102,
                -34.44589599878541
              ],
              [
                118.92212976691033,
                -34.447849244320324
              ],
              [
                118.90406327762798,
                -34.4568008932278
              ],
              [
                118.8979598247626,
                -34.4587541496878
              ],
              [
                118.84595782037215,
                -34.4525691448777
              ],
              [
                118.83985430437521,
                -34.4525691448777
              ],
              [
                118.88200931388504,
                -34.4906552120967
              ],
              [
                118.88770590233126,
                -34.5004207831162
              ],
              [
                118.87549891681,
                -34.50644301517501
              ],
              [
                118.8088484834898,
                -34.51344162166968
              ],
              [
                118.78988692940729,
                -34.51881278843536
              ],
              [
                118.75367271821246,
                -34.542738532003874
              ],
              [
                118.7400008546172,
                -34.54827241007912
              ],
              [
                118.72730551425694,
                -34.55803797522563
              ],
              [
                118.72380611834829,
                -34.57887120934785
              ],
              [
                118.73243249688706,
                -34.5983212407234
              ],
              [
                118.7573348664084,
                -34.60344824746291
              ],
              [
                118.72494553291858,
                -34.63583754832094
              ],
              [
                118.70590256383359,
                -34.6477190581267
              ],
              [
                118.66627042501112,
                -34.6568336887679
              ],
              [
                118.63249753113429,
                -34.67791093806044
              ],
              [
                118.6132919086063,
                -34.685967801849145
              ],
              [
                118.52344811497188,
                -34.70338307514427
              ],
              [
                118.47982834857197,
                -34.71705500394151
              ],
              [
                118.44263754781979,
                -34.74000412681708
              ],
              [
                118.43018645133115,
                -34.754571342352826
              ],
              [
                118.40992265775482,
                -34.788832155289526
              ],
              [
                118.39771565379053,
                -34.80527101402032
              ],
              [
                118.38738043016188,
                -34.82594171769362
              ],
              [
                118.38933354699263,
                -34.84628675255701
              ],
              [
                118.40113361148497,
                -34.87721109461354
              ],
              [
                118.39844805700125,
                -34.90097410007865
              ],
              [
                118.38510176579032,
                -34.90837983017514
              ],
              [
                118.34262133643342,
                -34.90504332397988
              ],
              [
                118.26441492709192,
                -34.911309538712764
              ],
              [
                118.24447670524707,
                -34.91676186469005
              ],
              [
                118.20240318417176,
                -34.93922290074038
              ],
              [
                118.16773520790872,
                -34.94255947356801
              ],
              [
                118.16081792877817,
                -34.945489240661594
              ],
              [
                118.158864779209,
                -34.95663827734847
              ],
              [
                118.16553789619557,
                -34.96152096509023
              ],
              [
                118.17505946542657,
                -34.9635556479744
              ],
              [
                118.18140711794076,
                -34.96591566669372
              ],
              [
                118.19288172705583,
                -34.983575169814806
              ],
              [
                118.20101972697586,
                -35.00237395594958
              ],
              [
                118.19939212289161,
                -35.016778252774195
              ],
              [
                118.18140709645118,
                -35.021172782857114
              ],
              [
                118.16920006595888,
                -35.016696872914196
              ],
              [
                118.11988367041752,
                -34.98707449873015
              ],
              [
                118.11304771716681,
                -34.99382902392012
              ],
              [
                118.1062117954163,
                -34.98707449873015
              ],
              [
                118.09213300416766,
                -34.99382902392012
              ],
              [
                118.04468834704126,
                -35.007500909085955
              ],
              [
                118.03419029990785,
                -35.01197682080751
              ],
              [
                118.0267033209716,
                -35.0139299459407
              ],
              [
                118.01685631580915,
                -35.01490650760189
              ],
              [
                118.00831139397167,
                -35.0139299459407
              ],
              [
                117.98845462300822,
                -35.00872161301702
              ],
              [
                117.97901451904129,
                -35.007500909085955
              ],
              [
                117.97169030000826,
                -35.00872161301702
              ],
              [
                117.95443769610526,
                -35.01384856621956
              ],
              [
                117.94483483180935,
                -35.01490650760189
              ],
              [
                117.93881269621679,
                -35.01336028445234
              ],
              [
                117.93425540514127,
                -35.010349217294724
              ],
              [
                117.92872155012464,
                -35.00758229025998
              ],
              [
                117.92058353004123,
                -35.007500909085955
              ],
              [
                117.91684004003685,
                -35.00994231607682
              ],
              [
                117.90886477983865,
                -35.019138278663114
              ],
              [
                117.90756269545243,
                -35.021172782857114
              ],
              [
                117.84929446658639,
                -35.02556731513637
              ],
              [
                117.83545983151959,
                -35.03142668999696
              ],
              [
                117.8320418624912,
                -35.04583098693826
              ],
              [
                117.84376061235638,
                -35.06023528265777
              ],
              [
                117.86003665412095,
                -35.07138437116814
              ],
              [
                117.88892662728115,
                -35.08171965542048
              ],
              [
                117.89771568882135,
                -35.08147551446323
              ],
              [
                117.9013777994804,
                -35.07268645491745
              ],
              [
                117.89869225397763,
                -35.064222914953255
              ],
              [
                117.89405358172334,
                -35.05478280942311
              ],
              [
                117.89323977957156,
                -35.04656340810649
              ],
              [
                117.90137780002631,
                -35.0416805970546
              ],
              [
                117.9176538410723,
                -35.047051689065825
              ],
              [
                117.93482506701362,
                -35.08131276010995
              ],
              [
                117.9519962891221,
                -35.08953215717325
              ],
              [
                117.98861738404803,
                -35.084730727099846
              ],
              [
                118.00147545501099,
                -35.088148691862685
              ],
              [
                117.99634850258067,
                -35.10369231304937
              ],
              [
                117.98275800757762,
                -35.09954192204224
              ],
              [
                117.97046959764677,
                -35.1039364573447
              ],
              [
                117.94857831920211,
                -35.11736418726288
              ],
              [
                117.93287194167554,
                -35.12037525940409
              ],
              [
                117.89047285020301,
                -35.11736418726288
              ],
              [
                117.86036217375762,
                -35.10881926641463
              ],
              [
                117.80982506512134,
                -35.07138437116814
              ],
              [
                117.74724368686965,
                -35.051364843815186
              ],
              [
                117.68433678436863,
                -35.046319267680985
              ],
              [
                117.66732832033843,
                -35.04908619461789
              ],
              [
                117.64128665595936,
                -35.061293229003404
              ],
              [
                117.6268009787353,
                -35.080254819621935
              ],
              [
                117.62086022384248,
                -35.105889584842004
              ],
              [
                117.61963951762378,
                -35.13787200013344
              ],
              [
                117.58904055947276,
                -35.12558358881669
              ],
              [
                117.53858483114188,
                -35.09221770420818
              ],
              [
                117.5035913401809,
                -35.08326587919947
              ],
              [
                117.47103925789574,
                -35.07968515169203
              ],
              [
                117.45997155112016,
                -35.07610442734151
              ],
              [
                117.40235436216739,
                -35.04664478825635
              ],
              [
                117.3899031910146,
                -35.03826262803047
              ],
              [
                117.3595483729683,
                -35.024183851933365
              ],
              [
                117.34058678500658,
                -35.01783619601362
              ],
              [
                117.33220462294013,
                -35.01816171687432
              ],
              [
                117.32398522239721,
                -35.03297291583264
              ],
              [
                117.30494225383015,
                -35.03020598764373
              ],
              [
                117.26693769581037,
                -35.01490650760189
              ],
              [
                117.24887129027131,
                -35.014092706569414
              ],
              [
                117.23959394592057,
                -35.01482512783316
              ],
              [
                117.23292076894022,
                -35.01816171687432
              ],
              [
                117.223399285333,
                -35.02076588369888
              ],
              [
                117.21216881589254,
                -35.016778252774195
              ],
              [
                117.20093834693843,
                -35.010674737870524
              ],
              [
                117.19166100404098,
                -35.007500909085955
              ],
              [
                117.1716414718022,
                -35.01327890358441
              ],
              [
                117.15894615969857,
                -35.02743905936697
              ],
              [
                117.14039147215496,
                -35.06275807132485
              ],
              [
                117.12794030004622,
                -35.056084894096735
              ],
              [
                117.10678144589136,
                -35.03834400777178
              ],
              [
                117.09546959700674,
                -35.03484465901409
              ],
              [
                117.07797285164206,
                -35.03264739324792
              ],
              [
                117.05258222695039,
                -35.023370049895654
              ],
              [
                117.04037519545643,
                -35.021172782857114
              ],
              [
                117.02808678495042,
                -35.023370049895654
              ],
              [
                117.0149031914558,
                -35.027276300958185
              ],
              [
                117.0024520189234,
                -35.02898528383872
              ],
              [
                116.99244225348978,
                -35.02459075192688
              ],
              [
                116.98170006590428,
                -35.01848723779855
              ],
              [
                116.96607506610172,
                -35.01425546721401
              ],
              [
                116.9499617851541,
                -35.01344166532426
              ],
              [
                116.93775475394034,
                -35.01816171687432
              ],
              [
                116.91724694092416,
                -35.03753020584035
              ],
              [
                116.89958743623211,
                -35.050388279487926
              ],
              [
                116.87769615951434,
                -35.05486418997868
              ],
              [
                116.84498131534308,
                -35.04908619461789
              ],
              [
                116.8309025398533,
                -35.04338958069122
              ],
              [
                116.79086347645762,
                -35.021172782857114
              ],
              [
                116.74952233224704,
                -35.01238372252062
              ],
              [
                116.73633873804086,
                -35.007500909085955
              ],
              [
                116.73096764385777,
                -35.01441822669991
              ],
              [
                116.72803795700948,
                -35.01767343501982
              ],
              [
                116.72730553533157,
                -35.02076588369888
              ],
              [
                116.72885175851165,
                -35.0280087209707
              ],
              [
                116.65837649751197,
                -35.0280087209707
              ],
              [
                116.64698326901457,
                -35.03826262803047
              ],
              [
                116.63786868591605,
                -35.05022551882293
              ],
              [
                116.61768639435927,
                -35.04306406075726
              ],
              [
                116.58480878945856,
                -35.021172782857114
              ],
              [
                116.53158613403244,
                -35.014743748068405
              ],
              [
                116.51295006596905,
                -35.00408294093445
              ],
              [
                116.5031844625083,
                -34.99993259546515
              ],
              [
                116.49008222776934,
                -34.99920012962644
              ],
              [
                116.46509850398692,
                -35.000664971972284
              ],
              [
                116.4585066460172,
                -34.99700273402756
              ],
              [
                116.4347436668559,
                -34.97340256146722
              ],
              [
                116.39503012789581,
                -34.94947678686048
              ],
              [
                116.37525472581332,
                -34.93271243819825
              ],
              [
                116.38298582558254,
                -34.924981277374336
              ],
              [
                116.46876060627196,
                -34.93922290074038
              ],
              [
                116.4882918899752,
                -34.94573338814699
              ],
              [
                116.49773200015065,
                -34.94622168322287
              ],
              [
                116.50367271526987,
                -34.93922290074038
              ],
              [
                116.50049887813678,
                -34.92888759437518
              ],
              [
                116.4894311991252,
                -34.92001721283303
              ],
              [
                116.47559652931221,
                -34.913669485113616
              ],
              [
                116.44223071184828,
                -34.90553160744142
              ],
              [
                116.42660570730678,
                -34.891859722860914
              ],
              [
                116.41382902473285,
                -34.8761533650864
              ],
              [
                116.39926196811068,
                -34.86353943395876
              ],
              [
                116.39291430159408,
                -34.85979592160956
              ],
              [
                116.38754318457414,
                -34.85751722664526
              ],
              [
                116.38135823430942,
                -34.858168153191166
              ],
              [
                116.3725692600986,
                -34.86353943395876
              ],
              [
                116.39893634314066,
                -34.90390379599735
              ],
              [
                116.37614998085726,
                -34.91741311422562
              ],
              [
                116.33082113490838,
                -34.91269291370341
              ],
              [
                116.28939862470712,
                -34.897637608242675
              ],
              [
                116.24838300659346,
                -34.877536711877674
              ],
              [
                116.09620196166335,
                -34.83863685461649
              ],
              [
                116.01978596477318,
                -34.82935954918615
              ],
              [
                116.00953203976007,
                -34.83033607369241
              ],
              [
                115.98959390709547,
                -34.834649263870325
              ],
              [
                115.97852618293078,
                -34.8356257913233
              ],
              [
                115.973887603927,
                -34.830254897065586
              ],
              [
                115.97559649216886,
                -34.818454561335884
              ],
              [
                115.98161865242237,
                -34.801446150154945
              ],
              [
                115.97242269329173,
                -34.78297285352464
              ],
              [
                115.94654376227561,
                -34.7575007938156
              ],
              [
                115.93360436387455,
                -34.722588801877585
              ],
              [
                115.91578203426378,
                -34.70191809216541
              ],
              [
                115.88672942973963,
                -34.677341547613224
              ],
              [
                115.74545336193547,
                -34.540215841674915
              ],
              [
                115.61231525718063,
                -34.44589599878541
              ],
              [
                115.57064860102588,
                -34.424737166130775
              ],
              [
                115.53492275409342,
                -34.41838965098897
              ],
              [
                115.52637775603817,
                -34.41480875610711
              ],
              [
                115.51905355545681,
                -34.40520593007576
              ],
              [
                115.51400794478,
                -34.39511470179233
              ],
              [
                115.50814858320278,
                -34.38697671005522
              ],
              [
                115.49903409121816,
                -34.38372170304213
              ],
              [
                115.48926844479159,
                -34.382094051241594
              ],
              [
                115.33472740288293,
                -34.314222899386316
              ],
              [
                115.29078213468416,
                -34.30185320574558
              ],
              [
                115.26286870755963,
                -34.298516581357724
              ],
              [
                115.1837671606492,
                -34.30185320574558
              ],
              [
                115.16488688470388,
                -34.31023521742668
              ],
              [
                115.13754315311309,
                -34.349867419915284
              ],
              [
                115.1188257360935,
                -34.363376601882436
              ],
              [
                115.10840900937608,
                -34.34433350281207
              ],
              [
                115.0178328797145,
                -34.262139582575145
              ],
              [
                115.01042734276477,
                -34.24504987647408
              ],
              [
                115.00896249047187,
                -34.2186826703097
              ],
              [
                115.01172934597724,
                -34.17913173134189
              ],
              [
                115.00993896920217,
                -34.163181184250085
              ],
              [
                115.00269619960916,
                -34.14478940875488
              ],
              [
                114.97445724080995,
                -34.09189221567099
              ],
              [
                114.97103929913965,
                -34.08269631118442
              ],
              [
                114.97437586699081,
                -34.061700172454174
              ],
              [
                114.97266688947352,
                -33.92278417221527
              ],
              [
                114.96338956708156,
                -33.88201273574247
              ],
              [
                114.96119224276646,
                -33.859551665802925
              ],
              [
                114.96387780887778,
                -33.843031527926286
              ],
              [
                114.97950286075152,
                -33.79859805159922
              ],
              [
                114.9885359526236,
                -33.781019674402366
              ],
              [
                114.97144619514432,
                -33.75628028517073
              ],
              [
                114.95899503814438,
                -33.71990336615094
              ],
              [
                114.95679767803104,
                -33.68230549762042
              ],
              [
                114.9710392512629,
                -33.65390388649309
              ],
              [
                114.99789467587297,
                -33.63103595022602
              ],
              [
                115.00391683849563,
                -33.616957234479955
              ],
              [
                115.00269620745104,
                -33.59547302261174
              ],
              [
                114.99000079367029,
                -33.54192461675909
              ],
              [
                114.98853605989613,
                -33.52109153119305
              ],
              [
                115.00269621590304,
                -33.52109153119305
              ],
              [
                115.04566496948894,
                -33.53720482020578
              ],
              [
                115.07056728560353,
                -33.563734704729065
              ],
              [
                115.09066820421111,
                -33.59295021686677
              ],
              [
                115.11882569356794,
                -33.61646895496154
              ],
              [
                115.15552816350592,
                -33.63258222783067
              ],
              [
                115.19467202592182,
                -33.644626458157724
              ],
              [
                115.23707118383636,
                -33.65113703081691
              ],
              [
                115.28272547862426,
                -33.65064874480409
              ],
              [
                115.3237410786422,
                -33.64381275042188
              ],
              [
                115.36719812876899,
                -33.63128024159297
              ],
              [
                115.40601649577094,
                -33.61467869767548
              ],
              [
                115.43409269162906,
                -33.59547302261174
              ],
              [
                115.51710042913072,
                -33.51238365884848
              ],
              [
                115.57553145195843,
                -33.426690376545864
              ],
              [
                115.60482833376345,
                -33.36956148508296
              ],
              [
                115.61882569387284,
                -33.32073327819323
              ],
              [
                115.6259871248116,
                -33.308037904345625
              ],
              [
                115.63697351019296,
                -33.29924897015179
              ],
              [
                115.64616945792608,
                -33.30038825826717
              ],
              [
                115.65772542447245,
                -33.30510825670207
              ],
              [
                115.67709389578934,
                -33.308037904345625
              ],
              [
                115.7016707098644,
                -33.29713293592829
              ],
              [
                115.71013434832041,
                -33.27068458833842
              ],
              [
                115.70785572966179,
                -33.20842879227728
              ],
              [
                115.70484457901672,
                -33.192478081731146
              ],
              [
                115.6979272618729,
                -33.1931291233998
              ],
              [
                115.69109133408917,
                -33.20484789685373
              ],
              [
                115.68637126933663,
                -33.240492398676125
              ],
              [
                115.67367597921535,
                -33.28769297206336
              ],
              [
                115.66684004221523,
                -33.28769297206336
              ],
              [
                115.6718856302966,
                -33.12053805883412
              ],
              [
                115.67457120276714,
                -33.02499775292319
              ],
              [
                115.66000405714492,
                -32.93816486781659
              ],
              [
                115.62468514298851,
                -32.811781627166695
              ],
              [
                115.61280363991989,
                -32.72844831091349
              ],
              [
                115.60385181076214,
                -32.695001030666305
              ],
              [
                115.60092212783279,
                -32.66171653780009
              ],
              [
                115.61231526407312,
                -32.62281658026889
              ],
              [
                115.6296493445028,
                -32.59238060751645
              ],
              [
                115.67579190117551,
                -32.53492613036536
              ],
              [
                115.7009383291227,
                -32.512953340646625
              ],
              [
                115.69336999696402,
                -32.55266694619712
              ],
              [
                115.63990325150183,
                -32.60857527075214
              ],
              [
                115.63965911069758,
                -32.65691511488359
              ],
              [
                115.66797934405022,
                -32.73064539655844
              ],
              [
                115.69109137111099,
                -32.77060319112901
              ],
              [
                115.7141219888754,
                -32.78045023996954
              ],
              [
                115.72299232501048,
                -32.76376704693881
              ],
              [
                115.71713299845729,
                -32.74163174429833
              ],
              [
                115.69792730274507,
                -32.70322036339754
              ],
              [
                115.68376716202533,
                -32.690199568686126
              ],
              [
                115.68051189579047,
                -32.681247608848544
              ],
              [
                115.68018643625766,
                -32.665459993400034
              ],
              [
                115.67823323322871,
                -32.65618246581833
              ],
              [
                115.67367596792529,
                -32.64275479462963
              ],
              [
                115.66187584476388,
                -32.63396574773119
              ],
              [
                115.65886483891961,
                -32.628513417863466
              ],
              [
                115.6668400040561,
                -32.62281658026889
              ],
              [
                115.67676838905305,
                -32.62281658026889
              ],
              [
                115.69385823491255,
                -32.63372153270569
              ],
              [
                115.70443763768311,
                -32.636488402663325
              ],
              [
                115.74870857729816,
                -32.63730245334028
              ],
              [
                115.76286864008904,
                -32.62769936888841
              ],
              [
                115.76929775483549,
                -32.602308929410874
              ],
              [
                115.7629501205526,
                -32.57903424176071
              ],
              [
                115.74634847347008,
                -32.57008221789851
              ],
              [
                115.72925864990655,
                -32.56609463515454
              ],
              [
                115.72152760270934,
                -32.55730574522102
              ],
              [
                115.71452887878895,
                -32.53704201204524
              ],
              [
                115.71412188238438,
                -32.5266251192407
              ],
              [
                115.71705164844744,
                -32.51921970505259
              ],
              [
                115.72974696560827,
                -32.50188573331618
              ],
              [
                115.73511804701558,
                -32.49244559948592
              ],
              [
                115.74545334607932,
                -32.45566177655798
              ],
              [
                115.745616096597,
                -32.41871513672693
              ],
              [
                115.73365320576929,
                -32.38795341819334
              ],
              [
                115.70785564934651,
                -32.3695614186575
              ],
              [
                115.73194421669737,
                -32.34587983915565
              ],
              [
                115.73585044244918,
                -32.3331844682341
              ],
              [
                115.72779381463036,
                -32.315036713724325
              ],
              [
                115.71436608853683,
                -32.30299246164415
              ],
              [
                115.68677820866488,
                -32.29021579531331
              ],
              [
                115.67367600531536,
                -32.27337011788904
              ],
              [
                115.7197371876214,
                -32.2732073202491
              ],
              [
                115.73585044876965,
                -32.26441820726845
              ],
              [
                115.74195396030294,
                -32.242364162928176
              ],
              [
                115.74529056261288,
                -32.222832944874234
              ],
              [
                115.75684657778943,
                -32.18564225187113
              ],
              [
                115.75562586543124,
                -32.163506813401625
              ],
              [
                115.75098719243118,
                -32.15341566501521
              ],
              [
                115.7387801454664,
                -32.13941823053711
              ],
              [
                115.73511806554639,
                -32.129489915726275
              ],
              [
                115.74089604805636,
                -32.11451592661108
              ],
              [
                115.74268639361642,
                -32.10230885107267
              ],
              [
                115.73853598404314,
                -32.09148523574155
              ],
              [
                115.7293400174596,
                -32.07463952644359
              ],
              [
                115.72779384358,
                -32.05510839782084
              ],
              [
                115.74366297657477,
                -31.92782973272732
              ],
              [
                115.7215275493268,
                -31.772637650927795
              ],
              [
                115.70093834720217,
                -31.691176040499027
              ],
              [
                115.68034914297859,
                -31.64861416124487
              ],
              [
                115.60482833669305,
                -31.546563448078597
              ],
              [
                115.55062907280674,
                -31.434746929833118
              ],
              [
                115.45460044054617,
                -31.30348068543323
              ],
              [
                115.38306726387977,
                -31.133884398207925
              ],
              [
                115.31299889958183,
                -30.99081798136453
              ],
              [
                115.23853599489652,
                -30.878676016407965
              ],
              [
                115.18091882770865,
                -30.82724377844748
              ],
              [
                115.16651450798454,
                -30.765883042250312
              ],
              [
                115.1660262268671,
                -30.7555477549263
              ],
              [
                115.16195723875876,
                -30.742120080732636
              ],
              [
                115.1010848332195,
                -30.63339609520891
              ],
              [
                115.09839929150631,
                -30.625176708129878
              ],
              [
                115.0950626995238,
                -30.60572683028825
              ],
              [
                115.06080162677752,
                -30.52239348211113
              ],
              [
                115.05697676036182,
                -30.50546640761197
              ],
              [
                115.05738365756243,
                -30.46746184052002
              ],
              [
                115.05494225690217,
                -30.448011984723887
              ],
              [
                115.03419029738153,
                -30.37037525099724
              ],
              [
                115.02263430487787,
                -30.340590085596705
              ],
              [
                115.01978600332052,
                -30.33562590717872
              ],
              [
                115.01107832688969,
                -30.324965117796612
              ],
              [
                115.00896243465571,
                -30.320082286393113
              ],
              [
                115.01050866242198,
                -30.31267669750075
              ],
              [
                115.02027428504745,
                -30.30250416512725
              ],
              [
                115.02263430998613,
                -30.296156505275984
              ],
              [
                115.02377363636579,
                -30.274183858363976
              ],
              [
                115.02279706823592,
                -30.26287199555932
              ],
              [
                115.01921633932746,
                -30.25457121480172
              ],
              [
                115.01042727651814,
                -30.248223556617702
              ],
              [
                114.98902428743249,
                -30.237074483560093
              ],
              [
                114.98170006741381,
                -30.23202890781423
              ],
              [
                114.97486412816805,
                -30.21404387575274
              ],
              [
                114.97820071937934,
                -30.19182708743495
              ],
              [
                114.98487389097782,
                -30.168145432814537
              ],
              [
                114.9885360041636,
                -30.14568450344358
              ],
              [
                114.98633873823701,
                -30.136000258642877
              ],
              [
                114.9770613923761,
                -30.115492441587115
              ],
              [
                114.97120201827586,
                -30.092380465029162
              ],
              [
                114.96290123796017,
                -30.082696221891204
              ],
              [
                114.95378665440178,
                -30.074476819369842
              ],
              [
                114.94752037981216,
                -30.06682708321396
              ],
              [
                114.9426375660038,
                -30.03101979001019
              ],
              [
                114.96745852193146,
                -29.902439037781374
              ],
              [
                114.96558674227019,
                -29.880629047171386
              ],
              [
                114.95101976559425,
                -29.84490335967664
              ],
              [
                114.94752035739296,
                -29.83001061521911
              ],
              [
                114.94068443480779,
                -29.744073157773762
              ],
              [
                114.94605557984514,
                -29.65813580042856
              ],
              [
                114.96119221068766,
                -29.580254694273513
              ],
              [
                114.9793400776445,
                -29.523207396165876
              ],
              [
                114.98170009621342,
                -29.501723000323924
              ],
              [
                114.97877034630139,
                -29.47991292652622
              ],
              [
                114.95378666959061,
                -29.42937595040579
              ],
              [
                114.93995201775238,
                -29.387465098449113
              ],
              [
                114.93506921993098,
                -29.36451591985529
              ],
              [
                114.93327885887524,
                -29.34368259816268
              ],
              [
                114.92969811994496,
                -29.327813428841832
              ],
              [
                114.91236417345237,
                -29.292087625316075
              ],
              [
                114.89625087860348,
                -29.233656598871544
              ],
              [
                114.84245848682464,
                -29.108575002780324
              ],
              [
                114.83204188066341,
                -29.092054997288034
              ],
              [
                114.65259848732643,
                -28.91236739693346
              ],
              [
                114.64828533343251,
                -28.902276245321602
              ],
              [
                114.61451257004947,
                -28.857517196963826
              ],
              [
                114.6037703816931,
                -28.838555604967247
              ],
              [
                114.59278405918229,
                -28.797784140241426
              ],
              [
                114.5774846133005,
                -28.78508892561844
              ],
              [
                114.59555094362582,
                -28.748304846661803
              ],
              [
                114.59782964077377,
                -28.7018369000668
              ],
              [
                114.58985431710383,
                -28.65585689153533
              ],
              [
                114.53109787173743,
                -28.522393547680377
              ],
              [
                114.50863693336318,
                -28.49089940265451
              ],
              [
                114.42286221882877,
                -28.400974350749024
              ],
              [
                114.36931395935052,
                -28.3228490983692
              ],
              [
                114.36475673774616,
                -28.3090146754652
              ],
              [
                114.35694423772097,
                -28.292575873500667
              ],
              [
                114.31006923122528,
                -28.23015723387014
              ],
              [
                114.29558351749446,
                -28.221449438322168
              ],
              [
                114.26050863983806,
                -28.205254753553312
              ],
              [
                114.24488361470888,
                -28.19247798257924
              ],
              [
                114.16602621322492,
                -28.106703305676444
              ],
              [
                114.15414472151046,
                -28.078057532831036
              ],
              [
                114.14869225387403,
                -28.068536065605578
              ],
              [
                114.14682049506722,
                -28.061618704371845
              ],
              [
                114.14568116479592,
                -28.027601754444714
              ],
              [
                114.14389077791587,
                -28.018649862681528
              ],
              [
                114.10596767995696,
                -27.904066778880456
              ],
              [
                114.09791098604343,
                -27.86272546195924
              ],
              [
                114.09717856689555,
                -27.819431199872025
              ],
              [
                114.10254966902397,
                -27.79794685393005
              ],
              [
                114.12061609064142,
                -27.75969820264505
              ],
              [
                114.12435956291131,
                -27.740166899087797
              ],
              [
                114.1276961988995,
                -27.730157283699057
              ],
              [
                114.14234458083777,
                -27.709161014118276
              ],
              [
                114.14568117480997,
                -27.698907123053967
              ],
              [
                114.1438907752375,
                -27.687757923877975
              ],
              [
                114.07447349710986,
                -27.447198152449342
              ],
              [
                114.01254315208098,
                -27.315362195287417
              ],
              [
                113.92318771055966,
                -27.171319317685672
              ],
              [
                113.76441489562235,
                -26.918145391941508
              ],
              [
                113.65452815737017,
                -26.77558610104148
              ],
              [
                113.59057934156459,
                -26.67565069852326
              ],
              [
                113.53174889246225,
                -26.623223560623188
              ],
              [
                113.46570788511994,
                -26.55714340503382
              ],
              [
                113.35726973103125,
                -26.45517344929974
              ],
              [
                113.34294681919582,
                -26.443047813103128
              ],
              [
                113.31262468443587,
                -26.415945695026547
              ],
              [
                113.29778181258045,
                -26.39728867415457
              ],
              [
                113.29786928913708,
                -26.37465741734585
              ],
              [
                113.29198688279672,
                -26.35334994662419
              ],
              [
                113.29948918858396,
                -26.338721074953458
              ],
              [
                113.28465725808074,
                -26.31872852511492
              ],
              [
                113.2713368599429,
                -26.288088086216277
              ],
              [
                113.24466992804493,
                -26.24009770427592
              ],
              [
                113.21322676676128,
                -26.215101849087077
              ],
              [
                113.17628576362526,
                -26.177308056961486
              ],
              [
                113.15697951745489,
                -26.151925735571467
              ],
              [
                113.16149482639464,
                -26.13995276865833
              ],
              [
                113.1868501545469,
                -26.156038182442096
              ],
              [
                113.21021569610016,
                -26.174493115516327
              ],
              [
                113.22852623081826,
                -26.18059658694263
              ],
              [
                113.25825158185508,
                -26.185558863732922
              ],
              [
                113.26412986575272,
                -26.210868771723398
              ],
              [
                113.27597094277152,
                -26.23485743539709
              ],
              [
                113.27906329089694,
                -26.19759717662652
              ],
              [
                113.28510429306648,
                -26.165671523241226
              ],
              [
                113.29261378901279,
                -26.131083027642262
              ],
              [
                113.28822224351872,
                -26.093787899498945
              ],
              [
                113.2853235868608,
                -26.056503285112374
              ],
              [
                113.2913141528087,
                -26.024567105954787
              ],
              [
                113.30622430525807,
                -25.996651512023785
              ],
              [
                113.32090186856595,
                -26.12184733491412
              ],
              [
                113.32964058328267,
                -26.23502929428643
              ],
              [
                113.3279982978308,
                -26.274896268980466
              ],
              [
                113.33533466669047,
                -26.310836692361555
              ],
              [
                113.34719065560759,
                -26.330815122651636
              ],
              [
                113.36201033342392,
                -26.35744706379284
              ],
              [
                113.36790520807277,
                -26.378743416691574
              ],
              [
                113.38426983169026,
                -26.38275535436462
              ],
              [
                113.37543066749579,
                -26.350811876102938
              ],
              [
                113.3561868244219,
                -26.308202626097692
              ],
              [
                113.35329967051015,
                -26.274943590250388
              ],
              [
                113.36382827784037,
                -26.22839920652642
              ],
              [
                113.37725299958814,
                -26.20980028697465
              ],
              [
                113.38039789508395,
                -26.099377973833004
              ],
              [
                113.35669825163046,
                -26.042085606989072
              ],
              [
                113.36267349278319,
                -26.012815345823437
              ],
              [
                113.38787141102611,
                -26.06080434201439
              ],
              [
                113.39664248556718,
                -26.176580060047513
              ],
              [
                113.41301505152371,
                -26.15532753660499
              ],
              [
                113.42341581855744,
                -26.156676644507282
              ],
              [
                113.45163113689159,
                -26.159384024098053
              ],
              [
                113.45008961314556,
                -26.200609214679798
              ],
              [
                113.4589801427013,
                -26.221898688658147
              ],
              [
                113.46191056831738,
                -26.24982853714279
              ],
              [
                113.47377528350466,
                -26.263140012442374
              ],
              [
                113.47820284167834,
                -26.283087505391908
              ],
              [
                113.48708229708954,
                -26.300382901079082
              ],
              [
                113.49596333489625,
                -26.326982552519972
              ],
              [
                113.50331739229678,
                -26.376189423008437
              ],
              [
                113.48987998861297,
                -26.400127946365757
              ],
              [
                113.49278760723256,
                -26.434714779408
              ],
              [
                113.47931871072032,
                -26.47329234454905
              ],
              [
                113.48675518930428,
                -26.479942543030102
              ],
              [
                113.50762277434023,
                -26.469295434892068
              ],
              [
                113.50767475003366,
                -26.434713577600302
              ],
              [
                113.50771532884649,
                -26.410769507563703
              ],
              [
                113.51369324366432,
                -26.393482997635214
              ],
              [
                113.5256533877759,
                -26.354918457642807
              ],
              [
                113.50936279228834,
                -26.312362539884674
              ],
              [
                113.51383992222702,
                -26.295082018614703
              ],
              [
                113.51386964900543,
                -26.27380893135072
              ],
              [
                113.53021571350669,
                -26.267171784979144
              ],
              [
                113.54356547066426,
                -26.287117474502953
              ],
              [
                113.54948777811067,
                -26.3044031048177
              ],
              [
                113.5539242300104,
                -26.324345331955303
              ],
              [
                113.56132619141191,
                -26.352265464177695
              ],
              [
                113.55237689379682,
                -26.384173338276213
              ],
              [
                113.55976983335252,
                -26.412099007805047
              ],
              [
                113.56715541734977,
                -26.44534717137234
              ],
              [
                113.55674349919701,
                -26.47060405252745
              ],
              [
                113.56711369147145,
                -26.490560505416507
              ],
              [
                113.567085143882,
                -26.529126015433054
              ],
              [
                113.565506537809,
                -26.565081176840206
              ],
              [
                113.58183383115872,
                -26.56510851790175
              ],
              [
                113.59376468469463,
                -26.553116606663103
              ],
              [
                113.59676435279037,
                -26.53847185709205
              ],
              [
                113.59828287187781,
                -26.518506708434714
              ],
              [
                113.6042501345295,
                -26.507855551463955
              ],
              [
                113.62360808134338,
                -26.487885884741882
              ],
              [
                113.62065210589613,
                -26.469265690167596
              ],
              [
                113.61771592988387,
                -26.446654287257175
              ],
              [
                113.62514749575621,
                -26.439997324996124
              ],
              [
                113.64442594481316,
                -26.48122021390426
              ],
              [
                113.64441347518573,
                -26.499843258915313
              ],
              [
                113.64290745684198,
                -26.526451997546946
              ],
              [
                113.64288718544242,
                -26.54907253201563
              ],
              [
                113.6339330612999,
                -26.573039978932908
              ],
              [
                113.63837911728838,
                -26.58768261497444
              ],
              [
                113.62875408442201,
                -26.5980770194766
              ],
              [
                113.6443147042043,
                -26.60232509618423
              ],
              [
                113.66217675568862,
                -26.60097516987835
              ],
              [
                113.66663084821545,
                -26.615615994316773
              ],
              [
                113.67108433019096,
                -26.6355821537339
              ],
              [
                113.66958599377205,
                -26.652893221626176
              ],
              [
                113.68628992458679,
                -26.654229475809657
              ],
              [
                113.68746821666666,
                -26.63155896764356
              ],
              [
                113.6949177617792,
                -26.614240229633296
              ],
              [
                113.7112924433757,
                -26.610213886841137
              ],
              [
                113.73509565336433,
                -26.600868810225563
              ],
              [
                113.76037771570245,
                -26.595511317959197
              ],
              [
                113.77227138174182,
                -26.58750685109049
              ],
              [
                113.78044683243138,
                -26.601250983892026
              ],
              [
                113.81243183786856,
                -26.599415378504787
              ],
              [
                113.81387872512153,
                -26.56348548035349
              ],
              [
                113.83319099900038,
                -26.554132732945728
              ],
              [
                113.8524996770957,
                -26.54477172136536
              ],
              [
                113.87028641955699,
                -26.52212985295647
              ],
              [
                113.88656741484458,
                -26.49283837957552
              ],
              [
                113.88947930135986,
                -26.464915148493283
              ],
              [
                113.88345463606312,
                -26.422399704399563
              ],
              [
                113.87303119323917,
                -26.398492886128235
              ],
              [
                113.88336946132455,
                -26.378543165322384
              ],
              [
                113.88477257107857,
                -26.342673224594257
              ],
              [
                113.86841115658522,
                -26.31879973232885
              ],
              [
                113.84107505882655,
                -26.29566820134584
              ],
              [
                113.81421958003223,
                -26.26677819216731
              ],
              [
                113.78174889243117,
                -26.241387622362222
              ],
              [
                113.74924027555248,
                -26.238514619557062
              ],
              [
                113.6841377559536,
                -26.221604094853152
              ],
              [
                113.67995597521778,
                -26.200827042866127
              ],
              [
                113.67997054089216,
                -26.183826753932767
              ],
              [
                113.66778410807582,
                -26.16620370012932
              ],
              [
                113.64887769695505,
                -26.139385588969887
              ],
              [
                113.61108205107946,
                -26.09648205964895
              ],
              [
                113.57723934487304,
                -26.08934255025059
              ],
              [
                113.57131528759783,
                -26.05715631926671
              ],
              [
                113.56735597261475,
                -26.036602418590086
              ],
              [
                113.57634712959889,
                -26.008897892195613
              ],
              [
                113.56242580995783,
                -25.999963778543393
              ],
              [
                113.55351702047535,
                -25.97226135746147
              ],
              [
                113.55755290349994,
                -25.940989485592794
              ],
              [
                113.51876452129152,
                -25.919535885907003
              ],
              [
                113.52376630071842,
                -25.89184579336322
              ],
              [
                113.51781766808568,
                -25.87039993676907
              ],
              [
                113.51187158634082,
                -25.85342166269102
              ],
              [
                113.49995248798075,
                -25.84268664392801
              ],
              [
                113.48802899548082,
                -25.827482019895758
              ],
              [
                113.47411118392661,
                -25.817632136542
              ],
              [
                113.46815785628743,
                -25.80511100680303
              ],
              [
                113.46916495357353,
                -25.79170729981672
              ],
              [
                113.46045983469467,
                -25.77662526807729
              ],
              [
                113.44752038600168,
                -25.76482515421326
              ],
              [
                113.42078062170235,
                -25.728215202417516
              ],
              [
                113.41352822874144,
                -25.702046802026583
              ],
              [
                113.41900060766218,
                -25.680810555185083
              ],
              [
                113.42264732251633,
                -25.65466267895743
              ],
              [
                113.43356907503218,
                -25.63343711398226
              ],
              [
                113.45175387408139,
                -25.604054108688267
              ],
              [
                113.4644567474797,
                -25.573011388218617
              ],
              [
                113.48986926120219,
                -25.545269030338684
              ],
              [
                113.50254780686214,
                -25.51421308919396
              ],
              [
                113.51525017939915,
                -25.50933654424106
              ],
              [
                113.518909458193,
                -25.540428836735316
              ],
              [
                113.52438791330165,
                -25.578056755748758
              ],
              [
                113.5207962323723,
                -25.600955326579196
              ],
              [
                113.53288822011517,
                -25.618259384794314
              ],
              [
                113.54664147534777,
                -25.61760834367409
              ],
              [
                113.55591881892138,
                -25.619561467057284
              ],
              [
                113.56251061731727,
                -25.631524363323443
              ],
              [
                113.58433955319879,
                -25.632112873091433
              ],
              [
                113.59343621960498,
                -25.66643152789543
              ],
              [
                113.60798038349158,
                -25.704015288661193
              ],
              [
                113.63103275741967,
                -25.736260710290757
              ],
              [
                113.66064141687251,
                -25.749767238454094
              ],
              [
                113.67518432575733,
                -25.78079118982578
              ],
              [
                113.70093834838123,
                -25.791761982148177
              ],
              [
                113.72783160607158,
                -25.79543966946361
              ],
              [
                113.72240933563693,
                -25.828120932091924
              ],
              [
                113.71697710053577,
                -25.84607417101445
              ],
              [
                113.7223413329829,
                -25.866631735599203
              ],
              [
                113.7273055450704,
                -25.872816702281675
              ],
              [
                113.74424372737586,
                -25.880324111396995
              ],
              [
                113.75695081532595,
                -25.88521698220486
              ],
              [
                113.76060881738536,
                -25.90479259827298
              ],
              [
                113.75336595121395,
                -25.92111499010155
              ],
              [
                113.73521628482523,
                -25.93581463830659
              ],
              [
                113.73884936876847,
                -25.9554004001168
              ],
              [
                113.73888638162809,
                -25.984769731646747
              ],
              [
                113.73163929308411,
                -26.007621268321483
              ],
              [
                113.71891322543463,
                -26.032115907243757
              ],
              [
                113.72255025289425,
                -26.04843898181773
              ],
              [
                113.71527590087939,
                -26.07783182820273
              ],
              [
                113.71345979536159,
                -26.12191381008973
              ],
              [
                113.70435979146997,
                -26.148045688834998
              ],
              [
                113.72801348760974,
                -26.180685070263834
              ],
              [
                113.72800444841033,
                -26.197034879442047
              ],
              [
                113.76260513734285,
                -26.19697313641688
              ],
              [
                113.7662514706158,
                -26.210033964026454
              ],
              [
                113.79538590817114,
                -26.20671478841071
              ],
              [
                113.84807000311754,
                -26.12171047867681
              ],
              [
                113.86800393934676,
                -26.07924185316543
              ],
              [
                113.87884183025771,
                -26.04332114399873
              ],
              [
                113.86443119329228,
                -25.99944429569141
              ],
              [
                113.86231530776709,
                -25.988946250453584
              ],
              [
                113.85287518829468,
                -25.97128668872989
              ],
              [
                113.85075931747397,
                -25.961602495770958
              ],
              [
                113.85157310497576,
                -25.947686426503502
              ],
              [
                113.85450279682642,
                -25.944268476331086
              ],
              [
                113.8587345795312,
                -25.946221644361202
              ],
              [
                113.86443119210985,
                -25.947930619455768
              ],
              [
                113.88550865749372,
                -25.951755457792764
              ],
              [
                113.90957726784134,
                -25.97637260274597
              ],
              [
                113.90599553514066,
                -25.999219632127357
              ],
              [
                113.90243313680979,
                -26.031853912407993
              ],
              [
                113.91163652291613,
                -26.088939117266015
              ],
              [
                113.90601646682177,
                -26.11931729723299
              ],
              [
                113.92809561112394,
                -26.137868077211778
              ],
              [
                113.94808736559914,
                -26.139464082252218
              ],
              [
                113.93546936665929,
                -26.191722049785085
              ],
              [
                113.94282681733826,
                -26.227640413438422
              ],
              [
                113.95563704725814,
                -26.260278051759254
              ],
              [
                113.95750801275742,
                -26.28314729543648
              ],
              [
                113.96484877161676,
                -26.309278546180487
              ],
              [
                113.9699813090989,
                -26.331719634417016
              ],
              [
                114.0215340576201,
                -26.390887692285723
              ],
              [
                114.06908317622496,
                -26.436559854673327
              ],
              [
                114.08553722204934,
                -26.447952239333155
              ],
              [
                114.10377561248347,
                -26.44788148291858
              ],
              [
                114.12376326619086,
                -26.429813957597442
              ],
              [
                114.14374883630715,
                -26.41339260400419
              ],
              [
                114.15642124849587,
                -26.393729368362887
              ],
              [
                114.18370441760985,
                -26.382177885328918
              ],
              [
                114.20736051801823,
                -26.375541347661258
              ],
              [
                114.21630894488823,
                -26.34444499178769
              ],
              [
                114.23437149812113,
                -26.31658374577943
              ],
              [
                114.21958139575285,
                -26.27416256395485
              ],
              [
                114.20487534532357,
                -26.246445966950287
              ],
              [
                114.19928310842566,
                -26.218694962219594
              ],
              [
                114.19189501224326,
                -26.195861536620484
              ],
              [
                114.19721269322937,
                -26.168086562229796
              ],
              [
                114.20437795670631,
                -26.14684012218808
              ],
              [
                114.21729576289532,
                -26.105645418911454
              ],
              [
                114.22331790911771,
                -26.100681262903606
              ],
              [
                114.22681724549025,
                -26.08879970717116
              ],
              [
                114.22828209023503,
                -26.075290598466
              ],
              [
                114.22754966567048,
                -26.064629782136247
              ],
              [
                114.21778404216745,
                -26.043064031518647
              ],
              [
                114.19174238494249,
                -26.00400156343855
              ],
              [
                114.18653404596627,
                -25.97893644125268
              ],
              [
                114.19076581678743,
                -25.970879800589735
              ],
              [
                114.20020592432358,
                -25.976657807526497
              ],
              [
                114.21387779927097,
                -25.992771089338092
              ],
              [
                114.21957440857513,
                -25.996758698551375
              ],
              [
                114.23267662072463,
                -25.996026269799174
              ],
              [
                114.24683677539056,
                -25.99285243692617
              ],
              [
                114.25554447409593,
                -25.98951590890439
              ],
              [
                114.25814864179401,
                -25.988946250453584
              ],
              [
                114.2685653070968,
                -25.98951590890439
              ],
              [
                114.2602645087292,
                -25.97112391845114
              ],
              [
                114.24805749267314,
                -25.96087006709985
              ],
              [
                114.23747806470294,
                -25.94963959456321
              ],
              [
                114.23422284791224,
                -25.92742276899978
              ],
              [
                114.24170983848468,
                -25.908786740829452
              ],
              [
                114.25440514236375,
                -25.885837491976464
              ],
              [
                114.263194207857,
                -25.86223724116025
              ],
              [
                114.25855553157776,
                -25.841892172357767
              ],
              [
                114.24268640353785,
                -25.828871387275697
              ],
              [
                114.19312585304439,
                -25.802178666413337
              ],
              [
                114.15528404917663,
                -25.789727468942345
              ],
              [
                114.14869226275263,
                -25.773207322545073
              ],
              [
                114.14486738834495,
                -25.757012644177628
              ],
              [
                114.13200931429883,
                -25.749932562290937
              ],
              [
                114.13648522553946,
                -25.73333100120484
              ],
              [
                114.12916100628809,
                -25.715264589549403
              ],
              [
                114.11548912644997,
                -25.700778894459127
              ],
              [
                114.10059655414273,
                -25.69475678450901
              ],
              [
                114.09750410074952,
                -25.690524993316657
              ],
              [
                114.09302819866753,
                -25.671644818761507
              ],
              [
                114.08692467767958,
                -25.667413029055034
              ],
              [
                114.04932702775588,
                -25.6469052389232
              ],
              [
                114.04102624332273,
                -25.633558872037312
              ],
              [
                114.01563561533283,
                -25.56959401683008
              ],
              [
                113.95167077133198,
                -25.489190371890675
              ],
              [
                113.92839602857069,
                -25.449802336531285
              ],
              [
                113.86207116221509,
                -25.30266693358502
              ],
              [
                113.85816490785118,
                -25.280043218655447
              ],
              [
                113.85328209752325,
                -25.263929948034495
              ],
              [
                113.81666100221676,
                -25.208754158030636
              ],
              [
                113.80811608206031,
                -25.182224217235905
              ],
              [
                113.80241946708637,
                -25.171807550338354
              ],
              [
                113.78931725249288,
                -25.160332935083943
              ],
              [
                113.7473250666814,
                -25.1366513026809
              ],
              [
                113.7130639982737,
                -25.124932551078068
              ],
              [
                113.69214928566325,
                -25.10523854261776
              ],
              [
                113.67790774761184,
                -25.081638277464396
              ],
              [
                113.66944420703996,
                -25.047539972158148
              ],
              [
                113.65528405007586,
                -25.026136977301107
              ],
              [
                113.6510522799449,
                -25.005303643780348
              ],
              [
                113.64576257034543,
                -24.99309663032505
              ],
              [
                113.64470459889431,
                -24.98560953682742
              ],
              [
                113.6473087871483,
                -24.977308840614867
              ],
              [
                113.66041097740356,
                -24.96257892769446
              ],
              [
                113.66521242794438,
                -24.954847882781685
              ],
              [
                113.66675867296664,
                -24.93377049295254
              ],
              [
                113.6582137714392,
                -24.91204205923812
              ],
              [
                113.63965907963279,
                -24.896172903138456
              ],
              [
                113.61060630013074,
                -24.892754752162382
              ],
              [
                113.60971111293281,
                -24.87135173609735
              ],
              [
                113.60572351204168,
                -24.850192999468064
              ],
              [
                113.6051538384549,
                -24.830498941662515
              ],
              [
                113.61402429613221,
                -24.814060199080515
              ],
              [
                113.62094163679446,
                -24.795831129110915
              ],
              [
                113.61866297229511,
                -24.770440425164104
              ],
              [
                113.611664226593,
                -24.74537512600118
              ],
              [
                113.60434003196312,
                -24.728285382215528
              ],
              [
                113.54249109493331,
                -24.643487291160916
              ],
              [
                113.43946374808566,
                -24.53281019587327
              ],
              [
                113.41675867637827,
                -24.497653972208138
              ],
              [
                113.40023849490645,
                -24.457940437823964
              ],
              [
                113.39144943482954,
                -24.413669612162913
              ],
              [
                113.38526453618631,
                -24.24911882103134
              ],
              [
                113.38941491293551,
                -24.22779714549441
              ],
              [
                113.39722739438676,
                -24.214125191477212
              ],
              [
                113.42269942367611,
                -24.19052503502568
              ],
              [
                113.43327881214499,
                -24.170179818401532
              ],
              [
                113.43181401942628,
                -24.148044620732765
              ],
              [
                113.41928145865238,
                -24.10458755235712
              ],
              [
                113.41382893955674,
                -24.07040767024368
              ],
              [
                113.41456141172993,
                -24.04941179349719
              ],
              [
                113.42269943357181,
                -24.033135755223558
              ],
              [
                113.43572023370226,
                -24.021091342188864
              ],
              [
                113.44678796329757,
                -24.00758231724995
              ],
              [
                113.45533289154898,
                -23.990655260366406
              ],
              [
                113.46045986462367,
                -23.967950269573098
              ],
              [
                113.45948325682684,
                -23.944593955079572
              ],
              [
                113.45655360119619,
                -23.927178727561767
              ],
              [
                113.45972738463935,
                -23.91033283046742
              ],
              [
                113.49187256694276,
                -23.87216551350992
              ],
              [
                113.50212651599685,
                -23.852797211744267
              ],
              [
                113.52637781292798,
                -23.764743804920148
              ],
              [
                113.53834066898274,
                -23.748467608955316
              ],
              [
                113.55933677658732,
                -23.741957252908907
              ],
              [
                113.59945722306054,
                -23.633965735501995
              ],
              [
                113.60434004555363,
                -23.624688433682707
              ],
              [
                113.61109457272875,
                -23.620375150100756
              ],
              [
                113.6199650251092,
                -23.617119983792
              ],
              [
                113.62769616029445,
                -23.611911718309464
              ],
              [
                113.63103274663119,
                -23.60116952290754
              ],
              [
                113.63624105148193,
                -23.596856242134006
              ],
              [
                113.66041103205772,
                -23.586032934981038
              ],
              [
                113.68213951622562,
                -23.57968514163805
              ],
              [
                113.68897546873583,
                -23.569756821322777
              ],
              [
                113.6936141438246,
                -23.558363606144386
              ],
              [
                113.69996179519343,
                -23.549574522506262
              ],
              [
                113.73755941822131,
                -23.52703205718222
              ],
              [
                113.74984784087813,
                -23.51165125023863
              ],
              [
                113.75456793125176,
                -23.485040089666715
              ],
              [
                113.75684652281838,
                -23.47909909511706
              ],
              [
                113.76661218067572,
                -23.46591564847039
              ],
              [
                113.76880943621127,
                -23.457696200497615
              ],
              [
                113.77100673433291,
                -23.389581111299027
              ],
              [
                113.78028407883346,
                -23.348809633416163
              ],
              [
                113.78248128441575,
                -23.327080844935196
              ],
              [
                113.76880942124221,
                -23.241143397981656
              ],
              [
                113.75114992026853,
                -23.180840681031572
              ],
              [
                113.74830161300532,
                -23.16228599273769
              ],
              [
                113.75367271277176,
                -23.13827886166718
              ],
              [
                113.7545679183025,
                -23.128187819061193
              ],
              [
                113.75831136898402,
                -23.11882891910548
              ],
              [
                113.76742597616496,
                -23.111504812163194
              ],
              [
                113.77865642399965,
                -23.10507567788553
              ],
              [
                113.78931726039154,
                -23.097100548387786
              ],
              [
                113.80502365100199,
                -23.075127941272534
              ],
              [
                113.81153404153692,
                -23.05136480298149
              ],
              [
                113.80738364098364,
                -22.930596524663336
              ],
              [
                113.80176839301375,
                -22.899834745128015
              ],
              [
                113.78589927008767,
                -22.874932480479846
              ],
              [
                113.77540121024852,
                -22.85247148343766
              ],
              [
                113.75977626385135,
                -22.788751030165596
              ],
              [
                113.71363365483431,
                -22.74146898371096
              ],
              [
                113.70289144426854,
                -22.73560950255077
              ],
              [
                113.69068447214747,
                -22.730645587575726
              ],
              [
                113.6760360240741,
                -22.727715847494096
              ],
              [
                113.65894618751541,
                -22.727797262541433
              ],
              [
                113.6716414653974,
                -22.69019944585074
              ],
              [
                113.67212977581316,
                -22.668715205033525
              ],
              [
                113.6619572204015,
                -22.64869553979366
              ],
              [
                113.65951580101601,
                -22.640801596445556
              ],
              [
                113.65894615252944,
                -22.607110248585492
              ],
              [
                113.65577234644168,
                -22.594659181510394
              ],
              [
                113.64966879679294,
                -22.586521000835777
              ],
              [
                113.64665776367026,
                -22.577732103415173
              ],
              [
                113.6521102174784,
                -22.562676669510466
              ],
              [
                113.66081789231862,
                -22.55339928670413
              ],
              [
                113.68262779162819,
                -22.543552302180387
              ],
              [
                113.69312586964165,
                -22.535414428729247
              ],
              [
                113.71680749984291,
                -22.492120106470136
              ],
              [
                113.73145592490512,
                -22.479587497546937
              ],
              [
                113.7346297483304,
                -22.470310126937854
              ],
              [
                113.74089601860364,
                -22.42555098547519
              ],
              [
                113.74773196840397,
                -22.40154388472482
              ],
              [
                113.75879968244334,
                -22.382419564686828
              ],
              [
                113.79273521087445,
                -22.34734460557619
              ],
              [
                113.8039656986409,
                -22.33082451371832
              ],
              [
                113.8855086579832,
                -22.11093514420848
              ],
              [
                113.89079837667735,
                -22.08912527587051
              ],
              [
                113.89323977177871,
                -22.068536026008555
              ],
              [
                113.8979598324423,
                -22.04924895815284
              ],
              [
                113.92310632941953,
                -22.013116209428734
              ],
              [
                113.94703210019817,
                -21.95256928463265
              ],
              [
                114.01148522450274,
                -21.859958604276677
              ],
              [
                114.03581789666022,
                -21.837823134059356
              ],
              [
                114.06714927400317,
                -21.819024292987137
              ],
              [
                114.08627363484929,
                -21.811944273171957
              ],
              [
                114.10743247547305,
                -21.809258660467634
              ],
              [
                114.12777753522478,
                -21.80429450554362
              ],
              [
                114.14470460778217,
                -21.79550539223106
              ],
              [
                114.15919028736528,
                -21.79192467592085
              ],
              [
                114.1722111412098,
                -21.802992481403393
              ],
              [
                114.17603601727647,
                -21.822198240138285
              ],
              [
                114.16602623981599,
                -21.83505625690527
              ],
              [
                114.15251713552352,
                -21.846368158392824
              ],
              [
                114.14568118660188,
                -21.861016536948682
              ],
              [
                114.14234459563102,
                -21.88046639729821
              ],
              [
                114.1276961717458,
                -21.922784170400114
              ],
              [
                114.09644616679908,
                -22.10637789595482
              ],
              [
                114.0830184265853,
                -22.140720317671633
              ],
              [
                114.07748457428505,
                -22.175469674872044
              ],
              [
                114.09376061389453,
                -22.210137632313597
              ],
              [
                114.10271244601637,
                -22.222751608271302
              ],
              [
                114.12094159621498,
                -22.260430569177434
              ],
              [
                114.12435955683821,
                -22.275323106943347
              ],
              [
                114.1113387288002,
                -22.312106984866332
              ],
              [
                114.10971112452091,
                -22.330987192570216
              ],
              [
                114.12435956152983,
                -22.336683806632276
              ],
              [
                114.13160242415528,
                -22.32626725284399
              ],
              [
                114.13754317226545,
                -22.307305631854227
              ],
              [
                114.1474715623394,
                -22.294528963228572
              ],
              [
                114.16602624486733,
                -22.3026669579436
              ],
              [
                114.17139732503101,
                -22.317478089594736
              ],
              [
                114.17042076031969,
                -22.338474175436414
              ],
              [
                114.16382896379805,
                -22.355564020759683
              ],
              [
                114.1518660692726,
                -22.358005406110074
              ],
              [
                114.12273196729889,
                -22.38909270742764
              ],
              [
                114.11768640933568,
                -22.398858404232325
              ],
              [
                114.11817467605971,
                -22.413262633056142
              ],
              [
                114.1257430406166,
                -22.438164998763146
              ],
              [
                114.11085044802863,
                -22.47771571033564
              ],
              [
                114.1224064583433,
                -22.5041643796089
              ],
              [
                114.148122564838,
                -22.521416796178535
              ],
              [
                114.17969811494612,
                -22.521742455226725
              ],
              [
                114.19629965938675,
                -22.50774497592642
              ],
              [
                114.20687909153212,
                -22.486911667285867
              ],
              [
                114.2219344461018,
                -22.467950152250772
              ],
              [
                114.25171958897715,
                -22.459649308856733
              ],
              [
                114.26221764540048,
                -22.45549896265883
              ],
              [
                114.2740991409764,
                -22.447523629296793
              ],
              [
                114.28663169526926,
                -22.44329186919616
              ],
              [
                114.29981529932523,
                -22.44980233879118
              ],
              [
                114.30689537208708,
                -22.462497621154647
              ],
              [
                114.31177820216243,
                -22.476169581994515
              ],
              [
                114.31983481653066,
                -22.487562684607962
              ],
              [
                114.33741296346275,
                -22.493829064645855
              ],
              [
                114.356944211645,
                -22.48601655603164
              ],
              [
                114.36703536213118,
                -22.47828546306987
              ],
              [
                114.37086020629548,
                -22.46559002743728
              ],
              [
                114.37159263490257,
                -22.442966360754316
              ],
              [
                114.373789908108,
                -22.43417733300196
              ],
              [
                114.38355552805834,
                -22.41423915795511
              ],
              [
                114.38575280332238,
                -22.402276315824906
              ],
              [
                114.38721764382704,
                -22.379489841174664
              ],
              [
                114.39193768324576,
                -22.358005406110074
              ],
              [
                114.42172283881432,
                -22.29851647087333
              ],
              [
                114.42847741439392,
                -22.271254186063693
              ],
              [
                114.43978927060017,
                -22.244561511678995
              ],
              [
                114.44385825482165,
                -22.237481309924014
              ],
              [
                114.4676212832209,
                -22.206475486407353
              ],
              [
                114.46851647238232,
                -22.19475677083896
              ],
              [
                114.4636336535695,
                -22.18108486304357
              ],
              [
                114.46762129737155,
                -22.172295866500406
              ],
              [
                114.47681726691282,
                -22.168064122194302
              ],
              [
                114.48829187163889,
                -22.167657200605337
              ],
              [
                114.49781335123369,
                -22.163669549391994
              ],
              [
                114.50570722919218,
                -22.126397404577318
              ],
              [
                114.5212508436036,
                -22.089043861585033
              ],
              [
                114.52230878296996,
                -22.069268453992407
              ],
              [
                114.51872806003992,
                -22.060723561353306
              ],
              [
                114.50635826824193,
                -22.048516530328282
              ],
              [
                114.50180096506207,
                -22.041924680166254
              ],
              [
                114.4995223360655,
                -22.034926059701764
              ],
              [
                114.49610435031182,
                -22.016045769454127
              ],
              [
                114.49561609553264,
                -22.00448990767613
              ],
              [
                114.50318443788689,
                -21.996026284886245
              ],
              [
                114.52051841114975,
                -22.01100019081631
              ],
              [
                114.53891035135726,
                -22.031996348885635
              ],
              [
                114.55030357005708,
                -22.041924680166254
              ],
              [
                114.59880617359046,
                -21.955987177694976
              ],
              [
                114.61109460200218,
                -21.92522554333919
              ],
              [
                114.61378015700814,
                -21.92351659729702
              ],
              [
                114.61744224595571,
                -21.92327235485709
              ],
              [
                114.62126712397313,
                -21.922295835734776
              ],
              [
                114.62476646073951,
                -21.918552287199518
              ],
              [
                114.62720788742111,
                -21.91301852899124
              ],
              [
                114.63160240140363,
                -21.8980444871292
              ],
              [
                114.63770592081556,
                -21.85735440458304
              ],
              [
                114.64673913100194,
                -21.843357038772776
              ],
              [
                114.66944419861389,
                -21.837823134059356
              ],
              [
                114.67823325991033,
                -21.83456792262162
              ],
              [
                114.69157963399002,
                -21.81747817668856
              ],
              [
                114.70045005340792,
                -21.809258660467634
              ],
              [
                114.77898197634656,
                -21.781345355695013
              ],
              [
                114.92896567708951,
                -21.693942898835264
              ],
              [
                114.9707137292427,
                -21.682061413082014
              ],
              [
                115.00896244509235,
                -21.693129209524784
              ],
              [
                115.05518640694001,
                -21.676527665383254
              ],
              [
                115.06739341305776,
                -21.668633663490997
              ],
              [
                115.07740319429394,
                -21.65976329514215
              ],
              [
                115.08863365314294,
                -21.652764547389825
              ],
              [
                115.09864341814236,
                -21.652764547389825
              ],
              [
                115.10515384719668,
                -21.665215778454918
              ],
              [
                115.22388756017706,
                -21.598809474431807
              ],
              [
                115.45460046444964,
                -21.513767221592918
              ],
              [
                115.47852625238889,
                -21.501153323697253
              ],
              [
                115.48878015460508,
                -21.483331040135372
              ],
              [
                115.49463951327643,
                -21.466078354845518
              ],
              [
                115.50831138980975,
                -21.45012784237839
              ],
              [
                115.53646894691305,
                -21.424411721496174
              ],
              [
                115.6027124458959,
                -21.34351983884091
              ],
              [
                115.62598717445293,
                -21.32195403129802
              ],
              [
                115.66228275248758,
                -21.298028275170356
              ],
              [
                115.80616295686805,
                -21.235446872347232
              ],
              [
                115.81869550481807,
                -21.225762607318966
              ],
              [
                115.83041425443504,
                -21.190850496402433
              ],
              [
                115.85906009705734,
                -21.154961872055708
              ],
              [
                115.87761477253497,
                -21.115166887976866
              ],
              [
                115.90552819480818,
                -21.084567985898715
              ],
              [
                115.93669680729401,
                -21.059014562599256
              ],
              [
                115.95801842020559,
                -21.048272370192176
              ],
              [
                115.9741317053786,
                -21.044854416948592
              ],
              [
                116.02320397082785,
                -21.02157967917838
              ],
              [
                116.05640709472017,
                -21.01083748667679
              ],
              [
                116.07105554055197,
                -21.00383882757589
              ],
              [
                116.08521569070999,
                -20.993584892559102
              ],
              [
                116.1212671171109,
                -20.98642340574777
              ],
              [
                116.15154056423899,
                -20.969984649091003
              ],
              [
                116.17408288027599,
                -20.94304779034211
              ],
              [
                116.18767336679504,
                -20.90422939413042
              ],
              [
                116.1893009739754,
                -20.858819253935817
              ],
              [
                116.19629967486856,
                -20.846856377344835
              ],
              [
                116.21859785275146,
                -20.84286875174311
              ],
              [
                116.23023522186848,
                -20.846856377344835
              ],
              [
                116.24594160199138,
                -20.855401299956938
              ],
              [
                116.26587976005052,
                -20.86256278811185
              ],
              [
                116.28939863366753,
                -20.863213798345505
              ],
              [
                116.30860436149639,
                -20.855564052517934
              ],
              [
                116.33432050554367,
                -20.833184485796366
              ],
              [
                116.34799238777337,
                -20.82854584978126
              ],
              [
                116.39193769085303,
                -20.827894764390948
              ],
              [
                116.4347436893388,
                -20.82236095160818
              ],
              [
                116.45150801081795,
                -20.81471120504342
              ],
              [
                116.48226973002183,
                -20.792738555035957
              ],
              [
                116.49219811486158,
                -20.7881812572626
              ],
              [
                116.49805749364448,
                -20.7862281510856
              ],
              [
                116.50619550621869,
                -20.78085701515968
              ],
              [
                116.51351972251999,
                -20.773207267704276
              ],
              [
                116.52051842966799,
                -20.751153276240892
              ],
              [
                116.53003990342046,
                -20.74684006924067
              ],
              [
                116.55079186005067,
                -20.74724698831777
              ],
              [
                116.58708743498997,
                -20.735284107971992
              ],
              [
                116.69939211918668,
                -20.65935635900569
              ],
              [
                116.74317467705949,
                -20.616875919262704
              ],
              [
                116.7793074850618,
                -20.560235269346258
              ],
              [
                116.79712975543274,
                -20.54859792214553
              ],
              [
                116.79086347940253,
                -20.53492605198625
              ],
              [
                116.80640709437733,
                -20.529066651915677
              ],
              [
                116.81446374024362,
                -20.527764592192053
              ],
              [
                116.82447350314516,
                -20.528090097735724
              ],
              [
                116.83513431349176,
                -20.53093842142725
              ],
              [
                116.84351647150206,
                -20.535251557516652
              ],
              [
                116.84538821566824,
                -20.539320564359116
              ],
              [
                116.83513430795784,
                -20.54111091982983
              ],
              [
                116.8203231097346,
                -20.549899981716905
              ],
              [
                116.81446374057434,
                -20.57000092183219
              ],
              [
                116.81080162818728,
                -20.61003996795167
              ],
              [
                116.8055119151984,
                -20.617852472988158
              ],
              [
                116.78874759918368,
                -20.633721648772795
              ],
              [
                116.78419030716583,
                -20.64478935667719
              ],
              [
                116.78394615444857,
                -20.65715908536689
              ],
              [
                116.78728274261601,
                -20.66423916420487
              ],
              [
                116.83594811607321,
                -20.70427826827497
              ],
              [
                116.85547936645264,
                -20.712090770155164
              ],
              [
                116.87964927894764,
                -20.71306728593339
              ],
              [
                116.8991805390117,
                -20.708103142927666
              ],
              [
                116.9216414792812,
                -20.698337534169145
              ],
              [
                116.9402775390107,
                -20.686618743085212
              ],
              [
                116.94800865281326,
                -20.675469623290777
              ],
              [
                116.9570418588691,
                -20.66806403947244
              ],
              [
                117.06251061441901,
                -20.62167734905116
              ],
              [
                117.07154381320228,
                -20.620538005097913
              ],
              [
                117.09017988196024,
                -20.63469816486889
              ],
              [
                117.09546959191951,
                -20.63738369676831
              ],
              [
                117.10767662233788,
                -20.63518642291529
              ],
              [
                117.1179305358746,
                -20.62965260634335
              ],
              [
                117.14437909900016,
                -20.607110269098985
              ],
              [
                117.15406334804683,
                -20.59636810220016
              ],
              [
                117.16016686404693,
                -20.59636810220016
              ],
              [
                117.16716556021207,
                -20.603692312086327
              ],
              [
                117.16863040216963,
                -20.609470295944117
              ],
              [
                117.16773522057721,
                -20.615655198935105
              ],
              [
                117.16773522134889,
                -20.62428150476738
              ],
              [
                117.16098067094849,
                -20.63860445452497
              ],
              [
                117.16016687018887,
                -20.64478935667719
              ],
              [
                117.1628524142033,
                -20.649834914857657
              ],
              [
                117.17237389113708,
                -20.65846118179666
              ],
              [
                117.17457115770674,
                -20.661553632623708
              ],
              [
                117.18132571343823,
                -20.673516516336537
              ],
              [
                117.19760176265225,
                -20.683770459105354
              ],
              [
                117.27247155245838,
                -20.712985947171212
              ],
              [
                117.31153405571051,
                -20.722832969257485
              ],
              [
                117.35377038309156,
                -20.727715773236984
              ],
              [
                117.43751061356035,
                -20.722588802769497
              ],
              [
                117.51343835324487,
                -20.706312788859716
              ],
              [
                117.54379315983255,
                -20.692559477463522
              ],
              [
                117.57911218016292,
                -20.6670875235196
              ],
              [
                117.60271242892594,
                -20.65732183803287
              ],
              [
                117.62330162669788,
                -20.661553632623708
              ],
              [
                117.63575280625662,
                -20.673272424906813
              ],
              [
                117.65064538106797,
                -20.67213308121457
              ],
              [
                117.66114342269725,
                -20.661553632623708
              ],
              [
                117.66423586592224,
                -20.65732183803287
              ],
              [
                117.67042076152529,
                -20.6613094660766
              ],
              [
                117.67530357784369,
                -20.66806403947244
              ],
              [
                117.67481530206847,
                -20.67213308121457
              ],
              [
                117.68995202150187,
                -20.66814545335418
              ],
              [
                117.7295027932272,
                -20.650974183553572
              ],
              [
                117.73633873512334,
                -20.65846118179666
              ],
              [
                117.74984785791112,
                -20.649672162186345
              ],
              [
                117.78679446452729,
                -20.636325766791085
              ],
              [
                117.81006920876736,
                -20.623223574726115
              ],
              [
                117.83082116350914,
                -20.619886994324773
              ],
              [
                117.83936608407883,
                -20.616875919262704
              ],
              [
                117.8491317039822,
                -20.607110269098985
              ],
              [
                117.86060631451264,
                -20.584730719653262
              ],
              [
                117.86719811280568,
                -20.57586028303967
              ],
              [
                117.87875410552799,
                -20.56511811442903
              ],
              [
                117.88550866177943,
                -20.56292083979044
              ],
              [
                117.91114342203333,
                -20.560235269346258
              ],
              [
                117.91863040531734,
                -20.555108332567233
              ],
              [
                117.93181400138256,
                -20.538018504711186
              ],
              [
                117.93531334423142,
                -20.529880453320214
              ],
              [
                117.93336021949857,
                -20.509860922635482
              ],
              [
                117.93482506622809,
                -20.500746353127287
              ],
              [
                117.94068444065925,
                -20.49277109031512
              ],
              [
                118.13559004164532,
                -20.362074485137857
              ],
              [
                118.15088952252496,
                -20.356133739433336
              ],
              [
                118.1618758451285,
                -20.354261967744318
              ],
              [
                118.1692000668809,
                -20.35068125235633
              ],
              [
                118.17701256827186,
                -20.34807709223505
              ],
              [
                118.18873131459304,
                -20.34929777704261
              ],
              [
                118.19157962126944,
                -20.35588957244339
              ],
              [
                118.19141686474134,
                -20.36614349660791
              ],
              [
                118.19507897100625,
                -20.37135181608783
              ],
              [
                118.20923912999471,
                -20.362969663916683
              ],
              [
                118.23080488754539,
                -20.37167735951898
              ],
              [
                118.24838300619967,
                -20.365817953163326
              ],
              [
                118.26433352819814,
                -20.35507577009638
              ],
              [
                118.28093509059192,
                -20.34929777704261
              ],
              [
                118.291758662194,
                -20.347263289839454
              ],
              [
                118.31226647031106,
                -20.337823166655774
              ],
              [
                118.32227624058709,
                -20.335707302780083
              ],
              [
                118.3352970677791,
                -20.33879972209067
              ],
              [
                118.33904056382542,
                -20.34636811095366
              ],
              [
                118.34205163032168,
                -20.355564066526235
              ],
              [
                118.35328209799593,
                -20.362969663916683
              ],
              [
                118.36882571864862,
                -20.362074485137857
              ],
              [
                118.41081790711502,
                -20.346449487438758
              ],
              [
                118.55193118335644,
                -20.32146573996298
              ],
              [
                118.5507918625988,
                -20.322035413021197
              ],
              [
                118.55469810976024,
                -20.322360919023275
              ],
              [
                118.56544029735615,
                -20.32146573996298
              ],
              [
                118.5704858731661,
                -20.319512628818813
              ],
              [
                118.5730086629699,
                -20.31755951764419
              ],
              [
                118.57593834902046,
                -20.316013288962367
              ],
              [
                118.60629316601582,
                -20.309502868007925
              ],
              [
                118.61670983211174,
                -20.30836354055042
              ],
              [
                118.62810305918282,
                -20.309828374042723
              ],
              [
                118.63445071788128,
                -20.313246356343196
              ],
              [
                118.63965905226216,
                -20.317640894147697
              ],
              [
                118.64747154735436,
                -20.32146573996298
              ],
              [
                118.66236412577801,
                -20.323988524126115
              ],
              [
                118.68181399782307,
                -20.323663018128272
              ],
              [
                118.70191491064047,
                -20.317803647154534
              ],
              [
                118.7380477227717,
                -20.292168881800993
              ],
              [
                118.76050865857816,
                -20.288262620997177
              ],
              [
                118.78402753896363,
                -20.286553638896702
              ],
              [
                118.80567467521001,
                -20.28101979103351
              ],
              [
                118.83179772144148,
                -20.261976818249828
              ],
              [
                118.85173587232993,
                -20.236504812699856
              ],
              [
                118.88086998826364,
                -20.185479426298258
              ],
              [
                118.9588322269018,
                -20.10418059651599
              ],
              [
                118.97022545665283,
                -20.072198173288665
              ],
              [
                118.97461998799832,
                -20.050388278991356
              ],
              [
                118.98568769632398,
                -20.04062265559662
              ],
              [
                119.00017337322315,
                -20.0346005200994
              ],
              [
                119.01490319109836,
                -20.02434661348442
              ],
              [
                119.04810631605893,
                -20.01360442529011
              ],
              [
                119.05616295709372,
                -20.009860935461266
              ],
              [
                119.06080162899927,
                -20.00107187299632
              ],
              [
                119.06421960980259,
                -19.99081803007826
              ],
              [
                119.06853274793086,
                -19.98284270565914
              ],
              [
                119.09546961747425,
                -19.966729525867706
              ],
              [
                119.11833744835039,
                -19.971612298830866
              ],
              [
                119.16138756603968,
                -20.007419529195154
              ],
              [
                119.16098066635371,
                -19.980726827664753
              ],
              [
                119.16325928952486,
                -19.96624103826047
              ],
              [
                119.1721297578077,
                -19.960137646747743
              ],
              [
                119.19239344602022,
                -19.95891702847908
              ],
              [
                119.21241292952874,
                -19.961195435787477
              ],
              [
                119.29200280532493,
                -19.985039998186533
              ],
              [
                119.33326256853904,
                -19.99212006248125
              ],
              [
                119.3569442322262,
                -19.993096736982146
              ],
              [
                119.37647544932697,
                -19.996270403294904
              ],
              [
                119.41700280010726,
                -20.01018645652635
              ],
              [
                119.43580162905913,
                -20.01360442529011
              ],
              [
                119.44507897201451,
                -20.011325779071132
              ],
              [
                119.45728600399542,
                -20.001153252977485
              ],
              [
                119.46306399940826,
                -19.999932556914708
              ],
              [
                119.4739689459794,
                -20.00546640389874
              ],
              [
                119.478526237952,
                -20.013441664764013
              ],
              [
                119.48129316497914,
                -20.02255624789745
              ],
              [
                119.48715253977149,
                -20.030938407878384
              ],
              [
                119.52344811267663,
                -20.053155204413276
              ],
              [
                119.54664147198297,
                -20.063571872916246
              ],
              [
                119.56666100414871,
                -20.068780206729016
              ],
              [
                119.58985436299912,
                -20.065850518995166
              ],
              [
                119.62330162878537,
                -20.046156506947824
              ],
              [
                119.6378686862964,
                -20.041599218452593
              ],
              [
                119.64291425880279,
                -20.037774346033157
              ],
              [
                119.66480553506625,
                -20.010430597324362
              ],
              [
                119.67212975395427,
                -20.00855885177571
              ],
              [
                119.69092858201081,
                -20.014825128052692
              ],
              [
                119.70264733205931,
                -20.01360442529011
              ],
              [
                119.71753990999665,
                -20.00367603998346
              ],
              [
                119.71900473916085,
                -19.99334068028859
              ],
              [
                119.71566818589947,
                -19.983086949416965
              ],
              [
                119.71615647617868,
                -19.973239989899312
              ],
              [
                119.73438558909183,
                -19.962660297839165
              ],
              [
                119.75562581940349,
                -19.961195435787477
              ],
              [
                119.80225670456488,
                -19.96575285107342
              ],
              [
                119.90658613019065,
                -19.946547114356797
              ],
              [
                120.0705672462407,
                -19.921644752070303
              ],
              [
                120.23829186357442,
                -19.90683359480397
              ],
              [
                120.36850019756119,
                -19.867120057616013
              ],
              [
                120.6505640205477,
                -19.763279013848585
              ],
              [
                120.80323326820175,
                -19.69801197311271
              ],
              [
                120.95435630627217,
                -19.633721565658668
              ],
              [
                121.12826583642526,
                -19.52068457806789
              ],
              [
                121.16602622704535,
                -19.48455163767824
              ],
              [
                121.1798608722599,
                -19.47975025439743
              ],
              [
                121.19353272052845,
                -19.47242590629083
              ],
              [
                121.3115340377014,
                -19.354099157092943
              ],
              [
                121.41618901781564,
                -19.221612334650153
              ],
              [
                121.51937911755046,
                -19.069594083995696
              ],
              [
                121.53980552043696,
                -19.013604353762286
              ],
              [
                121.5579533091819,
                -18.990004107170435
              ],
              [
                121.56413822892948,
                -18.97568130638867
              ],
              [
                121.56657960978552,
                -18.955254751294905
              ],
              [
                121.56918381659436,
                -18.94459413824552
              ],
              [
                121.57569418576344,
                -18.935723461979578
              ],
              [
                121.59107504565681,
                -18.921156408337048
              ],
              [
                121.59742274400746,
                -18.911228230833313
              ],
              [
                121.6128035641217,
                -18.865004077320517
              ],
              [
                121.63184652059986,
                -18.82398839570368
              ],
              [
                121.64258871751713,
                -18.810235183446938
              ],
              [
                121.64869225339083,
                -18.786228120008026
              ],
              [
                121.64966883745858,
                -18.776788124418452
              ],
              [
                121.64625085092473,
                -18.763441684287468
              ],
              [
                121.63819418230975,
                -18.754815241630425
              ],
              [
                121.62891688526356,
                -18.747735393466858
              ],
              [
                121.6217554199289,
                -18.739353196422588
              ],
              [
                121.61329188783634,
                -18.712497776236653
              ],
              [
                121.62452231368461,
                -18.710625818860887
              ],
              [
                121.64389082086737,
                -18.71705494534732
              ],
              [
                121.65967858531708,
                -18.715020457317998
              ],
              [
                121.6677352502916,
                -18.70907982419191
              ],
              [
                121.67823328263935,
                -18.706150065102914
              ],
              [
                121.7155867660929,
                -18.703708499002797
              ],
              [
                121.72380615963766,
                -18.699476691328595
              ],
              [
                121.76905356195107,
                -18.657403154316043
              ],
              [
                121.77719158655214,
                -18.640882994936764
              ],
              [
                121.78003993378937,
                -18.619236052197387
              ],
              [
                121.77475022053089,
                -18.606133842896508
              ],
              [
                121.76197350862627,
                -18.59693778080755
              ],
              [
                121.73161868299096,
                -18.580987223155056
              ],
              [
                121.7596134723205,
                -18.560967682907517
              ],
              [
                121.77393637760065,
                -18.5456681460484
              ],
              [
                121.79664149936472,
                -18.48691185226864
              ],
              [
                121.8110457758286,
                -18.462579067773312
              ],
              [
                121.82374105191876,
                -18.45183669819009
              ],
              [
                121.83741296792913,
                -18.455743151052985
              ],
              [
                121.85075928962729,
                -18.463636871329147
              ],
              [
                121.86654707414625,
                -18.470798450550515
              ],
              [
                121.88868246291577,
                -18.471856254045452
              ],
              [
                121.91032961270699,
                -18.464450728135144
              ],
              [
                122.02214602435484,
                -18.384698147065606
              ],
              [
                122.04420005065631,
                -18.360528177034258
              ],
              [
                122.05307053721278,
                -18.3314756587897
              ],
              [
                122.06226645764596,
                -18.320000837858856
              ],
              [
                122.12208094721325,
                -18.293633832125643
              ],
              [
                122.14210044124822,
                -18.279473487886552
              ],
              [
                122.15805100016591,
                -18.263441779920875
              ],
              [
                122.18344159436468,
                -18.225355689085735
              ],
              [
                122.18637129979723,
                -18.229668926641537
              ],
              [
                122.19239342037552,
                -18.2343075270441
              ],
              [
                122.1971134579208,
                -18.23894612731061
              ],
              [
                122.21045983849301,
                -18.211114223248607
              ],
              [
                122.22038820576577,
                -18.197198119182257
              ],
              [
                122.2506616321199,
                -18.186781394309975
              ],
              [
                122.32398520870014,
                -18.150567249876353
              ],
              [
                122.34701581483279,
                -18.12118902931451
              ],
              [
                122.36304774668012,
                -18.087986057916204
              ],
              [
                122.36915125097487,
                -18.06389745866816
              ],
              [
                122.36768639571231,
                -18.026136985544877
              ],
              [
                122.36068770017636,
                -18.000176711862153
              ],
              [
                122.3440861313523,
                -17.9830054537641
              ],
              [
                122.31373131919011,
                -17.971449492957294
              ],
              [
                122.28345785348264,
                -17.964287891291857
              ],
              [
                122.24854574349708,
                -17.960869922312185
              ],
              [
                122.21705165492254,
                -17.969659242781628
              ],
              [
                122.19711347987071,
                -17.998793241359863
              ],
              [
                122.19092858487063,
                -17.998793241359863
              ],
              [
                122.1872664749282,
                -17.991957304652296
              ],
              [
                122.18238366445371,
                -17.986504838290713
              ],
              [
                122.17676840392981,
                -17.982110178522206
              ],
              [
                122.16976973008575,
                -17.978285430450075
              ],
              [
                122.19613691207344,
                -17.94540779533305
              ],
              [
                122.20785566741543,
                -17.911309515118823
              ],
              [
                122.20728601999305,
                -17.873223646352237
              ],
              [
                122.19336996026149,
                -17.805840613271908
              ],
              [
                122.19711345156566,
                -17.742445442574454
              ],
              [
                122.19947349469832,
                -17.733086800017
              ],
              [
                122.20362387763046,
                -17.722100436284535
              ],
              [
                122.20541427366669,
                -17.710870124141753
              ],
              [
                122.20053141978931,
                -17.700860151444818
              ],
              [
                122.18848719616595,
                -17.683689167124435
              ],
              [
                122.17725670753411,
                -17.663018490705145
              ],
              [
                122.17432700412225,
                -17.653985208603117
              ],
              [
                122.1697697163509,
                -17.62883874597664
              ],
              [
                122.15626062918182,
                -17.597833023201936
              ],
              [
                122.15406334971463,
                -17.58814870979573
              ],
              [
                122.14519288187047,
                -17.572198057369715
              ],
              [
                122.14323978302691,
                -17.563653268399445
              ],
              [
                122.14112388253118,
                -17.45875410639279
              ],
              [
                122.14942468659977,
                -17.34148534357607
              ],
              [
                122.1670028123463,
                -17.295668290531914
              ],
              [
                122.17204836539537,
                -17.261162979807246
              ],
              [
                122.17872154568317,
                -17.24423591273539
              ],
              [
                122.19044028689467,
                -17.230563992372637
              ],
              [
                122.207692890763,
                -17.22478599252392
              ],
              [
                122.21412195512336,
                -17.210870122932626
              ],
              [
                122.2668563127474,
                -17.15064867916274
              ],
              [
                122.27963301708414,
                -17.139255508865553
              ],
              [
                122.27369225715886,
                -17.12835053536798
              ],
              [
                122.26254316124846,
                -17.126234613556754
              ],
              [
                122.25660241637833,
                -17.121270474066154
              ],
              [
                122.26612389854294,
                -17.101250932571723
              ],
              [
                122.27605227571864,
                -17.089287996773507
              ],
              [
                122.41277102510713,
                -16.972751534480114
              ],
              [
                122.45101972627826,
                -16.95045337923256
              ],
              [
                122.4445092974406,
                -16.968926620283025
              ],
              [
                122.4508569676739,
                -16.981622006511845
              ],
              [
                122.46412192685622,
                -16.9838191953028
              ],
              [
                122.47828208371563,
                -16.970961126743713
              ],
              [
                122.48161867250307,
                -16.94996503156229
              ],
              [
                122.4752710187928,
                -16.932386918456395
              ],
              [
                122.47291099105065,
                -16.920179878312236
              ],
              [
                122.48829187250156,
                -16.915704083670498
              ],
              [
                122.50611412526825,
                -16.919610264498363
              ],
              [
                122.51539146388473,
                -16.929375866614944
              ],
              [
                122.52133222734298,
                -16.941664322789958
              ],
              [
                122.52955163096782,
                -16.953871362263374
              ],
              [
                122.54297935545065,
                -16.9608700106427
              ],
              [
                122.59498130270296,
                -16.970961126743713
              ],
              [
                122.58204186412074,
                -16.956231383841676
              ],
              [
                122.560313341785,
                -16.90943773074468
              ],
              [
                122.53044681044678,
                -16.873955985102423
              ],
              [
                122.52613365756086,
                -16.861748943216845
              ],
              [
                122.52751712310702,
                -16.85027434756086
              ],
              [
                122.53126061210882,
                -16.844170826325023
              ],
              [
                122.53598066330747,
                -16.84010181212043
              ],
              [
                122.54029381908973,
                -16.834405222213636
              ],
              [
                122.54167728706697,
                -16.83749769107836
              ],
              [
                122.54615318573812,
                -16.839043850395278
              ],
              [
                122.5510360110675,
                -16.83749769107836
              ],
              [
                122.55347741003652,
                -16.8309872381914
              ],
              [
                122.55258221535486,
                -16.817315301840814
              ],
              [
                122.55347742406926,
                -16.81389746790299
              ],
              [
                122.56177818057328,
                -16.79973718319251
              ],
              [
                122.57056726654638,
                -16.78850683498394
              ],
              [
                122.58236738333572,
                -16.779554942504944
              ],
              [
                122.601247601304,
                -16.772230775962026
              ],
              [
                122.60661867533753,
                -16.786879108935153
              ],
              [
                122.61443118068952,
                -16.796075100092068
              ],
              [
                122.62598716253392,
                -16.8003882135089
              ],
              [
                122.64283288129161,
                -16.800225531037213
              ],
              [
                122.65015710799615,
                -16.797621409765227
              ],
              [
                122.66456140655606,
                -16.78850683498394
              ],
              [
                122.67359460127358,
                -16.786716426458764
              ],
              [
                122.69727623894417,
                -16.78769297196024
              ],
              [
                122.70427494027466,
                -16.786716426458764
              ],
              [
                122.71892337455259,
                -16.778903912159635
              ],
              [
                122.72901453117379,
                -16.769219723008007
              ],
              [
                122.74048913148576,
                -16.76132579207414
              ],
              [
                122.7587996859495,
                -16.758721670589416
              ],
              [
                122.7736922553805,
                -16.76165130725876
              ],
              [
                122.82097416817822,
                -16.77971777519845
              ],
              [
                122.763194198172,
                -16.730075732497056
              ],
              [
                122.74610437183642,
                -16.702894836622477
              ],
              [
                122.74512778857563,
                -16.66985436461094
              ],
              [
                122.7483016418596,
                -16.662367514001456
              ],
              [
                122.75709068416259,
                -16.646579648814203
              ],
              [
                122.75879967175084,
                -16.638848548796627
              ],
              [
                122.75879967647849,
                -16.604424745842717
              ],
              [
                122.76246177712324,
                -16.594170789191516
              ],
              [
                122.77149497838981,
                -16.579278201950867
              ],
              [
                122.78394615799054,
                -16.56585050831857
              ],
              [
                122.79712975616134,
                -16.560153915490957
              ],
              [
                122.82553143869582,
                -16.563083553181627
              ],
              [
                122.83741296856196,
                -16.56161880944521
              ],
              [
                122.84888757642128,
                -16.55315526140523
              ],
              [
                122.85596764306831,
                -16.541192311042863
              ],
              [
                122.86166426570047,
                -16.52776461667219
              ],
              [
                122.87045331327451,
                -16.516778211846987
              ],
              [
                122.88640385546684,
                -16.51230241374516
              ],
              [
                122.89454185604608,
                -16.49212001291046
              ],
              [
                122.90284264163017,
                -16.450616131329785
              ],
              [
                122.91618900650218,
                -16.4159482205445
              ],
              [
                122.93824302904694,
                -16.416110903116362
              ],
              [
                123.00660242239263,
                -16.374444335503178
              ],
              [
                123.02027427190454,
                -16.382582219767468
              ],
              [
                123.01807700571898,
                -16.396091332829016
              ],
              [
                122.99838300952966,
                -16.422946875834118
              ],
              [
                123.0415145116329,
                -16.441094619634754
              ],
              [
                123.05836021046896,
                -16.453545769440264
              ],
              [
                123.05372155476668,
                -16.470635700422005
              ],
              [
                123.04078210626339,
                -16.47812270338847
              ],
              [
                123.02833091591494,
                -16.47722742355417
              ],
              [
                123.01587975046172,
                -16.473239823125976
              ],
              [
                123.00261478476466,
                -16.470635700422005
              ],
              [
                122.99000085710298,
                -16.473402655902063
              ],
              [
                122.98487389388819,
                -16.48105234140315
              ],
              [
                122.97787520308842,
                -16.50546644175093
              ],
              [
                122.9904077358671,
                -16.52922936047901
              ],
              [
                122.95980878400346,
                -16.580336164197437
              ],
              [
                122.97169029210986,
                -16.594170789191516
              ],
              [
                122.97673586415897,
                -16.616468961214196
              ],
              [
                122.98072350880862,
                -16.62542085643263
              ],
              [
                122.98878013725866,
                -16.629001524354223
              ],
              [
                123.00904381294859,
                -16.616875892856918
              ],
              [
                123.02100671910735,
                -16.614353187054192
              ],
              [
                123.02637778996763,
                -16.62558353895855
              ],
              [
                123.02670332719246,
                -16.64910250469578
              ],
              [
                123.03077234264363,
                -16.676202137110636
              ],
              [
                123.04281658794642,
                -16.6924780489862
              ],
              [
                123.06739342595398,
                -16.683526305025147
              ],
              [
                123.08187910995262,
                -16.703220351844422
              ],
              [
                123.09017989219431,
                -16.70964939009806
              ],
              [
                123.1020613799498,
                -16.7120906791193
              ],
              [
                123.1125594275441,
                -16.709730656241526
              ],
              [
                123.11703535885653,
                -16.70354586706618
              ],
              [
                123.11988366498795,
                -16.69540783624824
              ],
              [
                123.12574303900334,
                -16.686944290075793
              ],
              [
                123.1321720771947,
                -16.686293259612043
              ],
              [
                123.13355552087035,
                -16.6968725796586
              ],
              [
                123.13103275890397,
                -16.71103286732599
              ],
              [
                123.12574304131282,
                -16.72112398917176
              ],
              [
                123.11491948043178,
                -16.727634443560422
              ],
              [
                123.10710697621063,
                -16.72893650438532
              ],
              [
                123.10084070321174,
                -16.73235448914226
              ],
              [
                123.09457441186224,
                -16.745700762529992
              ],
              [
                123.09449302529848,
                -16.769300989141865
              ],
              [
                123.10645593040235,
                -16.786390911291164
              ],
              [
                123.12378990938042,
                -16.796807546757407
              ],
              [
                123.13941491230086,
                -16.800225531037213
              ],
              [
                123.15088952508668,
                -16.8077125298271
              ],
              [
                123.1562606050273,
                -16.824802300349706
              ],
              [
                123.15772545139288,
                -16.843438379736643
              ],
              [
                123.15674888361006,
                -16.855564005809967
              ],
              [
                123.14356530933367,
                -16.89234796359172
              ],
              [
                123.14332114731396,
                -16.913750843027632
              ],
              [
                123.16016686898769,
                -16.92310966411849
              ],
              [
                123.1837671089926,
                -16.928968935236856
              ],
              [
                123.19825280975223,
                -16.943129215615762
              ],
              [
                123.21810958515213,
                -16.977715826311652
              ],
              [
                123.26042727479563,
                -17.01474372109897
              ],
              [
                123.26661217704759,
                -17.02939219557495
              ],
              [
                123.26758875239675,
                -17.069512702209185
              ],
              [
                123.2717391304373,
                -17.085625916402364
              ],
              [
                123.28028405458063,
                -17.101250932571723
              ],
              [
                123.31544031173573,
                -17.138278964268
              ],
              [
                123.33375086027866,
                -17.162367514103533
              ],
              [
                123.34180748487796,
                -17.187269774006978
              ],
              [
                123.35075931835684,
                -17.204685191651308
              ],
              [
                123.36817468409343,
                -17.228448221480615
              ],
              [
                123.37940514484747,
                -17.25481536732562
              ],
              [
                123.36963951016816,
                -17.27947352096184
              ],
              [
                123.38795007086865,
                -17.315606402782997
              ],
              [
                123.39966882897775,
                -17.329278319014392
              ],
              [
                123.43441816565158,
                -17.34441497531113
              ],
              [
                123.44809002979423,
                -17.36500411318849
              ],
              [
                123.45777427579519,
                -17.384372607313697
              ],
              [
                123.46583093396788,
                -17.38933689247122
              ],
              [
                123.47706138630011,
                -17.40545008898815
              ],
              [
                123.49040773607659,
                -17.416273635625057
              ],
              [
                123.50147546775833,
                -17.429782864438124
              ],
              [
                123.5117293678013,
                -17.47185640224883
              ],
              [
                123.54053795861311,
                -17.50139740213471
              ],
              [
                123.55396568351334,
                -17.518975481275856
              ],
              [
                123.56031333145275,
                -17.536228044720303
              ],
              [
                123.56690512644171,
                -17.576348477745533
              ],
              [
                123.56763755582291,
                -17.591403852878106
              ],
              [
                123.57081141364955,
                -17.595147492685868
              ],
              [
                123.57789144290871,
                -17.59050857587445
              ],
              [
                123.58497152142506,
                -17.58098709442013
              ],
              [
                123.58814539191323,
                -17.570570635910297
              ],
              [
                123.58765710480859,
                -17.51506930834149
              ],
              [
                123.58659915526383,
                -17.507500910329487
              ],
              [
                123.58130945543427,
                -17.492364263796887
              ],
              [
                123.56332442267731,
                -17.457614880782153
              ],
              [
                123.56080163172334,
                -17.447360948763155
              ],
              [
                123.56169680691337,
                -17.404473545308164
              ],
              [
                123.56763755978479,
                -17.361993065473555
              ],
              [
                123.573252801121,
                -17.350192972688593
              ],
              [
                123.58985436315268,
                -17.326755467775115
              ],
              [
                123.59498132102404,
                -17.313571898533507
              ],
              [
                123.59522545827149,
                -17.302666931464902
              ],
              [
                123.59408613619551,
                -17.290459905169897
              ],
              [
                123.59441164150473,
                -17.27874107530411
              ],
              [
                123.59839929103134,
                -17.26946383071336
              ],
              [
                123.6043400347665,
                -17.260511950339428
              ],
              [
                123.6076766230527,
                -17.250664941690285
              ],
              [
                123.60922283999236,
                -17.228203972741927
              ],
              [
                123.6128035784222,
                -17.215752844736958
              ],
              [
                123.62061607741663,
                -17.207940339597158
              ],
              [
                123.62964928526637,
                -17.202569270360293
              ],
              [
                123.634532100909,
                -17.201592725962758
              ],
              [
                123.63697350305198,
                -17.20289478515878
              ],
              [
                123.6433211708227,
                -17.203708647260655
              ],
              [
                123.64429773544934,
                -17.184747071733014
              ],
              [
                123.63965905509816,
                -17.172784139069464
              ],
              [
                123.62281336150811,
                -17.155938483257863
              ],
              [
                123.57960045059744,
                -17.094008038119547
              ],
              [
                123.57447350244246,
                -17.042901291980545
              ],
              [
                123.5776473185461,
                -17.02548586567347
              ],
              [
                123.59131920964288,
                -16.9999325636337
              ],
              [
                123.5949813263762,
                -16.985121405567316
              ],
              [
                123.60613039093087,
                -16.996351748414728
              ],
              [
                123.61540774800453,
                -16.996514581022996
              ],
              [
                123.62468510556376,
                -16.992608400980043
              ],
              [
                123.63591555693884,
                -16.991387607047166
              ],
              [
                123.65040124691816,
                -16.993910460998972
              ],
              [
                123.656016467291,
                -16.995782134714467
              ],
              [
                123.667246950318,
                -17.00847752002016
              ],
              [
                123.66993247946941,
                -17.015720266054107
              ],
              [
                123.68018640419879,
                -17.060316717418736
              ],
              [
                123.68628991432459,
                -17.057875280228625
              ],
              [
                123.69312584722138,
                -17.05071380113795
              ],
              [
                123.69800865982563,
                -17.04664478910318
              ],
              [
                123.71273848447603,
                -17.052829723428623
              ],
              [
                123.73340906193006,
                -17.066094720273014
              ],
              [
                123.75147546164531,
                -17.082614865835403
              ],
              [
                123.75945071894253,
                -17.09783295095919
              ],
              [
                123.76107832342224,
                -17.10800547941252
              ],
              [
                123.76547286431015,
                -17.117608394051157
              ],
              [
                123.77125085837302,
                -17.126071931224658
              ],
              [
                123.777110225401,
                -17.132419546405224
              ],
              [
                123.78891034039721,
                -17.140720250649018
              ],
              [
                123.81153406209796,
                -17.150485996843123
              ],
              [
                123.82154383053143,
                -17.155938483257863
              ],
              [
                123.83448326352661,
                -17.171644762053344
              ],
              [
                123.84652753327629,
                -17.19231532870664
              ],
              [
                123.86085045830333,
                -17.210381775640563
              ],
              [
                123.87973067563911,
                -17.217950182183593
              ],
              [
                123.90267988507973,
                -17.2185197954977
              ],
              [
                123.91334070287185,
                -17.215590162452
              ],
              [
                123.91773523407643,
                -17.20745214251478
              ],
              [
                123.9140731262564,
                -17.198988607553847
              ],
              [
                123.90479576352683,
                -17.196058824102415
              ],
              [
                123.89340254751782,
                -17.194512666325114
              ],
              [
                123.88298587234381,
                -17.19068775465374
              ],
              [
                123.85377038181234,
                -17.163262642362582
              ],
              [
                123.83708743940262,
                -17.132419546405224
              ],
              [
                123.81470788412643,
                -17.053480753328614
              ],
              [
                123.79883872972931,
                -17.019789278445835
              ],
              [
                123.79460695457871,
                -17.00009524602577
              ],
              [
                123.80445396793328,
                -16.991387607047166
              ],
              [
                123.81763756716906,
                -16.996189066020992
              ],
              [
                123.85401451521248,
                -17.01848721851985
              ],
              [
                123.86304771538083,
                -17.025567281971032
              ],
              [
                123.86963951981492,
                -17.00465260619306
              ],
              [
                123.85865317871786,
                -16.991631705748226
              ],
              [
                123.84310957257019,
                -16.979261985092137
              ],
              [
                123.8352156984112,
                -16.960707328233497
              ],
              [
                123.84164473972898,
                -16.946547198711425
              ],
              [
                123.87012778966725,
                -16.923597861607686
              ],
              [
                123.87671960951538,
                -16.912693031702666
              ],
              [
                123.88379966897293,
                -16.8969051748166
              ],
              [
                123.9007267733711,
                -16.88665137438245
              ],
              [
                123.92090904905098,
                -16.878350514086318
              ],
              [
                123.93751061149479,
                -16.867852464203533
              ],
              [
                123.94849693296483,
                -16.850518446348428
              ],
              [
                123.95329836694107,
                -16.828545799557332
              ],
              [
                123.9485783146952,
                -16.809258689246583
              ],
              [
                123.93140709931569,
                -16.800225531037213
              ],
              [
                123.9235945996218,
                -16.83879975160132
              ],
              [
                123.90259849640628,
                -16.858981989639805
              ],
              [
                123.83521570103154,
                -16.881524398962803
              ],
              [
                123.79249106808452,
                -16.890720237927415
              ],
              [
                123.76807703206899,
                -16.87851334674372
              ],
              [
                123.73267664320466,
                -16.81389746790299
              ],
              [
                123.72608483249874,
                -16.796482031596806
              ],
              [
                123.71680747470833,
                -16.757419459627183
              ],
              [
                123.7082625540002,
                -16.74187584631285
              ],
              [
                123.69312585292991,
                -16.729913050001834
              ],
              [
                123.65935307498593,
                -16.71445085220117
              ],
              [
                123.64332115079567,
                -16.704034064791106
              ],
              [
                123.61158288332811,
                -16.673760697712734
              ],
              [
                123.59555098046766,
                -16.665297151208286
              ],
              [
                123.50993901004423,
                -16.65390396732691
              ],
              [
                123.5091252069466,
                -16.649834951569495
              ],
              [
                123.51295007383595,
                -16.642022435226863
              ],
              [
                123.52930748433907,
                -16.632419509730482
              ],
              [
                123.5525008349359,
                -16.626234569491142
              ],
              [
                123.56617272891408,
                -16.61598076341436
              ],
              [
                123.55396568307243,
                -16.594170789191516
              ],
              [
                123.59506268622499,
                -16.57488367040876
              ],
              [
                123.60914147626738,
                -16.563897416534147
              ],
              [
                123.60922285593395,
                -16.54631928979456
              ],
              [
                123.59644616901876,
                -16.53590264970607
              ],
              [
                123.5551863836123,
                -16.539727417045643
              ],
              [
                123.53345788570881,
                -16.53215914851327
              ],
              [
                123.54574627684723,
                -16.562676621504973
              ],
              [
                123.54346765251206,
                -16.566989886964226
              ],
              [
                123.51254317458913,
                -16.566664371667766
              ],
              [
                123.49854577954586,
                -16.5619443247441
              ],
              [
                123.49252364110944,
                -16.549737275608262
              ],
              [
                123.48804771952204,
                -16.543877849886755
              ],
              [
                123.45850670517554,
                -16.525974207332368
              ],
              [
                123.45883222946645,
                -16.524672146069648
              ],
              [
                123.44597416852814,
                -16.51230241374516
              ],
              [
                123.44467208452792,
                -16.51230241374516
              ],
              [
                123.43946375153179,
                -16.507907881786593
              ],
              [
                123.43336021068298,
                -16.50457116194756
              ],
              [
                123.42758223801094,
                -16.499769848447382
              ],
              [
                123.4241642550309,
                -16.49114346692023
              ],
              [
                123.46949303355952,
                -16.50367603235788
              ],
              [
                123.48267663611753,
                -16.50546644175093
              ],
              [
                123.49252362934982,
                -16.5002580463299
              ],
              [
                123.48609458786503,
                -16.488376511500693
              ],
              [
                123.4658309231329,
                -16.46379972807066
              ],
              [
                123.48951256907417,
                -16.468926707339403
              ],
              [
                123.52426190197768,
                -16.498467636924776
              ],
              [
                123.54346765112109,
                -16.50546644175093
              ],
              [
                123.56763755547725,
                -16.511000202243853
              ],
              [
                123.59294680017766,
                -16.522149289705585
              ],
              [
                123.61841880853179,
                -16.529961807488675
              ],
              [
                123.64332115817274,
                -16.525974207332368
              ],
              [
                123.63510174845753,
                -16.51539473418447
              ],
              [
                123.62061607342841,
                -16.510349171599714
              ],
              [
                123.58814538612357,
                -16.50546644175093
              ],
              [
                123.60743247477669,
                -16.494073104887292
              ],
              [
                123.63819420837068,
                -16.489515890267185
              ],
              [
                123.65406335030264,
                -16.48447032751423
              ],
              [
                123.53874760261996,
                -16.426446278566797
              ],
              [
                123.50611412301943,
                -16.416110903116362
              ],
              [
                123.50611412035818,
                -16.407972868905905
              ],
              [
                123.53785242259023,
                -16.414646159109573
              ],
              [
                123.54932702621251,
                -16.41187920344713
              ],
              [
                123.55396569322818,
                -16.395603134888677
              ],
              [
                123.64844812641365,
                -16.427829756377747
              ],
              [
                123.71168054224002,
                -16.429782848502093
              ],
              [
                123.68816164634545,
                -16.407972868905905
              ],
              [
                123.6755477343317,
                -16.399102537719912
              ],
              [
                123.66041100623006,
                -16.395603134888677
              ],
              [
                123.65186607990104,
                -16.39251066380689
              ],
              [
                123.64405357422349,
                -16.38534917551048
              ],
              [
                123.6324976001194,
                -16.371351864359255
              ],
              [
                123.63160239687416,
                -16.364678573875914
              ],
              [
                123.64047286581007,
                -16.360609706792214
              ],
              [
                123.65162192756223,
                -16.36028404120153
              ],
              [
                123.66439863270276,
                -16.369886970073626
              ],
              [
                123.68132570986793,
                -16.37623459493926
              ],
              [
                123.69971764274699,
                -16.38103605931573
              ],
              [
                123.7116805260547,
                -16.381280158289357
              ],
              [
                123.71509849147604,
                -16.37346763917257
              ],
              [
                123.71656333882147,
                -16.358656464320518
              ],
              [
                123.71558679665634,
                -16.343357091312317
              ],
              [
                123.7116805210582,
                -16.33359132942262
              ],
              [
                123.69825279723443,
                -16.33001066020117
              ],
              [
                123.6579696013915,
                -16.32773205250947
              ],
              [
                123.64958744005202,
                -16.323337519699432
              ],
              [
                123.64576255282316,
                -16.3153621673974
              ],
              [
                123.63697350111302,
                -16.30535245652053
              ],
              [
                123.6269637267663,
                -16.29680748972995
              ],
              [
                123.6191512311072,
                -16.2931454040082
              ],
              [
                123.61011802880728,
                -16.295179912767527
              ],
              [
                123.60336348454365,
                -16.299737278472417
              ],
              [
                123.6028752038976,
                -16.304131811359973
              ],
              [
                123.61231528737362,
                -16.30624758628994
              ],
              [
                123.61589603825009,
                -16.308526344233623
              ],
              [
                123.61500083992331,
                -16.313409075068442
              ],
              [
                123.61019940721812,
                -16.31812912329921
              ],
              [
                123.60181725475307,
                -16.31991953303519
              ],
              [
                123.59408613040841,
                -16.316827061749617
              ],
              [
                123.58887779432278,
                -16.310723535557763
              ],
              [
                123.58480879025153,
                -16.3043759103492
              ],
              [
                123.58130944089987,
                -16.299981377462434
              ],
              [
                123.55836021424025,
                -16.286716362318774
              ],
              [
                123.54737390773796,
                -16.277520514841203
              ],
              [
                123.5397241581043,
                -16.265232045699488
              ],
              [
                123.56714929449923,
                -16.26091892910334
              ],
              [
                123.57642663291416,
                -16.242445592080234
              ],
              [
                123.57064863895653,
                -16.22185640473032
              ],
              [
                123.5539656889339,
                -16.21062589784793
              ],
              [
                123.56373131537478,
                -16.18531666161998
              ],
              [
                123.57016035645464,
                -16.176934527092932
              ],
              [
                123.58130944027587,
                -16.16961028008187
              ],
              [
                123.58545983149524,
                -16.174004813269224
              ],
              [
                123.59669030559857,
                -16.178806278269374
              ],
              [
                123.60336347867077,
                -16.175551049034677
              ],
              [
                123.59498131569725,
                -16.155938407360324
              ],
              [
                123.69092858305476,
                -16.14869557670931
              ],
              [
                123.71908613369692,
                -16.155938407360324
              ],
              [
                123.72413170452133,
                -16.136325765574714
              ],
              [
                123.73259524490076,
                -16.141045814220305
              ],
              [
                123.74187258787862,
                -16.154880444707914
              ],
              [
                123.74952233834195,
                -16.162774381282023
              ],
              [
                123.77100670472483,
                -16.163343995703265
              ],
              [
                123.77369226034311,
                -16.162774381282023
              ],
              [
                123.77849368497945,
                -16.167413013485806
              ],
              [
                123.78581790561728,
                -16.180433855331614
              ],
              [
                123.79053795584049,
                -16.183282152741928
              ],
              [
                123.79965253894838,
                -16.18547941932585
              ],
              [
                123.80689538156501,
                -16.191094672833618
              ],
              [
                123.80933679128916,
                -16.19890719290142
              ],
              [
                123.80445397275365,
                -16.207452085060268
              ],
              [
                123.7960718076025,
                -16.208754146695256
              ],
              [
                123.77426191889471,
                -16.201918247995962
              ],
              [
                123.76685631239494,
                -16.204359613566815
              ],
              [
                123.7692977223164,
                -16.216566666703972
              ],
              [
                123.78785241109676,
                -16.225355732902912
              ],
              [
                123.81128990983203,
                -16.230238539096355
              ],
              [
                123.82837975809305,
                -16.231133744014535
              ],
              [
                123.81348718181425,
                -16.246026336620016
              ],
              [
                123.78711999164089,
                -16.251560173563522
              ],
              [
                123.75749758896183,
                -16.253676023672792
              ],
              [
                123.73267663059973,
                -16.258965761595725
              ],
              [
                123.80347741931035,
                -16.30820082884401
              ],
              [
                123.82837975475447,
                -16.31991953303519
              ],
              [
                123.84245852254321,
                -16.32252365612696
              ],
              [
                123.8537703830587,
                -16.323337519699432
              ],
              [
                123.8626408196388,
                -16.32732512072468
              ],
              [
                123.86931399063462,
                -16.340427302667727
              ],
              [
                123.87061607312666,
                -16.356621955662305
              ],
              [
                123.86605878013589,
                -16.368096560412365
              ],
              [
                123.85808351889374,
                -16.37078209979577
              ],
              [
                123.8488061851326,
                -16.360772389372766
              ],
              [
                123.83521569478934,
                -16.36825939320658
              ],
              [
                123.85328210556699,
                -16.4159482205445
              ],
              [
                123.86304772924886,
                -16.429782848502093
              ],
              [
                123.8693139920019,
                -16.416110903116362
              ],
              [
                123.87671959100152,
                -16.416110903116362
              ],
              [
                123.87924239177964,
                -16.420668268338595
              ],
              [
                123.88502038019753,
                -16.424981384361264
              ],
              [
                123.8896590572505,
                -16.429782848502093
              ],
              [
                123.89470462290566,
                -16.409763278498186
              ],
              [
                123.89136802687112,
                -16.369805553676624
              ],
              [
                123.8972274025476,
                -16.353936416245112
              ],
              [
                123.8918563137076,
                -16.33879972575918
              ],
              [
                123.90674890639464,
                -16.33863704317559
              ],
              [
                123.92872153893077,
                -16.34612389693767
              ],
              [
                123.94507896454473,
                -16.353936416245112
              ],
              [
                123.95036867358513,
                -16.35995852582552
              ],
              [
                123.96697026048942,
                -16.374444335503178
              ],
              [
                123.98462974831911,
                -16.384698144773342
              ],
              [
                123.99284914256141,
                -16.377862171794344
              ],
              [
                123.95777428260335,
                -16.320896079195222
              ],
              [
                123.95142663464365,
                -16.293633752205196
              ],
              [
                123.98601320346047,
                -16.286309430521843
              ],
              [
                123.98601320553801,
                -16.278903842614675
              ],
              [
                123.96461022843533,
                -16.26865003249289
              ],
              [
                123.94239342447263,
                -16.252862235169527
              ],
              [
                123.92335045679035,
                -16.234795829873203
              ],
              [
                123.91089928957805,
                -16.217461871628103
              ],
              [
                123.93287193920078,
                -16.221774988324977
              ],
              [
                123.97217858521383,
                -16.240411083255044
              ],
              [
                123.9962671265975,
                -16.244805616306053
              ],
              [
                124.01889082782549,
                -16.246026336620016
              ],
              [
                124.02930748476412,
                -16.249281490643334
              ],
              [
                124.03386477828084,
                -16.255547774782517
              ],
              [
                124.0378524045688,
                -16.26344163589658
              ],
              [
                124.04761804315667,
                -16.263604468703644
              ],
              [
                124.06853274960413,
                -16.258965761595725
              ],
              [
                124.10775799747611,
                -16.26539472829159
              ],
              [
                124.12623131130447,
                -16.27223070187054
              ],
              [
                124.14795984043782,
                -16.28826267310313
              ],
              [
                124.1671655633464,
                -16.29697032253347
              ],
              [
                124.17090904745022,
                -16.302992432384976
              ],
              [
                124.19939213358342,
                -16.3750953662466
              ],
              [
                124.20997155706418,
                -16.389581025506757
              ],
              [
                124.22266686524027,
                -16.395603134888677
              ],
              [
                124.30062911100696,
                -16.40243910775008
              ],
              [
                124.33220462184082,
                -16.41008879385874
              ],
              [
                124.34213300029964,
                -16.407972868905905
              ],
              [
                124.36646569256209,
                -16.36451589129595
              ],
              [
                124.38607830809617,
                -16.35116946042337
              ],
              [
                124.40015710620501,
                -16.35312270290777
              ],
              [
                124.42481531253559,
                -16.374444335503178
              ],
              [
                124.44922935004787,
                -16.386976752351586
              ],
              [
                124.47364343450153,
                -16.393324527329504
              ],
              [
                124.59245852827422,
                -16.401299728871514
              ],
              [
                124.62330163153705,
                -16.39999766741711
              ],
              [
                124.65015709458969,
                -16.388116131246193
              ],
              [
                124.65748131824805,
                -16.395603134888677
              ],
              [
                124.68132570402369,
                -16.386976752351586
              ],
              [
                124.72575931942876,
                -16.382500953586195
              ],
              [
                124.7687280531527,
                -16.38534917551048
              ],
              [
                124.78785241555204,
                -16.39902112132519
              ],
              [
                124.80372155133679,
                -16.41822682805135
              ],
              [
                124.83969160796913,
                -16.425713831464325
              ],
              [
                124.87891687084249,
                -16.420668268338595
              ],
              [
                124.90398197605069,
                -16.40243910775008
              ],
              [
                124.8840438068863,
                -16.399183803899863
              ],
              [
                124.84083091083183,
                -16.405205913224492
              ],
              [
                124.82520593055378,
                -16.39902112132519
              ],
              [
                124.80941817830315,
                -16.387627933302035
              ],
              [
                124.79135174784642,
                -16.381931189028624
              ],
              [
                124.75318445356857,
                -16.374444335503178
              ],
              [
                124.6972762251098,
                -16.34441490363804
              ],
              [
                124.59620201289387,
                -16.326592673554728
              ],
              [
                124.57325278915933,
                -16.325860226384307
              ],
              [
                124.49927818432407,
                -16.335707254519637
              ],
              [
                124.48552492680913,
                -16.3454728661776
              ],
              [
                124.47632896244275,
                -16.347832890234816
              ],
              [
                124.45679770903082,
                -16.33326581403927
              ],
              [
                124.45337974943978,
                -16.335056223753988
              ],
              [
                124.44996178375416,
                -16.33847421037724
              ],
              [
                124.44459068360041,
                -16.340427302667727
              ],
              [
                124.42872154944835,
                -16.340508719066776
              ],
              [
                124.41325931081109,
                -16.338148694995184
              ],
              [
                124.40154055348876,
                -16.329278213032737
              ],
              [
                124.39478599917508,
                -16.299248930277507
              ],
              [
                124.38998457981701,
                -16.29265720602581
              ],
              [
                124.38542728268152,
                -16.287855741306647
              ],
              [
                124.3833113847769,
                -16.282647344774023
              ],
              [
                124.38526451358574,
                -16.270196193080526
              ],
              [
                124.39478599970766,
                -16.249607006045363
              ],
              [
                124.39682051107974,
                -16.23853933212961
              ],
              [
                124.39210045316715,
                -16.229180576475024
              ],
              [
                124.38306724863327,
                -16.222914292248085
              ],
              [
                124.37842858753442,
                -16.214939089665865
              ],
              [
                124.38656659589547,
                -16.20061611124976
              ],
              [
                124.39185631358339,
                -16.188164959025112
              ],
              [
                124.39185630943912,
                -16.175957905747094
              ],
              [
                124.39454186447902,
                -16.166599224951206
              ],
              [
                124.4182235102635,
                -16.16057711468119
              ],
              [
                124.42554772200883,
                -16.153578383047485
              ],
              [
                124.42969810738303,
                -16.141859602760796
              ],
              [
                124.43091881618747,
                -16.070000910013796
              ],
              [
                124.43433678102028,
                -16.057793856456616
              ],
              [
                124.44312584042336,
                -16.051853087387286
              ],
              [
                124.4542749408103,
                -16.05266695104375
              ],
              [
                124.46583091968162,
                -16.060479396222274
              ],
              [
                124.47242271836095,
                -16.073500238327338
              ],
              [
                124.47266685690848,
                -16.087823142100692
              ],
              [
                124.47103926540197,
                -16.10182060554405
              ],
              [
                124.47266685654526,
                -16.11500413020176
              ],
              [
                124.47689863836452,
                -16.120538042519964
              ],
              [
                124.49984785210872,
                -16.14226653458471
              ],
              [
                124.51091556038071,
                -16.158298431671547
              ],
              [
                124.52035567095699,
                -16.176446253973747
              ],
              [
                124.52955163162635,
                -16.154961861115357
              ],
              [
                124.54672285397594,
                -16.128106388636677
              ],
              [
                124.56967206619606,
                -16.10995856611318
              ],
              [
                124.59620201253887,
                -16.11500413020176
              ],
              [
                124.59001712522264,
                -16.094170842987207
              ],
              [
                124.58936608145503,
                -16.02507903104658
              ],
              [
                124.58375085352452,
                -15.988864877440863
              ],
              [
                124.59115644651732,
                -15.97730885481196
              ],
              [
                124.61597740381852,
                -15.977227438404096
              ],
              [
                124.60767663446097,
                -15.957614871721395
              ],
              [
                124.60629316530998,
                -15.936781509689366
              ],
              [
                124.60971114036845,
                -15.89869560580218
              ],
              [
                124.61988366254684,
                -15.881931261933035
              ],
              [
                124.64258873531749,
                -15.865655191309868
              ],
              [
                124.66586347999085,
                -15.861504832379783
              ],
              [
                124.67798912735704,
                -15.881036057015098
              ],
              [
                124.68425540335694,
                -15.881036057015098
              ],
              [
                124.69459068901907,
                -15.856377852149558
              ],
              [
                124.69922936569672,
                -15.836846627790305
              ],
              [
                124.70875084414078,
                -15.820733315300847
              ],
              [
                124.73267662816944,
                -15.806573170435907
              ],
              [
                124.69711347330136,
                -15.79404060265096
              ],
              [
                124.67888430764633,
                -15.79168057854282
              ],
              [
                124.63168378588428,
                -15.79420336034453
              ],
              [
                124.6218367834947,
                -15.797784104715475
              ],
              [
                124.60971113317026,
                -15.806573170435907
              ],
              [
                124.58668053850761,
                -15.8478329602407
              ],
              [
                124.55844159844241,
                -15.874932530517848
              ],
              [
                124.51514732675125,
                -15.970147365436263
              ],
              [
                124.48633874329593,
                -15.99830497477095
              ],
              [
                124.48365318709237,
                -15.985528231751701
              ],
              [
                124.48666425271266,
                -15.975030171788402
              ],
              [
                124.49138431047396,
                -15.964125255135267
              ],
              [
                124.49317467488702,
                -15.950453382383571
              ],
              [
                124.48943118815508,
                -15.940687769753882
              ],
              [
                124.48226973266642,
                -15.934991174919087
              ],
              [
                124.47559655156005,
                -15.927341412517036
              ],
              [
                124.46949303604706,
                -15.895928649729521
              ],
              [
                124.45045006311456,
                -15.843194253149218
              ],
              [
                124.4384871754562,
                -15.826348568508712
              ],
              [
                124.43995202196156,
                -15.839043894274335
              ],
              [
                124.43873132079682,
                -15.849704711340195
              ],
              [
                124.43409263743155,
                -15.85564540494438
              ],
              [
                124.42481530456216,
                -15.85426200204609
              ],
              [
                124.42090904899271,
                -15.860609627471668
              ],
              [
                124.41675865978202,
                -15.864841402803943
              ],
              [
                124.404307484866,
                -15.874769772815815
              ],
              [
                124.39918053968032,
                -15.804782835791247
              ],
              [
                124.393402538434,
                -15.788832281360147
              ],
              [
                124.3845320939066,
                -15.771416907910123
              ],
              [
                124.38152102859378,
                -15.748467698217851
              ],
              [
                124.38347414884555,
                -15.727634338890018
              ],
              [
                124.38998456978315,
                -15.717054939250882
              ],
              [
                124.37794029424931,
                -15.687269758030967
              ],
              [
                124.37647545786355,
                -15.67620208580391
              ],
              [
                124.37745202081851,
                -15.666924748124021
              ],
              [
                124.38062584285348,
                -15.664483307910348
              ],
              [
                124.38526451837036,
                -15.667738536494301
              ],
              [
                124.38998457186354,
                -15.67620208580391
              ],
              [
                124.39682050986359,
                -15.67620208580391
              ],
              [
                124.3956811832863,
                -15.663995034889897
              ],
              [
                124.39673913479008,
                -15.652276332266567
              ],
              [
                124.3997501984703,
                -15.6422665477766
              ],
              [
                124.40430749167982,
                -15.635186476531393
              ],
              [
                124.41797935747188,
                -15.669366113237102
              ],
              [
                124.42628015058608,
                -15.647556284706562
              ],
              [
                124.4275008449707,
                -15.621514569667536
              ],
              [
                124.41846764082827,
                -15.6040991992627
              ],
              [
                124.39682050743612,
                -15.608005458255676
              ],
              [
                124.40333092354146,
                -15.55925871381422
              ],
              [
                124.39698326831976,
                -15.53915780617578
              ],
              [
                124.3764754580728,
                -15.525323181037217
              ],
              [
                124.38990319376371,
                -15.522556263555398
              ],
              [
                124.40601647159276,
                -15.528008719708902
              ],
              [
                124.41920006564058,
                -15.534600516979097
              ],
              [
                124.42481529677181,
                -15.535577062852752
              ],
              [
                124.4289656899197,
                -15.53045012192491
              ],
              [
                124.4477645208797,
                -15.525079044572493
              ],
              [
                124.45199628875024,
                -15.521661058968684
              ],
              [
                124.4519962878777,
                -15.491143476030878
              ],
              [
                124.47291100353563,
                -15.468682547376842
              ],
              [
                124.50424238721668,
                -15.4674618651666
              ],
              [
                124.53760827189163,
                -15.480726837309009
              ],
              [
                124.5652775397308,
                -15.501560152484506
              ],
              [
                124.57813560973698,
                -15.506931229638711
              ],
              [
                124.59799238490054,
                -15.509942321065228
              ],
              [
                124.61768639612801,
                -15.50953542696721
              ],
              [
                124.62964928766294,
                -15.50497813797996
              ],
              [
                124.62964928786225,
                -15.43254975419339
              ],
              [
                124.63111412699455,
                -15.425469647647347
              ],
              [
                124.63461347456372,
                -15.419040609201767
              ],
              [
                124.64014733235211,
                -15.415948176994092
              ],
              [
                124.64673912698485,
                -15.41887785158795
              ],
              [
                124.64942467534229,
                -15.426853124936736
              ],
              [
                124.64283287974429,
                -15.446384377205652
              ],
              [
                124.64332116143832,
                -15.457126568120616
              ],
              [
                124.65406334879657,
                -15.472344669130232
              ],
              [
                124.66863040817965,
                -15.478448192918451
              ],
              [
                124.68262779709238,
                -15.473890866609835
              ],
              [
                124.69174238543884,
                -15.457126568120616
              ],
              [
                124.67286217390424,
                -15.44264087680716
              ],
              [
                124.67261803502359,
                -15.418226821133194
              ],
              [
                124.68344160121697,
                -15.392347910557376
              ],
              [
                124.69800866229205,
                -15.373956001021446
              ],
              [
                124.72779381742075,
                -15.361260683077761
              ],
              [
                124.73267662869844,
                -15.357517183284848
              ],
              [
                124.72803795390067,
                -15.34758878235811
              ],
              [
                124.70850670985733,
                -15.34563569126878
              ],
              [
                124.70533288094023,
                -15.332940374058978
              ],
              [
                124.68100019273234,
                -15.349786047396657
              ],
              [
                124.66968834931606,
                -15.352308865184042
              ],
              [
                124.6637475929454,
                -15.339776305387081
              ],
              [
                124.66700280169113,
                -15.324395450648558
              ],
              [
                124.6772567057905,
                -15.321058845097284
              ],
              [
                124.68921959744874,
                -15.320489193560455
              ],
              [
                124.69800866003628,
                -15.313083592207073
              ],
              [
                124.69792727885083,
                -15.29843514743064
              ],
              [
                124.68685957235809,
                -15.294366151766683
              ],
              [
                124.67286217635804,
                -15.294366151766683
              ],
              [
                124.6637475909257,
                -15.291924731853689
              ],
              [
                124.6603296238565,
                -15.283786721903306
              ],
              [
                124.6601668637782,
                -15.274183856458244
              ],
              [
                124.663747593479,
                -15.250420839490399
              ],
              [
                124.6823836594164,
                -15.260674734652788
              ],
              [
                124.68816165456307,
                -15.262790620494279
              ],
              [
                124.69800866013686,
                -15.264743748784344
              ],
              [
                124.69605553376407,
                -15.261976813913224
              ],
              [
                124.69800866069957,
                -15.25709401201264
              ],
              [
                124.70264733344334,
                -15.252536725281496
              ],
              [
                124.70875084847953,
                -15.250420839490399
              ],
              [
                124.71176191354029,
                -15.2535132706254
              ],
              [
                124.71306399928993,
                -15.268650005390706
              ],
              [
                124.71558678454106,
                -15.274590750371535
              ],
              [
                124.72038821755768,
                -15.275323178193243
              ],
              [
                124.75660240979053,
                -15.28525155880149
              ],
              [
                124.76148522357235,
                -15.292168886988179
              ],
              [
                124.75489342482973,
                -15.307793877027054
              ],
              [
                124.73951256794079,
                -15.332940374058978
              ],
              [
                124.74586022312545,
                -15.33538177541112
              ],
              [
                124.7822371744558,
                -15.301446218891366
              ],
              [
                124.7978621739246,
                -15.291924731853689
              ],
              [
                124.8039656898851,
                -15.295179939630453
              ],
              [
                124.81560306122836,
                -15.309828384302715
              ],
              [
                124.82520592503639,
                -15.313083592207073
              ],
              [
                124.83545983345341,
                -15.318047792285357
              ],
              [
                124.83480878860108,
                -15.329766526032362
              ],
              [
                124.82862389724369,
                -15.343357047454173
              ],
              [
                124.82203209378208,
                -15.354099198706807
              ],
              [
                124.84343509287302,
                -15.352797137962325
              ],
              [
                124.86931400107856,
                -15.347751577502919
              ],
              [
                124.88347415292021,
                -15.347263267176011
              ],
              [
                124.90552818875793,
                -15.351657797260074
              ],
              [
                124.92042077123438,
                -15.361016546684358
              ],
              [
                124.9455672572658,
                -15.388848584494589
              ],
              [
                124.94971764640134,
                -15.395684516590759
              ],
              [
                124.95215905299656,
                -15.402032175950426
              ],
              [
                124.95753014550945,
                -15.406833600534592
              ],
              [
                124.97624758986133,
                -15.410251547911836
              ],
              [
                124.98340905008448,
                -15.413832290476874
              ],
              [
                124.98959394560104,
                -15.41838957874682
              ],
              [
                124.99333743699117,
                -15.422295836595572
              ],
              [
                124.99317467435026,
                -15.438083588335642
              ],
              [
                124.97624759009125,
                -15.469170820261674
              ],
              [
                124.97974693997024,
                -15.477634367210864
              ],
              [
                124.99170982952775,
                -15.478122640103075
              ],
              [
                125.0007430349703,
                -15.47291432083278
              ],
              [
                125.00855553461722,
                -15.46648528184653
              ],
              [
                125.01758874058851,
                -15.463311470563427
              ],
              [
                125.02759850280667,
                -15.466729418287974
              ],
              [
                125.02711022291223,
                -15.47478607112724
              ],
              [
                125.02442467452259,
                -15.484063406318038
              ],
              [
                125.02759850186787,
                -15.491143476030878
              ],
              [
                125.04981530309833,
                -15.498223583379655
              ],
              [
                125.05396569189314,
                -15.48577239901457
              ],
              [
                125.05355879229305,
                -15.465590114895448
              ],
              [
                125.06169680855028,
                -15.449639567206576
              ],
              [
                125.08659915695668,
                -15.454766545009834
              ],
              [
                125.1579695992526,
                -15.505140895617961
              ],
              [
                125.18523196401149,
                -15.517836179279694
              ],
              [
                125.17237389126376,
                -15.502373940670456
              ],
              [
                125.13217206777337,
                -15.471774979874557
              ],
              [
                125.1237085288875,
                -15.46013762174399
              ],
              [
                125.07252037697796,
                -15.41887785158795
              ],
              [
                125.07349694064166,
                -15.40748463097547
              ],
              [
                125.08961021991679,
                -15.347263267176011
              ],
              [
                125.09888756549958,
                -15.338067313157493
              ],
              [
                125.11304772204883,
                -15.329278253277424
              ],
              [
                125.12924238546145,
                -15.322360943309182
              ],
              [
                125.14429771956337,
                -15.31926847414448
              ],
              [
                125.14429772203641,
                -15.313083592207073
              ],
              [
                125.12761478145912,
                -15.313734641301432
              ],
              [
                125.1144311864358,
                -15.308689062480454
              ],
              [
                125.1040145201156,
                -15.298760681355724
              ],
              [
                125.09644615978998,
                -15.28525155880149
              ],
              [
                125.09050540648445,
                -15.305108339454122
              ],
              [
                125.07292728006534,
                -15.304457290371976
              ],
              [
                125.05258222857526,
                -15.293226829983032
              ],
              [
                125.03809655150806,
                -15.281426699608732
              ],
              [
                125.02662194143309,
                -15.283949479472112
              ],
              [
                124.9843856126043,
                -15.312188406745149
              ],
              [
                124.95150800840976,
                -15.323011973639655
              ],
              [
                124.92888431028818,
                -15.338148691951456
              ],
              [
                124.9177352229473,
                -15.339776305387081
              ],
              [
                124.90658613530714,
                -15.333184510438247
              ],
              [
                124.90162194245885,
                -15.322360943309182
              ],
              [
                124.89714602906305,
                -15.299411711652928
              ],
              [
                124.89380944006042,
                -15.297295825636748
              ],
              [
                124.88933353008689,
                -15.298028253495657
              ],
              [
                124.88526451951088,
                -15.296807552916047
              ],
              [
                124.88347415414236,
                -15.288669524100445
              ],
              [
                124.88453209829903,
                -15.28045013542554
              ],
              [
                124.88746178513277,
                -15.275485935758931
              ],
              [
                124.89714603013705,
                -15.264743748784344
              ],
              [
                124.90699303364633,
                -15.257745042248537
              ],
              [
                124.91871178499184,
                -15.253024997953181
              ],
              [
                124.92465254157858,
                -15.247165632045835
              ],
              [
                124.9177352207944,
                -15.23739999108514
              ],
              [
                124.92465254089916,
                -15.229261982160157
              ],
              [
                124.9362085284851,
                -15.222588791301458
              ],
              [
                124.94792727968183,
                -15.217950126172369
              ],
              [
                124.96558678652882,
                -15.21306732478295
              ],
              [
                124.97055097853564,
                -15.207777610825753
              ],
              [
                124.97681725553574,
                -15.207777610825753
              ],
              [
                124.98991946700484,
                -15.219984633027408
              ],
              [
                125.00652102915716,
                -15.221286712162366
              ],
              [
                125.02572675991317,
                -15.203708597247612
              ],
              [
                125.05543053633295,
                -15.162286073685111
              ],
              [
                125.04672285236336,
                -15.158379818095648
              ],
              [
                125.02507571771275,
                -15.153008726113558
              ],
              [
                125.01384524759914,
                -15.148614188684856
              ],
              [
                125.00586998801144,
                -15.177504165065304
              ],
              [
                125.00359134112539,
                -15.18206145096327
              ],
              [
                124.99366295801535,
                -15.18141042084709
              ],
              [
                124.98633873834848,
                -15.178480729007093
              ],
              [
                124.98170006506844,
                -15.172539966630247
              ],
              [
                124.97974694233214,
                -15.162286073685111
              ],
              [
                124.9738875659315,
                -15.16806405960502
              ],
              [
                124.96363365910602,
                -15.186293221851953
              ],
              [
                124.96265709712524,
                -15.19019947772072
              ],
              [
                124.95492597540617,
                -15.191827071826156
              ],
              [
                124.9318953782797,
                -15.203220305857029
              ],
              [
                124.88721764559368,
                -15.23967865314033
              ],
              [
                124.86988366148142,
                -15.250420839490399
              ],
              [
                124.8701277999375,
                -15.233819268640811
              ],
              [
                124.87224368568504,
                -15.228610933191188
              ],
              [
                124.87671959851042,
                -15.223728131675463
              ],
              [
                124.86988366159892,
                -15.216241153190186
              ],
              [
                124.86304772084242,
                -15.22991301235328
              ],
              [
                124.85621178384244,
                -15.22991301235328
              ],
              [
                124.85792077046077,
                -15.219496360394146
              ],
              [
                124.8567814467262,
                -15.198500262180636
              ],
              [
                124.85621178632158,
                -15.195082297610623
              ],
              [
                124.85987389332102,
                -15.1862118430865
              ],
              [
                124.86817467477967,
                -15.174411715728485
              ],
              [
                124.86988365987074,
                -15.165948174253602
              ],
              [
                124.86150149765524,
                -15.16285572500874
              ],
              [
                124.8450626951707,
                -15.167250253212293
              ],
              [
                124.83423912935679,
                -15.164727474060237
              ],
              [
                124.84197024772055,
                -15.141208590382734
              ],
              [
                124.84351647231028,
                -15.141534114795094
              ],
              [
                124.85621178457949,
                -15.13494231356572
              ],
              [
                124.85808352963876,
                -15.131280203908132
              ],
              [
                124.86052493644935,
                -15.118910417604468
              ],
              [
                124.86304772179776,
                -15.114434501827144
              ],
              [
                124.87159264343538,
                -15.109307546724166
              ],
              [
                124.88363691563859,
                -15.104750261705231
              ],
              [
                124.89665774732539,
                -15.101495046084569
              ],
              [
                124.90772545684541,
                -15.10027434610215
              ],
              [
                124.91700279945356,
                -15.102471609828832
              ],
              [
                124.93067467500494,
                -15.11223723802801
              ],
              [
                124.95248457108576,
                -15.115899347496711
              ],
              [
                124.95997155075908,
                -15.119886981395446
              ],
              [
                124.97291100357911,
                -15.13494231356572
              ],
              [
                124.99708092567175,
                -15.097914324896102
              ],
              [
                125.01303144572192,
                -15.08464934538543
              ],
              [
                125.02125084684522,
                -15.10027434610215
              ],
              [
                125.02759850393838,
                -15.084567966642087
              ],
              [
                125.03150475411753,
                -15.061618748683632
              ],
              [
                125.02784264388322,
                -15.040948174318812
              ],
              [
                125.01042728019156,
                -15.031914973117312
              ],
              [
                125.0127059250313,
                -15.023695571182163
              ],
              [
                125.01197350398998,
                -15.005140882941218
              ],
              [
                125.00806725674836,
                -14.984551707101238
              ],
              [
                125.0001733876885,
                -14.970391620168805
              ],
              [
                125.01343833630774,
                -14.972100456290892
              ],
              [
                125.02361085221474,
                -14.976739069156649
              ],
              [
                125.04175868491834,
                -14.990980872863657
              ],
              [
                125.0480249418902,
                -14.981866178505472
              ],
              [
                125.05958093275987,
                -14.972344704492636
              ],
              [
                125.07227621438061,
                -14.9685196514946
              ],
              [
                125.08204188749393,
                -14.976657953516602
              ],
              [
                125.08318117714131,
                -14.993259321171681
              ],
              [
                125.06324303494924,
                -15.01360442470338
              ],
              [
                125.06169681119167,
                -15.031914973117312
              ],
              [
                125.06910240983677,
                -15.025079033047477
              ],
              [
                125.07593834710202,
                -15.059828383593036
              ],
              [
                125.08741295727665,
                -15.051202082609807
              ],
              [
                125.09839928515636,
                -15.029066665911477
              ],
              [
                125.11003665483672,
                -15.025079033047477
              ],
              [
                125.11036217515029,
                -15.027520441875756
              ],
              [
                125.11540774805485,
                -15.032891534319306
              ],
              [
                125.12134850388566,
                -15.037692966333617
              ],
              [
                125.12370852993688,
                -15.03875090863198
              ],
              [
                125.12614993588123,
                -15.049493096308504
              ],
              [
                125.12330162862582,
                -15.055271089823503
              ],
              [
                125.11898847663583,
                -15.06047942288261
              ],
              [
                125.1168725918597,
                -15.069512627184706
              ],
              [
                125.13282311377212,
                -15.107842710469486
              ],
              [
                125.13404381579733,
                -15.114434501827144
              ],
              [
                125.14047285129163,
                -15.120375253903497
              ],
              [
                125.15430748726534,
                -15.150323170762432
              ],
              [
                125.16529381733412,
                -15.162286073685111
              ],
              [
                125.17156009150236,
                -15.156019787131543
              ],
              [
                125.16724694173102,
                -15.149834898215273
              ],
              [
                125.16627037844884,
                -15.141859629819313
              ],
              [
                125.16895592509674,
                -15.133233331557951
              ],
              [
                125.17457115958526,
                -15.12444426660304
              ],
              [
                125.17611738445608,
                -15.116306250637365
              ],
              [
                125.15886477979258,
                -15.062758069794214
              ],
              [
                125.14795983181838,
                -15.04485442394228
              ],
              [
                125.14576256587934,
                -15.028008721296437
              ],
              [
                125.16529381603368,
                -15.011407159196303
              ],
              [
                125.16504967497404,
                -15.031996351848223
              ],
              [
                125.1726180350537,
                -15.04452890431216
              ],
              [
                125.185883009139,
                -15.05071380080857
              ],
              [
                125.20191490972857,
                -15.052422782421747
              ],
              [
                125.21558678477645,
                -15.057549736700718
              ],
              [
                125.22201582112922,
                -15.067071222750236
              ],
              [
                125.22974694072144,
                -15.072686454383343
              ],
              [
                125.24659264401791,
                -15.06609465910354
              ],
              [
                125.24984785235505,
                -15.078220312058864
              ],
              [
                125.25570722708473,
                -15.085056248490778
              ],
              [
                125.26221764387613,
                -15.08928801828198
              ],
              [
                125.28077233179869,
                -15.10759856483535
              ],
              [
                125.28174889387913,
                -15.113376559300852
              ],
              [
                125.27906334776098,
                -15.119886981395446
              ],
              [
                125.27393639368711,
                -15.128106376193264
              ],
              [
                125.28825931116438,
                -15.140557550947248
              ],
              [
                125.31080162885813,
                -15.150648695182644
              ],
              [
                125.32878665490448,
                -15.152764580449753
              ],
              [
                125.32911217471946,
                -15.141208590382734
              ],
              [
                125.35710696666547,
                -15.136488538071413
              ],
              [
                125.41993248857004,
                -15.149346616280301
              ],
              [
                125.43213951914387,
                -15.137953383828254
              ],
              [
                125.43067467531117,
                -15.120538020794736
              ],
              [
                125.4251408202633,
                -15.116143483748008
              ],
              [
                125.3940535818784,
                -15.120700778297628
              ],
              [
                125.38209069139491,
                -15.116875911279676
              ],
              [
                125.37378990979849,
                -15.10759856483535
              ],
              [
                125.36939537939755,
                -15.096449479299215
              ],
              [
                125.36947675935255,
                -15.086521094040885
              ],
              [
                125.37330162908479,
                -15.085056248490778
              ],
              [
                125.38038170696447,
                -15.084079684794071
              ],
              [
                125.38746178542102,
                -15.081801042437837
              ],
              [
                125.39063561271801,
                -15.076592704365959
              ],
              [
                125.38738040502403,
                -15.068129165139155
              ],
              [
                125.38013756601786,
                -15.06609465910354
              ],
              [
                125.37281334695189,
                -15.06503671672079
              ],
              [
                125.3694767591022,
                -15.059828383593036
              ],
              [
                125.36646569126019,
                -15.051446223510691
              ],
              [
                125.36939537929442,
                -15.047784114709945
              ],
              [
                125.38062584685542,
                -15.04615650716005
              ],
              [
                125.38892662925338,
                -15.042901301472032
              ],
              [
                125.40577233182606,
                -15.028415621987797
              ],
              [
                125.43083743595355,
                -15.019707940729432
              ],
              [
                125.42953535195413,
                -15.009047132732555
              ],
              [
                125.41749108201181,
                -15.00221119606837
              ],
              [
                125.38404381591026,
                -15.013929945477036
              ],
              [
                125.36695397196267,
                -15.008396091782005
              ],
              [
                125.35450278874943,
                -14.993910349323817
              ],
              [
                125.34652755253349,
                -14.996270514153794
              ],
              [
                125.33529709132385,
                -14.997735402618462
              ],
              [
                125.32992598953186,
                -14.996270514153794
              ],
              [
                125.32691489980594,
                -14.986423375438667
              ],
              [
                125.32162521347163,
                -14.984063511108083
              ],
              [
                125.31714927938144,
                -14.985121319165575
              ],
              [
                125.31128990960966,
                -14.987237235719075
              ],
              [
                125.3076277781142,
                -14.989678516144098
              ],
              [
                125.30860438797156,
                -14.990980872863657
              ],
              [
                125.29769941069806,
                -14.99195726487135
              ],
              [
                125.28858485764236,
                -14.99439884575998
              ],
              [
                125.28093509547824,
                -14.993422153316683
              ],
              [
                125.27393641146509,
                -14.984063511108083
              ],
              [
                125.27369224171184,
                -14.976169457106916
              ],
              [
                125.27767986887703,
                -14.967950039459128
              ],
              [
                125.28760824432919,
                -14.956231233418535
              ],
              [
                125.27572673810798,
                -14.956963677560612
              ],
              [
                125.26417076857953,
                -14.962009370536087
              ],
              [
                125.25570724470685,
                -14.967706091688951
              ],
              [
                125.25342859671831,
                -14.970391620168805
              ],
              [
                125.24284915299009,
                -14.966078371227127
              ],
              [
                125.23812907674981,
                -14.952813260919731
              ],
              [
                125.22925867685663,
                -14.949965200887995
              ],
              [
                125.22169030990344,
                -14.951918285090647
              ],
              [
                125.21827231569782,
                -14.95566162140431
              ],
              [
                125.21412195447857,
                -14.958103202022794
              ],
              [
                125.20492595234543,
                -14.956231233418535
              ],
              [
                125.197032086257,
                -14.952325064973714
              ],
              [
                125.18677817892198,
                -14.945489120092413
              ],
              [
                125.18295334444224,
                -14.939141671706572
              ],
              [
                125.19507898635935,
                -14.936293311364356
              ],
              [
                125.20427493990096,
                -14.93206147892559
              ],
              [
                125.20899497562071,
                -14.922295758184916
              ],
              [
                125.21208742561912,
                -14.912774285888792
              ],
              [
                125.2158309430124,
                -14.90837992207446
              ],
              [
                125.22722416552885,
                -14.906915034006468
              ],
              [
                125.24463951763333,
                -14.901299729948098
              ],
              [
                125.2534285989922,
                -14.901543978097619
              ],
              [
                125.25619551204736,
                -14.905450145944892
              ],
              [
                125.25782312320486,
                -14.912367506054222
              ],
              [
                125.26319421230501,
                -14.9191220341987
              ],
              [
                125.27735438331833,
                -14.922051810448442
              ],
              [
                125.28972413118676,
                -14.920098425993578
              ],
              [
                125.29476970963711,
                -14.914727369872432
              ],
              [
                125.29395591954241,
                -14.90601975787291
              ],
              [
                125.28760828482612,
                -14.894708034260558
              ],
              [
                125.30884850987741,
                -14.885023730658782
              ],
              [
                125.29761801789124,
                -14.868340651949099
              ],
              [
                125.26758873252906,
                -14.856215069643168
              ],
              [
                125.23292077985025,
                -14.860528317163137
              ],
              [
                125.22771243932338,
                -14.850192986671992
              ],
              [
                125.20215905990459,
                -14.844821931668328
              ],
              [
                125.19141688461828,
                -14.832696350204086
              ],
              [
                125.18873133294436,
                -14.77939228597246
              ],
              [
                125.1814071155913,
                -14.771905316867974
              ],
              [
                125.16814209877903,
                -14.77678787460754
              ],
              [
                125.16089928016099,
                -14.778415594154804
              ],
              [
                125.15788821187789,
                -14.774997623456906
              ],
              [
                125.15495853694537,
                -14.762872044460789
              ],
              [
                125.14820399661046,
                -14.75969832196414
              ],
              [
                125.14136802136406,
                -14.759860853568021
              ],
              [
                125.13746179869835,
                -14.757500990824344
              ],
              [
                125.13599692540602,
                -14.735935060669393
              ],
              [
                125.14429770822416,
                -14.728448092500779
              ],
              [
                125.15658613809603,
                -14.72869234052687
              ],
              [
                125.16846766134556,
                -14.730238643839861
              ],
              [
                125.17750086173952,
                -14.72747170125428
              ],
              [
                125.17725669506457,
                -14.720961124492275
              ],
              [
                125.17400150818185,
                -14.713067377045933
              ],
              [
                125.17457115182498,
                -14.70598718895436
              ],
              [
                125.18165125572992,
                -14.698825885431347
              ],
              [
                125.1853133289127,
                -14.698337389420859
              ],
              [
                125.18873132669657,
                -14.70077896819592
              ],
              [
                125.19507899589607,
                -14.702325271386053
              ],
              [
                125.2114364106986,
                -14.700860384198174
              ],
              [
                125.20134525298482,
                -14.684991173956284
              ],
              [
                125.20492599898921,
                -14.668145573342864
              ],
              [
                125.2177840563478,
                -14.66383232821499
              ],
              [
                125.25310308445843,
                -14.672947014069784
              ],
              [
                125.26026454128117,
                -14.671563542998951
              ],
              [
                125.26319422485494,
                -14.653741251550452
              ],
              [
                125.27149499158222,
                -14.650811477581613
              ],
              [
                125.2843530834181,
                -14.649021227072522
              ],
              [
                125.3012801683756,
                -14.634698322037606
              ],
              [
                125.28158615103806,
                -14.629815465838261
              ],
              [
                125.25806723564273,
                -14.632744939207521
              ],
              [
                125.23902427725852,
                -14.6315243002651
              ],
              [
                125.23292079276541,
                -14.614190506702116
              ],
              [
                125.24366296640551,
                -14.594170887970394
              ],
              [
                125.26587975614508,
                -14.57561615701241
              ],
              [
                125.29053796855746,
                -14.566176110157599
              ],
              [
                125.30860438633093,
                -14.573174879516511
              ],
              [
                125.31478928233201,
                -14.573174879516511
              ],
              [
                125.32243901433496,
                -14.558038118207172
              ],
              [
                125.32894942796433,
                -14.55046973778675
              ],
              [
                125.33350668463443,
                -14.543145304993978
              ],
              [
                125.33692468965678,
                -14.514255556360085
              ],
              [
                125.34107506580534,
                -14.503106376811857
              ],
              [
                125.3476668418175,
                -14.498711717680326
              ],
              [
                125.35645591423642,
                -14.504327015326062
              ],
              [
                125.3552351993599,
                -14.570489053690723
              ],
              [
                125.3522241312431,
                -14.582777458075073
              ],
              [
                125.34278407374069,
                -14.607354568515934
              ],
              [
                125.35564214415689,
                -14.587497782114562
              ],
              [
                125.37370850747004,
                -14.573907022421206
              ],
              [
                125.38819421626143,
                -14.559991200207458
              ],
              [
                125.39063559905654,
                -14.539157725216846
              ],
              [
                125.40430749739363,
                -14.553155263037985
              ],
              [
                125.43799891593383,
                -14.631931380197447
              ],
              [
                125.43946371615313,
                -14.638848434409844
              ],
              [
                125.44068445833787,
                -14.636651404450319
              ],
              [
                125.44516032865313,
                -14.620375117145796
              ],
              [
                125.43962649680087,
                -14.598809495750748
              ],
              [
                125.44263756820132,
                -14.589288032318423
              ],
              [
                125.45948324530534,
                -14.593031364708018
              ],
              [
                125.45826254689244,
                -14.58147540332595
              ],
              [
                125.45997152734103,
                -14.570489053690723
              ],
              [
                125.46485437578072,
                -14.560723643513734
              ],
              [
                125.47315512985627,
                -14.552829599162637
              ],
              [
                125.46615643661212,
                -14.54810957599806
              ],
              [
                125.46290121453201,
                -14.541761834419235
              ],
              [
                125.46290124291261,
                -14.53394950686718
              ],
              [
                125.46631919557872,
                -14.524834824503872
              ],
              [
                125.49366294527694,
                -14.54534263481653
              ],
              [
                125.48715254289877,
                -14.517510692647003
              ],
              [
                125.48658287290637,
                -14.503024960854004
              ],
              [
                125.49366294670376,
                -14.49065514316801
              ],
              [
                125.50131271395588,
                -14.486260784610726
              ],
              [
                125.5092879397805,
                -14.485772288885851
              ],
              [
                125.51693767513457,
                -14.488457813668983
              ],
              [
                125.5244246645329,
                -14.494073111160628
              ],
              [
                125.53248132306214,
                -14.497735327054494
              ],
              [
                125.55054773964369,
                -14.496514688561842
              ],
              [
                125.55502362336682,
                -14.497491079184494
              ],
              [
                125.55543052030501,
                -14.513848476558792
              ],
              [
                125.54468832620967,
                -14.527438933605374
              ],
              [
                125.53223717739607,
                -14.538018502553578
              ],
              [
                125.52784263227373,
                -14.54534263481653
              ],
              [
                125.53956141509933,
                -14.55331809497574
              ],
              [
                125.55779057984836,
                -14.55396912229966
              ],
              [
                125.57618249505968,
                -14.550388321818465
              ],
              [
                125.58920330926793,
                -14.54534263481653
              ],
              [
                125.5839950023388,
                -14.534763366086466
              ],
              [
                125.58383224030472,
                -14.526543958867105
              ],
              [
                125.58920330992486,
                -14.511162951593008
              ],
              [
                125.59115643734896,
                -14.510511924344453
              ],
              [
                125.59571372344064,
                -14.510430508384971
              ],
              [
                125.60035243192222,
                -14.508884506442014
              ],
              [
                125.60352622721521,
                -14.504327015326062
              ],
              [
                125.60328209105455,
                -14.499606992779478
              ],
              [
                125.5979923875851,
                -14.493584915853456
              ],
              [
                125.59669028970484,
                -14.48723717520661
              ],
              [
                125.60572349423614,
                -14.43320071915742
              ],
              [
                125.61500084808448,
                -14.410088806660216
              ],
              [
                125.617198121629,
                -14.401299791036573
              ],
              [
                125.61060629470872,
                -14.384453902927193
              ],
              [
                125.59766688614012,
                -14.367282952692827
              ],
              [
                125.58838950412233,
                -14.351006677112924
              ],
              [
                125.59302816830403,
                -14.336520951644763
              ],
              [
                125.59205160750986,
                -14.326267051975744
              ],
              [
                125.58643639058288,
                -14.30803799781112
              ],
              [
                125.5849715604704,
                -14.287693032044713
              ],
              [
                125.59669028725801,
                -14.270928564727516
              ],
              [
                125.5966902915592,
                -14.26482507545717
              ],
              [
                125.58545985109716,
                -14.255629283986853
              ],
              [
                125.58562258728453,
                -14.245700749592451
              ],
              [
                125.59457443748941,
                -14.239922924315565
              ],
              [
                125.6103621659215,
                -14.243584837383132
              ],
              [
                125.60580487929698,
                -14.229261947630718
              ],
              [
                125.61817466649389,
                -14.223728069858964
              ],
              [
                125.63526452998485,
                -14.231540691566835
              ],
              [
                125.64437909105096,
                -14.257256700822584
              ],
              [
                125.6518660710504,
                -14.257256700822584
              ],
              [
                125.65186607205597,
                -14.2504207690448
              ],
              [
                125.6580509670554,
                -14.2504207690448
              ],
              [
                125.66529381560333,
                -14.264255464531763
              ],
              [
                125.69361411970179,
                -14.27988040924487
              ],
              [
                125.7065535667623,
                -14.291436361462106
              ],
              [
                125.70875084880294,
                -14.283461207193595
              ],
              [
                125.71273847973141,
                -14.276625274968357
              ],
              [
                125.71876063141056,
                -14.270684617428648
              ],
              [
                125.72706138555046,
                -14.26482507545717
              ],
              [
                125.73316489724412,
                -14.270928564727516
              ],
              [
                125.72657312332522,
                -14.27947363011926
              ],
              [
                125.7127384601409,
                -14.305108226539481
              ],
              [
                125.7194116786514,
                -14.313897540419523
              ],
              [
                125.71843507763887,
                -14.324313971177874
              ],
              [
                125.71094813120587,
                -14.333672896510736
              ],
              [
                125.6990665790536,
                -14.339938918260685
              ],
              [
                125.68873132557019,
                -14.337660474131935
              ],
              [
                125.68140709816218,
                -14.330010682186284
              ],
              [
                125.67261805288248,
                -14.32545349362959
              ],
              [
                125.65805095468977,
                -14.333102985058648
              ],
              [
                125.66358484134895,
                -14.341078440757794
              ],
              [
                125.66285240469067,
                -14.348402569220134
              ],
              [
                125.65967860151451,
                -14.354913139412513
              ],
              [
                125.6580509890239,
                -14.360284187157095
              ],
              [
                125.6726180565901,
                -14.458266014952542
              ],
              [
                125.68197674927858,
                -14.473565303672494
              ],
              [
                125.68433680222412,
                -14.506768592794359
              ],
              [
                125.63697349925657,
                -14.598077052368023
              ],
              [
                125.63770594944103,
                -14.634698322037606
              ],
              [
                125.65235437643793,
                -14.622247083924442
              ],
              [
                125.69605552420718,
                -14.504327015326062
              ],
              [
                125.7057397870654,
                -14.494317359028402
              ],
              [
                125.71070396593662,
                -14.470879778995885
              ],
              [
                125.71273848174648,
                -14.425876589085682
              ],
              [
                125.71957440039336,
                -14.400974127292825
              ],
              [
                125.73292077566458,
                -14.398532850934828
              ],
              [
                125.74105881435332,
                -14.410414470411686
              ],
              [
                125.73316491448854,
                -14.429294556492023
              ],
              [
                125.74341883642819,
                -14.434991269046666
              ],
              [
                125.74415122278238,
                -14.444756675931666
              ],
              [
                125.73316490047335,
                -14.470147335866676
              ],
              [
                125.76823978838713,
                -14.463555648195875
              ],
              [
                125.78223718726498,
                -14.45745215589988
              ],
              [
                125.78785243334123,
                -14.445977614684315
              ],
              [
                125.79102621982452,
                -14.437188297806511
              ],
              [
                125.79810632485163,
                -14.434828437160421
              ],
              [
                125.80518637926522,
                -14.437920740871906
              ],
              [
                125.80836024534503,
                -14.445977614684315
              ],
              [
                125.80632572014291,
                -14.453220329196494
              ],
              [
                125.80355876710688,
                -14.45696366021241
              ],
              [
                125.80518641075305,
                -14.45956806926934
              ],
              [
                125.8157658118797,
                -14.463311400348115
              ],
              [
                125.82211346322897,
                -14.461195486957688
              ],
              [
                125.82740317178323,
                -14.454278135653977
              ],
              [
                125.83350669153376,
                -14.448174643507746
              ],
              [
                125.84253991563686,
                -14.449151334432774
              ],
              [
                125.84994553288733,
                -14.457614987795843
              ],
              [
                125.84896893666847,
                -14.466729368091912
              ],
              [
                125.84213298520123,
                -14.474053498953598
              ],
              [
                125.83253013423716,
                -14.476983271509354
              ],
              [
                125.81723064079246,
                -14.484307402570819
              ],
              [
                125.83301842078804,
                -14.519463774432829
              ],
              [
                125.82203208548046,
                -14.531670761148325
              ],
              [
                125.82203208300848,
                -14.539157725216846
              ],
              [
                125.83725021603819,
                -14.545098687343087
              ],
              [
                125.83716880181517,
                -14.552829599162637
              ],
              [
                125.83106531408417,
                -14.562107114159797
              ],
              [
                125.82886805842774,
                -14.573174879516511
              ],
              [
                125.83301843190812,
                -14.58456800868367
              ],
              [
                125.83985437002829,
                -14.594821915367085
              ],
              [
                125.84799239344628,
                -14.601006825907843
              ],
              [
                125.85670008964772,
                -14.600518630458856
              ],
              [
                125.88965905284032,
                -14.626885692064874
              ],
              [
                125.9094344608863,
                -14.639418346326865
              ],
              [
                125.91814212373697,
                -14.63779062742233
              ],
              [
                125.92505944690124,
                -14.596856413542735
              ],
              [
                125.92310632901331,
                -14.591485362417899
              ],
              [
                125.91863039529613,
                -14.585707231491575
              ],
              [
                125.90821374369189,
                -14.57634860034996
              ],
              [
                125.90381921277513,
                -14.569512662875267
              ],
              [
                125.90560958393536,
                -14.56414161215305
              ],
              [
                125.90984133713579,
                -14.56047939560217
              ],
              [
                125.91187583508676,
                -14.559014508992059
              ],
              [
                125.91602625470897,
                -14.537530307188648
              ],
              [
                125.920095269536,
                -14.52597434755446
              ],
              [
                125.92505942735787,
                -14.518649915247167
              ],
              [
                125.95964604934122,
                -14.519789438278748
              ],
              [
                125.96599369228717,
                -14.521661104114646
              ],
              [
                125.96810957841049,
                -14.526462542904099
              ],
              [
                125.9790145071585,
                -14.541924666351992
              ],
              [
                125.9834090382312,
                -14.54534263481653
              ],
              [
                125.99781332586261,
                -14.541110807116917
              ],
              [
                125.99927817595614,
                -14.53093831789983
              ],
              [
                125.99708093264708,
                -14.51962660635575
              ],
              [
                126.00074302388862,
                -14.511162951593008
              ],
              [
                126.01124106389793,
                -14.509698065178398
              ],
              [
                126.02670330264694,
                -14.519951969773931
              ],
              [
                126.034922708346,
                -14.518649915247167
              ],
              [
                126.04127038914262,
                -14.508721674523775
              ],
              [
                126.04053794632578,
                -14.497491079184494
              ],
              [
                126.03695724155061,
                -14.485528341451543
              ],
              [
                126.03492271225127,
                -14.473565303672494
              ],
              [
                126.03174888139874,
                -14.462578957233637
              ],
              [
                126.01758873673143,
                -14.44768644826009
              ],
              [
                126.01441493384658,
                -14.439141679602558
              ],
              [
                126.01286868371068,
                -14.42441170300265
              ],
              [
                126.00847416600243,
                -14.419122070304605
              ],
              [
                126.00180097996362,
                -14.416273714135084
              ],
              [
                125.99390710279917,
                -14.40878675251274
              ],
              [
                125.98845461979262,
                -14.404554926350036
              ],
              [
                125.98210698981829,
                -14.400811595848875
              ],
              [
                125.97828210869203,
                -14.39381282970628
              ],
              [
                125.98023523235042,
                -14.380791988552966
              ],
              [
                125.98568771090511,
                -14.38290790149791
              ],
              [
                125.9996850769982,
                -14.377699384874312
              ],
              [
                126.01172934283167,
                -14.370782035080218
              ],
              [
                126.01099695252478,
                -14.36712012083526
              ],
              [
                126.01677493730925,
                -14.36492279204822
              ],
              [
                126.03492274497292,
                -14.355645582321285
              ],
              [
                126.0608830221412,
                -14.350030286864978
              ],
              [
                126.06446373326982,
                -14.34156663587029
              ],
              [
                126.06267336023095,
                -14.330498877284978
              ],
              [
                126.06226645109697,
                -14.319431119011726
              ],
              [
                126.06568445459216,
                -14.31170021193119
              ],
              [
                126.07422937879598,
                -14.302829782612328
              ],
              [
                126.07585696852475,
                -14.29509857542867
              ],
              [
                126.07374107770814,
                -14.28679775743805
              ],
              [
                126.06430097808128,
                -14.27044036970223
              ],
              [
                126.0622664836671,
                -14.261000330382446
              ],
              [
                126.061534049487,
                -14.247816661812891
              ],
              [
                126.06299890221221,
                -14.235609684066851
              ],
              [
                126.07178796190676,
                -14.226657840535243
              ],
              [
                126.10206139019665,
                -14.222426016326926
              ],
              [
                126.10816488818449,
                -14.220798299203881
              ],
              [
                126.11670983837386,
                -14.216403943688494
              ],
              [
                126.1412866358103,
                -14.195489071301008
              ],
              [
                126.14478601587118,
                -14.195245124047622
              ],
              [
                126.14633220403347,
                -14.17693435950294
              ],
              [
                126.14185629497857,
                -14.158461064427115
              ],
              [
                126.14039147202199,
                -14.142998956137657
              ],
              [
                126.15162196308353,
                -14.133721751525307
              ],
              [
                126.13445070886381,
                -14.094903201772492
              ],
              [
                126.10710698566247,
                -14.079522511695876
              ],
              [
                126.00660243354368,
                -14.078220458615883
              ],
              [
                125.99244223694132,
                -14.071465645239593
              ],
              [
                125.98650152143092,
                -14.055596761238048
              ],
              [
                125.98422285273038,
                -14.045668231625053
              ],
              [
                125.97494548698045,
                -14.030938269358911
              ],
              [
                125.97282960639704,
                -14.021416819614037
              ],
              [
                125.9738875668711,
                -14.013441670532998
              ],
              [
                125.97901450692179,
                -14.000909036191876
              ],
              [
                125.98023524269138,
                -13.99041119770724
              ],
              [
                125.99236087145987,
                -13.999688399205484
              ],
              [
                126.01002039856498,
                -14.02605572109643
              ],
              [
                126.02051842299257,
                -14.031914959274557
              ],
              [
                126.03386477877307,
                -14.028496995220788
              ],
              [
                126.03516686398046,
                -14.01824310322142
              ],
              [
                126.03296958425754,
                -14.004327000028477
              ],
              [
                126.03492274270035,
                -13.99041119770724
              ],
              [
                126.04737390279237,
                -13.984063464968946
              ],
              [
                126.0740666215749,
                -14.02605572109643
              ],
              [
                126.09636477955735,
                -14.025079031194029
              ],
              [
                126.0915633472314,
                -14.016859634468018
              ],
              [
                126.09099367489121,
                -14.007093937459981
              ],
              [
                126.0914819493547,
                -13.996026187839252
              ],
              [
                126.0900985263574,
                -13.983575270278267
              ],
              [
                126.08594810493989,
                -13.96941492063689
              ],
              [
                126.08187908845356,
                -13.964532072634407
              ],
              [
                126.07504314179016,
                -13.962334745986762
              ],
              [
                126.03589930023924,
                -13.942315460394582
              ],
              [
                126.02800539728479,
                -13.935804896658384
              ],
              [
                126.01734458712345,
                -13.922051627749747
              ],
              [
                126.0202742688335,
                -13.920586743456528
              ],
              [
                126.03142335907012,
                -13.924737148823919
              ],
              [
                126.06006920807498,
                -13.931817322875263
              ],
              [
                126.06641686181884,
                -13.92766691744225
              ],
              [
                126.06910243296194,
                -13.911553791133063
              ],
              [
                126.07447352013608,
                -13.899102575510797
              ],
              [
                126.08643640489262,
                -13.889418296930634
              ],
              [
                126.09839929751003,
                -13.88738380232237
              ],
              [
                126.10377038886746,
                -13.89763769129222
              ],
              [
                126.09937585494492,
                -13.909275048906977
              ],
              [
                126.09213301666495,
                -13.918877912072132
              ],
              [
                126.09156333076676,
                -13.925388175134401
              ],
              [
                126.12012778040541,
                -13.929457164703207
              ],
              [
                126.1292424018971,
                -13.932061570405759
              ],
              [
                126.13843833386389,
                -13.930922049025432
              ],
              [
                126.15162193671559,
                -13.92213304359146
              ],
              [
                126.14958745705643,
                -13.932794012570534
              ],
              [
                126.14429771740859,
                -13.94133877067847
              ],
              [
                126.1303816886866,
                -13.956231261196697
              ],
              [
                126.13607831464185,
                -13.957777561455263
              ],
              [
                126.14576255632306,
                -13.961846551320154
              ],
              [
                126.1516219209465,
                -13.963067188201409
              ],
              [
                126.15162191938091,
                -13.969903115311856
              ],
              [
                126.13697351358452,
                -13.975844069015212
              ],
              [
                126.12476645193803,
                -13.987074349405562
              ],
              [
                126.11557050574538,
                -14.001722894327228
              ],
              [
                126.11060633058275,
                -14.017754908492511
              ],
              [
                126.12842858777674,
                -14.012139617653164
              ],
              [
                126.14323978558497,
                -14.002536752464083
              ],
              [
                126.17212976994917,
                -13.977308953490613
              ],
              [
                126.1816512308128,
                -13.970798389240286
              ],
              [
                126.19239343134322,
                -13.965508762401585
              ],
              [
                126.22046957867346,
                -13.956231261196697
              ],
              [
                126.20964601229748,
                -13.97682045837993
              ],
              [
                126.17839601479712,
                -13.995375161424843
              ],
              [
                126.16586349317866,
                -14.010918980635308
              ],
              [
                126.19239344604097,
                -14.014418360409206
              ],
              [
                126.21070398363797,
                -14.026625331695703
              ],
              [
                126.21420333199416,
                -14.039646161533112
              ],
              [
                126.19629967573168,
                -14.045668231625053
              ],
              [
                126.1691186802971,
                -14.049004779949788
              ],
              [
                126.16488690074013,
                -14.057793787929095
              ],
              [
                126.16871180093526,
                -14.070570671530858
              ],
              [
                126.1658634740803,
                -14.08538175060511
              ],
              [
                126.19825279528202,
                -14.077813379262004
              ],
              [
                126.21225020747957,
                -14.0814755913233
              ],
              [
                126.2136336521097,
                -14.099704635373977
              ],
              [
                126.18751061664247,
                -14.12249116686512
              ],
              [
                126.18034914307918,
                -14.133233256236334
              ],
              [
                126.19996180839806,
                -14.126885821807797
              ],
              [
                126.1910913527756,
                -14.159600586410424
              ],
              [
                126.21452886053615,
                -14.175469774768013
              ],
              [
                126.24146566781323,
                -14.185153759345818
              ],
              [
                126.24398845737313,
                -14.198907036712543
              ],
              [
                126.2373153142123,
                -14.202813497523328
              ],
              [
                126.23178144063324,
                -14.203220276571676
              ],
              [
                126.22803796962447,
                -14.204847993624455
              ],
              [
                126.22657311993046,
                -14.212985978130412
              ],
              [
                126.2297469407404,
                -14.214939058384724
              ],
              [
                126.24366294409553,
                -14.22161215776459
              ],
              [
                126.247731972291,
                -14.223239874890877
              ],
              [
                126.25928796093042,
                -14.217054970444368
              ],
              [
                126.27149500022949,
                -14.208265959114282
              ],
              [
                126.28207440186709,
                -14.20859132227176
              ],
              [
                126.28882897638103,
                -14.230075806208397
              ],
              [
                126.29558353438128,
                -14.230075806208397
              ],
              [
                126.2976180370312,
                -14.214288031632234
              ],
              [
                126.3020125678267,
                -14.20126719637352
              ],
              [
                126.31080162749099,
                -14.192315353597163
              ],
              [
                126.34506268660348,
                -14.184665564423849
              ],
              [
                126.34546957790504,
                -14.174248836851442
              ],
              [
                126.33594811658716,
                -14.161553666410738
              ],
              [
                126.31934655412724,
                -14.145114867827376
              ],
              [
                126.31373133223438,
                -14.141859734627518
              ],
              [
                126.30730227002971,
                -14.140801628575792
              ],
              [
                126.29867599797805,
                -14.140557681354682
              ],
              [
                126.29371180891332,
                -14.136488689796453
              ],
              [
                126.29802494567616,
                -14.127374016661753
              ],
              [
                126.30925539449065,
                -14.113376494035002
              ],
              [
                126.31226645093768,
                -14.096774865596396
              ],
              [
                126.31592858556847,
                -14.086846635451936
              ],
              [
                126.32455490039905,
                -14.080173538237355
              ],
              [
                126.34327232136896,
                -14.072930530038494
              ],
              [
                126.33855227579859,
                -14.06959398152725
              ],
              [
                126.33350672671801,
                -14.063083716318882
              ],
              [
                126.3291121671808,
                -14.059258672681102
              ],
              [
                126.34359784137328,
                -14.045505399895864
              ],
              [
                126.36166423716965,
                -14.045342568166701
              ],
              [
                126.37720786116127,
                -14.04265704635478
              ],
              [
                126.39031008242202,
                -14.005059442313199
              ],
              [
                126.4216414574932,
                -13.982354332912669
              ],
              [
                126.43213949733291,
                -13.969903115311856
              ],
              [
                126.44996180666533,
                -13.991794666376741
              ],
              [
                126.4699813014346,
                -13.99195719765829
              ],
              [
                126.4881291219111,
                -13.979424864360627
              ],
              [
                126.500987154891,
                -13.963067188201409
              ],
              [
                126.51693770584207,
                -13.937432612690385
              ],
              [
                126.52751711704988,
                -13.928968970072692
              ],
              [
                126.54184003314944,
                -13.932386933352452
              ],
              [
                126.56918378293139,
                -13.94198979701315
              ],
              [
                126.55583742010835,
                -13.945977370887235
              ],
              [
                126.54004967179634,
                -13.953708571627725
              ],
              [
                126.52686608993992,
                -13.963474267447607
              ],
              [
                126.52149498224401,
                -13.973565326460106
              ],
              [
                126.51905356271719,
                -13.983656385703753
              ],
              [
                126.51319419326401,
                -13.988539233918416
              ],
              [
                126.50635829067504,
                -13.991794666376741
              ],
              [
                126.50098719429624,
                -13.997247125242927
              ],
              [
                126.49634849696798,
                -14.023614146558327
              ],
              [
                126.49366295498503,
                -14.031914959274557
              ],
              [
                126.46501710717905,
                -14.05982828332433
              ],
              [
                126.45329835116533,
                -14.077569131649858
              ],
              [
                126.46273847407342,
                -14.08538175060511
              ],
              [
                126.48340906150433,
                -14.0814755913233
              ],
              [
                126.51596114349424,
                -14.069105786740073
              ],
              [
                126.52767987335336,
                -14.072930530038494
              ],
              [
                126.49366294647537,
                -14.113376494035002
              ],
              [
                126.5018009708388,
                -14.120293839411051
              ],
              [
                126.51392661097388,
                -14.141371239329029
              ],
              [
                126.52149500773834,
                -14.14739361129623
              ],
              [
                126.53614340730431,
                -14.146172673462456
              ],
              [
                126.54835044618763,
                -14.139418159423599
              ],
              [
                126.55884851565968,
                -14.134942388894993
              ],
              [
                126.56918381102294,
                -14.140557681354682
              ],
              [
                126.5720320771821,
                -14.151625134303512
              ],
              [
                126.56869551256779,
                -14.182793900205288
              ],
              [
                126.56918380191111,
                -14.195245124047622
              ],
              [
                126.57593832892,
                -14.209893375759524
              ],
              [
                126.5828556498419,
                -14.214043783939951
              ],
              [
                126.59156333128264,
                -14.217461749506926
              ],
              [
                126.60352624239202,
                -14.230075806208397
              ],
              [
                126.60328208727377,
                -14.201104364583836
              ],
              [
                126.60531658290701,
                -14.187269671251267
              ],
              [
                126.61085046982977,
                -14.175388358878298
              ],
              [
                126.62086023358356,
                -14.16920345515478
              ],
              [
                126.63453209997562,
                -14.164971631540348
              ],
              [
                126.64673913322017,
                -14.158135701309332
              ],
              [
                126.65186610239566,
                -14.143975646311423
              ],
              [
                126.64991294733628,
                -14.132582229612886
              ],
              [
                126.64698328166851,
                -14.123305025231877
              ],
              [
                126.64730878830407,
                -14.114190352384101
              ],
              [
                126.65528404138117,
                -14.103122599997675
              ],
              [
                126.65699305527791,
                -14.095310281142796
              ],
              [
                126.65170329956806,
                -14.08717199851439
              ],
              [
                126.64722740526517,
                -14.077813379262004
              ],
              [
                126.6518660728236,
                -14.066094601305087
              ],
              [
                126.65870199614305,
                -14.07138422937007
              ],
              [
                126.67359457685829,
                -14.080336069552187
              ],
              [
                126.6790470680684,
                -14.08538175060511
              ],
              [
                126.68336020810602,
                -14.094821785898466
              ],
              [
                126.68799887623068,
                -14.115329573818912
              ],
              [
                126.69271892605232,
                -14.120782034257322
              ],
              [
                126.70484458084651,
                -14.118096511968496
              ],
              [
                126.72038821732338,
                -14.08611419302788
              ],
              [
                126.73373456033602,
                -14.072930530038494
              ],
              [
                126.72681723150816,
                -14.058363398570389
              ],
              [
                126.733897323805,
                -14.04485437340717
              ],
              [
                126.74439537852597,
                -14.029880464011365
              ],
              [
                126.74740646225324,
                -14.010918980635308
              ],
              [
                126.74122156625252,
                -14.010918980635308
              ],
              [
                126.7371525546552,
                -14.017754908492511
              ],
              [
                126.73194418552494,
                -14.022718872521708
              ],
              [
                126.7202254549814,
                -14.031914959274557
              ],
              [
                126.70850668708269,
                -14.020684377301746
              ],
              [
                126.70118247683746,
                -14.007093937459981
              ],
              [
                126.7000431851452,
                -13.993829161461731
              ],
              [
                126.70720464546683,
                -13.983575270278267
              ],
              [
                126.71322676448258,
                -13.983331022719375
              ],
              [
                126.73414145346717,
                -13.989841286727835
              ],
              [
                126.7474064668174,
                -13.99041119770724
              ],
              [
                126.75123133118298,
                -13.980726917143034
              ],
              [
                126.7617293412764,
                -13.969903115311856
              ],
              [
                126.77426189329772,
                -13.974704547522434
              ],
              [
                126.78825933264125,
                -13.97258893710259
              ],
              [
                126.78891033027169,
                -13.969903115311856
              ],
              [
                126.81657960844791,
                -13.982354332912669
              ],
              [
                126.82976321928716,
                -13.982598580471027
              ],
              [
                126.84302816926241,
                -13.969903115311856
              ],
              [
                126.82406659880535,
                -13.963311435749093
              ],
              [
                126.81324301977136,
                -13.95696370340128
              ],
              [
                126.81006919019083,
                -13.949395334297426
              ],
              [
                126.81820721760825,
                -13.94264082334877
              ],
              [
                126.83106529942948,
                -13.943454681376506
              ],
              [
                126.8572697101845,
                -13.949395334297426
              ],
              [
                126.85157311562615,
                -13.939385691680146
              ],
              [
                126.84473719053304,
                -13.932712596726875
              ],
              [
                126.83472739839863,
                -13.928887554229744
              ],
              [
                126.81983483081177,
                -13.92766691744225
              ],
              [
                126.8078719375502,
                -13.923516512047735
              ],
              [
                126.80054774032298,
                -13.912855843716736
              ],
              [
                126.79688560129264,
                -13.89869549632325
              ],
              [
                126.79574630352417,
                -13.883965839383958
              ],
              [
                126.79200281526754,
                -13.877129913584167
              ],
              [
                126.77369226863028,
                -13.855157252717257
              ],
              [
                126.76783285581013,
                -13.846367948323447
              ],
              [
                126.75554447457014,
                -13.804945619727153
              ],
              [
                126.74740644414625,
                -13.791761965052169
              ],
              [
                126.76465902837936,
                -13.790785275657612
              ],
              [
                126.78541098343392,
                -13.787367313433668
              ],
              [
                126.80290774297447,
                -13.780043194588078
              ],
              [
                126.81006920131999,
                -13.76767339832663
              ],
              [
                126.81446372985482,
                -13.768324424415097
              ],
              [
                126.82276450393317,
                -13.776462400810207
              ],
              [
                126.82789147261037,
                -13.79111093893135
              ],
              [
                126.82325279206125,
                -13.812269738961598
              ],
              [
                126.83277430390422,
                -13.816094780481242
              ],
              [
                126.84302818904841,
                -13.818536053462521
              ],
              [
                126.84587649586848,
                -13.80754972429269
              ],
              [
                126.85328211348781,
                -13.800958047085851
              ],
              [
                126.86410566908339,
                -13.798028279278192
              ],
              [
                126.87720788308383,
                -13.798028279278192
              ],
              [
                126.87720787714436,
                -13.791761965052169
              ],
              [
                126.85962975593439,
                -13.782891546466558
              ],
              [
                126.84644614938694,
                -13.768975450504465
              ],
              [
                126.84538823750144,
                -13.754327213496063
              ],
              [
                126.86353602453359,
                -13.74334088582188
              ],
              [
                126.8818465499114,
                -13.745782158426582
              ],
              [
                126.89779704869056,
                -13.756442822906884
              ],
              [
                126.91374761174781,
                -13.763930073442113
              ],
              [
                126.9323836683415,
                -13.757582343855876
              ],
              [
                126.91285240991134,
                -13.745782158426582
              ],
              [
                126.9050399305403,
                -13.74334088582188
              ],
              [
                126.91553794114608,
                -13.735935051418773
              ],
              [
                126.92774500247695,
                -13.730889674705862
              ],
              [
                126.95289145552402,
                -13.723565256301766
              ],
              [
                126.97820071548954,
                -13.754001550247642
              ],
              [
                126.9931746685389,
                -13.766289930338177
              ],
              [
                127.01124108619581,
                -13.771254192037965
              ],
              [
                127.02003012412543,
                -13.777764453012226
              ],
              [
                127.02173913334417,
                -13.793226848934117
              ],
              [
                127.02116945510356,
                -13.825941588735198
              ],
              [
                127.03760824653605,
                -13.816175895876679
              ],
              [
                127.05062912491596,
                -13.813409260045649
              ],
              [
                127.05591882586393,
                -13.820082353251905
              ],
              [
                127.04908285776712,
                -13.83953202308473
              ],
              [
                127.07016034402369,
                -13.828057498895886
              ],
              [
                127.07211347387124,
                -13.842543206981361
              ],
              [
                127.06413820233301,
                -13.867770998372286
              ],
              [
                127.05534916760494,
                -13.88738380232237
              ],
              [
                127.08513431893196,
                -13.883884423549114
              ],
              [
                127.09351646110989,
                -13.900078964707516
              ],
              [
                127.09571374159466,
                -13.926364864815602
              ],
              [
                127.10743247042524,
                -13.952813297733888
              ],
              [
                127.12973068098849,
                -13.967706089064981
              ],
              [
                127.14258871953965,
                -13.956231261196697
              ],
              [
                127.15406334082334,
                -13.933770401840459
              ],
              [
                127.17261802686986,
                -13.915215701373956
              ],
              [
                127.16358485199116,
                -13.910821349002967
              ],
              [
                127.15935304600323,
                -13.902764485650549
              ],
              [
                127.15967859451483,
                -13.892185233646678
              ],
              [
                127.16521245051476,
                -13.88054787647122
              ],
              [
                127.18140707520179,
                -13.890313270270488
              ],
              [
                127.18726648418287,
                -13.901788096448001
              ],
              [
                127.18628991108456,
                -13.931817322875263
              ],
              [
                127.18930098120413,
                -13.946954060613525
              ],
              [
                127.19695069463343,
                -13.949313918450738
              ],
              [
                127.20590255059275,
                -13.943617513067743
              ],
              [
                127.21363365221217,
                -13.935804896658384
              ],
              [
                127.22632898009012,
                -13.904473617401212
              ],
              [
                127.23682702025381,
                -13.892022401974105
              ],
              [
                127.25131270595723,
                -13.89763769129222
              ],
              [
                127.28793380875162,
                -13.938246470708604
              ],
              [
                127.30298911212543,
                -13.949395334297426
              ],
              [
                127.33269289770871,
                -13.961195524956366
              ],
              [
                127.33122805228365,
                -13.944024291868567
              ],
              [
                127.32243899938615,
                -13.917413027789282
              ],
              [
                127.33025150702838,
                -13.901055654333783
              ],
              [
                127.34424890209769,
                -13.904473617401212
              ],
              [
                127.35328209520979,
                -13.916680585649656
              ],
              [
                127.36036217785474,
                -13.929782828075492
              ],
              [
                127.36768638620282,
                -13.935804896658384
              ],
              [
                127.38152101492645,
                -13.937757975641023
              ],
              [
                127.38949629493831,
                -13.943536097222111
              ],
              [
                127.39429771238017,
                -13.952243687230578
              ],
              [
                127.39861085274828,
                -13.963067188201409
              ],
              [
                127.40479574874735,
                -13.963067188201409
              ],
              [
                127.4070744110557,
                -13.957126535097455
              ],
              [
                127.41846763688405,
                -13.94198979701315
              ],
              [
                127.43043054312804,
                -13.953871403322715
              ],
              [
                127.44076581285317,
                -13.96941492063689
              ],
              [
                127.44849695706691,
                -13.986911818125831
              ],
              [
                127.45248458880539,
                -14.004083052885532
              ],
              [
                127.45215903142747,
                -14.013848449398425
              ],
              [
                127.44629965220633,
                -14.048760532354079
              ],
              [
                127.45020592438524,
                -14.057305593155403
              ],
              [
                127.47046961557655,
                -14.069919645004047
              ],
              [
                127.48047935902683,
                -14.079196848211724
              ],
              [
                127.48926840237293,
                -14.058363398570389
              ],
              [
                127.5042423885668,
                -14.06560640652189
              ],
              [
                127.52027426647003,
                -14.083103007472568
              ],
              [
                127.53199302829037,
                -14.092868706209579
              ],
              [
                127.54712976466898,
                -14.097914387411697
              ],
              [
                127.57496179776123,
                -14.123305025231877
              ],
              [
                127.59034266633542,
                -14.133721751525307
              ],
              [
                127.59506271601954,
                -14.134372778150523
              ],
              [
                127.6061304240302,
                -14.132989309019676
              ],
              [
                127.610850479339,
                -14.133721751525307
              ],
              [
                127.61524500984684,
                -14.137139716426006
              ],
              [
                127.62452235191036,
                -14.14739361129623
              ],
              [
                127.66602622142285,
                -14.17839924467071
              ],
              [
                127.67074629474156,
                -14.197198204217052
              ],
              [
                127.68262779813779,
                -14.216973554546371
              ],
              [
                127.69825279662219,
                -14.23544685226343
              ],
              [
                127.75586999091988,
                -14.284844676835046
              ],
              [
                127.76156660354509,
                -14.29509857542867
              ],
              [
                127.78956140568755,
                -14.36712012083526
              ],
              [
                127.79672283731125,
                -14.370863451009752
              ],
              [
                127.81592856465008,
                -14.374932444941846
              ],
              [
                127.82357833150188,
                -14.380791988552966
              ],
              [
                127.82585696959794,
                -14.38958100370838
              ],
              [
                127.82357832582616,
                -14.425876589085682
              ],
              [
                127.82691489980662,
                -14.436618686629497
              ],
              [
                127.83399501195348,
                -14.44255964712807
              ],
              [
                127.84107506128122,
                -14.443536037610789
              ],
              [
                127.84424891819295,
                -14.439141679602558
              ],
              [
                127.84595788382701,
                -14.425876589085682
              ],
              [
                127.85108485637396,
                -14.417250404978283
              ],
              [
                127.85987388756179,
                -14.415459855172303
              ],
              [
                127.87142988893004,
                -14.422458621709975
              ],
              [
                127.87940514797167,
                -14.439548458895098
              ],
              [
                127.85523524355021,
                -14.46510195037967
              ],
              [
                127.8579207587013,
                -14.483819207276381
              ],
              [
                127.87427821357333,
                -14.46990338844252
              ],
              [
                127.88721761981456,
                -14.474053498953598
              ],
              [
                127.90560956016779,
                -14.497491079184494
              ],
              [
                127.94019617006535,
                -14.518975579092375
              ],
              [
                127.95476319448355,
                -14.53289139975643
              ],
              [
                127.94385825477262,
                -14.539157725216846
              ],
              [
                127.93946371873905,
                -14.543877748266695
              ],
              [
                127.93995202365245,
                -14.554457317686346
              ],
              [
                127.94320722686786,
                -14.566013278214118
              ],
              [
                127.94727626182224,
                -14.573174879516511
              ],
              [
                127.95753013420415,
                -14.57887129384165
              ],
              [
                127.96697026473846,
                -14.578545930371408
              ],
              [
                127.99244224417102,
                -14.568617387606794
              ],
              [
                127.9987898857192,
                -14.56226964567363
              ],
              [
                128.0053817200395,
                -14.560723643513734
              ],
              [
                128.01856532387467,
                -14.569756910792849
              ],
              [
                128.04151450434497,
                -14.590427255141112
              ],
              [
                128.0465600678167,
                -14.593031364708018
              ],
              [
                128.05404709506055,
                -14.600518630458856
              ],
              [
                128.0593367609765,
                -14.616957147978052
              ],
              [
                128.06641684786445,
                -14.633477382660576
              ],
              [
                128.08033290040942,
                -14.640801817273134
              ],
              [
                128.09595788591477,
                -14.641290012776611
              ],
              [
                128.10694419219695,
                -14.643731290732035
              ],
              [
                128.11784914890683,
                -14.649997618102553
              ],
              [
                128.15919030524367,
                -14.688409143774605
              ],
              [
                128.17530356962112,
                -14.698418805422568
              ],
              [
                128.19678798146904,
                -14.702325271386053
              ],
              [
                128.20866947795463,
                -14.70077896819592
              ],
              [
                128.2146916263022,
                -14.698907301433158
              ],
              [
                128.21949302155042,
                -14.70045330418704
              ],
              [
                128.22779383239632,
                -14.70973082299308
              ],
              [
                128.23129315012463,
                -14.718194181979936
              ],
              [
                128.23194420749238,
                -14.72795989687718
              ],
              [
                128.23047934210632,
                -14.73723711598221
              ],
              [
                128.2277938348592,
                -14.743910525071744
              ],
              [
                128.21363367324955,
                -14.734958669402005
              ],
              [
                128.19776453818795,
                -14.731622115140864
              ],
              [
                128.1848250782179,
                -14.73699316837824
              ],
              [
                128.1794539855999,
                -14.75408302033275
              ],
              [
                128.1814070716396,
                -14.769951933277724
              ],
              [
                128.19361413933714,
                -14.805922193011975
              ],
              [
                128.19434653385508,
                -14.8219539404062
              ],
              [
                128.19060307407847,
                -14.829847990764716
              ],
              [
                128.1806746786437,
                -14.832452102104412
              ],
              [
                128.16228277013127,
                -14.832696350204086
              ],
              [
                128.1489363780412,
                -14.834242353554949
              ],
              [
                128.138356986151,
                -14.8387998488995
              ],
              [
                128.11793055128618,
                -14.853773790197794
              ],
              [
                128.13746179519012,
                -14.862562816883088
              ],
              [
                128.13282311440972,
                -14.895196230121936
              ],
              [
                128.11109459109105,
                -14.959893454145227
              ],
              [
                128.10824628291755,
                -14.972832900468337
              ],
              [
                128.09498129904617,
                -14.9972469061773
              ],
              [
                128.09058678503445,
                -15.011407159196303
              ],
              [
                128.09017988408033,
                -15.03118255045735
              ],
              [
                128.09197024781625,
                -15.046644788954787
              ],
              [
                128.09034264421527,
                -15.060804947222074
              ],
              [
                128.073090040493,
                -15.089125260793198
              ],
              [
                128.06853274766019,
                -15.106622001077245
              ],
              [
                128.067067905558,
                -15.125176694151234
              ],
              [
                128.06959069071328,
                -15.141208590382734
              ],
              [
                128.08122806108668,
                -15.162692967487605
              ],
              [
                128.084646029334,
                -15.174574473254532
              ],
              [
                128.07569420668412,
                -15.277764579238628
              ],
              [
                128.0705672527258,
                -15.287692959901376
              ],
              [
                128.06023196861392,
                -15.292168886988179
              ],
              [
                128.0427352208966,
                -15.291924731853689
              ],
              [
                128.07129967594057,
                -15.367933857204834
              ],
              [
                128.07227624010952,
                -15.4044735776394
              ],
              [
                128.05591881917474,
                -15.443454702465488
              ],
              [
                128.02027428826517,
                -15.478448192918451
              ],
              [
                128.01490319350106,
                -15.487481391715937
              ],
              [
                128.0242619167607,
                -15.4965145906482
              ],
              [
                128.04558353228583,
                -15.487562770532596
              ],
              [
                128.06869550822205,
                -15.47096119172983
              ],
              [
                128.08375084847805,
                -15.457126568120616
              ],
              [
                128.10132897268295,
                -15.424574480761402
              ],
              [
                128.11280358028682,
                -15.381768478531834
              ],
              [
                128.1184188179886,
                -15.335137639030693
              ],
              [
                128.11793053389596,
                -15.291924731853689
              ],
              [
                128.10059654881246,
                -15.22991301235328
              ],
              [
                128.11060631729967,
                -15.224867453275786
              ],
              [
                128.111175978348,
                -15.213148703553848
              ],
              [
                128.10914147142665,
                -15.199965098783318
              ],
              [
                128.1110945971284,
                -15.19019947772072
              ],
              [
                128.12517337210357,
                -15.18206145096327
              ],
              [
                128.13453209832167,
                -15.187676698420908
              ],
              [
                128.14332115933348,
                -15.197849213260685
              ],
              [
                128.17448978090982,
                -15.213311461095682
              ],
              [
                128.22445722807097,
                -15.260186461972467
              ],
              [
                128.23462975352814,
                -15.274590750371535
              ],
              [
                128.23812910183776,
                -15.28199635109677
              ],
              [
                128.25562584596415,
                -15.310235278248182
              ],
              [
                128.28028404958582,
                -15.383558849713728
              ],
              [
                128.28305097391186,
                -15.401788001983856
              ],
              [
                128.28931725091167,
                -15.401788001983856
              ],
              [
                128.29664147246035,
                -15.316176042553922
              ],
              [
                128.2917586595127,
                -15.290704031290552
              ],
              [
                128.27865644454087,
                -15.271661057873736
              ],
              [
                128.24146568976232,
                -15.23739999108514
              ],
              [
                128.23047936349488,
                -15.224053646767578
              ],
              [
                128.22022545847474,
                -15.205661725262166
              ],
              [
                128.21631920613157,
                -15.185235279125527
              ],
              [
                128.22437584686728,
                -15.165948174253602
              ],
              [
                128.22584069226693,
                -15.160251567125378
              ],
              [
                128.21827233170208,
                -15.11809661131783
              ],
              [
                128.2121688167098,
                -15.11101653800941
              ],
              [
                128.2052514983243,
                -15.106377864832334
              ],
              [
                128.1998804048413,
                -15.10027434610215
              ],
              [
                128.19581139364522,
                -15.056817313985594
              ],
              [
                128.2158309250513,
                -15.0219052062916
              ],
              [
                128.2687280760726,
                -14.970391620168805
              ],
              [
                128.27165772377637,
                -14.9685196514946
              ],
              [
                128.27947022476437,
                -14.9664851511277
              ],
              [
                128.28305099692702,
                -14.963637090977786
              ],
              [
                128.28394614408492,
                -14.959079593932628
              ],
              [
                128.28223718923024,
                -14.94719825651362
              ],
              [
                128.283051001616,
                -14.94255964406393
              ],
              [
                128.2951766130211,
                -14.924981286295749
              ],
              [
                128.31348719292944,
                -14.904961950068552
              ],
              [
                128.32300865022916,
                -14.91073978586445
              ],
              [
                128.33025151271895,
                -14.936293311364356
              ],
              [
                128.34278405016278,
                -15.021091404925267
              ],
              [
                128.35010826893514,
                -15.037286065631038
              ],
              [
                128.364919466852,
                -15.04615650716005
              ],
              [
                128.35914147207927,
                -15.01409270645074
              ],
              [
                128.35840907229036,
                -14.999118875015789
              ],
              [
                128.36491948489598,
                -14.984063511108083
              ],
              [
                128.39942467499785,
                -15.023858330987116
              ],
              [
                128.4179793626219,
                -15.039727469853759
              ],
              [
                128.4441024098519,
                -15.04615650716005
              ],
              [
                128.4502059252782,
                -15.042657160577265
              ],
              [
                128.45582116013384,
                -15.034112238759654
              ],
              [
                128.4597274100321,
                -15.023695571182163
              ],
              [
                128.46119225398235,
                -15.014825127899597
              ],
              [
                128.4598087900003,
                -15.001641534001566
              ],
              [
                128.45679774586154,
                -14.995049873914356
              ],
              [
                128.45240317879203,
                -14.990492376432611
              ],
              [
                128.44752039690746,
                -14.984063511108083
              ],
              [
                128.42286216915974,
                -14.94011806356034
              ],
              [
                128.41732833200246,
                -14.915785478136005
              ],
              [
                128.40805098468266,
                -14.895277646170271
              ],
              [
                128.4060164867291,
                -14.884454118766499
              ],
              [
                128.4074813358159,
                -14.86882914820038
              ],
              [
                128.41195721282583,
                -14.8656551242925
              ],
              [
                128.41871178940943,
                -14.865899372416106
              ],
              [
                128.4270125771269,
                -14.860528317163137
              ],
              [
                128.43360438692721,
                -14.855238678034175
              ],
              [
                128.43824301402313,
                -14.85328529396828
              ],
              [
                128.43897543560573,
                -14.849867322522355
              ],
              [
                128.43327885647184,
                -14.840101904601097
              ],
              [
                128.42741946102467,
                -14.835056213464007
              ],
              [
                128.41032962230946,
                -14.828301687005656
              ],
              [
                128.4025985163341,
                -14.823012048378663
              ],
              [
                128.38843832121051,
                -14.803399197472562
              ],
              [
                128.39576254805147,
                -14.795993643870908
              ],
              [
                128.44068444984816,
                -14.792250309332173
              ],
              [
                128.4798283444213,
                -14.779473701993073
              ],
              [
                128.49927817780207,
                -14.770114765314498
              ],
              [
                128.51246179933446,
                -14.760918961349574
              ],
              [
                128.53239996057414,
                -14.752862380971349
              ],
              [
                128.55420983495884,
                -14.758721630202043
              ],
              [
                128.59083094093924,
                -14.77800881448131
              ],
              [
                128.67554770191282,
                -14.787774230630186
              ],
              [
                128.7133895147633,
                -14.79753994748398
              ],
              [
                128.74854578174833,
                -14.826430019554572
              ],
              [
                128.76710047410896,
                -14.821709992742369
              ],
              [
                128.79004968529577,
                -14.827081047381096
              ],
              [
                128.81373130146937,
                -14.83562582527306
              ],
              [
                128.834157762517,
                -14.840101904601097
              ],
              [
                128.9197697415266,
                -14.840101904601097
              ],
              [
                128.94027754545874,
                -14.84612398739304
              ],
              [
                128.9734806579613,
                -14.863702040594601
              ],
              [
                128.9918726040789,
                -14.867364260305056
              ],
              [
                129.00977622420976,
                -14.869073095898065
              ],
              [
                129.05103600189483,
                -14.88014087094037
              ],
              [
                129.09205165212433,
                -14.89820742221067
              ],
              [
                129.10230553183092,
                -14.905368729894088
              ],
              [
                129.11158289006195,
                -14.915785478136005
              ],
              [
                129.11548911433604,
                -14.926364758387258
              ],
              [
                129.1170353494241,
                -14.937432535326993
              ],
              [
                129.1202905650996,
                -14.946384396332341
              ],
              [
                129.12867273938153,
                -14.949965200887995
              ],
              [
                129.15503990670118,
                -14.95378995324218
              ],
              [
                129.1731876986471,
                -14.964776315034797
              ],
              [
                129.18392989008498,
                -14.981866178505472
              ],
              [
                129.18734785198166,
                -15.004571221896173
              ],
              [
                129.1838485041638,
                -15.021091404925267
              ],
              [
                129.17774498763873,
                -15.03948332896127
              ],
              [
                129.17554772205744,
                -15.058526300323331
              ],
              [
                129.1839298837094,
                -15.076592704365959
              ],
              [
                129.1980086591758,
                -15.098402597374637
              ],
              [
                129.1992293633878,
                -15.117364193172131
              ],
              [
                129.19190514389265,
                -15.135918877398925
              ],
              [
                129.17172285160495,
                -15.17343515179685
              ],
              [
                129.1525985055621,
                -15.223728131675463
              ],
              [
                129.1720483737828,
                -15.22185638234718
              ],
              [
                129.19996178351852,
                -15.167413010735348
              ],
              [
                129.2214461613263,
                -15.169691672395592
              ],
              [
                129.2127384775853,
                -15.185804949259492
              ],
              [
                129.20818118521439,
                -15.204278248631061
              ],
              [
                129.20826256527656,
                -15.222344654983242
              ],
              [
                129.21412193975294,
                -15.23739999108514
              ],
              [
                129.2436629568753,
                -15.113376559300852
              ],
              [
                129.26303144579222,
                -15.10759856483535
              ],
              [
                129.26335696777687,
                -15.09059010636006
              ],
              [
                129.25562584708106,
                -15.03118255045735
              ],
              [
                129.25180097693595,
                -15.018243096638209
              ],
              [
                129.24333743596662,
                -15.008233330811102
              ],
              [
                129.23902429420662,
                -14.98463312317157
              ],
              [
                129.23568771082276,
                -14.936293311364356
              ],
              [
                129.22299237493547,
                -14.867771040085021
              ],
              [
                129.22144617497412,
                -14.843519875948628
              ],
              [
                129.22877038687975,
                -14.836602517253764
              ],
              [
                129.24439539168768,
                -14.844170903807848
              ],
              [
                129.2589624462793,
                -14.862562816883088
              ],
              [
                129.26303146132128,
                -14.887872090563024
              ],
              [
                129.269297737322,
                -14.887872090563024
              ],
              [
                129.28923588556933,
                -14.861911788988499
              ],
              [
                129.32439214816193,
                -14.862074621069075
              ],
              [
                129.3579207754839,
                -14.87957125905633
              ],
              [
                129.37289474507742,
                -14.904961950068552
              ],
              [
                129.47657309079918,
                -14.93377031484921
              ],
              [
                129.49586021478993,
                -14.953057509107126
              ],
              [
                129.49830161766974,
                -14.957777537767994
              ],
              [
                129.51295006602044,
                -15.007989191115225
              ],
              [
                129.52515709693844,
                -15.016696872652728
              ],
              [
                129.5535587901898,
                -15.03036874906845
              ],
              [
                129.56413821693462,
                -15.03875090863198
              ],
              [
                129.57243899780997,
                -15.05364348693223
              ],
              [
                129.58448326941817,
                -15.088067318341151
              ],
              [
                129.59473717490175,
                -15.103936455450194
              ],
              [
                129.59815514355813,
                -15.117120047531621
              ],
              [
                129.58757571751585,
                -15.153090104872039
              ],
              [
                129.58521569233,
                -15.169691672395592
              ],
              [
                129.62940514468826,
                -15.139336850835228
              ],
              [
                129.64551842456342,
                -15.13494231356572
              ],
              [
                129.66195722753713,
                -15.138360286993105
              ],
              [
                129.66675865959618,
                -15.148125906751474
              ],
              [
                129.6665145205813,
                -15.175957949782243
              ],
              [
                129.6717228525702,
                -15.194268491162006
              ],
              [
                129.67725670561538,
                -15.199151292324803
              ],
              [
                129.69727623937288,
                -15.195082297610623
              ],
              [
                129.71599368648353,
                -15.195407812679788
              ],
              [
                129.72706139332342,
                -15.193617442248952
              ],
              [
                129.73096764307195,
                -15.186293221851953
              ],
              [
                129.72852623933156,
                -15.169691672395592
              ],
              [
                129.72169030071763,
                -15.159356381989284
              ],
              [
                129.65902753957582,
                -15.089939057626221
              ],
              [
                129.65202884230717,
                -15.07691822872046
              ],
              [
                129.62989342497377,
                -15.019463799851536
              ],
              [
                129.61931398029193,
                -14.957696121704316
              ],
              [
                129.61182704387105,
                -14.94255964406393
              ],
              [
                129.61980227911718,
                -14.933363534988956
              ],
              [
                129.6345320779732,
                -14.907891425765596
              ],
              [
                129.63990320737585,
                -14.894708034260558
              ],
              [
                129.6455184247176,
                -14.840590100383443
              ],
              [
                129.64918055738798,
                -14.832696350204086
              ],
              [
                129.66480555167402,
                -14.83603290544307
              ],
              [
                129.6897078549241,
                -14.850518350393763
              ],
              [
                129.70411219148787,
                -14.853773790197794
              ],
              [
                129.73471115049165,
                -14.853773790197794
              ],
              [
                129.7695418742433,
                -14.860528317163137
              ],
              [
                129.78565512520944,
                -14.86150470878741
              ],
              [
                129.80054774185925,
                -14.859958705312266
              ],
              [
                129.8247176605032,
                -14.853773790197794
              ],
              [
                129.84799237893995,
                -14.841892156091923
              ],
              [
                129.85523523663207,
                -14.840101904601097
              ],
              [
                129.86646567674913,
                -14.839043796575556
              ],
              [
                129.86980229670044,
                -14.83603290544307
              ],
              [
                129.87094162537693,
                -14.830661850663267
              ],
              [
                129.87598718747572,
                -14.823012048378663
              ],
              [
                129.919688356942,
                -14.790215810031725
              ],
              [
                129.92725670306967,
                -14.788669506451553
              ],
              [
                129.9353947361363,
                -14.783379868436002
              ],
              [
                129.95362389766328,
                -14.790134394008568
              ],
              [
                129.98243249848147,
                -14.805922193011975
              ],
              [
                129.98015382969191,
                -14.780368677364768
              ],
              [
                129.99333742148553,
                -14.72503012229382
              ],
              [
                129.9824325046207,
                -14.70973082299308
              ],
              [
                129.9748641230396,
                -14.740166890667846
              ],
              [
                129.95525147337398,
                -14.755629023330238
              ],
              [
                129.89307703829112,
                -14.771905316867974
              ],
              [
                129.79859460624164,
                -14.816827133936483
              ],
              [
                129.76270593708708,
                -14.819594077236976
              ],
              [
                129.79566493335673,
                -14.776055731284693
              ],
              [
                129.79688563401132,
                -14.764418347925519
              ],
              [
                129.78858484049448,
                -14.764255515891417
              ],
              [
                129.75538172387473,
                -14.78484475597055
              ],
              [
                129.73698979619897,
                -14.790297226054884
              ],
              [
                129.7241317020814,
                -14.790704005742853
              ],
              [
                129.71159917186898,
                -14.78484475597055
              ],
              [
                129.66993247943148,
                -14.75310632858644
              ],
              [
                129.66504965051644,
                -14.739922642633742
              ],
              [
                129.67335043112394,
                -14.7228327913724
              ],
              [
                129.65211020286046,
                -14.71062579818567
              ],
              [
                129.6272078821377,
                -14.692478141200041
              ],
              [
                129.60678146905425,
                -14.671563542998951
              ],
              [
                129.59009849227186,
                -14.62737388754947
              ],
              [
                129.58806401892585,
                -14.613458063288258
              ],
              [
                129.59473719954605,
                -14.607354568515934
              ],
              [
                129.6086532118867,
                -14.606622125115944
              ],
              [
                129.64551844935966,
                -14.600518630458856
              ],
              [
                129.69271893860372,
                -14.602146048767262
              ],
              [
                129.71762127396354,
                -14.595879722228714
              ],
              [
                129.7285262438646,
                -14.57634860034996
              ],
              [
                129.7374780448996,
                -14.5685359716345
              ],
              [
                129.77767989741747,
                -14.543633800794243
              ],
              [
                129.7893986221172,
                -14.531670761148325
              ],
              [
                129.76807702891557,
                -14.532647452291245
              ],
              [
                129.743174670141,
                -14.539971584447608
              ],
              [
                129.72006267645827,
                -14.55071368526373
              ],
              [
                129.6865340326626,
                -14.573988438394696
              ],
              [
                129.66732830497614,
                -14.57537190909091
              ],
              [
                129.62623134021945,
                -14.566338942101156
              ],
              [
                129.6159773855162,
                -14.565687614327347
              ],
              [
                129.595388211872,
                -14.567315332908128
              ],
              [
                129.58521571521175,
                -14.566338942101156
              ],
              [
                129.5799259987657,
                -14.563572000782276
              ],
              [
                129.5745548717402,
                -14.559014508992059
              ],
              [
                129.566661020954,
                -14.554620149624714
              ],
              [
                129.5538842963962,
                -14.552829599162637
              ],
              [
                129.53532961089937,
                -14.54534263481653
              ],
              [
                129.47535239903488,
                -14.497491079184494
              ],
              [
                129.4707137173709,
                -14.496677220046857
              ],
              [
                129.45964602261884,
                -14.498223522367098
              ],
              [
                129.4548445860366,
                -14.497491079184494
              ],
              [
                129.45329836220523,
                -14.494073111160628
              ],
              [
                129.44906660980845,
                -14.480645487236165
              ],
              [
                129.44743898795667,
                -14.476983271509354
              ],
              [
                129.4431258623264,
                -14.475274437800978
              ],
              [
                129.43043055658487,
                -14.471937885930725
              ],
              [
                129.4270125561935,
                -14.470147335866676
              ],
              [
                129.42367596511681,
                -14.46396242751466
              ],
              [
                129.41993247435568,
                -14.450941583969405
              ],
              [
                129.41675868401458,
                -14.445977614684315
              ],
              [
                129.36736084827433,
                -14.418633574666382
              ],
              [
                129.35808353595405,
                -14.40878675251274
              ],
              [
                129.37289472472378,
                -14.3292782393255
              ],
              [
                129.37671961678475,
                -14.323418996916104
              ],
              [
                129.40308678656496,
                -14.29509857542867
              ],
              [
                129.40935304609232,
                -14.284600429099966
              ],
              [
                129.41089926794018,
                -14.27361408801888
              ],
              [
                129.41114343789937,
                -14.262383799946129
              ],
              [
                129.4133406807582,
                -14.2504207690448
              ],
              [
                129.4209090329216,
                -14.232517081523593
              ],
              [
                129.43034914573857,
                -14.218926634819805
              ],
              [
                129.47380616242768,
                -14.17693435950294
              ],
              [
                129.48560631967655,
                -14.161553666410738
              ],
              [
                129.49317468174644,
                -14.144463841185354
              ],
              [
                129.4958602208689,
                -14.123793220081634
              ],
              [
                129.49586024165507,
                -14.089125378604592
              ],
              [
                129.49333743448136,
                -14.078545821671735
              ],
              [
                129.48324630278398,
                -14.060235362661071
              ],
              [
                129.48218834871048,
                -14.05185313353292
              ],
              [
                129.48861736335977,
                -14.048109505860474
              ],
              [
                129.50025474675533,
                -14.055840708410063
              ],
              [
                129.5148218129215,
                -14.061455999818502
              ],
              [
                129.53003991171113,
                -14.05185313353292
              ],
              [
                129.53337649093893,
                -14.060642141570646
              ],
              [
                129.53532963448887,
                -14.071872724587429
              ],
              [
                129.53882897225748,
                -14.08131275958045
              ],
              [
                129.54712975100205,
                -14.08538175060511
              ],
              [
                129.5597436977841,
                -14.0814755913233
              ],
              [
                129.57113693158826,
                -14.07537210485702
              ],
              [
                129.5799259596654,
                -14.076267078575857
              ],
              [
                129.58521568418232,
                -14.092868706209579
              ],
              [
                129.60466555728482,
                -14.066176017173593
              ],
              [
                129.60084067995822,
                -14.035902533966897
              ],
              [
                129.59424890733146,
                -14.010186538340728
              ],
              [
                129.60572352376974,
                -13.997247125242927
              ],
              [
                129.60914147073828,
                -14.028496995220788
              ],
              [
                129.63257896347653,
                -14.035251507492733
              ],
              [
                129.69044029954483,
                -14.025079031194029
              ],
              [
                129.71753991512006,
                -14.01555758157793
              ],
              [
                129.7356063382283,
                -13.991794666376741
              ],
              [
                129.74586021457054,
                -13.961195524956366
              ],
              [
                129.7491968121064,
                -13.931817322875263
              ],
              [
                129.74488367622646,
                -13.913506870009979
              ],
              [
                129.73503664867806,
                -13.903578343605895
              ],
              [
                129.723643439331,
                -13.894952170379632
              ],
              [
                129.7148543778058,
                -13.88054787647122
              ],
              [
                129.7159936963103,
                -13.867445635472091
              ],
              [
                129.7231551655345,
                -13.851820705849063
              ],
              [
                129.7417098198488,
                -13.825941588735198
              ],
              [
                129.79615317735846,
                -13.785414235092217
              ],
              [
                129.81592856199651,
                -13.761976694770109
              ],
              [
                129.8037215710095,
                -13.74334088582188
              ],
              [
                129.8003035976341,
                -13.749444367784381
              ],
              [
                129.7929793691661,
                -13.758233369930513
              ],
              [
                129.7893986485199,
                -13.763848657628339
              ],
              [
                129.78321374652893,
                -13.757582343855876
              ],
              [
                129.78923589322673,
                -13.74195741790411
              ],
              [
                129.7884220637069,
                -13.725762581811294
              ],
              [
                129.78321375873355,
                -13.691827212733688
              ],
              [
                129.78549238307525,
                -13.675713794115534
              ],
              [
                129.80982504794432,
                -13.615004049471056
              ],
              [
                129.82740321359938,
                -13.582614987023863
              ],
              [
                129.83090254544112,
                -13.568617480961722
              ],
              [
                129.83155360138434,
                -13.53720480992303
              ],
              [
                129.83350668429324,
                -13.522149200458069
              ],
              [
                129.83773845767448,
                -13.510511852146408
              ],
              [
                129.84742270774464,
                -13.503024905843878
              ],
              [
                129.85906010359022,
                -13.499281582946255
              ],
              [
                129.8686629552152,
                -13.493584882452847
              ],
              [
                129.87533615140103,
                -13.46705505885096
              ],
              [
                129.88257896392588,
                -13.450860231558917
              ],
              [
                129.89128663888383,
                -13.437676586202308
              ],
              [
                129.89926189244105,
                -13.434828236277133
              ],
              [
                129.90658614069687,
                -13.446954077503687
              ],
              [
                129.90845786849297,
                -13.465264512864204
              ],
              [
                129.90674890609853,
                -13.500665050193831
              ],
              [
                129.91472414976718,
                -13.511407125215705
              ],
              [
                129.93295333577035,
                -13.519952176269394
              ],
              [
                129.96892335380707,
                -13.530450004361402
              ],
              [
                129.98194418493267,
                -13.523532667766089
              ],
              [
                130.04322349576836,
                -13.504489788872712
              ],
              [
                130.0623478392928,
                -13.493422050913424
              ],
              [
                130.11280359770169,
                -13.449151401816449
              ],
              [
                130.13396241834207,
                -13.461032695644901
              ],
              [
                130.16374757679722,
                -13.43287515930411
              ],
              [
                130.21461023876992,
                -13.360446982578633
              ],
              [
                130.2373153131086,
                -13.335625994842124
              ],
              [
                130.2541610101083,
                -13.323825819040179
              ],
              [
                130.2732039628345,
                -13.318780145898858
              ],
              [
                130.29232832309336,
                -13.327894803712724
              ],
              [
                130.31666098208035,
                -13.343356885650474
              ],
              [
                130.3322859993493,
                -13.346368066597583
              ],
              [
                130.32447349483084,
                -13.318780145898858
              ],
              [
                130.31397545222896,
                -13.308526268693257
              ],
              [
                130.29476970754857,
                -13.297295703210771
              ],
              [
                130.27263429113574,
                -13.288343877364394
              ],
              [
                130.2524520354761,
                -13.284763387406539
              ],
              [
                130.2425236401747,
                -13.278415663655169
              ],
              [
                130.23121178885964,
                -13.263929971449631
              ],
              [
                130.21461021655185,
                -13.236260638975509
              ],
              [
                130.16049237362083,
                -13.171481959915726
              ],
              [
                130.15552819282172,
                -13.16822683312942
              ],
              [
                130.13135824665287,
                -13.167168729160716
              ],
              [
                130.122731959716,
                -13.164646043471079
              ],
              [
                130.11866293653372,
                -13.156182413530784
              ],
              [
                130.11890709964896,
                -13.047051708849416
              ],
              [
                130.12256919776874,
                -13.032403190710259
              ],
              [
                130.12989342806833,
                -13.020196242726731
              ],
              [
                130.1346134663392,
                -12.998630394836866
              ],
              [
                130.13013755534723,
                -12.969007998681779
              ],
              [
                130.12989344338038,
                -12.940525123121294
              ],
              [
                130.1469832644853,
                -12.921563378213671
              ],
              [
                130.1588647625371,
                -12.922051571937283
              ],
              [
                130.16863038408076,
                -12.918552199334023
              ],
              [
                130.17603600466472,
                -12.911309507536018
              ],
              [
                130.1810002018574,
                -12.901055637010241
              ],
              [
                130.1932072331728,
                -12.912774389113068
              ],
              [
                130.19727623199026,
                -12.9263648010539
              ],
              [
                130.2041121718357,
                -12.937432528464752
              ],
              [
                130.2251082540072,
                -12.942071120027904
              ],
              [
                130.24675542267428,
                -12.937758191239258
              ],
              [
                130.28345788934456,
                -12.919040693482398
              ],
              [
                130.3005477208866,
                -12.914727464411644
              ],
              [
                130.31861414382172,
                -12.906019891087846
              ],
              [
                130.33513433114572,
                -12.885430734655394
              ],
              [
                130.3471785654657,
                -12.861423321767434
              ],
              [
                130.351817258727,
                -12.842461879430076
              ],
              [
                130.35092205931127,
                -12.78085694832508
              ],
              [
                130.3606876982679,
                -12.750746367697406
              ],
              [
                130.3554793587877,
                -12.732028874788679
              ],
              [
                130.3474227239795,
                -12.712823188753328
              ],
              [
                130.344981324573,
                -12.69500096867051
              ],
              [
                130.35434003628984,
                -12.672051665120108
              ],
              [
                130.3674422428653,
                -12.672621274342848
              ],
              [
                130.38306724453048,
                -12.68092206701811
              ],
              [
                130.40015711298244,
                -12.68132914534373
              ],
              [
                130.40202884396032,
                -12.674900011664697
              ],
              [
                130.40202884930562,
                -12.663262678984406
              ],
              [
                130.40357506600293,
                -12.652113540019647
              ],
              [
                130.41000409860806,
                -12.647230703292358
              ],
              [
                130.42115317686495,
                -12.6443009411848
              ],
              [
                130.43751060638874,
                -12.630629118725397
              ],
              [
                130.44800866780068,
                -12.626722969615395
              ],
              [
                130.46143639493351,
                -12.630059509532373
              ],
              [
                130.4980574798421,
                -12.648532753026497
              ],
              [
                130.51612388678325,
                -12.654066614633487
              ],
              [
                130.50147546356663,
                -12.632907855928252
              ],
              [
                130.49496504390376,
                -12.61907320234226
              ],
              [
                130.49634849525623,
                -12.605075717674286
              ],
              [
                130.50684656233454,
                -12.596449563575318
              ],
              [
                130.51685630692492,
                -12.603692252352014
              ],
              [
                130.5584416180018,
                -12.68132914534373
              ],
              [
                130.56804445849437,
                -12.686455928850032
              ],
              [
                130.57878665464705,
                -12.68865325054587
              ],
              [
                130.5864363896486,
                -12.694105696765677
              ],
              [
                130.58643638758377,
                -12.709242401485149
              ],
              [
                130.59799237643503,
                -12.703708539492254
              ],
              [
                130.60645594602803,
                -12.706231523907372
              ],
              [
                130.61459392987194,
                -12.711846501159703
              ],
              [
                130.62598718002832,
                -12.714939094854712
              ],
              [
                130.6267195989837,
                -12.712823188753328
              ],
              [
                130.63005617176012,
                -12.708428545231934
              ],
              [
                130.63502038171336,
                -12.703871370827219
              ],
              [
                130.6411238988162,
                -12.701836880423228
              ],
              [
                130.64698326389535,
                -12.703057514579626
              ],
              [
                130.6574813246502,
                -12.70810318298697
              ],
              [
                130.66431724757987,
                -12.709242401485149
              ],
              [
                130.6755477231879,
                -12.708672792235856
              ],
              [
                130.68572026389714,
                -12.706150108239648
              ],
              [
                130.69288172174058,
                -12.700616246268737
              ],
              [
                130.6955672490776,
                -12.691338765817948
              ],
              [
                130.61304770230421,
                -12.66765702182672
              ],
              [
                130.6140242732911,
                -12.669854343470385
              ],
              [
                130.61019941394724,
                -12.672784105671363
              ],
              [
                130.60425866708752,
                -12.674981427329175
              ],
              [
                130.59880620564886,
                -12.674493233769185
              ],
              [
                130.596853057283,
                -12.672051665120108
              ],
              [
                130.59205161087223,
                -12.662855600668037
              ],
              [
                130.5891219249854,
                -12.66082111036973
              ],
              [
                130.58765709032477,
                -12.65683354545127
              ],
              [
                130.5747176467412,
                -12.63974376714833
              ],
              [
                130.57154379793278,
                -12.636651173746671
              ],
              [
                130.56739344638876,
                -12.631768637539421
              ],
              [
                130.5603947073451,
                -12.6283503815289
              ],
              [
                130.5590926590166,
                -12.624769895067404
              ],
              [
                130.57154383504607,
                -12.619317449318856
              ],
              [
                130.5798446009063,
                -12.61907320234226
              ],
              [
                130.5879012549364,
                -12.62135193951293
              ],
              [
                130.5964461772759,
                -12.622735404864844
              ],
              [
                130.605642142051,
                -12.619317449318856
              ],
              [
                130.616058789687,
                -12.610039969807437
              ],
              [
                130.61752364018213,
                -12.603936499324053
              ],
              [
                130.61500084442108,
                -12.597588781915308
              ],
              [
                130.61304771524874,
                -12.588555549614446
              ],
              [
                130.60767663664816,
                -12.58464940070304
              ],
              [
                130.5837508297288,
                -12.585625787715799
              ],
              [
                130.57837975112724,
                -12.581719638818043
              ],
              [
                130.57943768323906,
                -12.56845459523427
              ],
              [
                130.60417728381063,
                -12.504571248969107
              ],
              [
                130.60450279734425,
                -12.487562739171903
              ],
              [
                130.59034264850453,
                -12.462497686015546
              ],
              [
                130.59253990921138,
                -12.452406502389183
              ],
              [
                130.59961998467077,
                -12.444431224296194
              ],
              [
                130.62037194393523,
                -12.436944289909638
              ],
              [
                130.61524498326892,
                -12.427504131263508
              ],
              [
                130.59880618910944,
                -12.413832312204855
              ],
              [
                130.59457440542042,
                -12.411553575572132
              ],
              [
                130.5783797611007,
                -12.406996402749831
              ],
              [
                130.5783797626732,
                -12.400811518026844
              ],
              [
                130.60580489420423,
                -12.386000331067196
              ],
              [
                130.6411239037904,
                -12.383233401103965
              ],
              [
                130.67432701644944,
                -12.392347896757137
              ],
              [
                130.69556725711172,
                -12.413832312204855
              ],
              [
                130.71257570983772,
                -12.410902550881888
              ],
              [
                130.73926843218095,
                -12.41562270521633
              ],
              [
                130.7661238888319,
                -12.424737201179543
              ],
              [
                130.78386479008782,
                -12.434991215787434
              ],
              [
                130.7736922621819,
                -12.454278311118154
              ],
              [
                130.77328534263708,
                -12.469170764589673
              ],
              [
                130.78386478365124,
                -12.503187783809055
              ],
              [
                130.78443442002083,
                -12.564873808603334
              ],
              [
                130.7900496701808,
                -12.585137594209279
              ],
              [
                130.7959090578885,
                -12.571547188381688
              ],
              [
                130.7972111269307,
                -12.558200729304092
              ],
              [
                130.8003035979758,
                -12.54615662043589
              ],
              [
                130.8110457532702,
                -12.537367335208014
              ],
              [
                130.8430282117812,
                -12.559340248019202
              ],
              [
                130.8774520301401,
                -12.617120127812488
              ],
              [
                130.89991296486565,
                -12.639825182809249
              ],
              [
                130.89828534921776,
                -12.623793207581766
              ],
              [
                130.89673913537237,
                -12.618422177498486
              ],
              [
                130.8937280763789,
                -12.613051147450319
              ],
              [
                130.9091903125615,
                -12.597833028885555
              ],
              [
                130.9305119235091,
                -12.603285474492212
              ],
              [
                130.9685978598318,
                -12.626722969615395
              ],
              [
                130.95777427254708,
                -12.59880941591371
              ],
              [
                130.93376710221816,
                -12.580742951383039
              ],
              [
                130.90650473300127,
                -12.564873808603334
              ],
              [
                130.88624106247514,
                -12.544203245648575
              ],
              [
                130.87623132576897,
                -12.524672201858468
              ],
              [
                130.87378991784905,
                -12.513604480386538
              ],
              [
                130.88086999137747,
                -12.509047156842117
              ],
              [
                130.8999129642076,
                -12.50945408487047
              ],
              [
                130.91993248344258,
                -12.514092673852437
              ],
              [
                130.95085698036206,
                -12.530938503073108
              ],
              [
                130.9685978362512,
                -12.537367335208014
              ],
              [
                130.9624129521696,
                -12.519952046957949
              ],
              [
                130.95248456136025,
                -12.506768419972035
              ],
              [
                130.93091880799614,
                -12.486097858392002
              ],
              [
                130.92359458853787,
                -12.483330928131299
              ],
              [
                130.90381921227274,
                -12.482517222311959
              ],
              [
                130.89991296410886,
                -12.479099267323992
              ],
              [
                130.89779707443907,
                -12.471449501364122
              ],
              [
                130.89332116588824,
                -12.463555638749487
              ],
              [
                130.88282311069963,
                -12.451348549668092
              ],
              [
                130.8669539786969,
                -12.444594055581236
              ],
              [
                130.8559676407758,
                -12.453057527108369
              ],
              [
                130.84359785103928,
                -12.45964934018307
              ],
              [
                130.82471764369006,
                -12.447930594797068
              ],
              [
                130.82195070669934,
                -12.43914146074869
              ],
              [
                130.82667076970222,
                -12.430352476996916
              ],
              [
                130.83041426540285,
                -12.41871514762112
              ],
              [
                130.82471765268966,
                -12.400811518026844
              ],
              [
                130.8587345649472,
                -12.393324433773685
              ],
              [
                130.84766685488083,
                -12.379489783931765
              ],
              [
                130.85547936441665,
                -12.368259383141798
              ],
              [
                130.88624108851457,
                -12.35247165970183
              ],
              [
                130.8935653080012,
                -12.344903310399282
              ],
              [
                130.89519290965814,
                -12.338637010436761
              ],
              [
                130.89763432116658,
                -12.334242519008372
              ],
              [
                130.90723717257217,
                -12.331963782561724
              ],
              [
                130.91651452407794,
                -12.332777638465409
              ],
              [
                130.92139733263636,
                -12.336846617567048
              ],
              [
                130.92579186067013,
                -12.341973549284273
              ],
              [
                130.93392988233458,
                -12.346123944057503
              ],
              [
                131.0251570899353,
                -12.36052820244748
              ],
              [
                131.05128014745122,
                -12.373467730658433
              ],
              [
                131.05176842681658,
                -12.35377370900414
              ],
              [
                131.0461531835691,
                -12.34050866873
              ],
              [
                131.0301212955451,
                -12.318291964843267
              ],
              [
                131.0263778048276,
                -12.304131803737208
              ],
              [
                131.03012129802875,
                -12.253106436063492
              ],
              [
                131.02475020523488,
                -12.23414485691488
              ],
              [
                131.00147544830745,
                -12.206231314827432
              ],
              [
                130.99610437196407,
                -12.191338865243786
              ],
              [
                131.0001733820117,
                -12.171319334719888
              ],
              [
                131.01091556339534,
                -12.1560198074935
              ],
              [
                131.026133668691,
                -12.147149410521502
              ],
              [
                131.0437931614614,
                -12.146254139138076
              ],
              [
                131.0529077546253,
                -12.150567364396567
              ],
              [
                131.0714624285477,
                -12.164483276644555
              ],
              [
                131.0778914745063,
                -12.167413037273779
              ],
              [
                131.08521568474444,
                -12.164157764376569
              ],
              [
                131.0962020145839,
                -12.14934658074672
              ],
              [
                131.1059676404598,
                -12.146254139138076
              ],
              [
                131.11638430722624,
                -12.154880439457626
              ],
              [
                131.12671959744037,
                -12.170830991208422
              ],
              [
                131.13786868536909,
                -12.182549733408221
              ],
              [
                131.16277102970926,
                -12.173923432882457
              ],
              [
                131.18816165052283,
                -12.200778871490991
              ],
              [
                131.2055770178118,
                -12.208428635379494
              ],
              [
                131.21648196303053,
                -12.214939031224452
              ],
              [
                131.22193444595968,
                -12.228204069904203
              ],
              [
                131.23226973072295,
                -12.2385393479215
              ],
              [
                131.25733482324452,
                -12.236260611683752
              ],
              [
                131.23902428068544,
                -12.212172101719677
              ],
              [
                131.236175979934,
                -12.201592727293955
              ],
              [
                131.2391056560416,
                -12.193454619930945
              ],
              [
                131.25391687149664,
                -12.1771787058073
              ],
              [
                131.25733483244085,
                -12.170830991208422
              ],
              [
                131.2579858685784,
                -12.14934658074672
              ],
              [
                131.26010176025696,
                -12.134942325181878
              ],
              [
                131.27100670069197,
                -12.098565316756833
              ],
              [
                131.2729598417164,
                -12.067071293452003
              ],
              [
                131.2771102198853,
                -12.057549722434285
              ],
              [
                131.28736413315534,
                -12.047295861614343
              ],
              [
                131.2962345771097,
                -12.043877908025793
              ],
              [
                131.30258221805363,
                -12.04810956709994
              ],
              [
                131.30713952804194,
                -12.071547199444986
              ],
              [
                131.31617272142728,
                -12.084161061796856
              ],
              [
                131.3182072168592,
                -12.095391459663118
              ],
              [
                131.31820723497273,
                -12.140232087182461
              ],
              [
                131.3278914717027,
                -12.18531666283997
              ],
              [
                131.34685307089862,
                -12.21965918465128
              ],
              [
                131.37378990986568,
                -12.24675872103039
              ],
              [
                131.4069116467816,
                -12.270440303836706
              ],
              [
                131.42628013846374,
                -12.281182510193188
              ],
              [
                131.4477645133709,
                -12.289808811566836
              ],
              [
                131.47038821091027,
                -12.295668183291353
              ],
              [
                131.49293053157078,
                -12.297784088396305
              ],
              [
                131.51465905612355,
                -12.295179989937473
              ],
              [
                131.55689538012044,
                -12.28508880804464
              ],
              [
                131.57886803961497,
                -12.284112271133749
              ],
              [
                131.59083092891936,
                -12.287204713128029
              ],
              [
                131.6128035722654,
                -12.296644720213108
              ],
              [
                131.62419680088846,
                -12.29387779049721
              ],
              [
                131.70687909281438,
                -12.282159047101356
              ],
              [
                131.78435305275798,
                -12.270440303836706
              ],
              [
                131.82007897452556,
                -12.257500927147378
              ],
              [
                131.83969160186518,
                -12.24675872103039
              ],
              [
                131.86426843336517,
                -12.225844068276592
              ],
              [
                131.87435957745086,
                -12.220635721503493
              ],
              [
                131.88550865863672,
                -12.217054936169612
              ],
              [
                131.89698326138296,
                -12.21591556807248
              ],
              [
                131.90463300798538,
                -12.2198218656866
              ],
              [
                131.90756269735596,
                -12.229180606764013
              ],
              [
                131.90967857366326,
                -12.240411006034655
              ],
              [
                131.91407310598362,
                -12.250095259582086
              ],
              [
                131.9338484986561,
                -12.263929907658543
              ],
              [
                131.977061400307,
                -12.277927387172582
              ],
              [
                132.00196373770663,
                -12.292657156901758
              ],
              [
                132.0251571034082,
                -12.29656345479625
              ],
              [
                132.0456649029727,
                -12.307386926840012
              ],
              [
                132.05787193640725,
                -12.306735902218621
              ],
              [
                132.07846113055547,
                -12.297784088396305
              ],
              [
                132.11557051870236,
                -12.275567385435611
              ],
              [
                132.15088951014855,
                -12.246270377485809
              ],
              [
                132.16651451989802,
                -12.225030212455831
              ],
              [
                132.17123456163876,
                -12.222100451676752
              ],
              [
                132.21631920580265,
                -12.208428635379494
              ],
              [
                132.22217858461227,
                -12.19882579782231
              ],
              [
                132.22999107393116,
                -12.170342647697135
              ],
              [
                132.236175983697,
                -12.16057712943486
              ],
              [
                132.25131269734896,
                -12.15634531975921
              ],
              [
                132.2622176449898,
                -12.164971620153349
              ],
              [
                132.26880944147427,
                -12.180840756422153
              ],
              [
                132.2708439508959,
                -12.198174773266834
              ],
              [
                132.27833092999964,
                -12.228204069904203
              ],
              [
                132.2967228469711,
                -12.226657773884616
              ],
              [
                132.32113691788973,
                -12.211602492780145
              ],
              [
                132.3460392619588,
                -12.201592727293955
              ],
              [
                132.36133873853532,
                -12.202243751851404
              ],
              [
                132.37183677874424,
                -12.206963755010966
              ],
              [
                132.3798934223133,
                -12.21599698369653
              ],
              [
                132.41187585527123,
                -12.273125968075572
              ],
              [
                132.41684003738598,
                -12.294691646370525
              ],
              [
                132.41960697489094,
                -12.299004872211135
              ],
              [
                132.42164146809088,
                -12.303643460166011
              ],
              [
                132.4211532005652,
                -12.311456056053094
              ],
              [
                132.41700279924595,
                -12.317152596637271
              ],
              [
                132.4040633521685,
                -12.324151336730436
              ],
              [
                132.3994246713219,
                -12.332289294880447
              ],
              [
                132.39063560806827,
                -12.341241109006875
              ],
              [
                132.3875431633161,
                -12.346123944057503
              ],
              [
                132.38648522763958,
                -12.35418063696481
              ],
              [
                132.38754316441637,
                -12.380303639874635
              ],
              [
                132.40528404626124,
                -12.358168200518797
              ],
              [
                132.43197674895228,
                -12.331149926658687
              ],
              [
                132.44939213115555,
                -12.300388337075038
              ],
              [
                132.42286217793185,
                -12.231622024024018
              ],
              [
                132.42416425311944,
                -12.189711153653304
              ],
              [
                132.43962649418813,
                -12.154880439457626
              ],
              [
                132.46615645404242,
                -12.140232087182461
              ],
              [
                132.48894290877539,
                -12.135674765320044
              ],
              [
                132.5446883406307,
                -12.098565316756833
              ],
              [
                132.5639754657131,
                -12.091566728294321
              ],
              [
                132.5773218212268,
                -12.094008145264795
              ],
              [
                132.60670007206792,
                -12.112237281974442
              ],
              [
                132.64096114044452,
                -12.126397440625457
              ],
              [
                132.67904708115012,
                -12.136814133337344
              ],
              [
                132.71859786005774,
                -12.140232087182461
              ],
              [
                132.75757896331845,
                -12.133396029288713
              ],
              [
                132.74708092312255,
                -12.12867602643007
              ],
              [
                132.7270613933322,
                -12.128350514172006
              ],
              [
                132.71599368152573,
                -12.126560121647547
              ],
              [
                132.70622805226932,
                -12.122002799837341
              ],
              [
                132.6971134830721,
                -12.112237281974442
              ],
              [
                132.6887313238594,
                -12.106052398957035
              ],
              [
                132.64893639213435,
                -12.08310310944368
              ],
              [
                132.63453209107172,
                -12.067152558852476
              ],
              [
                132.62720788517166,
                -12.043877908025793
              ],
              [
                132.6269637331334,
                -12.004327045353566
              ],
              [
                132.65105227361985,
                -11.865817919620172
              ],
              [
                132.65219159658562,
                -11.848565322722564
              ],
              [
                132.64926192390575,
                -11.833265949353665
              ],
              [
                132.64087975457426,
                -11.8186174502851
              ],
              [
                132.5998641334604,
                -11.792087531383464
              ],
              [
                132.59302819257945,
                -11.784437769830925
              ],
              [
                132.60059655381036,
                -11.766859661590553
              ],
              [
                132.64079837027882,
                -11.726332269502947
              ],
              [
                132.6544702475777,
                -11.708754161813397
              ],
              [
                132.66675866201086,
                -11.674248971223722
              ],
              [
                132.67628014643324,
                -11.664239209437993
              ],
              [
                132.6955672503483,
                -11.660332913320616
              ],
              [
                132.69556725463187,
                -11.653497007792447
              ],
              [
                132.6496688154714,
                -11.635511972981572
              ],
              [
                132.6125594400992,
                -11.62997811614638
              ],
              [
                132.59498131338313,
                -11.62200284307195
              ],
              [
                132.57886803645223,
                -11.611016545072685
              ],
              [
                132.56519615954107,
                -11.59889087949594
              ],
              [
                132.55209395030408,
                -11.583428676916178
              ],
              [
                132.55128013628723,
                -11.575616084966939
              ],
              [
                132.55591882403996,
                -11.568291986580318
              ],
              [
                132.55892987852428,
                -11.553887585998952
              ],
              [
                132.55128013683938,
                -11.544528849018652
              ],
              [
                132.53589929009442,
                -11.538181287145417
              ],
              [
                132.5251571061871,
                -11.528578453668997
              ],
              [
                132.53101647884847,
                -11.509535467780184
              ],
              [
                132.51156659957803,
                -11.506605708325807
              ],
              [
                132.49537193691938,
                -11.47616949743462
              ],
              [
                132.4349064368844,
                -11.446709823242092
              ],
              [
                132.41553795444173,
                -11.44060635812578
              ],
              [
                132.3698836525547,
                -11.434991086109285
              ],
              [
                132.34693444172368,
                -11.438246357625703
              ],
              [
                132.3112899176049,
                -11.46152115099702
              ],
              [
                132.2888289717025,
                -11.461032807691222
              ],
              [
                132.2649845772673,
                -11.456312806663076
              ],
              [
                132.24366295854014,
                -11.454847926961536
              ],
              [
                132.23275801528158,
                -11.45769627077885
              ],
              [
                132.22632897744472,
                -11.462172175262722
              ],
              [
                132.219899936037,
                -11.467950128286628
              ],
              [
                132.20948326478384,
                -11.474786033310602
              ],
              [
                132.20053144816552,
                -11.485609649772197
              ],
              [
                132.1958113940391,
                -11.489027602302256
              ],
              [
                132.1888126914431,
                -11.488946186715014
              ],
              [
                132.18344161091863,
                -11.485040041088649
              ],
              [
                132.17823327316137,
                -11.482191697246055
              ],
              [
                132.17123457316507,
                -11.485609649772197
              ],
              [
                132.14242597474953,
                -11.509372636604526
              ],
              [
                132.12452232565727,
                -11.518975470013428
              ],
              [
                132.10645591897114,
                -11.523125862450948
              ],
              [
                132.08472740710033,
                -11.517998933596072
              ],
              [
                132.07007897073177,
                -11.506280196188095
              ],
              [
                132.05909263517714,
                -11.494398627653723
              ],
              [
                132.04810631603902,
                -11.489027602302256
              ],
              [
                132.04281659942853,
                -11.484144770056725
              ],
              [
                132.037119984916,
                -11.473077057053175
              ],
              [
                132.03256269785544,
                -11.460381783425774
              ],
              [
                132.03077232320868,
                -11.450860215578865
              ],
              [
                132.0356551486241,
                -11.446954070000526
              ],
              [
                132.04590905448111,
                -11.445570605889333
              ],
              [
                132.05551191932335,
                -11.442803677668728
              ],
              [
                132.05795331584872,
                -11.434340061849053
              ],
              [
                132.04070072233154,
                -11.418633763628232
              ],
              [
                132.0139266323551,
                -11.423435180188445
              ],
              [
                131.99048912680092,
                -11.425062740834127
              ],
              [
                131.98218835479315,
                -11.399672193993904
              ],
              [
                131.97608483979283,
                -11.399672193993904
              ],
              [
                131.9660750616,
                -11.406019755580546
              ],
              [
                131.9552514913093,
                -11.403903851646037
              ],
              [
                131.94776452535203,
                -11.394463849753913
              ],
              [
                131.94809004104545,
                -11.379164329201831
              ],
              [
                131.96949302567577,
                -11.373793153820596
              ],
              [
                131.97950280610107,
                -11.366469055914584
              ],
              [
                131.9760848373462,
                -11.351250951053137
              ],
              [
                131.96558678778518,
                -11.344984654924396
              ],
              [
                131.93962650335513,
                -11.35263441512918
              ],
              [
                131.92774499334425,
                -11.351250951053137
              ],
              [
                131.92261803198426,
                -11.34107835924315
              ],
              [
                131.92579185940852,
                -11.330010646675744
              ],
              [
                131.92554773024352,
                -11.320896157072216
              ],
              [
                131.91130619296342,
                -11.31707127699478
              ],
              [
                131.89616946719266,
                -11.314873957521867
              ],
              [
                131.87094160500658,
                -11.305596636780278
              ],
              [
                131.8562117812479,
                -11.303399317312442
              ],
              [
                131.84693444400605,
                -11.305596636780278
              ],
              [
                131.82439212319258,
                -11.314873957521867
              ],
              [
                131.81568444795838,
                -11.31707127699478
              ],
              [
                131.76758874241295,
                -11.310804980912359
              ],
              [
                131.76587975152094,
                -11.307224197379345
              ],
              [
                131.77426190998105,
                -11.299574437248374
              ],
              [
                131.78882896332502,
                -11.292250189247559
              ],
              [
                131.80486087977536,
                -11.290459947700368
              ],
              [
                131.78972415389987,
                -11.263360275254302
              ],
              [
                131.80054772089971,
                -11.263360275254302
              ],
              [
                131.82203208960294,
                -11.27361413227735
              ],
              [
                131.83887779399123,
                -11.277439012323198
              ],
              [
                131.84693443989934,
                -11.263360275254302
              ],
              [
                131.83814538028844,
                -11.244398706258082
              ],
              [
                131.82488040259645,
                -11.223077061818882
              ],
              [
                131.81910241381206,
                -11.201592736489307
              ],
              [
                131.82683352554113,
                -11.204034077348188
              ],
              [
                131.8484806684671,
                -11.207289348707729
              ],
              [
                131.8562117881159,
                -11.211602496888453
              ],
              [
                131.86850019185243,
                -11.220798401905222
              ],
              [
                131.87476646981375,
                -11.215996985546937
              ],
              [
                131.87680097774518,
                -11.206719664953726
              ],
              [
                131.87647546081377,
                -11.201592736489307
              ],
              [
                131.86988365847117,
                -11.19475675676816
              ],
              [
                131.87435956781775,
                -11.181247628504625
              ],
              [
                131.882497591744,
                -11.171970307946822
              ],
              [
                131.88672935857156,
                -11.17742274850875
              ],
              [
                131.89014733660244,
                -11.184502899855998
              ],
              [
                131.90503990540037,
                -11.199883685228546
              ],
              [
                131.93604576707082,
                -11.246758706655122
              ],
              [
                131.94027753660063,
                -11.25139736697585
              ],
              [
                131.94695071856614,
                -11.249932562451031
              ],
              [
                131.9624129549276,
                -11.242608314511944
              ],
              [
                131.9832462910799,
                -11.226250917604078
              ],
              [
                131.9825952444236,
                -11.209405177453492
              ],
              [
                131.97339928876596,
                -11.190362268120618
              ],
              [
                131.96859784765974,
                -11.167575744202656
              ],
              [
                131.98666426221519,
                -11.176527627749602
              ],
              [
                131.98975670377177,
                -11.168633696124358
              ],
              [
                131.9821883455478,
                -11.147067955333693
              ],
              [
                131.9816186898972,
                -11.130059534363719
              ],
              [
                131.98560631817458,
                -11.129164338501267
              ],
              [
                131.99610436765448,
                -11.135430634432879
              ],
              [
                132.0143335254493,
                -11.139580951421534
              ],
              [
                132.02222740854737,
                -11.147067955333693
              ],
              [
                132.03174889383544,
                -11.163506767680026
              ],
              [
                132.04460696813092,
                -11.179945580049681
              ],
              [
                132.07781008872877,
                -11.192478096862285
              ],
              [
                132.07390383771096,
                -11.218031473819522
              ],
              [
                132.08594810974742,
                -11.228936430110576
              ],
              [
                132.0962020205703,
                -11.224704697502398
              ],
              [
                132.1062117860238,
                -11.213636985159908
              ],
              [
                132.11451256452332,
                -11.208754153223959
              ],
              [
                132.12012780081298,
                -11.222100525472936
              ],
              [
                132.11833743435858,
                -11.228448161937187
              ],
              [
                132.10865318732206,
                -11.245863510781666
              ],
              [
                132.10645592608438,
                -11.252862246607622
              ],
              [
                132.10759523891213,
                -11.261488467920296
              ],
              [
                132.11215253609618,
                -11.276787988087113
              ],
              [
                132.1132918718934,
                -11.287041995347211
              ],
              [
                132.10710697397377,
                -11.31707127699478
              ],
              [
                132.10726973584158,
                -11.331963869617805
              ],
              [
                132.11670983888138,
                -11.338148750144393
              ],
              [
                132.12191816071513,
                -11.340020407292847
              ],
              [
                132.1247664814343,
                -11.343031582189957
              ],
              [
                132.12777754717706,
                -11.343682606434667
              ],
              [
                132.1337996818823,
                -11.338148750144393
              ],
              [
                132.1347762300184,
                -11.331312695161527
              ],
              [
                132.13168379049725,
                -11.323174741918145
              ],
              [
                132.1313582635475,
                -11.313734589994105
              ],
              [
                132.14063560923987,
                -11.303399317312442
              ],
              [
                132.15300540903243,
                -11.326348597758148
              ],
              [
                132.1510522843818,
                -11.355726855405909
              ],
              [
                132.15251712434724,
                -11.384698185546581
              ],
              [
                132.1746525390132,
                -11.40642668329321
              ],
              [
                132.20386803987367,
                -11.410332979038563
              ],
              [
                132.20313561921157,
                -11.391696921573498
              ],
              [
                132.19166101011078,
                -11.366469055914584
              ],
              [
                132.18832442035475,
                -11.351250951053137
              ],
              [
                132.20362390034782,
                -11.349541974854702
              ],
              [
                132.21631921606797,
                -11.358575199145553
              ],
              [
                132.22689862975426,
                -11.36386480870916
              ],
              [
                132.23617598235668,
                -11.351250951053137
              ],
              [
                132.23560631849773,
                -11.339450798632493
              ],
              [
                132.22828209778672,
                -11.32870859819034
              ],
              [
                132.20948327342776,
                -11.310804980912359
              ],
              [
                132.20337974938772,
                -11.307875221619094
              ],
              [
                132.19792728880367,
                -11.309502932432146
              ],
              [
                132.1928817102928,
                -11.309747028968848
              ],
              [
                132.18832441123843,
                -11.303399317312442
              ],
              [
                132.18873131096524,
                -11.299574437248374
              ],
              [
                132.19410240341384,
                -11.290215700951322
              ],
              [
                132.19581138600603,
                -11.283623892782918
              ],
              [
                132.19629967629155,
                -11.268243107228773
              ],
              [
                132.1948348365907,
                -11.256036102406519
              ],
              [
                132.19027754241063,
                -11.24407319414177
              ],
              [
                132.18148847374502,
                -11.228936430110576
              ],
              [
                132.19076582055,
                -11.216892181416666
              ],
              [
                132.18344160555006,
                -11.196058880331762
              ],
              [
                132.16928144971263,
                -11.176364871692794
              ],
              [
                132.15796959265356,
                -11.167575744202656
              ],
              [
                132.14747155178637,
                -11.157321887317199
              ],
              [
                132.14812259506706,
                -11.137302366633365
              ],
              [
                132.1613061829975,
                -11.123711822852764
              ],
              [
                132.18832441460722,
                -11.132745046844757
              ],
              [
                132.19890384116184,
                -11.14690519927728
              ],
              [
                132.20671634628437,
                -11.164971647296266
              ],
              [
                132.21648196541506,
                -11.180759360334
              ],
              [
                132.2331649142566,
                -11.187432583987855
              ],
              [
                132.24097740748292,
                -11.196465732921304
              ],
              [
                132.25521894652576,
                -11.240411070174419
              ],
              [
                132.2641707681095,
                -11.256280198940894
              ],
              [
                132.2851668586746,
                -11.268487203763618
              ],
              [
                132.28785241184835,
                -11.255466418648663
              ],
              [
                132.27767988691045,
                -11.21868257315643
              ],
              [
                132.27230878988618,
                -11.17750416409046
              ],
              [
                132.27751712727684,
                -11.162204719227232
              ],
              [
                132.2981876925904,
                -11.153252835691458
              ],
              [
                132.31031334865474,
                -11.154554959249946
              ],
              [
                132.3147078770941,
                -11.159844643746938
              ],
              [
                132.3195906919415,
                -11.161797791532441
              ],
              [
                132.33236738058952,
                -11.153252835691458
              ],
              [
                132.33204185945024,
                -11.147718979559295
              ],
              [
                132.33692467460688,
                -11.132745046844757
              ],
              [
                132.34302818897203,
                -11.122002846709925
              ],
              [
                132.34603926068914,
                -11.129327094557464
              ],
              [
                132.3499455102546,
                -11.146254175051729
              ],
              [
                132.38347415329605,
                -11.214450765447317
              ],
              [
                132.3844507182994,
                -11.21917084132918
              ],
              [
                132.38347415146802,
                -11.223402573934228
              ],
              [
                132.3807072237401,
                -11.228936430110576
              ],
              [
                132.3868921244262,
                -11.24578217030588
              ],
              [
                132.37794030312918,
                -11.283135699711943
              ],
              [
                132.3909611408055,
                -11.290459947700368
              ],
              [
                132.40398197012976,
                -11.283135699711943
              ],
              [
                132.41146895052916,
                -11.265883106823717
              ],
              [
                132.4211531877391,
                -11.228936430110576
              ],
              [
                132.44507896742863,
                -11.212497617651064
              ],
              [
                132.4749455070049,
                -11.234144774175252
              ],
              [
                132.50196373507018,
                -11.273695547860115
              ],
              [
                132.51734460143803,
                -11.310804980912359
              ],
              [
                132.51303144083175,
                -11.322035374388424
              ],
              [
                132.51238040026155,
                -11.330336158797158
              ],
              [
                132.51734460390222,
                -11.338148750144393
              ],
              [
                132.52312259109823,
                -11.339043870926607
              ],
              [
                132.53003991348842,
                -11.336358358367251
              ],
              [
                132.53581789700186,
                -11.332696159231359
              ],
              [
                132.53785240866264,
                -11.330743086502252
              ],
              [
                132.54322350281626,
                -11.33489347871254
              ],
              [
                132.55518638559465,
                -11.348239776150379
              ],
              [
                132.56080162216304,
                -11.356215048484223
              ],
              [
                132.56918379430874,
                -11.375420864657732
              ],
              [
                132.61353600300995,
                -11.40642668329321
              ],
              [
                132.633148638026,
                -11.437269821234425
              ],
              [
                132.65007572097923,
                -11.47665784074281
              ],
              [
                132.6741642600638,
                -11.508396100190541
              ],
              [
                132.71599368409042,
                -11.516289957313225
              ],
              [
                132.73698977194582,
                -11.508233269014935
              ],
              [
                132.75953209028538,
                -11.492364139248927
              ],
              [
                132.7775171324309,
                -11.472263351824857
              ],
              [
                132.78809654185062,
                -11.443617382889487
              ],
              [
                132.79574629878292,
                -11.440118165036397
              ],
              [
                132.8050236266848,
                -11.437758014323402
              ],
              [
                132.81275474881932,
                -11.434340061849053
              ],
              [
                132.82634524563247,
                -11.422295812630328
              ],
              [
                132.82960046021995,
                -11.420668251985942
              ],
              [
                132.83399499106451,
                -11.417901323785616
              ],
              [
                132.83350671318095,
                -11.41139093100753
              ],
              [
                132.83179772327932,
                -11.404392194943604
              ],
              [
                132.83326257384343,
                -11.399672193993904
              ],
              [
                132.85596764956276,
                -11.400323218247776
              ],
              [
                132.8781844494952,
                -11.413506834946427
              ],
              [
                132.89486738363536,
                -11.418877860171397
              ],
              [
                132.90162193266823,
                -11.395928579216585
              ],
              [
                132.89893639131537,
                -11.371840081072788
              ],
              [
                132.89193770055562,
                -11.358493783561363
              ],
              [
                132.86744226092046,
                -11.338148750144393
              ],
              [
                132.87289472097083,
                -11.32789474278052
              ],
              [
                132.87916100805458,
                -11.326348597758148
              ],
              [
                132.88721763469565,
                -11.328871279144368
              ],
              [
                132.91098066480203,
                -11.331801038450404
              ],
              [
                132.915293825044,
                -11.334730797758311
              ],
              [
                132.91716555440988,
                -11.339287967464838
              ],
              [
                132.92204837580545,
                -11.344984654924396
              ],
              [
                132.92872155181718,
                -11.348077095195627
              ],
              [
                132.93555749211012,
                -11.350192999100367
              ],
              [
                132.94092858297637,
                -11.353936463621565
              ],
              [
                132.94312584043604,
                -11.361748904797615
              ],
              [
                132.9557397815069,
                -11.387465113721921
              ],
              [
                132.95980878493975,
                -11.392185114656227
              ],
              [
                132.98552492811402,
                -11.404229363773316
              ],
              [
                133.01107832601116,
                -11.43279391678475
              ],
              [
                133.0323999348718,
                -11.466892176299671
              ],
              [
                133.04493248606227,
                -11.495212483101342
              ],
              [
                133.05176842306219,
                -11.495212483101342
              ],
              [
                133.05958091528154,
                -11.500257996327209
              ],
              [
                133.0686141345161,
                -11.504327123362604
              ],
              [
                133.07601971778735,
                -11.509942245292846
              ],
              [
                133.07911217094122,
                -11.519707909879974
              ],
              [
                133.07374108300155,
                -11.54778412065663
              ],
              [
                133.07422936719146,
                -11.560967738001914
              ],
              [
                133.0994572228673,
                -11.59710048756823
              ],
              [
                133.1411238948464,
                -11.674574483384282
              ],
              [
                133.15186608265753,
                -11.688734637951987
              ],
              [
                133.16675866524915,
                -11.704359672469124
              ],
              [
                133.18506920718482,
                -11.7170549473869
              ],
              [
                133.20630944751485,
                -11.722344707882648
              ],
              [
                133.26124108779217,
                -11.729587541409721
              ],
              [
                133.28288821860252,
                -11.720879828018798
              ],
              [
                133.2920027923718,
                -11.688246294601125
              ],
              [
                133.3081160910147,
                -11.691989909796305
              ],
              [
                133.33464602931804,
                -11.687676685869704
              ],
              [
                133.3466902923687,
                -11.688246294601125
              ],
              [
                133.36443118608065,
                -11.697360935605722
              ],
              [
                133.35889733725674,
                -11.704359672469124
              ],
              [
                133.3429468072118,
                -11.711114162572487
              ],
              [
                133.32943769042936,
                -11.718682508225108
              ],
              [
                133.31836998588358,
                -11.734633055152313
              ],
              [
                133.31576581756653,
                -11.74911872232854
              ],
              [
                133.32374107700906,
                -11.759453996724256
              ],
              [
                133.3437606142112,
                -11.763360293039982
              ],
              [
                133.3650822282113,
                -11.763360293039982
              ],
              [
                133.37240645058367,
                -11.761000292215412
              ],
              [
                133.37663821976054,
                -11.753025018622195
              ],
              [
                133.38819420505303,
                -11.736016519430741
              ],
              [
                133.3973087932318,
                -11.727471637201685
              ],
              [
                133.40723716626067,
                -11.723809437534348
              ],
              [
                133.41618900018656,
                -11.727797149370971
              ],
              [
                133.42221112774524,
                -11.74285242524189
              ],
              [
                133.41895593332194,
                -11.74863052917571
              ],
              [
                133.4108179137494,
                -11.75416438633719
              ],
              [
                133.40414473499752,
                -11.760023755690284
              ],
              [
                133.40528404906067,
                -11.766778245993184
              ],
              [
                133.41195722390873,
                -11.770196198952872
              ],
              [
                133.42123457986736,
                -11.771091470099233
              ],
              [
                133.43930097390805,
                -11.770196198952872
              ],
              [
                133.46485436463263,
                -11.785821234147226
              ],
              [
                133.47852624709887,
                -11.790785482660665
              ],
              [
                133.48438561779156,
                -11.780694304665143
              ],
              [
                133.4913843107494,
                -11.776462496133691
              ],
              [
                133.50684655887312,
                -11.771091470099233
              ],
              [
                133.523203980221,
                -11.76279068428617
              ],
              [
                133.532074411561,
                -11.74911872232854
              ],
              [
                133.54322349591286,
                -11.76734785474827
              ],
              [
                133.54200279676198,
                -11.799899973954135
              ],
              [
                133.53394616058372,
                -11.834161070319626
              ],
              [
                133.52466881612634,
                -11.858330988932538
              ],
              [
                133.53207440857747,
                -11.865817919620172
              ],
              [
                133.53956139259577,
                -11.853122643627394
              ],
              [
                133.5500594444146,
                -11.823500283293633
              ],
              [
                133.55836021366713,
                -11.811211785199445
              ],
              [
                133.58350670376095,
                -11.799899973954135
              ],
              [
                133.58985435611018,
                -11.798109581845809
              ],
              [
                133.6002710279925,
                -11.800957926100246
              ],
              [
                133.60328209786172,
                -11.807224223391316
              ],
              [
                133.60385175569118,
                -11.814060129475726
              ],
              [
                133.60670006657847,
                -11.8186174502851
              ],
              [
                133.6154891196823,
                -11.829847846055491
              ],
              [
                133.62208093397118,
                -11.833265949353665
              ],
              [
                133.6378686774174,
                -11.823988476467315
              ],
              [
                133.65528405080704,
                -11.821384378973997
              ],
              [
                133.66187584757867,
                -11.8186174502851
              ],
              [
                133.67009524305,
                -11.808851784310512
              ],
              [
                133.68238365690246,
                -11.770196198952872
              ],
              [
                133.69898521336,
                -11.775974152760211
              ],
              [
                133.7165633479775,
                -11.777520448265603
              ],
              [
                133.7345483763094,
                -11.775485959600156
              ],
              [
                133.7512313129008,
                -11.770196198952872
              ],
              [
                133.76514733879307,
                -11.758965803568652
              ],
              [
                133.80250084475173,
                -11.714939043192654
              ],
              [
                133.82984459475122,
                -11.714939043192654
              ],
              [
                133.83757572671354,
                -11.717217778577302
              ],
              [
                133.84229576124636,
                -11.722100461096415
              ],
              [
                133.8459578740216,
                -11.726983293841206
              ],
              [
                133.85059655223066,
                -11.729180613644411
              ],
              [
                133.8679305374767,
                -11.733331006470774
              ],
              [
                133.88526451488497,
                -11.739434472333192
              ],
              [
                133.90162194389686,
                -11.738864863586771
              ],
              [
                133.91578210354956,
                -11.722344707882648
              ],
              [
                133.93327883233525,
                -11.74521242604313
              ],
              [
                133.9389754625745,
                -11.757907851447642
              ],
              [
                133.93287194221645,
                -11.763360293039982
              ],
              [
                133.9189559156628,
                -11.766289902622349
              ],
              [
                133.90894616911947,
                -11.773858398712115
              ],
              [
                133.90137780987004,
                -11.784926113206735
              ],
              [
                133.89527427809438,
                -11.798109581845809
              ],
              [
                133.87012779384466,
                -11.792250212367247
              ],
              [
                133.84636477724584,
                -11.806817295608436
              ],
              [
                133.83415775317332,
                -11.831475557209918
              ],
              [
                133.8437606140843,
                -11.855238547988058
              ],
              [
                133.89128665155508,
                -11.887627837710323
              ],
              [
                133.94312585191693,
                -11.913669564987144
              ],
              [
                133.98487388954374,
                -11.889336814313822
              ],
              [
                134.00749760136307,
                -11.88128027471963
              ],
              [
                134.01368247833423,
                -11.869561384977233
              ],
              [
                134.018077011792,
                -11.856133668966132
              ],
              [
                134.02564537812955,
                -11.84587980958918
              ],
              [
                134.04037520557054,
                -11.841566735507492
              ],
              [
                134.0560001938836,
                -11.844821857414637
              ],
              [
                134.06836998180094,
                -11.854424692398766
              ],
              [
                134.07341555252887,
                -11.869235872781204
              ],
              [
                134.07553144147016,
                -11.873793193745216
              ],
              [
                134.0802515010156,
                -11.877373978129079
              ],
              [
                134.0848087813434,
                -11.88201256450649
              ],
              [
                134.08708744491352,
                -11.889906573324263
              ],
              [
                134.08570396978695,
                -11.901462481799637
              ],
              [
                134.08350671513804,
                -11.909926099522657
              ],
              [
                134.0831811852986,
                -11.918064054873652
              ],
              [
                134.08708744574287,
                -11.927911137129772
              ],
              [
                134.13217207721036,
                -11.886407204514706
              ],
              [
                134.13795007152555,
                -11.879489882522197
              ],
              [
                134.1442977160921,
                -11.886895397707521
              ],
              [
                134.15870201734901,
                -11.921156495944286
              ],
              [
                134.1616317110601,
                -11.930922162615428
              ],
              [
                134.16830488743753,
                -11.938164997055408
              ],
              [
                134.18279056717483,
                -11.94166436598622
              ],
              [
                134.195078966646,
                -11.94768641702062
              ],
              [
                134.19629967941614,
                -11.962009405103903
              ],
              [
                134.19206790472072,
                -11.963311453969572
              ],
              [
                134.1746525360959,
                -11.96428799061958
              ],
              [
                134.16895592753764,
                -11.968194287439731
              ],
              [
                134.16781659447153,
                -11.976657755338499
              ],
              [
                134.17172285105968,
                -11.983330981177447
              ],
              [
                134.1777449804146,
                -11.98943444799888
              ],
              [
                134.18262780407272,
                -11.99618908950909
              ],
              [
                134.18775476405148,
                -12.00872168573466
              ],
              [
                134.18970788027033,
                -12.0182431061831
              ],
              [
                134.1894637451652,
                -12.040785466681365
              ],
              [
                134.18848716585705,
                -12.04810956709994
              ],
              [
                134.1838485130265,
                -12.058770505992559
              ],
              [
                134.1826277903496,
                -12.06812909557837
              ],
              [
                134.18580162024847,
                -12.076429883099074
              ],
              [
                134.1928817107611,
                -12.078708619024123
              ],
              [
                134.19996178967435,
                -12.075616177595398
              ],
              [
                134.2107853591339,
                -12.05217869538888
              ],
              [
                134.2468367908487,
                -12.026950821226626
              ],
              [
                134.25782310434235,
                -12.016696810433416
              ],
              [
                134.26205489185222,
                -11.997979481850424
              ],
              [
                134.26189212105416,
                -11.985039957893258
              ],
              [
                134.26628665586665,
                -11.975762634288037
              ],
              [
                134.28500410453978,
                -11.968194287439731
              ],
              [
                134.34669029905444,
                -12.020277595172953
              ],
              [
                134.3821720662066,
                -12.042657124481604
              ],
              [
                134.42896568883452,
                -12.057549722434285
              ],
              [
                134.52222740368822,
                -12.064385629693147
              ],
              [
                134.56202233311555,
                -12.052422792014104
              ],
              [
                134.5826929009409,
                -12.050957911836853
              ],
              [
                134.5942488876849,
                -12.064385629693147
              ],
              [
                134.60466555190553,
                -12.049493031661283
              ],
              [
                134.63266034847385,
                -12.030938383624724
              ],
              [
                134.69654381854758,
                -11.968194287439731
              ],
              [
                134.7047632213671,
                -11.960625940632161
              ],
              [
                134.7229110026512,
                -11.952243738223073
              ],
              [
                134.74756920902215,
                -11.94850027266
              ],
              [
                134.76856529462316,
                -11.94768641702062
              ],
              [
                134.77369226126677,
                -11.95273208165084
              ],
              [
                134.77442468213252,
                -11.964125309617833
              ],
              [
                134.77222739960726,
                -11.9859350789497
              ],
              [
                134.77458743372938,
                -11.995049721617981
              ],
              [
                134.7800399097849,
                -12.003024996449286
              ],
              [
                134.79224693230785,
                -12.016696810433416
              ],
              [
                134.79590905558277,
                -12.024183892153124
              ],
              [
                134.8009546276017,
                -12.038669562047847
              ],
              [
                134.80640710327305,
                -12.043877908025793
              ],
              [
                134.8146265079358,
                -12.042901371318331
              ],
              [
                134.82593835160253,
                -12.038669562047847
              ],
              [
                134.83619225112486,
                -12.037855706354842
              ],
              [
                134.8405867892678,
                -12.047295861614343
              ],
              [
                134.8466902952674,
                -12.090996969200154
              ],
              [
                134.85320070963266,
                -12.113050987502227
              ],
              [
                134.8610945924534,
                -12.126560121647547
              ],
              [
                134.8806258469697,
                -12.13388437278458
              ],
              [
                134.9274194745342,
                -12.134698228540344
              ],
              [
                134.9399520293231,
                -12.136814133337344
              ],
              [
                134.94727623005625,
                -12.140313352587793
              ],
              [
                134.96705163662565,
                -12.14609145811329
              ],
              [
                134.97095787715227,
                -12.150079020893829
              ],
              [
                134.97364342258416,
                -12.155938391873764
              ],
              [
                134.9913843028837,
                -12.181735877618985
              ],
              [
                135.0012313091655,
                -12.202813360786164
              ],
              [
                135.00505618477735,
                -12.208428635379494
              ],
              [
                135.04053796185178,
                -12.226820605134279
              ],
              [
                135.04607180410915,
                -12.232842657549408
              ],
              [
                135.0488387366502,
                -12.237074467512873
              ],
              [
                135.07016035606102,
                -12.259942344471426
              ],
              [
                135.08033287477068,
                -12.263604395361332
              ],
              [
                135.0924585266383,
                -12.2605119534363
              ],
              [
                135.11491945981336,
                -12.250095259582086
              ],
              [
                135.13355554081008,
                -12.24374769478008
              ],
              [
                135.14722094841184,
                -12.243767372726607
              ],
              [
                135.1581235582155,
                -12.253439158597493
              ],
              [
                135.17199304179945,
                -12.269890222600202
              ],
              [
                135.18785372077053,
                -12.280524275348071
              ],
              [
                135.20271731738586,
                -12.294066007811514
              ],
              [
                135.21759004205657,
                -12.300822904268811
              ],
              [
                135.23780358018843,
                -12.291599204353982
              ],
              [
                135.22999107418022,
                -12.274590698320239
              ],
              [
                135.18889023979622,
                -12.251444325528333
              ],
              [
                135.17007500897938,
                -12.228221795077163
              ],
              [
                135.20777428131888,
                -12.229099191138998
              ],
              [
                135.23255586169043,
                -12.227149271900316
              ],
              [
                135.25831138442015,
                -12.222100451676752
              ],
              [
                135.26922450390813,
                -12.234831632264305
              ],
              [
                135.28309542873194,
                -12.250292790115237
              ],
              [
                135.3019288584171,
                -12.258958296917084
              ],
              [
                135.3234969338022,
                -12.250095259582086
              ],
              [
                135.3381453775056,
                -12.245700768528504
              ],
              [
                135.34929446429373,
                -12.236016515020463
              ],
              [
                135.34937584295417,
                -12.226332261598666
              ],
              [
                135.32866574369436,
                -12.234724379945938
              ],
              [
                135.3048961142719,
                -12.231861464073075
              ],
              [
                135.29003704381597,
                -12.224145305730774
              ],
              [
                135.2642875217702,
                -12.208696315529078
              ],
              [
                135.24149763422585,
                -12.206795816511109
              ],
              [
                135.22268351002643,
                -12.191330303084264
              ],
              [
                135.2375603388906,
                -12.179689821935845
              ],
              [
                135.26530169425138,
                -12.178680989254719
              ],
              [
                135.30697675543902,
                -12.157647368822888
              ],
              [
                135.3134871647385,
                -12.153741071422857
              ],
              [
                135.32260175268902,
                -12.144138234324233
              ],
              [
                135.3239038464201,
                -12.139825159302589
              ],
              [
                135.30888942865832,
                -12.136040234322696
              ],
              [
                135.30294823496124,
                -12.128309806363092
              ],
              [
                135.32472793165553,
                -12.110869439528534
              ],
              [
                135.35143977314237,
                -12.105034403326666
              ],
              [
                135.36626719008797,
                -12.087612663275694
              ],
              [
                135.3890115863056,
                -12.091452415963529
              ],
              [
                135.415049679414,
                -12.08424247741177
              ],
              [
                135.41767868545227,
                -12.0875513762444
              ],
              [
                135.40879363025434,
                -12.1059298248926
              ],
              [
                135.42859185215852,
                -12.115544678749323
              ],
              [
                135.46021896605436,
                -12.113571626852591
              ],
              [
                135.48487390202507,
                -12.106052398957035
              ],
              [
                135.50513757198257,
                -12.098077123488537
              ],
              [
                135.51551516021044,
                -12.078717782036097
              ],
              [
                135.51549744731295,
                -12.065190472604334
              ],
              [
                135.5362418689514,
                -12.062265068408273
              ],
              [
                135.53527956259558,
                -12.080620984687283
              ],
              [
                135.57154381441637,
                -12.09726326775739
              ],
              [
                135.58790123148452,
                -12.098565316756833
              ],
              [
                135.62208091524604,
                -12.06812909557837
              ],
              [
                135.62671959941062,
                -12.064873973161587
              ],
              [
                135.6489363965135,
                -12.054864208908777
              ],
              [
                135.65609785413417,
                -12.05071381521191
              ],
              [
                135.71199680824202,
                -12.018483447469386
              ],
              [
                135.7020917358556,
                -12.007871628654069
              ],
              [
                135.65170331506457,
                -12.02019617956211
              ],
              [
                135.63575280807066,
                -12.02353286769118
              ],
              [
                135.59294681605067,
                -12.055596648999412
              ],
              [
                135.58106529781605,
                -12.057549722434285
              ],
              [
                135.5722762432211,
                -12.04420342026176
              ],
              [
                135.56582628975997,
                -12.025500661981843
              ],
              [
                135.57071742624237,
                -11.994574596945917
              ],
              [
                135.5925399135131,
                -11.965101846268427
              ],
              [
                135.60059654789308,
                -11.956719643832926
              ],
              [
                135.6220809152378,
                -11.954522323723063
              ],
              [
                135.62826581272415,
                -11.956963740440898
              ],
              [
                135.63086998873416,
                -11.961602477280326
              ],
              [
                135.635020388755,
                -11.966241214134943
              ],
              [
                135.64568118856553,
                -11.968194287439731
              ],
              [
                135.65503990876704,
                -11.966403895136919
              ],
              [
                135.65935306790666,
                -11.96135838067154
              ],
              [
                135.66260827407814,
                -11.954766570543978
              ],
              [
                135.6697697215872,
                -11.94768641702062
              ],
              [
                135.68392988395675,
                -11.93914153368828
              ],
              [
                135.70093834501165,
                -11.932549723662483
              ],
              [
                135.71973717051162,
                -11.931817283637763
              ],
              [
                135.73926842149743,
                -11.941501534773758
              ],
              [
                135.77515709141534,
                -11.919366103699806
              ],
              [
                135.809825075028,
                -11.889906573324263
              ],
              [
                135.83676192009943,
                -11.87395602495035
              ],
              [
                135.84107505741719,
                -11.869235872781204
              ],
              [
                135.84506268742965,
                -11.855075716784858
              ],
              [
                135.8546655630213,
                -11.85076264267864
              ],
              [
                135.8658960197399,
                -11.849867371490271
              ],
              [
                135.87525475311756,
                -11.84587980958918
              ],
              [
                135.88697351362362,
                -11.824639651054568
              ],
              [
                135.88314862645962,
                -11.80673588000922
              ],
              [
                135.87378991675845,
                -11.788669578381537
              ],
              [
                135.86841881504327,
                -11.766778245993184
              ],
              [
                135.87818443204594,
                -11.756280140362195
              ],
              [
                135.900401238839,
                -11.759209900146447
              ],
              [
                135.92359459487844,
                -11.76848722247222
              ],
              [
                135.93677818360004,
                -11.777032104891843
              ],
              [
                135.92212846306305,
                -11.816001035310878
              ],
              [
                135.90341650887802,
                -11.849898615853874
              ],
              [
                135.84107507098656,
                -11.913669564987144
              ],
              [
                135.81120852986223,
                -11.951918226009079
              ],
              [
                135.79363040227173,
                -11.963962478402838
              ],
              [
                135.75847415655107,
                -11.969903264136954
              ],
              [
                135.75123131436163,
                -11.97503019424114
              ],
              [
                135.74691815548195,
                -11.982842637739058
              ],
              [
                135.71690744753926,
                -12.003019138130492
              ],
              [
                135.7238434591321,
                -12.010737698473756
              ],
              [
                135.7646590541208,
                -11.99618908950909
              ],
              [
                135.7864689543187,
                -11.989353182603192
              ],
              [
                135.85108482370003,
                -11.982517125517992
              ],
              [
                135.8670353481854,
                -11.978448147654403
              ],
              [
                135.89722740720404,
                -11.962579013929151
              ],
              [
                135.9162703834727,
                -11.962009405103903
              ],
              [
                135.91627038157063,
                -11.968194287439731
              ],
              [
                135.9025985012024,
                -11.976739170946734
              ],
              [
                135.85474694932293,
                -11.989353182603192
              ],
              [
                135.82837976027352,
                -12.005547828862413
              ],
              [
                135.7928165977984,
                -12.036797754040034
              ],
              [
                135.76539148011705,
                -12.071872711688025
              ],
              [
                135.7307234966976,
                -12.101657758242682
              ],
              [
                135.71816596665724,
                -12.108385512156488
              ],
              [
                135.69053489184063,
                -12.129703635732671
              ],
              [
                135.66882255475997,
                -12.147143251775402
              ],
              [
                135.6500727569596,
                -12.164576108477343
              ],
              [
                135.65213788550236,
                -12.203285631485446
              ],
              [
                135.66903065929588,
                -12.237137557112057
              ],
              [
                135.68885597240012,
                -12.250670576648371
              ],
              [
                135.7037392186466,
                -12.265177429407592
              ],
              [
                135.71366908813093,
                -12.276786516877719
              ],
              [
                135.73194421680438,
                -12.311456056053094
              ],
              [
                135.75180096740442,
                -12.270765816136015
              ],
              [
                135.76531009074236,
                -12.257093999225024
              ],
              [
                135.7790633427488,
                -12.263604395361332
              ],
              [
                135.78646894174855,
                -12.263604395361332
              ],
              [
                135.79444420153814,
                -12.235284074817606
              ],
              [
                135.80689537250908,
                -12.216973520545501
              ],
              [
                135.84742271203473,
                -12.18792076103446
              ],
              [
                135.88013757434805,
                -12.151625316808826
              ],
              [
                135.8889266253306,
                -12.146254139138076
              ],
              [
                135.89576256795576,
                -12.150485948777225
              ],
              [
                135.902598513222,
                -12.159926104901176
              ],
              [
                135.90748131769826,
                -12.170505478938642
              ],
              [
                135.90943443100085,
                -12.177910995758669
              ],
              [
                135.91260827466223,
                -12.182305636756714
              ],
              [
                135.919932496453,
                -12.17441177639526
              ],
              [
                135.93051192388452,
                -12.157159175530495
              ],
              [
                135.93458093020064,
                -12.146742482639263
              ],
              [
                135.94434655768092,
                -12.14609145811329
              ],
              [
                135.95655358472104,
                -12.14739350716558
              ],
              [
                135.96778405229307,
                -12.143243113156434
              ],
              [
                136.02857507267817,
                -12.082207988320903
              ],
              [
                136.05347740361637,
                -12.064385629693147
              ],
              [
                136.04932702823558,
                -12.082940428427353
              ],
              [
                136.03589929273784,
                -12.103285469711349
              ],
              [
                136.0198673835815,
                -12.119724214045375
              ],
              [
                136.00863691041465,
                -12.126560121647547
              ],
              [
                136.00464927826056,
                -12.129978075463239
              ],
              [
                135.99366295580919,
                -12.145603114612383
              ],
              [
                135.99138430913834,
                -12.150079020893829
              ],
              [
                135.98959395164553,
                -12.160902641701828
              ],
              [
                135.9850366511911,
                -12.166273669226708
              ],
              [
                135.9538680422552,
                -12.184747053914064
              ],
              [
                135.94361412331077,
                -12.192478083102532
              ],
              [
                135.93677819403914,
                -12.201592727293955
              ],
              [
                135.93539472772807,
                -12.213636982095077
              ],
              [
                135.94044029286522,
                -12.221449427107663
              ],
              [
                135.94703210063756,
                -12.227146117420395
              ],
              [
                135.95045005906297,
                -12.232842657549408
              ],
              [
                135.95736738660483,
                -12.257500927147378
              ],
              [
                135.97445721899166,
                -12.264580932253216
              ],
              [
                135.99488366920548,
                -12.260023760098782
              ],
              [
                136.0124617777656,
                -12.250095259582086
              ],
              [
                136.02588951675938,
                -12.240166909370451
              ],
              [
                136.04420006005304,
                -12.231133680486243
              ],
              [
                136.0602319624112,
                -12.232191632973919
              ],
              [
                136.06714929333742,
                -12.253106436063492
              ],
              [
                136.0628361259864,
                -12.264580932253216
              ],
              [
                136.05347741162055,
                -12.269219670268583
              ],
              [
                136.04395592548798,
                -12.270928647392369
              ],
              [
                136.03980552451154,
                -12.273858258090982
              ],
              [
                136.0382593117717,
                -12.282321878359465
              ],
              [
                136.02613366982555,
                -12.311456056053094
              ],
              [
                135.99024498471982,
                -12.353692293369365
              ],
              [
                135.98511802934465,
                -12.362969620017333
              ],
              [
                135.98568769692326,
                -12.37273529035764
              ],
              [
                135.98804772478,
                -12.38518647511953
              ],
              [
                135.9933374463827,
                -12.393243168348953
              ],
              [
                136.00180097672205,
                -12.390313407089227
              ],
              [
                136.01384524657007,
                -12.3833960821651
              ],
              [
                136.0162866639784,
                -12.3921852156945
              ],
              [
                136.01246178823826,
                -12.413832312204855
              ],
              [
                136.01661216621946,
                -12.435723505922779
              ],
              [
                136.0232039806704,
                -12.455661776203181
              ],
              [
                136.03394616263034,
                -12.465915640940906
              ],
              [
                136.050059434619,
                -12.458184459448294
              ],
              [
                136.0544539808473,
                -12.448418938440755
              ],
              [
                136.05494226242476,
                -12.438409170610674
              ],
              [
                136.05811607625833,
                -12.430596573707415
              ],
              [
                136.0708113890713,
                -12.427504131263508
              ],
              [
                136.07642663352155,
                -12.4293759399422
              ],
              [
                136.0793563186021,
                -12.43417735979771
              ],
              [
                136.0813908245152,
                -12.43971122002981
              ],
              [
                136.08448327074737,
                -12.444512639938727
              ],
              [
                136.09083091945908,
                -12.447849179154266
              ],
              [
                136.09620200935024,
                -12.446058786080984
              ],
              [
                136.10181724515823,
                -12.442966343585667
              ],
              [
                136.14136803395527,
                -12.435153896857463
              ],
              [
                136.14909916550167,
                -12.434991215787434
              ],
              [
                136.15707440443325,
                -12.440524925811022
              ],
              [
                136.16928144596048,
                -12.457940362730517
              ],
              [
                136.17359458854395,
                -12.461602414357511
              ],
              [
                136.19605552750394,
                -12.459893436901305
              ],
              [
                136.2172957737222,
                -12.45525484819914
              ],
              [
                136.2526961638223,
                -12.441094685092995
              ],
              [
                136.28451581680284,
                -12.415785386282987
              ],
              [
                136.30453536095257,
                -12.38355891343961
              ],
              [
                136.33399498034962,
                -12.30461999709531
              ],
              [
                136.36394290609906,
                -12.256442974634918
              ],
              [
                136.36817467013756,
                -12.239434469164795
              ],
              [
                136.36304772006247,
                -12.222914307495351
              ],
              [
                136.34978274837167,
                -12.21087005259356
              ],
              [
                136.3322046187005,
                -12.20354580096747
              ],
              [
                136.31348717804758,
                -12.201592727293955
              ],
              [
                136.30062910540286,
                -12.204359656772418
              ],
              [
                136.27739734468258,
                -12.20822960272062
              ],
              [
                136.25941562976934,
                -12.208984274477958
              ],
              [
                136.23494253850677,
                -12.211159513676266
              ],
              [
                136.22510826579244,
                -12.191827058550745
              ],
              [
                136.21469159200777,
                -12.18792076103446
              ],
              [
                136.18824302545838,
                -12.192071155204275
              ],
              [
                136.18002363528552,
                -12.187758080003794
              ],
              [
                136.1770125664573,
                -12.170830991208422
              ],
              [
                136.18238365957816,
                -12.162530203038072
              ],
              [
                136.19556724807086,
                -12.158298393355299
              ],
              [
                136.2246199776694,
                -12.153741071422857
              ],
              [
                136.23096764005874,
                -12.132093980251815
              ],
              [
                136.2835392690039,
                -12.065687828871665
              ],
              [
                136.30046634414435,
                -12.05071381521191
              ],
              [
                136.3203231161592,
                -12.049004838411994
              ],
              [
                136.32960045667394,
                -12.05136483968739
              ],
              [
                136.3362736386155,
                -12.05006279073675
              ],
              [
                136.36182702711386,
                -12.02353286769118
              ],
              [
                136.3854272712993,
                -12.00530358203257
              ],
              [
                136.41822349716105,
                -11.97356531414852
              ],
              [
                136.42945396448383,
                -11.965264527270275
              ],
              [
                136.44044030448998,
                -11.962009405103903
              ],
              [
                136.4507130961151,
                -11.942333416005111
              ],
              [
                136.46506553306688,
                -11.945811755084542
              ],
              [
                136.48085759550744,
                -11.950690833162252
              ],
              [
                136.51230978288046,
                -11.94079177695215
              ],
              [
                136.5258147992291,
                -11.921820889341705
              ],
              [
                136.55298256730273,
                -11.916128556591833
              ],
              [
                136.56583184457568,
                -11.909079497406953
              ],
              [
                136.56432197734281,
                -11.891560271439346
              ],
              [
                136.57221502112654,
                -11.89644280424409
              ],
              [
                136.5815649401497,
                -11.906925438796742
              ],
              [
                136.5780315101159,
                -11.91675028941177
              ],
              [
                136.5630521943885,
                -11.92730923245999
              ],
              [
                136.54808051503144,
                -11.939271768615377
              ],
              [
                136.52809259236534,
                -11.94915069623331
              ],
              [
                136.515940855869,
                -11.951993182444134
              ],
              [
                136.49879057419085,
                -11.95834840661547
              ],
              [
                136.48016872598217,
                -11.958392569324882
              ],
              [
                136.4694465882876,
                -11.9668112736018
              ],
              [
                136.4702510914341,
                -11.986424624095589
              ],
              [
                136.4774893502217,
                -12.002518326981006
              ],
              [
                136.4896826736643,
                -12.006687497188947
              ],
              [
                136.50465512196538,
                -11.993334135504474
              ],
              [
                136.51966203467873,
                -11.98768536432638
              ],
              [
                136.5332886420371,
                -11.993246110510004
              ],
              [
                136.54851245253394,
                -12.038701707695381
              ],
              [
                136.5601340049292,
                -12.079250889076771
              ],
              [
                136.58662587115612,
                -12.083353214607305
              ],
              [
                136.58173964179898,
                -12.112055073223308
              ],
              [
                136.58188938933193,
                -12.148430129283565
              ],
              [
                136.59057534769065,
                -12.17427823675118
              ],
              [
                136.61207115938743,
                -12.192559498724876
              ],
              [
                136.62191816376264,
                -12.208428635379494
              ],
              [
                136.64991294788481,
                -12.236260611683752
              ],
              [
                136.65870202135724,
                -12.256117462340011
              ],
              [
                136.66358482772117,
                -12.263604395361332
              ],
              [
                136.6906030708264,
                -12.282810221920624
              ],
              [
                136.71908613855047,
                -12.281345341451157
              ],
              [
                136.74537194461644,
                -12.26580171602932
              ],
              [
                136.7658797533736,
                -12.242608326655125
              ],
              [
                136.75953208876663,
                -12.233168169837292
              ],
              [
                136.752777543548,
                -12.225762652651818
              ],
              [
                136.72816897301485,
                -12.219878195684966
              ],
              [
                136.71165070839658,
                -12.206660324089924
              ],
              [
                136.70084580040762,
                -12.190619643843053
              ],
              [
                136.67943952556053,
                -12.204698538038004
              ],
              [
                136.68579298533353,
                -12.184385340229193
              ],
              [
                136.71370371652978,
                -12.185668762872389
              ],
              [
                136.72938905518555,
                -12.173011788226248
              ],
              [
                136.7609155532242,
                -12.164483276644555
              ],
              [
                136.7799585205024,
                -12.172051624667528
              ],
              [
                136.80746504721273,
                -12.194756819250145
              ],
              [
                136.82477585292426,
                -12.213857345047526
              ],
              [
                136.84911437514018,
                -12.21444212553438
              ],
              [
                136.8763795096047,
                -12.223413917029179
              ],
              [
                136.90666701069344,
                -12.26175286579461
              ],
              [
                136.92691070037688,
                -12.288967616869698
              ],
              [
                136.93412693120962,
                -12.322354484712735
              ],
              [
                136.92781627348703,
                -12.348983405338025
              ],
              [
                136.94933957651244,
                -12.355869035001975
              ],
              [
                136.969981320576,
                -12.345879847368414
              ],
              [
                136.98365319164355,
                -12.345472919411138
              ],
              [
                136.97144617020726,
                -12.365980796830346
              ],
              [
                136.96363366726348,
                -12.372491193661961
              ],
              [
                136.9562280699617,
                -12.374932611261674
              ],
              [
                136.94792727234196,
                -12.376397341653755
              ],
              [
                136.92795848082113,
                -12.37697416092477
              ],
              [
                136.90867732383148,
                -12.388972452479537
              ],
              [
                136.8616378781548,
                -12.434679372849994
              ],
              [
                136.79398691149768,
                -12.516122807606605
              ],
              [
                136.7833230329274,
                -12.534358861675342
              ],
              [
                136.77117710455056,
                -12.541405972102803
              ],
              [
                136.768240128779,
                -12.524628639979422
              ],
              [
                136.7800399068036,
                -12.507907788406332
              ],
              [
                136.8006290957074,
                -12.482679903390421
              ],
              [
                136.802500854263,
                -12.477715802203342
              ],
              [
                136.80518639042612,
                -12.467543202763839
              ],
              [
                136.8055119095495,
                -12.456475481998464
              ],
              [
                136.80062910167578,
                -12.447930594797068
              ],
              [
                136.78980553294164,
                -12.445489177009332
              ],
              [
                136.7814233678935,
                -12.450616109307045
              ],
              [
                136.77466881596033,
                -12.457940362730517
              ],
              [
                136.76970461450696,
                -12.461602414357511
              ],
              [
                136.74024498059202,
                -12.475762577780872
              ],
              [
                136.73804772393189,
                -12.507989204054565
              ],
              [
                136.7446794588179,
                -12.547828194926739
              ],
              [
                136.76128539801496,
                -12.574338153063911
              ],
              [
                136.74170983271574,
                -12.573500262804734
              ],
              [
                136.73178144487366,
                -12.578301683440674
              ],
              [
                136.70118248087337,
                -12.616143440335946
              ],
              [
                136.67922198800233,
                -12.671291885730286
              ],
              [
                136.69725954512654,
                -12.698527979473303
              ],
              [
                136.69013799463693,
                -12.713272326850449
              ],
              [
                136.67009524583676,
                -12.70517342065442
              ],
              [
                136.6276961572372,
                -12.70240648966752
              ],
              [
                136.60840905525856,
                -12.714939094854712
              ],
              [
                136.6018986459922,
                -12.733656587345756
              ],
              [
                136.60906010502694,
                -12.750909199042333
              ],
              [
                136.62176274448652,
                -12.76400630705708
              ],
              [
                136.62256920673144,
                -12.78655364223212
              ],
              [
                136.62086024022557,
                -12.79648214883599
              ],
              [
                136.62322023645194,
                -12.807061380148278
              ],
              [
                136.62191818299885,
                -12.818536184091272
              ],
              [
                136.6106876737369,
                -12.83033605008596
              ],
              [
                136.59742271347915,
                -12.83123132215286
              ],
              [
                136.58627362889484,
                -12.823011943510327
              ],
              [
                136.58155356000077,
                -12.808282014474582
              ],
              [
                136.5793563037599,
                -12.79257569846394
              ],
              [
                136.56959069396606,
                -12.765232048568897
              ],
              [
                136.56723065720539,
                -12.753350467512949
              ],
              [
                136.56511479778877,
                -12.748223683562973
              ],
              [
                136.55925540612026,
                -12.745212505405654
              ],
              [
                136.5514429058831,
                -12.743829039839014
              ],
              [
                136.54346766349315,
                -12.743422261907408
              ],
              [
                136.5330247922273,
                -12.748312609906028
              ],
              [
                136.52730062520314,
                -12.754733632670144
              ],
              [
                136.52571533272717,
                -12.769170043615997
              ],
              [
                136.53232638152141,
                -12.779570820991374
              ],
              [
                136.53402317022338,
                -12.793198483329219
              ],
              [
                136.53242843814033,
                -12.804426336178791
              ],
              [
                136.5119019409673,
                -12.805296672784708
              ],
              [
                136.49634850501616,
                -12.780368754697802
              ],
              [
                136.47925866861203,
                -12.766696929848871
              ],
              [
                136.47169028082664,
                -12.773858204514966
              ],
              [
                136.47380619787296,
                -12.792250336182859
              ],
              [
                136.4827580045724,
                -12.825778874941053
              ],
              [
                136.48487389894942,
                -12.842461879430076
              ],
              [
                136.48975671402295,
                -12.850762673977767
              ],
              [
                136.5263778172246,
                -12.880547896410915
              ],
              [
                136.54566489791674,
                -12.871840023085953
              ],
              [
                136.54672284473597,
                -12.891208544649295
              ],
              [
                136.54542078096085,
                -12.912855804803755
              ],
              [
                136.5571395007931,
                -12.911716285561818
              ],
              [
                136.56788169961175,
                -12.911879116942963
              ],
              [
                136.6129081084213,
                -12.938678398876974
              ],
              [
                136.63694387527764,
                -12.954940808366038
              ],
              [
                136.64062918100652,
                -12.975950564589953
              ],
              [
                136.65749397184752,
                -12.995739386389381
              ],
              [
                136.65674890981896,
                -13.006605828889308
              ],
              [
                136.65202885421456,
                -13.013441743624268
              ],
              [
                136.64185633507722,
                -13.008721735864148
              ],
              [
                136.63233481313276,
                -13.000583470383589
              ],
              [
                136.62940514047924,
                -12.996677319295957
              ],
              [
                136.62126712556642,
                -12.98919037956224
              ],
              [
                136.62012779269784,
                -12.982842658845296
              ],
              [
                136.61687257286425,
                -12.979912895392212
              ],
              [
                136.60206140020537,
                -12.98235446507787
              ],
              [
                136.58171567409659,
                -13.014067833383802
              ],
              [
                136.5652808087946,
                -13.011729310023979
              ],
              [
                136.5643345204149,
                -12.979729334536419
              ],
              [
                136.55524023812725,
                -12.963761943690708
              ],
              [
                136.54004969184243,
                -12.961846722044262
              ],
              [
                136.53956137883617,
                -12.964125159843567
              ],
              [
                136.53321375841858,
                -12.9742979160456
              ],
              [
                136.53256270876275,
                -12.976250991520837
              ],
              [
                136.5268661027319,
                -12.975681382060012
              ],
              [
                136.51807701042847,
                -12.968356973529744
              ],
              [
                136.512705902947,
                -12.96884516728698
              ],
              [
                136.49675539276635,
                -12.975192887870875
              ],
              [
                136.49333743881317,
                -12.9802385581872
              ],
              [
                136.49219813586305,
                -12.992933999632001
              ],
              [
                136.493988482735,
                -13.000258108005537
              ],
              [
                136.49830164512557,
                -13.007989294971058
              ],
              [
                136.50391687274947,
                -13.014092768820511
              ],
              [
                136.50928794538922,
                -13.016534038205384
              ],
              [
                136.522146021803,
                -13.01864994521222
              ],
              [
                136.5236922720639,
                -13.023858447268585
              ],
              [
                136.5224715535405,
                -13.030531530773755
              ],
              [
                136.53422348131716,
                -13.050250955589867
              ],
              [
                136.5672306766918,
                -13.058200853982083
              ],
              [
                136.53935169638058,
                -13.102241646530286
              ],
              [
                136.53133378904258,
                -13.155082550227883
              ],
              [
                136.5132124486691,
                -13.143144181622215
              ],
              [
                136.49268825121507,
                -13.148818947424282
              ],
              [
                136.481245241726,
                -13.166464528224036
              ],
              [
                136.4780379361197,
                -13.191989709712352
              ],
              [
                136.47803797347024,
                -13.2276344769908
              ],
              [
                136.4723413299576,
                -13.24236411506897
              ],
              [
                136.45736736924462,
                -13.250583499026211
              ],
              [
                136.45769288688197,
                -13.240899232732415
              ],
              [
                136.4560652789572,
                -13.232598433178987
              ],
              [
                136.45053144743446,
                -13.216403913068428
              ],
              [
                136.44385827043448,
                -13.216403913068428
              ],
              [
                136.43474370812245,
                -13.227715892721703
              ],
              [
                136.39924701252878,
                -13.242004503879771
              ],
              [
                136.38851970587007,
                -13.264255333966327
              ],
              [
                136.3675236362581,
                -13.297621366173336
              ],
              [
                136.35330923258633,
                -13.310275956085912
              ],
              [
                136.3426246409242,
                -13.321538367096656
              ],
              [
                136.3310873951371,
                -13.31997915045014
              ],
              [
                136.33271562591108,
                -13.310354067130376
              ],
              [
                136.3220007933851,
                -13.307989105051112
              ],
              [
                136.32115366464905,
                -13.295969017195391
              ],
              [
                136.34473719384965,
                -13.281345428520535
              ],
              [
                136.34169159181084,
                -13.270251257459796
              ],
              [
                136.33507765423278,
                -13.259059147387218
              ],
              [
                136.3375240627745,
                -13.24863613080749
              ],
              [
                136.35152079682993,
                -13.248586860769349
              ],
              [
                136.3655315638964,
                -13.254944798715139
              ],
              [
                136.38196714316686,
                -13.245275854129355
              ],
              [
                136.3881941892823,
                -13.225762516037594
              ],
              [
                136.3819005236865,
                -13.213231703903093
              ],
              [
                136.3670360606095,
                -13.194870504541276
              ],
              [
                136.3710694599555,
                -13.165236082138053
              ],
              [
                136.36444155925372,
                -13.150851035736308
              ],
              [
                136.36817465663856,
                -13.095635557495427
              ],
              [
                136.3715926274328,
                -13.065362131671117
              ],
              [
                136.36548911775822,
                -13.055108258775421
              ],
              [
                136.34355256057907,
                -13.046855229615435
              ],
              [
                136.33285631221364,
                -13.046882268042138
              ],
              [
                136.31869552480845,
                -13.063083693520321
              ],
              [
                136.3102319785362,
                -13.076104498995598
              ],
              [
                136.30419428443767,
                -13.090993359721327
              ],
              [
                136.30588566560112,
                -13.1062000725549
              ],
              [
                136.32097414731132,
                -13.121270391900143
              ],
              [
                136.3117329648664,
                -13.138207565027606
              ],
              [
                136.31177459476328,
                -13.154220925549494
              ],
              [
                136.30836022768162,
                -13.162774383141217
              ],
              [
                136.2900496928352,
                -13.165704147435381
              ],
              [
                136.27344809846358,
                -13.160414228486257
              ],
              [
                136.2609969193472,
                -13.129326942772034
              ],
              [
                136.24927819157065,
                -13.129652605642745
              ],
              [
                136.23755945284194,
                -13.138767260541428
              ],
              [
                136.23218836530404,
                -13.150567432636171
              ],
              [
                136.23650148829452,
                -13.166680535251894
              ],
              [
                136.24390708968704,
                -13.182549691546894
              ],
              [
                136.24537193575938,
                -13.197035381757308
              ],
              [
                136.23218835421423,
                -13.208916970713743
              ],
              [
                136.22486414557443,
                -13.203545936085336
              ],
              [
                136.21778405022386,
                -13.204685155418536
              ],
              [
                136.21265709389357,
                -13.211521072317392
              ],
              [
                136.21111087374058,
                -13.222588804687035
              ],
              [
                136.211110874432,
                -13.216403913068428
              ],
              [
                136.20704185591836,
                -13.23211023921686
              ],
              [
                136.1938582908343,
                -13.235284251045602
              ],
              [
                136.17741946392343,
                -13.235609613546371
              ],
              [
                136.15861789266674,
                -13.262878176279198
              ],
              [
                136.14785444100136,
                -13.238857830877011
              ],
              [
                136.13873427086583,
                -13.206813380571063
              ],
              [
                136.15699304382835,
                -13.17245864816854
              ],
              [
                136.15650475734924,
                -13.146905227361287
              ],
              [
                136.14763432305494,
                -13.122247080073139
              ],
              [
                136.13656657896377,
                -13.12517654374733
              ],
              [
                136.10399005038698,
                -13.15880544180906
              ],
              [
                136.08585547549816,
                -13.19974613490738
              ],
              [
                136.08586751420123,
                -13.230227462875598
              ],
              [
                136.07677936519715,
                -13.23105453855181
              ],
              [
                136.06397546901815,
                -13.222751636147429
              ],
              [
                136.05836023744675,
                -13.224867543855526
              ],
              [
                136.05347740498024,
                -13.230075747214068
              ],
              [
                136.05241946727733,
                -13.245293879752955
              ],
              [
                136.05909263605676,
                -13.292657109003725
              ],
              [
                136.0534774034331,
                -13.311944227741254
              ],
              [
                136.0466414654334,
                -13.311944227741254
              ],
              [
                136.0398055193437,
                -13.28704182639041
              ],
              [
                136.0369572464308,
                -13.260023818701114
              ],
              [
                136.0304468277325,
                -13.23658630190389
              ],
              [
                136.0082847937943,
                -13.215504734921828
              ],
              [
                135.99141665443324,
                -13.219386252356932
              ],
              [
                135.97754496598148,
                -13.231960626544229
              ],
              [
                135.96770679532298,
                -13.27544173602454
              ],
              [
                135.95681117684074,
                -13.288021218677917
              ],
              [
                135.95191492780393,
                -13.26344177746141
              ],
              [
                135.94283851546874,
                -13.256149210820679
              ],
              [
                135.92399456720747,
                -13.266797547837996
              ],
              [
                135.9111106750696,
                -13.284197983641107
              ],
              [
                135.9071693353816,
                -13.302557383239495
              ],
              [
                135.88336491773373,
                -13.325764475127203
              ],
              [
                135.88342926741873,
                -13.367305733786942
              ],
              [
                135.91285242154106,
                -13.374118820156397
              ],
              [
                135.9208969994372,
                -13.377495020232399
              ],
              [
                135.92538598760243,
                -13.386248265159669
              ],
              [
                135.92627016201587,
                -13.398496379150604
              ],
              [
                135.91636153273365,
                -13.403732523822933
              ],
              [
                135.92264668365434,
                -13.41511721057339
              ],
              [
                135.93637130160099,
                -13.416762049225012
              ],
              [
                135.95948326288368,
                -13.415134334920959
              ],
              [
                135.9646102158834,
                -13.415134334920959
              ],
              [
                135.96943490354386,
                -13.425652289562953
              ],
              [
                135.96762307533405,
                -13.436147712371806
              ],
              [
                135.9646102384078,
                -13.449151401816449
              ],
              [
                135.94581141499867,
                -13.446465883355586
              ],
              [
                135.93677818815135,
                -13.450941647322095
              ],
              [
                135.91987670278672,
                -13.464104263102184
              ],
              [
                135.89943272881283,
                -13.437799460911993
              ],
              [
                135.88052785835438,
                -13.430093804660643
              ],
              [
                135.86065738103787,
                -13.437843022850643
              ],
              [
                135.85474695448184,
                -13.455987321673323
              ],
              [
                135.86101323802174,
                -13.480157289164186
              ],
              [
                135.86101320840007,
                -13.504489788872712
              ],
              [
                135.86939538891923,
                -13.539808913069123
              ],
              [
                135.8684188283281,
                -13.551527677816205
              ],
              [
                135.8640242741122,
                -13.557386910076032
              ],
              [
                135.85743248475723,
                -13.561618728074443
              ],
              [
                135.8508407134503,
                -13.567478260876689
              ],
              [
                135.84742273211668,
                -13.578301753068603
              ],
              [
                135.84483735554326,
                -13.60018607567587
              ],
              [
                135.85280575986167,
                -13.615638551856067
              ],
              [
                135.8707400667883,
                -13.653305823437382
              ],
              [
                135.88468607225826,
                -13.666812133232307
              ],
              [
                135.91627039640377,
                -13.653985389964486
              ],
              [
                135.9184676373841,
                -13.658461155735363
              ],
              [
                135.92212977628495,
                -13.66985456047588
              ],
              [
                135.92310631767083,
                -13.675062768152115
              ],
              [
                135.89372804871218,
                -13.687920756410234
              ],
              [
                135.88672937247372,
                -13.71363703437119
              ],
              [
                135.90137779616666,
                -13.738864818842476
              ],
              [
                135.93677821066873,
                -13.75017680965932
              ],
              [
                135.96989993114857,
                -13.742282780716993
              ],
              [
                135.9965926551605,
                -13.722588867474538
              ],
              [
                136.03296959867222,
                -13.675062768152115
              ],
              [
                136.03614343087864,
                -13.666192351719499
              ],
              [
                136.03589927914717,
                -13.65984462341538
              ],
              [
                136.03736412628982,
                -13.654392168513882
              ],
              [
                136.04664148343733,
                -13.647719077611441
              ],
              [
                136.0553491364351,
                -13.645928530995254
              ],
              [
                136.06348717467523,
                -13.647556246022923
              ],
              [
                136.07032311139847,
                -13.650974207256622
              ],
              [
                136.07447352142404,
                -13.653985389964486
              ],
              [
                136.07789147324814,
                -13.662692974583809
              ],
              [
                136.07178797419257,
                -13.671156612389755
              ],
              [
                136.0534774152472,
                -13.688165003813062
              ],
              [
                136.04721114305346,
                -13.701267239825627
              ],
              [
                136.03296961668264,
                -13.75017680965932
              ],
              [
                136.0048934293777,
                -13.798028279278192
              ],
              [
                136.01270592023698,
                -13.808200750436331
              ],
              [
                136.01270592198037,
                -13.82195401591427
              ],
              [
                136.00489340012044,
                -13.846367948323447
              ],
              [
                136.00171961022306,
                -13.851006847986168
              ],
              [
                135.99724368369377,
                -13.854913005228237
              ],
              [
                135.99301192788784,
                -13.860609709919746
              ],
              [
                135.99138430892413,
                -13.87070076662161
              ],
              [
                135.99244226564366,
                -13.894219728276495
              ],
              [
                135.9913843206425,
                -13.901055654333783
              ],
              [
                135.96461021367645,
                -13.935804896658384
              ],
              [
                135.923106295327,
                -13.95964922468588
              ],
              [
                135.90333090176583,
                -14.135837362740302
              ],
              [
                135.9094344537901,
                -14.195245124047622
              ],
              [
                135.8899031875396,
                -14.189548414952647
              ],
              [
                135.86963949896125,
                -14.192071105918021
              ],
              [
                135.8537704020318,
                -14.200860417327105
              ],
              [
                135.84742272945869,
                -14.212985978130412
              ],
              [
                135.84197025691336,
                -14.219170882515028
              ],
              [
                135.81853272637758,
                -14.223565238060326
              ],
              [
                135.81324304028584,
                -14.226657840535243
              ],
              [
                135.80860436828573,
                -14.226657840535243
              ],
              [
                135.78931722983947,
                -14.240655066584276
              ],
              [
                135.78646893618597,
                -14.243584837383132
              ],
              [
                135.75912517800646,
                -14.265394686383353
              ],
              [
                135.73414149455903,
                -14.298109762540674
              ],
              [
                135.67530359856625,
                -14.406182644231032
              ],
              [
                135.66774098815148,
                -14.427263964794607
              ],
              [
                135.65023791609818,
                -14.436481691536423
              ],
              [
                135.62468511429833,
                -14.43157330158922
              ],
              [
                135.609385618832,
                -14.452569302048484
              ],
              [
                135.55460250196214,
                -14.545692633347022
              ],
              [
                135.5322577729034,
                -14.581084546559742
              ],
              [
                135.5178656564288,
                -14.61648607690251
              ],
              [
                135.52263431873465,
                -14.651543921071575
              ],
              [
                135.50342860683173,
                -14.662693105160058
              ],
              [
                135.47934006004542,
                -14.670831099467886
              ],
              [
                135.45378665797392,
                -14.685642201517805
              ],
              [
                135.4433699827006,
                -14.699883692600281
              ],
              [
                135.44011477430118,
                -14.71217210141906
              ],
              [
                135.43409265951092,
                -14.720635760892778
              ],
              [
                135.416026210978,
                -14.7228327913724
              ],
              [
                135.4040633416957,
                -14.719008041615671
              ],
              [
                135.39087977150842,
                -14.713148793051012
              ],
              [
                135.37826582811195,
                -14.712334933428876
              ],
              [
                135.3681746479876,
                -14.7228327913724
              ],
              [
                135.38404379828853,
                -14.725681149929333
              ],
              [
                135.39128662943511,
                -14.739922642633742
              ],
              [
                135.3955184417827,
                -14.77800881448131
              ],
              [
                135.40398196055497,
                -14.813897358600794
              ],
              [
                135.4477645149614,
                -14.916273674028208
              ],
              [
                135.46957444075568,
                -14.948012116696905
              ],
              [
                135.55111738401345,
                -15.019138279072436
              ],
              [
                135.58106529988262,
                -15.035902601368322
              ],
              [
                135.6152449878437,
                -15.04615650716005
              ],
              [
                135.62574303516718,
                -15.045505467897637
              ],
              [
                135.64568118558057,
                -15.039971610746413
              ],
              [
                135.6526798841271,
                -15.042413019682664
              ],
              [
                135.66976972701934,
                -15.06609465910354
              ],
              [
                135.69752037825518,
                -15.08684660901612
              ],
              [
                135.70899498809786,
                -15.097588800522363
              ],
              [
                135.71762128978017,
                -15.114434501827144
              ],
              [
                135.73633873825486,
                -15.10955169235946
              ],
              [
                135.7590438159262,
                -15.115411065606203
              ],
              [
                135.77849368667893,
                -15.126722918616343
              ],
              [
                135.78646894615565,
                -15.137953383828254
              ],
              [
                135.79615319181696,
                -15.146661070343491
              ],
              [
                135.86101321865678,
                -15.175957949782243
              ],
              [
                135.88795006585764,
                -15.199802341246853
              ],
              [
                135.91822350346723,
                -15.23398202619075
              ],
              [
                135.95167077026693,
                -15.264418233660995
              ],
              [
                135.9882918626646,
                -15.277764579238628
              ],
              [
                136.00310305948506,
                -15.281345302047956
              ],
              [
                136.04346764252142,
                -15.301690355254147
              ],
              [
                136.0603133470396,
                -15.313083592207073
              ],
              [
                136.09066816557004,
                -15.339939062975606
              ],
              [
                136.10124758973342,
                -15.347263267176011
              ],
              [
                136.11231529755682,
                -15.351657797260074
              ],
              [
                136.13640384055566,
                -15.357842698473767
              ],
              [
                136.16578209353054,
                -15.380140864957982
              ],
              [
                136.20606529904381,
                -15.396742441035192
              ],
              [
                136.22461999104723,
                -15.408623971802626
              ],
              [
                136.2370711568763,
                -15.419203366815623
              ],
              [
                136.24008222930067,
                -15.424086207915144
              ],
              [
                136.25733483140223,
                -15.470879812915408
              ],
              [
                136.2679142607821,
                -15.545017194140323
              ],
              [
                136.27320396951941,
                -15.559502850291398
              ],
              [
                136.28443444454373,
                -15.570977490137173
              ],
              [
                136.33082116277066,
                -15.604424752139424
              ],
              [
                136.34839928593794,
                -15.613864846782324
              ],
              [
                136.39584394311106,
                -15.61728279527799
              ],
              [
                136.4165145167752,
                -15.621514569667536
              ],
              [
                136.4680281836237,
                -15.674248918590637
              ],
              [
                136.49382571634098,
                -15.690036713662076
              ],
              [
                136.5090438184752,
                -15.70476654652048
              ],
              [
                136.5285750730365,
                -15.719008106551467
              ],
              [
                136.55372155511768,
                -15.724053669841926
              ],
              [
                136.56267337577506,
                -15.720310168015695
              ],
              [
                136.5725203742135,
                -15.713636952814404
              ],
              [
                136.58318118157192,
                -15.709079662619688
              ],
              [
                136.59473717939807,
                -15.710870072223166
              ],
              [
                136.5984806605145,
                -15.71803148534701
              ],
              [
                136.6062117881157,
                -15.744805612703306
              ],
              [
                136.61207115274536,
                -15.754652565464072
              ],
              [
                136.65821373238586,
                -15.787774318803
              ],
              [
                136.67042076307493,
                -15.799086166268262
              ],
              [
                136.7044377016292,
                -15.847344687142135
              ],
              [
                136.7150985090127,
                -15.85426200204609
              ],
              [
                136.7229109972872,
                -15.862237204480031
              ],
              [
                136.71794680480386,
                -15.88014085209758
              ],
              [
                136.70875084014224,
                -15.90056728184463
              ],
              [
                136.70460046156006,
                -15.915215775688587
              ],
              [
                136.71558678805104,
                -15.935967721157285
              ],
              [
                136.73414146625362,
                -15.938571844460727
              ],
              [
                136.75196373587875,
                -15.928480716458449
              ],
              [
                136.75977623051816,
                -15.912041887779953
              ],
              [
                136.7679142589909,
                -15.900811455954463
              ],
              [
                136.78695722811426,
                -15.90048594054629
              ],
              [
                136.82813561589333,
                -15.90894949138895
              ],
              [
                136.8597111267482,
                -15.907484596939877
              ],
              [
                136.86963952189424,
                -15.90894949138895
              ],
              [
                136.87940515015245,
                -15.914727502573317
              ],
              [
                136.8995874352379,
                -15.93254973421772
              ],
              [
                136.90650474859046,
                -15.93621182016319
              ],
              [
                136.925547729359,
                -15.934665659506434
              ],
              [
                136.92579186021226,
                -15.928643474164412
              ],
              [
                136.92221112806388,
                -15.916110905513182
              ],
              [
                136.92986087640048,
                -15.895277618914674
              ],
              [
                136.94263757192735,
                -15.885512006501493
              ],
              [
                136.98316491369593,
                -15.865899365415414
              ],
              [
                136.9918725938061,
                -15.864190371999452
              ],
              [
                137.0080672538055,
                -15.891859632032613
              ],
              [
                137.0459090535343,
                -15.922295848532059
              ],
              [
                137.09034264117494,
                -15.946709880013517
              ],
              [
                137.13477623630678,
                -15.959893479627311
              ],
              [
                137.15365644226233,
                -15.974053625538984
              ],
              [
                137.16041099719627,
                -15.977227438404096
              ],
              [
                137.17945396758148,
                -15.97877367418726
              ],
              [
                137.18897545224135,
                -15.981133698513291
              ],
              [
                137.19800866626431,
                -15.98463310190801
              ],
              [
                137.2502547608049,
                -16.020603156480238
              ],
              [
                137.25953209152243,
                -16.02874111706654
              ],
              [
                137.26498457057394,
                -16.040785412906764
              ],
              [
                137.291758661475,
                -16.071872661229804
              ],
              [
                137.36117597630536,
                -16.122165619608147
              ],
              [
                137.37989341743136,
                -16.12867600306305
              ],
              [
                137.40259850617986,
                -16.128106388636677
              ],
              [
                137.41309655069327,
                -16.13079192838148
              ],
              [
                137.41773522683997,
                -16.138604448597736
              ],
              [
                137.42172285155522,
                -16.1491838498327
              ],
              [
                137.43140709102838,
                -16.15081142691013
              ],
              [
                137.44239342502573,
                -16.149021092124915
              ],
              [
                137.45118249549986,
                -16.1491025085325
              ],
              [
                137.47510827061413,
                -16.171156515849614
              ],
              [
                137.4853621815773,
                -16.176446253973747
              ],
              [
                137.49740644933544,
                -16.17742280021203
              ],
              [
                137.51921634246557,
                -16.17148203126299
              ],
              [
                137.53003990919416,
                -16.16961028008187
              ],
              [
                137.5504663408444,
                -16.171970304383017
              ],
              [
                137.66089928790458,
                -16.211358345070373
              ],
              [
                137.68978925555004,
                -16.231215085312137
              ],
              [
                137.73023522947082,
                -16.24382907009727
              ],
              [
                137.74610435719364,
                -16.252129787962577
              ],
              [
                137.78012128717074,
                -16.302992432384976
              ],
              [
                137.7846785723661,
                -16.31845463868642
              ],
              [
                137.8447371678365,
                -16.400567281749932
              ],
              [
                137.8491316988412,
                -16.412041886019676
              ],
              [
                137.86687258991174,
                -16.437107019038844
              ],
              [
                137.9128524062743,
                -16.47763435527764
              ],
              [
                137.94996179076625,
                -16.510512004368167
              ],
              [
                138.00017337843332,
                -16.541599242732087
              ],
              [
                138.00082440287702,
                -16.542087440587046
              ],
              [
                138.06153403758668,
                -16.61272546047504
              ],
              [
                138.10206140820856,
                -16.6339658198877
              ],
              [
                138.15349369549753,
                -16.67685316758632
              ],
              [
                138.1842554199521,
                -16.697198245098907
              ],
              [
                138.21998131620452,
                -16.709893488957764
              ],
              [
                138.23715254899875,
                -16.71843845112243
              ],
              [
                138.26205488140343,
                -16.723728110851223
              ],
              [
                138.2708439564699,
                -16.72454197398068
              ],
              [
                138.27767989908594,
                -16.727634443560422
              ],
              [
                138.2895614061921,
                -16.74146906497681
              ],
              [
                138.29411868247482,
                -16.745700762529992
              ],
              [
                138.31185958514627,
                -16.749607095069603
              ],
              [
                138.37322024447283,
                -16.745700762529992
              ],
              [
                138.40308678674495,
                -16.75725677714083
              ],
              [
                138.44654381524978,
                -16.779554942504944
              ],
              [
                138.49268638625048,
                -16.79436610794006
              ],
              [
                138.54468835656064,
                -16.778985328506522
              ],
              [
                138.64795984510994,
                -16.778008782987104
              ],
              [
                138.65723718987746,
                -16.77971777519845
              ],
              [
                138.68441815137825,
                -16.80885175775313
              ],
              [
                138.69507898792233,
                -16.81389746790299
              ],
              [
                138.71021567781955,
                -16.817315301840814
              ],
              [
                138.73829185081885,
                -16.83424238953953
              ],
              [
                138.75342859196792,
                -16.841241190178803
              ],
              [
                138.80445397743085,
                -16.851006794137753
              ],
              [
                138.84034263891627,
                -16.870863516498897
              ],
              [
                138.8696395192135,
                -16.87802499898592
              ],
              [
                138.9713647710295,
                -16.884698133600544
              ],
              [
                139.0083114089713,
                -16.89544043203571
              ],
              [
                139.0372827508986,
                -16.91562266734917
              ],
              [
                139.06218510006167,
                -16.977634410003404
              ],
              [
                139.09343508602592,
                -17.002211168618203
              ],
              [
                139.15805096503075,
                -17.032972860250077
              ],
              [
                139.14063560125282,
                -17.06617598634653
              ],
              [
                139.1416121835602,
                -17.11687594800029
              ],
              [
                139.15251711288428,
                -17.16855229602943
              ],
              [
                139.16431726618129,
                -17.203708647260655
              ],
              [
                139.20948327311297,
                -17.286065381581267
              ],
              [
                139.23991947298083,
                -17.32341890496878
              ],
              [
                139.2741805192128,
                -17.34832115090791
              ],
              [
                139.3143009903655,
                -17.35914485014017
              ],
              [
                139.40162193206464,
                -17.366387587831735
              ],
              [
                139.43864993763182,
                -17.375664979330463
              ],
              [
                139.44890384258179,
                -17.38176849061232
              ],
              [
                139.47282960799166,
                -17.40300865467401
              ],
              [
                139.50879966227603,
                -17.4200171279779
              ],
              [
                139.51783287017238,
                -17.426853083454137
              ],
              [
                139.53158613162356,
                -17.440850508361514
              ],
              [
                139.5758569832158,
                -17.471286789474693
              ],
              [
                139.61793053203658,
                -17.51392993278297
              ],
              [
                139.64096114190525,
                -17.53240328822455
              ],
              [
                139.66863043749797,
                -17.540134517730156
              ],
              [
                139.69654380972344,
                -17.54314541305592
              ],
              [
                139.78126059380904,
                -17.56682699569518
              ],
              [
                139.80469812824506,
                -17.56853613374823
              ],
              [
                139.81967205047584,
                -17.578382979837592
              ],
              [
                139.8317163474435,
                -17.58953218316506
              ],
              [
                139.92530357000715,
                -17.62135176786401
              ],
              [
                139.93336025469193,
                -17.632012772774768
              ],
              [
                139.95443771326657,
                -17.66863379834127
              ],
              [
                139.9904890989736,
                -17.700860151444818
              ],
              [
                139.99952235378763,
                -17.70615009415738
              ],
              [
                140.11744226580086,
                -17.715590154019058
              ],
              [
                140.24048915267997,
                -17.702081092346287
              ],
              [
                140.40430750021997,
                -17.667901353856735
              ],
              [
                140.42408290810687,
                -17.66057720930182
              ],
              [
                140.43238368954923,
                -17.65309023228268
              ],
              [
                140.44141685097063,
                -17.64177819994134
              ],
              [
                140.46265707552098,
                -17.638278809262975
              ],
              [
                140.50749757948947,
                -17.636325723833288
              ],
              [
                140.52320397000645,
                -17.630303635207888
              ],
              [
                140.53858482300953,
                -17.62070073933905
              ],
              [
                140.56617274062043,
                -17.597833023201936
              ],
              [
                140.5753686737318,
                -17.593438354834202
              ],
              [
                140.59791101462562,
                -17.590264627911772
              ],
              [
                140.6074324733108,
                -17.584567902136392
              ],
              [
                140.61589603154087,
                -17.577243754805423
              ],
              [
                140.64470459763461,
                -17.560642072913247
              ],
              [
                140.67383872685429,
                -17.532891484701647
              ],
              [
                140.68897546499207,
                -17.52288180435972
              ],
              [
                140.7341414588181,
                -17.516208533680217
              ],
              [
                140.74333745093023,
                -17.507989257072598
              ],
              [
                140.74708093798782,
                -17.495049795506326
              ],
              [
                140.75513755230443,
                -17.47812259331909
              ],
              [
                140.76832115695524,
                -17.46803149450503
              ],
              [
                140.789317255632,
                -17.459242453234552
              ],
              [
                140.8129988889576,
                -17.45305752764378
              ],
              [
                140.83326257099628,
                -17.45077892615015
              ],
              [
                140.84522545313857,
                -17.441176022874934
              ],
              [
                140.8562931696896,
                -17.419854445814703
              ],
              [
                140.88306725452304,
                -17.346449479328527
              ],
              [
                140.8945418502461,
                -17.262139524006198
              ],
              [
                140.90463299258485,
                -17.22478599252392
              ],
              [
                140.91089929988811,
                -17.215264647667365
              ],
              [
                140.93262779925354,
                -17.19068775465374
              ],
              [
                140.93824302334303,
                -17.160739789677542
              ],
              [
                140.94312586063583,
                -17.152520502226434
              ],
              [
                140.94898522461088,
                -17.138848577729988
              ],
              [
                140.9599715400093,
                -17.073988494974724
              ],
              [
                140.95606531007502,
                -17.056573220444008
              ],
              [
                140.94939212743705,
                -17.037204705033833
              ],
              [
                140.94703211008482,
                -17.01832453613605
              ],
              [
                140.95622807232635,
                -17.00204848622707
              ],
              [
                141.05054773446352,
                -16.887627919662652
              ],
              [
                141.08350670963617,
                -16.800225531037213
              ],
              [
                141.09034264201136,
                -16.797133061917776
              ],
              [
                141.11003664348718,
                -16.7953426534256
              ],
              [
                141.11768638993874,
                -16.79338956245246
              ],
              [
                141.12427818540644,
                -16.78728604044788
              ],
              [
                141.1455184375895,
                -16.758721670589416
              ],
              [
                141.19947349726877,
                -16.703057519126148
              ],
              [
                141.20639082559123,
                -16.686944290075793
              ],
              [
                141.20964603307993,
                -16.672051705149315
              ],
              [
                141.22413170991697,
                -16.639255480424236
              ],
              [
                141.23422285590277,
                -16.573011995027674
              ],
              [
                141.24480228110872,
                -16.556084899125747
              ],
              [
                141.26156660448632,
                -16.560153915490957
              ],
              [
                141.28370200297306,
                -16.518731303761022
              ],
              [
                141.29265383768237,
                -16.49553799897411
              ],
              [
                141.29623457894908,
                -16.47437920191374
              ],
              [
                141.30225669915347,
                -16.454278216520027
              ],
              [
                141.30396570336052,
                -16.44198989950693
              ],
              [
                141.29948978007235,
                -16.436455988336387
              ],
              [
                141.2912703645747,
                -16.43157310783843
              ],
              [
                141.28842206425026,
                -16.420505435552762
              ],
              [
                141.28956140423807,
                -16.40243910775008
              ],
              [
                141.29566490506852,
                -16.388767161981193
              ],
              [
                141.31861411364218,
                -16.36028404120153
              ],
              [
                141.32374109291433,
                -16.344008122073554
              ],
              [
                141.32732181443322,
                -16.323663035085357
              ],
              [
                141.34424889663399,
                -16.283461208369754
              ],
              [
                141.34978275155188,
                -16.265232045699488
              ],
              [
                141.34978274508933,
                -16.224297770279012
              ],
              [
                141.35279382110417,
                -16.21526460507358
              ],
              [
                141.36207115424665,
                -16.200290595839935
              ],
              [
                141.3693140032216,
                -16.179131793681886
              ],
              [
                141.4248153066108,
                -16.081719690436078
              ],
              [
                141.43116296225233,
                -16.06178153300814
              ],
              [
                141.41293378625983,
                -16.041761959165346
              ],
              [
                141.3787540983849,
                -15.93792081363466
              ],
              [
                141.37769616257896,
                -15.92937592139505
              ],
              [
                141.3837996713134,
                -15.917657141266448
              ],
              [
                141.40170332703082,
                -15.903578412033267
              ],
              [
                141.40552819079926,
                -15.891859632032613
              ],
              [
                141.4065047536561,
                -15.851332288338229
              ],
              [
                141.439707882074,
                -15.648858346070195
              ],
              [
                141.48707116197602,
                -15.478936465811337
              ],
              [
                141.5705672539953,
                -15.2872860659761
              ],
              [
                141.5752059233897,
                -15.271661057873736
              ],
              [
                141.5776473336903,
                -15.236504824553814
              ],
              [
                141.58090254076882,
                -15.21868255389655
              ],
              [
                141.58920332214336,
                -15.205824482800985
              ],
              [
                141.60425865918356,
                -15.203220305857029
              ],
              [
                141.59799238577716,
                -15.182305606033946
              ],
              [
                141.6093856142726,
                -15.1687151084758
              ],
              [
                141.6268009768075,
                -15.156996351019172
              ],
              [
                141.6390080086829,
                -15.141208590382734
              ],
              [
                141.63738040519598,
                -15.124769791000759
              ],
              [
                141.63257897186884,
                -15.106540622328916
              ],
              [
                141.6359969401436,
                -15.093682545614215
              ],
              [
                141.6589461600467,
                -15.093926691238924
              ],
              [
                141.65333092528647,
                -15.075372004468996
              ],
              [
                141.65691165457642,
                -15.055271089823503
              ],
              [
                141.66325931116936,
                -15.033868097871222
              ],
              [
                141.66570071703813,
                -15.011407159196303
              ],
              [
                141.66163167976865,
                -14.990329544289086
              ],
              [
                141.65406336793015,
                -14.971124064342407
              ],
              [
                141.6437280452462,
                -14.955010593328074
              ],
              [
                141.63152105717737,
                -14.94255964406393
              ],
              [
                141.6315210462446,
                -14.936293311364356
              ],
              [
                141.6372176390976,
                -14.927178618519363
              ],
              [
                141.6118269973117,
                -14.895603009935602
              ],
              [
                141.60425868189316,
                -14.877699591321845
              ],
              [
                141.54590905292483,
                -14.62004975363832
              ],
              [
                141.54281660856492,
                -14.555840788308823
              ],
              [
                141.53980551653044,
                -14.539808752515729
              ],
              [
                141.52613365039528,
                -14.503675988089466
              ],
              [
                141.52165773660067,
                -14.483819207276381
              ],
              [
                141.52320395788266,
                -14.440687681258794
              ],
              [
                141.5333764711223,
                -14.40016026836251
              ],
              [
                141.59205164572256,
                -14.245293970501509
              ],
              [
                141.60108485537555,
                -14.204278382783537
              ],
              [
                141.60425867946776,
                -14.161065471516695
              ],
              [
                141.5984806887379,
                -14.11451601589521
              ],
              [
                141.583995009759,
                -14.076104547262565
              ],
              [
                141.5622664908736,
                -14.044529010376966
              ],
              [
                141.53541102036635,
                -14.017754908492511
              ],
              [
                141.4850366730741,
                -13.94850036083975
              ],
              [
                141.46778406931958,
                -13.865492556793502
              ],
              [
                141.474131729759,
                -13.77629986960574
              ],
              [
                141.5270288492682,
                -13.571384415830652
              ],
              [
                141.5504663538973,
                -13.52402116241254
              ],
              [
                141.55583744918343,
                -13.500665050193831
              ],
              [
                141.5598250454332,
                -13.491957167915404
              ],
              [
                141.58985438252853,
                -13.454685270305971
              ],
              [
                141.59961998567783,
                -13.438571859148862
              ],
              [
                141.62566166217422,
                -13.36923597806471
              ],
              [
                141.63152100728533,
                -13.346123819354661
              ],
              [
                141.6429142442883,
                -13.351739102552408
              ],
              [
                141.65414471292917,
                -13.353122569423471
              ],
              [
                141.66456141432317,
                -13.35084413017443
              ],
              [
                141.67310629327866,
                -13.346123819354661
              ],
              [
                141.66098065284262,
                -13.328382997755817
              ],
              [
                141.66456141451326,
                -13.314385798746459
              ],
              [
                141.67400149595665,
                -13.301690350658625
              ],
              [
                141.67937257887277,
                -13.287774267616301
              ],
              [
                141.6813257327976,
                -13.279229520608183
              ],
              [
                141.69076582961478,
                -13.259860987230377
              ],
              [
                141.6936141136784,
                -13.250583499026211
              ],
              [
                141.69336999843813,
                -13.241306311396114
              ],
              [
                141.68816165233454,
                -13.22942472179175
              ],
              [
                141.68677816744898,
                -13.219496208656164
              ],
              [
                141.6850692255108,
                -13.215264693712848
              ],
              [
                141.68100020077858,
                -13.20956799611358
              ],
              [
                141.6754663623756,
                -13.204278377207018
              ],
              [
                141.6624455045343,
                -13.199802314763339
              ],
              [
                141.6585392410258,
                -13.194105617311394
              ],
              [
                141.65552817636217,
                -13.187269700611145
              ],
              [
                141.65211024306407,
                -13.181573303704836
              ],
              [
                141.64332115454567,
                -13.17156337563897
              ],
              [
                141.63599695178254,
                -13.160088866026275
              ],
              [
                141.62468509972328,
                -13.133884420415665
              ],
              [
                141.62061607890442,
                -13.118584874966073
              ],
              [
                141.61573326391795,
                -13.049004784541006
              ],
              [
                141.60425867639165,
                -13.006605828889308
              ],
              [
                141.60092206375128,
                -13.003513233927944
              ],
              [
                141.5940047542097,
                -13.000176692304317
              ],
              [
                141.58692469077226,
                -12.994887075161893
              ],
              [
                141.58375085154486,
                -12.98577242231127
              ],
              [
                141.5854598341082,
                -12.977471626142398
              ],
              [
                141.60547934716627,
                -12.943454585976275
              ],
              [
                141.61744227626417,
                -12.928155345432899
              ],
              [
                141.62769618032794,
                -12.91090272951046
              ],
              [
                141.63152104846537,
                -12.893650114017852
              ],
              [
                141.64454187118778,
                -12.907972966367376
              ],
              [
                141.6613875746107,
                -12.899021146061054
              ],
              [
                141.67969810593212,
                -12.88225672455784
              ],
              [
                141.71607507945293,
                -12.863946306717878
              ],
              [
                141.73747806613986,
                -12.842461879430076
              ],
              [
                141.75473067819067,
                -12.8184547684114
              ],
              [
                141.76197351570767,
                -12.801202155154085
              ],
              [
                141.76539148817716,
                -12.78541442361794
              ],
              [
                141.78923585800277,
                -12.722914225301086
              ],
              [
                141.79542077236422,
                -12.69353608752744
              ],
              [
                141.80128012196516,
                -12.677992304787072
              ],
              [
                141.80974366461578,
                -12.66765702182672
              ],
              [
                141.820078961357,
                -12.666436387725154
              ],
              [
                141.8220320749619,
                -12.677992304787072
              ],
              [
                141.81714929022814,
                -12.701836880423228
              ],
              [
                141.82325280522846,
                -12.701836880423228
              ],
              [
                141.83594809675014,
                -12.679457185901237
              ],
              [
                141.8533634923316,
                -12.684747101153157
              ],
              [
                141.86890709641602,
                -12.70037199926736
              ],
              [
                141.8820906722123,
                -12.718031388135248
              ],
              [
                141.89283287375966,
                -12.7775204077625
              ],
              [
                141.89210044012725,
                -12.821465646438497
              ],
              [
                141.8940536014401,
                -12.843357151512027
              ],
              [
                141.9021102213812,
                -12.85271574910411
              ],
              [
                141.91130620964037,
                -12.859958740724482
              ],
              [
                141.93873131026265,
                -12.908461160081382
              ],
              [
                141.93799891175186,
                -12.890883182323597
              ],
              [
                141.93921960058591,
                -12.86931733853432
              ],
              [
                141.9379989087828,
                -12.847426133095912
              ],
              [
                141.9213973100913,
                -12.812432411540778
              ],
              [
                141.9139103451701,
                -12.770603079658251
              ],
              [
                141.90528406232704,
                -12.757094086333643
              ],
              [
                141.98902429934165,
                -12.730238631321349
              ],
              [
                142.00831139946652,
                -12.714939094854712
              ],
              [
                141.9822697134006,
                -12.716729338286482
              ],
              [
                141.9526473428995,
                -12.715020510523363
              ],
              [
                141.9253035835259,
                -12.710056257739192
              ],
              [
                141.90528405523145,
                -12.701836880423228
              ],
              [
                141.89144939683268,
                -12.68287514170256
              ],
              [
                141.881521042657,
                -12.672295912112707
              ],
              [
                141.83179773430197,
                -12.657810232976743
              ],
              [
                141.82325279215803,
                -12.654066614633487
              ],
              [
                141.83692465328662,
                -12.640069129365278
              ],
              [
                141.87419678793097,
                -12.62004958939549
              ],
              [
                141.89763433127655,
                -12.603448305806822
              ],
              [
                141.91895593841306,
                -12.596449563575318
              ],
              [
                141.92945396466376,
                -12.588555549614446
              ],
              [
                141.93799890231173,
                -12.58464940070304
              ],
              [
                141.950450060416,
                -12.583754128920047
              ],
              [
                141.9741317017687,
                -12.585137594209279
              ],
              [
                141.94703207889552,
                -12.57529050592317
              ],
              [
                141.9309187960821,
                -12.565606249059046
              ],
              [
                141.91773520759085,
                -12.565687664712698
              ],
              [
                141.89909914977144,
                -12.585137594209279
              ],
              [
                141.885508650815,
                -12.578871292598151
              ],
              [
                141.87029056018383,
                -12.579685148720937
              ],
              [
                141.83757571177375,
                -12.585137594209279
              ],
              [
                141.8113713064738,
                -12.584079791541669
              ],
              [
                141.79761805607106,
                -12.580010811340996
              ],
              [
                141.782969600046,
                -12.571465772727475
              ],
              [
                141.77173911353148,
                -12.560153803696501
              ],
              [
                141.75782311471824,
                -12.5355770921689
              ],
              [
                141.7482202393176,
                -12.523695514488423
              ],
              [
                141.7363387483405,
                -12.51604589835886
              ],
              [
                141.69361413295584,
                -12.503187783809055
              ],
              [
                141.73422285093864,
                -12.4755184810584
              ],
              [
                141.75114994056884,
                -12.461114220920187
              ],
              [
                141.74480227550634,
                -12.454766504551838
              ],
              [
                141.6999617917161,
                -12.457696266012789
              ],
              [
                141.6837671318645,
                -12.454278311118154
              ],
              [
                141.66570072097417,
                -12.441094685092995
              ],
              [
                141.6640731108683,
                -12.445489177009332
              ],
              [
                141.66358483266544,
                -12.446221617366307
              ],
              [
                141.66236411895542,
                -12.446058786080984
              ],
              [
                141.6589461596643,
                -12.447930594797068
              ],
              [
                141.66089928773914,
                -12.465915640940906
              ],
              [
                141.6589461491943,
                -12.527113469648217
              ],
              [
                141.66358485125176,
                -12.528252988322285
              ],
              [
                141.68685955240318,
                -12.529066543970286
              ],
              [
                141.69662518108854,
                -12.53394938000798
              ],
              [
                141.69996177468124,
                -12.544366076951823
              ],
              [
                141.68873133065736,
                -12.546807645223724
              ],
              [
                141.6657006958671,
                -12.544203245648575
              ],
              [
                141.62183680803867,
                -12.562107178520163
              ],
              [
                141.59994552104942,
                -12.561944347213556
              ],
              [
                141.59058676584885,
                -12.540785290421546
              ],
              [
                141.59473718575384,
                -12.526055667052283
              ],
              [
                141.69361413923497,
                -12.311456056053094
              ],
              [
                141.7082625766243,
                -12.248305017078577
              ],
              [
                141.7171330017687,
                -12.232842657549408
              ],
              [
                141.73243248945698,
                -12.229180606764013
              ],
              [
                141.77076256274728,
                -12.24325935123686
              ],
              [
                141.78923587235062,
                -12.242608326655125
              ],
              [
                141.7990828870448,
                -12.238946275836856
              ],
              [
                141.80974367654062,
                -12.236260611683752
              ],
              [
                141.7995711591208,
                -12.231215096111411
              ],
              [
                141.79232830991853,
                -12.223809428725833
              ],
              [
                141.78874758084103,
                -12.213799663129494
              ],
              [
                141.78923587616998,
                -12.201592727293955
              ],
              [
                141.78296960016982,
                -12.201592727293955
              ],
              [
                141.77930748801478,
                -12.208103123098926
              ],
              [
                141.7734481101227,
                -12.21599698369653
              ],
              [
                141.76628666063525,
                -12.220961233787753
              ],
              [
                141.7585555429702,
                -12.218926744459361
              ],
              [
                141.75342858201483,
                -12.208103123098926
              ],
              [
                141.7551375670269,
                -12.195000915904323
              ],
              [
                141.76612388454336,
                -12.153415559157885
              ],
              [
                141.78492272639073,
                -12.115655235749498
              ],
              [
                141.80103600026388,
                -12.055108305534485
              ],
              [
                141.83122807146984,
                -12.005954756698943
              ],
              [
                141.87134851420356,
                -11.966241214134943
              ],
              [
                141.9133406807849,
                -11.954522323723063
              ],
              [
                141.90308678200842,
                -11.975355706460466
              ],
              [
                141.89820397443867,
                -11.99098074371737
              ],
              [
                141.89893638780666,
                -12.007419486612845
              ],
              [
                141.9163517512848,
                -12.066094606513586
              ],
              [
                141.9196883466167,
                -12.085544526397511
              ],
              [
                141.91960697540623,
                -12.106052398957035
              ],
              [
                141.952159042673,
                -12.046075078066934
              ],
              [
                141.96387779175123,
                -12.037774290742917
              ],
              [
                141.97575931615665,
                -12.04143649115187
              ],
              [
                142.02198327749116,
                -12.071872711688025
              ],
              [
                142.03296958648033,
                -12.04119224431541
              ],
              [
                142.03003990991007,
                -12.028578382386298
              ],
              [
                142.01172937145,
                -12.02353286769118
              ],
              [
                141.99708091997115,
                -11.994317281560843
              ],
              [
                141.99154706005052,
                -11.9859350789497
              ],
              [
                141.97925865473374,
                -11.978773659874514
              ],
              [
                141.9690047615287,
                -11.978285466651027
              ],
              [
                141.96029706445447,
                -11.97909917209473
              ],
              [
                141.95297284772786,
                -11.975681218679853
              ],
              [
                141.944183798087,
                -11.944105782682174
              ],
              [
                141.94760174985745,
                -11.896172720746796
              ],
              [
                141.96729576014255,
                -11.811211785199445
              ],
              [
                142.01002036842377,
                -11.757989116831334
              ],
              [
                142.0117293603767,
                -11.746026281580797
              ],
              [
                142.0066024174275,
                -11.729262029240127
              ],
              [
                142.01050865188358,
                -11.705173377776115
              ],
              [
                142.13184655740307,
                -11.338148750144393
              ],
              [
                142.13412519863903,
                -11.31560639734606
              ],
              [
                142.13184654678264,
                -11.25969815127605
              ],
              [
                142.13347415367534,
                -11.236748946209042
              ],
              [
                142.13819421200768,
                -11.220961233069454
              ],
              [
                142.15235436757592,
                -11.187432583987855
              ],
              [
                142.15935306501834,
                -11.151137006957487
              ],
              [
                142.15805097228687,
                -11.06666428555127
              ],
              [
                142.14535566344375,
                -10.983086835191605
              ],
              [
                142.15105227924252,
                -10.950616138232771
              ],
              [
                142.17457116240567,
                -10.930108349350704
              ],
              [
                142.22120201799694,
                -10.919854417341753
              ],
              [
                142.2280379592653,
                -10.927341421278388
              ],
              [
                142.23902428152843,
                -10.91773851349457
              ],
              [
                142.2576603517382,
                -10.91122812099969
              ],
              [
                142.27955162742913,
                -10.907403240997148
              ],
              [
                142.29997805877716,
                -10.906182533015
              ],
              [
                142.32341556496513,
                -10.901625288305892
              ],
              [
                142.34034264855643,
                -10.890232063862292
              ],
              [
                142.3645125638246,
                -10.858493731302401
              ],
              [
                142.40113366352747,
                -10.820407837176985
              ],
              [
                142.40609785364742,
                -10.80689870870986
              ],
              [
                142.40894615579424,
                -10.791761944500147
              ],
              [
                142.42497806297058,
                -10.745049753300455
              ],
              [
                142.43409264633965,
                -10.728122672196935
              ],
              [
                142.44857831700287,
                -10.714532127868733
              ],
              [
                142.46322676157004,
                -10.711195591021168
              ],
              [
                142.50513756987482,
                -10.715020471164518
              ],
              [
                142.51059004029204,
                -10.711846615273943
              ],
              [
                142.5268660827974,
                -10.697686462217437
              ],
              [
                142.53248131321962,
                -10.694512606311976
              ],
              [
                142.53532961907015,
                -10.69345465434287
              ],
              [
                142.53728274734144,
                -10.691094653860908
              ],
              [
                142.54029381861096,
                -10.688734653377383
              ],
              [
                142.54615319233332,
                -10.68767670140656
              ],
              [
                142.55005943855923,
                -10.690199457954934
              ],
              [
                142.5495711555885,
                -10.69638433860017
              ],
              [
                142.5483504581032,
                -10.70322031859571
              ],
              [
                142.5495711584837,
                -10.708184491190709
              ],
              [
                142.56373131773591,
                -10.717054959505308
              ],
              [
                142.60084068907156,
                -10.734958577029047
              ],
              [
                142.6150008479575,
                -10.745375265424082
              ],
              [
                142.6158960261655,
                -10.75237392628907
              ],
              [
                142.6118270144699,
                -10.762383686935094
              ],
              [
                142.60621178948313,
                -10.772393522665132
              ],
              [
                142.60108483116508,
                -10.779554939548037
              ],
              [
                142.59302819110658,
                -10.786309503822585
              ],
              [
                142.57715905437004,
                -10.792087531727026
              ],
              [
                142.5700789692305,
                -10.796970288635052
              ],
              [
                142.56397546031278,
                -10.806410440530886
              ],
              [
                142.55518639668315,
                -10.82903413363015
              ],
              [
                142.54957116093564,
                -10.837985942187872
              ],
              [
                142.5418400381231,
                -10.841566650585866
              ],
              [
                142.52149498705333,
                -10.846937750732248
              ],
              [
                142.51539147416872,
                -10.851657826640485
              ],
              [
                142.51026452233026,
                -10.876560179486965
              ],
              [
                142.5138452471727,
                -10.900160408683663
              ],
              [
                142.5148218119563,
                -10.923516541282321
              ],
              [
                142.50171959610034,
                -10.94784921016548
              ],
              [
                142.52271568747673,
                -10.94158291422098
              ],
              [
                142.54004967895034,
                -10.925469689071425
              ],
              [
                142.55201257063092,
                -10.904229460328512
              ],
              [
                142.55640709997155,
                -10.882256791720796
              ],
              [
                142.5671492810695,
                -10.870212467910338
              ],
              [
                142.5908309249172,
                -10.864922783365435
              ],
              [
                142.61451256890226,
                -10.868259395214832
              ],
              [
                142.62525475697296,
                -10.882256791720796
              ],
              [
                142.63445072175588,
                -10.93084078915949
              ],
              [
                142.64039146805047,
                -10.931898665975154
              ],
              [
                142.64918053961938,
                -10.929457325123549
              ],
              [
                142.65943444121703,
                -10.933526301649206
              ],
              [
                142.66822350102825,
                -10.951267162458716
              ],
              [
                142.65951582296896,
                -10.983493762885262
              ],
              [
                142.66627037606182,
                -11.003106355833289
              ],
              [
                142.67839602660456,
                -10.982191639329509
              ],
              [
                142.70093834656984,
                -10.970147390743941
              ],
              [
                142.72510826725525,
                -10.967705974793155
              ],
              [
                142.74195397420092,
                -10.975030222644332
              ],
              [
                142.74626712680978,
                -10.985772422777638
              ],
              [
                142.75228926252754,
                -11.015313435562899
              ],
              [
                142.75896243418126,
                -11.026625244320938
              ],
              [
                142.76954186700763,
                -11.038995080099326
              ],
              [
                142.77808678668808,
                -11.053643500657781
              ],
              [
                142.78980553520807,
                -11.08489348955494
              ],
              [
                142.79517662943599,
                -11.112888282248495
              ],
              [
                142.7966414690853,
                -11.143243075348948
              ],
              [
                142.80681399330334,
                -11.167575744202656
              ],
              [
                142.81006920965513,
                -11.171156527663177
              ],
              [
                142.8061629599568,
                -11.179457311879117
              ],
              [
                142.79664147034453,
                -11.19475675676816
              ],
              [
                142.7937117821032,
                -11.21754320564686
              ],
              [
                142.7942000633818,
                -11.248304926761662
              ],
              [
                142.8012801362789,
                -11.277764524441267
              ],
              [
                142.81763756649138,
                -11.296563412591661
              ],
              [
                142.82960046464297,
                -11.29461033987688
              ],
              [
                142.84058678962802,
                -11.308038052785694
              ],
              [
                142.8486434221749,
                -11.326918206416863
              ],
              [
                142.8518172591596,
                -11.341566702533097
              ],
              [
                142.8549910828903,
                -11.351169535469074
              ],
              [
                142.86915124479128,
                -11.372002912241701
              ],
              [
                142.87224368006864,
                -11.382500866039383
              ],
              [
                142.86963952202126,
                -11.391289993862461
              ],
              [
                142.86353601120874,
                -11.399997706120814
              ],
              [
                142.851817248487,
                -11.413262588190385
              ],
              [
                142.83008872850408,
                -11.452243679692298
              ],
              [
                142.8210555355779,
                -11.477634377146186
              ],
              [
                142.82764733204223,
                -11.489027602302256
              ],
              [
                142.8396102176197,
                -11.49863043564261
              ],
              [
                142.8408309170614,
                -11.52068444629793
              ],
              [
                142.83757571795232,
                -11.564711202771335
              ],
              [
                142.84180749455507,
                -11.57447686756193
              ],
              [
                142.85417727662087,
                -11.594008047046612
              ],
              [
                142.85792076639515,
                -11.605075760556124
              ],
              [
                142.86548912691458,
                -11.736016519430741
              ],
              [
                142.85792076859008,
                -11.821709891160422
              ],
              [
                142.86231529572467,
                -11.836846583433722
              ],
              [
                142.8728947239701,
                -11.850681227077263
              ],
              [
                142.9275008362518,
                -11.893731304129618
              ],
              [
                142.94019615294712,
                -11.892754767526492
              ],
              [
                142.9742944603777,
                -11.925225473644954
              ],
              [
                142.9921981163198,
                -11.934014603713045
              ],
              [
                143.02068118775884,
                -11.931573187034026
              ],
              [
                143.04021244106127,
                -11.925062792647633
              ],
              [
                143.07715905969528,
                -11.906833658475254
              ],
              [
                143.10417727507263,
                -11.902113506205373
              ],
              [
                143.12338301526583,
                -11.910577123932045
              ],
              [
                143.17530358542263,
                -11.962334917320211
              ],
              [
                143.1838484971858,
                -11.963555550578675
              ],
              [
                143.20053145071236,
                -11.962009405103903
              ],
              [
                143.22803796743847,
                -11.954847986150966
              ],
              [
                143.23951255983854,
                -11.956312716010851
              ],
              [
                143.24903405270936,
                -11.968194287439731
              ],
              [
                143.2391056622697,
                -11.978122635434366
              ],
              [
                143.22722416440058,
                -11.982110347901733
              ],
              [
                143.20394940625076,
                -11.982517125517992
              ],
              [
                143.10580489469862,
                -12.135430668678369
              ],
              [
                143.10132898068812,
                -12.140232087182461
              ],
              [
                143.0909936963428,
                -12.142673504251214
              ],
              [
                143.0862736304856,
                -12.149021068482982
              ],
              [
                143.08383222973583,
                -12.167413037273779
              ],
              [
                143.0852156981226,
                -12.17058689455942
              ],
              [
                143.09066817029637,
                -12.198174773266834
              ],
              [
                143.0903426349881,
                -12.210381709064968
              ],
              [
                143.0888778096226,
                -12.219984696935244
              ],
              [
                143.08480879540798,
                -12.228204069904203
              ],
              [
                143.07715904045608,
                -12.236260611683752
              ],
              [
                143.08171634095658,
                -12.239841397080456
              ],
              [
                143.08627362979183,
                -12.246351793112098
              ],
              [
                143.09066815738908,
                -12.250095259582086
              ],
              [
                143.08253014411264,
                -12.268161717744471
              ],
              [
                143.0784611274657,
                -12.287041881869168
              ],
              [
                143.0771590428197,
                -12.328789924799622
              ],
              [
                143.08497155069546,
                -12.336846617567048
              ],
              [
                143.1033634785602,
                -12.342380477240097
              ],
              [
                143.13917076717942,
                -12.346123944057503
              ],
              [
                143.17603600645023,
                -12.339288035078647
              ],
              [
                143.18539471652596,
                -12.342543158294463
              ],
              [
                143.20508874586614,
                -12.356622054518965
              ],
              [
                143.21119225421793,
                -12.359958593426931
              ],
              [
                143.25294029940258,
                -12.38892994210043
              ],
              [
                143.25635827033884,
                -12.392754824733915
              ],
              [
                143.26205489351568,
                -12.400811518026844
              ],
              [
                143.2717391277161,
                -12.41790129164554
              ],
              [
                143.27588951476065,
                -12.43303799145598
              ],
              [
                143.27833091508504,
                -12.495049673974691
              ],
              [
                143.28435307145338,
                -12.51604589835886
              ],
              [
                143.29493248687106,
                -12.534844651738785
              ],
              [
                143.31039474256227,
                -12.550958040917802
              ],
              [
                143.32349695245117,
                -12.557793951466275
              ],
              [
                143.36207117097462,
                -12.569512698309099
              ],
              [
                143.3762313190802,
                -12.571465772727475
              ],
              [
                143.39112391743012,
                -12.576592855970574
              ],
              [
                143.40723719800656,
                -12.58831160307368
              ],
              [
                143.43392990085223,
                -12.613051147450319
              ],
              [
                143.43392990492217,
                -12.619317449318856
              ],
              [
                143.4111434075089,
                -12.647718896835721
              ],
              [
                143.40219162172795,
                -12.666192441161135
              ],
              [
                143.41000412357627,
                -12.674493233769185
              ],
              [
                143.41187585354717,
                -12.682549779468234
              ],
              [
                143.37940514797629,
                -12.73284273106679
              ],
              [
                143.37769615682603,
                -12.750664952024962
              ],
              [
                143.36508220577417,
                -12.804864058109906
              ],
              [
                143.3642684295785,
                -12.861748984506432
              ],
              [
                143.35889735008658,
                -12.880547896410915
              ],
              [
                143.37940514337484,
                -12.85271574910411
              ],
              [
                143.38819420239108,
                -12.859551662301794
              ],
              [
                143.4004012378707,
                -12.86581796619511
              ],
              [
                143.41325932564627,
                -12.868096704104635
              ],
              [
                143.42367598760293,
                -12.863213865979963
              ],
              [
                143.43832441393022,
                -12.851332283335696
              ],
              [
                143.44841555993017,
                -12.851332283335696
              ],
              [
                143.4580184394162,
                -12.856377952747179
              ],
              [
                143.47193443638835,
                -12.859551662301794
              ],
              [
                143.4972436636159,
                -12.856540483688613
              ],
              [
                143.5117293586398,
                -12.849216376846451
              ],
              [
                143.52442468248526,
                -12.84042738864929
              ],
              [
                143.54379316776547,
                -12.832777619245528
              ],
              [
                143.4954533160222,
                -12.921563378213671
              ],
              [
                143.5114852462848,
                -12.954359782700227
              ],
              [
                143.51246180440052,
                -12.997002982099177
              ],
              [
                143.50294029144882,
                -13.075127810894255
              ],
              [
                143.52759849906008,
                -13.198418848258727
              ],
              [
                143.52662192932232,
                -13.329766464569426
              ],
              [
                143.52995850521324,
                -13.341973418803494
              ],
              [
                143.53353923433397,
                -13.34954177862999
              ],
              [
                143.57056723453786,
                -13.377129700842492
              ],
              [
                143.5730086512305,
                -13.38827885216686
              ],
              [
                143.5854598541957,
                -13.405206118967534
              ],
              [
                143.5910750595403,
                -13.415134334920959
              ],
              [
                143.59441167469228,
                -13.427178759946536
              ],
              [
                143.59457441142706,
                -13.435804924979868
              ],
              [
                143.58171636353998,
                -13.498711972979581
              ],
              [
                143.58326255055272,
                -13.516778162809267
              ],
              [
                143.59791102833387,
                -13.524183993961453
              ],
              [
                143.5911564278422,
                -13.543552236257794
              ],
              [
                143.56446373162544,
                -13.59937912806527
              ],
              [
                143.55567465807633,
                -13.632907712247675
              ],
              [
                143.54761801792398,
                -13.691989743909543
              ],
              [
                143.53345789258307,
                -13.731540700744139
              ],
              [
                143.53012131076738,
                -13.75017680965932
              ],
              [
                143.53443444276445,
                -13.765720320066578
              ],
              [
                143.55323328576682,
                -13.802992541312513
              ],
              [
                143.55762781557675,
                -13.822198263385863
              ],
              [
                143.56226645922746,
                -13.832126487594886
              ],
              [
                143.59449305229072,
                -13.877129913584167
              ],
              [
                143.59831789584715,
                -13.885023644383066
              ],
              [
                143.59791099481978,
                -13.915215701373956
              ],
              [
                143.60108484882247,
                -13.926527696500617
              ],
              [
                143.60564214955974,
                -13.93694441805114
              ],
              [
                143.61133873635328,
                -13.946872644767295
              ],
              [
                143.6184187951474,
                -13.956231261196697
              ],
              [
                143.67839601183584,
                -14.00359455774499
              ],
              [
                143.68726648951827,
                -14.014336944550458
              ],
              [
                143.69564864591783,
                -14.075290688986758
              ],
              [
                143.69410240244008,
                -14.092868706209579
              ],
              [
                143.70443770708312,
                -14.114353184139611
              ],
              [
                143.70777429333955,
                -14.20956801260103
              ],
              [
                143.74870850375865,
                -14.339938918260685
              ],
              [
                143.7827254349143,
                -14.402276181413812
              ],
              [
                143.80494227764325,
                -14.43157330158922
              ],
              [
                143.83130943088082,
                -14.456475464953416
              ],
              [
                143.84620199226526,
                -14.46721756336416
              ],
              [
                143.85971111750067,
                -14.474867358042125
              ],
              [
                143.87427816612524,
                -14.480238407471498
              ],
              [
                143.89275148640962,
                -14.483819207276381
              ],
              [
                143.92603598822762,
                -14.486504732045507
              ],
              [
                143.93506918425828,
                -14.493259252030423
              ],
              [
                143.94117270930656,
                -14.511162951593008
              ],
              [
                143.95199628577706,
                -14.49895596555114
              ],
              [
                143.96290120987993,
                -14.49456130646845
              ],
              [
                143.98894289318628,
                -14.49065514316801
              ],
              [
                144.03052820711952,
                -14.467055031891917
              ],
              [
                144.06723067119566,
                -14.452569302048484
              ],
              [
                144.11345461654255,
                -14.405205953416052
              ],
              [
                144.129161014588,
                -14.394463856754077
              ],
              [
                144.14633222210773,
                -14.388116117763932
              ],
              [
                144.16163170900404,
                -14.373142195760472
              ],
              [
                144.17335043688797,
                -14.355075670837175
              ],
              [
                144.18002360767994,
                -14.339938918260685
              ],
              [
                144.182790545777,
                -14.314060071827189
              ],
              [
                144.18189537006728,
                -14.286065314657353
              ],
              [
                144.18539470565543,
                -14.262627747239947
              ],
              [
                144.20118247658797,
                -14.2504207690448
              ],
              [
                144.2044376729968,
                -14.256442842190047
              ],
              [
                144.21143641724169,
                -14.265232154995571
              ],
              [
                144.21485434836916,
                -14.270928564727516
              ],
              [
                144.21973716633528,
                -14.266208545034058
              ],
              [
                144.22291100354477,
                -14.264255464531763
              ],
              [
                144.22559654469313,
                -14.262139552224749
              ],
              [
                144.22852622543158,
                -14.257256700822584
              ],
              [
                144.23536216243096,
                -14.257256700822584
              ],
              [
                144.25098717725692,
                -14.291680609201386
              ],
              [
                144.25586996686812,
                -14.29892332083048
              ],
              [
                144.26807699176098,
                -14.303643340911828
              ],
              [
                144.28028407454318,
                -14.302911198527752
              ],
              [
                144.29216557628203,
                -14.303480809508438
              ],
              [
                144.3035587670429,
                -14.312595186166346
              ],
              [
                144.44027751532016,
                -14.250257937235386
              ],
              [
                144.44825278955994,
                -14.243584837383132
              ],
              [
                144.46705163717007,
                -14.196547177492869
              ],
              [
                144.47217859411614,
                -14.189060220025436
              ],
              [
                144.47527102681136,
                -14.18613044961915
              ],
              [
                144.47608481701306,
                -14.179131687256527
              ],
              [
                144.47559654043593,
                -14.164808799765055
              ],
              [
                144.47885174244198,
                -14.159925949529365
              ],
              [
                144.4863387132007,
                -14.161879029531205
              ],
              [
                144.49976648784167,
                -14.168552428474934
              ],
              [
                144.51490321649965,
                -14.172784252126068
              ],
              [
                144.52247153054373,
                -14.181817209939895
              ],
              [
                144.52735436688624,
                -14.191013300165363
              ],
              [
                144.53386479360174,
                -14.195245124047622
              ],
              [
                144.54371180886127,
                -14.204278382783537
              ],
              [
                144.58472740028304,
                -14.26482507545717
              ],
              [
                144.5765079928805,
                -14.28118246296292
              ],
              [
                144.57276454359297,
                -14.302911198527752
              ],
              [
                144.57178797273608,
                -14.34319435348665
              ],
              [
                144.58041425641008,
                -14.36419034912197
              ],
              [
                144.60010825428876,
                -14.365410987190565
              ],
              [
                144.62094160454294,
                -14.35466889163396
              ],
              [
                144.6331486075972,
                -14.339938918260685
              ],
              [
                144.6374618020477,
                -14.356215193378468
              ],
              [
                144.63347416334136,
                -14.376641578628513
              ],
              [
                144.62525478068892,
                -14.393975661575082
              ],
              [
                144.61646570093407,
                -14.401299791036573
              ],
              [
                144.61247807801055,
                -14.413018578722134
              ],
              [
                144.6159774233919,
                -14.467706059064902
              ],
              [
                144.6194767473511,
                -14.483819207276381
              ],
              [
                144.62598714675983,
                -14.491143338471364
              ],
              [
                144.65357505324374,
                -14.511162951593008
              ],
              [
                144.65984131534887,
                -14.521254024305223
              ],
              [
                144.6705835245642,
                -14.546807521372152
              ],
              [
                144.6775822337103,
                -14.555840788308823
              ],
              [
                144.69752038151384,
                -14.561944282218136
              ],
              [
                144.7397566932852,
                -14.55217857184074
              ],
              [
                144.75660239368253,
                -14.552829599162637
              ],
              [
                144.77100671369757,
                -14.566094694185852
              ],
              [
                144.7820743956999,
                -14.584242344780373
              ],
              [
                144.7967228656547,
                -14.600355798500045
              ],
              [
                144.82154384342996,
                -14.607354568515934
              ],
              [
                144.8859969301519,
                -14.609633014278318
              ],
              [
                144.90072678649764,
                -14.614190506702116
              ],
              [
                144.9084578876061,
                -14.622165667940113
              ],
              [
                144.91041102370755,
                -14.629815465838261
              ],
              [
                144.9109806494505,
                -14.63827882292171
              ],
              [
                144.91431727858796,
                -14.647637756094499
              ],
              [
                144.92009523025084,
                -14.656019697606784
              ],
              [
                144.93799891978145,
                -14.671563542998951
              ],
              [
                144.93685958462348,
                -14.67620215177879
              ],
              [
                144.94174236225973,
                -14.726332177566055
              ],
              [
                144.9441024026589,
                -14.73333095005831
              ],
              [
                144.95533290031943,
                -14.743910525071744
              ],
              [
                145.01384526243015,
                -14.784112312202518
              ],
              [
                145.03052820269485,
                -14.805922193011975
              ],
              [
                145.0550236203772,
                -14.792657089022446
              ],
              [
                145.07732178998106,
                -14.801446114131927
              ],
              [
                145.09913168385916,
                -14.817803525435187
              ],
              [
                145.12289474136958,
                -14.826430019554572
              ],
              [
                145.13607832726058,
                -14.828383103037872
              ],
              [
                145.15479579622775,
                -14.837497793202864
              ],
              [
                145.16822352035751,
                -14.840101904601097
              ],
              [
                145.18246501701793,
                -14.838962380540808
              ],
              [
                145.20785568302702,
                -14.832614934170842
              ],
              [
                145.2228296480773,
                -14.832696350204086
              ],
              [
                145.21168052208216,
                -14.859551625113491
              ],
              [
                145.21998132502895,
                -14.88095473095987
              ],
              [
                145.27711022385674,
                -14.947035424391556
              ],
              [
                145.29346765642535,
                -14.949883784826275
              ],
              [
                145.3134871522377,
                -14.944024231860803
              ],
              [
                145.3457137658902,
                -14.94255964406393
              ],
              [
                145.33228602802768,
                -14.970473036235587
              ],
              [
                145.25733483227737,
                -15.075616145386892
              ],
              [
                145.24732506614188,
                -15.094984633708348
              ],
              [
                145.23585045684968,
                -15.165948174253602
              ],
              [
                145.2390242858733,
                -15.182549742327927
              ],
              [
                145.25318444256928,
                -15.212090760756698
              ],
              [
                145.2599389998536,
                -15.23967865314033
              ],
              [
                145.2688094422943,
                -15.249444275376733
              ],
              [
                145.2810164702599,
                -15.255629156431764
              ],
              [
                145.29420006774396,
                -15.257907818584485
              ],
              [
                145.3100692055272,
                -15.254489834748327
              ],
              [
                145.3177189471844,
                -15.24521250383568
              ],
              [
                145.32455488586083,
                -15.216241153190186
              ],
              [
                145.34197024760087,
                -15.229668876030752
              ],
              [
                145.34945722872436,
                -15.250420839490399
              ],
              [
                145.34376061161842,
                -15.26946379320743
              ],
              [
                145.30258222511623,
                -15.284600509747905
              ],
              [
                145.28589928411625,
                -15.300469654664715
              ],
              [
                145.28101647011619,
                -15.319024337772397
              ],
              [
                145.2978621772607,
                -15.332940374058978
              ],
              [
                145.28825930758595,
                -15.343194252310841
              ],
              [
                145.2866317065793,
                -15.35320403194461
              ],
              [
                145.28711998992193,
                -15.363376569379275
              ],
              [
                145.28370202167054,
                -15.373956001021446
              ],
              [
                145.27865644369908,
                -15.377536705782806
              ],
              [
                145.2620548862357,
                -15.384942326893464
              ],
              [
                145.25635827279675,
                -15.388848584494589
              ],
              [
                145.24805748490255,
                -15.40601977493092
              ],
              [
                145.24390709964533,
                -15.428399359846239
              ],
              [
                145.24586022072336,
                -15.44264087680716
              ],
              [
                145.2563582681208,
                -15.435967701732688
              ],
              [
                145.2644149091207,
                -15.435967701732688
              ],
              [
                145.2778426431385,
                -15.47535572283214
              ],
              [
                145.27979576538706,
                -15.49586352255187
              ],
              [
                145.26726322010393,
                -15.50497813797996
              ],
              [
                145.26392662557944,
                -15.50904711649625
              ],
              [
                145.2649031929495,
                -15.518487247398859
              ],
              [
                145.268402539769,
                -15.527927340886963
              ],
              [
                145.27344811336295,
                -15.532159114747646
              ],
              [
                145.27377363733416,
                -15.535739858052176
              ],
              [
                145.3099064482451,
                -15.562595320783778
              ],
              [
                145.3139754558409,
                -15.56796639843452
              ],
              [
                145.3214624347864,
                -15.590101815182987
              ],
              [
                145.3227645226942,
                -15.599786083691948
              ],
              [
                145.3211369169738,
                -15.609144799446408
              ],
              [
                145.3073836561906,
                -15.62859464079342
              ],
              [
                145.30933678572626,
                -15.63396575646937
              ],
              [
                145.3151961538352,
                -15.638116114558821
              ],
              [
                145.35377037434174,
                -15.722426017898599
              ],
              [
                145.3628035898615,
                -15.73455172826315
              ],
              [
                145.366384306492,
                -15.74928148665524
              ],
              [
                145.35938560779903,
                -15.796563384457214
              ],
              [
                145.35938561420426,
                -15.812676696675648
              ],
              [
                145.3650822331729,
                -15.822523725072994
              ],
              [
                145.37012779717364,
                -15.827325114692929
              ],
              [
                145.3732202455857,
                -15.831719647637074
              ],
              [
                145.37305749394585,
                -15.840590129966039
              ],
              [
                145.3685001927739,
                -15.852146076837856
              ],
              [
                145.35531659941827,
                -15.872246990882402
              ],
              [
                145.35254966766078,
                -15.88486090058253
              ],
              [
                145.35580489068954,
                -15.903415654328983
              ],
              [
                145.3640242862652,
                -15.916192321919443
              ],
              [
                145.38672935725543,
                -15.93621182016319
              ],
              [
                145.43018639174113,
                -15.991631758490204
              ],
              [
                145.4505314459936,
                -16.027113539970266
              ],
              [
                145.46241295078443,
                -16.060479396222274
              ],
              [
                145.46241295937307,
                -16.098728133958804
              ],
              [
                145.44027754587182,
                -16.165459921002373
              ],
              [
                145.43441815786244,
                -16.20061611124976
              ],
              [
                145.43783613857633,
                -16.201918247995962
              ],
              [
                145.45899498947065,
                -16.21404388474069
              ],
              [
                145.4622501992726,
                -16.22031016899431
              ],
              [
                145.4685978562204,
                -16.244805616306053
              ],
              [
                145.46859783928468,
                -16.260674679892354
              ],
              [
                145.46241294781638,
                -16.273207248063038
              ],
              [
                145.4310001930136,
                -16.302992432384976
              ],
              [
                145.4145613911407,
                -16.334405192987994
              ],
              [
                145.41431726543715,
                -16.408868148809834
              ],
              [
                145.40040124594148,
                -16.443291960903334
              ],
              [
                145.4039819644765,
                -16.455010663599182
              ],
              [
                145.40902753175496,
                -16.465427304774913
              ],
              [
                145.41675866388127,
                -16.473321239514018
              ],
              [
                145.42758223794885,
                -16.47812270338847
              ],
              [
                145.44809005495293,
                -16.470391601471782
              ],
              [
                145.46338953500782,
                -16.481215174177684
              ],
              [
                145.47282961270406,
                -16.501560107634756
              ],
              [
                145.4760848286143,
                -16.52190519077143
              ],
              [
                145.48145590884164,
                -16.5319148993677
              ],
              [
                145.517100467026,
                -16.566989886964226
              ],
              [
                145.5306095690586,
                -16.60100676031075
              ],
              [
                145.5490014873668,
                -16.620863492468917
              ],
              [
                145.55176841313073,
                -16.62558353895855
              ],
              [
                145.55583745272546,
                -16.640069343678604
              ],
              [
                145.5660913461089,
                -16.65650808932788
              ],
              [
                145.57911217023957,
                -16.67197028878552
              ],
              [
                145.62623129937893,
                -16.7120906791193
              ],
              [
                145.63770590862958,
                -16.71851971726452
              ],
              [
                145.661468960587,
                -16.72795995876696
              ],
              [
                145.67123455907065,
                -16.734795778056338
              ],
              [
                145.6759546200259,
                -16.74334073980683
              ],
              [
                145.68002363674364,
                -16.765720322155442
              ],
              [
                145.68531333451685,
                -16.776055541727594
              ],
              [
                145.6946720850733,
                -16.78443782028079
              ],
              [
                145.71355226626886,
                -16.79363366127088
              ],
              [
                145.7225041047229,
                -16.800225531037213
              ],
              [
                145.74341882389896,
                -16.84832125682624
              ],
              [
                145.7585555260668,
                -16.858981989639805
              ],
              [
                145.7742619013966,
                -16.877211136126515
              ],
              [
                145.77767987190532,
                -16.885349163790664
              ],
              [
                145.7736922580502,
                -16.89837006780685
              ],
              [
                145.76433352796298,
                -16.902032150044917
              ],
              [
                145.75294030910305,
                -16.903497043016788
              ],
              [
                145.74366295079858,
                -16.90943773074468
              ],
              [
                145.74048913164194,
                -16.92205170260366
              ],
              [
                145.74756920998263,
                -16.932549751092115
              ],
              [
                145.7594507274094,
                -16.943454730663582
              ],
              [
                145.77084395153545,
                -16.957289345263707
              ],
              [
                145.7724715594104,
                -16.96477634123233
              ],
              [
                145.77076257623395,
                -16.981377907804184
              ],
              [
                145.7742619140111,
                -16.98837655567209
              ],
              [
                145.78345786454372,
                -16.991631705748226
              ],
              [
                145.79297936620048,
                -16.98943451700363
              ],
              [
                145.79835044289754,
                -16.983168165276133
              ],
              [
                145.7885848437934,
                -16.962090804675164
              ],
              [
                145.7858992805727,
                -16.945000889583284
              ],
              [
                145.78760826626433,
                -16.929782797992612
              ],
              [
                145.79476973408805,
                -16.92310966411849
              ],
              [
                145.80298913935684,
                -16.91806410547888
              ],
              [
                145.8309025347545,
                -16.892185130939716
              ],
              [
                145.839121952814,
                -16.881524398962803
              ],
              [
                145.85694419906395,
                -16.892836161118055
              ],
              [
                145.86768640733712,
                -16.904555004580445
              ],
              [
                145.88038171517397,
                -16.905857064896658
              ],
              [
                145.90406333489486,
                -16.885349163790664
              ],
              [
                145.91163171370408,
                -16.876397423480164
              ],
              [
                145.91732831454428,
                -16.87118903160483
              ],
              [
                145.92481530380806,
                -16.86858491075039
              ],
              [
                145.93824303322748,
                -16.867852464203533
              ],
              [
                145.95508872372514,
                -16.87314212223514
              ],
              [
                145.95728599457854,
                -16.884698133600544
              ],
              [
                145.95248457328987,
                -16.8966610760559
              ],
              [
                145.94898520899036,
                -16.902601763883673
              ],
              [
                145.94727625093168,
                -16.902520497774333
              ],
              [
                145.93734786809446,
                -16.91236751662952
              ],
              [
                145.93482507732028,
                -16.915704083670498
              ],
              [
                145.93392988242385,
                -16.920993741086058
              ],
              [
                145.9416610208914,
                -16.92490007207669
              ],
              [
                145.94166101760058,
                -16.92994563062942
              ],
              [
                145.93140711385334,
                -16.950290696818936
              ],
              [
                145.9243270304586,
                -16.960056298166805
              ],
              [
                145.91773523414705,
                -16.96412531117261
              ],
              [
                145.90984135776935,
                -16.971612307006236
              ],
              [
                145.89161217487413,
                -17.00701262744974
              ],
              [
                145.88697351340898,
                -17.01930108108143
              ],
              [
                145.88233481743063,
                -17.03972740844908
              ],
              [
                145.8818465648089,
                -17.059665687531655
              ],
              [
                145.88803144953826,
                -17.074802357406423
              ],
              [
                145.90406334278484,
                -17.080824458653332
              ],
              [
                145.91179446328974,
                -17.088962481858015
              ],
              [
                145.95248457834646,
                -17.16228609783952
              ],
              [
                145.9591577624083,
                -17.183038081381085
              ],
              [
                145.9625757242712,
                -17.205010706447478
              ],
              [
                145.96338950482095,
                -17.228203972741927
              ],
              [
                145.96843510345514,
                -17.242364240455053
              ],
              [
                146.0036727104232,
                -17.293715052148567
              ],
              [
                146.02995852067693,
                -17.356540582973686
              ],
              [
                146.0412703785182,
                -17.37224700093308
              ],
              [
                146.05974368451592,
                -17.38616301263795
              ],
              [
                146.07105554230267,
                -17.392022425294158
              ],
              [
                146.0752059289544,
                -17.402520457937015
              ],
              [
                146.072438990136,
                -17.44589605837874
              ],
              [
                146.07536866988863,
                -17.50530357529455
              ],
              [
                146.06836997586407,
                -17.51588301926767
              ],
              [
                146.0800887581198,
                -17.539320656673983
              ],
              [
                146.1067000461555,
                -17.57431397563523
              ],
              [
                146.13502036918027,
                -17.60027430530544
              ],
              [
                146.14429771813948,
                -17.613946205618422
              ],
              [
                146.14771571344104,
                -17.63258238515127
              ],
              [
                146.14242598175053,
                -17.647393508131234
              ],
              [
                146.11646571755162,
                -17.668715214442578
              ],
              [
                146.10670007102502,
                -17.684177363268667
              ],
              [
                146.10271244167126,
                -17.70598726198365
              ],
              [
                146.1067000802582,
                -17.769463860150164
              ],
              [
                146.1013290041676,
                -17.77304466469004
              ],
              [
                146.09066818789728,
                -17.783868193553204
              ],
              [
                146.08399501526193,
                -17.795505581912476
              ],
              [
                146.08936610045745,
                -17.80087663778199
              ],
              [
                146.09620200604542,
                -17.805352417418877
              ],
              [
                146.09620201678942,
                -17.815687748689577
              ],
              [
                146.09359782802179,
                -17.827080887054148
              ],
              [
                146.09302819903783,
                -17.834893521828562
              ],
              [
                146.10743246349074,
                -17.85369221292932
              ],
              [
                146.11353602367603,
                -17.86435320570882
              ],
              [
                146.10474695217002,
                -17.8765602009352
              ],
              [
                146.09937586852723,
                -17.909437848351416
              ],
              [
                146.09644617852604,
                -17.916924815735793
              ],
              [
                146.09791102881562,
                -17.93132913807263
              ],
              [
                146.06983482683782,
                -17.99871182539729
              ],
              [
                146.0214950108211,
                -18.085870145249178
              ],
              [
                146.01514734940903,
                -18.116631841589772
              ],
              [
                146.00587001026102,
                -18.142022486749934
              ],
              [
                146.00367274587754,
                -18.156426790440335
              ],
              [
                146.0042423850395,
                -18.17197031432691
              ],
              [
                146.00619554035197,
                -18.185967836442597
              ],
              [
                146.01050869063104,
                -18.198988667386494
              ],
              [
                146.01734459263093,
                -18.21168383383811
              ],
              [
                146.010101768061,
                -18.236504853638095
              ],
              [
                146.02377362739514,
                -18.263116116589583
              ],
              [
                146.1009220536053,
                -18.349541853036886
              ],
              [
                146.1196395014548,
                -18.36191164444973
              ],
              [
                146.1321721022825,
                -18.364434632333193
              ],
              [
                146.1635848641081,
                -18.36581809971248
              ],
              [
                146.17505940701759,
                -18.369317175565385
              ],
              [
                146.18344162233234,
                -18.380140966993068
              ],
              [
                146.18685955322488,
                -18.394219585602066
              ],
              [
                146.1892196011873,
                -18.42400483327509
              ],
              [
                146.2137150410229,
                -18.492120054211366
              ],
              [
                146.20915773705468,
                -18.51336023896166
              ],
              [
                146.22925864205425,
                -18.507093934153414
              ],
              [
                146.25098715007533,
                -18.511162916461764
              ],
              [
                146.26823975405756,
                -18.51873127130952
              ],
              [
                146.2746687962389,
                -18.523614109744983
              ],
              [
                146.28882900057457,
                -18.51580180850792
              ],
              [
                146.30404710029097,
                -18.517185274437118
              ],
              [
                146.33936605949344,
                -18.527032066505488
              ],
              [
                146.3374129680904,
                -18.572849262522166
              ],
              [
                146.33106527952484,
                -18.61256267403871
              ],
              [
                146.32048585996904,
                -18.647149293607967
              ],
              [
                146.2920027779699,
                -18.710625818860887
              ],
              [
                146.278086809564,
                -18.828708692236003
              ],
              [
                146.2761336574987,
                -18.83538175879445
              ],
              [
                146.2731225578032,
                -18.8427058484955
              ],
              [
                146.27076259960018,
                -18.85165794704495
              ],
              [
                146.27125082179032,
                -18.862888176203242
              ],
              [
                146.276621947795,
                -18.874281535699605
              ],
              [
                146.29460694593098,
                -18.89690512016587
              ],
              [
                146.2985132533536,
                -18.907159261065484
              ],
              [
                146.30176842505102,
                -18.912367446207398
              ],
              [
                146.31568444179638,
                -18.922784116241928
              ],
              [
                146.321055545647,
                -18.931898739334557
              ],
              [
                146.33326258778678,
                -18.959079773616327
              ],
              [
                146.4108992736976,
                -19.01018641010072
              ],
              [
                146.42579189449162,
                -19.02727642782985
              ],
              [
                146.44654382363447,
                -19.059747033965273
              ],
              [
                146.4622501936793,
                -19.074965092591007
              ],
              [
                146.47925868671666,
                -19.083591512287843
              ],
              [
                146.51856533132892,
                -19.09547304191893
              ],
              [
                146.53467859285945,
                -19.105726864979786
              ],
              [
                146.55567469506417,
                -19.128106459212603
              ],
              [
                146.56169683077272,
                -19.139255547013153
              ],
              [
                146.56902106597525,
                -19.140801836567498
              ],
              [
                146.57813558344702,
                -19.140882951425993
              ],
              [
                146.58659917627898,
                -19.14275490208826
              ],
              [
                146.6547957951955,
                -19.18254984385275
              ],
              [
                146.69304448814316,
                -19.192966489398653
              ],
              [
                146.74634853023926,
                -19.1727842189822
              ],
              [
                146.76075282621446,
                -19.18254984385275
              ],
              [
                146.77833091031977,
                -19.21217207375929
              ],
              [
                146.80445396684775,
                -19.23739997722141
              ],
              [
                146.81918381315234,
                -19.248142278343817
              ],
              [
                146.82943767479264,
                -19.252618011510524
              ],
              [
                146.85035241509578,
                -19.26474376853463
              ],
              [
                146.8750106003569,
                -19.288343957079878
              ],
              [
                146.9051212976536,
                -19.304620080809887
              ],
              [
                146.94214929192125,
                -19.29412203085947
              ],
              [
                146.95720461795955,
                -19.296807529713575
              ],
              [
                146.97820074890228,
                -19.2838682254046
              ],
              [
                147.01042725876658,
                -19.252618011510524
              ],
              [
                147.01929772198656,
                -19.23674895594562
              ],
              [
                147.02312259786484,
                -19.217950151624724
              ],
              [
                147.0223087936138,
                -19.19768647056257
              ],
              [
                147.01783287943525,
                -19.177422785754633
              ],
              [
                147.02409915543532,
                -19.177422785754633
              ],
              [
                147.02881923302,
                -19.19231546785754
              ],
              [
                147.0478621877522,
                -19.21103286136597
              ],
              [
                147.05201256931377,
                -19.229099230343174
              ],
              [
                147.0539656938248,
                -19.23398204037356
              ],
              [
                147.06299887076295,
                -19.242119956460062
              ],
              [
                147.0651147610403,
                -19.246351744685033
              ],
              [
                147.06397543735605,
                -19.25123455393654
              ],
              [
                147.059336761387,
                -19.258884277971536
              ],
              [
                147.0520125551364,
                -19.290459850301414
              ],
              [
                147.05201255595819,
                -19.300957900613703
              ],
              [
                147.05860432611635,
                -19.316094510704865
              ],
              [
                147.08122802567397,
                -19.34270584604981
              ],
              [
                147.0861922895678,
                -19.35247175589479
              ],
              [
                147.13396241753756,
                -19.410821147916547
              ],
              [
                147.14665777343635,
                -19.398614293076836
              ],
              [
                147.16724696460574,
                -19.39999774871508
              ],
              [
                147.22250409345546,
                -19.413018453735603
              ],
              [
                147.24463954510964,
                -19.422458696671523
              ],
              [
                147.25440516273656,
                -19.424493172106054
              ],
              [
                147.26270591091046,
                -19.42278405652298
              ],
              [
                147.28598064651845,
                -19.410821147916547
              ],
              [
                147.42139729741706,
                -19.412774208505375
              ],
              [
                147.449880437992,
                -19.39657981712947
              ],
              [
                147.4504500576299,
                -19.378676006469536
              ],
              [
                147.44166096960063,
                -19.358819131146234
              ],
              [
                147.4292098542538,
                -19.342543316210808
              ],
              [
                147.40626063200304,
                -19.327813485208882
              ],
              [
                147.3987736141888,
                -19.312757991526134
              ],
              [
                147.4023543671827,
                -19.30388764478077
              ],
              [
                147.42261806572358,
                -19.314629939225256
              ],
              [
                147.4448348245277,
                -19.341566635047233
              ],
              [
                147.49146570788994,
                -19.451836914568275
              ],
              [
                147.55046631161588,
                -19.520928522612767
              ],
              [
                147.55909265986148,
                -19.537530269349748
              ],
              [
                147.56153406131904,
                -19.562107074192433
              ],
              [
                147.5685327187281,
                -19.588474100172828
              ],
              [
                147.5792749194162,
                -19.613946155837912
              ],
              [
                147.59327235512586,
                -19.63616311122791
              ],
              [
                147.58920329868857,
                -19.66253011704473
              ],
              [
                147.5991317040735,
                -19.686700116335608
              ],
              [
                147.5991316995903,
                -19.702894760472688
              ],
              [
                147.56527754993562,
                -19.70517347460062
              ],
              [
                147.58033287349417,
                -19.712090731059185
              ],
              [
                147.59205163641133,
                -19.722100548528413
              ],
              [
                147.61378011028654,
                -19.753513144740698
              ],
              [
                147.68425539755046,
                -19.828057520369
              ],
              [
                147.71941165684456,
                -19.833103130334454
              ],
              [
                147.78500412018155,
                -19.83538184126336
              ],
              [
                147.760101794196,
                -19.776788158990943
              ],
              [
                147.7542423756706,
                -19.767185120865587
              ],
              [
                147.755218957738,
                -19.75676853469844
              ],
              [
                147.7508243972754,
                -19.691501489432714
              ],
              [
                147.82390384479976,
                -19.71428803013806
              ],
              [
                147.8459578842739,
                -19.734795851973423
              ],
              [
                147.85922288373496,
                -19.82488384808115
              ],
              [
                147.87427819966368,
                -19.854424772407423
              ],
              [
                147.8979598229691,
                -19.876234597146485
              ],
              [
                147.92904706622423,
                -19.897556229047353
              ],
              [
                147.94947353329897,
                -19.907810270246706
              ],
              [
                147.96908610822757,
                -19.91155354176167
              ],
              [
                148.01490320627525,
                -19.911228183577638
              ],
              [
                148.0180770284458,
                -19.90691500945986
              ],
              [
                148.0197046182214,
                -19.897556229047353
              ],
              [
                148.02214600201066,
                -19.888116032984925
              ],
              [
                148.02857504064437,
                -19.883884272432013
              ],
              [
                148.0346785853093,
                -19.88486094812465
              ],
              [
                148.04395592566368,
                -19.889092708631612
              ],
              [
                148.04916428806743,
                -19.890069384267647
              ],
              [
                148.05551193678556,
                -19.887872089388974
              ],
              [
                148.07243900015777,
                -19.877048443556355
              ],
              [
                148.0837508153264,
                -19.884535289420555
              ],
              [
                148.1145125311177,
                -19.91643631776447
              ],
              [
                148.1208602426169,
                -19.928318048691352
              ],
              [
                148.13038173638287,
                -19.936211963410344
              ],
              [
                148.19654382389936,
                -19.94524508127968
              ],
              [
                148.25391684441865,
                -19.9634741434599
              ],
              [
                148.27857506298596,
                -19.96575285107342
              ],
              [
                148.27198329533178,
                -19.985935258183268
              ],
              [
                148.27930748801174,
                -20.002536717046134
              ],
              [
                148.3064070972899,
                -20.03394947814629
              ],
              [
                148.28500410220565,
                -20.038995050813327
              ],
              [
                148.26490319137574,
                -20.04762135348594
              ],
              [
                148.27523847701204,
                -20.05584075304763
              ],
              [
                148.2788192075171,
                -20.06536224004428
              ],
              [
                148.2752384771909,
                -20.0749651027546
              ],
              [
                148.26490318986873,
                -20.083103118527113
              ],
              [
                148.29004967465352,
                -20.09319426762998
              ],
              [
                148.30152428544483,
                -20.099379166758006
              ],
              [
                148.32748457021862,
                -20.132582286913244
              ],
              [
                148.33033287918533,
                -20.137627863731975
              ],
              [
                148.33773847696037,
                -20.141289971843268
              ],
              [
                148.37476647390235,
                -20.164971620509874
              ],
              [
                148.40211022374467,
                -20.17392344188532
              ],
              [
                148.40870201776974,
                -20.182224212144913
              ],
              [
                148.40202884330242,
                -20.198500263138573
              ],
              [
                148.41627038079477,
                -20.202243755080225
              ],
              [
                148.43580162799378,
                -20.199965098030553
              ],
              [
                148.45378665515435,
                -20.193942967608617
              ],
              [
                148.46404056132917,
                -20.185479426298258
              ],
              [
                148.46558678477135,
                -20.174086195097708
              ],
              [
                148.45557701865013,
                -20.171563407619317
              ],
              [
                148.43946373809487,
                -20.17066822737381
              ],
              [
                148.422536656903,
                -20.164971620509874
              ],
              [
                148.43344160169522,
                -20.153252861796915
              ],
              [
                148.44605553592731,
                -20.15016041865938
              ],
              [
                148.4589949891386,
                -20.14950937749278
              ],
              [
                148.47022545752358,
                -20.143812760065757
              ],
              [
                148.47641035292773,
                -20.132012631660945
              ],
              [
                148.4733992841171,
                -20.121026296515282
              ],
              [
                148.46461022240652,
                -20.112969660604662
              ],
              [
                148.45346113379023,
                -20.109795830172022
              ],
              [
                148.44385826887753,
                -20.10418059651599
              ],
              [
                148.4375106132963,
                -20.090752864169612
              ],
              [
                148.4370223321912,
                -20.0749651027546
              ],
              [
                148.4441837898835,
                -20.061944268539946
              ],
              [
                148.45915774793454,
                -20.056817315741252
              ],
              [
                148.4702254567149,
                -20.065118095873796
              ],
              [
                148.48113040444196,
                -20.077080985796428
              ],
              [
                148.49512779886703,
                -20.083103118527113
              ],
              [
                148.52165774840444,
                -20.083184504595856
              ],
              [
                148.53028405025998,
                -20.078220311025472
              ],
              [
                148.54281660251795,
                -20.06536224004428
              ],
              [
                148.56006920710027,
                -20.052666925395368
              ],
              [
                148.56666100381017,
                -20.059991143250695
              ],
              [
                148.56820722636735,
                -20.11541106350446
              ],
              [
                148.57520592542684,
                -20.147230728682743
              ],
              [
                148.5898543610884,
                -20.172539964464537
              ],
              [
                148.61426842588352,
                -20.17864349148129
              ],
              [
                148.60661868528877,
                -20.191501557197427
              ],
              [
                148.60450279913152,
                -20.205010671577778
              ],
              [
                148.61085045859448,
                -20.21363698328095
              ],
              [
                148.62794030075653,
                -20.21160247497965
              ],
              [
                148.63868249015178,
                -20.203057558475393
              ],
              [
                148.6416121753413,
                -20.19182708234408
              ],
              [
                148.6427514962967,
                -20.17888762128878
              ],
              [
                148.6484481149059,
                -20.164971620509874
              ],
              [
                148.65739993494856,
                -20.172458587857168
              ],
              [
                148.66098066601768,
                -20.18075937700896
              ],
              [
                148.66032962524656,
                -20.18954844384929
              ],
              [
                148.65528405130468,
                -20.198500263138573
              ],
              [
                148.6753035815881,
                -20.190199475377216
              ],
              [
                148.68311608232975,
                -20.185479426298258
              ],
              [
                148.68311608294186,
                -20.19768645970898
              ],
              [
                148.6793725926894,
                -20.20867278671439
              ],
              [
                148.67212975628158,
                -20.218194277983557
              ],
              [
                148.66277102868753,
                -20.226495044832156
              ],
              [
                148.6831160843286,
                -20.23707448616587
              ],
              [
                148.6893009762961,
                -20.239434500229322
              ],
              [
                148.68531334537747,
                -20.245375251613407
              ],
              [
                148.6828719397884,
                -20.25367603523143
              ],
              [
                148.68213952054668,
                -20.263441671086024
              ],
              [
                148.6831160797871,
                -20.274183843292725
              ],
              [
                148.72169030082088,
                -20.257256772229226
              ],
              [
                148.74073326813328,
                -20.25115324958976
              ],
              [
                148.7583113946674,
                -20.25310638062491
              ],
              [
                148.756683790786,
                -20.229668881092675
              ],
              [
                148.78199303271745,
                -20.24081795802126
              ],
              [
                148.803884308731,
                -20.26669686407858
              ],
              [
                148.7923283207875,
                -20.28728606516453
              ],
              [
                148.7973738926265,
                -20.29485441960098
              ],
              [
                148.81072024700313,
                -20.307224213082407
              ],
              [
                148.81348717401136,
                -20.311781504115082
              ],
              [
                148.8167423806815,
                -20.32146573996298
              ],
              [
                148.82447350595402,
                -20.324314067675708
              ],
              [
                148.8332625698748,
                -20.324965117219797
              ],
              [
                148.84017988076866,
                -20.32887133930863
              ],
              [
                148.84937585175223,
                -20.348728141658395
              ],
              [
                148.84766686694655,
                -20.362725534491926
              ],
              [
                148.84213300985144,
                -20.375258074341758
              ],
              [
                148.84017988340992,
                -20.390883068684584
              ],
              [
                148.85084068917647,
                -20.421075120847938
              ],
              [
                148.8711043592177,
                -20.439873941171925
              ],
              [
                148.923350454593,
                -20.47283293157214
              ],
              [
                148.89812259392403,
                -20.477308859536446
              ],
              [
                148.90528404935387,
                -20.49439869346931
              ],
              [
                148.9248152973702,
                -20.516208581707
              ],
              [
                148.93702233506386,
                -20.53492605198625
              ],
              [
                148.92823327217624,
                -20.53093842142725
              ],
              [
                148.91968834745492,
                -20.529554947779875
              ],
              [
                148.91130618917586,
                -20.53093842142725
              ],
              [
                148.9021916050631,
                -20.53492605198625
              ],
              [
                148.8960067027037,
                -20.52434659618395
              ],
              [
                148.88599694162215,
                -20.519952083435246
              ],
              [
                148.8757430371836,
                -20.5214169335481
              ],
              [
                148.86817467391077,
                -20.528090097735724
              ],
              [
                148.86019941303064,
                -20.513767177288525
              ],
              [
                148.85132897193233,
                -20.50318775773461
              ],
              [
                148.8405867897901,
                -20.496351839764557
              ],
              [
                148.8271590524725,
                -20.493340762686692
              ],
              [
                148.83253014512712,
                -20.482191669416302
              ],
              [
                148.83448326991004,
                -20.469333595566326
              ],
              [
                148.83277428750526,
                -20.456312767820947
              ],
              [
                148.8271590456797,
                -20.445570554059575
              ],
              [
                148.8225203751433,
                -20.441501544876147
              ],
              [
                148.808278838476,
                -20.433363526177434
              ],
              [
                148.80258222262,
                -20.431817298819013
              ],
              [
                148.79297936333992,
                -20.433851822332933
              ],
              [
                148.79070071329065,
                -20.438246337449968
              ],
              [
                148.79232831668068,
                -20.445570554059575
              ],
              [
                148.7854109997241,
                -20.4552547992317
              ],
              [
                148.78158613469037,
                -20.464532161706835
              ],
              [
                148.7746688167545,
                -20.470961198958143
              ],
              [
                148.75831139159573,
                -20.47283293157214
              ],
              [
                148.7431746740811,
                -20.469496348395737
              ],
              [
                148.73796634191493,
                -20.46298593466623
              ],
              [
                148.7341414764433,
                -20.454522411430744
              ],
              [
                148.72413170268274,
                -20.445570554059575
              ],
              [
                148.70101973075242,
                -20.43922292972732
              ],
              [
                148.7038680393853,
                -20.455336213206376
              ],
              [
                148.71705163239693,
                -20.48040131332151
              ],
              [
                148.72413170728765,
                -20.500746353127287
              ],
              [
                148.7160750698815,
                -20.522067982211215
              ],
              [
                148.6985783203239,
                -20.543226818351062
              ],
              [
                148.67693118392785,
                -20.556898687882178
              ],
              [
                148.65528404644263,
                -20.555433838061237
              ],
              [
                148.66016685887323,
                -20.572198158835764
              ],
              [
                148.66871178455264,
                -20.586195569248257
              ],
              [
                148.6893009759655,
                -20.61003996795167
              ],
              [
                148.69117271856356,
                -20.614190349553603
              ],
              [
                148.69418379027488,
                -20.626560155075197
              ],
              [
                148.69613691491503,
                -20.63054778366757
              ],
              [
                148.70264732406991,
                -20.63355882098462
              ],
              [
                148.71615644793505,
                -20.632745057567256
              ],
              [
                148.72071373473835,
                -20.63396574024468
              ],
              [
                148.7282821055757,
                -20.646416958525332
              ],
              [
                148.72575931007086,
                -20.65667082736821
              ],
              [
                148.7098087967322,
                -20.678887654304166
              ],
              [
                148.72575930446064,
                -20.685479399455147
              ],
              [
                148.7397567044249,
                -20.71892668094882
              ],
              [
                148.76172936079757,
                -20.726739182405918
              ],
              [
                148.76726322329546,
                -20.731540647560607
              ],
              [
                148.7823999389417,
                -20.75530365546915
              ],
              [
                148.7854923922776,
                -20.764255499266184
              ],
              [
                148.79029382394526,
                -20.768975549966516
              ],
              [
                148.80079186921571,
                -20.76677827722454
              ],
              [
                148.8122664658016,
                -20.762302317841645
              ],
              [
                148.81967207174594,
                -20.760186458907175
              ],
              [
                148.832041856061,
                -20.76392991895958
              ],
              [
                148.8390405610922,
                -20.769626560359008
              ],
              [
                148.84351648055937,
                -20.77752047434156
              ],
              [
                148.8476668653786,
                -20.7881812572626
              ],
              [
                148.8538517665523,
                -20.832207970379145
              ],
              [
                148.8517358786213,
                -20.837823196864395
              ],
              [
                148.84701582387393,
                -20.842705999177486
              ],
              [
                148.84245852953097,
                -20.849216402175813
              ],
              [
                148.84017988527535,
                -20.859958596958194
              ],
              [
                148.8393660805986,
                -20.87029387255247
              ],
              [
                148.83668053965349,
                -20.878350537084202
              ],
              [
                148.83253014518328,
                -20.884860939597548
              ],
              [
                148.82715905753747,
                -20.890557579284412
              ],
              [
                148.8453882243675,
                -20.887465130622633
              ],
              [
                148.85889733541114,
                -20.873793240255296
              ],
              [
                148.8750106139627,
                -20.84286875174311
              ],
              [
                148.8888452548311,
                -20.85328544155371
              ],
              [
                148.89942467780907,
                -20.86451589391519
              ],
              [
                148.91081791441923,
                -20.873304982590675
              ],
              [
                148.92644290860383,
                -20.876885688997007
              ],
              [
                148.95655358930813,
                -20.870375286382938
              ],
              [
                148.97144616513444,
                -20.87053803893882
              ],
              [
                148.97803795669756,
                -20.880303642825673
              ],
              [
                149.00163820889168,
                -20.901136945542305
              ],
              [
                149.0131942043243,
                -20.908461185621515
              ],
              [
                149.0180770213146,
                -20.906508079977332
              ],
              [
                149.02068117789065,
                -20.901136945542305
              ],
              [
                149.02572675073515,
                -20.89804449693808
              ],
              [
                149.03972415467717,
                -20.89739348674773
              ],
              [
                149.05632572207563,
                -20.898532829685355
              ],
              [
                149.0695093193411,
                -20.906019822341566
              ],
              [
                149.07357832823513,
                -20.92473726603925
              ],
              [
                149.05640709794744,
                -20.91904062667276
              ],
              [
                149.0368758538421,
                -20.9154599205289
              ],
              [
                149.02637779902383,
                -20.919203379214736
              ],
              [
                149.0363061883269,
                -20.93523529301744
              ],
              [
                149.03980552962963,
                -20.951348545197053
              ],
              [
                149.03052818776425,
                -20.965915610469697
              ],
              [
                149.026621934651,
                -20.976250884420082
              ],
              [
                149.0462345671568,
                -20.979913004124636
              ],
              [
                149.0793563201572,
                -20.969984649091003
              ],
              [
                149.0949813220872,
                -20.969821896559065
              ],
              [
                149.10157310510877,
                -20.98333095747047
              ],
              [
                149.11019940538398,
                -20.99277105480977
              ],
              [
                149.1506453850081,
                -20.996189083227954
              ],
              [
                149.16293378507726,
                -21.00790779097564
              ],
              [
                149.16651452141696,
                -21.024346622335774
              ],
              [
                149.1750594397563,
                -21.03704192019772
              ],
              [
                149.18685956284577,
                -21.045342674524903
              ],
              [
                149.1999617788311,
                -21.048272370192176
              ],
              [
                149.2021590419921,
                -21.05462001910063
              ],
              [
                149.23121178293732,
                -21.08977629205034
              ],
              [
                149.2312117941579,
                -21.12607190825596
              ],
              [
                149.19613691703634,
                -21.180922140828308
              ],
              [
                149.1965438127408,
                -21.22014738148583
              ],
              [
                149.2258406854591,
                -21.27320726876525
              ],
              [
                149.23438561872925,
                -21.281670852948853
              ],
              [
                149.24219809361583,
                -21.27743898573062
              ],
              [
                149.24976647462518,
                -21.25855886206343
              ],
              [
                149.2547306621764,
                -21.25432707017428
              ],
              [
                149.2634383441762,
                -21.25432707017428
              ],
              [
                149.26465904163373,
                -21.25554775192689
              ],
              [
                149.26539148179307,
                -21.25953545253724
              ],
              [
                149.2722273917953,
                -21.267998886242438
              ],
              [
                149.2732853453607,
                -21.271742420562475
              ],
              [
                149.27222742432053,
                -21.276299792858858
              ],
              [
                149.27182052633916,
                -21.279961913414947
              ],
              [
                149.27564538473072,
                -21.281670852948853
              ],
              [
                149.2898869287527,
                -21.281019842669384
              ],
              [
                149.29273522773144,
                -21.281670852948853
              ],
              [
                149.29900150184923,
                -21.295831002733333
              ],
              [
                149.30054773368695,
                -21.305352516718997
              ],
              [
                149.29615317981,
                -21.30950282018714
              ],
              [
                149.29297934675193,
                -21.31926842585335
              ],
              [
                149.3010360061634,
                -21.341241152267955
              ],
              [
                149.3205672565287,
                -21.377211205650884
              ],
              [
                149.3139754753966,
                -21.385349287196007
              ],
              [
                149.30640708122354,
                -21.391208531810598
              ],
              [
                149.29737388633464,
                -21.39527757275751
              ],
              [
                149.28646892745917,
                -21.39771893727074
              ],
              [
                149.29639734565086,
                -21.409275050049985
              ],
              [
                149.3264266384712,
                -21.414320607099558
              ],
              [
                149.34107506718018,
                -21.424411721496174
              ],
              [
                149.32496176784778,
                -21.437676625676858
              ],
              [
                149.30713951159242,
                -21.447930568795385
              ],
              [
                149.29249108715103,
                -21.46111421060468
              ],
              [
                149.28646895970854,
                -21.483331040135372
              ],
              [
                149.29216554963386,
                -21.510674694817897
              ],
              [
                149.30640708419506,
                -21.5092098453536
              ],
              [
                149.34734135224977,
                -21.47966891697031
              ],
              [
                149.35564211302145,
                -21.494724179083423
              ],
              [
                149.37183676746474,
                -21.500095243389737
              ],
              [
                149.38795005399118,
                -21.501234587389487
              ],
              [
                149.395192899947,
                -21.503838780810955
              ],
              [
                149.39283287038685,
                -21.534274965327672
              ],
              [
                149.39747156589337,
                -21.549004876252358
              ],
              [
                149.41285240643862,
                -21.55535245850305
              ],
              [
                149.41325930184888,
                -21.562188374328304
              ],
              [
                149.4177352274313,
                -21.575372023566857
              ],
              [
                149.42937260233538,
                -21.58375420412154
              ],
              [
                149.45093836627206,
                -21.575860356960646
              ],
              [
                149.4586694658151,
                -21.565524993512376
              ],
              [
                149.46900474452903,
                -21.53753017009656
              ],
              [
                149.47828207734904,
                -21.528008647483322
              ],
              [
                149.48715255076604,
                -21.53590264281033
              ],
              [
                149.49170981725635,
                -21.545098510132664
              ],
              [
                149.49878991785025,
                -21.569594037717337
              ],
              [
                149.44727624245746,
                -21.620293894846444
              ],
              [
                149.44190515577878,
                -21.63738376648865
              ],
              [
                149.44703211117283,
                -21.6605771344804
              ],
              [
                149.46461020576857,
                -21.698662957851816
              ],
              [
                149.47437585650707,
                -21.711195606794508
              ],
              [
                149.47828210766698,
                -21.718438449148877
              ],
              [
                149.47828210561568,
                -21.726739223417216
              ],
              [
                149.47169031121808,
                -21.737969701190995
              ],
              [
                149.46322676920028,
                -21.740492484361578
              ],
              [
                149.45297286045422,
                -21.742282841794786
              ],
              [
                149.4401147750054,
                -21.75156013522153
              ],
              [
                149.43246502967978,
                -21.769219620225385
              ],
              [
                149.43539470722087,
                -21.78972739775243
              ],
              [
                149.44507898905235,
                -21.810642248950654
              ],
              [
                149.45720463013598,
                -21.82968518073767
              ],
              [
                149.46583094485447,
                -21.840264655354403
              ],
              [
                149.47169031919188,
                -21.845310225854618
              ],
              [
                149.47559654785445,
                -21.851250900968836
              ],
              [
                149.47828211687096,
                -21.86443457733228
              ],
              [
                149.47754967865066,
                -21.873304959650685
              ],
              [
                149.47217858626675,
                -21.8967424619386
              ],
              [
                149.47087648295997,
                -21.908461139844302
              ],
              [
                149.47437583451895,
                -21.929375862443425
              ],
              [
                149.4831648983884,
                -21.95134852273184
              ],
              [
                149.52149499104934,
                -22.012627874327787
              ],
              [
                149.5249129536171,
                -22.028741131442008
              ],
              [
                149.52865646095393,
                -22.075941720386062
              ],
              [
                149.53581789379146,
                -22.095798393526735
              ],
              [
                149.57447350574435,
                -22.15862396243303
              ],
              [
                149.55933677226972,
                -22.170668180073402
              ],
              [
                149.55420982886733,
                -22.177911054455578
              ],
              [
                149.55339604070514,
                -22.18661878743181
              ],
              [
                149.574473485704,
                -22.192803576637232
              ],
              [
                149.58057701104067,
                -22.211846583723514
              ],
              [
                149.58415775975385,
                -22.217380510220003
              ],
              [
                149.6085717980263,
                -22.24431726836597
              ],
              [
                149.60499107260767,
                -22.255059468532785
              ],
              [
                149.58985436234755,
                -22.273695568607526
              ],
              [
                149.5875757049291,
                -22.282159068758848
              ],
              [
                149.59213302100892,
                -22.28557712500476
              ],
              [
                149.63941491539188,
                -22.302992465733862
              ],
              [
                149.64478599605258,
                -22.30608486491846
              ],
              [
                149.65308677157026,
                -22.313164922878197
              ],
              [
                149.6616317242543,
                -22.327325191060925
              ],
              [
                149.66879318314633,
                -22.343357095263325
              ],
              [
                149.67920983732995,
                -22.352146111452356
              ],
              [
                149.69743900544623,
                -22.34433361918403
              ],
              [
                149.70329838623664,
                -22.3628883272746
              ],
              [
                149.70508875268274,
                -22.383884426489136
              ],
              [
                149.70411217198952,
                -22.42245858105448
              ],
              [
                149.69922936108358,
                -22.446954027041212
              ],
              [
                149.6872664541354,
                -22.461358266178348
              ],
              [
                149.67383873143137,
                -22.474216380179822
              ],
              [
                149.66325931945946,
                -22.493829064645855
              ],
              [
                149.69402101869534,
                -22.48870204004327
              ],
              [
                149.731293167542,
                -22.469333601216814
              ],
              [
                149.76539147753547,
                -22.445245070092255
              ],
              [
                149.7861434099921,
                -22.42555098547519
              ],
              [
                149.80152428891398,
                -22.388767199245724
              ],
              [
                149.81275475840764,
                -22.37810639405034
              ],
              [
                149.83082114489986,
                -22.38860437004963
              ],
              [
                149.85816491139434,
                -22.421075133064466
              ],
              [
                149.8708602372357,
                -22.44036229327682
              ],
              [
                149.8761499466305,
                -22.45663831753367
              ],
              [
                149.88086996939668,
                -22.467380399606938
              ],
              [
                149.9640405467084,
                -22.533623904441598
              ],
              [
                149.97169028848924,
                -22.545668185503096
              ],
              [
                149.98023519147327,
                -22.576592596145197
              ],
              [
                150.00066166123636,
                -22.60865653039885
              ],
              [
                150.02523847549463,
                -22.63396574760161
              ],
              [
                150.04672285557442,
                -22.645277614807675
              ],
              [
                150.02247153326172,
                -22.55339928670413
              ],
              [
                149.95557701483656,
                -22.401136961871316
              ],
              [
                149.93718507547092,
                -22.380059442865075
              ],
              [
                149.9284774143668,
                -22.356052357907586
              ],
              [
                149.92994223670783,
                -22.338067252948218
              ],
              [
                149.9506942144589,
                -22.34433361918403
              ],
              [
                149.94336999451488,
                -22.328301714764574
              ],
              [
                149.9306746862994,
                -22.313734674251684
              ],
              [
                149.92351321251112,
                -22.298272377598046
              ],
              [
                149.9334416071622,
                -22.27874116287932
              ],
              [
                149.9431258428619,
                -22.26474373285591
              ],
              [
                149.96111088560193,
                -22.220961242213768
              ],
              [
                149.9682723150068,
                -22.188164909583627
              ],
              [
                149.97820073039404,
                -22.173760724227698
              ],
              [
                149.9904891233593,
                -22.162855706259023
              ],
              [
                150.00220788074932,
                -22.15862396243303
              ],
              [
                150.0178328731639,
                -22.155694247537003
              ],
              [
                150.05355880293482,
                -22.14153416059069
              ],
              [
                150.0579533262804,
                -22.149346632420023
              ],
              [
                150.07732182750533,
                -22.157321933671497
              ],
              [
                150.08155360228707,
                -22.162367520551847
              ],
              [
                150.083181178834,
                -22.17107510167715
              ],
              [
                150.10222413519296,
                -22.217461774418595
              ],
              [
                150.11060630173873,
                -22.232517132782746
              ],
              [
                150.1196395305388,
                -22.24488701921975
              ],
              [
                150.12940514739032,
                -22.25481537539776
              ],
              [
                150.13803144362234,
                -22.259047124307283
              ],
              [
                150.1469832506717,
                -22.261407092004713
              ],
              [
                150.15381921650985,
                -22.266290006750474
              ],
              [
                150.15658613916983,
                -22.27874116287932
              ],
              [
                150.15691166510928,
                -22.289483367896953
              ],
              [
                150.15796959030263,
                -22.29753994756574
              ],
              [
                150.15992273546763,
                -22.3041318181167
              ],
              [
                150.16342208029977,
                -22.310153937905035
              ],
              [
                150.18767337495177,
                -22.3268368541084
              ],
              [
                150.19336997299516,
                -22.33879968338639
              ],
              [
                150.17725668863864,
                -22.350518421202647
              ],
              [
                150.19402101781154,
                -22.37867599572947
              ],
              [
                150.21558678642657,
                -22.394789326176124
              ],
              [
                150.2998153004242,
                -22.41822682253607
              ],
              [
                150.31324304256924,
                -22.425388306402947
              ],
              [
                150.34107507420507,
                -22.44597750166665
              ],
              [
                150.35580488021105,
                -22.45403409930749
              ],
              [
                150.38705488228837,
                -22.4657528568196
              ],
              [
                150.4030867818369,
                -22.47389087158502
              ],
              [
                150.41244550438887,
                -22.48202888736779
              ],
              [
                150.43091881978668,
                -22.503350532640777
              ],
              [
                150.4441024154842,
                -22.514336866742227
              ],
              [
                150.46078534780446,
                -22.522393472904714
              ],
              [
                150.51295009597416,
                -22.535414428729247
              ],
              [
                150.53394612192005,
                -22.548272257253753
              ],
              [
                150.60914144917237,
                -22.610528171349745
              ],
              [
                150.61540775079982,
                -22.60369232601753
              ],
              [
                150.59913172359674,
                -22.58757909344349
              ],
              [
                150.58326254482273,
                -22.559014505021718
              ],
              [
                150.57488042379373,
                -22.53036881553664
              ],
              [
                150.58122806648922,
                -22.514336866742227
              ],
              [
                150.58122807876197,
                -22.508070634904247
              ],
              [
                150.54525801097049,
                -22.481377870101458
              ],
              [
                150.53451581137287,
                -22.42701584820071
              ],
              [
                150.54371177486644,
                -22.366957253256246
              ],
              [
                150.5676375562568,
                -22.32317470259709
              ],
              [
                150.5759383321907,
                -22.33025476221129
              ],
              [
                150.60173588049122,
                -22.34433361918403
              ],
              [
                150.6184188284179,
                -22.334405251080337
              ],
              [
                150.63624108840358,
                -22.342543250233895
              ],
              [
                150.64372804897639,
                -22.35662195940826
              ],
              [
                150.62907963755086,
                -22.36467869673678
              ],
              [
                150.63379965499163,
                -22.373630394519246
              ],
              [
                150.6350203803976,
                -22.381280211060634
              ],
              [
                150.6316024051699,
                -22.387627845515386
              ],
              [
                150.62281335731845,
                -22.392022431345108
              ],
              [
                150.634287948104,
                -22.39576585081156
              ],
              [
                150.6448673727621,
                -22.401787978353504
              ],
              [
                150.65479577654926,
                -22.409763306291268
              ],
              [
                150.6638289810714,
                -22.41936617677535
              ],
              [
                150.67066490884852,
                -22.412530201838237
              ],
              [
                150.6629337868337,
                -22.4000790225481
              ],
              [
                150.66065515522936,
                -22.384209934648137
              ],
              [
                150.66488691593764,
                -22.36882903739664
              ],
              [
                150.6775008302001,
                -22.358005406110074
              ],
              [
                150.6798608692194,
                -22.37981534931311
              ],
              [
                150.6858016384174,
                -22.403741178048573
              ],
              [
                150.6945093220899,
                -22.42506279804811
              ],
              [
                150.70476321686985,
                -22.439873955530352
              ],
              [
                150.71314537230788,
                -22.444431223860956
              ],
              [
                150.73991946131375,
                -22.45224372750124
              ],
              [
                150.74952231270728,
                -22.4535457614604
              ],
              [
                150.756195518152,
                -22.458754197977097
              ],
              [
                150.7597762494783,
                -22.47047295633193
              ],
              [
                150.75831138594245,
                -22.482354396003405
              ],
              [
                150.7495223116011,
                -22.487562684607962
              ],
              [
                150.72339928515075,
                -22.519952081541128
              ],
              [
                150.7058211535769,
                -22.528741120935916
              ],
              [
                150.69792727044018,
                -22.5046525676254
              ],
              [
                150.6901147954703,
                -22.49920018364582
              ],
              [
                150.67628014639763,
                -22.5065243556212
              ],
              [
                150.671641507181,
                -22.52060324941232
              ],
              [
                150.69109137200968,
                -22.535414428729247
              ],
              [
                150.67750084100533,
                -22.562676669510466
              ],
              [
                150.70386803054026,
                -22.55632901800999
              ],
              [
                150.71607506000382,
                -22.562676669510466
              ],
              [
                150.71924887883068,
                -22.580254761689638
              ],
              [
                150.71900474409355,
                -22.607110248585492
              ],
              [
                150.7226668247263,
                -22.623793090307323
              ],
              [
                150.73194417886776,
                -22.628106277557666
              ],
              [
                150.74333743000295,
                -22.622653882583187
              ],
              [
                150.7531844181505,
                -22.610528171349745
              ],
              [
                150.75717205468897,
                -22.599297725679147
              ],
              [
                150.7590438260671,
                -22.58611422702163
              ],
              [
                150.75945072466172,
                -22.559258749455385
              ],
              [
                150.76368252476368,
                -22.534763410916064
              ],
              [
                150.77344811244,
                -22.530205985989973
              ],
              [
                150.7829695732151,
                -22.54273845470263
              ],
              [
                150.7873641058257,
                -22.56959392501829
              ],
              [
                150.77979580868578,
                -22.626560295659456
              ],
              [
                150.78451582293192,
                -22.653008728885467
              ],
              [
                150.80713949794938,
                -22.65211346498123
              ],
              [
                150.81348715295948,
                -22.67180747154476
              ],
              [
                150.82642662027942,
                -22.697930566007727
              ],
              [
                150.82764734398907,
                -22.713555639569304
              ],
              [
                150.82325277163235,
                -22.733575027388532
              ],
              [
                150.80990645533396,
                -22.771742479033787
              ],
              [
                150.80494225005322,
                -22.812920817065184
              ],
              [
                150.79566487793213,
                -22.848321109012804
              ],
              [
                150.78972412935323,
                -22.897881678902788
              ],
              [
                150.7873641522558,
                -22.905938490658517
              ],
              [
                150.78687584140783,
                -22.91057706136948
              ],
              [
                150.78842208164312,
                -22.92254000933324
              ],
              [
                150.78736410670055,
                -22.926446143797065
              ],
              [
                150.78174889079693,
                -22.927992434767344
              ],
              [
                150.7656356516932,
                -22.925551175721196
              ],
              [
                150.7414656567794,
                -22.929131648973467
              ],
              [
                150.7365014967591,
                -22.93287525364815
              ],
              [
                150.74236085010023,
                -22.943129084749852
              ],
              [
                150.75074304851276,
                -22.950372050330376
              ],
              [
                150.76880941313843,
                -22.96184651549123
              ],
              [
                150.77369224931516,
                -22.966892168609814
              ],
              [
                150.77393643559472,
                -22.976983476429726
              ],
              [
                150.76929773978753,
                -22.986504878156747
              ],
              [
                150.7659611541461,
                -22.99553808936048
              ],
              [
                150.7702743181674,
                -23.0046527177685
              ],
              [
                150.77588954053135,
                -23.01148861511865
              ],
              [
                150.77865648175646,
                -23.01921978368511
              ],
              [
                150.77979578813802,
                -23.039157876651277
              ],
              [
                150.76099698021673,
                -23.120782294890876
              ],
              [
                150.7644148913708,
                -23.158868032606513
              ],
              [
                150.80095462149686,
                -23.179620044812342
              ],
              [
                150.79395588443222,
                -23.197849077155716
              ],
              [
                150.7946883330713,
                -23.213148648033346
              ],
              [
                150.80176844793834,
                -23.227146170916654
              ],
              [
                150.81397543080877,
                -23.241143397981656
              ],
              [
                150.8160913668658,
                -23.236749041485986
              ],
              [
                150.8195907104056,
                -23.232598632731023
              ],
              [
                150.82146241305313,
                -23.227471534065504
              ],
              [
                150.8390405710123,
                -23.248956022388153
              ],
              [
                150.83253011123767,
                -23.2759741046697
              ],
              [
                150.8117781656878,
                -23.299248869335813
              ],
              [
                150.78736408528226,
                -23.30933995239515
              ],
              [
                150.81421963537318,
                -23.411309633391554
              ],
              [
                150.84180747546304,
                -23.435316622476734
              ],
              [
                150.87582439525406,
                -23.475843941227225
              ],
              [
                150.88233483699852,
                -23.488864858886934
              ],
              [
                150.87224366982522,
                -23.500176636394016
              ],
              [
                150.8538518027191,
                -23.504001707573757
              ],
              [
                150.81397548519865,
                -23.502536812219066
              ],
              [
                150.81397547590367,
                -23.50920995780299
              ],
              [
                150.83692470005013,
                -23.51262794751517
              ],
              [
                150.8566186994635,
                -23.5199521263948
              ],
              [
                150.87037198383794,
                -23.532973059292217
              ],
              [
                150.87549887952508,
                -23.553399298314826
              ],
              [
                150.8857527858038,
                -23.571547085316197
              ],
              [
                150.90821370516167,
                -23.565362127667687
              ],
              [
                150.92969807741918,
                -23.550550920346126
              ],
              [
                150.93685956999775,
                -23.54273853662785
              ],
              [
                150.957285994309,
                -23.544691632403044
              ],
              [
                150.98601318992715,
                -23.56406006307748
              ],
              [
                151.01127742873754,
                -23.56650195997484
              ],
              [
                151.02744240971228,
                -23.579997288769412
              ],
              [
                151.0415325902486,
                -23.612799490781743
              ],
              [
                151.0698348306824,
                -23.62395598359588
              ],
              [
                151.10271509323263,
                -23.65327052246134
              ],
              [
                151.11468545654893,
                -23.665483043083746
              ],
              [
                151.12598716828123,
                -23.675388256633486
              ],
              [
                151.14340253538933,
                -23.70940519069053
              ],
              [
                151.15040127959074,
                -23.727715890908158
              ],
              [
                151.15406330687023,
                -23.752373823176562
              ],
              [
                151.15658612462127,
                -23.761895409979907
              ],
              [
                151.16089930930787,
                -23.770765963343646
              ],
              [
                151.174326992696,
                -23.790948088193733
              ],
              [
                151.17701257968878,
                -23.793226866165778
              ],
              [
                151.1871850572967,
                -23.804131654595714
              ],
              [
                151.2104598567074,
                -23.813165053384353
              ],
              [
                151.25277749590575,
                -23.823907013911388
              ],
              [
                151.26002039112217,
                -23.824314099883846
              ],
              [
                151.26954185399637,
                -23.82350022837636
              ],
              [
                151.27784259989852,
                -23.823907013911388
              ],
              [
                151.28142334444155,
                -23.8273250340721
              ],
              [
                151.2822371739244,
                -23.836114187464254
              ],
              [
                151.2846785417275,
                -23.844414839714517
              ],
              [
                151.28882894054902,
                -23.851739087750076
              ],
              [
                151.2944442325778,
                -23.858086930926174
              ],
              [
                151.29737386436724,
                -23.85702880676222
              ],
              [
                151.30567464635322,
                -23.85637776899851
              ],
              [
                151.31617273750336,
                -23.85735447586528
              ],
              [
                151.32488044726418,
                -23.861504954614873
              ],
              [
                151.33057699103054,
                -23.868910323321163
              ],
              [
                151.3395288069419,
                -23.887302227249826
              ],
              [
                151.34555095190757,
                -23.895928561924848
              ],
              [
                151.4036564474564,
                -23.94996510674257
              ],
              [
                151.42416425104665,
                -23.974786040152026
              ],
              [
                151.4360458045418,
                -23.99863058229124
              ],
              [
                151.44092857989736,
                -24.005547777182883
              ],
              [
                151.4482528312403,
                -24.009047234249678
              ],
              [
                151.4531356234261,
                -24.00302503180501
              ],
              [
                151.4580184629564,
                -23.994073298148194
              ],
              [
                151.46509848711048,
                -23.988457886181337
              ],
              [
                151.48096760375594,
                -23.988946091397885
              ],
              [
                151.49732508062982,
                -23.994561503451926
              ],
              [
                151.51197352604524,
                -24.003106449450684
              ],
              [
                151.53003993797682,
                -24.01816180756132
              ],
              [
                151.5372827286251,
                -24.021742383302907
              ],
              [
                151.5434676235045,
                -24.02695071270586
              ],
              [
                151.54761804782746,
                -24.036309544460355
              ],
              [
                151.5465600460852,
                -24.04241287066326
              ],
              [
                151.541758672198,
                -24.046075167398058
              ],
              [
                151.536468946608,
                -24.04924895796336
              ],
              [
                151.5340275172742,
                -24.053643414636745
              ],
              [
                151.53532964990322,
                -24.072849303720158
              ],
              [
                151.54029377668934,
                -24.08407955839823
              ],
              [
                151.55054770889635,
                -24.09140386182545
              ],
              [
                151.568125802083,
                -24.098321077527743
              ],
              [
                151.56885823373943,
                -24.093845196548116
              ],
              [
                151.5704858947107,
                -24.090997072869065
              ],
              [
                151.57252041115646,
                -24.088474320504012
              ],
              [
                151.57439216537026,
                -24.084649483418158
              ],
              [
                151.57154385573295,
                -24.07683697500602
              ],
              [
                151.58057699657033,
                -24.0575496656363
              ],
              [
                151.58179767611242,
                -24.043714953800436
              ],
              [
                151.58619227788762,
                -24.048109710119693
              ],
              [
                151.59253988733317,
                -24.052992372851698
              ],
              [
                151.59546955149497,
                -24.056735788195144
              ],
              [
                151.6222436401483,
                -24.050876412036708
              ],
              [
                151.6447046482323,
                -24.065036798323966
              ],
              [
                151.6666772409341,
                -24.085381643303844
              ],
              [
                151.69166095904637,
                -24.098321077527743
              ],
              [
                151.68295334591616,
                -24.06243263030112
              ],
              [
                151.67611738439578,
                -24.04664479127705
              ],
              [
                151.66374754761875,
                -24.030043083593398
              ],
              [
                151.65113368720213,
                -24.021417012961333
              ],
              [
                151.62142985826387,
                -24.006035982665335
              ],
              [
                151.61589604375908,
                -23.995863584588378
              ],
              [
                151.62378991915884,
                -23.984063438705377
              ],
              [
                151.641368059286,
                -23.978285493793884
              ],
              [
                151.66187588342356,
                -23.977715871162307
              ],
              [
                151.677989162811,
                -23.981622112642892
              ],
              [
                151.6906844573099,
                -23.991306300846958
              ],
              [
                151.7006942524142,
                -24.002618244013927
              ],
              [
                151.71306400491255,
                -24.01213960335919
              ],
              [
                151.7325952069905,
                -24.01637121941065
              ],
              [
                151.73259525165864,
                -24.022556259823187
              ],
              [
                151.7099715505144,
                -24.042738541659663
              ],
              [
                151.72103921364717,
                -24.058688913829293
              ],
              [
                151.73959392429103,
                -24.06340904306644
              ],
              [
                151.7394311750278,
                -24.05046962361894
              ],
              [
                151.74976648421477,
                -24.046075167398058
              ],
              [
                151.78044681465983,
                -24.022556259823187
              ],
              [
                151.78028405074642,
                -24.053155208405325
              ],
              [
                151.78614338729602,
                -24.08863685581146
              ],
              [
                151.79704835431667,
                -24.12118900010251
              ],
              [
                151.8113713362324,
                -24.142348062961098
              ],
              [
                151.83619227633713,
                -24.163506840358163
              ],
              [
                151.8518172277289,
                -24.171563325135338
              ],
              [
                151.86988362431157,
                -24.173435040102856
              ],
              [
                151.87574304600923,
                -24.17310966813452
              ],
              [
                151.87671956130998,
                -24.173435040102856
              ],
              [
                151.877696145347,
                -24.171644743231788
              ],
              [
                151.88347415686107,
                -24.165948180942245
              ],
              [
                151.88697346343673,
                -24.15984452942268
              ],
              [
                151.88754317613657,
                -24.153741179591808
              ],
              [
                151.88965906736738,
                -24.148614246526144
              ],
              [
                151.89771571682,
                -24.145440445566866
              ],
              [
                151.90007568297463,
                -24.155368639279114
              ],
              [
                151.90121499829417,
                -24.177910932972285
              ],
              [
                151.90398195010874,
                -24.187106975161974
              ],
              [
                151.91244554151388,
                -24.196465856550805
              ],
              [
                151.93336021938586,
                -24.21103280168479
              ],
              [
                151.93734781392166,
                -24.217868626949958
              ],
              [
                151.9409286010678,
                -24.235609693530034
              ],
              [
                152.00367273543336,
                -24.41041436303779
              ],
              [
                152.05860437191933,
                -24.513929973668667
              ],
              [
                152.08464606155192,
                -24.531670928719425
              ],
              [
                152.12305750673528,
                -24.59172948272496
              ],
              [
                152.15040123713564,
                -24.61907317234298
              ],
              [
                152.3061629877066,
                -24.724216497462407
              ],
              [
                152.32569419622388,
                -24.728285382215528
              ],
              [
                152.34595787128015,
                -24.730157135520404
              ],
              [
                152.40479576557175,
                -24.748711836593184
              ],
              [
                152.43946377756308,
                -24.77117290384058
              ],
              [
                152.46973721112587,
                -24.80559672209003
              ],
              [
                152.49146567640773,
                -24.847588756097778
              ],
              [
                152.49976645069867,
                -24.892754752162382
              ],
              [
                152.49976649685098,
                -24.978692389928465
              ],
              [
                152.50603270361032,
                -24.99944413718731
              ],
              [
                152.57781009229157,
                -25.09986744685778
              ],
              [
                152.58228600241947,
                -25.108819264352668
              ],
              [
                152.59213301024602,
                -25.12086354365943
              ],
              [
                152.63233483096067,
                -25.142754812953633
              ],
              [
                152.6369735019783,
                -25.160332935083943
              ],
              [
                152.63233482949323,
                -25.169121995669688
              ],
              [
                152.62549889364783,
                -25.173028251970056
              ],
              [
                152.60279381372797,
                -25.17457447035776
              ],
              [
                152.59888756681863,
                -25.17351653639329
              ],
              [
                152.5852970701599,
                -25.168389578542392
              ],
              [
                152.57862389369717,
                -25.167168877113763
              ],
              [
                152.57154381710595,
                -25.16936614723505
              ],
              [
                152.56788170865016,
                -25.174004820825
              ],
              [
                152.5677189484575,
                -25.17864349518322
              ],
              [
                152.57154381409296,
                -25.180840747426736
              ],
              [
                152.59620202010106,
                -25.183526303216155
              ],
              [
                152.61882571894543,
                -25.191013284678494
              ],
              [
                152.63746178559487,
                -25.201592707734477
              ],
              [
                152.6506453808072,
                -25.214288024263325
              ],
              [
                152.66211999093522,
                -25.228448183537804
              ],
              [
                152.677093946954,
                -25.241875911771512
              ],
              [
                152.69703209981736,
                -25.251885683177044
              ],
              [
                152.7463485013308,
                -25.258233323259354
              ],
              [
                152.77230878841996,
                -25.26458098342112
              ],
              [
                152.79639733057044,
                -25.273532805860782
              ],
              [
                152.81511478288257,
                -25.28386810533728
              ],
              [
                152.81706790229808,
                -25.271905198176984
              ],
              [
                152.81592858464603,
                -25.25855885966938
              ],
              [
                152.81771894787622,
                -25.24749114944318
              ],
              [
                152.82878665613345,
                -25.242282813289382
              ],
              [
                152.83570397000875,
                -25.247246997223236
              ],
              [
                152.8425399103019,
                -25.270928644873884
              ],
              [
                152.85328209895573,
                -25.276462503658628
              ],
              [
                152.90113366288418,
                -25.28386810533728
              ],
              [
                152.9138289743182,
                -25.28769297369841
              ],
              [
                152.91814212566305,
                -25.297295838688346
              ],
              [
                152.91814212408664,
                -25.32415130313002
              ],
              [
                152.9318140009696,
                -25.416680605487283
              ],
              [
                152.92603600705093,
                -25.423109641715403
              ],
              [
                152.88705489045876,
                -25.44459402642216
              ],
              [
                152.88013756845632,
                -25.453545838001116
              ],
              [
                152.87435957663507,
                -25.464939076046992
              ],
              [
                152.8703719383389,
                -25.475681240428447
              ],
              [
                152.89039146573475,
                -25.46851977216549
              ],
              [
                152.9441837915856,
                -25.43726979452346
              ],
              [
                152.96241296175498,
                -25.437432563563622
              ],
              [
                152.96908613596221,
                -25.452813414589983
              ],
              [
                152.9597274112963,
                -25.463311459689876
              ],
              [
                152.945648636981,
                -25.47039154248117
              ],
              [
                152.9386499333377,
                -25.475681240428447
              ],
              [
                152.94581139881996,
                -25.48650482969444
              ],
              [
                152.9589949858621,
                -25.490980720928086
              ],
              [
                152.96615644475628,
                -25.497246999469606
              ],
              [
                152.95573977949675,
                -25.513116142573246
              ],
              [
                152.91879316313194,
                -25.543715096716415
              ],
              [
                152.90503991031989,
                -25.560723566903285
              ],
              [
                152.89771569183964,
                -25.58489349036685
              ],
              [
                152.90951583283677,
                -25.644301073203945
              ],
              [
                152.90796960585132,
                -25.669610308777983
              ],
              [
                152.8840438265853,
                -25.674248985625407
              ],
              [
                152.89380943063856,
                -25.688164943035606
              ],
              [
                152.90837649601852,
                -25.69890715346625
              ],
              [
                152.9386499256408,
                -25.71591559411584
              ],
              [
                152.92432701334627,
                -25.721286701241162
              ],
              [
                152.9181421344483,
                -25.72210055090839
              ],
              [
                152.92701255309788,
                -25.740166889094084
              ],
              [
                152.94288169940188,
                -25.753187736879312
              ],
              [
                152.96265710459812,
                -25.760918899104176
              ],
              [
                152.98340904697852,
                -25.763604416610224
              ],
              [
                153.0212508602668,
                -25.825127899643903
              ],
              [
                153.0278426483104,
                -25.844821884886112
              ],
              [
                153.0341902870317,
                -25.885349181357032
              ],
              [
                153.0348413460001,
                -25.903578393977767
              ],
              [
                153.0330509644057,
                -25.907810119447344
              ],
              [
                153.02426190184673,
                -25.919610247946018
              ],
              [
                153.0212508415243,
                -25.92742276899978
              ],
              [
                153.0200301535526,
                -25.93743257614724
              ],
              [
                153.02125084116253,
                -25.969008055062027
              ],
              [
                153.0280053991623,
                -25.969008055062027
              ],
              [
                153.0573836511525,
                -25.915459869745423
              ],
              [
                153.0615340540009,
                -25.903578393977767
              ],
              [
                153.0605574899265,
                -25.871026305299743
              ],
              [
                153.0642195839199,
                -25.85279709696248
              ],
              [
                153.07520593253025,
                -25.838067336769786
              ],
              [
                153.0657658090116,
                -25.82268642288989
              ],
              [
                153.06153404969692,
                -25.817559502162272
              ],
              [
                153.07715903973485,
                -25.825290594657265
              ],
              [
                153.08399499258184,
                -25.83603282263887
              ],
              [
                153.08936608414228,
                -25.86541107189513
              ],
              [
                153.1100366428012,
                -25.917168844574327
              ],
              [
                153.1215926411504,
                -25.93377043320263
              ],
              [
                153.14893638731044,
                -25.943536047713412
              ],
              [
                153.1806746816291,
                -25.944756787115292
              ],
              [
                153.20557702944026,
                -25.934991172547946
              ],
              [
                153.20004316753642,
                -25.94890716592803
              ],
              [
                153.18213951280345,
                -25.975192950107644
              ],
              [
                153.17481530862517,
                -25.998142208470416
              ],
              [
                153.1565047548196,
                -26.03492604222387
              ],
              [
                153.1474715583534,
                -26.047621374645107
              ],
              [
                153.14177494934214,
                -26.061456024130855
              ],
              [
                153.13209068636232,
                -26.103936443482215
              ],
              [
                153.12671960224554,
                -26.113051054148443
              ],
              [
                153.11003665462215,
                -26.164239189984652
              ],
              [
                153.10743250137583,
                -26.179131804893967
              ],
              [
                153.07748459629198,
                -26.280857096344292
              ],
              [
                153.07406662220436,
                -26.316582994648467
              ],
              [
                153.07520594754794,
                -26.335056307784498
              ],
              [
                153.07976322021005,
                -26.351983339499576
              ],
              [
                153.08936606319585,
                -26.366306198267242
              ],
              [
                153.10352626483316,
                -26.373467776920844
              ],
              [
                153.1171981044942,
                -26.374444246522202
              ],
              [
                153.12916097745224,
                -26.378106307870038
              ],
              [
                153.13721764903664,
                -26.392998969288602
              ],
              [
                153.12240643581254,
                -26.423272367181244
              ],
              [
                153.11345462107653,
                -26.45745207594934
              ],
              [
                153.11003666814366,
                -26.646905240013254
              ],
              [
                153.11402426323448,
                -26.662774290744146
              ],
              [
                153.11703537219694,
                -26.671156560167013
              ],
              [
                153.11988366969018,
                -26.67490002302132
              ],
              [
                153.15088951226807,
                -26.68474698563347
              ],
              [
                153.14421636104927,
                -26.732842754963617
              ],
              [
                153.14405357462252,
                -26.750583573062222
              ],
              [
                153.15007573988845,
                -26.781833650611706
              ],
              [
                153.1551213067356,
                -26.793552384816493
              ],
              [
                153.16114344536322,
                -26.798272446076634
              ],
              [
                153.15211024381122,
                -26.80592218875095
              ],
              [
                153.14649495861673,
                -26.823907083993017
              ],
              [
                153.14380946441236,
                -26.844496411672985
              ],
              [
                153.14405361062012,
                -26.860446945858712
              ],
              [
                153.1440535758994,
                -26.85230883645957
              ],
              [
                153.14616944162762,
                -26.89177818856136
              ],
              [
                153.15251710830015,
                -26.92498134076092
              ],
              [
                153.20622803853823,
                -27.046075071629065
              ],
              [
                153.21021567517337,
                -27.077243708373786
              ],
              [
                153.19174239876796,
                -27.099297820919624
              ],
              [
                153.1545516336246,
                -27.084242457576963
              ],
              [
                153.116547075187,
                -27.0899390704798
              ],
              [
                153.08220464409598,
                -27.110446925733697
              ],
              [
                153.0553491300821,
                -27.14031334683848
              ],
              [
                153.04786219055055,
                -27.152276338760455
              ],
              [
                153.03842209077985,
                -27.173435203228625
              ],
              [
                153.0382592808427,
                -27.19345461005388
              ],
              [
                153.0583602086944,
                -27.20232509495917
              ],
              [
                153.07992599325937,
                -27.20338311136667
              ],
              [
                153.09107504077454,
                -27.202569206373997
              ],
              [
                153.0993758168752,
                -27.19890708419454
              ],
              [
                153.11280360837776,
                -27.191013344532667
              ],
              [
                153.1174422573205,
                -27.19695404224548
              ],
              [
                153.11361736208173,
                -27.242364136751224
              ],
              [
                153.1038517836126,
                -27.254164381868346
              ],
              [
                153.08912193970687,
                -27.26165129680328
              ],
              [
                153.0720320770622,
                -27.274672083756226
              ],
              [
                153.06137126977782,
                -27.294528854122944
              ],
              [
                153.06495200573062,
                -27.310479392310267
              ],
              [
                153.07634522789672,
                -27.323011927523766
              ],
              [
                153.0893661049532,
                -27.332126616447287
              ],
              [
                153.10914145140117,
                -27.340508671379727
              ],
              [
                153.15113364632242,
                -27.35222743842626
              ],
              [
                153.16797936618676,
                -27.363702088814964
              ],
              [
                153.177500848032,
                -27.382500911527163
              ],
              [
                153.18409266411794,
                -27.428399396099568
              ],
              [
                153.19174237862475,
                -27.449395427901774
              ],
              [
                153.20777429138255,
                -27.46502045653341
              ],
              [
                153.22380620377746,
                -27.468194312251494
              ],
              [
                153.23845463811148,
                -27.467868784762747
              ],
              [
                153.25049888834064,
                -27.472751546237657
              ],
              [
                153.26026452845346,
                -27.48406343196775
              ],
              [
                153.2683211727358,
                -27.496270471913583
              ],
              [
                153.28126062957108,
                -27.523858371139745
              ],
              [
                153.28353930712203,
                -27.532810270488984
              ],
              [
                153.28394620850506,
                -27.5397275893574
              ],
              [
                153.2854924159663,
                -27.54656348630324
              ],
              [
                153.30453532994653,
                -27.570244996765624
              ],
              [
                153.3076278237845,
                -27.57805760737899
              ],
              [
                153.31080166640032,
                -27.640313498823872
              ],
              [
                153.3154403168055,
                -27.654880507318186
              ],
              [
                153.32447350169906,
                -27.66692473248473
              ],
              [
                153.34546957964758,
                -27.686700086471866
              ],
              [
                153.34945721196664,
                -27.698907123053967
              ],
              [
                153.35043379554784,
                -27.700941678263273
              ],
              [
                153.35629322008518,
                -27.723077212480653
              ],
              [
                153.3619898355739,
                -27.73211041655707
              ],
              [
                153.36695398725402,
                -27.736423471372078
              ],
              [
                153.37183683552385,
                -27.739190483443277
              ],
              [
                153.39991297353674,
                -27.766208631338852
              ],
              [
                153.40984138157322,
                -27.7819150660295
              ],
              [
                153.4078881619761,
                -27.7950984353782
              ],
              [
                153.4018661008395,
                -27.80917738668034
              ],
              [
                153.4114689448207,
                -27.815606375204595
              ],
              [
                153.42709388469189,
                -27.810723420638976
              ],
              [
                153.43897545010523,
                -27.79143643963136
              ],
              [
                153.44581138710498,
                -27.79143643963136
              ],
              [
                153.4455672722004,
                -27.810479468148426
              ],
              [
                153.43213953186466,
                -27.86028414339424
              ],
              [
                153.43018636290014,
                -27.878513205615373
              ],
              [
                153.43213956937075,
                -27.935316783381428
              ],
              [
                153.41830494731033,
                -27.90878686608331
              ],
              [
                153.4090275686687,
                -27.917901367470055
              ],
              [
                153.40219159000173,
                -27.934991115795405
              ],
              [
                153.39991291612372,
                -27.95419677703879
              ],
              [
                153.404063283634,
                -27.97014724541212
              ],
              [
                153.41334075317909,
                -27.976169674734226
              ],
              [
                153.42204834815004,
                -27.969008012731035
              ],
              [
                153.43018641733414,
                -27.957207995756548
              ],
              [
                153.43897544236876,
                -27.948988505647748
              ],
              [
                153.44507890990656,
                -27.980889435544412
              ],
              [
                153.4494734774157,
                -28.073174676126477
              ],
              [
                153.46273847552996,
                -28.092461843583244
              ],
              [
                153.48226976660038,
                -28.110528344908822
              ],
              [
                153.50521897138412,
                -28.147719066753858
              ],
              [
                153.50652108549508,
                -28.149265360433713
              ],
              [
                153.53199299012533,
                -28.177910962367893
              ],
              [
                153.56251067163655,
                -28.174981513413435
              ],
              [
                153.5705673056893,
                -28.193780325208674
              ],
              [
                153.58122803265883,
                -28.246758656880573
              ],
              [
                153.59107512665284,
                -28.268487377144673
              ],
              [
                153.59083087197527,
                -28.318535944771277
              ],
              [
                153.56348715143463,
                -28.460869996634074
              ],
              [
                153.56251067478308,
                -28.504571361499647
              ],
              [
                153.57601969578855,
                -28.589613469937333
              ],
              [
                153.58423910750665,
                -28.608086798814924
              ],
              [
                153.6209415882804,
                -28.644463769324894
              ],
              [
                153.63062582628146,
                -28.66155359773241
              ],
              [
                153.6290796420432,
                -28.667250300510094
              ],
              [
                153.6198836401681,
                -28.68661870378358
              ],
              [
                153.61695403098653,
                -28.69573346243552
              ],
              [
                153.61752366465507,
                -28.705824545260093
              ],
              [
                153.61963952370323,
                -28.717543237464106
              ],
              [
                153.6196395462874,
                -28.72958755866376
              ],
              [
                153.60132897511355,
                -28.76140716590797
              ],
              [
                153.60010831000378,
                -28.783379906842466
              ],
              [
                153.61011801365947,
                -28.82610437785776
              ],
              [
                153.60596764847216,
                -28.867445580852245
              ],
              [
                153.5822860630938,
                -28.89609153395953
              ],
              [
                153.52133217479994,
                -28.943454570514387
              ],
              [
                153.47559651632392,
                -29.000176617394683
              ],
              [
                153.45378670868473,
                -29.03557719808125
              ],
              [
                153.43897543079052,
                -29.07301191997401
              ],
              [
                153.43620858931905,
                -29.08513775696446
              ],
              [
                153.43555751197334,
                -29.093845362090384
              ],
              [
                153.44507902335883,
                -29.14006938025166
              ],
              [
                153.44581139871843,
                -29.1516252682129
              ],
              [
                153.4414168799859,
                -29.155368784758306
              ],
              [
                153.4226994612771,
                -29.16106546312131
              ],
              [
                153.41830482641328,
                -29.164971488437992
              ],
              [
                153.41521236795165,
                -29.175957793911547
              ],
              [
                153.37086018431265,
                -29.241631687861283
              ],
              [
                153.35059654420002,
                -29.28101977754287
              ],
              [
                153.34034262181729,
                -29.322686408482067
              ],
              [
                153.3494571840461,
                -29.361097823221435
              ],
              [
                153.3667098748224,
                -29.382745141359493
              ],
              [
                153.36996505172544,
                -29.396661090992623
              ],
              [
                153.3601180651833,
                -29.41204198927625
              ],
              [
                153.35645591176987,
                -29.424004787846812
              ],
              [
                153.35759531372452,
                -29.443129304685517
              ],
              [
                153.3608504790924,
                -29.461521138896842
              ],
              [
                153.36378009237706,
                -29.470391424480432
              ],
              [
                153.35206142898298,
                -29.49000423912946
              ],
              [
                153.3440047058703,
                -29.535414219302048
              ],
              [
                153.32748454378788,
                -29.56503665960313
              ],
              [
                153.32447345092186,
                -29.575860172120457
              ],
              [
                153.32227626152655,
                -29.597588849521852
              ],
              [
                153.3232527528197,
                -29.602634273720543
              ],
              [
                153.3278914814119,
                -29.612074496792435
              ],
              [
                153.32911223182074,
                -29.618096732442933
              ],
              [
                153.32699629023634,
                -29.624444269496518
              ],
              [
                153.31771900915112,
                -29.63518658861598
              ],
              [
                153.31544024736098,
                -29.642266423507003
              ],
              [
                153.3178816667924,
                -29.666599132732816
              ],
              [
                153.32300868589638,
                -29.682305651217774
              ],
              [
                153.32162521142175,
                -29.697523728256733
              ],
              [
                153.29639740249806,
                -29.735040119132016
              ],
              [
                153.29118905883615,
                -29.75318788482646
              ],
              [
                153.2884220884299,
                -29.771254201295758
              ],
              [
                153.2880965197682,
                -29.785739779102645
              ],
              [
                153.29493250742658,
                -29.82659274631124
              ],
              [
                153.29078211262856,
                -29.835544561412853
              ],
              [
                153.27670330214377,
                -29.850762588926656
              ],
              [
                153.2737736235064,
                -29.857354403263972
              ],
              [
                153.2714950347312,
                -29.901625354529596
              ],
              [
                153.26734459622827,
                -29.924248954408
              ],
              [
                153.26010173304397,
                -29.943291871519467
              ],
              [
                153.22445719465918,
                -29.98691165052945
              ],
              [
                153.21989993596583,
                -30.00139739392968
              ],
              [
                153.21656334700117,
                -30.007256769002304
              ],
              [
                153.20240319077442,
                -30.02467213253724
              ],
              [
                153.19922936319085,
                -30.03582122239085
              ],
              [
                153.20004316402168,
                -30.04656340699633
              ],
              [
                153.2055770183473,
                -30.073663017665226
              ],
              [
                153.20378665447214,
                -30.12916431992427
              ],
              [
                153.18962649539085,
                -30.174981372697836
              ],
              [
                153.13721764126012,
                -30.257989185458385
              ],
              [
                153.14649498940767,
                -30.28606536584171
              ],
              [
                153.13209068438647,
                -30.323825765676638
              ],
              [
                153.08936607653953,
                -30.38892993503914
              ],
              [
                153.08253015321728,
                -30.40642670948275
              ],
              [
                153.0754500661035,
                -30.438409113207044
              ],
              [
                153.0505477244857,
                -30.473321226965567
              ],
              [
                153.04314211517243,
                -30.49382901838077
              ],
              [
                153.0230703889191,
                -30.575506193797352
              ],
              [
                153.0180770371755,
                -30.63307060697752
              ],
              [
                153.00798585759,
                -30.651625227527074
              ],
              [
                153.01099694222304,
                -30.65536875041789
              ],
              [
                152.98779636620696,
                -30.734633820375553
              ],
              [
                152.99985922139916,
                -30.75112151954824
              ],
              [
                153.0050014272299,
                -30.835814284709798
              ],
              [
                153.0275171141091,
                -30.8755835746456
              ],
              [
                153.0348413333197,
                -30.882500892064012
              ],
              [
                153.04314213953816,
                -30.887953415254884
              ],
              [
                153.05453536853116,
                -30.89299898822967
              ],
              [
                153.0646265054367,
                -30.8934872524974
              ],
              [
                153.06885825174655,
                -30.885511943350505
              ],
              [
                153.07211347174248,
                -30.88193123774439
              ],
              [
                153.0791121826339,
                -30.88591889288666
              ],
              [
                153.0862736389679,
                -30.894707950682577
              ],
              [
                153.08936606338597,
                -30.905694232743535
              ],
              [
                153.08790122417196,
                -30.926690336097355
              ],
              [
                153.08570397087462,
                -30.935153901811578
              ],
              [
                153.08187909343582,
                -30.943942950353886
              ],
              [
                153.06332724103788,
                -30.959593066767173
              ],
              [
                153.046599177905,
                -30.992753991325845
              ],
              [
                153.03987998978567,
                -31.02996517073797
              ],
              [
                153.04592386084755,
                -31.046572880302865
              ],
              [
                153.0578921722031,
                -31.051637438730914
              ],
              [
                153.06091909447483,
                -31.06058325101667
              ],
              [
                153.05950070974856,
                -31.07720995629031
              ],
              [
                153.04163113656332,
                -31.09010264551624
              ],
              [
                153.00888016288496,
                -31.122248215450604
              ],
              [
                152.98061502806567,
                -31.165914731152853
              ],
              [
                152.979218273132,
                -31.19924544157293
              ],
              [
                152.959894004218,
                -31.240315276715627
              ],
              [
                152.97041188954526,
                -31.25567657915905
              ],
              [
                152.97673588360044,
                -31.3200009291926
              ],
              [
                152.9325891159458,
                -31.36600788442139
              ],
              [
                152.91782828358464,
                -31.39525435867967
              ],
              [
                152.9164353849459,
                -31.420656599734937
              ],
              [
                152.9343544634478,
                -31.4383920880888
              ],
              [
                152.93887446851926,
                -31.45486949248774
              ],
              [
                152.940381092968,
                -31.462483729552783
              ],
              [
                152.93450209236332,
                -31.482810554018496
              ],
              [
                152.90629780506382,
                -31.505727649818184
              ],
              [
                152.87658742888476,
                -31.532446136360278
              ],
              [
                152.8453807336156,
                -31.569318615563912
              ],
              [
                152.84991512560475,
                -31.599780187916473
              ],
              [
                152.83656194837468,
                -31.62519614969098
              ],
              [
                152.84853262194673,
                -31.64422020193088
              ],
              [
                152.83214698770178,
                -31.655679038752137
              ],
              [
                152.81278823277773,
                -31.67603154574654
              ],
              [
                152.78894859710803,
                -31.704008685207334
              ],
              [
                152.80390150892774,
                -31.719226954674053
              ],
              [
                152.80092903898853,
                -31.73320814069326
              ],
              [
                152.77554756829088,
                -31.754852573492414
              ],
              [
                152.74418546733466,
                -31.793022684715638
              ],
              [
                152.7367282313935,
                -31.827349147306148
              ],
              [
                152.7472150451009,
                -31.84258473946547
              ],
              [
                152.71577587030743,
                -31.859170112607465
              ],
              [
                152.69288169052084,
                -31.885349186476464
              ],
              [
                152.664317281395,
                -31.90349705370416
              ],
              [
                152.60925508568124,
                -31.945848249478377
              ],
              [
                152.54637267055602,
                -32.04367919866603
              ],
              [
                152.55534571532817,
                -32.07163087523844
              ],
              [
                152.52833093211297,
                -32.097100532047484
              ],
              [
                152.5202742877368,
                -32.11581797201566
              ],
              [
                152.5153100933695,
                -32.13648854250725
              ],
              [
                152.51008296186484,
                -32.16188142161147
              ],
              [
                152.51695272612554,
                -32.177392269832815
              ],
              [
                152.53567897608198,
                -32.183199574767
              ],
              [
                152.54538155533868,
                -32.196888191217994
              ],
              [
                152.56478720439944,
                -32.20602141237624
              ],
              [
                152.56950930406217,
                -32.21933357935443
              ],
              [
                152.55665119902713,
                -32.23202883300364
              ],
              [
                152.5465600610523,
                -32.24627038465912
              ],
              [
                152.53998828225951,
                -32.25979710658203
              ],
              [
                152.5335154728335,
                -32.26890790241757
              ],
              [
                152.52595709301963,
                -32.281664543954406
              ],
              [
                152.52487138275873,
                -32.294425570884876
              ],
              [
                152.52704289172695,
                -32.31266081135651
              ],
              [
                152.53997670433648,
                -32.31448869417668
              ],
              [
                152.55445395054497,
                -32.32122157408721
              ],
              [
                152.5520125322366,
                -32.3280574887835
              ],
              [
                152.54835046368848,
                -32.33212657212465
              ],
              [
                152.54420004943125,
                -32.33570725996879
              ],
              [
                152.5407821358029,
                -32.34172949531148
              ],
              [
                152.53663172868713,
                -32.35458753727359
              ],
              [
                152.53394613936456,
                -32.3695614186575
              ],
              [
                152.5248349541452,
                -32.38830530315112
              ],
              [
                152.5204991840999,
                -32.41017643666067
              ],
              [
                152.5215599316218,
                -32.42749400054533
              ],
              [
                152.53988626429822,
                -32.442091883836746
              ],
              [
                152.4023935556486,
                -32.489428605579
              ],
              [
                152.35355989860327,
                -32.51492337786894
              ],
              [
                152.29476393090127,
                -32.559588950492596
              ],
              [
                152.2859295957443,
                -32.588803930053814
              ],
              [
                152.26417424377067,
                -32.5942562091109
              ],
              [
                152.23586186103924,
                -32.6069991473137
              ],
              [
                152.21066996749735,
                -32.63073868612261
              ],
              [
                152.19198878255963,
                -32.6526703180184
              ],
              [
                152.1875008090691,
                -32.66913586464416
              ],
              [
                152.20372078349314,
                -32.68653599453825
              ],
              [
                152.21924885082686,
                -32.697198097939676
              ],
              [
                152.20557693886767,
                -32.697930453963046
              ],
              [
                152.20215910980096,
                -32.69589619875763
              ],
              [
                152.19410242989304,
                -32.68718844452997
              ],
              [
                152.19068444469798,
                -32.68425872860576
              ],
              [
                152.1860458110118,
                -32.68352637505215
              ],
              [
                152.1753035765849,
                -32.6851538943261
              ],
              [
                152.17074629369748,
                -32.68425872860576
              ],
              [
                152.1452742036757,
                -32.66659907156138
              ],
              [
                152.13672928862832,
                -32.66375077596954
              ],
              [
                152.1352644520229,
                -32.66668047721206
              ],
              [
                152.11670977338648,
                -32.68010822622438
              ],
              [
                152.10938561669613,
                -32.68425872860576
              ],
              [
                152.06088292894378,
                -32.697930453963046
              ],
              [
                152.08676188736405,
                -32.71591557367324
              ],
              [
                152.09229569623605,
                -32.71843827914541
              ],
              [
                152.16732824820008,
                -32.71843827914541
              ],
              [
                152.1779891203913,
                -32.72063565964706
              ],
              [
                152.19019615853298,
                -32.725274344384296
              ],
              [
                152.1977645277195,
                -32.72991303454132
              ],
              [
                152.19483490909073,
                -32.732110421394005
              ],
              [
                152.19092864341357,
                -32.736586305433235
              ],
              [
                152.1894636888322,
                -32.75855876447741
              ],
              [
                152.18506919364498,
                -32.766778229235534
              ],
              [
                152.1748152441467,
                -32.76921955961721
              ],
              [
                152.15015711355198,
                -32.766045860460885
              ],
              [
                152.14014729282488,
                -32.77019615228075
              ],
              [
                152.13119548117496,
                -32.78085697950232
              ],
              [
                152.12761483436134,
                -32.78655374067865
              ],
              [
                152.1225692771059,
                -32.79013449766263
              ],
              [
                152.109385610719,
                -32.794121998944114
              ],
              [
                152.0594287823729,
                -32.78525391470613
              ],
              [
                151.98492689379427,
                -32.79874575132034
              ],
              [
                151.93518796717498,
                -32.81582893105109
              ],
              [
                151.87566254933347,
                -32.842087997635
              ],
              [
                151.85621919027966,
                -32.855858813756974
              ],
              [
                151.83403304841443,
                -32.8649670889029
              ],
              [
                151.79923728275625,
                -32.89368023392467
              ],
              [
                151.8035587520525,
                -32.91936607678734
              ],
              [
                151.78785235184031,
                -32.9318985930369
              ],
              [
                151.7725070225966,
                -32.945608468126274
              ],
              [
                151.7488629519721,
                -32.95702324098864
              ],
              [
                151.73763497558403,
                -32.97200186379993
              ],
              [
                151.7360350996164,
                -32.993997064703336
              ],
              [
                151.73438553050002,
                -33.01482498245395
              ],
              [
                151.72053511860824,
                -33.019371211476596
              ],
              [
                151.70380015431377,
                -33.028521368402515
              ],
              [
                151.68148842429358,
                -33.04998128513368
              ],
              [
                151.67058356833112,
                -33.06113053450791
              ],
              [
                151.66700286462893,
                -33.07333761176187
              ],
              [
                151.66568859678523,
                -33.087343075447244
              ],
              [
                151.65291510386803,
                -33.11043288973293
              ],
              [
                151.64673908077626,
                -33.144707856379675
              ],
              [
                151.6349390814298,
                -33.158624102316054
              ],
              [
                151.62956791318504,
                -33.1742489703449
              ],
              [
                151.6259872586156,
                -33.19158308743143
              ],
              [
                151.61226343697678,
                -33.207550918209115
              ],
              [
                151.58999430919894,
                -33.21893716262458
              ],
              [
                151.56895271734055,
                -33.244224757423964
              ],
              [
                151.5631809664829,
                -33.26500984081892
              ],
              [
                151.57601981171334,
                -33.2824847807953
              ],
              [
                151.56895726964913,
                -33.292227876475344
              ],
              [
                151.53068561114827,
                -33.31911867476186
              ],
              [
                151.51534112138674,
                -33.327082337773334
              ],
              [
                151.51546263565064,
                -33.31666612570044
              ],
              [
                151.5322588488804,
                -33.302928824277124
              ],
              [
                151.54086734198145,
                -33.27754188973156
              ],
              [
                151.5161095958678,
                -33.26110950967343
              ],
              [
                151.4910196195731,
                -33.27361149800476
              ],
              [
                151.45379510099747,
                -33.30419880765718
              ],
              [
                151.45272660904484,
                -33.311514968144095
              ],
              [
                151.46973724668817,
                -33.32822043490225
              ],
              [
                151.45639236243076,
                -33.33108821329702
              ],
              [
                151.4427035936767,
                -33.33421558218531
              ],
              [
                151.4440210213385,
                -33.34563565991808
              ],
              [
                151.45122802902029,
                -33.35546038794798
              ],
              [
                151.459956608892,
                -33.359611420712376
              ],
              [
                151.47454555038428,
                -33.363001114765325
              ],
              [
                151.48835678677014,
                -33.34929093556151
              ],
              [
                151.49529355497643,
                -33.3395864081971
              ],
              [
                151.504995182933,
                -33.34374342714399
              ],
              [
                151.50382947641094,
                -33.360010119672495
              ],
              [
                151.48999988025957,
                -33.374533976373925
              ],
              [
                151.48584626534782,
                -33.3940244231203
              ],
              [
                151.45722742961453,
                -33.419805379569254
              ],
              [
                151.44530033769095,
                -33.43597155358997
              ],
              [
                151.45199783590192,
                -33.44498595270635
              ],
              [
                151.45091024593148,
                -33.4531143205803
              ],
              [
                151.43906543821265,
                -33.46358451570374
              ],
              [
                151.44275997785525,
                -33.47826965723873
              ],
              [
                151.44752150525605,
                -33.48645370953409
              ],
              [
                151.4415958873008,
                -33.49128338757513
              ],
              [
                151.42787569452767,
                -33.49441393934288
              ],
              [
                151.43246510406982,
                -33.5095355257621
              ],
              [
                151.43002361819222,
                -33.515069241678106
              ],
              [
                151.42888425353297,
                -33.521742346703356
              ],
              [
                151.42416429962222,
                -33.52776465117406
              ],
              [
                151.41431727371238,
                -33.532891568047255
              ],
              [
                151.40699310660773,
                -33.534600642678015
              ],
              [
                151.38648524896192,
                -33.53394952357504
              ],
              [
                151.38005612727096,
                -33.53679768255709
              ],
              [
                151.3626819065677,
                -33.532103435019216
              ],
              [
                151.35371742644318,
                -33.541796315583696
              ],
              [
                151.34310956156924,
                -33.54827237771426
              ],
              [
                151.32056725046982,
                -33.55136483590373
              ],
              [
                151.30876706700045,
                -33.54762125527196
              ],
              [
                151.28288822317654,
                -33.562107039663665
              ],
              [
                151.2664494627606,
                -33.56121192947057
              ],
              [
                151.25554448308668,
                -33.54680757779709
              ],
              [
                151.2459416755209,
                -33.52109153119305
              ],
              [
                151.23072351097096,
                -33.53492605205376
              ],
              [
                151.22681722307655,
                -33.554864137573844
              ],
              [
                151.23406012700926,
                -33.57333755843315
              ],
              [
                151.25277759392554,
                -33.58245217403794
              ],
              [
                151.2480574160336,
                -33.59010169687323
              ],
              [
                151.24195400263974,
                -33.595879868835695
              ],
              [
                151.234548407828,
                -33.59986750605035
              ],
              [
                151.22559654268952,
                -33.60222745939568
              ],
              [
                151.225596511983,
                -33.609063343473146
              ],
              [
                151.24952239157489,
                -33.606377965679705
              ],
              [
                151.28164070384096,
                -33.572901870142175
              ],
              [
                151.29933816353,
                -33.57062427321549
              ],
              [
                151.3099926184858,
                -33.578874712187236
              ],
              [
                151.29873641832057,
                -33.60648944320768
              ],
              [
                151.29150196648143,
                -33.63653296232091
              ],
              [
                151.2952597393272,
                -33.64878003753493
              ],
              [
                151.30909439022835,
                -33.63753356762475
              ],
              [
                151.31712319298978,
                -33.622148027061904
              ],
              [
                151.3254715385983,
                -33.59205840141248
              ],
              [
                151.3407529730287,
                -33.61746564623647
              ],
              [
                151.32134203589865,
                -33.667817538195514
              ],
              [
                151.3091786306652,
                -33.69297282361994
              ],
              [
                151.30567465844135,
                -33.72014736561113
              ],
              [
                151.3044539739232,
                -33.72616953229624
              ],
              [
                151.31177814176235,
                -33.73609783064674
              ],
              [
                151.3176375975655,
                -33.74675877605045
              ],
              [
                151.31714928072196,
                -33.75750090167776
              ],
              [
                151.3087670553959,
                -33.781019674402366
              ],
              [
                151.3046981053349,
                -33.82537198991757
              ],
              [
                151.29175871861588,
                -33.82984801503043
              ],
              [
                151.2791447351849,
                -33.8275692829704
              ],
              [
                151.26636802340357,
                -33.82838305120548
              ],
              [
                151.25277749277356,
                -33.84246176642841
              ],
              [
                151.2469182393305,
                -33.85637798974241
              ],
              [
                151.24732510703902,
                -33.86728287994376
              ],
              [
                151.25473061023422,
                -33.874200034693104
              ],
              [
                151.26986729845677,
                -33.87664138828609
              ],
              [
                151.2801213527079,
                -33.8707008858359
              ],
              [
                151.28467862859065,
                -33.86012143141001
              ],
              [
                151.28785248435062,
                -33.85637798974241
              ],
              [
                151.29444413320869,
                -33.87037513229094
              ],
              [
                151.2924910496359,
                -33.89177819791471
              ],
              [
                151.27369230584995,
                -33.93743263809153
              ],
              [
                151.28142342751468,
                -33.952325220555906
              ],
              [
                151.26742602556504,
                -33.98170346536018
              ],
              [
                151.26026452808284,
                -33.99260834639691
              ],
              [
                151.24935954269773,
                -34.0038387520416
              ],
              [
                151.24170991431205,
                -33.99863060651544
              ],
              [
                151.21314545254418,
                -33.96672954984515
              ],
              [
                151.20191498158505,
                -33.95916118756725
              ],
              [
                151.18230232032622,
                -33.96347428547915
              ],
              [
                151.17790779666925,
                -33.97380958561317
              ],
              [
                151.17603599858901,
                -33.987481368820234
              ],
              [
                151.16407309428544,
                -34.000746320265925
              ],
              [
                151.14535573951784,
                -34.00367616635833
              ],
              [
                151.12468510251261,
                -34.000420848830764
              ],
              [
                151.10629321998096,
                -34.00090920626498
              ],
              [
                151.0952254804993,
                -34.01441826684236
              ],
              [
                151.12549884794083,
                -34.02044028494277
              ],
              [
                151.13266039816313,
                -34.02410255021742
              ],
              [
                151.1435652955739,
                -34.032810146503586
              ],
              [
                151.14918050788475,
                -34.03199630607671
              ],
              [
                151.16032964806286,
                -34.01751071746955
              ],
              [
                151.2214460874246,
                -34.02499753110707
              ],
              [
                151.2322697731935,
                -34.02410255021742
              ],
              [
                151.2312117888054,
                -34.040459900438975
              ],
              [
                151.22584075612247,
                -34.04705180116774
              ],
              [
                151.17969806471785,
                -34.04794679129886
              ],
              [
                151.17554777418152,
                -34.04664487830632
              ],
              [
                151.17237384572022,
                -34.04794679129886
              ],
              [
                151.16407307675846,
                -34.05478274868466
              ],
              [
                151.1584577953522,
                -34.06259516852141
              ],
              [
                151.1550398490094,
                -34.07089598887625
              ],
              [
                151.14918062182625,
                -34.07830183776715
              ],
              [
                151.13607837376588,
                -34.08269631118442
              ],
              [
                151.14682055936154,
                -34.08603289510277
              ],
              [
                151.17042081936953,
                -34.08603289510277
              ],
              [
                151.1770125169186,
                -34.08953207608894
              ],
              [
                151.17709395363923,
                -34.10035573989869
              ],
              [
                151.1689558627842,
                -34.110121246985884
              ],
              [
                151.15040132574848,
                -34.12428165604143
              ],
              [
                151.11286096194164,
                -34.14947013878478
              ],
              [
                151.09611740819648,
                -34.16293833989046
              ],
              [
                151.0683571427629,
                -34.17511124807641
              ],
              [
                151.0279573754678,
                -34.20079594698695
              ],
              [
                151.0096859699117,
                -34.21991706181908
              ],
              [
                150.96895251239758,
                -34.26267518794951
              ],
              [
                150.9406284374812,
                -34.30215918598682
              ],
              [
                150.92491818255826,
                -34.33041897408131
              ],
              [
                150.92827483874336,
                -34.36348691441852
              ],
              [
                150.90805030039783,
                -34.40764127471884
              ],
              [
                150.90304958364385,
                -34.45086087742304
              ],
              [
                150.9188675263698,
                -34.4864041515791
              ],
              [
                150.89777925202222,
                -34.50208129884568
              ],
              [
                150.88721763708773,
                -34.53020597650907
              ],
              [
                150.8733015397559,
                -34.54550531872049
              ],
              [
                150.85499117137226,
                -34.541436604534226
              ],
              [
                150.8670353238545,
                -34.5225562011913
              ],
              [
                150.86085051224364,
                -34.51327899591302
              ],
              [
                150.84815513098923,
                -34.510511955348605
              ],
              [
                150.84131929321256,
                -34.51067488147211
              ],
              [
                150.83513430428542,
                -34.51376717382663
              ],
              [
                150.80095463267395,
                -34.54827241007912
              ],
              [
                150.80583744160174,
                -34.557224226307
              ],
              [
                150.81218506959516,
                -34.56121180978237
              ],
              [
                150.82032311100357,
                -34.562107025683844
              ],
              [
                150.8420515519275,
                -34.56169999999974
              ],
              [
                150.8549911193933,
                -34.569919591076086
              ],
              [
                150.8823349196709,
                -34.592217851386195
              ],
              [
                150.89722743839312,
                -34.60116957606341
              ],
              [
                150.91700284372624,
                -34.60344824746291
              ],
              [
                150.88363690871924,
                -34.60702889359057
              ],
              [
                150.87045338519772,
                -34.62672302132313
              ],
              [
                150.84791091486025,
                -34.75172276807013
              ],
              [
                150.83375077182913,
                -34.782403129231874
              ],
              [
                150.8105575388174,
                -34.795180029641216
              ],
              [
                150.77930751068013,
                -34.80689873332021
              ],
              [
                150.75342866009402,
                -34.85808697527148
              ],
              [
                150.7286889378135,
                -34.86980549817039
              ],
              [
                150.72706141712848,
                -34.87411878597207
              ],
              [
                150.73878016505418,
                -34.883721647550935
              ],
              [
                150.75407967509463,
                -34.89332456244993
              ],
              [
                150.76319419495238,
                -34.897637608242675
              ],
              [
                150.77849373822926,
                -34.901625343629526
              ],
              [
                150.7768660979947,
                -34.91008882621481
              ],
              [
                150.76400806711206,
                -34.91741311422562
              ],
              [
                150.7457789053063,
                -34.91814554474679
              ],
              [
                150.7541609754654,
                -34.92815515925778
              ],
              [
                150.77613360270706,
                -34.93580485219043
              ],
              [
                150.78736415934375,
                -34.945489240661594
              ],
              [
                150.77979581352884,
                -34.95289486286019
              ],
              [
                150.7873641337822,
                -34.959730734822344
              ],
              [
                150.77621498921934,
                -34.98699301401643
              ],
              [
                150.79615319095745,
                -35.00400155993045
              ],
              [
                150.82764733178956,
                -35.012627862656394
              ],
              [
                150.8515731127561,
                -35.01490650760189
              ],
              [
                150.85499108183873,
                -35.02166106573676
              ],
              [
                150.8435978525044,
                -35.054131769821716
              ],
              [
                150.84473717426687,
                -35.077243746806445
              ],
              [
                150.83285566540593,
                -35.09091562366042
              ],
              [
                150.8071395199121,
                -35.11052825448303
              ],
              [
                150.79883873854155,
                -35.099379165880805
              ],
              [
                150.7861434261744,
                -35.0891252599113
              ],
              [
                150.77808678470774,
                -35.078545830524
              ],
              [
                150.7835392601205,
                -35.06617604182534
              ],
              [
                150.79281660250703,
                -35.050469659826426
              ],
              [
                150.781260612859,
                -35.028578382769716
              ],
              [
                150.78736412875617,
                -35.01490650760189
              ],
              [
                150.76758873806833,
                -35.00725676911133
              ],
              [
                150.7487899101806,
                -35.010349217294724
              ],
              [
                150.7314559252247,
                -35.017266534366634
              ],
              [
                150.69556725344802,
                -35.02613697609877
              ],
              [
                150.68702233233384,
                -35.038995050544564
              ],
              [
                150.67750084799826,
                -35.07577890562669
              ],
              [
                150.69695071956713,
                -35.07976653818237
              ],
              [
                150.7015080070798,
                -35.09286874487323
              ],
              [
                150.7009383493044,
                -35.10947031374993
              ],
              [
                150.7037866547176,
                -35.120456638540496
              ],
              [
                150.70476321838393,
                -35.12420013025061
              ],
              [
                150.7210392567095,
                -35.135186452276734
              ],
              [
                150.73715254206255,
                -35.131768491352595
              ],
              [
                150.7526147783344,
                -35.12468840629188
              ],
              [
                150.76685631738445,
                -35.12420013025061
              ],
              [
                150.77035566359592,
                -35.13290780771827
              ],
              [
                150.76954186325497,
                -35.14885833141389
              ],
              [
                150.76539146899586,
                -35.16619231112398
              ],
              [
                150.75945071629206,
                -35.1788876268514
              ],
              [
                150.75147545296284,
                -35.183200772451016
              ],
              [
                150.7425236306855,
                -35.18254973262289
              ],
              [
                150.7351994201782,
                -35.18084076140137
              ],
              [
                150.73218835162504,
                -35.18230560450353
              ],
              [
                150.72877037603163,
                -35.18670012318477
              ],
              [
                150.72087649755989,
                -35.19182708028605
              ],
              [
                150.71192467862886,
                -35.19654713888478
              ],
              [
                150.70476321326365,
                -35.199395434940854
              ],
              [
                150.68441817074526,
                -35.17603933032626
              ],
              [
                150.63721764924426,
                -35.17929453751449
              ],
              [
                150.61304771717766,
                -35.187269782171384
              ],
              [
                150.58594810916594,
                -35.196221606776724
              ],
              [
                150.55396568683182,
                -35.213555590237654
              ],
              [
                150.54810631183588,
                -35.22136809024599
              ],
              [
                150.5437117862019,
                -35.237969660948174
              ],
              [
                150.53972415043432,
                -35.247735276601894
              ],
              [
                150.53443443581884,
                -35.254978114606665
              ],
              [
                150.52312259302056,
                -35.26433684865264
              ],
              [
                150.499522334891,
                -35.28972747667783
              ],
              [
                150.48910566294668,
                -35.305759369679244
              ],
              [
                150.4846297559243,
                -35.32431406310974
              ],
              [
                150.48503665877473,
                -35.350192973094025
              ],
              [
                150.48845461156935,
                -35.364515864556395
              ],
              [
                150.4918725806985,
                -35.369398677768594
              ],
              [
                150.49203536135045,
                -35.37314220008154
              ],
              [
                150.48503664372546,
                -35.38437263582209
              ],
              [
                150.45582114880833,
                -35.40398526596617
              ],
              [
                150.45093834950586,
                -35.4084612000371
              ],
              [
                150.44548586662364,
                -35.42546964873329
              ],
              [
                150.4329533259748,
                -35.44068776600574
              ],
              [
                150.41920007354173,
                -35.454522406131005
              ],
              [
                150.4099227126312,
                -35.46689216993628
              ],
              [
                150.40699302664362,
                -35.48739998457477
              ],
              [
                150.40935307134095,
                -35.53850678557937
              ],
              [
                150.40650474780398,
                -35.54876066506977
              ],
              [
                150.38965903969495,
                -35.5578752414884
              ],
              [
                150.37232507721853,
                -35.57887136996193
              ],
              [
                150.3325301672781,
                -35.63941826419009
              ],
              [
                150.30689538085826,
                -35.70029062596201
              ],
              [
                150.29167726902642,
                -35.72283292352186
              ],
              [
                150.2736922339523,
                -35.730645409075535
              ],
              [
                150.2534285817026,
                -35.726250908526005
              ],
              [
                150.23178145278857,
                -35.713311466820755
              ],
              [
                150.22193444853963,
                -35.71770600001662
              ],
              [
                150.19092855999898,
                -35.72682053594019
              ],
              [
                150.2181095818011,
                -35.751153270191956
              ],
              [
                150.22584068546197,
                -35.77890389519546
              ],
              [
                150.22868901613055,
                -35.7852515888162
              ],
              [
                150.2385360271926,
                -35.79949313383817
              ],
              [
                150.24097742950997,
                -35.8097470339753
              ],
              [
                150.23861739498906,
                -35.833103140430715
              ],
              [
                150.23243248203516,
                -35.84384530054221
              ],
              [
                150.2181095506412,
                -35.85019293472495
              ],
              [
                150.19092858369183,
                -35.857191667681604
              ],
              [
                150.18930099213702,
                -35.85955171499224
              ],
              [
                150.15259852197153,
                -35.89373140645222
              ],
              [
                150.14975017471372,
                -35.89820725630522
              ],
              [
                150.15023849353298,
                -35.91253023215501
              ],
              [
                150.1608179205048,
                -35.93971122049939
              ],
              [
                150.16342209164668,
                -35.95663831160107
              ],
              [
                150.15658613754968,
                -36.025079039589386
              ],
              [
                150.14869226335722,
                -36.06259532471224
              ],
              [
                150.12964927765586,
                -36.05950285144979
              ],
              [
                150.10678145939832,
                -36.04859793608396
              ],
              [
                150.08773849641048,
                -36.062676721531034
              ],
              [
                150.0911564585019,
                -36.07024506965784
              ],
              [
                150.0901798604684,
                -36.07529058600656
              ],
              [
                150.08155358341742,
                -36.08375416722746
              ],
              [
                150.08765710496013,
                -36.08277761451017
              ],
              [
                150.0925399064019,
                -36.08269621634524
              ],
              [
                150.09701581546085,
                -36.081312749294554
              ],
              [
                150.1020613713721,
                -36.07634853043134
              ],
              [
                150.11915123210704,
                -36.085056238741174
              ],
              [
                150.13575281569038,
                -36.09775158463588
              ],
              [
                150.1433211379958,
                -36.1144344684759
              ],
              [
                150.1230574822396,
                -36.15260181197495
              ],
              [
                150.12110435332445,
                -36.17376065985423
              ],
              [
                150.1241968158087,
                -36.195245057520246
              ],
              [
                150.14478600413565,
                -36.25286223821154
              ],
              [
                150.14649496336443,
                -36.273532771603385
              ],
              [
                150.1328231596726,
                -36.2824033257223
              ],
              [
                150.13282310514464,
                -36.286797771762345
              ],
              [
                150.14039151448793,
                -36.30974706912284
              ],
              [
                150.1423445888997,
                -36.32000089639919
              ],
              [
                150.1381942361094,
                -36.33001072026428
              ],
              [
                150.12842860967103,
                -36.33831149901538
              ],
              [
                150.10824626225582,
                -36.351332246888475
              ],
              [
                150.09229575992757,
                -36.367852457910494
              ],
              [
                150.07927492591236,
                -36.386000242344586
              ],
              [
                150.07048588237436,
                -36.406345324536474
              ],
              [
                150.06739339764098,
                -36.4292944866149
              ],
              [
                150.0730086995097,
                -36.453057611145056
              ],
              [
                150.07422932077125,
                -36.463311390675656
              ],
              [
                150.07097412444398,
                -36.470147346745
              ],
              [
                150.05681402035137,
                -36.488946256541915
              ],
              [
                150.05355881249244,
                -36.5009091477431
              ],
              [
                150.0636498985415,
                -36.54314538324698
              ],
              [
                150.06576585226506,
                -36.56658298915509
              ],
              [
                150.0569767418805,
                -36.58717210665372
              ],
              [
                150.029063324795,
                -36.62428147387504
              ],
              [
                149.99537198595831,
                -36.686456056923625
              ],
              [
                149.9891056892009,
                -36.704685191073864
              ],
              [
                149.98609461075804,
                -36.722914342060086
              ],
              [
                149.9853621654243,
                -36.74480558235549
              ],
              [
                149.9795027825565,
                -36.769952054351016
              ],
              [
                149.96509846008388,
                -36.79452883697316
              ],
              [
                149.94703210979424,
                -36.81568777751152
              ],
              [
                149.93002360083162,
                -36.830498905443676
              ],
              [
                149.93995203305204,
                -36.85295991539602
              ],
              [
                149.9348251149954,
                -36.87070085354767
              ],
              [
                149.9096786040945,
                -36.90553154157188
              ],
              [
                149.90381915851438,
                -36.9283992733974
              ],
              [
                149.9113875701615,
                -36.938571879314054
              ],
              [
                149.92652429194615,
                -36.94410573753548
              ],
              [
                149.94369546953612,
                -36.953383011173884
              ],
              [
                149.93213953953395,
                -36.96550875311458
              ],
              [
                149.9231062709569,
                -36.983493679796275
              ],
              [
                149.92017664470987,
                -37.00261812076816
              ],
              [
                149.92676842263708,
                -37.01824309342741
              ],
              [
                149.93482503098502,
                -37.02662520508481
              ],
              [
                149.9399520642261,
                -37.03386816532204
              ],
              [
                149.94288174856842,
                -37.04216894077241
              ],
              [
                149.9436954732364,
                -37.05339929302009
              ],
              [
                149.9415796609902,
                -37.06218846631915
              ],
              [
                149.93685959645393,
                -37.0689430053944
              ],
              [
                149.93230224432656,
                -37.070977418193586
              ],
              [
                149.9300235944766,
                -37.0663387403737
              ],
              [
                149.9225366874675,
                -37.06178155699357
              ],
              [
                149.90577229633294,
                -37.070977418193586
              ],
              [
                149.89031013357626,
                -37.08407974769088
              ],
              [
                149.88550864005555,
                -37.09050869193408
              ],
              [
                149.87614996376055,
                -37.09587985784104
              ],
              [
                149.88209073792808,
                -37.1075986366914
              ],
              [
                149.89665770911955,
                -37.119317257466996
              ],
              [
                149.9130965666423,
                -37.12468843404538
              ],
              [
                149.93018642505308,
                -37.12281671173114
              ],
              [
                149.93897550432433,
                -37.11980566822288
              ],
              [
                149.94605553234277,
                -37.11923593100086
              ],
              [
                149.95875086364728,
                -37.12468843404538
              ],
              [
                149.99756924019977,
                -37.150485984878564
              ],
              [
                150.00586995175127,
                -37.15886804256364
              ],
              [
                150.0114037943277,
                -37.173435082457075
              ],
              [
                150.01441493684018,
                -37.20533623622192
              ],
              [
                150.01954189541414,
                -37.22087986453981
              ],
              [
                150.0535587603432,
                -37.26873133369318
              ],
              [
                150.053558812472,
                -37.2761370105617
              ],
              [
                150.0300398779389,
                -37.26604578308791
              ],
              [
                150.0073348527998,
                -37.25937268509688
              ],
              [
                149.9853622066777,
                -37.259047180367624
              ],
              [
                149.96436605236087,
                -37.26873133369318
              ],
              [
                149.95101970383513,
                -37.28427496339218
              ],
              [
                149.95134522966475,
                -37.29973721062638
              ],
              [
                149.9716903292772,
                -37.33757907762954
              ],
              [
                149.9572859927215,
                -37.37786222122092
              ],
              [
                149.95679776328424,
                -37.4154599553154
              ],
              [
                149.96713301121278,
                -37.45370859528052
              ],
              [
                149.98536216271987,
                -37.49586352183036
              ],
              [
                149.97209715633858,
                -37.51026776995676
              ],
              [
                149.9531356047643,
                -37.53085701683102
              ],
              [
                149.89633223395586,
                -37.54859792527336
              ],
              [
                149.77865651910534,
                -37.55608500202117
              ],
              [
                149.78712006300617,
                -37.55282979583994
              ],
              [
                149.79135185111852,
                -37.547947009153816
              ],
              [
                149.79127043469154,
                -37.5420875803354
              ],
              [
                149.7861433581543,
                -37.535576982141436
              ],
              [
                149.79786218649144,
                -37.519707958005405
              ],
              [
                149.79395589116837,
                -37.510837447913076
              ],
              [
                149.78272541963622,
                -37.512790567684426
              ],
              [
                149.77247154956612,
                -37.529392184357995
              ],
              [
                149.76002035216365,
                -37.52402105228402
              ],
              [
                149.71843509285557,
                -37.51580169226683
              ],
              [
                149.76148528286953,
                -37.56633888991027
              ],
              [
                149.76628660456436,
                -37.58407961056345
              ],
              [
                149.75757887061138,
                -37.59710036944266
              ],
              [
                149.72543378506143,
                -37.62029387072126
              ],
              [
                149.71168056562811,
                -37.648532855088
              ],
              [
                149.6784773366936,
                -37.6910131712681
              ],
              [
                149.66667726725203,
                -37.70012784427161
              ],
              [
                149.6152448922424,
                -37.710381628337764
              ],
              [
                149.60987399499464,
                -37.717461995312384
              ],
              [
                149.60482826227513,
                -37.72633220379314
              ],
              [
                149.59498136006317,
                -37.734795895663
              ],
              [
                149.57504311463038,
                -37.74098065309296
              ],
              [
                149.5320744836751,
                -37.74627054177113
              ],
              [
                149.51246169867372,
                -37.75530351736352
              ],
              [
                149.50733475062242,
                -37.761407039651985
              ],
              [
                149.49781335158207,
                -37.77760182771536
              ],
              [
                149.49122164712924,
                -37.783298577322306
              ],
              [
                149.47901455510032,
                -37.78590265489524
              ],
              [
                149.34107514849697,
                -37.78671652498463
              ],
              [
                149.29900149112422,
                -37.798516523918906
              ],
              [
                149.27222747739685,
                -37.8235003567195
              ],
              [
                149.26539140641046,
                -37.81707112589489
              ],
              [
                149.2610783369902,
                -37.81031668843744
              ],
              [
                149.2591252561549,
                -37.802504253204106
              ],
              [
                149.25855557623464,
                -37.79290136048835
              ],
              [
                149.25318447966814,
                -37.7894833877342
              ],
              [
                149.1731063983546,
                -37.790215873892464
              ],
              [
                149.15235442691582,
                -37.78639097685454
              ],
              [
                149.13558995690082,
                -37.775811333903505
              ],
              [
                149.09278409791807,
                -37.789646162381
              ],
              [
                148.94385830758802,
                -37.7894833877342
              ],
              [
                148.90219165513605,
                -37.79631934712125
              ],
              [
                148.78630615206401,
                -37.79810958307193
              ],
              [
                148.76514727896134,
                -37.803806169976504
              ],
              [
                148.7360132305449,
                -37.82048921091402
              ],
              [
                148.72413177414944,
                -37.8235003567195
              ],
              [
                148.6040145972222,
                -37.81113058215609
              ],
              [
                148.30640715676475,
                -37.82341896611086
              ],
              [
                148.1306258111334,
                -37.85711023114059
              ],
              [
                147.91651444510643,
                -37.91855223324614
              ],
              [
                147.75757899660906,
                -37.98512138814675
              ],
              [
                147.58936616560226,
                -38.08066183939819
              ],
              [
                147.39551833380347,
                -38.220147261169146
              ],
              [
                147.180674621001,
                -38.39788169088467
              ],
              [
                147.0827743070104,
                -38.47283297274954
              ],
              [
                146.9836530946231,
                -38.57219803653425
              ],
              [
                146.89486731361924,
                -38.634209793118295
              ],
              [
                146.88445065482333,
                -38.63860433588992
              ],
              [
                146.87859132519276,
                -38.644301015917655
              ],
              [
                146.8476668426529,
                -38.68499111489568
              ],
              [
                146.83643644626636,
                -38.6823870517757
              ],
              [
                146.83204190855596,
                -38.67278417820699
              ],
              [
                146.846527607056,
                -38.65960061503206
              ],
              [
                146.83025148294374,
                -38.65471768443017
              ],
              [
                146.68881268524615,
                -38.68010831559754
              ],
              [
                146.64144935269204,
                -38.67685303371585
              ],
              [
                146.61768638749558,
                -38.67913175967888
              ],
              [
                146.57471772237434,
                -38.703220422216795
              ],
              [
                146.55347737169464,
                -38.70452233914942
              ],
              [
                146.53060947627932,
                -38.701348430325226
              ],
              [
                146.50391696741426,
                -38.700616293591715
              ],
              [
                146.45866955245998,
                -38.710137750418895
              ],
              [
                146.43279050366206,
                -38.71965903088757
              ],
              [
                146.42139732862927,
                -38.73162199817501
              ],
              [
                146.41179437861328,
                -38.739841277526565
              ],
              [
                146.39112386088323,
                -38.72600672157485
              ],
              [
                146.3722437086727,
                -38.70745211350118
              ],
              [
                146.3674423583169,
                -38.700616293591715
              ],
              [
                146.3504338229106,
                -38.6950009562122
              ],
              [
                146.25570727935215,
                -38.7017555421269
              ],
              [
                146.2382919209926,
                -38.70582456021482
              ],
              [
                146.2241316272288,
                -38.71445066456995
              ],
              [
                146.18238371665018,
                -38.755954766126194
              ],
              [
                146.21599372550267,
                -38.783786773481985
              ],
              [
                146.22095793637462,
                -38.7916806790023
              ],
              [
                146.2295027498293,
                -38.80885174935641
              ],
              [
                146.23707105750694,
                -38.817966257711824
              ],
              [
                146.24122144460972,
                -38.819024196588366
              ],
              [
                146.26058993749044,
                -38.817966257711824
              ],
              [
                146.2639266360247,
                -38.82040782002326
              ],
              [
                146.263926584034,
                -38.82626712085729
              ],
              [
                146.26319428496285,
                -38.83310323417582
              ],
              [
                146.26384527364695,
                -38.838474253563234
              ],
              [
                146.2667749207623,
                -38.851250887290085
              ],
              [
                146.2666122366136,
                -38.86337664773257
              ],
              [
                146.27027428556113,
                -38.87322356679853
              ],
              [
                146.28492281290465,
                -38.87932721032587
              ],
              [
                146.27767997881134,
                -38.89934674776136
              ],
              [
                146.2863876039922,
                -38.909844712970326
              ],
              [
                146.3029076734074,
                -38.91187905905847
              ],
              [
                146.31902100443386,
                -38.90667079468414
              ],
              [
                146.33423906188096,
                -38.8934871426096
              ],
              [
                146.35499108160224,
                -38.86858489343391
              ],
              [
                146.3737084245318,
                -38.85833083789549
              ],
              [
                146.38298585665558,
                -38.85719164173832
              ],
              [
                146.40235429963812,
                -38.8585750378407
              ],
              [
                146.4108992799719,
                -38.85515715184455
              ],
              [
                146.4167585716722,
                -38.84685625225802
              ],
              [
                146.41830480923898,
                -38.83733478752416
              ],
              [
                146.41895591963126,
                -38.82756926135006
              ],
              [
                146.42139722937776,
                -38.817966257711824
              ],
              [
                146.43262786597492,
                -38.80144631611403
              ],
              [
                146.44776450384379,
                -38.79029711136995
              ],
              [
                146.46355236555948,
                -38.79127381808512
              ],
              [
                146.4767359511403,
                -38.810479536386616
              ],
              [
                146.47046963999318,
                -38.82382584024908
              ],
              [
                146.46851641635493,
                -38.840264501787615
              ],
              [
                146.46924894135273,
                -38.869236002314175
              ],
              [
                146.47095779688206,
                -38.87916420432189
              ],
              [
                146.47486423152813,
                -38.88591902362696
              ],
              [
                146.4795028952744,
                -38.89185976828127
              ],
              [
                146.48292071913752,
                -38.899997583228625
              ],
              [
                146.48414139461565,
                -38.90740314320601
              ],
              [
                146.48406001140802,
                -38.910902487673944
              ],
              [
                146.48324638524622,
                -38.91513450808729
              ],
              [
                146.482920747342,
                -38.924086165295435
              ],
              [
                146.47754966439268,
                -38.929457274965195
              ],
              [
                146.46583095572694,
                -38.937676734537824
              ],
              [
                146.4541121431934,
                -38.949314014953494
              ],
              [
                146.44857835249525,
                -38.96502048557337
              ],
              [
                146.44654391875082,
                -38.97576277334439
              ],
              [
                146.43726643479698,
                -39.00514083044579
              ],
              [
                146.4350692581316,
                -39.01995215317946
              ],
              [
                146.43799889833693,
                -39.02695078511984
              ],
              [
                146.44467197109452,
                -39.0303686070488
              ],
              [
                146.45264723208916,
                -39.0303686070488
              ],
              [
                146.4659936910353,
                -39.02361419810513
              ],
              [
                146.47055107229005,
                -39.02825299742933
              ],
              [
                146.48340910209026,
                -39.064629889350485
              ],
              [
                146.47787519889752,
                -39.07170989807885
              ],
              [
                146.46485428807276,
                -39.07333739252213
              ],
              [
                146.4485782501321,
                -39.07805745024827
              ],
              [
                146.4343367405689,
                -39.08912519548731
              ],
              [
                146.43490639705365,
                -39.097425971162224
              ],
              [
                146.43897555493328,
                -39.10808698465747
              ],
              [
                146.43506917315253,
                -39.12639734646366
              ],
              [
                146.4255477163833,
                -39.136407151114994
              ],
              [
                146.41065518113942,
                -39.14316176912569
              ],
              [
                146.3942164275785,
                -39.14495220111402
              ],
              [
                146.38038166919978,
                -39.140069215927554
              ],
              [
                146.3505965311231,
                -39.128024971475526
              ],
              [
                146.3357852856335,
                -39.118584800694904
              ],
              [
                146.3258569842425,
                -39.10588960525769
              ],
              [
                146.32260171930653,
                -39.088962442109825
              ],
              [
                146.33057697537046,
                -39.08277754055262
              ],
              [
                146.3414820139435,
                -39.077813475125396
              ],
              [
                146.34693439989954,
                -39.06438561706974
              ],
              [
                146.34034272994325,
                -39.055271213193485
              ],
              [
                146.29851311791117,
                -39.03769282711065
              ],
              [
                146.2890730100405,
                -39.02808995656947
              ],
              [
                146.26384525143717,
                -38.996026304863165
              ],
              [
                146.25098727185673,
                -38.93962995342809
              ],
              [
                146.18165119378983,
                -38.86834069002645
              ],
              [
                146.09180747893012,
                -38.819756756042636
              ],
              [
                146.0173446749318,
                -38.83163839032647
              ],
              [
                146.00814862946504,
                -38.84693775152601
              ],
              [
                146.00424232430217,
                -38.86549236085091
              ],
              [
                146.00367262590692,
                -38.89641678814117
              ],
              [
                145.992442167762,
                -38.90016029218969
              ],
              [
                145.9389754015141,
                -38.90878663798691
              ],
              [
                145.92115316550334,
                -38.90667079468414
              ],
              [
                145.91578214821766,
                -38.89576595599193
              ],
              [
                145.89649492953592,
                -38.82919678940416
              ],
              [
                145.8552352508028,
                -38.75953545633258
              ],
              [
                145.82154391287474,
                -38.71795026732485
              ],
              [
                145.7678329041737,
                -38.6747372742924
              ],
              [
                145.75717213755857,
                -38.65960061503206
              ],
              [
                145.78500420217603,
                -38.668633866446605
              ],
              [
                145.82553149116796,
                -38.696221678025616
              ],
              [
                145.8535263419507,
                -38.700616293591715
              ],
              [
                145.83301851809517,
                -38.66912213718908
              ],
              [
                145.8093367694178,
                -38.65016039251547
              ],
              [
                145.7773542738096,
                -38.64088294221764
              ],
              [
                145.7330834683107,
                -38.63860433588992
              ],
              [
                145.69922927343163,
                -38.64625403563545
              ],
              [
                145.6394962941455,
                -38.677422789980874
              ],
              [
                145.59961997732609,
                -38.68010831559754
              ],
              [
                145.57081134307117,
                -38.6617163304319
              ],
              [
                145.5294701971439,
                -38.5934383352783
              ],
              [
                145.51368244949919,
                -38.57838301514283
              ],
              [
                145.5018010422701,
                -38.574639675718274
              ],
              [
                145.4480899671259,
                -38.55046955308703
              ],
              [
                145.3916121328875,
                -38.5427384787487
              ],
              [
                145.37305756045978,
                -38.53679788943293
              ],
              [
                145.37305747748115,
                -38.53053149268981
              ],
              [
                145.39503013261606,
                -38.525811439429425
              ],
              [
                145.4202579481613,
                -38.515313320415274
              ],
              [
                145.4338485339051,
                -38.50212985956647
              ],
              [
                145.42074636392204,
                -38.48894632976798
              ],
              [
                145.43116302729638,
                -38.475762730538435
              ],
              [
                145.4345809825787,
                -38.459730811049
              ],
              [
                145.43116288490566,
                -38.44280353867555
              ],
              [
                145.42074637180062,
                -38.42693462260202
              ],
              [
                145.4518334412555,
                -38.41326249818952
              ],
              [
                145.46216885913256,
                -38.41521581608149
              ],
              [
                145.470876429754,
                -38.41985432521748
              ],
              [
                145.47771248215432,
                -38.424493164464224
              ],
              [
                145.48226980883524,
                -38.42693462260202
              ],
              [
                145.5061141353376,
                -38.424086205262036
              ],
              [
                145.52133223796093,
                -38.41204194102622
              ],
              [
                145.53158612406108,
                -38.39902107746017
              ],
              [
                145.5408635514509,
                -38.39275492494049
              ],
              [
                145.5568954502812,
                -38.38518656032791
              ],
              [
                145.5543726157332,
                -38.36858492876375
              ],
              [
                145.54004969259054,
                -38.35198335678853
              ],
              [
                145.5205185088324,
                -38.34441509496295
              ],
              [
                145.51547276870414,
                -38.339043755788786
              ],
              [
                145.51726311435692,
                -38.32756911832372
              ],
              [
                145.52393639754428,
                -38.310804951206485
              ],
              [
                145.5185653742578,
                -38.301853232137496
              ],
              [
                145.50294032323484,
                -38.28525159417849
              ],
              [
                145.47657303162688,
                -38.24488685705195
              ],
              [
                145.46436598861956,
                -38.234551553274834
              ],
              [
                145.4480901199184,
                -38.22828553291751
              ],
              [
                145.4298609427523,
                -38.22682067393759
              ],
              [
                145.3833113006716,
                -38.234551553274834
              ],
              [
                145.34571364469576,
                -38.234551553274834
              ],
              [
                145.3385522173251,
                -38.238864749500486
              ],
              [
                145.33399491777539,
                -38.24537515438623
              ],
              [
                145.32764727127338,
                -38.2472469134041
              ],
              [
                145.31495197612057,
                -38.23796959570288
              ],
              [
                145.29655999942958,
                -38.23170324629374
              ],
              [
                145.27173905278565,
                -38.23316811443661
              ],
              [
                145.25587004075084,
                -38.24146908588749
              ],
              [
                145.26441487565737,
                -38.25554773332847
              ],
              [
                145.2561142189716,
                -38.26482526070028
              ],
              [
                145.24683671015973,
                -38.27288165865133
              ],
              [
                145.23910573983434,
                -38.281915082299165
              ],
              [
                145.2317000558737,
                -38.30624763909084
              ],
              [
                145.22169030353692,
                -38.310804951206485
              ],
              [
                145.2106225462322,
                -38.314385607631124
              ],
              [
                145.20240314124698,
                -38.324476747795345
              ],
              [
                145.20281010731873,
                -38.33570731252726
              ],
              [
                145.21859781760952,
                -38.35035567646608
              ],
              [
                145.22282972353096,
                -38.36199324463691
              ],
              [
                145.22380610252466,
                -38.38600013554884
              ],
              [
                145.22901443039146,
                -38.41326249818952
              ],
              [
                145.13656660427964,
                -38.40081145934362
              ],
              [
                145.1129663340868,
                -38.40642667939411
              ],
              [
                145.1057235470269,
                -38.41521581608149
              ],
              [
                145.10075935200376,
                -38.42652766208549
              ],
              [
                145.0922957960312,
                -38.436293266594674
              ],
              [
                145.0607203063488,
                -38.44500099445187
              ],
              [
                145.0504662905925,
                -38.45598716274696
              ],
              [
                145.03728284614596,
                -38.482110427507614
              ],
              [
                145.04468842073086,
                -38.48894632976798
              ],
              [
                145.02466889389203,
                -38.493910528839265
              ],
              [
                144.95533292935693,
                -38.49879330061494
              ],
              [
                144.9445907346405,
                -38.5103492807665
              ],
              [
                144.92107182723774,
                -38.50302502173815
              ],
              [
                144.88640394004386,
                -38.482110427507614
              ],
              [
                144.72901459693608,
                -38.35133240490235
              ],
              [
                144.71119231994814,
                -38.342055043282635
              ],
              [
                144.69125416408946,
                -38.3381487876199
              ],
              [
                144.67676835709668,
                -38.333184402767486
              ],
              [
                144.67302491866747,
                -38.3233374724028
              ],
              [
                144.6766057012404,
                -38.31658299453602
              ],
              [
                144.68474365180126,
                -38.3204891404918
              ],
              [
                144.6933700775887,
                -38.32634869826902
              ],
              [
                144.72877036495157,
                -38.33131273726856
              ],
              [
                144.74805743538747,
                -38.34221762840936
              ],
              [
                144.78345794295748,
                -38.37273537816381
              ],
              [
                144.80396560410514,
                -38.37908281312172
              ],
              [
                144.84961999233997,
                -38.37851328538489
              ],
              [
                144.89323968358607,
                -38.372816523158825
              ],
              [
                144.9528915692087,
                -38.34791446411804
              ],
              [
                144.98292069714225,
                -38.34140379819507
              ],
              [
                144.99317469766115,
                -38.3337541983761
              ],
              [
                144.99805755702454,
                -38.323907260705475
              ],
              [
                144.9928491511114,
                -38.31365324726721
              ],
              [
                144.99146565084348,
                -38.304945511775315
              ],
              [
                145.00180088861632,
                -38.2960749976032
              ],
              [
                145.02369217828698,
                -38.28289142224494
              ],
              [
                145.0271916676021,
                -38.27581155286041
              ],
              [
                145.03272548105102,
                -38.25839612753831
              ],
              [
                145.03728275970496,
                -38.248793244302576
              ],
              [
                145.0444441616422,
                -38.239841336925366
              ],
              [
                145.06177810823635,
                -38.22356524053211
              ],
              [
                145.07243908531726,
                -38.20623150730048
              ],
              [
                145.11931393406317,
                -38.15935628314572
              ],
              [
                145.12916108743988,
                -38.12615337697026
              ],
              [
                145.1254987929108,
                -38.08814854553894
              ],
              [
                145.11019934615285,
                -38.05169026034455
              ],
              [
                145.08497162619915,
                -38.023532923784984
              ],
              [
                145.0753686503408,
                -38.01816166373472
              ],
              [
                145.04468838071273,
                -38.00920994438895
              ],
              [
                145.03296964780958,
                -38.00237403197295
              ],
              [
                145.02711029109392,
                -37.99627054434594
              ],
              [
                145.00245211661905,
                -37.9600563942801
              ],
              [
                144.99244223131026,
                -37.92009853193498
              ],
              [
                144.98267661714002,
                -37.89934659517592
              ],
              [
                144.96314535801002,
                -37.881931216425436
              ],
              [
                144.93482508472997,
                -37.86793388019829
              ],
              [
                144.9114689909566,
                -37.86980566468838
              ],
              [
                144.9069930231462,
                -37.89934659517592
              ],
              [
                144.84205153359147,
                -37.89316157343382
              ],
              [
                144.8254501369076,
                -37.89853291668416
              ],
              [
                144.8172306624789,
                -37.9113908792088
              ],
              [
                144.81202230440414,
                -37.92734136253138
              ],
              [
                144.80445388543492,
                -37.94085038899185
              ],
              [
                144.79444416202014,
                -37.94768638846322
              ],
              [
                144.778330912694,
                -37.954278234526065
              ],
              [
                144.76091553177184,
                -37.95940516212767
              ],
              [
                144.74610431379966,
                -37.96135825714793
              ],
              [
                144.7336532479343,
                -37.96795021344228
              ],
              [
                144.69581133616043,
                -37.997491057294035
              ],
              [
                144.6878361713532,
                -38.0057919809768
              ],
              [
                144.67204830184969,
                -38.017185047419616
              ],
              [
                144.5584416455631,
                -38.047621417215325
              ],
              [
                144.54330480915635,
                -38.05828204699979
              ],
              [
                144.53126065636772,
                -38.07154719786331
              ],
              [
                144.52328528816977,
                -38.08424235058204
              ],
              [
                144.523773537552,
                -38.09148513987163
              ],
              [
                144.5278426080692,
                -38.09823978832443
              ],
              [
                144.52808682268633,
                -38.10491307528028
              ],
              [
                144.51710040378518,
                -38.11158611654774
              ],
              [
                144.50782301536148,
                -38.11207433121526
              ],
              [
                144.49805750492476,
                -38.10865653327597
              ],
              [
                144.48902418746164,
                -38.10320388828614
              ],
              [
                144.4824325784187,
                -38.09734479412018
              ],
              [
                144.45411227303074,
                -38.10637800946309
              ],
              [
                144.39503011816652,
                -38.106621964387834
              ],
              [
                144.37305743499803,
                -38.11842205381169
              ],
              [
                144.36255946133176,
                -38.14657971533947
              ],
              [
                144.381846532986,
                -38.15781012862777
              ],
              [
                144.43384844036515,
                -38.15935628314572
              ],
              [
                144.52361084410583,
                -38.17799240299411
              ],
              [
                144.55811600354878,
                -38.17302813623494
              ],
              [
                144.58204180778492,
                -38.16326254579546
              ],
              [
                144.65357506424286,
                -38.12468840638042
              ],
              [
                144.70476326768244,
                -38.14609147945214
              ],
              [
                144.72510817418612,
                -38.1648087109902
              ],
              [
                144.71827230711833,
                -38.19011806003689
              ],
              [
                144.7158309703673,
                -38.19597753937799
              ],
              [
                144.71664474682842,
                -38.209567996429776
              ],
              [
                144.71509855963595,
                -38.214613622557636
              ],
              [
                144.70899496678408,
                -38.21835699752182
              ],
              [
                144.6953231257297,
                -38.218438427888515
              ],
              [
                144.68783618175,
                -38.22144954784657
              ],
              [
                144.67042076098457,
                -38.238051028115024
              ],
              [
                144.6611434260402,
                -38.24968841054142
              ],
              [
                144.6535750073253,
                -38.26181397308717
              ],
              [
                144.652842733439,
                -38.28582135433519
              ],
              [
                144.61158293667475,
                -38.29257586433384
              ],
              [
                144.5301212730707,
                -38.29029710793506
              ],
              [
                144.51880945289258,
                -38.29501720260515
              ],
              [
                144.510752701104,
                -38.29941157062074
              ],
              [
                144.50212656251713,
                -38.302667020484904
              ],
              [
                144.48926844081447,
                -38.303399370406396
              ],
              [
                144.4790146025271,
                -38.301039444648616
              ],
              [
                144.45606520132876,
                -38.29225011184924
              ],
              [
                144.44483481508078,
                -38.29029710793506
              ],
              [
                144.42237393578355,
                -38.29338964290022
              ],
              [
                144.40186604155926,
                -38.30120202110207
              ],
              [
                144.30974378453112,
                -38.356703528651515
              ],
              [
                144.25953205503944,
                -38.395765821064366
              ],
              [
                144.24903411434676,
                -38.40162535295917
              ],
              [
                144.22787527594545,
                -38.40341574098639
              ],
              [
                144.21485435513577,
                -38.40642667939411
              ],
              [
                144.2075302159527,
                -38.41179789016348
              ],
              [
                144.19410235094708,
                -38.42839925992908
              ],
              [
                144.18751067671656,
                -38.43434019592503
              ],
              [
                144.13640392971308,
                -38.44736106426537
              ],
              [
                144.13135833488,
                -38.450616241077796
              ],
              [
                144.1212672112798,
                -38.46526471100481
              ],
              [
                144.11622146417392,
                -38.46851966362321
              ],
              [
                144.07146239452624,
                -38.47527428593129
              ],
              [
                144.05250088205094,
                -38.485772445592374
              ],
              [
                143.99919691125066,
                -38.53362410328406
              ],
              [
                143.99683674683902,
                -38.5401343169517
              ],
              [
                143.99927822341758,
                -38.54745863959537
              ],
              [
                144.00017346748888,
                -38.55641055366892
              ],
              [
                143.99236083558463,
                -38.56780358911667
              ],
              [
                143.9795027647206,
                -38.57561609226431
              ],
              [
                143.95386801124891,
                -38.58033616117168
              ],
              [
                143.94117279157686,
                -38.58513773001221
              ],
              [
                143.92847739798438,
                -38.60051847039404
              ],
              [
                143.9055281936015,
                -38.64381276180447
              ],
              [
                143.8896590177144,
                -38.65292729479794
              ],
              [
                143.8798933506796,
                -38.656914863355844
              ],
              [
                143.86988359148324,
                -38.66619221587696
              ],
              [
                143.85515382259035,
                -38.683526271657115
              ],
              [
                143.84490000571876,
                -38.69117614177631
              ],
              [
                143.74545339195473,
                -38.71933369551387
              ],
              [
                143.72510821661652,
                -38.721774921577094
              ],
              [
                143.7046004411551,
                -38.728122630887206
              ],
              [
                143.692393375822,
                -38.74309654131001
              ],
              [
                143.68360443989917,
                -38.761163131011145
              ],
              [
                143.67107173917867,
                -38.78036864347146
              ],
              [
                143.6709091194493,
                -38.78337991706168
              ],
              [
                143.67058346552403,
                -38.78630940918807
              ],
              [
                143.66675869757026,
                -38.7901344276557
              ],
              [
                143.66228272973106,
                -38.79094814842311
              ],
              [
                143.65088953560021,
                -38.7892392151529
              ],
              [
                143.64625088456486,
                -38.7901344276557
              ],
              [
                143.61085048517063,
                -38.8065732159653
              ],
              [
                143.6013289528767,
                -38.81422288719932
              ],
              [
                143.57325273494027,
                -38.84295003353003
              ],
              [
                143.55640710025122,
                -38.853936460718906
              ],
              [
                143.53695712357575,
                -38.85833083789549
              ],
              [
                143.51734455108968,
                -38.85019290033304
              ],
              [
                143.48340913930448,
                -38.82366314887478
              ],
              [
                143.47193434044493,
                -38.817966257711824
              ],
              [
                143.46697021035337,
                -38.814629761220736
              ],
              [
                143.45630942145584,
                -38.80006272953957
              ],
              [
                143.45118245959472,
                -38.79680750862799
              ],
              [
                143.41342210974545,
                -38.783786773481985
              ],
              [
                143.3761498351524,
                -38.76433669981246
              ],
              [
                143.3574325626337,
                -38.75823343997378
              ],
              [
                143.33448332454657,
                -38.755954766126194
              ],
              [
                143.24154699199204,
                -38.76279050757075
              ],
              [
                143.22339922483073,
                -38.75628011805527
              ],
              [
                143.20281002973775,
                -38.74285238092492
              ],
              [
                143.18588299602482,
                -38.726495031003246
              ],
              [
                143.17888421227335,
                -38.7111140463439
              ],
              [
                143.1186628851035,
                -38.66643635038788
              ],
              [
                143.0809025055689,
                -38.64478927035729
              ],
              [
                143.06006926492356,
                -38.63591896324432
              ],
              [
                142.94743908257607,
                -38.61874777866757
              ],
              [
                142.9002385512996,
                -38.60116963864712
              ],
              [
                142.87134859897594,
                -38.59661237821854
              ],
              [
                142.85401459216146,
                -38.58733500207292
              ],
              [
                142.84799245304842,
                -38.58513773001221
              ],
              [
                142.8102319292145,
                -38.57838301514283
              ],
              [
                142.76197354177694,
                -38.53704198097225
              ],
              [
                142.7353621638243,
                -38.525811439429425
              ],
              [
                142.65381917696428,
                -38.47275151532855
              ],
              [
                142.5898542883396,
                -38.443129053754916
              ],
              [
                142.55307045281512,
                -38.419528820169454
              ],
              [
                142.53907302427646,
                -38.41464595957673
              ],
              [
                142.5324812638109,
                -38.40984458108461
              ],
              [
                142.52833095494293,
                -38.407891578708295
              ],
              [
                142.51872805793937,
                -38.40748462842954
              ],
              [
                142.51539146422837,
                -38.40642667939411
              ],
              [
                142.5037541924027,
                -38.384861070151295
              ],
              [
                142.50489342926974,
                -38.37851328538489
              ],
              [
                142.50245200720067,
                -38.374444251351164
              ],
              [
                142.4878034871867,
                -38.372816523158825
              ],
              [
                142.47852617641144,
                -38.376560061873306
              ],
              [
                142.4729109622947,
                -38.38534915463881
              ],
              [
                142.46949295865193,
                -38.39641681089453
              ],
              [
                142.46753990223098,
                -38.40642667939411
              ],
              [
                142.44434664094885,
                -38.397068102946555
              ],
              [
                142.43246495054058,
                -38.390313275226035
              ],
              [
                142.41065507743465,
                -38.37175862235889
              ],
              [
                142.39771572783144,
                -38.36712010514946
              ],
              [
                142.31283608265773,
                -38.366957213076155
              ],
              [
                142.28191169059122,
                -38.37379328031901
              ],
              [
                142.26954193577757,
                -38.39275492494049
              ],
              [
                142.22461996247213,
                -38.405694230798275
              ],
              [
                142.17546634891778,
                -38.39869558135904
              ],
              [
                142.09083084551662,
                -38.36541094671884
              ],
              [
                141.9851993234339,
                -38.29900467805672
              ],
              [
                141.9467878828934,
                -38.28289142224494
              ],
              [
                141.93531339406044,
                -38.281426761979
              ],
              [
                141.89909908091826,
                -38.28289142224494
              ],
              [
                141.88754313575095,
                -38.27996180286707
              ],
              [
                141.8645124797178,
                -38.27109127373678
              ],
              [
                141.7619734464982,
                -38.26181397308717
              ],
              [
                141.72144625455678,
                -38.267510817923466
              ],
              [
                141.6725366229881,
                -38.284274949634764
              ],
              [
                141.63209070389755,
                -38.30877046046949
              ],
              [
                141.61784921577066,
                -38.3381487876199
              ],
              [
                141.62378998007986,
                -38.353611040574066
              ],
              [
                141.6440535763409,
                -38.37297941648338
              ],
              [
                141.6521102103147,
                -38.38648852242675
              ],
              [
                141.65398201700717,
                -38.39983496915596
              ],
              [
                141.6479597404941,
                -38.40276444348812
              ],
              [
                141.6212671133282,
                -38.39902107746017
              ],
              [
                141.61451250184126,
                -38.397149250536415
              ],
              [
                141.60808354863593,
                -38.393731406025026
              ],
              [
                141.60141035202514,
                -38.39226653403776
              ],
              [
                141.59400471281478,
                -38.395765821064366
              ],
              [
                141.57325271362197,
                -38.41326249818952
              ],
              [
                141.5680444112034,
                -38.419528820169454
              ],
              [
                141.56462641989623,
                -38.431410297716994
              ],
              [
                141.55787201246088,
                -38.439711303270904
              ],
              [
                141.5428166645478,
                -38.43434019592503
              ],
              [
                141.53321375356944,
                -38.4237606983929
              ],
              [
                141.51937918836617,
                -38.39812603893398
              ],
              [
                141.50798586132657,
                -38.38648852242675
              ],
              [
                141.49675532247548,
                -38.38054765972328
              ],
              [
                141.48308349175235,
                -38.376234575384125
              ],
              [
                141.46729580438748,
                -38.37379328031901
              ],
              [
                141.4497175498775,
                -38.372816523158825
              ],
              [
                141.43441810722854,
                -38.37509522293922
              ],
              [
                141.42986079207648,
                -38.381280084080714
              ],
              [
                141.4284773477803,
                -38.390720216300494
              ],
              [
                141.42237380263978,
                -38.40276444348812
              ],
              [
                141.41032966197113,
                -38.40650812965232
              ],
              [
                141.39454192607343,
                -38.40162535295917
              ],
              [
                141.37964929408085,
                -38.39299896967843
              ],
              [
                141.37086021033787,
                -38.38648852242675
              ],
              [
                141.37614985208614,
                -38.37688554850152
              ],
              [
                141.39136796320471,
                -38.358656399689245
              ],
              [
                141.3982853913104,
                -38.34433365134057
              ],
              [
                141.39991290411314,
                -38.33635825113605
              ],
              [
                141.39812255857808,
                -38.3204891404918
              ],
              [
                141.3911238053585,
                -38.3060847599456
              ],
              [
                141.37476647602335,
                -38.291192322089444
              ],
              [
                141.21387772336368,
                -38.17302813623494
              ],
              [
                141.13428792538573,
                -38.12761804870286
              ],
              [
                140.98755942032,
                -38.06991949728978
              ],
              [
                140.97055101758227,
                -38.060153966263194
              ],
              [
                140.95142666485543,
                -38.05429458403341
              ],
              [
                140.71355224473066,
                -38.07057051681514
              ],
              [
                140.6901962294355,
                -38.06812927170416
              ],
              [
                140.66920015643026,
                -38.061781647029164
              ],
              [
                140.65088958140984,
                -38.05217874000491
              ],
              [
                140.63477633225025,
                -38.04021589808184
              ],
              [
                140.62501064568548,
                -38.036879215324696
              ],
              [
                140.602386977734,
                -38.03777444360115
              ],
              [
                140.59376055297943,
                -38.0333797235524
              ],
              [
                140.58383222194755,
                -38.023207282213555
              ],
              [
                140.57593833182514,
                -38.01824307360737
              ],
              [
                140.5553491876693,
                -38.00920994438895
              ],
              [
                140.47706133980992,
                -37.95086020014571
              ],
              [
                140.45728601354207,
                -37.93914154877542
              ],
              [
                140.41651454533056,
                -37.92766696580488
              ],
              [
                140.39820391183483,
                -37.91985433171492
              ],
              [
                140.39625079899028,
                -37.91619224154815
              ],
              [
                140.39242591701867,
                -37.9030900089246
              ],
              [
                140.39079836151564,
                -37.89934659517592
              ],
              [
                140.3867293060791,
                -37.897637539647896
              ],
              [
                140.37476643097332,
                -37.89495201730552
              ],
              [
                140.3708601295367,
                -37.89316157343382
              ],
              [
                140.35987389470023,
                -37.88209400908768
              ],
              [
                140.3574324004906,
                -37.87517655500066
              ],
              [
                140.35670015402755,
                -37.86174909288912
              ],
              [
                140.35352632319697,
                -37.84710065157909
              ],
              [
                140.33716887313892,
                -37.81609474805304
              ],
              [
                140.28777096282354,
                -37.74879312194433
              ],
              [
                140.2815047518278,
                -37.73154061960004
              ],
              [
                140.24057055311212,
                -37.665948244268975
              ],
              [
                140.21314533574562,
                -37.642510606992374
              ],
              [
                140.13721770629724,
                -37.59531025221028
              ],
              [
                140.11019941591115,
                -37.57040781143829
              ],
              [
                140.1101993948507,
                -37.56357184118333
              ],
              [
                140.1342879501377,
                -37.556735924162524
              ],
              [
                140.13168387489793,
                -37.53736758019524
              ],
              [
                140.11426846475808,
                -37.51751073790808
              ],
              [
                140.09351651953202,
                -37.50839616725064
              ],
              [
                140.08269288728187,
                -37.50505947494293
              ],
              [
                140.06324304838128,
                -37.49098074820576
              ],
              [
                140.0520939900438,
                -37.48788834881324
              ],
              [
                140.04615320578063,
                -37.486911740430514
              ],
              [
                140.03646893441,
                -37.4825171666224
              ],
              [
                140.03142341725675,
                -37.48162207318078
              ],
              [
                140.02523849033543,
                -37.484633092144826
              ],
              [
                140.02198329833146,
                -37.491469054495234
              ],
              [
                140.02100668977116,
                -37.49830491869731
              ],
              [
                140.02149503306194,
                -37.501560225398705
              ],
              [
                139.98804771014434,
                -37.48707445819841
              ],
              [
                139.7949324603708,
                -37.26873133369318
              ],
              [
                139.77003017419958,
                -37.22087986453981
              ],
              [
                139.74154707491655,
                -37.18084075930747
              ],
              [
                139.74740644409158,
                -37.170830984925246
              ],
              [
                139.76417077005962,
                -37.16464609370726
              ],
              [
                139.78126056857897,
                -37.15260174939154
              ],
              [
                139.78834073321752,
                -37.12623470113165
              ],
              [
                139.77418053189726,
                -37.10369231098713
              ],
              [
                139.75342855726984,
                -37.08163823900125
              ],
              [
                139.7397567163563,
                -37.056410430150976
              ],
              [
                139.73568774232263,
                -37.01873145313875
              ],
              [
                139.72917726468037,
                -37.00383877513293
              ],
              [
                139.71225023289972,
                -36.98805109994452
              ],
              [
                139.68620852100972,
                -36.976495035384836
              ],
              [
                139.67562906812725,
                -36.96819421391057
              ],
              [
                139.67204833623958,
                -36.953383011173884
              ],
              [
                139.78484131285802,
                -36.90203211150472
              ],
              [
                139.8154403343625,
                -36.87900161604705
              ],
              [
                139.84213301624953,
                -36.845879827839084
              ],
              [
                139.85718832239084,
                -36.808770400750525
              ],
              [
                139.86353599487526,
                -36.76726651904984
              ],
              [
                139.85710693075882,
                -36.63494225628061
              ],
              [
                139.8536890054124,
                -36.62175873422142
              ],
              [
                139.72901449951786,
                -36.37232835050671
              ],
              [
                139.6346134871297,
                -36.20354584802609
              ],
              [
                139.5673934031183,
                -36.07529058600656
              ],
              [
                139.54818771272738,
                -36.05820080730317
              ],
              [
                139.51498458312653,
                -36.03533296154261
              ],
              [
                139.47266688379892,
                -35.984551726318266
              ],
              [
                139.46656333119478,
                -35.97014736714414
              ],
              [
                139.4567163632956,
                -35.95794039920536
              ],
              [
                139.2721460439456,
                -35.80510835488922
              ],
              [
                139.198903830281,
                -35.74675870186671
              ],
              [
                139.16138755602958,
                -35.72779711585296
              ],
              [
                139.1298934285466,
                -35.699314066107604
              ],
              [
                139.0988875475596,
                -35.68645595621938
              ],
              [
                139.0623478640221,
                -35.658135695748044
              ],
              [
                139.03150474154114,
                -35.64544034148224
              ],
              [
                138.99903404763543,
                -35.61728280591031
              ],
              [
                138.96827232719843,
                -35.60662199469036
              ],
              [
                138.91781660134126,
                -35.57675546585813
              ],
              [
                138.9592391392147,
                -35.56666433870657
              ],
              [
                139.0009871699071,
                -35.58538176018072
              ],
              [
                139.34815512268074,
                -35.84783290456228
              ],
              [
                139.4475203745944,
                -35.92734139649993
              ],
              [
                139.49822025080073,
                -35.97722747675637
              ],
              [
                139.5651961690357,
                -36.04973725329202
              ],
              [
                139.6004338074364,
                -36.11101656342739
              ],
              [
                139.66521244986893,
                -36.227797156282335
              ],
              [
                139.67204838686965,
                -36.227797156282335
              ],
              [
                139.66570072392992,
                -36.18385183265476
              ],
              [
                139.61052491495357,
                -36.07634853043134
              ],
              [
                139.60027104820855,
                -36.03785575782363
              ],
              [
                139.59376062571465,
                -36.02255626953799
              ],
              [
                139.47543378382474,
                -35.89641691447601
              ],
              [
                139.45777429336624,
                -35.88298920526729
              ],
              [
                139.41814211502725,
                -35.87167732839341
              ],
              [
                139.40137780562912,
                -35.857354434613384
              ],
              [
                139.37598719285273,
                -35.8300107055286
              ],
              [
                139.18677817499213,
                -35.69068773043376
              ],
              [
                139.1677352294432,
                -35.685967718821544
              ],
              [
                139.10352625614001,
                -35.64129000331837
              ],
              [
                139.09457440885464,
                -35.63209399738536
              ],
              [
                139.05339602770616,
                -35.611993093033504
              ],
              [
                139.04135175388927,
                -35.604099208159234
              ],
              [
                139.0361434339548,
                -35.58684662850142
              ],
              [
                139.04135174865235,
                -35.57398852207858
              ],
              [
                139.05518638381682,
                -35.56943123036189
              ],
              [
                139.0755314453405,
                -35.57675546585813
              ],
              [
                139.07683353555032,
                -35.551446231618776
              ],
              [
                139.08594811637485,
                -35.53533294685194
              ],
              [
                139.11345461631427,
                -35.51116300739769
              ],
              [
                139.13542728417747,
                -35.4983049532518
              ],
              [
                139.15528405424982,
                -35.503350526374795
              ],
              [
                139.18482506883268,
                -35.52825286790972
              ],
              [
                139.20142662049037,
                -35.53525154525605
              ],
              [
                139.21949304256486,
                -35.539483344102884
              ],
              [
                139.23414146990453,
                -35.54753996837192
              ],
              [
                139.24000084362393,
                -35.56552499215916
              ],
              [
                139.23585045277417,
                -35.590020433695884
              ],
              [
                139.22836348670737,
                -35.604180613769486
              ],
              [
                139.2248641266399,
                -35.615411061924476
              ],
              [
                139.2325952594764,
                -35.631280225803295
              ],
              [
                139.24187261250518,
                -35.63583753337449
              ],
              [
                139.25123131404618,
                -35.63437265062931
              ],
              [
                139.2565210089463,
                -35.63640712268365
              ],
              [
                139.25367271320297,
                -35.651788003834675
              ],
              [
                139.24610437503804,
                -35.658135695748044
              ],
              [
                139.2335718246983,
                -35.66578543860444
              ],
              [
                139.2248641180278,
                -35.67587654109934
              ],
              [
                139.22950280589086,
                -35.68938568514145
              ],
              [
                139.24390711028758,
                -35.69451265086866
              ],
              [
                139.2976180216291,
                -35.70061612100218
              ],
              [
                139.31519616172238,
                -35.70029062596201
              ],
              [
                139.33806401657563,
                -35.687432581957204
              ],
              [
                139.34009851606234,
                -35.6687151227672
              ],
              [
                139.337657107662,
                -35.64763764637213
              ],
              [
                139.346202028897,
                -35.627862255066226
              ],
              [
                139.3603621747506,
                -35.60784270556943
              ],
              [
                139.3557234979138,
                -35.59335701849103
              ],
              [
                139.28443445057604,
                -35.53850678557937
              ],
              [
                139.27076257578204,
                -35.5313453269425
              ],
              [
                139.2361759805018,
                -35.52459075906814
              ],
              [
                139.2226668592116,
                -35.517998949432545
              ],
              [
                139.21892337952792,
                -35.50725678032133
              ],
              [
                139.23047935397688,
                -35.50058357634803
              ],
              [
                139.26050865443798,
                -35.49423592535155
              ],
              [
                139.26685631743925,
                -35.49041106849686
              ],
              [
                139.26978599845228,
                -35.48593514437379
              ],
              [
                139.27393638715162,
                -35.482110272115385
              ],
              [
                139.284434450483,
                -35.480564076456105
              ],
              [
                139.2950952442088,
                -35.481133715421564
              ],
              [
                139.3504337824282,
                -35.49293383887308
              ],
              [
                139.36101320806733,
                -35.4895158675127
              ],
              [
                139.37305748219512,
                -35.47673918093131
              ],
              [
                139.37549889243047,
                -35.46396249527613
              ],
              [
                139.36687258430692,
                -35.45256925564287
              ],
              [
                139.3554793733502,
                -35.441501577979494
              ],
              [
                139.34986413265537,
                -35.428969014353186
              ],
              [
                139.36426842221883,
                -35.38892994115875
              ],
              [
                139.36296633146895,
                -35.376885656660285
              ],
              [
                139.35132896614377,
                -35.370212487797865
              ],
              [
                139.33863364947078,
                -35.376885656660285
              ],
              [
                139.31519615990717,
                -35.39788176883829
              ],
              [
                139.30144289764522,
                -35.35662199017584
              ],
              [
                139.26758874799174,
                -35.33131277544314
              ],
              [
                139.2231551438418,
                -35.31878020572342
              ],
              [
                139.17798912232766,
                -35.31536222633662
              ],
              [
                139.18262780968251,
                -35.320570587920884
              ],
              [
                139.1852319738195,
                -35.3243954529155
              ],
              [
                139.1893009727836,
                -35.327080980633575
              ],
              [
                139.19849694227028,
                -35.32903411521884
              ],
              [
                139.1842554107885,
                -35.344008081106345
              ],
              [
                139.13754317009727,
                -35.367282818894516
              ],
              [
                139.1196395094982,
                -35.38054776742613
              ],
              [
                139.10206139969657,
                -35.38925547693394
              ],
              [
                139.07471763609044,
                -35.39234790120529
              ],
              [
                139.0466414633006,
                -35.39072029482394
              ],
              [
                139.02767987358385,
                -35.38437263582209
              ],
              [
                138.9817000624988,
                -35.40007902789147
              ],
              [
                138.96119226051866,
                -35.41383230136827
              ],
              [
                138.9526473293247,
                -35.43580494133791
              ],
              [
                138.9568791019059,
                -35.46379973783616
              ],
              [
                138.96908612548802,
                -35.47535571219223
              ],
              [
                139.01400800226946,
                -35.486748944300345
              ],
              [
                139.03142337303535,
                -35.497002863061304
              ],
              [
                139.0379337829613,
                -35.50839607977729
              ],
              [
                139.03093508261588,
                -35.51751065870955
              ],
              [
                139.0071720646675,
                -35.52141691400682
              ],
              [
                138.9948836595258,
                -35.51921965817665
              ],
              [
                138.9744572210038,
                -35.5099423055834
              ],
              [
                138.91781659524497,
                -35.501071861256385
              ],
              [
                138.90870201387497,
                -35.494724208087085
              ],
              [
                138.8986108770394,
                -35.479180604029416
              ],
              [
                138.8906356191272,
                -35.473077091665864
              ],
              [
                138.88111412764223,
                -35.47112395363604
              ],
              [
                138.80372154993916,
                -35.47576262789383
              ],
              [
                138.79379316352836,
                -35.48398202643741
              ],
              [
                138.80860435625038,
                -35.501071861256385
              ],
              [
                138.8263452422427,
                -35.507012617986554
              ],
              [
                138.89730880007804,
                -35.507745067518485
              ],
              [
                138.91000409600653,
                -35.5099423055834
              ],
              [
                138.9191186755162,
                -35.51539477178425
              ],
              [
                138.93523196046647,
                -35.53167081965654
              ],
              [
                138.94662518691706,
                -35.53639086723457
              ],
              [
                138.95834395402017,
                -35.533786730920816
              ],
              [
                138.96949303456216,
                -35.52939218423985
              ],
              [
                138.97934004282848,
                -35.52825286790972
              ],
              [
                138.99976647588915,
                -35.53875091574706
              ],
              [
                138.99341881390816,
                -35.54753996837192
              ],
              [
                138.9723413448071,
                -35.55388763286789
              ],
              [
                138.9489852113646,
                -35.556247635554946
              ],
              [
                138.93864993381433,
                -35.55494556720876
              ],
              [
                138.91911867725614,
                -35.54998136282834
              ],
              [
                138.90756269027764,
                -35.54876066506977
              ],
              [
                138.8977970772373,
                -35.55103933182352
              ],
              [
                138.88200931443274,
                -35.56064219095513
              ],
              [
                138.86947675204019,
                -35.56178149592526
              ],
              [
                138.852386917706,
                -35.55673593969617
              ],
              [
                138.81446373567277,
                -35.53899504595703
              ],
              [
                138.79127038894183,
                -35.53508881727617
              ],
              [
                138.745860225882,
                -35.53875091574706
              ],
              [
                138.66065515232745,
                -35.55852631447078
              ],
              [
                138.63900799946973,
                -35.56707120544179
              ],
              [
                138.6298934356243,
                -35.579766552450586
              ],
              [
                138.62281335154435,
                -35.59563568288729
              ],
              [
                138.60580489314893,
                -35.61003998787211
              ],
              [
                138.56910242142166,
                -35.631280225803295
              ],
              [
                138.5312606104086,
                -35.64592863950813
              ],
              [
                138.4370223214604,
                -35.65781013572779
              ],
              [
                138.28052818226445,
                -35.651788003834675
              ],
              [
                138.28052817094243,
                -35.644301005168764
              ],
              [
                138.26465904243838,
                -35.65374113087207
              ],
              [
                138.24415123432084,
                -35.66253019961367
              ],
              [
                138.22201581362248,
                -35.669040610195744
              ],
              [
                138.20167078240019,
                -35.671644813257636
              ],
              [
                138.17676842244612,
                -35.66822681656579
              ],
              [
                138.15837648862635,
                -35.65984464271775
              ],
              [
                138.10743249313128,
                -35.620700787930176
              ],
              [
                138.1049910787372,
                -35.61044686731892
              ],
              [
                138.11133874842164,
                -35.597751578153584
              ],
              [
                138.11597741799028,
                -35.57293061093174
              ],
              [
                138.12273196478597,
                -35.55535246813698
              ],
              [
                138.13900801432976,
                -35.54045990330339
              ],
              [
                138.1594344327454,
                -35.52890388958645
              ],
              [
                138.25757896306817,
                -35.49065519039129
              ],
              [
                138.28728274537755,
                -35.469903248414305
              ],
              [
                138.31519615702285,
                -35.43889738878877
              ],
              [
                138.3398543621728,
                -35.40276457955009
              ],
              [
                138.3564559289894,
                -35.384535421995565
              ],
              [
                138.37322023754373,
                -35.376885656660285
              ],
              [
                138.38884524239097,
                -35.37297941516161
              ],
              [
                138.4089461597444,
                -35.36386484155149
              ],
              [
                138.42741946700298,
                -35.35263437300507
              ],
              [
                138.43816164936024,
                -35.342705978099495
              ],
              [
                138.4445093101398,
                -35.32203541348872
              ],
              [
                138.44109133837392,
                -35.28167082461931
              ],
              [
                138.44556725079494,
                -35.26083749235587
              ],
              [
                138.45191491262776,
                -35.25253672162867
              ],
              [
                138.45997155087167,
                -35.24675872353551
              ],
              [
                138.46729576576215,
                -35.23967863829409
              ],
              [
                138.47217858210834,
                -35.2272274721908
              ],
              [
                138.47193444324978,
                -35.21461354396815
              ],
              [
                138.46753991500523,
                -35.20468516283201
              ],
              [
                138.46225019848822,
                -35.19540781439238
              ],
              [
                138.4592391308679,
                -35.18564218829863
              ],
              [
                138.45850670870468,
                -35.166680600012384
              ],
              [
                138.46656334783745,
                -35.11052825448303
              ],
              [
                138.47657311242085,
                -35.09189218397344
              ],
              [
                138.50733483097343,
                -35.05657317317845
              ],
              [
                138.5139266290172,
                -35.03826262803047
              ],
              [
                138.50953214587184,
                -34.99553810590863
              ],
              [
                138.49073330112364,
                -34.91375096631244
              ],
              [
                138.4865015805151,
                -34.87346785345087
              ],
              [
                138.4939071507825,
                -34.791599313407595
              ],
              [
                138.50098721200303,
                -34.770928710379536
              ],
              [
                138.51693774996042,
                -34.76913837579526
              ],
              [
                138.53500403419503,
                -34.78085690744136
              ],
              [
                138.5480248958892,
                -34.801446150154945
              ],
              [
                138.55062905076858,
                -34.78191488016804
              ],
              [
                138.54704839014778,
                -34.7594540647649
              ],
              [
                138.5363062320207,
                -34.74089942963248
              ],
              [
                138.51758873014973,
                -34.73316821289807
              ],
              [
                138.50635828607417,
                -34.73056409067644
              ],
              [
                138.49634855384568,
                -34.72372821258643
              ],
              [
                138.48926835590902,
                -34.71396237377023
              ],
              [
                138.48650147971244,
                -34.70281337610274
              ],
              [
                138.48096756325685,
                -34.69841873272161
              ],
              [
                138.45460045788872,
                -34.69101328059964
              ],
              [
                138.4455673072316,
                -34.685967801849145
              ],
              [
                138.44019614068645,
                -34.67555100520819
              ],
              [
                138.4397078352554,
                -34.66570395516692
              ],
              [
                138.4401962068459,
                -34.65545021245571
              ],
              [
                138.4381617150144,
                -34.64446390824484
              ],
              [
                138.43360428231645,
                -34.63648839442419
              ],
              [
                138.39795980880749,
                -34.60784266409572
              ],
              [
                138.36882579211576,
                -34.59050885784021
              ],
              [
                138.35670003768735,
                -34.57610437376507
              ],
              [
                138.34131923763724,
                -34.53785578253187
              ],
              [
                138.32960048881364,
                -34.52060318070887
              ],
              [
                138.29420003919265,
                -34.50457117332855
              ],
              [
                138.2790634012519,
                -34.48357522659323
              ],
              [
                138.25993903305627,
                -34.438409176833055
              ],
              [
                138.2265731341056,
                -34.32048922962371
              ],
              [
                138.2053328668675,
                -34.28818122576436
              ],
              [
                138.1722111587362,
                -34.2712542103769
              ],
              [
                138.15560955931815,
                -34.26043057555819
              ],
              [
                138.15381917678803,
                -34.25025801552272
              ],
              [
                138.16407308053587,
                -34.23015709934236
              ],
              [
                138.15886471467167,
                -34.211846492854995
              ],
              [
                138.10027110817012,
                -34.144138423225534
              ],
              [
                138.07813556563576,
                -34.12835043154049
              ],
              [
                138.06812587886037,
                -34.1408017498048
              ],
              [
                138.0638126752095,
                -34.16285568866052
              ],
              [
                138.05339602386016,
                -34.180922121685036
              ],
              [
                138.01628673508145,
                -34.2273089993356
              ],
              [
                138.00928800694376,
                -34.24431740782803
              ],
              [
                138.01010182298896,
                -34.26327902156006
              ],
              [
                138.0232040396574,
                -34.284356502180756
              ],
              [
                138.02995849111892,
                -34.291110863659284
              ],
              [
                138.03614348903855,
                -34.29892355245761
              ],
              [
                138.0377710431846,
                -34.30803804317336
              ],
              [
                137.9992781472197,
                -34.356540542866036
              ],
              [
                137.93091876351238,
                -34.41480875610711
              ],
              [
                137.92790768243086,
                -34.42961993027659
              ],
              [
                137.89226318056416,
                -34.52605553071108
              ],
              [
                137.8899846526912,
                -34.541436604534226
              ],
              [
                137.8901473207521,
                -34.56926846757112
              ],
              [
                137.88892662021732,
                -34.58098722205587
              ],
              [
                137.8831486123631,
                -34.58977626073253
              ],
              [
                137.91041107400116,
                -34.623956114843494
              ],
              [
                137.89730875163318,
                -34.6443009705277
              ],
              [
                137.88648522439698,
                -34.666599221336725
              ],
              [
                137.8790797055657,
                -34.6906065272517
              ],
              [
                137.87330161412353,
                -34.7601864291802
              ],
              [
                137.870127878105,
                -34.774102612736236
              ],
              [
                137.8640243398948,
                -34.786716502869936
              ],
              [
                137.8459578694316,
                -34.81194425178113
              ],
              [
                137.84229568756552,
                -34.8189428204904
              ],
              [
                137.83790127275438,
                -34.83074315949997
              ],
              [
                137.81918378834578,
                -34.85125090602703
              ],
              [
                137.8147891938482,
                -34.86012123494845
              ],
              [
                137.81332449146458,
                -34.87420026530255
              ],
              [
                137.80054777986987,
                -34.91814554474679
              ],
              [
                137.77442466865725,
                -34.97625089765191
              ],
              [
                137.76612389395936,
                -35.00807057092711
              ],
              [
                137.77393639400796,
                -35.03484465901409
              ],
              [
                137.75220787799117,
                -35.047946871199706
              ],
              [
                137.746918166311,
                -35.05885182333848
              ],
              [
                137.75277753792503,
                -35.093194265303566
              ],
              [
                137.75082441594174,
                -35.126071874675475
              ],
              [
                137.7495223312801,
                -35.131036064719304
              ],
              [
                137.74724368402659,
                -35.13298918748967
              ],
              [
                137.7187606105036,
                -35.14470793656052
              ],
              [
                137.69361413354494,
                -35.172295839075
              ],
              [
                137.68458092435353,
                -35.1788876268514
              ],
              [
                137.67139733672946,
                -35.18084076140137
              ],
              [
                137.61988366085524,
                -35.16659921852053
              ],
              [
                137.58179772322976,
                -35.14039479218931
              ],
              [
                137.5610457682811,
                -35.131036064719304
              ],
              [
                137.54957115969427,
                -35.129652601455255
              ],
              [
                137.52019290428132,
                -35.131036064719304
              ],
              [
                137.5089624381131,
                -35.12786224176571
              ],
              [
                137.4910587889524,
                -35.1192359331321
              ],
              [
                137.48194420490444,
                -35.11736418726288
              ],
              [
                137.44418379133168,
                -35.11638763037537
              ],
              [
                137.42554772318286,
                -35.11825937510995
              ],
              [
                137.40349368726174,
                -35.12420013025061
              ],
              [
                137.38355553589312,
                -35.136163020592534
              ],
              [
                137.35075930800116,
                -35.166110929657215
              ],
              [
                137.33204186454165,
                -35.17205169374609
              ],
              [
                137.2609969452781,
                -35.16578542262671
              ],
              [
                137.2389429065406,
                -35.17205169374609
              ],
              [
                137.20883223160607,
                -35.19768646420451
              ],
              [
                137.1917423828434,
                -35.22437916294158
              ],
              [
                137.16920007126333,
                -35.24228281936166
              ],
              [
                137.12281334470964,
                -35.24089934292447
              ],
              [
                137.06202233617796,
                -35.22665781744144
              ],
              [
                137.03972415510717,
                -35.2272274721908
              ],
              [
                136.9809676418814,
                -35.25530364022823
              ],
              [
                136.95337975002886,
                -35.283949469936886
              ],
              [
                136.91358482842392,
                -35.296563402640786
              ],
              [
                136.87387128754725,
                -35.294691660636744
              ],
              [
                136.85596764485973,
                -35.271091405530804
              ],
              [
                136.85303796006082,
                -35.26604583645151
              ],
              [
                136.839366081543,
                -35.2561174451854
              ],
              [
                136.83545982785,
                -35.247735276601894
              ],
              [
                136.837087437653,
                -35.24130625094731
              ],
              [
                136.84636477901338,
                -35.226495048239705
              ],
              [
                136.8484806599522,
                -35.21672941599153
              ],
              [
                136.85547936794703,
                -35.20468516283201
              ],
              [
                136.8898218085499,
                -35.18865324862395
              ],
              [
                136.90308678435713,
                -35.1788876268514
              ],
              [
                136.89568118753667,
                -35.17205169374609
              ],
              [
                136.90430749226704,
                -35.16578542262671
              ],
              [
                136.92253665444278,
                -35.15667083000362
              ],
              [
                136.92986087080106,
                -35.1515438740679
              ],
              [
                136.93384850320174,
                -35.14592864257228
              ],
              [
                136.93970788040042,
                -35.13201263050567
              ],
              [
                136.96094811087642,
                -35.09644947319548
              ],
              [
                136.96265709812272,
                -35.08180104201228
              ],
              [
                136.95777428518116,
                -35.06275807132485
              ],
              [
                136.94890384087225,
                -35.0474585899756
              ],
              [
                136.94190514407038,
                -35.038669529126196
              ],
              [
                136.94125410252934,
                -35.02988046795083
              ],
              [
                136.95150800877852,
                -35.01490650760189
              ],
              [
                136.97575923154994,
                -34.996758579138515
              ],
              [
                136.98072351044073,
                -34.98495860358597
              ],
              [
                136.97144618427018,
                -34.96591566669372
              ],
              [
                137.01417082512944,
                -34.91790140120495
              ],
              [
                137.01978593991703,
                -34.90146238238547
              ],
              [
                137.03060956072162,
                -34.899834875456655
              ],
              [
                137.0949812601439,
                -34.924981277374336
              ],
              [
                137.13949629920197,
                -34.926039337571325
              ],
              [
                137.22364348421934,
                -34.90699645865804
              ],
              [
                137.26685636985863,
                -34.90504332397988
              ],
              [
                137.2874454726821,
                -34.911228057629835
              ],
              [
                137.29712971463138,
                -34.9201798751681
              ],
              [
                137.30787186058058,
                -34.92831782236633
              ],
              [
                137.35718837367685,
                -34.93759535794364
              ],
              [
                137.374034006716,
                -34.94801189925025
              ],
              [
                137.3912866604743,
                -34.954034122829626
              ],
              [
                137.41773524965336,
                -34.945489240661594
              ],
              [
                137.44613696797867,
                -34.91741311422562
              ],
              [
                137.4529728170628,
                -34.88339602912333
              ],
              [
                137.45232175084436,
                -34.84441486357364
              ],
              [
                137.4580183852048,
                -34.801446150154945
              ],
              [
                137.4743758160885,
                -34.772637572137306
              ],
              [
                137.47852618077133,
                -34.76116291553413
              ],
              [
                137.47925864037668,
                -34.749200092505866
              ],
              [
                137.47771243275076,
                -34.724704679117124
              ],
              [
                137.47852618888774,
                -34.71266032603931
              ],
              [
                137.51270597004464,
                -34.61777117387774
              ],
              [
                137.49903402842344,
                -34.58977626073253
              ],
              [
                137.49398852877658,
                -34.55413186336553
              ],
              [
                137.48023529570457,
                -34.52654401249186
              ],
              [
                137.48243243658973,
                -34.48398193503075
              ],
              [
                137.4785261864838,
                -34.466241049767426
              ],
              [
                137.45948327296676,
                -34.44752370326216
              ],
              [
                137.4448348616314,
                -34.45183690124564
              ],
              [
                137.43116289890827,
                -34.46502033469768
              ],
              [
                137.41431728574526,
                -34.472426098080334
              ],
              [
                137.4152938155228,
                -34.463311455126565
              ],
              [
                137.43580160627982,
                -34.41920334134888
              ],
              [
                137.44499753925737,
                -34.40422932825928
              ],
              [
                137.44874100781348,
                -34.40325272692502
              ],
              [
                137.46111092009335,
                -34.40504331336554
              ],
              [
                137.46485431024985,
                -34.40422932825928
              ],
              [
                137.46705156485515,
                -34.39983477634325
              ],
              [
                137.47022541917312,
                -34.3882788345856
              ],
              [
                137.47632895486723,
                -34.37664150254703
              ],
              [
                137.48389736043916,
                -34.35540135225143
              ],
              [
                137.49219807845245,
                -34.282484569340234
              ],
              [
                137.49219814644795,
                -34.26018651768943
              ],
              [
                137.48910565589466,
                -34.23772550219073
              ],
              [
                137.48316484579158,
                -34.21461342134773
              ],
              [
                137.474131756671,
                -34.19296649587581
              ],
              [
                137.45386804780472,
                -34.163995073716514
              ],
              [
                137.4524031522258,
                -34.155694197157786
              ],
              [
                137.45557706391776,
                -34.14837013324817
              ],
              [
                137.46143642572042,
                -34.1408017498048
              ],
              [
                137.47055098691092,
                -34.13787202137434
              ],
              [
                137.49463946074562,
                -34.1488582230668
              ],
              [
                137.50652098643047,
                -34.15032309428665
              ],
              [
                137.51954187291452,
                -34.13787202137434
              ],
              [
                137.54859465440916,
                -34.08717223959768
              ],
              [
                137.5542097838271,
                -34.072035325499215
              ],
              [
                137.55372157442898,
                -34.0586891054119
              ],
              [
                137.55160566884516,
                -34.04957448415064
              ],
              [
                137.54053798309545,
                -34.02752048957773
              ],
              [
                137.5344345068436,
                -34.01799907862514
              ],
              [
                137.5319115999056,
                -34.015394687380486
              ],
              [
                137.5405379399721,
                -34.000746320265925
              ],
              [
                137.55274490904864,
                -33.98455154377603
              ],
              [
                137.5712996100349,
                -33.96640378278059
              ],
              [
                137.59050538643584,
                -33.951755432344164
              ],
              [
                137.61508228748204,
                -33.94150167293675
              ],
              [
                137.622894697748,
                -33.93157312035839
              ],
              [
                137.627940237883,
                -33.920098449915955
              ],
              [
                137.62940513604363,
                -33.910821207125196
              ],
              [
                137.62525483410963,
                -33.89910262184428
              ],
              [
                137.61817464872996,
                -33.89137130284334
              ],
              [
                137.6098739240955,
                -33.88486099133346
              ],
              [
                137.60206131618602,
                -33.87664138828609
              ],
              [
                137.61752361358865,
                -33.86923589677007
              ],
              [
                137.63111420848637,
                -33.85768009493385
              ],
              [
                137.65357503658106,
                -33.83220788582667
              ],
              [
                137.70411218327996,
                -33.7931454565485
              ],
              [
                137.7153426070013,
                -33.78728599650901
              ],
              [
                137.75196373975098,
                -33.72616953229624
              ],
              [
                137.77662187388643,
                -33.69353593949461
              ],
              [
                137.7944442394906,
                -33.69850031922175
              ],
              [
                137.800547754492,
                -33.69850031922175
              ],
              [
                137.8629662782525,
                -33.62615313256338
              ],
              [
                137.87884236308713,
                -33.59786993071128
              ],
              [
                137.90367804957572,
                -33.58769367827879
              ],
              [
                137.91006671242317,
                -33.59623743683972
              ],
              [
                137.89807894031722,
                -33.61365736816707
              ],
              [
                137.9060587042137,
                -33.62756629416328
              ],
              [
                137.9309187879246,
                -33.61646895496154
              ],
              [
                137.93327883097643,
                -33.603204013163115
              ],
              [
                137.93065675642436,
                -33.57796907966496
              ],
              [
                137.9367726266095,
                -33.552464864894084
              ],
              [
                137.93749207528668,
                -33.52784036950225
              ],
              [
                137.92901695054167,
                -33.51123376869642
              ],
              [
                137.9184608864246,
                -33.487879716605114
              ],
              [
                137.903671609141,
                -33.45599814973673
              ],
              [
                137.89253178778003,
                -33.43846536816548
              ],
              [
                137.88351285571076,
                -33.42497656205553
              ],
              [
                137.87399788246535,
                -33.41309616684267
              ],
              [
                137.86233960137878,
                -33.396009830225736
              ],
              [
                137.8646677618801,
                -33.374081794784345
              ],
              [
                137.86962451628833,
                -33.35843695665142
              ],
              [
                137.86171181452062,
                -33.34316446064676
              ],
              [
                137.84365392627427,
                -33.32335498264882
              ],
              [
                137.8181878113882,
                -33.29363515841229
              ],
              [
                137.8104437779791,
                -33.259984958197165
              ],
              [
                137.82178790746687,
                -33.24667724680408
              ],
              [
                137.83008873130456,
                -33.226006756120874
              ],
              [
                137.84083087893222,
                -33.20598714931333
              ],
              [
                137.85499108057206,
                -33.190606375249246
              ],
              [
                137.89429767693917,
                -33.17929444218069
              ],
              [
                137.95215907318803,
                -33.143650042730144
              ],
              [
                137.95753016718893,
                -33.143650042730144
              ],
              [
                137.96680750873892,
                -33.14902113199167
              ],
              [
                137.97266691689344,
                -33.149834997916976
              ],
              [
                137.97730558916942,
                -33.14714945145849
              ],
              [
                137.98878017990262,
                -33.1376279322575
              ],
              [
                137.99244227089488,
                -33.13551200959318
              ],
              [
                138.00416096636766,
                -33.139336774419206
              ],
              [
                138.01465897710884,
                -33.145928503469015
              ],
              [
                138.02515716065977,
                -33.14853293270903
              ],
              [
                138.0371200064414,
                -33.13958102355847
              ],
              [
                138.04330484024493,
                -33.12981527859777
              ],
              [
                138.04395589356085,
                -33.125095249341996
              ],
              [
                138.04175868064155,
                -33.12053805883412
              ],
              [
                138.0402124438394,
                -33.11223725313436
              ],
              [
                138.04118900099314,
                -33.089288024784295
              ],
              [
                138.04021245617574,
                -33.08163831800483
              ],
              [
                138.03549241265154,
                -33.06609471443225
              ],
              [
                138.02898192156923,
                -33.05071371203839
              ],
              [
                138.02051844738696,
                -33.03655368737554
              ],
              [
                138.01010177583004,
                -33.02410250462995
              ],
              [
                138.00082438332993,
                -33.02019616058276
              ],
              [
                137.97836349621872,
                -33.0211728212748
              ],
              [
                137.9692488664849,
                -33.017266480620826
              ],
              [
                137.96119229484458,
                -33.00945411327091
              ],
              [
                137.95777425460412,
                -33.00465254299311
              ],
              [
                137.9023544301532,
                -32.78753033774183
              ],
              [
                137.90235437601868,
                -32.774021117556245
              ],
              [
                137.91334071909097,
                -32.76523208416277
              ],
              [
                137.93848718810162,
                -32.75261812273834
              ],
              [
                137.89682051012574,
                -32.72161224021545
              ],
              [
                137.88998459131588,
                -32.715264620995846
              ],
              [
                137.8874618365769,
                -32.709893589567294
              ],
              [
                137.8808700568238,
                -32.707208076554174
              ],
              [
                137.87322026243166,
                -32.70501070342887
              ],
              [
                137.86247811414447,
                -32.6996396857241
              ],
              [
                137.85189856803532,
                -32.69890702899829
              ],
              [
                137.84913163442596,
                -32.697930453963046
              ],
              [
                137.84766690529648,
                -32.69394305037896
              ],
              [
                137.84815511153775,
                -32.689711131994244
              ],
              [
                137.84815519136893,
                -32.68547951841552
              ],
              [
                137.84571371510987,
                -32.681247608848544
              ],
              [
                137.8449812730514,
                -32.67636475726272
              ],
              [
                137.84978281033415,
                -32.65878684008328
              ],
              [
                137.84913163341133,
                -32.65016026963295
              ],
              [
                137.84351647485704,
                -32.64088307664639
              ],
              [
                137.82178791417144,
                -32.62281658026889
              ],
              [
                137.81080162320694,
                -32.6090633975306
              ],
              [
                137.8039656465841,
                -32.594659024998606
              ],
              [
                137.8059188178121,
                -32.58066172059263
              ],
              [
                137.82178796228337,
                -32.56829193547957
              ],
              [
                137.81275479897448,
                -32.56023537324967
              ],
              [
                137.80323329819709,
                -32.558038076950226
              ],
              [
                137.79428152067052,
                -32.55730574522102
              ],
              [
                137.78695726231737,
                -32.553887698120214
              ],
              [
                137.7832136744593,
                -32.54583086179151
              ],
              [
                137.77906341898597,
                -32.52548607812745
              ],
              [
                137.77393642113753,
                -32.51978937497334
              ],
              [
                137.7644149497287,
                -32.52418393100463
              ],
              [
                137.76010170782877,
                -32.540622552318055
              ],
              [
                137.75757901695644,
                -32.56023537324967
              ],
              [
                137.75277752930188,
                -32.574395419775186
              ],
              [
                137.76042721739506,
                -32.5935196659147
              ],
              [
                137.7622177186963,
                -32.617608478877656
              ],
              [
                137.76026452052494,
                -32.660332944012694
              ],
              [
                137.7529402337346,
                -32.68287512721191
              ],
              [
                137.7539168266212,
                -32.69345461323572
              ],
              [
                137.78003995668894,
                -32.70240660004607
              ],
              [
                137.78980549817996,
                -32.71306724345191
              ],
              [
                137.79656014108903,
                -32.72649514665564
              ],
              [
                137.80054771581416,
                -32.73894620982756
              ],
              [
                137.8066511958073,
                -32.77988038413817
              ],
              [
                137.80925538184894,
                -32.84693771267772
              ],
              [
                137.80827886132042,
                -32.85800550480351
              ],
              [
                137.8043725858428,
                -32.866143475956555
              ],
              [
                137.7960718156942,
                -32.87769948617712
              ],
              [
                137.78711997882087,
                -32.90113695907258
              ],
              [
                137.78012129511947,
                -32.91082123199437
              ],
              [
                137.77173906525147,
                -32.912855602551026
              ],
              [
                137.7657984137207,
                -32.9078102335162
              ],
              [
                137.76002036767989,
                -32.90593838689197
              ],
              [
                137.75277748216612,
                -32.917657046107344
              ],
              [
                137.75196368543823,
                -32.92717854144315
              ],
              [
                137.75416093443684,
                -32.93808345634167
              ],
              [
                137.75855545817421,
                -32.94817458825345
              ],
              [
                137.7751571693976,
                -32.97047305595237
              ],
              [
                137.77833088590174,
                -32.98284262992379
              ],
              [
                137.7697860528974,
                -32.99081806211355
              ],
              [
                137.74610434987798,
                -32.99277106647321
              ],
              [
                137.7330834708645,
                -32.99179441394609
              ],
              [
                137.72413171015722,
                -32.98984141014351
              ],
              [
                137.7049259252134,
                -32.979750157167324
              ],
              [
                137.67400144378695,
                -32.9552547102992
              ],
              [
                137.65626055078138,
                -32.95134844465284
              ],
              [
                137.63209065757925,
                -32.961521026837666
              ],
              [
                137.6092228659646,
                -32.97779716021151
              ],
              [
                137.5950626828923,
                -32.99277106647321
              ],
              [
                137.5944930946212,
                -32.99911886407629
              ],
              [
                137.59620202267647,
                -33.01962656715069
              ],
              [
                137.59506266032054,
                -33.02752037162682
              ],
              [
                137.59034261294244,
                -33.03484459863154
              ],
              [
                137.51270594006965,
                -33.10881929820884
              ],
              [
                137.49195392691334,
                -33.119561368639566
              ],
              [
                137.4697372077996,
                -33.12810644153808
              ],
              [
                137.45215902545078,
                -33.1400692214637
              ],
              [
                137.44499753927195,
                -33.160739739990085
              ],
              [
                137.44402097476524,
                -33.18515379725808
              ],
              [
                137.4406030126783,
                -33.204685060697955
              ],
              [
                137.43433685408124,
                -33.22185651128791
              ],
              [
                137.38803147439046,
                -33.2938779176185
              ],
              [
                137.38298592119827,
                -33.31145608065591
              ],
              [
                137.37671953559288,
                -33.389906390358476
              ],
              [
                137.3696395148322,
                -33.41326262002316
              ],
              [
                137.35922289387148,
                -33.43124773407879
              ],
              [
                137.31666100714065,
                -33.48121510799502
              ],
              [
                137.30567464139688,
                -33.49920006390161
              ],
              [
                137.25163817184693,
                -33.61248129226235
              ],
              [
                137.2248640628703,
                -33.65325273762944
              ],
              [
                137.2014266445593,
                -33.6711565374797
              ],
              [
                137.18433686375326,
                -33.67750431418964
              ],
              [
                137.1550398717573,
                -33.70574302462607
              ],
              [
                137.13249753294795,
                -33.71217202125715
              ],
              [
                137.08350670107194,
                -33.716485272780304
              ],
              [
                137.02019285981382,
                -33.73015707349142
              ],
              [
                137.01319422482692,
                -33.72942477173753
              ],
              [
                137.0055445247638,
                -33.72633239933926
              ],
              [
                136.993907147069,
                -33.71941506681047
              ],
              [
                136.99097734939008,
                -33.713555482197634
              ],
              [
                136.99008218583344,
                -33.707126482003545
              ],
              [
                136.98511806729974,
                -33.69850031922175
              ],
              [
                136.9653426967617,
                -33.684502963080746
              ],
              [
                136.94556720162066,
                -33.68230549762042
              ],
              [
                136.93043061340074,
                -33.69255965170039
              ],
              [
                136.9243269944796,
                -33.71550867553655
              ],
              [
                136.92017670260583,
                -33.72454206442398
              ],
              [
                136.91089928282702,
                -33.73211027988486
              ],
              [
                136.90023843840493,
                -33.737481304923215
              ],
              [
                136.89258874544817,
                -33.73943451710192
              ],
              [
                136.8831486011532,
                -33.74431725381769
              ],
              [
                136.88314863551477,
                -33.75481536586627
              ],
              [
                136.88697349171863,
                -33.765557526771914
              ],
              [
                136.88941488485756,
                -33.7704403154583
              ],
              [
                136.94654382816995,
                -33.75123465602129
              ],
              [
                136.9646102572662,
                -33.7531064446974
              ],
              [
                136.91236419809235,
                -33.780938539565255
              ],
              [
                136.899424685553,
                -33.790948194935346
              ],
              [
                136.8789169211546,
                -33.80250427482126
              ],
              [
                136.85547932472642,
                -33.80486411871731
              ],
              [
                136.83106533219376,
                -33.80462011081148
              ],
              [
                136.807465003614,
                -33.80836347126841
              ],
              [
                136.79004970998588,
                -33.81812923106729
              ],
              [
                136.77711025413245,
                -33.82935969365561
              ],
              [
                136.7612410189758,
                -33.838555478063114
              ],
              [
                136.73519937230643,
                -33.84246176642841
              ],
              [
                136.72478275228,
                -33.846856386076176
              ],
              [
                136.71111079738014,
                -33.86614334540849
              ],
              [
                136.70118242132628,
                -33.87037513229094
              ],
              [
                136.69564870609918,
                -33.87200299893417
              ],
              [
                136.67042074791897,
                -33.8834774322661
              ],
              [
                136.60743245015215,
                -33.90292727068986
              ],
              [
                136.59131918838222,
                -33.91448329593465
              ],
              [
                136.58521565962548,
                -33.92180749092406
              ],
              [
                136.58253017575262,
                -33.9284807867718
              ],
              [
                136.58155354768306,
                -33.948907094455784
              ],
              [
                136.54004964390845,
                -33.97283288256332
              ],
              [
                136.51124114935217,
                -33.9982236924796
              ],
              [
                136.49350018565866,
                -34.009698155586804
              ],
              [
                136.45118248554152,
                -34.0178361913848
              ],
              [
                136.4316512205971,
                -34.027032126339435
              ],
              [
                136.3693954439337,
                -34.073418999681664
              ],
              [
                136.36198982760789,
                -34.08269631118442
              ],
              [
                136.35808354029132,
                -34.0933570482708
              ],
              [
                136.35718841830965,
                -34.113702214417955
              ],
              [
                136.3543401191587,
                -34.12428165604143
              ],
              [
                136.3486434581852,
                -34.133233393041856
              ],
              [
                136.33423910026286,
                -34.148207236301445
              ],
              [
                136.32781004304326,
                -34.15781006255098
              ],
              [
                136.31812583562802,
                -34.18547940378027
              ],
              [
                136.29346766650343,
                -34.20891696695725
              ],
              [
                136.23218835764976,
                -34.30868907978422
              ],
              [
                136.1992294286872,
                -34.330987359947024
              ],
              [
                136.13803146895685,
                -34.354750300596876
              ],
              [
                136.1147567555753,
                -34.38372170304213
              ],
              [
                136.12663820515985,
                -34.39837002806711
              ],
              [
                136.1203719053253,
                -34.408623889940216
              ],
              [
                136.11085039292104,
                -34.417575660377956
              ],
              [
                136.11166423407334,
                -34.42815515987603
              ],
              [
                136.1223251376647,
                -34.442152734521784
              ],
              [
                136.1248477961548,
                -34.452894686777825
              ],
              [
                136.12232498629572,
                -34.483330840854876
              ],
              [
                136.115733299075,
                -34.51677830845075
              ],
              [
                136.10141032793032,
                -34.53484461464861
              ],
              [
                136.08716889509995,
                -34.53240339878042
              ],
              [
                136.0807398556266,
                -34.50416446054304
              ],
              [
                136.0693464883097,
                -34.481866030059976
              ],
              [
                136.04281662142964,
                -34.48650485188609
              ],
              [
                135.99138428752354,
                -34.51344162166968
              ],
              [
                135.96607507216407,
                -34.51555756137801
              ],
              [
                135.95142670550155,
                -34.5206846441984
              ],
              [
                135.9367781931582,
                -34.53460052298149
              ],
              [
                135.93043046690786,
                -34.54900469044511
              ],
              [
                135.92432694154712,
                -34.57887120934785
              ],
              [
                135.9162703576718,
                -34.58977626073253
              ],
              [
                135.9397079483945,
                -34.620049865586864
              ],
              [
                135.94361413604398,
                -34.63746511494151
              ],
              [
                135.9305118515634,
                -34.652520324508814
              ],
              [
                135.91098072434488,
                -34.63339620107533
              ],
              [
                135.890798398549,
                -34.63111749296994
              ],
              [
                135.87476642404798,
                -34.643731289876975
              ],
              [
                135.8684188934197,
                -34.66863386414342
              ],
              [
                135.86736085240355,
                -34.67880621019939
              ],
              [
                135.86207109543082,
                -34.69817461958229
              ],
              [
                135.86101328724772,
                -34.70964947577461
              ],
              [
                135.86491951767763,
                -34.718682642864074
              ],
              [
                135.88314856560692,
                -34.73544674777216
              ],
              [
                135.88892660973292,
                -34.74684006673908
              ],
              [
                135.88298584210042,
                -34.76848718149568
              ],
              [
                135.86117590722466,
                -34.769463672390444
              ],
              [
                135.8379012250792,
                -34.76669684936279
              ],
              [
                135.82691485694932,
                -34.77752034398355
              ],
              [
                135.8225203991155,
                -34.78769300377268
              ],
              [
                135.8038843388085,
                -34.79924900682018
              ],
              [
                135.79948973732152,
                -34.80527101402032
              ],
              [
                135.8051863626159,
                -34.81698978468513
              ],
              [
                135.8183700601888,
                -34.8217100257964
              ],
              [
                135.84742278873307,
                -34.82195415580865
              ],
              [
                135.86736094555707,
                -34.819431380432746
              ],
              [
                135.8869735149003,
                -34.81324637189731
              ],
              [
                135.90495858278715,
                -34.80388772437985
              ],
              [
                135.94190519951448,
                -34.770440464464045
              ],
              [
                135.94703216703215,
                -34.76734804300873
              ],
              [
                135.95923912714593,
                -34.77190520261187
              ],
              [
                135.96631926216324,
                -34.780531608764235
              ],
              [
                135.97339925167105,
                -34.78606530213553
              ],
              [
                135.9851180204592,
                -34.78093838244284
              ],
              [
                135.99048920724084,
                -34.771254307945576
              ],
              [
                135.98853605817177,
                -34.74879332605979
              ],
              [
                135.99138429012618,
                -34.74000412681708
              ],
              [
                135.9997665295883,
                -34.73512145735501
              ],
              [
                136.00904373724697,
                -34.736748811943876
              ],
              [
                136.01636809171126,
                -34.74407327870155
              ],
              [
                136.01929777208053,
                -34.75741962052693
              ],
              [
                136.01807709182077,
                -34.80136497486001
              ],
              [
                136.0122175761776,
                -34.818454561335884
              ],
              [
                135.99878984542465,
                -34.8356257913233
              ],
              [
                135.9827579676253,
                -34.850192891636006
              ],
              [
                135.97201578547813,
                -34.862399933322386
              ],
              [
                135.96949309345453,
                -34.876641640376285
              ],
              [
                135.99878993736783,
                -34.945489240661594
              ],
              [
                135.99789477353488,
                -34.946709978438875
              ],
              [
                135.99838306344137,
                -34.96217223172659
              ],
              [
                136.0003362095528,
                -34.965752999990244
              ],
              [
                136.01246186760733,
                -34.97966902768818
              ],
              [
                136.0031030730948,
                -34.990817988908304
              ],
              [
                135.97730546379623,
                -34.99700273402756
              ],
              [
                135.96461022204753,
                -35.007500909085955
              ],
              [
                135.94516030503158,
                -34.997735198907705
              ],
              [
                135.92750081865844,
                -34.955173383563356
              ],
              [
                135.91285243735047,
                -34.945489240661594
              ],
              [
                135.90259849842136,
                -34.94329191486882
              ],
              [
                135.87867273409807,
                -34.931817337983986
              ],
              [
                135.86402432713103,
                -34.92945736657394
              ],
              [
                135.85962979569746,
                -34.923435229806
              ],
              [
                135.85865322861932,
                -34.914971681414734
              ],
              [
                135.85474699430455,
                -34.90504332397988
              ],
              [
                135.8222762028593,
                -34.87428144397511
              ],
              [
                135.78272553332857,
                -34.857598705197255
              ],
              [
                135.74146572641325,
                -34.8610165985927
              ],
              [
                135.70394941099948,
                -34.89080168370947
              ],
              [
                135.69776453861152,
                -34.911309538712764
              ],
              [
                135.69459072857387,
                -34.914971681414734
              ],
              [
                135.6901147183165,
                -34.91676186469005
              ],
              [
                135.68409270098113,
                -34.91814554474679
              ],
              [
                135.68572026174132,
                -34.92652762701053
              ],
              [
                135.68978918225164,
                -34.93816483237567
              ],
              [
                135.69019612534558,
                -34.9485001949801
              ],
              [
                135.6806747150697,
                -34.95289486286019
              ],
              [
                135.63257901205546,
                -34.95289486286019
              ],
              [
                135.62354583500453,
                -34.94793071709201
              ],
              [
                135.6215927048138,
                -34.93596781670013
              ],
              [
                135.62240642188183,
                -34.92213302707418
              ],
              [
                135.62208094460058,
                -34.911309538712764
              ],
              [
                135.6040144462154,
                -34.88014075020622
              ],
              [
                135.5122176896624,
                -34.795180029641216
              ],
              [
                135.47641036082496,
                -34.74976980619787
              ],
              [
                135.45753011020054,
                -34.73154056090897
              ],
              [
                135.42953530361967,
                -34.71266032603931
              ],
              [
                135.38379971603365,
                -34.69646582852497
              ],
              [
                135.37159265516868,
                -34.68914155456423
              ],
              [
                135.3598738304216,
                -34.685235166907184
              ],
              [
                135.33220458740638,
                -34.689873890445455
              ],
              [
                135.31967212302973,
                -34.685967801849145
              ],
              [
                135.34229579706383,
                -34.65129978976089
              ],
              [
                135.34009856807273,
                -34.63811626223978
              ],
              [
                135.3234969491025,
                -34.62078217396433
              ],
              [
                135.2878524659645,
                -34.592461950503726
              ],
              [
                135.25147549052554,
                -34.569919591076086
              ],
              [
                135.2304793924187,
                -34.56503677149082
              ],
              [
                135.21216878728595,
                -34.56780359081269
              ],
              [
                135.19402096129835,
                -34.57317461075364
              ],
              [
                135.1733504293388,
                -34.57610437376507
              ],
              [
                135.15723712084687,
                -34.58318440271225
              ],
              [
                135.13892665327833,
                -34.59636814194419
              ],
              [
                135.1213484564493,
                -34.60442464999044
              ],
              [
                135.10808348292872,
                -34.59596110883995
              ],
              [
                135.10987381720935,
                -34.57830154871193
              ],
              [
                135.14096110377923,
                -34.54094811893249
              ],
              [
                135.14909916468918,
                -34.52467215098644
              ],
              [
                135.15316814466073,
                -34.50221115821016
              ],
              [
                135.16382896050087,
                -34.48943448162556
              ],
              [
                135.17709399346222,
                -34.479668966247424
              ],
              [
                135.18995196834146,
                -34.466241049767426
              ],
              [
                135.1936142000805,
                -34.45647565126829
              ],
              [
                135.19605553894897,
                -34.4450822973515
              ],
              [
                135.20045009726246,
                -34.43564224321978
              ],
              [
                135.20980878171574,
                -34.4315731595708
              ],
              [
                135.21851643685818,
                -34.43613040156568
              ],
              [
                135.2175398924355,
                -34.44687262130868
              ],
              [
                135.20980882268344,
                -34.46941503277925
              ],
              [
                135.2137149995319,
                -34.49236411581542
              ],
              [
                135.224782750438,
                -34.50432708552677
              ],
              [
                135.2421980683903,
                -34.50986085219627
              ],
              [
                135.3139754853054,
                -34.52353286248319
              ],
              [
                135.32715898795078,
                -34.52776446597999
              ],
              [
                135.30933678183695,
                -34.53866952313842
              ],
              [
                135.3027450673322,
                -34.55071394694869
              ],
              [
                135.3063256383351,
                -34.56340896736444
              ],
              [
                135.31967204330877,
                -34.57610437376507
              ],
              [
                135.34913163153405,
                -34.585707150454745
              ],
              [
                135.35547937215478,
                -34.592380483922774
              ],
              [
                135.34083096421324,
                -34.60344824746291
              ],
              [
                135.35157314933775,
                -34.614678711114045
              ],
              [
                135.37086016003673,
                -34.62818764363393
              ],
              [
                135.3912866038052,
                -34.63958089356613
              ],
              [
                135.40577239069987,
                -34.64446390824484
              ],
              [
                135.4155380227564,
                -34.642266655259185
              ],
              [
                135.43604570476262,
                -34.63290769151574
              ],
              [
                135.49789479577657,
                -34.623956114843494
              ],
              [
                135.5035913992167,
                -34.61191182256964
              ],
              [
                135.48113041230576,
                -34.60564545448523
              ],
              [
                135.43702237277216,
                -34.59978614130103
              ],
              [
                135.437998823425,
                -34.58855546659897
              ],
              [
                135.44223063195807,
                -34.568942905902965
              ],
              [
                135.4432072913193,
                -34.55877055997839
              ],
              [
                135.43848718625648,
                -34.54566824783369
              ],
              [
                135.42807055835925,
                -34.548923526351196
              ],
              [
                135.41871178639136,
                -34.55779388057421
              ],
              [
                135.4160262148923,
                -34.56178146525152
              ],
              [
                135.4078882026967,
                -34.57040778354689
              ],
              [
                135.40658612749993,
                -34.57756925698179
              ],
              [
                135.40495847521734,
                -34.5803360947207
              ],
              [
                135.39551839729336,
                -34.57610437376507
              ],
              [
                135.3891707579561,
                -34.56926846757112
              ],
              [
                135.38502044329167,
                -34.55877055997839
              ],
              [
                135.3825789207386,
                -34.54729573609023
              ],
              [
                135.38184650809427,
                -34.53801841038291
              ],
              [
                135.37973068256784,
                -34.53346122854516
              ],
              [
                135.376638182504,
                -34.523125845066616
              ],
              [
                135.37696375354403,
                -34.51262789182043
              ],
              [
                135.39161225024364,
                -34.50416446054304
              ],
              [
                135.39486734617927,
                -34.4950496678355
              ],
              [
                135.39584386672107,
                -34.483330840854876
              ],
              [
                135.39551845627895,
                -34.472426098080334
              ],
              [
                135.38843832168521,
                -34.45142989895164
              ],
              [
                135.36605875872397,
                -34.42197025179403
              ],
              [
                135.36133880711617,
                -34.40789166270529
              ],
              [
                135.34644616716935,
                -34.27556732942382
              ],
              [
                135.32862388774427,
                -34.2212867052589
              ],
              [
                135.3012801001561,
                -34.17978272755495
              ],
              [
                135.2651472624004,
                -34.17831783608057
              ],
              [
                135.24537194673547,
                -34.15935638879862
              ],
              [
                135.23747800370188,
                -34.1488582230668
              ],
              [
                135.23096766430075,
                -34.13681409826139
              ],
              [
                135.2490340195905,
                -34.134535357688065
              ],
              [
                135.26547287090318,
                -34.12704847063288
              ],
              [
                135.27312266557183,
                -34.11589948574083
              ],
              [
                135.2651472984513,
                -34.1032039706969
              ],
              [
                135.27116950187929,
                -34.09156673084238
              ],
              [
                135.27051847707128,
                -34.0819638983357
              ],
              [
                135.2674259577694,
                -34.07284918066857
              ],
              [
                135.26514740307087,
                -34.06218854333229
              ],
              [
                135.2651473544274,
                -34.01751071746955
              ],
              [
                135.2595320646973,
                -33.99797936377698
              ],
              [
                135.24610442356976,
                -33.98056417489233
              ],
              [
                135.21794685972617,
                -33.952325220555906
              ],
              [
                135.18978922096434,
                -33.8929988835541
              ],
              [
                135.17701254514924,
                -33.8834774322661
              ],
              [
                135.15430747723423,
                -33.87932706047702
              ],
              [
                135.13851980333868,
                -33.86907332060378
              ],
              [
                135.0643009495924,
                -33.79436609152865
              ],
              [
                135.00505620184472,
                -33.74627047141026
              ],
              [
                134.94556717844372,
                -33.71119542570349
              ],
              [
                134.9362084574819,
                -33.70191808748034
              ],
              [
                134.91285239009773,
                -33.68710699067828
              ],
              [
                134.9055282575203,
                -33.6812477821236
              ],
              [
                134.88819426832774,
                -33.65699647026142
              ],
              [
                134.8820907163006,
                -33.65064874480409
              ],
              [
                134.8498640824322,
                -33.63836019410251
              ],
              [
                134.84083094343075,
                -33.63128024159297
              ],
              [
                134.85425859876133,
                -33.6227351657044
              ],
              [
                134.8473413333285,
                -33.60271573623357
              ],
              [
                134.8530378878574,
                -33.58407955120984
              ],
              [
                134.86264079012884,
                -33.565036657219174
              ],
              [
                134.86793050672415,
                -33.544610229198085
              ],
              [
                134.8652449664734,
                -33.499769748195675
              ],
              [
                134.86101316726453,
                -33.47942464132513
              ],
              [
                134.85425861399497,
                -33.458916835490896
              ],
              [
                134.8242293704343,
                -33.39299897050978
              ],
              [
                134.8139754873325,
                -33.35279719231219
              ],
              [
                134.79900144001618,
                -33.33603269652028
              ],
              [
                134.76490313250417,
                -33.308037904345625
              ],
              [
                134.7307234491122,
                -33.273369942222686
              ],
              [
                134.71973716887783,
                -33.26677824097376
              ],
              [
                134.69613688897527,
                -33.2567684368466
              ],
              [
                134.6860457907367,
                -33.25009535274073
              ],
              [
                134.6766057411384,
                -33.23333113783469
              ],
              [
                134.69239343364217,
                -33.22861095200861
              ],
              [
                134.71607503530106,
                -33.228448114590975
              ],
              [
                134.73072353283828,
                -33.225518544748695
              ],
              [
                134.72868905018908,
                -33.21347431975655
              ],
              [
                134.71924891137476,
                -33.19264091724411
              ],
              [
                134.70622807216955,
                -33.17294689503607
              ],
              [
                134.69320719692544,
                -33.16415775063706
              ],
              [
                134.67017666738715,
                -33.16179785979172
              ],
              [
                134.60775803162582,
                -33.143650042730144
              ],
              [
                134.581553510922,
                -33.145928503469015
              ],
              [
                134.57064866017882,
                -33.16041437272903
              ],
              [
                134.57439212279183,
                -33.17685312258888
              ],
              [
                134.59083090947243,
                -33.184665592355785
              ],
              [
                134.61866298237925,
                -33.182875308079964
              ],
              [
                134.63038172855485,
                -33.1854794675247
              ],
              [
                134.63510175745537,
                -33.19451262495399
              ],
              [
                134.63843841627343,
                -33.20582461353317
              ],
              [
                134.64600663917767,
                -33.21168371836943
              ],
              [
                134.6550399742889,
                -33.21672955163096
              ],
              [
                134.66236415782362,
                -33.225518544748695
              ],
              [
                134.65235432462137,
                -33.227146016438816
              ],
              [
                134.64405358674492,
                -33.231133731340684
              ],
              [
                134.6365666711755,
                -33.237725655145695
              ],
              [
                134.62826577261458,
                -33.24667724680408
              ],
              [
                134.6048283322736,
                -33.21266043721816
              ],
              [
                134.5893660298275,
                -33.20208088511631
              ],
              [
                134.54175860115086,
                -33.19296628786118
              ],
              [
                134.47754960423597,
                -33.157321733054154
              ],
              [
                134.44605546553748,
                -33.15398514657513
              ],
              [
                134.42286219463466,
                -33.161716442838085
              ],
              [
                134.4021102725936,
                -33.17245869204307
              ],
              [
                134.3779403735647,
                -33.177829830456425
              ],
              [
                134.37842852066552,
                -33.171970188693656
              ],
              [
                134.36963948611256,
                -33.16082115691845
              ],
              [
                134.35914140258237,
                -33.15398514657513
              ],
              [
                134.35401446745777,
                -33.160739739990085
              ],
              [
                134.3538517437738,
                -33.17546962888504
              ],
              [
                134.35222419283517,
                -33.18816504678916
              ],
              [
                134.3462020764381,
                -33.19801209049276
              ],
              [
                134.33350673636923,
                -33.2050107330181
              ],
              [
                134.2788191456681,
                -33.162692845557594
              ],
              [
                134.2714949304891,
                -33.14666095203421
              ],
              [
                134.26970456706906,
                -33.12566486105763
              ],
              [
                134.26514727553044,
                -33.107110171890504
              ],
              [
                134.24195399192527,
                -33.05820081865323
              ],
              [
                134.23373456614746,
                -33.04729582133746
              ],
              [
                134.22144617380286,
                -33.041599244494144
              ],
              [
                134.19971762094406,
                -33.03997156706325
              ],
              [
                134.17066494400035,
                -33.04314550874677
              ],
              [
                134.16032963396594,
                -33.0401343948547
              ],
              [
                134.14861083821427,
                -33.02752037162682
              ],
              [
                134.16480557351483,
                -33.01832455383311
              ],
              [
                134.19849694176088,
                -33.01148854151779
              ],
              [
                134.20997152004537,
                -33.00017663121336
              ],
              [
                134.21192467883512,
                -32.98154063066083
              ],
              [
                134.2043562608058,
                -32.96217202263952
              ],
              [
                134.19068448649398,
                -32.94646584404031
              ],
              [
                134.1751407689644,
                -32.93816486781659
              ],
              [
                134.16407315480535,
                -32.938653336705585
              ],
              [
                134.1567488242895,
                -32.94353592644428
              ],
              [
                134.1518660462629,
                -32.94915122847259
              ],
              [
                134.148610907167,
                -32.9518369153776
              ],
              [
                134.13868251518286,
                -32.9494768754103
              ],
              [
                134.12061602998563,
                -32.93816486781659
              ],
              [
                134.08253012098717,
                -32.93596765988794
              ],
              [
                134.06869556090197,
                -32.92929463304116
              ],
              [
                134.05982507098125,
                -32.91082123199437
              ],
              [
                134.0676376310813,
                -32.90634544060037
              ],
              [
                134.07894943415195,
                -32.890801729457266
              ],
              [
                134.0870874976754,
                -32.88290793388295
              ],
              [
                134.11500088555775,
                -32.86638770549182
              ],
              [
                134.1240340046405,
                -32.85930745881382
              ],
              [
                134.1328231714098,
                -32.8356260265432
              ],
              [
                134.12452229092594,
                -32.80689861322595
              ],
              [
                134.10824631564228,
                -32.779392236748336
              ],
              [
                134.06959062051035,
                -32.73308670439285
              ],
              [
                134.0665795656109,
                -32.72584389185392
              ],
              [
                134.07406656128907,
                -32.71396241556597
              ],
              [
                134.0870874707592,
                -32.712579104380204
              ],
              [
                134.1171980488357,
                -32.71843827914541
              ],
              [
                134.19320718890205,
                -32.72136801995242
              ],
              [
                134.21680743054662,
                -32.72584389185392
              ],
              [
                134.2046004049273,
                -32.74138752279919
              ],
              [
                134.20036874267802,
                -32.74928162246527
              ],
              [
                134.19629972639055,
                -32.760023799737205
              ],
              [
                134.19532307700086,
                -32.76930096736289
              ],
              [
                134.1954859087279,
                -32.78297298704285
              ],
              [
                134.196950667544,
                -32.79558674733521
              ],
              [
                134.1997176220567,
                -32.800957896791324
              ],
              [
                134.21404055668535,
                -32.806247645310364
              ],
              [
                134.2207137877933,
                -32.803969108286786
              ],
              [
                134.22632890365736,
                -32.77971756820187
              ],
              [
                134.2322697033942,
                -32.768487190380796
              ],
              [
                134.24480229275073,
                -32.75261812273834
              ],
              [
                134.26465908375735,
                -32.73919043117515
              ],
              [
                134.27149505601213,
                -32.732110421394005
              ],
              [
                134.276133722913,
                -32.722914448144195
              ],
              [
                134.28353927843668,
                -32.702243787317016
              ],
              [
                134.29761802609343,
                -32.67848070896495
              ],
              [
                134.29664147348657,
                -32.660332944012694
              ],
              [
                134.2732853872932,
                -32.58806738778778
              ],
              [
                134.25407956717476,
                -32.554294415248094
              ],
              [
                134.22982829272397,
                -32.523695513287954
              ],
              [
                134.19564866337174,
                -32.49586360004425
              ],
              [
                134.14828532963713,
                -32.45696375418108
              ],
              [
                134.13111414661063,
                -32.451592742095926
              ],
              [
                134.11801192183822,
                -32.45208100201711
              ],
              [
                134.10865319885727,
                -32.45435964910516
              ],
              [
                134.10027106205746,
                -32.45964941269661
              ],
              [
                134.09050541784853,
                -32.46851981632153
              ],
              [
                134.08285563976997,
                -32.470472863315415
              ],
              [
                134.06324302719779,
                -32.46160245600759
              ],
              [
                134.05298916079582,
                -32.459079750185154
              ],
              [
                134.03199306537795,
                -32.46640396626604
              ],
              [
                134.01775152634048,
                -32.482598624050176
              ],
              [
                134.0063582499931,
                -32.49879318809477
              ],
              [
                133.99447676915557,
                -32.50611746678172
              ],
              [
                133.96924888500754,
                -32.50269945859156
              ],
              [
                133.9523217889254,
                -32.498223520796145
              ],
              [
                133.93669678165634,
                -32.500909052911574
              ],
              [
                133.9157821233775,
                -32.51978937497334
              ],
              [
                133.90984135978331,
                -32.52939222137261
              ],
              [
                133.90674895925872,
                -32.53720481842832
              ],
              [
                133.90121503505017,
                -32.5430640498819
              ],
              [
                133.88770588626767,
                -32.54705161183364
              ],
              [
                133.8753361413407,
                -32.54843516900425
              ],
              [
                133.86443111346802,
                -32.54680740172213
              ],
              [
                133.85670008403267,
                -32.541110971876364
              ],
              [
                133.85368906035566,
                -32.52971783358945
              ],
              [
                133.85482825490294,
                -32.52556718072885
              ],
              [
                133.86117601140123,
                -32.51336035444207
              ],
              [
                133.86394293553133,
                -32.509535477527955
              ],
              [
                133.86508219344122,
                -32.505791856259656
              ],
              [
                133.86158291397211,
                -32.49480566867514
              ],
              [
                133.86052491395273,
                -32.488864796800705
              ],
              [
                133.8591415037498,
                -32.459079750185154
              ],
              [
                133.8605249535751,
                -32.451592742095926
              ],
              [
                133.86915124044594,
                -32.43254974302764
              ],
              [
                133.88306723933133,
                -32.41025152981746
              ],
              [
                133.8962508519601,
                -32.39918386221036
              ],
              [
                133.90211023431428,
                -32.41399507532967
              ],
              [
                133.91089925900496,
                -32.42245853855515
              ],
              [
                133.9298609068089,
                -32.420017254508096
              ],
              [
                133.94662516786713,
                -32.40837975813553
              ],
              [
                133.94996176164423,
                -32.38941817891771
              ],
              [
                133.93995200550802,
                -32.3756649442032
              ],
              [
                133.90870205057178,
                -32.342950193164484
              ],
              [
                133.9021101891061,
                -32.324883654042516
              ],
              [
                133.8950301297503,
                -32.31365322354274
              ],
              [
                133.84742275476404,
                -32.27337011788904
              ],
              [
                133.83228601069183,
                -32.249932563883505
              ],
              [
                133.82642665042744,
                -32.24537530246758
              ],
              [
                133.8122664691938,
                -32.247165617176094
              ],
              [
                133.80241946969053,
                -32.254571227581806
              ],
              [
                133.79509527755638,
                -32.26279068429867
              ],
              [
                133.78882897682965,
                -32.26653412301506
              ],
              [
                133.77670329346762,
                -32.264255409895114
              ],
              [
                133.76929768997908,
                -32.25758222355985
              ],
              [
                133.7653914847128,
                -32.24797945139091
              ],
              [
                133.76368247484024,
                -32.22063564764332
              ],
              [
                133.76075278349984,
                -32.21648524969156
              ],
              [
                133.754567883361,
                -32.21575281800279
              ],
              [
                133.7350366568207,
                -32.20769622578799
              ],
              [
                133.7125756866671,
                -32.20183678386074
              ],
              [
                133.70346110685514,
                -32.19768639948138
              ],
              [
                133.69361414354293,
                -32.19109468929206
              ],
              [
                133.6920678880122,
                -32.18938563961175
              ],
              [
                133.6943465263895,
                -32.18580489680755
              ],
              [
                133.6960555431481,
                -32.174086212986055
              ],
              [
                133.69263758728727,
                -32.163506813401625
              ],
              [
                133.6843367516716,
                -32.160088730465986
              ],
              [
                133.67416427045737,
                -32.15837983990756
              ],
              [
                133.66488691872942,
                -32.15325287078449
              ],
              [
                133.66211998331997,
                -32.14373136822603
              ],
              [
                133.6694442082003,
                -32.13648854250725
              ],
              [
                133.67872156117593,
                -32.129978146352514
              ],
              [
                133.68238367727608,
                -32.122653940111604
              ],
              [
                133.67123459212533,
                -32.11004001618937
              ],
              [
                133.64918054442813,
                -32.10165782973306
              ],
              [
                133.62378989324705,
                -32.09685634292079
              ],
              [
                133.6032820771173,
                -32.095310112357794
              ],
              [
                133.58619225943778,
                -32.10312266538572
              ],
              [
                133.58139082318417,
                -32.121758726568984
              ],
              [
                133.57984457641223,
                -32.14430099697954
              ],
              [
                133.57252040026816,
                -32.163506813401625
              ],
              [
                133.56137131649956,
                -32.172133126304125
              ],
              [
                133.5520125371892,
                -32.17229577086834
              ],
              [
                133.50928795986144,
                -32.152520446979686
              ],
              [
                133.49634852359185,
                -32.14470798196389
              ],
              [
                133.4905705025973,
                -32.1393368336086
              ],
              [
                133.48666423934904,
                -32.11484136284772
              ],
              [
                133.47681723940818,
                -32.11191168643546
              ],
              [
                133.45036872122208,
                -32.129489915726275
              ],
              [
                133.43946374069472,
                -32.130629170640454
              ],
              [
                133.42798915620972,
                -32.130140939962715
              ],
              [
                133.41871177880185,
                -32.13347745902551
              ],
              [
                133.41480550806773,
                -32.14641686865832
              ],
              [
                133.41822351315514,
                -32.15691499114157
              ],
              [
                133.42676840127504,
                -32.16090255240827
              ],
              [
                133.45036870724869,
                -32.163506813401625
              ],
              [
                133.47266683622746,
                -32.17302819709126
              ],
              [
                133.49073328988092,
                -32.18694431256882
              ],
              [
                133.49431402862106,
                -32.19963964484999
              ],
              [
                133.47348069292337,
                -32.205173493217956
              ],
              [
                133.4642032945182,
                -32.20256921377649
              ],
              [
                133.44849691157907,
                -32.19207116060804
              ],
              [
                133.43588299817034,
                -32.19085049639852
              ],
              [
                133.4313257142654,
                -32.19443124229361
              ],
              [
                133.4270939370654,
                -32.2013485473619
              ],
              [
                133.42139731273488,
                -32.20818446282389
              ],
              [
                133.41179449050793,
                -32.211358380019604
              ],
              [
                133.35678141399563,
                -32.20598717121759
              ],
              [
                133.3260197405776,
                -32.199476849347406
              ],
              [
                133.30551190418095,
                -32.19085049639852
              ],
              [
                133.27947021370994,
                -32.214938988438604
              ],
              [
                133.27084396103263,
                -32.21884534136806
              ],
              [
                133.2622176224407,
                -32.21575281800279
              ],
              [
                133.24488362602924,
                -32.20110435403777
              ],
              [
                133.22429443759899,
                -32.195570509556994
              ],
              [
                133.20232180710184,
                -32.18670011984845
              ],
              [
                133.19263757003912,
                -32.18466563144751
              ],
              [
                133.18067467110254,
                -32.18670011984845
              ],
              [
                133.1618758509927,
                -32.19589610034766
              ],
              [
                133.15479574196664,
                -32.19768639948138
              ],
              [
                133.1477970868897,
                -32.19670992722382
              ],
              [
                133.14568118842666,
                -32.193780211074575
              ],
              [
                133.14283291112218,
                -32.18775813819673
              ],
              [
                133.13428799053017,
                -32.17717871418347
              ],
              [
                133.05567466040313,
                -32.108168196322175
              ],
              [
                133.03394616620383,
                -32.097100532047484
              ],
              [
                133.01075278020556,
                -32.095310112357794
              ],
              [
                133.00342854916582,
                -32.09970461593733
              ],
              [
                132.99626710397752,
                -32.106621963000265
              ],
              [
                132.98780359257185,
                -32.1114234572258
              ],
              [
                132.97657310462571,
                -32.10898201139021
              ],
              [
                132.97315513200246,
                -32.10068122276003
              ],
              [
                132.97120202957743,
                -32.086521114268294
              ],
              [
                132.9660750466751,
                -32.07317469728664
              ],
              [
                132.95297286193843,
                -32.06731538394624
              ],
              [
                132.9342553981034,
                -32.06170011345832
              ],
              [
                132.86882573788589,
                -32.01531345316315
              ],
              [
                132.84408613309998,
                -31.990655204094146
              ],
              [
                132.79802491670264,
                -31.95631271705088
              ],
              [
                132.77621505951714,
                -31.950860325433556
              ],
              [
                132.7526961345087,
                -31.949476766870117
              ],
              [
                132.70484457664816,
                -31.952080944773595
              ],
              [
                132.65894619190544,
                -31.949314127798385
              ],
              [
                132.5872502216596,
                -31.934747057596223
              ],
              [
                132.56364991455933,
                -31.93417729637093
              ],
              [
                132.51612389900862,
                -31.94133881065878
              ],
              [
                132.49447675583713,
                -31.947198168269775
              ],
              [
                132.47584070384553,
                -31.955010702326202
              ],
              [
                132.46273847629473,
                -31.96493905850028
              ],
              [
                132.45289146379406,
                -31.983982011566116
              ],
              [
                132.45769291437347,
                -31.997328402899754
              ],
              [
                132.470225431403,
                -32.009942261697205
              ],
              [
                132.48316492311716,
                -32.026462525801286
              ],
              [
                132.47185307412963,
                -32.03045015582435
              ],
              [
                132.46257573438862,
                -32.028903940855436
              ],
              [
                132.44166097958248,
                -32.019626508213776
              ],
              [
                132.42009528144283,
                -32.01384863695978
              ],
              [
                132.39779708258848,
                -32.012790647594194
              ],
              [
                132.37484785108083,
                -32.01506926704905
              ],
              [
                132.3261824568306,
                -32.033135608881466
              ],
              [
                132.2780867645722,
                -32.03801844466225
              ],
              [
                132.233734595916,
                -32.03297296789049
              ],
              [
                132.19459072095418,
                -32.017836259653016
              ],
              [
                132.16163171922514,
                -31.991631795019522
              ],
              [
                132.10743246077837,
                -31.932386918862495
              ],
              [
                132.07789149026263,
                -31.90781019306129
              ],
              [
                131.92310634048744,
                -31.823988592663618
              ],
              [
                131.7829696234353,
                -31.727797190198444
              ],
              [
                131.5358993007469,
                -31.605564094355746
              ]
            ]
          ],
          [
            [
              [
                128.15886478017546,
                -15.090264581993
              ],
              [
                128.16260826849614,
                -15.097263276148919
              ],
              [
                128.1713973328138,
                -15.101006773601823
              ],
              [
                128.18067467490286,
                -15.103936455450194
              ],
              [
                128.18677819079397,
                -15.10759856483535
              ],
              [
                128.1945093111989,
                -15.126885676121956
              ],
              [
                128.1985783215749,
                -15.152032162236118
              ],
              [
                128.19678795649975,
                -15.175551037189019
              ],
              [
                128.18677819112852,
                -15.19019947772072
              ],
              [
                128.18189537854315,
                -15.181898693434107
              ],
              [
                128.1740828798322,
                -15.17408620067661
              ],
              [
                128.16382897114866,
                -15.167250253212293
              ],
              [
                128.15202884336594,
                -15.162286073685111
              ],
              [
                128.13396243550278,
                -15.146579682197972
              ],
              [
                128.1259871754082,
                -15.134698177302033
              ],
              [
                128.12427819117744,
                -15.119561457002028
              ],
              [
                128.1237899102007,
                -15.048597916140702
              ],
              [
                128.13135826909183,
                -15.03753020652195
              ],
              [
                128.1520288417222,
                -15.052422782421747
              ],
              [
                128.15772545728902,
                -15.087090754636174
              ],
              [
                128.15886478017546,
                -15.090264581993
              ]
            ]
          ],
          [
            [
              [
                128.41618897271312,
                -14.956231233418535
              ],
              [
                128.4295353373111,
                -14.965915539095727
              ],
              [
                128.43783610767147,
                -14.988946071929021
              ],
              [
                128.44125410199578,
                -15.016289971975693
              ],
              [
                128.4406844409352,
                -15.03875090863198
              ],
              [
                128.41277102993644,
                -15.018243096638209
              ],
              [
                128.35824627102886,
                -14.95631264948183
              ],
              [
                128.35132897356246,
                -14.932712506956637
              ],
              [
                128.34839929191224,
                -14.882989230803162
              ],
              [
                128.35377037778278,
                -14.869235927982126
              ],
              [
                128.3717554243738,
                -14.874281619628766
              ],
              [
                128.38493899264623,
                -14.891696842203276
              ],
              [
                128.40935305734803,
                -14.944919508096737
              ],
              [
                128.41618897271312,
                -14.956231233418535
              ]
            ]
          ],
          [
            [
              [
                129.63249760761764,
                -14.84693784733056
              ],
              [
                129.6349390203025,
                -14.859307677422677
              ],
              [
                129.63363692146257,
                -14.870700815885542
              ],
              [
                129.62663820653538,
                -14.875258011292832
              ],
              [
                129.611827031137,
                -14.867364260305056
              ],
              [
                129.60645592070492,
                -14.857598541450884
              ],
              [
                129.5900984932009,
                -14.836358269151292
              ],
              [
                129.5852157038311,
                -14.826430019554572
              ],
              [
                129.58130946037568,
                -14.80877055225185
              ],
              [
                129.58301843015374,
                -14.8038062776042
              ],
              [
                129.58904056897538,
                -14.80657322079943
              ],
              [
                129.60645590052437,
                -14.817071081596815
              ],
              [
                129.61646568992032,
                -14.824883715810982
              ],
              [
                129.62598716896898,
                -14.835056213464007
              ],
              [
                129.63249760761764,
                -14.84693784733056
              ]
            ]
          ],
          [
            [
              [
                129.53345789732512,
                -14.79851663935587
              ],
              [
                129.57781010322665,
                -14.860528317163137
              ],
              [
                129.58708742804777,
                -14.883477426647492
              ],
              [
                129.59099367472314,
                -14.909356313837874
              ],
              [
                129.59148198713032,
                -14.963637090977786
              ],
              [
                129.58912192988012,
                -14.952325064973714
              ],
              [
                129.58480880850928,
                -14.942478228004017
              ],
              [
                129.5789493966714,
                -14.93450275894153
              ],
              [
                129.5715438383299,
                -14.92888775484607
              ],
              [
                129.55779053565087,
                -14.907810009714183
              ],
              [
                129.53484132911146,
                -14.858168153297798
              ],
              [
                129.51978599320677,
                -14.836358269151292
              ],
              [
                129.5046492738216,
                -14.802911001743395
              ],
              [
                129.50196375632072,
                -14.79851663935587
              ],
              [
                129.50814861478108,
                -14.785739731356188
              ],
              [
                129.51547284051634,
                -14.787204618900748
              ],
              [
                129.52393639567265,
                -14.794203392620519
              ],
              [
                129.53345789732512,
                -14.79851663935587
              ]
            ]
          ],
          [
            [
              [
                126.50098719118549,
                -13.873711950722749
              ],
              [
                126.52320398109453,
                -13.870863598286563
              ],
              [
                126.5539656721501,
                -13.875257950269958
              ],
              [
                126.5857039551914,
                -13.884209786461065
              ],
              [
                126.61085046784045,
                -13.894219728276495
              ],
              [
                126.61085046597738,
                -13.901055654333783
              ],
              [
                126.59864343620205,
                -13.90520605952099
              ],
              [
                126.58562257937675,
                -13.902113459372801
              ],
              [
                126.57129968175722,
                -13.896905249184705
              ],
              [
                126.55567468583574,
                -13.894219728276495
              ],
              [
                126.53956137356477,
                -13.897881638376694
              ],
              [
                126.52588952389625,
                -13.90374117528263
              ],
              [
                126.51514732091346,
                -13.904880396166517
              ],
              [
                126.50782312383163,
                -13.894219728276495
              ],
              [
                126.50562583882356,
                -13.8898250756824
              ],
              [
                126.50098719118549,
                -13.873711950722749
              ]
            ]
          ],
          [
            [
              [
                134.88526451682725,
                -12.057549722434285
              ],
              [
                134.90723716454215,
                -12.059828308112056
              ],
              [
                134.91822350740085,
                -12.06316499634279
              ],
              [
                134.9262801342961,
                -12.06812909557837
              ],
              [
                134.93287194448214,
                -12.087334918861806
              ],
              [
                134.92481530567773,
                -12.106703423461253
              ],
              [
                134.90796958771787,
                -12.117852405916652
              ],
              [
                134.8883569731724,
                -12.112237281974442
              ],
              [
                134.87810305351763,
                -12.100274293624011
              ],
              [
                134.86719810297944,
                -12.076755395343373
              ],
              [
                134.8542586521643,
                -12.037774290742917
              ],
              [
                134.88021895346904,
                -12.054945624521784
              ],
              [
                134.88526451682725,
                -12.057549722434285
              ]
            ]
          ],
          [
            [
              [
                134.96525628924928,
                -12.02646473097204
              ],
              [
                134.9844845334383,
                -12.036160849622611
              ],
              [
                134.98598553706367,
                -12.041450310776066
              ],
              [
                134.94872871474126,
                -12.054668931608218
              ],
              [
                134.93521018167547,
                -12.050258518676527
              ],
              [
                134.92078856671878,
                -12.040262874588196
              ],
              [
                134.90936965331,
                -12.035850058292613
              ],
              [
                134.9084717811414,
                -12.022624828265684
              ],
              [
                134.95624613672825,
                -12.016468636425055
              ],
              [
                134.96525628924928,
                -12.02646473097204
              ]
            ]
          ],
          [
            [
              [
                135.12196248888748,
                -11.929696422132622
              ],
              [
                135.1074843936137,
                -11.942097881557475
              ],
              [
                135.08485199011923,
                -11.946092804161522
              ],
              [
                135.05769679663112,
                -11.953185124954025
              ],
              [
                135.04607180751526,
                -11.941501534773758
              ],
              [
                135.0538885027822,
                -11.919436703947682
              ],
              [
                135.08446760838402,
                -11.920041012026967
              ],
              [
                135.1108544390196,
                -11.924958394408355
              ],
              [
                135.12196248888748,
                -11.929696422132622
              ]
            ]
          ],
          [
            [
              [
                133.40870202270867,
                -11.59205497415499
              ],
              [
                133.4290470639415,
                -11.586683798391391
              ],
              [
                133.45427493461415,
                -11.583672773473351
              ],
              [
                133.4754337911486,
                -11.58717214171967
              ],
              [
                133.48438561155206,
                -11.601983320023997
              ],
              [
                133.47437585302953,
                -11.611097960663772
              ],
              [
                133.45167076142857,
                -11.616387570678775
              ],
              [
                133.41179447358502,
                -11.619398745852084
              ],
              [
                133.3961694749679,
                -11.623223626304737
              ],
              [
                133.39844812273293,
                -11.63258236359177
              ],
              [
                133.4065047540345,
                -11.64381275826043
              ],
              [
                133.4087020196353,
                -11.653497007792447
              ],
              [
                133.3987736281452,
                -11.662367401864758
              ],
              [
                133.38575279554058,
                -11.66619228239278
              ],
              [
                133.37208092878225,
                -11.665297161508253
              ],
              [
                133.36019941132997,
                -11.660332913320616
              ],
              [
                133.367035352635,
                -11.653497007792447
              ],
              [
                133.35840904319383,
                -11.628838748501638
              ],
              [
                133.3595483817587,
                -11.61736425734784
              ],
              [
                133.37086022818352,
                -11.612481424859732
              ],
              [
                133.3808699893032,
                -11.609633080877602
              ],
              [
                133.40870202270867,
                -11.59205497415499
              ]
            ]
          ],
          [
            [
              [
                133.47689863555442,
                -11.454847926961536
              ],
              [
                133.48080489333339,
                -11.470879887702608
              ],
              [
                133.48894289789192,
                -11.484063354469596
              ],
              [
                133.49952233236922,
                -11.494561458828528
              ],
              [
                133.51099694070942,
                -11.503187755775048
              ],
              [
                133.49333743023388,
                -11.508965708878682
              ],
              [
                133.47584068624457,
                -11.507256732601343
              ],
              [
                133.4589949911994,
                -11.503594683500053
              ],
              [
                133.4428817067096,
                -11.503187755775048
              ],
              [
                133.42969811188536,
                -11.509047124466498
              ],
              [
                133.41529380624948,
                -11.519952006431105
              ],
              [
                133.40259850878275,
                -11.53264743053266
              ],
              [
                133.39503013795493,
                -11.544203336876386
              ],
              [
                133.39551841612416,
                -11.536553576225229
              ],
              [
                133.39682051144297,
                -11.531914990662626
              ],
              [
                133.40186607591204,
                -11.523125862450948
              ],
              [
                133.40300539708767,
                -11.512383661436438
              ],
              [
                133.4023543695373,
                -11.502618147088064
              ],
              [
                133.39958744552018,
                -11.494724290003358
              ],
              [
                133.39503014403948,
                -11.489027602302256
              ],
              [
                133.4240015070024,
                -11.485040041088649
              ],
              [
                133.44369550706872,
                -11.475518473165966
              ],
              [
                133.459727417834,
                -11.464288079233784
              ],
              [
                133.47689863555442,
                -11.454847926961536
              ]
            ]
          ],
          [
            [
              [
                147.99854572746125,
                -43.230401251144805
              ],
              [
                147.97803796385705,
                -43.2282040420663
              ],
              [
                147.9640406220288,
                -43.22242611181055
              ],
              [
                147.9045515256396,
                -43.18027097018534
              ],
              [
                147.894867473331,
                -43.169040728320745
              ],
              [
                147.88965897704625,
                -43.153090015945764
              ],
              [
                147.88795003403234,
                -43.13795334527505
              ],
              [
                147.8828230983966,
                -43.13152432976272
              ],
              [
                147.86752355180732,
                -43.14169677600186
              ],
              [
                147.85678141729986,
                -43.15618251614156
              ],
              [
                147.85377035487585,
                -43.17229580255242
              ],
              [
                147.85743242547045,
                -43.188246278299246
              ],
              [
                147.86752363113487,
                -43.20305754662461
              ],
              [
                147.8375755956803,
                -43.2019180840422
              ],
              [
                147.82146244066686,
                -43.21428802449777
              ],
              [
                147.80974377265628,
                -43.23121520404696
              ],
              [
                147.79249103217518,
                -43.24407311634001
              ],
              [
                147.77198335103805,
                -43.216892281671996
              ],
              [
                147.70020592136555,
                -43.16277434270842
              ],
              [
                147.69556729749075,
                -43.13420994539537
              ],
              [
                147.70850673675542,
                -43.13005953816463
              ],
              [
                147.73389721919642,
                -43.11825923966714
              ],
              [
                147.74789465770144,
                -43.105726739068
              ],
              [
                147.66456137533643,
                -43.08180101790616
              ],
              [
                147.64779718132368,
                -43.07284934764833
              ],
              [
                147.63819423150883,
                -43.061293256035455
              ],
              [
                147.62720782863997,
                -43.0427384803016
              ],
              [
                147.62061619207014,
                -43.02312603956074
              ],
              [
                147.62427819473345,
                -43.008233335430184
              ],
              [
                147.63355547554195,
                -43.001153182433846
              ],
              [
                147.66602612599232,
                -42.98943437005023
              ],
              [
                147.6790469454641,
                -42.98642328599263
              ],
              [
                147.6826278467239,
                -42.984551746461406
              ],
              [
                147.68604564882176,
                -42.976739048317924
              ],
              [
                147.68490644471396,
                -42.97193775647285
              ],
              [
                147.68262768418936,
                -42.96835689146621
              ],
              [
                147.68262787580446,
                -42.96355568703603
              ],
              [
                147.68100014893412,
                -42.955743041084254
              ],
              [
                147.6770125121651,
                -42.94687259002381
              ],
              [
                147.67823326755175,
                -42.939222913278364
              ],
              [
                147.69255619132096,
                -42.93621185332451
              ],
              [
                147.71517980180226,
                -42.937432452315996
              ],
              [
                147.7258407059634,
                -42.940525015779535
              ],
              [
                147.73047930914564,
                -42.94687259002381
              ],
              [
                147.7308048665461,
                -42.976820550284046
              ],
              [
                147.72722421449174,
                -42.987969729588514
              ],
              [
                147.71680752364819,
                -43.00514092527907
              ],
              [
                147.76303139933475,
                -43.03753015072402
              ],
              [
                147.7858177823925,
                -43.04859776983814
              ],
              [
                147.8164168705162,
                -43.05291107489573
              ],
              [
                147.82325272212728,
                -43.05193441083434
              ],
              [
                147.83383217005652,
                -43.04753990460131
              ],
              [
                147.84034260223808,
                -43.046075078570254
              ],
              [
                147.8409937576904,
                -43.04615659285243
              ],
              [
                147.85865324056124,
                -43.04558690565442
              ],
              [
                147.86068765423227,
                -43.046075078570254
              ],
              [
                147.87549893572708,
                -43.04094822438383
              ],
              [
                147.88705495929693,
                -43.034437847123854
              ],
              [
                147.90919040776842,
                -43.0187315055975
              ],
              [
                147.87924228091111,
                -43.01799883391548
              ],
              [
                147.85906015584663,
                -43.00750098464473
              ],
              [
                147.84506266920766,
                -42.98870204923606
              ],
              [
                147.8335067828819,
                -42.96355568703603
              ],
              [
                147.84351638327684,
                -42.96404377273581
              ],
              [
                147.84978285326923,
                -42.9623350188958
              ],
              [
                147.86068781874738,
                -42.95671980464611
              ],
              [
                147.86068761601285,
                -42.950453288073355
              ],
              [
                147.83383215076108,
                -42.944512537489295
              ],
              [
                147.83155361161084,
                -42.931898731167536
              ],
              [
                147.8388776916825,
                -42.916599088302924
              ],
              [
                147.84034262276413,
                -42.902032133757814
              ],
              [
                147.8269148587758,
                -42.89397545809188
              ],
              [
                147.76514731077495,
                -42.902032133757814
              ],
              [
                147.7570092043512,
                -42.89967200615112
              ],
              [
                147.7399195174544,
                -42.89129003203271
              ],
              [
                147.7304793493514,
                -42.88844164875771
              ],
              [
                147.72038815151114,
                -42.88909262806301
              ],
              [
                147.6894638516257,
                -42.89527773722658
              ],
              [
                147.67652425719027,
                -42.88982509489503
              ],
              [
                147.66919995994377,
                -42.88250078271587
              ],
              [
                147.66358473235525,
                -42.874688290317664
              ],
              [
                147.6552840719747,
                -42.867364217180096
              ],
              [
                147.64771560886007,
                -42.86532958712883
              ],
              [
                147.62818434868197,
                -42.863864731982005
              ],
              [
                147.62126719319983,
                -42.861097998669834
              ],
              [
                147.61793064638928,
                -42.854262109793346
              ],
              [
                147.61695392867628,
                -42.84514734233669
              ],
              [
                147.6145124708425,
                -42.83521889448915
              ],
              [
                147.60694425434855,
                -42.82634862249874
              ],
              [
                147.5957138571314,
                -42.821465895185945
              ],
              [
                147.58562247333063,
                -42.82122147135446
              ],
              [
                147.5335392708145,
                -42.83660248610028
              ],
              [
                147.51531004870617,
                -42.84514734233669
              ],
              [
                147.50391697430334,
                -42.854262109793346
              ],
              [
                147.50294026337113,
                -42.882093964335105
              ],
              [
                147.51929781425648,
                -42.918552451845045
              ],
              [
                147.5590926272587,
                -42.97722745210687
              ],
              [
                147.5398055279,
                -43.00432707256889
              ],
              [
                147.52930736160945,
                -43.01490635795146
              ],
              [
                147.5114039113733,
                -43.02499773634419
              ],
              [
                147.45435624984967,
                -43.038262549481246
              ],
              [
                147.4362084883522,
                -43.046075078570254
              ],
              [
                147.4261173644373,
                -43.03866950577539
              ],
              [
                147.41334068701482,
                -43.025323170266546
              ],
              [
                147.40349377177634,
                -43.01043069893215
              ],
              [
                147.40211018948435,
                -42.99822352734571
              ],
              [
                147.41667732663973,
                -42.984551746461406
              ],
              [
                147.43051202186376,
                -42.993585021030974
              ],
              [
                147.4428816597394,
                -43.00994225985195
              ],
              [
                147.45329848043622,
                -43.0187315055975
              ],
              [
                147.46900474340603,
                -43.011325766416526
              ],
              [
                147.47966545240843,
                -42.99480546796261
              ],
              [
                147.48373455815909,
                -42.97844815973437
              ],
              [
                147.48031665981475,
                -42.970961264748055
              ],
              [
                147.46648204269349,
                -42.96355568703603
              ],
              [
                147.46607511592288,
                -42.94589615141362
              ],
              [
                147.47730555330614,
                -42.908868118808634
              ],
              [
                147.4582626815049,
                -42.91366966660279
              ],
              [
                147.4382429872544,
                -42.923516477128736
              ],
              [
                147.4222112287235,
                -42.92693461582856
              ],
              [
                147.4157821668224,
                -42.91228614920792
              ],
              [
                147.40967846748043,
                -42.88811600742126
              ],
              [
                147.39437916992597,
                -42.87769955804373
              ],
              [
                147.37427828565765,
                -42.87200297597263
              ],
              [
                147.35368906807255,
                -42.861097998669834
              ],
              [
                147.29908297664875,
                -42.788751025897405
              ],
              [
                147.2942001347528,
                -42.77857846533384
              ],
              [
                147.28370201498817,
                -42.77849699819517
              ],
              [
                147.27295973730713,
                -42.78264728059947
              ],
              [
                147.26002046804896,
                -42.790134479626204
              ],
              [
                147.2680770442422,
                -42.799981408213824
              ],
              [
                147.28052811680004,
                -42.809340013218176
              ],
              [
                147.28598071443952,
                -42.812676750147055
              ],
              [
                147.3043726388974,
                -42.82919692907059
              ],
              [
                147.31959060196397,
                -42.84685627161626
              ],
              [
                147.3365992157005,
                -42.882419601440986
              ],
              [
                147.35914140794247,
                -42.91082114562927
              ],
              [
                147.36019930782436,
                -42.925225391278914
              ],
              [
                147.34001724531518,
                -42.95671980464611
              ],
              [
                147.33082109712325,
                -42.97861086017348
              ],
              [
                147.32943760287074,
                -42.99797931423371
              ],
              [
                147.33318128011013,
                -43.042657270783714
              ],
              [
                147.32374112266737,
                -43.046319317302405
              ],
              [
                147.3029892039996,
                -43.034437847123854
              ],
              [
                147.2717391184202,
                -43.011325766416526
              ],
              [
                147.25440521712534,
                -43.02727638694337
              ],
              [
                147.26294999249467,
                -43.04420329565276
              ],
              [
                147.29224700696352,
                -43.066013357319825
              ],
              [
                147.30128022647074,
                -43.083103220864736
              ],
              [
                147.29371173890783,
                -43.092461792316094
              ],
              [
                147.2767034048556,
                -43.100681347474335
              ],
              [
                147.25757908174364,
                -43.11435325314999
              ],
              [
                147.24773189695563,
                -43.129164237960694
              ],
              [
                147.2448835578615,
                -43.144626438963655
              ],
              [
                147.24683684196006,
                -43.16025162746788
              ],
              [
                147.2566023402376,
                -43.197198092459715
              ],
              [
                147.25814860250097,
                -43.215020403750536
              ],
              [
                147.25757908242207,
                -43.25432721143701
              ],
              [
                147.2492781717002,
                -43.268161694209354
              ],
              [
                147.2302351737627,
                -43.28045007104988
              ],
              [
                147.20866934956717,
                -43.286716265359956
              ],
              [
                147.1926374383479,
                -43.28167068025771
              ],
              [
                147.18490646498321,
                -43.27654390042127
              ],
              [
                147.16382888469948,
                -43.270114738854936
              ],
              [
                147.1544702002075,
                -43.26458093152108
              ],
              [
                147.15414469540764,
                -43.25741949165813
              ],
              [
                147.15886477486887,
                -43.24846769993363
              ],
              [
                147.15870193145454,
                -43.24098062347784
              ],
              [
                147.1445417554837,
                -43.23788815183933
              ],
              [
                147.1030379884949,
                -43.238702118258814
              ],
              [
                147.0921329406711,
                -43.231866063144295
              ],
              [
                147.10320060028744,
                -43.213311317828754
              ],
              [
                147.11801195127399,
                -43.19695407695869
              ],
              [
                147.1189883561875,
                -43.18914139089299
              ],
              [
                147.11280364734617,
                -43.17880632543076
              ],
              [
                147.10661863455778,
                -43.15471764500004
              ],
              [
                147.0978297277697,
                -43.17490012217144
              ],
              [
                147.07911214339495,
                -43.191827043555186
              ],
              [
                147.06055759106832,
                -43.201592828093766
              ],
              [
                147.05201247378906,
                -43.1996394717552
              ],
              [
                147.028493651841,
                -43.18515386350778
              ],
              [
                147.02409924966528,
                -43.17929464123814
              ],
              [
                147.0240991232191,
                -43.13795334527505
              ],
              [
                147.0178328539659,
                -43.11239996826075
              ],
              [
                147.00318432147444,
                -43.10995844998582
              ],
              [
                146.98609466473204,
                -43.11972429746244
              ],
              [
                146.972911129322,
                -43.13111759484141
              ],
              [
                146.96558667843323,
                -43.147718881487116
              ],
              [
                146.96265717632485,
                -43.17441181110238
              ],
              [
                146.9664820674789,
                -43.198988659111365
              ],
              [
                146.97999106651977,
                -43.20989346965637
              ],
              [
                146.9912215347277,
                -43.214125239906245
              ],
              [
                147.06226645136707,
                -43.253676015594195
              ],
              [
                147.08130945882016,
                -43.2671851750678
              ],
              [
                147.09595778272362,
                -43.28281004023768
              ],
              [
                147.0997827605055,
                -43.299411731769545
              ],
              [
                147.09441170372364,
                -43.306573232535555
              ],
              [
                147.0838323539275,
                -43.31560652785687
              ],
              [
                147.07252025067046,
                -43.32317458650755
              ],
              [
                147.06511476405763,
                -43.326592687180806
              ],
              [
                147.05298920601516,
                -43.32610451592067
              ],
              [
                147.04786228905954,
                -43.321954168673614
              ],
              [
                147.0447698032303,
                -43.31666441102249
              ],
              [
                147.03834061849872,
                -43.31292074536851
              ],
              [
                147.01937918837433,
                -43.31218851103209
              ],
              [
                146.99675532629115,
                -43.31658284801979
              ],
              [
                146.97592219501993,
                -43.32586043049026
              ],
              [
                146.96265697582174,
                -43.34026443790974
              ],
              [
                147.02133227978038,
                -43.337172195304646
              ],
              [
                147.03834056975933,
                -43.34026443790974
              ],
              [
                147.0551863855536,
                -43.34889087303474
              ],
              [
                147.05534914358765,
                -43.35621508853824
              ],
              [
                147.0315047591549,
                -43.37444427507843
              ],
              [
                147.02133220800295,
                -43.386407136604866
              ],
              [
                147.00505606441473,
                -43.413750765756696
              ],
              [
                146.99732505492406,
                -43.422784099953475
              ],
              [
                146.9812117666305,
                -43.42962002836403
              ],
              [
                146.9612736279799,
                -43.43132902690872
              ],
              [
                146.92164145363805,
                -43.42962002836403
              ],
              [
                146.9419051356958,
                -43.443780196220075
              ],
              [
                147.00115001776453,
                -43.45566181322349
              ],
              [
                147.0178328764012,
                -43.47812265094377
              ],
              [
                146.96241302811362,
                -43.47242612367362
              ],
              [
                146.94337010224066,
                -43.4766579444202
              ],
              [
                146.93604565896024,
                -43.49521236857974
              ],
              [
                146.94068441923648,
                -43.50269945140918
              ],
              [
                146.94971751603694,
                -43.50937250357013
              ],
              [
                146.95533295425847,
                -43.517836284448514
              ],
              [
                146.94955478202596,
                -43.53199623219326
              ],
              [
                146.93995206440164,
                -43.53728611933715
              ],
              [
                146.92603593054142,
                -43.53834392169587
              ],
              [
                146.91179449615115,
                -43.53639091725361
              ],
              [
                146.9017032190591,
                -43.53199623219326
              ],
              [
                146.89405366569648,
                -43.55787535630317
              ],
              [
                146.90609776835,
                -43.56682698278222
              ],
              [
                146.92603608000746,
                -43.57057066022331
              ],
              [
                146.942149204613,
                -43.581149903671715
              ],
              [
                146.94223071147545,
                -43.59832127651115
              ],
              [
                146.9270125665269,
                -43.611748956617774
              ],
              [
                146.85572356813228,
                -43.63958106318516
              ],
              [
                146.84652753231055,
                -43.64128996298503
              ],
              [
                146.8315536944991,
                -43.63990663990838
              ],
              [
                146.83025157164437,
                -43.636000344359566
              ],
              [
                146.83204189203263,
                -43.62981539705023
              ],
              [
                146.826182439344,
                -43.6215145239202
              ],
              [
                146.80323315143093,
                -43.61044673501549
              ],
              [
                146.78150472538834,
                -43.60849371441335
              ],
              [
                146.75961339648333,
                -43.61296956447998
              ],
              [
                146.7107040288793,
                -43.62900162676619
              ],
              [
                146.7004501258169,
                -43.623630537229104
              ],
              [
                146.69288162071598,
                -43.60857502665198
              ],
              [
                146.67514071786889,
                -43.587334772782405
              ],
              [
                146.60840912148657,
                -43.55885190512383
              ],
              [
                146.60010831938655,
                -43.55250422430691
              ],
              [
                146.5911565102797,
                -43.53573991769767
              ],
              [
                146.582041947508,
                -43.49472431663284
              ],
              [
                146.5721134744091,
                -43.47812265094377
              ],
              [
                146.5546980161693,
                -43.4694148577406
              ],
              [
                146.5481877298924,
                -43.48186618398116
              ],
              [
                146.55014075589392,
                -43.50416424424377
              ],
              [
                146.55844171534375,
                -43.52516054854384
              ],
              [
                146.54379304635987,
                -43.521579545188594
              ],
              [
                146.53809656659402,
                -43.51848725755739
              ],
              [
                146.51351976488164,
                -43.53394952163622
              ],
              [
                146.48910577981394,
                -43.53720482029729
              ],
              [
                146.3779403650074,
                -43.52849707968058
              ],
              [
                146.35865318150968,
                -43.520277590801506
              ],
              [
                146.3393661994388,
                -43.504815501650135
              ],
              [
                146.3186141619611,
                -43.52288180790133
              ],
              [
                146.3055118481606,
                -43.530450049123225
              ],
              [
                146.29167717848247,
                -43.53199623219326
              ],
              [
                146.27898191460943,
                -43.525648634155104
              ],
              [
                146.27442473271086,
                -43.51523209714581
              ],
              [
                146.27149492762052,
                -43.50302492667831
              ],
              [
                146.26384521835965,
                -43.491794493975824
              ],
              [
                146.25367283280718,
                -43.48723736895827
              ],
              [
                146.23812916740533,
                -43.48455176831349
              ],
              [
                146.22185305442804,
                -43.48544686523074
              ],
              [
                146.2091577183707,
                -43.491794493975824
              ],
              [
                146.2038679322625,
                -43.50448972059276
              ],
              [
                146.20337971389682,
                -43.51913823162727
              ],
              [
                146.20069410554564,
                -43.53199623219326
              ],
              [
                146.18921959660517,
                -43.539483330533706
              ],
              [
                146.1801863500652,
                -43.52385827909927
              ],
              [
                146.17164144538248,
                -43.51213954954481
              ],
              [
                146.1613876832959,
                -43.504815501650135
              ],
              [
                146.14991285289793,
                -43.5056290419385
              ],
              [
                146.11540769194923,
                -43.5150692027419
              ],
              [
                146.10670008254507,
                -43.51848725755739
              ],
              [
                146.1056420790876,
                -43.52385827909927
              ],
              [
                146.10808357494489,
                -43.54127374909562
              ],
              [
                146.10670003848568,
                -43.54631923649978
              ],
              [
                146.09937589890072,
                -43.54778417430616
              ],
              [
                146.0925399419208,
                -43.54469170271021
              ],
              [
                146.08594805094359,
                -43.540785341677235
              ],
              [
                146.07935631560545,
                -43.539483330533706
              ],
              [
                146.0241805851885,
                -43.55250422430691
              ],
              [
                146.0307723661839,
                -43.48267998646695
              ],
              [
                146.02393645053155,
                -43.45183691398035
              ],
              [
                146.0002547803025,
                -43.41936617519623
              ],
              [
                145.94385825014223,
                -43.386407136604866
              ],
              [
                145.93482497770856,
                -43.378106273117275
              ],
              [
                145.9432073307956,
                -43.364841527337575
              ],
              [
                145.9633895029577,
                -43.368910395941874
              ],
              [
                145.98609462692315,
                -43.37867607553299
              ],
              [
                146.00367263665396,
                -43.38193114667441
              ],
              [
                145.99805756057103,
                -43.371270527186695
              ],
              [
                145.97575938616785,
                -43.347751649341625
              ],
              [
                145.99390716552466,
                -43.34498471444181
              ],
              [
                146.0856227189091,
                -43.35393660670054
              ],
              [
                146.1130476267323,
                -43.36435300992581
              ],
              [
                146.12916103202525,
                -43.38160576024408
              ],
              [
                146.14226324053686,
                -43.40064872390294
              ],
              [
                146.1613876518565,
                -43.4159482767278
              ],
              [
                146.16586342078503,
                -43.40422935837404
              ],
              [
                146.15951589687464,
                -43.38518654597666
              ],
              [
                146.1613875711244,
                -43.37444427507843
              ],
              [
                146.167247016336,
                -43.37818784735008
              ],
              [
                146.17139727424262,
                -43.379652533502984
              ],
              [
                146.1823835745495,
                -43.38193114667441
              ],
              [
                146.17546638031357,
                -43.36842217845015
              ],
              [
                146.18018649796417,
                -43.364841527337575
              ],
              [
                146.18946383388106,
                -43.366387741736126
              ],
              [
                146.19548584344705,
                -43.36825933794672
              ],
              [
                146.206716347126,
                -43.37444427507843
              ],
              [
                146.2221786015997,
                -43.39185965622819
              ],
              [
                146.23023517763758,
                -43.39560307043251
              ],
              [
                146.23780355147917,
                -43.38437261782504
              ],
              [
                146.23796633370836,
                -43.359470300165576
              ],
              [
                146.23389730508276,
                -43.33367275205113
              ],
              [
                146.22950283981064,
                -43.31975681627148
              ],
              [
                146.2229924588154,
                -43.31503680585212
              ],
              [
                146.19548588542864,
                -43.299411731769545
              ],
              [
                146.17945404119763,
                -43.283461278276555
              ],
              [
                146.16822339509736,
                -43.27760169148275
              ],
              [
                146.1579694702452,
                -43.28167068025771
              ],
              [
                146.12989333817342,
                -43.32561604084725
              ],
              [
                146.11101312197232,
                -43.33603269712187
              ],
              [
                146.08562263177143,
                -43.31975681627148
              ],
              [
                146.08399506673064,
                -43.31340920659493
              ],
              [
                146.08090260543437,
                -43.29127377383755
              ],
              [
                146.07935620160092,
                -43.28573970589378
              ],
              [
                146.06763762814464,
                -43.28191504595013
              ],
              [
                146.0590926178382,
                -43.28508876886897
              ],
              [
                146.05347735934177,
                -43.29273847973033
              ],
              [
                146.05152425655896,
                -43.30282965117172
              ],
              [
                146.04363042673523,
                -43.32594169083697
              ],
              [
                146.02540129162458,
                -43.32488378575435
              ],
              [
                146.00489351348284,
                -43.311781613250126
              ],
              [
                145.99000085941114,
                -43.299411731769545
              ],
              [
                145.97535234794017,
                -43.283949403108025
              ],
              [
                145.96729589610507,
                -43.268243248412496
              ],
              [
                145.96404049707812,
                -43.25017661481355
              ],
              [
                145.96338947083376,
                -43.22698327355464
              ],
              [
                145.95883231032767,
                -43.22258889939556
              ],
              [
                145.93816177428434,
                -43.211032952352106
              ],
              [
                145.9171656270595,
                -43.19589617087929
              ],
              [
                145.9132593473309,
                -43.200941708376334
              ],
              [
                145.9143172195221,
                -43.22356532186227
              ],
              [
                145.9177352252344,
                -43.23853932485731
              ],
              [
                145.91570077531944,
                -43.246758791538525
              ],
              [
                145.90406342647069,
                -43.25025816575701
              ],
              [
                145.89600659361113,
                -43.25058345679403
              ],
              [
                145.88697338758257,
                -43.25188553617926
              ],
              [
                145.87867283138806,
                -43.25432721143701
              ],
              [
                145.8733015431182,
                -43.258395989600096
              ],
              [
                145.86931407941933,
                -43.27304462604209
              ],
              [
                145.88135835624084,
                -43.27629984196257
              ],
              [
                145.9177353305123,
                -43.27206809629431
              ],
              [
                145.92855889771968,
                -43.27743918832118
              ],
              [
                145.92579187599785,
                -43.289157825478874
              ],
              [
                145.9140729855974,
                -43.30071364831386
              ],
              [
                145.89722731320512,
                -43.30608477875939
              ],
              [
                145.8600366376074,
                -43.30462002928675
              ],
              [
                145.84424897525216,
                -43.30055113678563
              ],
              [
                145.83179762780927,
                -43.292575666767675
              ],
              [
                145.80567462584497,
                -43.24407311634001
              ],
              [
                145.8042097845166,
                -43.23748132132383
              ],
              [
                145.80567455931694,
                -43.213311317828754
              ],
              [
                145.80274502237612,
                -43.20810316406529
              ],
              [
                145.77475010978614,
                -43.18792072793101
              ],
              [
                145.7639266616144,
                -43.182387015999495
              ],
              [
                145.75717197204492,
                -43.175876441644384
              ],
              [
                145.75521904103422,
                -43.16920349668897
              ],
              [
                145.75440519607537,
                -43.16008886231387
              ],
              [
                145.75228930353634,
                -43.15203221230572
              ],
              [
                145.74691806112335,
                -43.14853268565254
              ],
              [
                145.73462965979402,
                -43.14332436420267
              ],
              [
                145.7280379716149,
                -43.130547801506154
              ],
              [
                145.7268173430743,
                -43.11467875074593
              ],
              [
                145.7299909671683,
                -43.10003006833143
              ],
              [
                145.72120210190016,
                -43.10377379538171
              ],
              [
                145.7104599207364,
                -43.10702901037624
              ],
              [
                145.69890382517144,
                -43.10849372782519
              ],
              [
                145.688324515322,
                -43.10686626428383
              ],
              [
                145.67408295464259,
                -43.09929787472234
              ],
              [
                145.67066496322383,
                -43.091485347850124
              ],
              [
                145.67465261638813,
                -43.06943133969521
              ],
              [
                145.67872163901544,
                -43.06585062586085
              ],
              [
                145.68572031173832,
                -43.05787533453037
              ],
              [
                145.688242963758,
                -43.04973715244103
              ],
              [
                145.67839598884873,
                -43.046075078570254
              ],
              [
                145.66667723751004,
                -43.04404057195514
              ],
              [
                145.6547956852876,
                -43.03899494940993
              ],
              [
                145.6337997434903,
                -43.02499773634419
              ],
              [
                145.59750400018768,
                -42.97185625537143
              ],
              [
                145.5822860787263,
                -42.96355568703603
              ],
              [
                145.51978610761026,
                -42.9623350188958
              ],
              [
                145.51026443080036,
                -42.95842853766126
              ],
              [
                145.47242272376658,
                -42.91513437513314
              ],
              [
                145.4497175395379,
                -42.88250078271587
              ],
              [
                145.42994234777956,
                -42.84628683050924
              ],
              [
                145.40967859717748,
                -42.79558686540138
              ],
              [
                145.39893646128215,
                -42.77800880362431
              ],
              [
                145.39356533905047,
                -42.77109145138643
              ],
              [
                145.38705477642554,
                -42.76685950243872
              ],
              [
                145.37159264428126,
                -42.76230234234135
              ],
              [
                145.36622148996875,
                -42.75750083610953
              ],
              [
                145.36475677278204,
                -42.7510719528895
              ],
              [
                145.36744225501587,
                -42.746758723233754
              ],
              [
                145.37126702161305,
                -42.743584770846574
              ],
              [
                145.384287996712,
                -42.72503025426093
              ],
              [
                145.3864853091415,
                -42.71445088493413
              ],
              [
                145.37647538586546,
                -42.70964926050572
              ],
              [
                145.37061596684933,
                -42.70427811295652
              ],
              [
                145.35271255891755,
                -42.650811605758186
              ],
              [
                145.34913163007377,
                -42.64820719626567
              ],
              [
                145.32886809417957,
                -42.649183924117665
              ],
              [
                145.32455480708674,
                -42.64820719626567
              ],
              [
                145.3170679666624,
                -42.63591895318088
              ],
              [
                145.3120223533588,
                -42.62249117005319
              ],
              [
                145.30591883535843,
                -42.611586219622374
              ],
              [
                145.29420002352958,
                -42.60719161316317
              ],
              [
                145.26547287038207,
                -42.604261999442414
              ],
              [
                145.26417071826188,
                -42.59531009203589
              ],
              [
                145.29786216098304,
                -42.558851803865636
              ],
              [
                145.27173911778883,
                -42.53899503628425
              ],
              [
                145.2472437235338,
                -42.50432712697753
              ],
              [
                145.23438566255894,
                -42.46453221979186
              ],
              [
                145.24341877500524,
                -42.42913171865801
              ],
              [
                145.21843511784132,
                -42.37037528980036
              ],
              [
                145.20826256373257,
                -42.33717213020631
              ],
              [
                145.20240313089545,
                -42.305596538866375
              ],
              [
                145.20240324516442,
                -42.24749121093822
              ],
              [
                145.1997176299311,
                -42.235446855605545
              ],
              [
                145.18962643815368,
                -42.21282310094563
              ],
              [
                145.18873136127868,
                -42.19573338706126
              ],
              [
                145.20199631845136,
                -42.20338310621428
              ],
              [
                145.21762134274982,
                -42.218519855247635
              ],
              [
                145.23047934892813,
                -42.235446855605545
              ],
              [
                145.23585051117695,
                -42.24749121093822
              ],
              [
                145.24105885035476,
                -42.26458106252542
              ],
              [
                145.25416105797834,
                -42.271905272629326
              ],
              [
                145.29053795338996,
                -42.27825285854578
              ],
              [
                145.30396566537172,
                -42.2832984033881
              ],
              [
                145.3097436458986,
                -42.287286016544456
              ],
              [
                145.3183699504867,
                -42.29941167075791
              ],
              [
                145.3226017803303,
                -42.30689872228604
              ],
              [
                145.32553147392642,
                -42.315687792403835
              ],
              [
                145.33082118876686,
                -42.32301201242914
              ],
              [
                145.35857179079684,
                -42.33017341012842
              ],
              [
                145.4244897376538,
                -42.3707007269628
              ],
              [
                145.43482507626635,
                -42.3793270936112
              ],
              [
                145.440277538776,
                -42.39128997049704
              ],
              [
                145.4431258313709,
                -42.43059659383459
              ],
              [
                145.45053140013152,
                -42.466485227821984
              ],
              [
                145.46314532579515,
                -42.5025366519187
              ],
              [
                145.47201581756633,
                -42.51279061880143
              ],
              [
                145.47925862865247,
                -42.509698136668135
              ],
              [
                145.48226974663953,
                -42.48748140203195
              ],
              [
                145.48226974590105,
                -42.41545991718288
              ],
              [
                145.50945074857813,
                -42.42848076570796
              ],
              [
                145.5197859935523,
                -42.426934490193496
              ],
              [
                145.52711019501245,
                -42.394138245885465
              ],
              [
                145.5350040944277,
                -42.3772111867038
              ],
              [
                145.55494221982175,
                -42.350681206009725
              ],
              [
                145.55811610370986,
                -42.3415666916794
              ],
              [
                145.5467228271099,
                -42.34319423841137
              ],
              [
                145.53353928432506,
                -42.349297815119456
              ],
              [
                145.53060952064385,
                -42.354099155130754
              ],
              [
                145.5323998973549,
                -42.35588953352272
              ],
              [
                145.5290633492369,
                -42.35784270874791
              ],
              [
                145.5239364058607,
                -42.359551705570325
              ],
              [
                145.52051840049785,
                -42.36012132189962
              ],
              [
                145.5166121756308,
                -42.35865650877477
              ],
              [
                145.51693766275133,
                -42.3550757381471
              ],
              [
                145.5182397458304,
                -42.350681206009725
              ],
              [
                145.5171004586333,
                -42.34726328100725
              ],
              [
                145.51351974463458,
                -42.340508743678704
              ],
              [
                145.5141708090994,
                -42.333103172307354
              ],
              [
                145.51270596392428,
                -42.32577895187461
              ],
              [
                145.50342853000876,
                -42.319268424035336
              ],
              [
                145.49268643822185,
                -42.318943021410355
              ],
              [
                145.4900008245247,
                -42.32642991835274
              ],
              [
                145.4887802047363,
                -42.335544603690096
              ],
              [
                145.4822697808502,
                -42.339776366215595
              ],
              [
                145.46314543547945,
                -42.32724381748688
              ],
              [
                145.40560962033243,
                -42.2707659438334
              ],
              [
                145.38965902295598,
                -42.24993251662374
              ],
              [
                145.37191811608895,
                -42.24098066661098
              ],
              [
                145.36622155394704,
                -42.23740000287392
              ],
              [
                145.35938563400543,
                -42.20940523196484
              ],
              [
                145.34603924463738,
                -42.182224199228024
              ],
              [
                145.34131915551038,
                -42.16383222624536
              ],
              [
                145.34571372121374,
                -42.147230706203786
              ],
              [
                145.33326256232252,
                -42.141778248442726
              ],
              [
                145.323741119532,
                -42.14275486251142
              ],
              [
                145.30420981809098,
                -42.155450110768285
              ],
              [
                145.30396563537204,
                -42.15699628308741
              ],
              [
                145.29786221056145,
                -42.168389625038245
              ],
              [
                145.29411866345177,
                -42.17099372007855
              ],
              [
                145.28150477093402,
                -42.17701590396672
              ],
              [
                145.2768660913932,
                -42.18206146762836
              ],
              [
                145.2766219394733,
                -42.19410572511069
              ],
              [
                145.282237198291,
                -42.20574312580891
              ],
              [
                145.28337652781465,
                -42.215915659865075
              ],
              [
                145.2700301543053,
                -42.22372813573987
              ],
              [
                145.26221763486518,
                -42.22079842370512
              ],
              [
                145.2290145642913,
                -42.19573338706126
              ],
              [
                145.2663680911844,
                -42.12346777570069
              ],
              [
                145.2514754939315,
                -42.04143650195263
              ],
              [
                145.20655359504272,
                -41.96656668127674
              ],
              [
                145.15455159940106,
                -41.91578537798046
              ],
              [
                145.07349696303444,
                -41.858168254631494
              ],
              [
                145.0660913007352,
                -41.855157107244615
              ],
              [
                145.06039469017685,
                -41.84954187880422
              ],
              [
                145.05591880816354,
                -41.82317472815904
              ],
              [
                145.04981526999242,
                -41.817152564306966
              ],
              [
                145.040782125181,
                -41.813246387405684
              ],
              [
                145.03052816663237,
                -41.80592210237468
              ],
              [
                144.99203538511503,
                -41.746758763721154
              ],
              [
                144.97250406313327,
                -41.732679896999834
              ],
              [
                144.96705161940554,
                -41.7234025898993
              ],
              [
                144.9597273941229,
                -41.71404385796761
              ],
              [
                144.94825274743175,
                -41.709730660658025
              ],
              [
                144.93433673242976,
                -41.71013756165019
              ],
              [
                144.92603604842145,
                -41.70907974107033
              ],
              [
                144.92017666306364,
                -41.702894833008
              ],
              [
                144.91431724136436,
                -41.688653237037244
              ],
              [
                144.9124455124573,
                -41.67929453336916
              ],
              [
                144.91431719558773,
                -41.65129966410318
              ],
              [
                144.86646572787282,
                -41.54461033085333
              ],
              [
                144.8108015905132,
                -41.47633224094708
              ],
              [
                144.79444414767454,
                -41.446465677290426
              ],
              [
                144.78711997534936,
                -41.44215258585194
              ],
              [
                144.77670328603992,
                -41.43865320836581
              ],
              [
                144.76563562781269,
                -41.430433870919025
              ],
              [
                144.74984782703632,
                -41.41423915909174
              ],
              [
                144.75391688551997,
                -41.41106539178725
              ],
              [
                144.75513752268307,
                -41.40781009862097
              ],
              [
                144.75538171194157,
                -41.40439219131829
              ],
              [
                144.75660243224274,
                -41.40056734444422
              ],
              [
                144.78191163428207,
                -41.39153408650066
              ],
              [
                144.78109788340072,
                -41.365166965205184
              ],
              [
                144.76734457043165,
                -41.33554449493852
              ],
              [
                144.70036867165393,
                -41.242445552530086
              ],
              [
                144.68165121476684,
                -41.22307705106102
              ],
              [
                144.6894637560026,
                -41.19915132321989
              ],
              [
                144.69125408666247,
                -41.16806404019233
              ],
              [
                144.6847437083336,
                -41.138848594878596
              ],
              [
                144.66724696943254,
                -41.120700815796965
              ],
              [
                144.6753036064847,
                -41.080743128738575
              ],
              [
                144.65650474786088,
                -41.04876066703023
              ],
              [
                144.60580488843243,
                -40.996514586768704
              ],
              [
                144.62037195236726,
                -40.993259387794886
              ],
              [
                144.63135824569255,
                -40.98560960265665
              ],
              [
                144.63819421576116,
                -40.974216415410666
              ],
              [
                144.6406356099573,
                -40.95907968103446
              ],
              [
                144.62289474468682,
                -40.93857189607329
              ],
              [
                144.61736088829304,
                -40.929620069958865
              ],
              [
                144.62403406502196,
                -40.92506277760795
              ],
              [
                144.6406356229213,
                -40.92148204195058
              ],
              [
                144.65642336086043,
                -40.899834878140545
              ],
              [
                144.66651450354794,
                -40.89511482181034
              ],
              [
                144.68474367047435,
                -40.893487217715325
              ],
              [
                144.6969507306854,
                -40.8868954588837
              ],
              [
                144.70378666910187,
                -40.87135183943942
              ],
              [
                144.70826255842047,
                -40.838962488075374
              ],
              [
                144.7087508293722,
                -40.810479401889616
              ],
              [
                144.68921961294072,
                -40.70452241499906
              ],
              [
                144.68921960194234,
                -40.6814104215173
              ],
              [
                144.69857833092337,
                -40.66025157309722
              ],
              [
                144.72136475888036,
                -40.640313381104754
              ],
              [
                144.72494549296027,
                -40.65715909183096
              ],
              [
                144.73511803935168,
                -40.671482034739086
              ],
              [
                144.75660242636596,
                -40.69548921255773
              ],
              [
                144.75912517528675,
                -40.70289476272506
              ],
              [
                144.76295005471925,
                -40.72047290015755
              ],
              [
                144.76628668178003,
                -40.72649508522476
              ],
              [
                144.77247155206607,
                -40.727634375717166
              ],
              [
                144.77955164696195,
                -40.72380952662664
              ],
              [
                144.78712000613572,
                -40.7185198138595
              ],
              [
                144.79395594125276,
                -40.71599702438359
              ],
              [
                144.82846112076825,
                -40.72136807959921
              ],
              [
                144.8947860123414,
                -40.74480560795308
              ],
              [
                144.9311629732928,
                -40.750176712383634
              ],
              [
                144.96794678611604,
                -40.74456142334061
              ],
              [
                144.98471114234655,
                -40.74480560795308
              ],
              [
                144.9996850711149,
                -40.753838772606215
              ],
              [
                145.01400802705245,
                -40.76669689666246
              ],
              [
                145.02686609387678,
                -40.773044544561834
              ],
              [
                145.05836021969364,
                -40.78427499498011
              ],
              [
                145.07536870761817,
                -40.80706148427414
              ],
              [
                145.08464601673813,
                -40.80999112665808
              ],
              [
                145.09522548398394,
                -40.81218844427925
              ],
              [
                145.11882573986728,
                -40.821384402880284
              ],
              [
                145.1372176546307,
                -40.81812917889102
              ],
              [
                145.14625085968427,
                -40.80771251458104
              ],
              [
                145.1335555258109,
                -40.79168058497826
              ],
              [
                145.22673584958392,
                -40.79778408239361
              ],
              [
                145.2502547448035,
                -40.79168058497826
              ],
              [
                145.2614852062687,
                -40.77548591442295
              ],
              [
                145.26392663518584,
                -40.75286224609911
              ],
              [
                145.2594507032275,
                -40.73064542294916
              ],
              [
                145.25025477030388,
                -40.71599702438359
              ],
              [
                145.269216338145,
                -40.71998462794531
              ],
              [
                145.29517665200956,
                -40.73691174714131
              ],
              [
                145.30787192424086,
                -40.7551408610658
              ],
              [
                145.27784266208536,
                -40.76669689666246
              ],
              [
                145.27035566669255,
                -40.77418385421382
              ],
              [
                145.26685628857237,
                -40.784844623139875
              ],
              [
                145.27003013428546,
                -40.79729581830578
              ],
              [
                145.27865643385792,
                -40.80543383614041
              ],
              [
                145.31836999361064,
                -40.82586029131972
              ],
              [
                145.33236740771721,
                -40.83806734692289
              ],
              [
                145.34213303717044,
                -40.84351982671789
              ],
              [
                145.3559676435293,
                -40.845798434386445
              ],
              [
                145.38843834080882,
                -40.847100510933984
              ],
              [
                145.4052840664787,
                -40.85027436846293
              ],
              [
                145.44304446496267,
                -40.867933849349036
              ],
              [
                145.47103928390288,
                -40.86492281640012
              ],
              [
                145.52393639352874,
                -40.845798434386445
              ],
              [
                145.53370202854572,
                -40.88502370840323
              ],
              [
                145.57211346946147,
                -40.909437748217435
              ],
              [
                145.62094159146218,
                -40.92253995833765
              ],
              [
                145.71159918198856,
                -40.93043388695694
              ],
              [
                145.72925864417167,
                -40.93906013350823
              ],
              [
                145.7360945939342,
                -40.95907968103446
              ],
              [
                145.74390712355458,
                -40.97535576132136
              ],
              [
                145.76156657674198,
                -40.99358486138338
              ],
              [
                145.7912704016066,
                -41.01702242315776
              ],
              [
                145.80982507925643,
                -41.026950796088634
              ],
              [
                145.8303328615841,
                -41.03329841255845
              ],
              [
                145.85279379999108,
                -41.03655362337737
              ],
              [
                145.90267987093156,
                -41.03826261117232
              ],
              [
                145.91553795012507,
                -41.04127368714921
              ],
              [
                145.92115318067528,
                -41.04802823971233
              ],
              [
                145.92514081188176,
                -41.05877042927065
              ],
              [
                145.93474369244558,
                -41.06121185528975
              ],
              [
                145.95533290153725,
                -41.05868908898484
              ],
              [
                145.97852622132626,
                -41.06519945556516
              ],
              [
                146.0166121729234,
                -41.08782317233353
              ],
              [
                146.0415145032216,
                -41.094903232750106
              ],
              [
                146.06226649120094,
                -41.10540132462789
              ],
              [
                146.06885827473062,
                -41.10979583834853
              ],
              [
                146.07894942002866,
                -41.11443450944676
              ],
              [
                146.119639547718,
                -41.120700815796965
              ],
              [
                146.2143660833673,
                -41.15536874974815
              ],
              [
                146.35377039992787,
                -41.16790132672025
              ],
              [
                146.42367597071643,
                -41.16619230798043
              ],
              [
                146.49154705128626,
                -41.15113695183597
              ],
              [
                146.5463973582837,
                -41.132745083563016
              ],
              [
                146.55518638306188,
                -41.137871989036135
              ],
              [
                146.55844158539932,
                -41.15789151282532
              ],
              [
                146.56251061963954,
                -41.168226829464864
              ],
              [
                146.57211346585066,
                -41.17669034879092
              ],
              [
                146.5856225731517,
                -41.18010830698478
              ],
              [
                146.60010824054044,
                -41.175388242735394
              ],
              [
                146.5825301417285,
                -41.161065360103336
              ],
              [
                146.59107504768815,
                -41.14714932363748
              ],
              [
                146.6268009909847,
                -41.1268856928523
              ],
              [
                146.63599693315803,
                -41.11842212298625
              ],
              [
                146.6486108624677,
                -41.099216390541244
              ],
              [
                146.65479577884602,
                -41.09286876058429
              ],
              [
                146.6667586334626,
                -41.08806728207772
              ],
              [
                146.68978924988696,
                -41.087497642352496
              ],
              [
                146.70264733646235,
                -41.085219013703245
              ],
              [
                146.71469161619476,
                -41.07976655214511
              ],
              [
                146.73064210873486,
                -41.068536047758094
              ],
              [
                146.74415121779154,
                -41.0655249721571
              ],
              [
                146.75367269423015,
                -41.066338764491164
              ],
              [
                146.76539148166836,
                -41.06975678135989
              ],
              [
                146.77670329856863,
                -41.074395412331526
              ],
              [
                146.7850040785096,
                -41.079034082985494
              ],
              [
                146.7959090272034,
                -41.09172939588957
              ],
              [
                146.80827882495683,
                -41.112562736257104
              ],
              [
                146.8125106423596,
                -41.132094045423784
              ],
              [
                146.7986759587972,
                -41.14055752680316
              ],
              [
                146.80811606340396,
                -41.15667080731925
              ],
              [
                146.82471762121943,
                -41.1609025729989
              ],
              [
                146.84351647770706,
                -41.162041932264025
              ],
              [
                146.86019940746016,
                -41.16855233240662
              ],
              [
                146.87289471614656,
                -41.15960050518672
              ],
              [
                146.8816838113525,
                -41.15553153517827
              ],
              [
                146.89112387692705,
                -41.15471768426933
              ],
              [
                146.90512129196645,
                -41.15488046950251
              ],
              [
                146.9165145013194,
                -41.15764737150255
              ],
              [
                146.92644291722277,
                -41.162774362548205
              ],
              [
                146.93685955452065,
                -41.16545987304075
              ],
              [
                146.94955488172278,
                -41.161065360103336
              ],
              [
                146.93409266143354,
                -41.151462520185866
              ],
              [
                146.9223739032609,
                -41.140232040791666
              ],
              [
                146.9078882081782,
                -41.1309546737617
              ],
              [
                146.8587345628003,
                -41.12428149754788
              ],
              [
                146.8380639991823,
                -41.11581796850764
              ],
              [
                146.82422934466553,
                -41.099786042599796
              ],
              [
                146.81934653140988,
                -41.075371979248594
              ],
              [
                146.8377384523695,
                -41.03972744048828
              ],
              [
                146.88152103779865,
                -41.02613698698001
              ],
              [
                146.93262781551724,
                -41.01824311685736
              ],
              [
                146.9729109991986,
                -40.999932543852466
              ],
              [
                146.97917728129374,
                -40.994398697656635
              ],
              [
                146.98658289229908,
                -40.98967866103312
              ],
              [
                146.99488367473526,
                -40.98577241287467
              ],
              [
                147.00904380172128,
                -40.9811337037081
              ],
              [
                147.01303145965016,
                -40.978692333487814
              ],
              [
                147.017588762496,
                -40.97665784138466
              ],
              [
                147.0240991503978,
                -40.97600676310357
              ],
              [
                147.0300399308826,
                -40.978204060751104
              ],
              [
                147.0330509890465,
                -40.98699311242575
              ],
              [
                147.03834068532709,
                -40.98984139673677
              ],
              [
                147.17107183153266,
                -41.00652437324607
              ],
              [
                147.21021570544292,
                -40.98992280246992
              ],
              [
                147.28598069077248,
                -40.94133883300961
              ],
              [
                147.29566493103428,
                -40.95712658692107
              ],
              [
                147.34278404191542,
                -40.94215259164936
              ],
              [
                147.3536890140159,
                -40.952243768494334
              ],
              [
                147.354502790321,
                -40.964532146620904
              ],
              [
                147.35816491181984,
                -40.971775000326595
              ],
              [
                147.36548911898942,
                -40.97519295420362
              ],
              [
                147.39291425463844,
                -40.978610929426516
              ],
              [
                147.39779708857574,
                -40.985039994452194
              ],
              [
                147.40040123478357,
                -40.99391041089259
              ],
              [
                147.40837650061047,
                -41.00335052233184
              ],
              [
                147.44483482558803,
                -41.00839608381951
              ],
              [
                147.48462976854336,
                -40.98601655256684
              ],
              [
                147.5203556495441,
                -40.9520809682443
              ],
              [
                147.5813908139929,
                -40.87184009301626
              ],
              [
                147.58643641776055,
                -40.856215132482085
              ],
              [
                147.59742270575566,
                -40.84685635715323
              ],
              [
                147.6505639827529,
                -40.828545811424384
              ],
              [
                147.66895593070143,
                -40.82586029131972
              ],
              [
                147.68376714044496,
                -40.835707312385125
              ],
              [
                147.70020594524567,
                -40.8539364819555
              ],
              [
                147.717133025099,
                -40.86736421162501
              ],
              [
                147.7536727092639,
                -40.856621986679535
              ],
              [
                147.77605227793,
                -40.867933849349036
              ],
              [
                147.79867599189427,
                -40.884454053057
              ],
              [
                147.81983481613796,
                -40.893487217715325
              ],
              [
                147.8494572510164,
                -40.888767215712406
              ],
              [
                147.88575282818522,
                -40.87379326305791
              ],
              [
                147.91618901500232,
                -40.852715774766736
              ],
              [
                147.92904706317103,
                -40.82903410296761
              ],
              [
                147.93213953747295,
                -40.820407833680214
              ],
              [
                147.94629965755504,
                -40.7955054446151
              ],
              [
                147.9516707445412,
                -40.76246507057074
              ],
              [
                147.95826255137584,
                -40.75115323419957
              ],
              [
                147.96924889245892,
                -40.74374765201818
              ],
              [
                147.98422286214486,
                -40.736504829047966
              ],
              [
                147.99097742668974,
                -40.74130626946016
              ],
              [
                147.99691816324213,
                -40.742608328739806
              ],
              [
                148.0202742834583,
                -40.74374765201818
              ],
              [
                148.0293074788383,
                -40.74675871022523
              ],
              [
                148.03598067133885,
                -40.75221120414423
              ],
              [
                148.0427352112092,
                -40.7697079271468
              ],
              [
                148.05193116998151,
                -40.76978930043702
              ],
              [
                148.0693465387532,
                -40.7638485515603
              ],
              [
                148.08090254338867,
                -40.76775482034951
              ],
              [
                148.0940047675418,
                -40.777032176373055
              ],
              [
                148.11402427509515,
                -40.79729581830578
              ],
              [
                148.13111412189187,
                -40.8248023329021
              ],
              [
                148.14380943755728,
                -40.83489348359577
              ],
              [
                148.16553794923942,
                -40.838962488075374
              ],
              [
                148.19898521592103,
                -40.837009365227
              ],
              [
                148.20932049916095,
                -40.840752850422106
              ],
              [
                148.28736413233636,
                -40.9230282572476
              ],
              [
                148.31462647364827,
                -40.96160244105293
              ],
              [
                148.3256941989072,
                -40.982679935725194
              ],
              [
                148.33139081926123,
                -41.00221119379431
              ],
              [
                148.3234969512996,
                -41.01083751106091
              ],
              [
                148.3088484983239,
                -41.01482512080254
              ],
              [
                148.29265384153493,
                -41.02450937241039
              ],
              [
                148.27906333950196,
                -41.03582121249872
              ],
              [
                148.2723088034757,
                -41.04501720206983
              ],
              [
                148.28402756762162,
                -41.04778414798188
              ],
              [
                148.29444422530116,
                -41.05169038617222
              ],
              [
                148.30225669307805,
                -41.05754972037744
              ],
              [
                148.3064070765763,
                -41.0655249721571
              ],
              [
                148.29053795631373,
                -41.10621510113287
              ],
              [
                148.289073134049,
                -41.11321382658412
              ],
              [
                148.27475017719544,
                -41.12493252625956
              ],
              [
                148.2688907977558,
                -41.15162522868577
              ],
              [
                148.26889079483976,
                -41.18157314204893
              ],
              [
                148.27230879318617,
                -41.202569273009665
              ],
              [
                148.27751710167544,
                -41.21559007517877
              ],
              [
                148.28199305997933,
                -41.22193778940879
              ],
              [
                148.31625412822467,
                -41.25530367692242
              ],
              [
                148.32154380207612,
                -41.268487220529735
              ],
              [
                148.3164168425622,
                -41.28142666536933
              ],
              [
                148.2719832433601,
                -41.30828212687062
              ],
              [
                148.25416097006675,
                -41.32594162250331
              ],
              [
                148.25798592254878,
                -41.3466122999998
              ],
              [
                148.33326258294804,
                -41.2921688992424
              ],
              [
                148.35417733024593,
                -41.29143651897063
              ],
              [
                148.33106525449082,
                -41.322523639027786
              ],
              [
                148.27947020981742,
                -41.45037195542492
              ],
              [
                148.28003988436683,
                -41.466241112081335
              ],
              [
                148.28386472502456,
                -41.48284263759015
              ],
              [
                148.28589930885806,
                -41.507094037659776
              ],
              [
                148.2840275554769,
                -41.51995210023111
              ],
              [
                148.28109787678622,
                -41.52825289378937
              ],
              [
                148.28126055243183,
                -41.53630942778562
              ],
              [
                148.30795328016046,
                -41.57512781236972
              ],
              [
                148.3126733400745,
                -41.58619553019961
              ],
              [
                148.3149520308418,
                -41.6065406376622
              ],
              [
                148.31104577798186,
                -41.62981537411151
              ],
              [
                148.30201251721968,
                -41.65252038070091
              ],
              [
                148.28907317042479,
                -41.67156347993967
              ],
              [
                148.28614346138207,
                -41.68938571991518
              ],
              [
                148.30640714953583,
                -41.75066503670055
              ],
              [
                148.2946883784639,
                -41.7629534217347
              ],
              [
                148.27442471878146,
                -41.77996190087208
              ],
              [
                148.26099693224265,
                -41.800388268231295
              ],
              [
                148.2685652785435,
                -41.822686429638566
              ],
              [
                148.2736108754821,
                -41.830498959048356
              ],
              [
                148.28394618556794,
                -41.85523857137173
              ],
              [
                148.2858993114408,
                -41.86370211343237
              ],
              [
                148.28907314944348,
                -41.872328427686625
              ],
              [
                148.31267333490462,
                -41.89470789433292
              ],
              [
                148.31576582072003,
                -41.90154387765705
              ],
              [
                148.31641690499086,
                -41.90683364341493
              ],
              [
                148.31869554682814,
                -41.91122816931002
              ],
              [
                148.32691487975416,
                -41.91578537798046
              ],
              [
                148.31348722286842,
                -41.94866307752444
              ],
              [
                148.300303597656,
                -42.00156017310659
              ],
              [
                148.29932703436083,
                -42.05055105871403
              ],
              [
                148.3637801860027,
                -42.11028416404284
              ],
              [
                148.36394291868206,
                -42.11565522262363
              ],
              [
                148.35645590457426,
                -42.11923591018445
              ],
              [
                148.34669025334657,
                -42.127536660332744
              ],
              [
                148.31934652349656,
                -42.15683355983446
              ],
              [
                148.31592856832438,
                -42.170179929409954
              ],
              [
                148.36068772874484,
                -42.18450290269112
              ],
              [
                148.3642684727537,
                -42.20435969084292
              ],
              [
                148.3541772374333,
                -42.240817915500394
              ],
              [
                148.34994546871178,
                -42.24667729326534
              ],
              [
                148.3310652533361,
                -42.262627806576276
              ],
              [
                148.32691495747872,
                -42.26775487340036
              ],
              [
                148.32178794976667,
                -42.27800871325771
              ],
              [
                148.31104583111315,
                -42.27304460408745
              ],
              [
                148.30128009470783,
                -42.26295332338701
              ],
              [
                148.29900151105818,
                -42.25839610779484
              ],
              [
                148.26465901196522,
                -42.25025802497022
              ],
              [
                148.25798592987255,
                -42.24423600384407
              ],
              [
                148.26050863681644,
                -42.235609604928456
              ],
              [
                148.28101646228214,
                -42.225681236230855
              ],
              [
                148.2858992233909,
                -42.2199031783743
              ],
              [
                148.28907316560822,
                -42.21428808273379
              ],
              [
                148.29615321148438,
                -42.20696382482146
              ],
              [
                148.30323322219908,
                -42.19752363927419
              ],
              [
                148.30640707165705,
                -42.185804915270936
              ],
              [
                148.30250082803917,
                -42.178887605003325
              ],
              [
                148.29322344625365,
                -42.169691594935905
              ],
              [
                148.2819930070421,
                -42.160902568065545
              ],
              [
                148.27230877580678,
                -42.155450110768285
              ],
              [
                148.3006290597752,
                -42.14373132672484
              ],
              [
                148.3139755053771,
                -42.13469823375902
              ],
              [
                148.32007891030847,
                -42.11939862103217
              ],
              [
                148.2927352448038,
                -42.119561483716055
              ],
              [
                148.27475021666362,
                -42.11321382512352
              ],
              [
                148.24431402744622,
                -42.085870085843204
              ],
              [
                148.22657310308887,
                -42.0752906109296
              ],
              [
                148.16244556120213,
                -42.05917740563757
              ],
              [
                148.18970785353275,
                -42.041273664939844
              ],
              [
                148.2058212128506,
                -42.0342750624658
              ],
              [
                148.22046962051027,
                -42.031182578677495
              ],
              [
                148.2319442505866,
                -42.02369562417626
              ],
              [
                148.241709886454,
                -42.00741959546872
              ],
              [
                148.24244224496746,
                -41.990899335967995
              ],
              [
                148.21119223384426,
                -41.97698330636521
              ],
              [
                148.20508873222573,
                -41.96266040793847
              ],
              [
                148.20240324434872,
                -41.94841894327429
              ],
              [
                148.1962996578408,
                -41.941827059999014
              ],
              [
                148.18100019061566,
                -41.94736092841081
              ],
              [
                148.18287189651326,
                -41.959567912583175
              ],
              [
                148.19654386909846,
                -41.979668942898
              ],
              [
                148.19369556468368,
                -42.00090918100752
              ],
              [
                148.18628994598504,
                -42.00123467695089
              ],
              [
                148.17554772327136,
                -41.99358489555327
              ],
              [
                148.16244551477993,
                -41.99032969206324
              ],
              [
                148.14698330561038,
                -41.99928155272951
              ],
              [
                148.1467391818397,
                -42.01262792752767
              ],
              [
                148.15251712112118,
                -42.02874114170685
              ],
              [
                148.15503988379575,
                -42.04558681503844
              ],
              [
                148.14942461755433,
                -42.04802818293636
              ],
              [
                148.1386824506988,
                -42.051039275507065
              ],
              [
                148.13013756869512,
                -42.05543385528656
              ],
              [
                148.13135823226835,
                -42.06194422421662
              ],
              [
                148.1413680269787,
                -42.07146574322433
              ],
              [
                148.14698327848038,
                -42.075616155551565
              ],
              [
                148.15503986726458,
                -42.0796851019377
              ],
              [
                148.16797941924165,
                -42.08375423350015
              ],
              [
                148.2170516604326,
                -42.09335706725814
              ],
              [
                148.119395363045,
                -42.09140388456615
              ],
              [
                148.092946870702,
                -42.100193039709865
              ],
              [
                148.08253015765618,
                -42.11565522262363
              ],
              [
                148.07894943637143,
                -42.13876721099536
              ],
              [
                148.0798445716958,
                -42.185804915270936
              ],
              [
                148.07447347731326,
                -42.19736090260373
              ],
              [
                148.03891036250164,
                -42.22372813573987
              ],
              [
                148.0346785951622,
                -42.23495860796176
              ],
              [
                148.03443441612734,
                -42.246270410848176
              ],
              [
                148.0306095290805,
                -42.25497807219705
              ],
              [
                148.01490320403312,
                -42.25839610779484
              ],
              [
                148.0180769573109,
                -42.26433677225523
              ],
              [
                148.01221763534883,
                -42.27792733152218
              ],
              [
                147.9834091020858,
                -42.31902441000726
              ],
              [
                147.96387785476884,
                -42.339776366215595
              ],
              [
                147.97584075277447,
                -42.335544603690096
              ],
              [
                147.99382575104255,
                -42.317315404180114
              ],
              [
                148.00473069410447,
                -42.31243258520991
              ],
              [
                148.0224714991373,
                -42.317803582485695
              ],
              [
                148.03093504430228,
                -42.33228926334482
              ],
              [
                148.03044681266152,
                -42.34726328100725
              ],
              [
                148.00521900557678,
                -42.36687598094341
              ],
              [
                148.00318449491226,
                -42.395684568041766
              ],
              [
                148.01156663856378,
                -42.443454729040106
              ],
              [
                148.01107832148102,
                -42.48943450357847
              ],
              [
                148.00603278836525,
                -42.514092754508944
              ],
              [
                147.99488372162054,
                -42.524672207032914
              ],
              [
                147.98096760298256,
                -42.52898523472232
              ],
              [
                147.96566825713688,
                -42.54827250463409
              ],
              [
                147.9532983272794,
                -42.552666870103664
              ],
              [
                147.9428818163343,
                -42.54778424430618
              ],
              [
                147.92790770042467,
                -42.524997596816014
              ],
              [
                147.91529381706445,
                -42.5172665352798
              ],
              [
                147.91578213231074,
                -42.529717748439225
              ],
              [
                147.91065510809997,
                -42.53785568386205
              ],
              [
                147.90137773867787,
                -42.54265708532143
              ],
              [
                147.88868257416678,
                -42.54509866952969
              ],
              [
                147.93685958213302,
                -42.59091563635233
              ],
              [
                147.94337009153745,
                -42.610446997095394
              ],
              [
                147.94239332366504,
                -42.62802487661089
              ],
              [
                147.94336992993183,
                -42.634535345454864
              ],
              [
                147.94629967343366,
                -42.640557548124306
              ],
              [
                147.95085684491391,
                -42.645440216841955
              ],
              [
                147.9550886901328,
                -42.64902103470277
              ],
              [
                147.95704176840604,
                -42.65162514478148
              ],
              [
                147.95736739062218,
                -42.67896901591907
              ],
              [
                147.9553329654559,
                -42.691664424349156
              ],
              [
                147.94955492549767,
                -42.70281345859092
              ],
              [
                147.9531357182165,
                -42.71998475866646
              ],
              [
                147.93995214402494,
                -42.73552840226629
              ],
              [
                147.9204208384098,
                -42.74684018484965
              ],
              [
                147.90544676129355,
                -42.7512345736707
              ],
              [
                147.88933365130606,
                -42.76067488276342
              ],
              [
                147.88111413774794,
                -42.781914982433236
              ],
              [
                147.88087008471945,
                -42.8049456862722
              ],
              [
                147.88868249487027,
                -42.81951263618392
              ],
              [
                147.88363701940696,
                -42.82822043434379
              ],
              [
                147.87989345696,
                -42.83098727606048
              ],
              [
                147.87525467872857,
                -42.82984782535436
              ],
              [
                147.86752368143206,
                -42.82634862249874
              ],
              [
                147.85059644100193,
                -42.851820441252016
              ],
              [
                147.8445744241496,
                -42.86614349888707
              ],
              [
                147.84717858817035,
                -42.8809546923386
              ],
              [
                147.85840903633957,
                -42.88844164875771
              ],
              [
                147.87777750709606,
                -42.892836156887725
              ],
              [
                147.89909906050912,
                -42.893242984698226
              ],
              [
                147.91529380233428,
                -42.88844164875771
              ],
              [
                147.91529382217314,
                -42.8809546923386
              ],
              [
                147.88160241351406,
                -42.87167734617955
              ],
              [
                147.8930770243604,
                -42.850192973379194
              ],
              [
                147.9207462295006,
                -42.83831138398806
              ],
              [
                147.93653413042134,
                -42.85768004165826
              ],
              [
                147.93930090882978,
                -42.87232830195112
              ],
              [
                147.94646241142857,
                -42.87428147878959
              ],
              [
                147.95630950507964,
                -42.87029395418121
              ],
              [
                147.9672957910211,
                -42.867364217180096
              ],
              [
                147.975352358088,
                -42.868259311288334
              ],
              [
                147.98072349890134,
                -42.87118905393956
              ],
              [
                147.9834089947125,
                -42.876397328295205
              ],
              [
                147.98422283553097,
                -42.88469815543285
              ],
              [
                147.98698968545298,
                -42.893242984698226
              ],
              [
                147.99976643423614,
                -42.90064865115831
              ],
              [
                148.0047306833716,
                -42.908868118808634
              ],
              [
                148.0027774931199,
                -42.91375085335653
              ],
              [
                147.99732512589065,
                -42.9198544960756
              ],
              [
                147.9921980108385,
                -42.927422662782085
              ],
              [
                147.9910587953317,
                -42.93621185332451
              ],
              [
                147.9943954330435,
                -42.93840917710229
              ],
              [
                148.00123121736462,
                -42.94150144302217
              ],
              [
                148.0080672294068,
                -42.94540778083812
              ],
              [
                148.01156652193126,
                -42.950453288073355
              ],
              [
                148.00977625600925,
                -42.96990327433892
              ],
              [
                148.00066168977315,
                -42.97747165419572
              ],
              [
                147.98755944412852,
                -42.980889584706304
              ],
              [
                147.97396894846977,
                -42.98772552192555
              ],
              [
                147.96387773727238,
                -43.01051190273997
              ],
              [
                147.96517980707767,
                -43.06031657406874
              ],
              [
                147.94955499454915,
                -43.07284934764833
              ],
              [
                147.97315520164514,
                -43.09807714906514
              ],
              [
                147.97738701689826,
                -43.10686626428383
              ],
              [
                147.97836348873338,
                -43.11834076684575
              ],
              [
                147.9763290455701,
                -43.125258157799195
              ],
              [
                147.96387771775386,
                -43.14169677600186
              ],
              [
                147.98633864479302,
                -43.14299884609582
              ],
              [
                147.99952222444244,
                -43.14788164220349
              ],
              [
                148.0034285905043,
                -43.15813568502216
              ],
              [
                147.99854566852335,
                -43.175876441644384
              ],
              [
                147.99341878478998,
                -43.18141037824089
              ],
              [
                147.98633872686463,
                -43.185479411885545
              ],
              [
                147.9799911583884,
                -43.191583030952074
              ],
              [
                147.97738691213274,
                -43.20305754662461
              ],
              [
                147.9884546830288,
                -43.21160254264373
              ],
              [
                147.99577882190314,
                -43.219984609356004
              ],
              [
                147.99854572746125,
                -43.230401251144805
              ]
            ]
          ],
          [
            [
              [
                158.89340259617765,
                -54.510837540846374
              ],
              [
                158.9077254319522,
                -54.49618904088991
              ],
              [
                158.94849696532657,
                -54.4860165525602
              ],
              [
                158.96241299217894,
                -54.469333618850506
              ],
              [
                158.96322691222323,
                -54.489190479882545
              ],
              [
                158.95557702067296,
                -54.55120208227386
              ],
              [
                158.94841541041018,
                -54.57122149838003
              ],
              [
                158.92562911927945,
                -54.61565521913758
              ],
              [
                158.91553801323911,
                -54.65097425971953
              ],
              [
                158.89258866921517,
                -54.686944216794885
              ],
              [
                158.8872175254427,
                -54.70598714806387
              ],
              [
                158.88624125910297,
                -54.73259870025031
              ],
              [
                158.88054461363265,
                -54.7457008901167
              ],
              [
                158.86573313257216,
                -54.749932446618594
              ],
              [
                158.83822690474204,
                -54.750420941456944
              ],
              [
                158.83204195681716,
                -54.73805111113024
              ],
              [
                158.83236748556348,
                -54.73365658501256
              ],
              [
                158.83822658601238,
                -54.729912887819765
              ],
              [
                158.83236748274174,
                -54.711683926918234
              ],
              [
                158.8351342289972,
                -54.68987389374558
              ],
              [
                158.84571377118425,
                -54.654880492215234
              ],
              [
                158.84815524350245,
                -54.64959082861759
              ],
              [
                158.85645612265708,
                -54.63933699724593
              ],
              [
                158.85938542270924,
                -54.633721468333334
              ],
              [
                158.85824644027977,
                -54.630792039258694
              ],
              [
                158.8553167168363,
                -54.62558367932506
              ],
              [
                158.85279392575953,
                -54.61923601848059
              ],
              [
                158.8525497945654,
                -54.61321389095404
              ],
              [
                158.85645575098968,
                -54.603773563597514
              ],
              [
                158.86060631969454,
                -54.59929778681133
              ],
              [
                158.86573340869154,
                -54.59490335930959
              ],
              [
                158.87232519363326,
                -54.58587014715339
              ],
              [
                158.88135822220713,
                -54.56633876436404
              ],
              [
                158.89340259617765,
                -54.510837540846374
              ]
            ]
          ],
          [
            [
              [
                147.3365990335134,
                -43.34026443790974
              ],
              [
                147.3375756038536,
                -43.344496218749356
              ],
              [
                147.3605249062115,
                -43.36825933794672
              ],
              [
                147.36402434258142,
                -43.37932714873608
              ],
              [
                147.36548925753078,
                -43.38787215416109
              ],
              [
                147.36451254079046,
                -43.39674241635862
              ],
              [
                147.36052496719518,
                -43.40862399266829
              ],
              [
                147.35547941264994,
                -43.41790135834828
              ],
              [
                147.34457439764594,
                -43.42986417061054
              ],
              [
                147.34001718600874,
                -43.43645606201843
              ],
              [
                147.33497142441445,
                -43.44768630850951
              ],
              [
                147.32634524539574,
                -43.47812265094377
              ],
              [
                147.31592861274703,
                -43.50066500806365
              ],
              [
                147.30388436469508,
                -43.50888443597138
              ],
              [
                147.2873640989922,
                -43.50497808780047
              ],
              [
                147.26433350015685,
                -43.491794493975824
              ],
              [
                147.25757885452154,
                -43.48967850611245
              ],
              [
                147.25082432764154,
                -43.489922681461
              ],
              [
                147.24439530886855,
                -43.489353040676754
              ],
              [
                147.23755948012234,
                -43.484307595931625
              ],
              [
                147.2368270067674,
                -43.47975024363631
              ],
              [
                147.23780348095124,
                -43.47340248332911
              ],
              [
                147.2404078699776,
                -43.46892683426371
              ],
              [
                147.24382583985923,
                -43.46998477729174
              ],
              [
                147.23617607085845,
                -43.45077901429412
              ],
              [
                147.22999108917074,
                -43.44426849642812
              ],
              [
                147.21648209554596,
                -43.44264103410891
              ],
              [
                147.22331785061183,
                -43.43906009006208
              ],
              [
                147.2319441246787,
                -43.43238688021265
              ],
              [
                147.23755942259845,
                -43.42962002836403
              ],
              [
                147.2155868872891,
                -43.41521587333266
              ],
              [
                147.204600432067,
                -43.425713770674804
              ],
              [
                147.19605565781936,
                -43.46998477729174
              ],
              [
                147.18490643505666,
                -43.48984139114917
              ],
              [
                147.1677351334976,
                -43.501641430091844
              ],
              [
                147.14918063552588,
                -43.50115337104078
              ],
              [
                147.13396247509485,
                -43.484307595931625
              ],
              [
                147.12533619620388,
                -43.464776373124224
              ],
              [
                147.10962984777777,
                -43.45077901429412
              ],
              [
                147.09408601323312,
                -43.43987381390679
              ],
              [
                147.0861922356174,
                -43.42962002836403
              ],
              [
                147.0906682941885,
                -43.41090275412377
              ],
              [
                147.1092229591439,
                -43.41497173913578
              ],
              [
                147.16163161483283,
                -43.454034004647596
              ],
              [
                147.17221106120712,
                -43.45891683944154
              ],
              [
                147.17920973982177,
                -43.454034004647596
              ],
              [
                147.18238372294135,
                -43.43645606201843
              ],
              [
                147.180430482231,
                -43.39723066487754
              ],
              [
                147.17595468050794,
                -43.37932714873608
              ],
              [
                147.1681420932504,
                -43.36825933794672
              ],
              [
                147.1735133076062,
                -43.36004007877886
              ],
              [
                147.18100019256556,
                -43.35426197295201
              ],
              [
                147.1901148203439,
                -43.3527158005491
              ],
              [
                147.20004321703084,
                -43.35702896531201
              ],
              [
                147.21566821494153,
                -43.377536775810924
              ],
              [
                147.22559651434264,
                -43.38551193502174
              ],
              [
                147.23357185891297,
                -43.37151463742446
              ],
              [
                147.23926852971744,
                -43.364841527337575
              ],
              [
                147.24154705957315,
                -43.35621508853824
              ],
              [
                147.23389729547063,
                -43.34400802794893
              ],
              [
                147.2285262136961,
                -43.332207912346796
              ],
              [
                147.2348739701819,
                -43.32301206683341
              ],
              [
                147.2544050473736,
                -43.3095027490309
              ],
              [
                147.2859807048787,
                -43.275567363070124
              ],
              [
                147.30445409527175,
                -43.2618142055392
              ],
              [
                147.3127548822766,
                -43.268243248412496
              ],
              [
                147.3365990335134,
                -43.34026443790974
              ]
            ]
          ],
          [
            [
              [
                147.40211034768797,
                -43.13111759484141
              ],
              [
                147.40259852923506,
                -43.14470797087198
              ],
              [
                147.40463296696498,
                -43.15536869825675
              ],
              [
                147.40886471669893,
                -43.16497153811357
              ],
              [
                147.41578199691892,
                -43.175876441644384
              ],
              [
                147.41993243772808,
                -43.188409053571206
              ],
              [
                147.43116292091264,
                -43.2139624553734
              ],
              [
                147.4375105573611,
                -43.238946156327835
              ],
              [
                147.42603608429965,
                -43.25025816575701
              ],
              [
                147.40121516845278,
                -43.245049889627374
              ],
              [
                147.39185626631016,
                -43.24407311634001
              ],
              [
                147.3792425126392,
                -43.24781681685835
              ],
              [
                147.36915115617228,
                -43.254652505414136
              ],
              [
                147.36085052690876,
                -43.257907892514126
              ],
              [
                147.35368907826026,
                -43.25025816575701
              ],
              [
                147.34734144002823,
                -43.22796000981146
              ],
              [
                147.35726981917054,
                -43.21795023691445
              ],
              [
                147.37403413087407,
                -43.210707385574274
              ],
              [
                147.3878687824248,
                -43.1962217269875
              ],
              [
                147.36890716266885,
                -43.182875335668925
              ],
              [
                147.31812581816294,
                -43.177178609875966
              ],
              [
                147.2956648695338,
                -43.16562260609177
              ],
              [
                147.29175871468007,
                -43.153008786760886
              ],
              [
                147.3046981354302,
                -43.145684529568534
              ],
              [
                147.35417722538645,
                -43.13941816232004
              ],
              [
                147.34896899734437,
                -43.13388443381982
              ],
              [
                147.33497156023026,
                -43.12688568712168
              ],
              [
                147.32634527541725,
                -43.12053805149436
              ],
              [
                147.33033293490905,
                -43.1010068352977
              ],
              [
                147.34457447566172,
                -43.082208012965566
              ],
              [
                147.36003661817787,
                -43.074883678311544
              ],
              [
                147.3728132543956,
                -43.101250799220594
              ],
              [
                147.3966576974708,
                -43.11711999013626
              ],
              [
                147.40211034768797,
                -43.13111759484141
              ]
            ]
          ],
          [
            [
              [
                148.1418563039751,
                -42.603773681603634
              ],
              [
                148.14372800513922,
                -42.62029381115898
              ],
              [
                148.14926199018598,
                -42.632745139925895
              ],
              [
                148.15984142313147,
                -42.64185973000205
              ],
              [
                148.17603592557757,
                -42.64820719626567
              ],
              [
                148.14958750702954,
                -42.66643654086423
              ],
              [
                148.10466546557893,
                -42.66472735795246
              ],
              [
                148.0730087025443,
                -42.666762027856606
              ],
              [
                148.08668043549946,
                -42.696547014180645
              ],
              [
                148.1101179325921,
                -42.71648516180409
              ],
              [
                148.10482829509957,
                -42.71949632109662
              ],
              [
                148.04346770596504,
                -42.72918067094231
              ],
              [
                148.0290632525969,
                -42.73650470336393
              ],
              [
                148.0183211102556,
                -42.7512345736707
              ],
              [
                148.0115665522579,
                -42.7512345736707
              ],
              [
                148.0115666399647,
                -42.73072686631056
              ],
              [
                148.02426201494464,
                -42.71933371131517
              ],
              [
                148.03296967888897,
                -42.703871449801326
              ],
              [
                148.045176505646,
                -42.66871495452619
              ],
              [
                148.02271564876716,
                -42.66627364549763
              ],
              [
                148.01286859137028,
                -42.65162514478148
              ],
              [
                148.01368245294185,
                -42.63176844602899
              ],
              [
                148.02458755839464,
                -42.6134580876024
              ],
              [
                148.03956130506347,
                -42.60320392744902
              ],
              [
                148.06755611592612,
                -42.59303142403628
              ],
              [
                148.07984456358315,
                -42.57927821294508
              ],
              [
                148.0963647406171,
                -42.58440515880689
              ],
              [
                148.11695388553358,
                -42.585707186404846
              ],
              [
                148.13445078107083,
                -42.590101897743025
              ],
              [
                148.1418563039751,
                -42.603773681603634
              ]
            ]
          ],
          [
            [
              [
                148.29900143661374,
                -42.305596538866375
              ],
              [
                148.31690519559066,
                -42.31438573727769
              ],
              [
                148.3247176077005,
                -42.32366297519673
              ],
              [
                148.3300887299843,
                -42.336032800331544
              ],
              [
                148.34058673367153,
                -42.354099155130754
              ],
              [
                148.33448321286892,
                -42.356621935344656
              ],
              [
                148.32976323448838,
                -42.3571103050791
              ],
              [
                148.32007892067864,
                -42.354099155130754
              ],
              [
                148.30469811029872,
                -42.34628671374223
              ],
              [
                148.2928165803983,
                -42.33700934693889
              ],
              [
                148.28003993065596,
                -42.32935965792847
              ],
              [
                148.24919679808042,
                -42.32390714340186
              ],
              [
                148.24268637014418,
                -42.318129136191395
              ],
              [
                148.23072346573485,
                -42.29941167075791
              ],
              [
                148.24634850863976,
                -42.29509857160704
              ],
              [
                148.26563555581822,
                -42.29648195990725
              ],
              [
                148.29900143661374,
                -42.305596538866375
              ]
            ]
          ],
          [
            [
              [
                145.0136825103373,
                -40.66822685040694
              ],
              [
                145.03101649772898,
                -40.67254000586167
              ],
              [
                145.04615318536906,
                -40.68303801159332
              ],
              [
                145.0581161105171,
                -40.696465790484
              ],
              [
                145.06519617032708,
                -40.709161079566
              ],
              [
                145.03728275832515,
                -40.709161079566
              ],
              [
                145.01587974306014,
                -40.69426847361451
              ],
              [
                144.98275803614692,
                -40.69931409569708
              ],
              [
                144.92741947921445,
                -40.72340261805035
              ],
              [
                144.92212977645517,
                -40.72332125150848
              ],
              [
                144.9148868959903,
                -40.72185635301617
              ],
              [
                144.90626059399153,
                -40.72185635301617
              ],
              [
                144.8969832958043,
                -40.72649508522476
              ],
              [
                144.8903100924514,
                -40.72812265459308
              ],
              [
                144.8829858721582,
                -40.72486744489341
              ],
              [
                144.87647545315545,
                -40.71998462794531
              ],
              [
                144.87281336326154,
                -40.71599702438359
              ],
              [
                144.87175538376357,
                -40.67131924101855
              ],
              [
                144.86963949271467,
                -40.66480881735527
              ],
              [
                144.917491068889,
                -40.62322354869279
              ],
              [
                144.93051191876233,
                -40.61532968996767
              ],
              [
                144.9371850789912,
                -40.625095292831546
              ],
              [
                144.94499761087386,
                -40.63990653289072
              ],
              [
                144.96216883913115,
                -40.64771903849095
              ],
              [
                144.9772241270362,
                -40.65097418014776
              ],
              [
                144.9965926411108,
                -40.66497160919518
              ],
              [
                145.0136825103373,
                -40.66822685040694
              ]
            ]
          ],
          [
            [
              [
                148.11402427310125,
                -40.52418383656285
              ],
              [
                148.13111413516773,
                -40.51376719300469
              ],
              [
                148.17115319468115,
                -40.50709401277757
              ],
              [
                148.18604576705795,
                -40.500095307478766
              ],
              [
                148.25114993211915,
                -40.48943449796161
              ],
              [
                148.2457788297559,
                -40.498304930109924
              ],
              [
                148.23536217204324,
                -40.510430593164536
              ],
              [
                148.2307234914584,
                -40.51734789873645
              ],
              [
                148.22877038048622,
                -40.52906666692618
              ],
              [
                148.22950281017808,
                -40.540134386184725
              ],
              [
                148.2268172565655,
                -40.54827239732215
              ],
              [
                148.21363366741016,
                -40.551527611595176
              ],
              [
                148.20948326727859,
                -40.562188406771796
              ],
              [
                148.20533288439907,
                -40.58277760898147
              ],
              [
                148.19418377671926,
                -40.59628669983555
              ],
              [
                148.16871178476657,
                -40.585625908698006
              ],
              [
                148.16187585184687,
                -40.57057057727277
              ],
              [
                148.1453556506978,
                -40.56609464048397
              ],
              [
                148.12859134606836,
                -40.56536224326763
              ],
              [
                148.12086021581035,
                -40.561700119983676
              ],
              [
                148.11890709796646,
                -40.558038020251786
              ],
              [
                148.10954836855646,
                -40.544203377239995
              ],
              [
                148.1071883497577,
                -40.537855730575615
              ],
              [
                148.10572351614036,
                -40.53045014374687
              ],
              [
                148.10499107881913,
                -40.5300432228739
              ],
              [
                148.107106963819,
                -40.5300432228739
              ],
              [
                148.11402427310125,
                -40.52418383656285
              ]
            ]
          ],
          [
            [
              [
                144.79086346638852,
                -40.42115649384976
              ],
              [
                144.79216555625194,
                -40.427911059670606
              ],
              [
                144.79053795114004,
                -40.50212980821487
              ],
              [
                144.78711998560235,
                -40.509942312815646
              ],
              [
                144.76563561636453,
                -40.524509377465826
              ],
              [
                144.76465903622037,
                -40.584567948759144
              ],
              [
                144.74244224366416,
                -40.59246183332068
              ],
              [
                144.73292077049726,
                -40.57740650998285
              ],
              [
                144.72950279224668,
                -40.569919518727126
              ],
              [
                144.72877036520296,
                -40.51360440667244
              ],
              [
                144.72535241207143,
                -40.505791927752554
              ],
              [
                144.71078536379304,
                -40.49578217468017
              ],
              [
                144.70826256221193,
                -40.48943449796161
              ],
              [
                144.71599367632177,
                -40.47665779712078
              ],
              [
                144.7301538342993,
                -40.47527433675259
              ],
              [
                144.74691817742996,
                -40.476169545537815
              ],
              [
                144.76295006371447,
                -40.469496348958415
              ],
              [
                144.76726323022348,
                -40.46005626560412
              ],
              [
                144.77711020812654,
                -40.41090258348938
              ],
              [
                144.7791447288499,
                -40.40536875046873
              ],
              [
                144.78370202327434,
                -40.408868102703124
              ],
              [
                144.79086346638852,
                -40.42115649384976
              ]
            ]
          ],
          [
            [
              [
                144.90072675671226,
                -40.469496348958415
              ],
              [
                144.87452232534778,
                -40.46754321815339
              ],
              [
                144.85906010037334,
                -40.45631276914201
              ],
              [
                144.8469344452493,
                -40.44150156565876
              ],
              [
                144.83122807120827,
                -40.42799245960418
              ],
              [
                144.83952883851555,
                -40.42571379535594
              ],
              [
                144.85906008204506,
                -40.42376066173306
              ],
              [
                144.866465680383,
                -40.42115649384976
              ],
              [
                144.87370853593475,
                -40.415215760911366
              ],
              [
                144.88160241415096,
                -40.40593841453558
              ],
              [
                144.88445071380417,
                -40.397637623736415
              ],
              [
                144.87614993663345,
                -40.39381275884512
              ],
              [
                144.87338300501563,
                -40.39169686768259
              ],
              [
                144.8792423903829,
                -40.38681406851979
              ],
              [
                144.88851972535278,
                -40.38176848580085
              ],
              [
                144.89698325827118,
                -40.37957120767591
              ],
              [
                144.92025801122543,
                -40.38062916797044
              ],
              [
                144.93067467989312,
                -40.382745056530055
              ],
              [
                144.9410913529421,
                -40.3864071735994
              ],
              [
                144.96045983496586,
                -40.39788177295435
              ],
              [
                144.96094810023186,
                -40.40748461598289
              ],
              [
                144.95346112715944,
                -40.41952889488783
              ],
              [
                144.94849694865482,
                -40.437920841188316
              ],
              [
                144.95264734516581,
                -40.448907176514
              ],
              [
                144.95020592194365,
                -40.45338306693482
              ],
              [
                144.92701255932818,
                -40.455987229125874
              ],
              [
                144.91724695350027,
                -40.45826589962545
              ],
              [
                144.90853926289364,
                -40.46266042017777
              ],
              [
                144.90072675671226,
                -40.469496348958415
              ]
            ]
          ],
          [
            [
              [
                148.42994226038854,
                -40.37330495432855
              ],
              [
                148.4680281819523,
                -40.415297121230566
              ],
              [
                148.48454838346578,
                -40.42799245960418
              ],
              [
                148.4768172648262,
                -40.43808360606694
              ],
              [
                148.46892338587253,
                -40.440687774724594
              ],
              [
                148.46176192247668,
                -40.43718841871613
              ],
              [
                148.45655359246388,
                -40.42799245960418
              ],
              [
                148.4526473357025,
                -40.432712502812656
              ],
              [
                148.44418380360403,
                -40.44850027567163
              ],
              [
                148.42530359034384,
                -40.45501068583663
              ],
              [
                148.42253665923758,
                -40.45525482150357
              ],
              [
                148.41098066953822,
                -40.468438414890976
              ],
              [
                148.40788820707493,
                -40.47665779712078
              ],
              [
                148.40886477611502,
                -40.48943449796161
              ],
              [
                148.38933353854168,
                -40.4818661550826
              ],
              [
                148.37094160574946,
                -40.48430755486485
              ],
              [
                148.35450281341093,
                -40.49293386939551
              ],
              [
                148.34058678590526,
                -40.50367604117361
              ],
              [
                148.34058678265802,
                -40.469496348958415
              ],
              [
                148.3273218095051,
                -40.43596770405525
              ],
              [
                148.29566491454844,
                -40.434665628918026
              ],
              [
                148.2307234923829,
                -40.462090737897
              ],
              [
                148.2241317190861,
                -40.45159272172082
              ],
              [
                148.2169702341533,
                -40.44548917298282
              ],
              [
                148.20801841349456,
                -40.44255948802626
              ],
              [
                148.1965438241046,
                -40.44166433154872
              ],
              [
                148.18978924518785,
                -40.44353604802291
              ],
              [
                148.18091882160536,
                -40.45289479729269
              ],
              [
                148.1760360082305,
                -40.45525482150357
              ],
              [
                148.1687931519234,
                -40.45452237698651
              ],
              [
                148.15739993220348,
                -40.44963957605891
              ],
              [
                148.1516219545772,
                -40.44850027567163
              ],
              [
                148.08204185426655,
                -40.45427824163035
              ],
              [
                148.05884851756875,
                -40.44850027567163
              ],
              [
                148.05030358409624,
                -40.44304778673077
              ],
              [
                148.0398055409846,
                -40.43181732380119
              ],
              [
                148.03272546743398,
                -40.42799245960418
              ],
              [
                148.01189210854142,
                -40.42848070814574
              ],
              [
                148.00245201975383,
                -40.42652760298306
              ],
              [
                147.9985457700182,
                -40.41773854132836
              ],
              [
                148.00220789068393,
                -40.39202240926279
              ],
              [
                148.01303143239664,
                -40.37810636021945
              ],
              [
                148.07406659692293,
                -40.35116952235822
              ],
              [
                148.0925399086133,
                -40.34693775618569
              ],
              [
                148.1381942016982,
                -40.34539152706527
              ],
              [
                148.16041101492664,
                -40.34783295528788
              ],
              [
                148.17156008691958,
                -40.35116952235822
              ],
              [
                148.1941023998482,
                -40.36565519273925
              ],
              [
                148.2031356216435,
                -40.35849375929344
              ],
              [
                148.2102156913775,
                -40.33863697749352
              ],
              [
                148.25294030289118,
                -40.33603281378025
              ],
              [
                148.28003990945209,
                -40.331231377283444
              ],
              [
                148.29216556821302,
                -40.321221622435345
              ],
              [
                148.29737388520329,
                -40.31951261649225
              ],
              [
                148.31959068404427,
                -40.30738696789676
              ],
              [
                148.32349693398908,
                -40.30445728082351
              ],
              [
                148.33790123292215,
                -40.30575936635467
              ],
              [
                148.34595787272752,
                -40.30950285479321
              ],
              [
                148.39144940129844,
                -40.35605232411816
              ],
              [
                148.40015709939127,
                -40.36174895911967
              ],
              [
                148.42066492091755,
                -40.36834076723725
              ],
              [
                148.42994226038854,
                -40.37330495432855
              ]
            ]
          ],
          [
            [
              [
                148.0149031940534,
                -40.15056732003448
              ],
              [
                148.01783288089175,
                -40.13738372450105
              ],
              [
                148.0124617877167,
                -40.119398699595045
              ],
              [
                148.00245201812214,
                -40.102471611837096
              ],
              [
                147.99105879356097,
                -40.09221771071933
              ],
              [
                147.9719344430265,
                -40.0891252606864
              ],
              [
                147.95899498887067,
                -40.09148528515405
              ],
              [
                147.9516707692729,
                -40.086358331361765
              ],
              [
                147.94955488278435,
                -40.06145598638591
              ],
              [
                147.94141686259186,
                -40.045098565457444
              ],
              [
                147.92237389437076,
                -40.03573984249278
              ],
              [
                147.90072675875842,
                -40.031670830678664
              ],
              [
                147.8850203781318,
                -40.03085702784502
              ],
              [
                147.8859155618253,
                -40.02410247309813
              ],
              [
                147.90447033746509,
                -39.99032980423761
              ],
              [
                147.90919030728273,
                -39.97616953871268
              ],
              [
                147.9060164192788,
                -39.962009302635565
              ],
              [
                147.89185624572596,
                -39.93206136205993
              ],
              [
                147.88868259880138,
                -39.91757592722511
              ],
              [
                147.88086993192033,
                -39.894952005890616
              ],
              [
                147.86247798257787,
                -39.89592853895875
              ],
              [
                147.82667087135533,
                -39.91415794700711
              ],
              [
                147.80746514752224,
                -39.91073998596639
              ],
              [
                147.75766035451278,
                -39.87932708437072
              ],
              [
                147.77369230141326,
                -39.8690732386296
              ],
              [
                147.79590914987475,
                -39.84726341315884
              ],
              [
                147.812998942131,
                -39.83831152067408
              ],
              [
                147.8536891098068,
                -39.8277321792735
              ],
              [
                147.8636173386066,
                -39.81698978096064
              ],
              [
                147.85401452430187,
                -39.79745859913645
              ],
              [
                147.8628035285288,
                -39.79420331101715
              ],
              [
                147.8811954836101,
                -39.78313564080569
              ],
              [
                147.8685001790222,
                -39.76913825611706
              ],
              [
                147.86304763945725,
                -39.761162907699756
              ],
              [
                147.8606877189239,
                -39.7526995079238
              ],
              [
                147.8650822382167,
                -39.74285248713793
              ],
              [
                147.87533604990173,
                -39.745700665525206
              ],
              [
                147.88672927923267,
                -39.752862125020265
              ],
              [
                147.8948674357642,
                -39.75644303679973
              ],
              [
                147.910899305839,
                -39.74928153610641
              ],
              [
                147.9532983889977,
                -39.711683873610575
              ],
              [
                148.1418563955486,
                -39.89934671933086
              ],
              [
                148.14812269977006,
                -39.91073998596639
              ],
              [
                148.16700274252062,
                -39.9356421083197
              ],
              [
                148.21094813847765,
                -39.95134859995159
              ],
              [
                148.29900151085724,
                -39.96184663011445
              ],
              [
                148.2922468458061,
                -39.98414466341972
              ],
              [
                148.29216555978158,
                -40.06145598638591
              ],
              [
                148.2832137350153,
                -40.081475515049874
              ],
              [
                148.24000084720456,
                -40.1070289042704
              ],
              [
                148.2238875677458,
                -40.12639739630607
              ],
              [
                148.2453719438045,
                -40.13290781370303
              ],
              [
                148.26742597862912,
                -40.127373958151274
              ],
              [
                148.28663170986823,
                -40.1145158867894
              ],
              [
                148.2990014980845,
                -40.09905364411163
              ],
              [
                148.30884850149656,
                -40.113539317692656
              ],
              [
                148.3198348322527,
                -40.13583749833338
              ],
              [
                148.33375084555374,
                -40.17473723609522
              ],
              [
                148.3320418561728,
                -40.1921525930162
              ],
              [
                148.32113692056245,
                -40.19019948432051
              ],
              [
                148.29216556222948,
                -40.167901301620034
              ],
              [
                148.2863061808729,
                -40.18971118925053
              ],
              [
                148.30347740433615,
                -40.201104417548976
              ],
              [
                148.32357832467972,
                -40.20956797183811
              ],
              [
                148.326914908936,
                -40.222588798601834
              ],
              [
                148.30738366234704,
                -40.23772552208205
              ],
              [
                148.28842207815137,
                -40.23113373139521
              ],
              [
                148.26905357538686,
                -40.216892176304704
              ],
              [
                148.24773196470483,
                -40.208916921980546
              ],
              [
                148.22592206592685,
                -40.20452238732376
              ],
              [
                148.21412194217194,
                -40.204196874542355
              ],
              [
                148.2028100897055,
                -40.208916921980546
              ],
              [
                148.19776452377627,
                -40.218682556282346
              ],
              [
                148.19255618493278,
                -40.24504973659782
              ],
              [
                148.1860457733345,
                -40.25058359769302
              ],
              [
                148.16749108623642,
                -40.25546640956359
              ],
              [
                148.14665775277263,
                -40.26490651426582
              ],
              [
                148.12427819582828,
                -40.270603129338284
              ],
              [
                148.07471764743102,
                -40.2551408875087
              ],
              [
                148.04997806318292,
                -40.24098072987096
              ],
              [
                148.03988692201995,
                -40.22283295024162
              ],
              [
                148.05884850485361,
                -40.202080989124646
              ],
              [
                148.02881920051183,
                -40.17880623943942
              ],
              [
                148.0144962886342,
                -40.16423918919648
              ],
              [
                148.0149031940534,
                -40.15056732003448
              ]
            ]
          ],
          [
            [
              [
                144.105479354589,
                -39.892998944438496
              ],
              [
                144.112966443065,
                -39.90260195984567
              ],
              [
                144.12289478907587,
                -39.90601987526104
              ],
              [
                144.13298577077578,
                -39.90829829462076
              ],
              [
                144.1403915718029,
                -39.91415794700711
              ],
              [
                144.14478594166772,
                -39.92644613648638
              ],
              [
                144.1442976440303,
                -39.936211740084914
              ],
              [
                144.1418563369298,
                -39.945977500686176
              ],
              [
                144.13868253387136,
                -39.98137792576172
              ],
              [
                144.1352646256687,
                -39.99212019587092
              ],
              [
                144.12916103761174,
                -39.99667738795599
              ],
              [
                144.12037194101575,
                -40.00090911302143
              ],
              [
                144.11719811299432,
                -40.01100025799206
              ],
              [
                144.11589603033178,
                -40.02239348845295
              ],
              [
                144.112478060154,
                -40.03085702784502
              ],
              [
                144.1030379572853,
                -40.03704192538921
              ],
              [
                144.08171634171217,
                -40.04534270560718
              ],
              [
                144.07146243536044,
                -40.05120208012743
              ],
              [
                144.0643009786715,
                -40.0591773442793
              ],
              [
                144.0581160806601,
                -40.06804778217342
              ],
              [
                144.05079186338608,
                -40.07537200352591
              ],
              [
                144.04037519752612,
                -40.07854583307935
              ],
              [
                144.01905357949056,
                -40.08163827558057
              ],
              [
                143.9225366565814,
                -40.127373958151274
              ],
              [
                143.90284264627493,
                -40.126153256095336
              ],
              [
                143.8864852204832,
                -40.10654062093379
              ],
              [
                143.88086998633298,
                -40.092380464727434
              ],
              [
                143.87224368536133,
                -40.05120208012743
              ],
              [
                143.88648522040128,
                -40.05217864181633
              ],
              [
                143.89242597716174,
                -40.03476327922108
              ],
              [
                143.89275156342777,
                -39.99285256162096
              ],
              [
                143.8859970289053,
                -39.96786886856552
              ],
              [
                143.87012786397628,
                -39.956719746804126
              ],
              [
                143.85189867318584,
                -39.949151353807665
              ],
              [
                143.83814536691486,
                -39.9345028463916
              ],
              [
                143.83716889232915,
                -39.91863382698035
              ],
              [
                143.84294678747264,
                -39.864434470555345
              ],
              [
                143.84831781473633,
                -39.85263424845694
              ],
              [
                143.8613387091887,
                -39.84254318723055
              ],
              [
                143.86654697024144,
                -39.81943110876526
              ],
              [
                143.8659774116239,
                -39.7769507812487
              ],
              [
                143.86378023951343,
                -39.77214947929798
              ],
              [
                143.8542586962749,
                -39.76132582927543
              ],
              [
                143.8517359233491,
                -39.75644303679973
              ],
              [
                143.85352631184574,
                -39.752618199391485
              ],
              [
                143.8634545383801,
                -39.74098060960987
              ],
              [
                143.86597733341793,
                -39.73528400673244
              ],
              [
                143.86011793581514,
                -39.712171995205544
              ],
              [
                143.86198979051267,
                -39.7006161586129
              ],
              [
                143.8756617004639,
                -39.695570634206256
              ],
              [
                143.8947860782494,
                -39.69150166323257
              ],
              [
                143.9172469749931,
                -39.680840800279654
              ],
              [
                143.93702242067587,
                -39.667250381401395
              ],
              [
                143.9480085540857,
                -39.65398513652417
              ],
              [
                143.94646241200698,
                -39.63437262055928
              ],
              [
                143.93816169958646,
                -39.6093076122231
              ],
              [
                143.93409256074423,
                -39.58798581868607
              ],
              [
                143.94459075176798,
                -39.578871436928544
              ],
              [
                143.9555769422566,
                -39.57773192174629
              ],
              [
                143.97437577745123,
                -39.5725235987891
              ],
              [
                143.98552488539795,
                -39.57146568227343
              ],
              [
                143.9931745976753,
                -39.57512775494829
              ],
              [
                144.02369222933677,
                -39.59937913058441
              ],
              [
                144.06544038450292,
                -39.615004282791816
              ],
              [
                144.08415777933283,
                -39.62615329664642
              ],
              [
                144.09506264254213,
                -39.64869549662146
              ],
              [
                144.10222414973933,
                -39.65618254268354
              ],
              [
                144.10922292618264,
                -39.665785518116785
              ],
              [
                144.11247802344076,
                -39.67791101382336
              ],
              [
                144.10547941585182,
                -39.722263352263695
              ],
              [
                144.10816483659323,
                -39.746026198363644
              ],
              [
                144.12273188442344,
                -39.786879050909555
              ],
              [
                144.12614990891768,
                -39.807712460621545
              ],
              [
                144.1215925645028,
                -39.828871242391145
              ],
              [
                144.1049911727794,
                -39.872491268908306
              ],
              [
                144.105479354589,
                -39.892998944438496
              ]
            ]
          ],
          [
            [
              [
                146.62680103382237,
                -38.755954766126194
              ],
              [
                146.63453210655047,
                -38.75318777163629
              ],
              [
                146.64258877436365,
                -38.75253676891961
              ],
              [
                146.6513779016508,
                -38.75351342412079
              ],
              [
                146.6608993418356,
                -38.755954766126194
              ],
              [
                146.6575626698154,
                -38.76441818963858
              ],
              [
                146.6520287436474,
                -38.76881261769035
              ],
              [
                146.64405360460145,
                -38.77027763424248
              ],
              [
                146.5827743809896,
                -38.76946393699883
              ],
              [
                146.57601978622841,
                -38.773207374521064
              ],
              [
                146.56617275675646,
                -38.7907854645605
              ],
              [
                146.55844157297935,
                -38.79680750862799
              ],
              [
                146.5389103494817,
                -38.797051687409386
              ],
              [
                146.5161239363022,
                -38.789483391344575
              ],
              [
                146.49463951034704,
                -38.778008709647615
              ],
              [
                146.4797469141445,
                -38.76620855363814
              ],
              [
                146.47136476303032,
                -38.74724697873622
              ],
              [
                146.48975673799012,
                -38.74570082330788
              ],
              [
                146.53467863878677,
                -38.755954766126194
              ],
              [
                146.580577106852,
                -38.74781679051569
              ],
              [
                146.60230556374202,
                -38.746840143059984
              ],
              [
                146.62680103382237,
                -38.755954766126194
              ]
            ]
          ],
          [
            [
              [
                145.33521574301966,
                -38.50945410980883
              ],
              [
                145.34343504059677,
                -38.51051190209724
              ],
              [
                145.34441169732568,
                -38.51336034566637
              ],
              [
                145.34327230202325,
                -38.51775477233376
              ],
              [
                145.34571371399454,
                -38.523125874041426
              ],
              [
                145.35450285576258,
                -38.534437839156865
              ],
              [
                145.3610131839633,
                -38.54851648595212
              ],
              [
                145.3613388242564,
                -38.561781633369996
              ],
              [
                145.35254970920974,
                -38.570977521703675
              ],
              [
                145.35230557206842,
                -38.56650161386871
              ],
              [
                145.3505965003124,
                -38.56357180078163
              ],
              [
                145.34831789631474,
                -38.5608049333745
              ],
              [
                145.34571380509067,
                -38.557224314544854
              ],
              [
                145.3195906936363,
                -38.539320574836815
              ],
              [
                145.2928166835297,
                -38.52564881475823
              ],
              [
                145.26368243858417,
                -38.51921958698321
              ],
              [
                145.22901449501381,
                -38.523125874041426
              ],
              [
                145.22038827668848,
                -38.530043313969
              ],
              [
                145.21314534244812,
                -38.53460046575075
              ],
              [
                145.20573985237633,
                -38.53679788943293
              ],
              [
                145.19800873900024,
                -38.5347633940994
              ],
              [
                145.18165120603797,
                -38.52548588840712
              ],
              [
                145.17505941702265,
                -38.523125874041426
              ],
              [
                145.159190372799,
                -38.523858437147254
              ],
              [
                145.1297305970785,
                -38.530450028974926
              ],
              [
                145.11296633149996,
                -38.53053149268981
              ],
              [
                145.12061610790246,
                -38.519626597785575
              ],
              [
                145.1545515460916,
                -38.495212376944984
              ],
              [
                145.17579177358832,
                -38.47551835734747
              ],
              [
                145.18767332202535,
                -38.466973491489625
              ],
              [
                145.20240309862493,
                -38.46111405595064
              ],
              [
                145.26441496246338,
                -38.455499032687136
              ],
              [
                145.2732039235942,
                -38.45370852124208
              ],
              [
                145.2793075501582,
                -38.45159279686557
              ],
              [
                145.28630614539014,
                -38.451429886636866
              ],
              [
                145.29786222747552,
                -38.455499032687136
              ],
              [
                145.3046980137056,
                -38.459160920923615
              ],
              [
                145.31316164432334,
                -38.46575284740622
              ],
              [
                145.31836990145794,
                -38.46851966362321
              ],
              [
                145.30827887926483,
                -38.47380955740765
              ],
              [
                145.30420979017137,
                -38.47527428593129
              ],
              [
                145.31299896339092,
                -38.490492547229735
              ],
              [
                145.3183699049981,
                -38.495212376944984
              ],
              [
                145.31495206310564,
                -38.50367610430192
              ],
              [
                145.31739345457058,
                -38.5079078531018
              ],
              [
                145.32447350015758,
                -38.50937264839987
              ],
              [
                145.33521574301966,
                -38.50945410980883
              ]
            ]
          ],
          [
            [
              [
                145.44190513982596,
                -38.31650155386616
              ],
              [
                145.45435628800533,
                -38.321709852875784
              ],
              [
                145.46314536996178,
                -38.328545817727814
              ],
              [
                145.4943953693251,
                -38.36516691082028
              ],
              [
                145.48878023235653,
                -38.36907330447771
              ],
              [
                145.4685977552032,
                -38.372816523158825
              ],
              [
                145.4270126211423,
                -38.374932630817646
              ],
              [
                145.41407302573904,
                -38.37908281312172
              ],
              [
                145.37663819926374,
                -38.415459868045545
              ],
              [
                145.35328203747235,
                -38.42839925992908
              ],
              [
                145.32455489239555,
                -38.42066823928687
              ],
              [
                145.31576574297506,
                -38.41432045676832
              ],
              [
                145.283702035688,
                -38.40260184545048
              ],
              [
                145.2824813643227,
                -38.39055762084136
              ],
              [
                145.2797958195391,
                -38.37932715513091
              ],
              [
                145.27003007023526,
                -38.358656399689245
              ],
              [
                145.2978621252143,
                -38.324476747795345
              ],
              [
                145.292979401562,
                -38.31780370072062
              ],
              [
                145.29021252450977,
                -38.31015403423789
              ],
              [
                145.29127044386945,
                -38.302667020484904
              ],
              [
                145.29786211942576,
                -38.29656332717736
              ],
              [
                145.30689534411113,
                -38.295342654633
              ],
              [
                145.31324296998716,
                -38.2998999023059
              ],
              [
                145.31861415936265,
                -38.30632907867636
              ],
              [
                145.3245548875393,
                -38.310804951206485
              ],
              [
                145.36410568935486,
                -38.32341891379658
              ],
              [
                145.3798933751862,
                -38.324476747795345
              ],
              [
                145.4250595177534,
                -38.3150368298085
              ],
              [
                145.44190513982596,
                -38.31650155386616
              ]
            ]
          ],
          [
            [
              [
                138.12964928168836,
                -35.81633879428258
              ],
              [
                138.12354575373422,
                -35.830987211659114
              ],
              [
                138.12818443889313,
                -35.84880949936732
              ],
              [
                138.12582440908014,
                -35.8639462117992
              ],
              [
                138.09888756130977,
                -35.87029386991857
              ],
              [
                138.0867619096026,
                -35.87737394670192
              ],
              [
                138.05982508010453,
                -35.9097633032701
              ],
              [
                138.0476994279948,
                -35.91863374435432
              ],
              [
                138.02670331548106,
                -35.91912199350467
              ],
              [
                138.00375412068337,
                -35.91350680115717
              ],
              [
                137.9831648994135,
                -35.90447354776926
              ],
              [
                137.950531466267,
                -35.88079195994298
              ],
              [
                137.93246505427842,
                -35.87525809562657
              ],
              [
                137.91293380427638,
                -35.87525809562657
              ],
              [
                137.88998457604677,
                -35.87769948570611
              ],
              [
                137.8742781697587,
                -35.87688563835094
              ],
              [
                137.84498129485266,
                -35.866631732490035
              ],
              [
                137.8217879533463,
                -35.86402759569013
              ],
              [
                137.7971297718806,
                -35.864841434882884
              ],
              [
                137.75668377763697,
                -35.87151455964632
              ],
              [
                137.67335047012688,
                -35.90203218165824
              ],
              [
                137.62875409901392,
                -35.910332935845716
              ],
              [
                137.61329186499992,
                -35.92424895945025
              ],
              [
                137.60694422074488,
                -35.94394299069575
              ],
              [
                137.60889735110322,
                -35.96648531690255
              ],
              [
                137.6118270196746,
                -35.97210052016138
              ],
              [
                137.61646567488043,
                -35.97698330324961
              ],
              [
                137.62061608160155,
                -35.98267994531401
              ],
              [
                137.62256922439502,
                -35.99081799692754
              ],
              [
                137.62037193397205,
                -36.000095297912935
              ],
              [
                137.61573328546154,
                -36.007582318303356
              ],
              [
                137.6110946112301,
                -36.01360444946156
              ],
              [
                137.6088973328828,
                -36.0179989575171
              ],
              [
                137.6023055246736,
                -36.02581143825657
              ],
              [
                137.55420984395613,
                -36.03533296154261
              ],
              [
                137.49317466282105,
                -36.070407789095185
              ],
              [
                137.45923912570478,
                -36.08269621634524
              ],
              [
                137.4449976015438,
                -36.06951264438773
              ],
              [
                137.41586347889913,
                -36.05543385526355
              ],
              [
                137.37110437735484,
                -36.01083752272182
              ],
              [
                137.33855228721885,
                -36.00123464544011
              ],
              [
                137.29029382439197,
                -35.998793241468206
              ],
              [
                137.2435001848884,
                -35.9830868278238
              ],
              [
                137.22787517959404,
                -35.97975022967974
              ],
              [
                137.2116805509032,
                -35.98015718645489
              ],
              [
                137.18799888690418,
                -35.993096600754036
              ],
              [
                137.18100021323522,
                -36.0140927357197
              ],
              [
                137.17123457831647,
                -36.03362396860693
              ],
              [
                137.13990320221725,
                -36.042250277325856
              ],
              [
                137.1242781911796,
                -36.04013437330941
              ],
              [
                137.09213301695218,
                -36.03069428271184
              ],
              [
                137.0744735046196,
                -36.02849700406847
              ],
              [
                137.04420004453118,
                -36.03460048197428
              ],
              [
                137.0302840314289,
                -36.03337978396673
              ],
              [
                137.01978602294918,
                -36.02174247870327
              ],
              [
                136.9519149040187,
                -36.046075117682356
              ],
              [
                136.92042075070609,
                -36.0494930654405
              ],
              [
                136.88941492119682,
                -36.042250277325856
              ],
              [
                136.8694767505088,
                -36.0305314933346
              ],
              [
                136.86215254061858,
                -36.02849700406847
              ],
              [
                136.8507592940111,
                -36.03045009865406
              ],
              [
                136.83326254844255,
                -36.03997158267995
              ],
              [
                136.82471765519156,
                -36.042250277325856
              ],
              [
                136.8029077313532,
                -36.041192287247526
              ],
              [
                136.79135177796223,
                -36.041924770753226
              ],
              [
                136.78337649070608,
                -36.045668214402355
              ],
              [
                136.7718204983932,
                -36.05608487568696
              ],
              [
                136.76514732208273,
                -36.05722419987742
              ],
              [
                136.7584741443212,
                -36.054945552559964
              ],
              [
                136.74610436809286,
                -36.055840761794435
              ],
              [
                136.72852625318163,
                -36.06080497221449
              ],
              [
                136.71558676885837,
                -36.06275804312711
              ],
              [
                136.70728600013183,
                -36.05689868931846
              ],
              [
                136.7046004398349,
                -36.03875087932805
              ],
              [
                136.69874110199694,
                -36.02654391258563
              ],
              [
                136.6852319747905,
                -36.007012641486064
              ],
              [
                136.65674890052165,
                -35.97389089430726
              ],
              [
                136.64291425298953,
                -35.96851977957535
              ],
              [
                136.60547935835663,
                -35.96314868794238
              ],
              [
                136.59131922578067,
                -35.95663831160107
              ],
              [
                136.53256267957636,
                -35.91187913642552
              ],
              [
                136.5368758630733,
                -35.902113567974894
              ],
              [
                136.53736411211864,
                -35.88225673959466
              ],
              [
                136.54004967036278,
                -35.87029386991857
              ],
              [
                136.5446069546247,
                -35.865329663429875
              ],
              [
                136.55152430173393,
                -35.86142346417009
              ],
              [
                136.55762777972294,
                -35.85426194164462
              ],
              [
                136.5620223441081,
                -35.82952241513208
              ],
              [
                136.56625412291825,
                -35.82057060752083
              ],
              [
                136.5717879392401,
                -35.81275803998446
              ],
              [
                136.57789148591894,
                -35.8063290583128
              ],
              [
                136.58236737026942,
                -35.796970286007834
              ],
              [
                136.57894942607206,
                -35.777520460362446
              ],
              [
                136.5815535916022,
                -35.768487254797705
              ],
              [
                136.59782962097154,
                -35.75750090545011
              ],
              [
                136.62110437102592,
                -35.75123464704595
              ],
              [
                136.69125410933498,
                -35.746026312832875
              ],
              [
                136.7386173639695,
                -35.72682053594019
              ],
              [
                136.76807700053186,
                -35.724297751678385
              ],
              [
                136.7802840710739,
                -35.72079847188355
              ],
              [
                136.79574627548965,
                -35.71168382659721
              ],
              [
                136.8051864048046,
                -35.707940381916416
              ],
              [
                137.0744735172908,
                -35.671644813257636
              ],
              [
                137.09392339181932,
                -35.665704066935184
              ],
              [
                137.14389080110726,
                -35.644301005168764
              ],
              [
                137.27995853183236,
                -35.61695729320852
              ],
              [
                137.29297936061928,
                -35.609144785829926
              ],
              [
                137.30502364436072,
                -35.597751578153584
              ],
              [
                137.31820723370475,
                -35.58733490575146
              ],
              [
                137.3351343201726,
                -35.58294037907764
              ],
              [
                137.35222414902367,
                -35.58562589852688
              ],
              [
                137.43588301396795,
                -35.61060964169178
              ],
              [
                137.444997591368,
                -35.61093515289423
              ],
              [
                137.4537866555001,
                -35.60808684787477
              ],
              [
                137.47234134528384,
                -35.59661224374691
              ],
              [
                137.48975671113237,
                -35.59612396323105
              ],
              [
                137.51612389680568,
                -35.598321226908155
              ],
              [
                137.53305098028525,
                -35.59661224374691
              ],
              [
                137.56885827049,
                -35.58554453160683
              ],
              [
                137.58676190617066,
                -35.58359138855246
              ],
              [
                137.60206139563314,
                -35.590427344855975
              ],
              [
                137.62289472772179,
                -35.58212656126242
              ],
              [
                137.6342879513164,
                -35.590508712062174
              ],
              [
                137.63363691646975,
                -35.60377369856836
              ],
              [
                137.61939537836716,
                -35.61093515289423
              ],
              [
                137.59799238165914,
                -35.61728280591031
              ],
              [
                137.58334395734036,
                -35.631280225803295
              ],
              [
                137.58155356967112,
                -35.64544034148224
              ],
              [
                137.59864341630757,
                -35.651788003834675
              ],
              [
                137.63282310430543,
                -35.651788003834675
              ],
              [
                137.64714604428977,
                -35.654066689919276
              ],
              [
                137.6477157071741,
                -35.65943778619903
              ],
              [
                137.6240340332444,
                -35.68726976081444
              ],
              [
                137.5808211398461,
                -35.72682053594019
              ],
              [
                137.6018172737637,
                -35.74391044935182
              ],
              [
                137.62378991274406,
                -35.744561460768544
              ],
              [
                137.64600672559217,
                -35.7423642233071
              ],
              [
                137.6860457669554,
                -35.75750090545011
              ],
              [
                137.71159913551622,
                -35.75628017217832
              ],
              [
                137.75277754078598,
                -35.74797942636439
              ],
              [
                137.76490317634304,
                -35.743584868553924
              ],
              [
                137.7722274249009,
                -35.739434528872444
              ],
              [
                137.77849369867585,
                -35.73951590500791
              ],
              [
                137.7869572277862,
                -35.74797942636439
              ],
              [
                137.79175866273675,
                -35.757256773747635
              ],
              [
                137.79127036865947,
                -35.76458097006633
              ],
              [
                137.7885848181222,
                -35.77288174493925
              ],
              [
                137.7869572436289,
                -35.7852515888162
              ],
              [
                137.7944442209591,
                -35.80478283416908
              ],
              [
                137.8127547754745,
                -35.81145602516658
              ],
              [
                137.8352970878666,
                -35.80925875118936
              ],
              [
                137.85596765929142,
                -35.802666951466364
              ],
              [
                137.87134850806336,
                -35.79306406703481
              ],
              [
                137.88445070804292,
                -35.77922940948532
              ],
              [
                137.893402525536,
                -35.76246507693148
              ],
              [
                137.896820517908,
                -35.744317331449864
              ],
              [
                137.90853924830805,
                -35.72909919844612
              ],
              [
                137.93555747908496,
                -35.72649503453088
              ],
              [
                137.96558677990313,
                -35.73023853115929
              ],
              [
                138.00684653663072,
                -35.74041104282702
              ],
              [
                138.04810631394994,
                -35.75750090545011
              ],
              [
                138.0647078928018,
                -35.76100028189233
              ],
              [
                138.06690514724417,
                -35.76628997761457
              ],
              [
                138.07439210166564,
                -35.79924891912744
              ],
              [
                138.08033289589656,
                -35.80925875118936
              ],
              [
                138.0940047428156,
                -35.814629796684514
              ],
              [
                138.1101180327272,
                -35.81650155607563
              ],
              [
                138.12964928168836,
                -35.81633879428258
              ]
            ]
          ],
          [
            [
              [
                136.44727623652327,
                -35.148125906349634
              ],
              [
                136.46290123973955,
                -35.13974375112224
              ],
              [
                136.47632896952612,
                -35.14470793656052
              ],
              [
                136.48796634010523,
                -35.15740324960162
              ],
              [
                136.4985457705323,
                -35.17205169374609
              ],
              [
                136.49219811235912,
                -35.1788876268514
              ],
              [
                136.48487389553216,
                -35.17205169374609
              ],
              [
                136.4642033174561,
                -35.17253996564675
              ],
              [
                136.44752037409478,
                -35.16936613520414
              ],
              [
                136.43995202336677,
                -35.16171641183279
              ],
              [
                136.44727623652327,
                -35.148125906349634
              ]
            ]
          ],
          [
            [
              [
                136.17359459711744,
                -35.01132577921224
              ],
              [
                136.1850692063676,
                -35.021172782857114
              ],
              [
                136.19361412836554,
                -35.02581145485373
              ],
              [
                136.19971764429485,
                -35.032810154532314
              ],
              [
                136.2048445962342,
                -35.04908619461789
              ],
              [
                136.20655358262636,
                -35.06121184812967
              ],
              [
                136.20590253898413,
                -35.07138437116814
              ],
              [
                136.20134524766715,
                -35.07537200239969
              ],
              [
                136.19060306213854,
                -35.06959401005315
              ],
              [
                136.16211998783945,
                -35.06552499771013
              ],
              [
                136.15284264334124,
                -35.04851653281046
              ],
              [
                136.15056399819213,
                -35.02467213334703
              ],
              [
                136.1428328789847,
                -35.000664971972284
              ],
              [
                136.09929443161676,
                -34.96819420489657
              ],
              [
                136.08611094300014,
                -34.94817486492774
              ],
              [
                136.1116642511371,
                -34.93922290074038
              ],
              [
                136.12696381236387,
                -34.948419012798546
              ],
              [
                136.17359459711744,
                -35.01132577921224
              ]
            ]
          ],
          [
            [
              [
                137.36915126973486,
                -34.472426098080334
              ],
              [
                137.37378998228942,
                -34.49822369816141
              ],
              [
                137.36719813197152,
                -34.52410250664982
              ],
              [
                137.3548282784835,
                -34.53801841038291
              ],
              [
                137.34197018502692,
                -34.52776446597999
              ],
              [
                137.33619228857086,
                -34.5153134721774
              ],
              [
                137.34408612364354,
                -34.50074633306378
              ],
              [
                137.36915126973486,
                -34.472426098080334
              ]
            ]
          ],
          [
            [
              [
                134.5463972740616,
                -33.71217202125715
              ],
              [
                134.55062915984462,
                -33.733656619454926
              ],
              [
                134.54346759043813,
                -33.7401668218201
              ],
              [
                134.52881923233525,
                -33.74130629680762
              ],
              [
                134.51156661778677,
                -33.74627047141026
              ],
              [
                134.49048905521653,
                -33.7756485540266
              ],
              [
                134.4790145959939,
                -33.78362410411252
              ],
              [
                134.4713647254103,
                -33.766778147904134
              ],
              [
                134.48259522144798,
                -33.737969607823054
              ],
              [
                134.48438568612661,
                -33.72958763899439
              ],
              [
                134.4845483671843,
                -33.716485272780304
              ],
              [
                134.48633867136923,
                -33.711683723432536
              ],
              [
                134.49927817280988,
                -33.705336160894916
              ],
              [
                134.5267033670195,
                -33.69947690981688
              ],
              [
                134.52898199872064,
                -33.69850031922175
              ],
              [
                134.53956136997076,
                -33.69646570662216
              ],
              [
                134.54200285350882,
                -33.69996520525715
              ],
              [
                134.5463972740616,
                -33.71217202125715
              ]
            ]
          ],
          [
            [
              [
                133.56568442221553,
                -32.32122157408721
              ],
              [
                133.5415145293158,
                -32.312595331382276
              ],
              [
                133.54379317072195,
                -32.294610295870655
              ],
              [
                133.56039474962537,
                -32.27459079997918
              ],
              [
                133.57935629755346,
                -32.25969813667483
              ],
              [
                133.59799237811396,
                -32.251153240767486
              ],
              [
                133.6233016370285,
                -32.24391043168772
              ],
              [
                133.65064541292335,
                -32.23943457351327
              ],
              [
                133.67554774711414,
                -32.23935317519288
              ],
              [
                133.67554774340329,
                -32.24537530246758
              ],
              [
                133.62037192254778,
                -32.25969813667483
              ],
              [
                133.62916103503304,
                -32.275323239401196
              ],
              [
                133.63396242788437,
                -32.28020597116255
              ],
              [
                133.62256923472427,
                -32.28508885750957
              ],
              [
                133.61622152803324,
                -32.294366098451796
              ],
              [
                133.61264080209818,
                -32.303399307823554
              ],
              [
                133.61011805112003,
                -32.30754977140448
              ],
              [
                133.59782964212238,
                -32.308851860627065
              ],
              [
                133.56568442221553,
                -32.32122157408721
              ]
            ]
          ],
          [
            [
              [
                159.04444419395313,
                -31.51921963534988
              ],
              [
                159.0688582983385,
                -31.520928697168124
              ],
              [
                159.0833439254007,
                -31.534844621700064
              ],
              [
                159.09376061718356,
                -31.55299245356722
              ],
              [
                159.10645595259768,
                -31.567640932877502
              ],
              [
                159.09839928151834,
                -31.579278246711088
              ],
              [
                159.0896102162625,
                -31.589043867641045
              ],
              [
                159.07886802755604,
                -31.593357015562212
              ],
              [
                159.06478926768588,
                -31.588148711685086
              ],
              [
                159.0800887549193,
                -31.576267215569466
              ],
              [
                159.08301841710218,
                -31.558363525716846
              ],
              [
                159.0752059410167,
                -31.53980888099548
              ],
              [
                159.05795331355907,
                -31.526055583517866
              ],
              [
                159.05176838452292,
                -31.533461122686635
              ],
              [
                159.04704840170612,
                -31.526543930013748
              ],
              [
                159.04444419395313,
                -31.51921963534988
              ]
            ]
          ],
          [
            [
              [
                153.4873152880709,
                -27.415215723915374
              ],
              [
                153.50114991673044,
                -27.417657112031296
              ],
              [
                153.5488387260661,
                -27.415215723915374
              ],
              [
                153.52751712625505,
                -27.455661724910613
              ],
              [
                153.50855554570143,
                -27.504082966920482
              ],
              [
                153.45590252777976,
                -27.720798405846164
              ],
              [
                153.45069426211913,
                -27.723077212480653
              ],
              [
                153.43555754311373,
                -27.723077212480653
              ],
              [
                153.4217229108022,
                -27.72503034627337
              ],
              [
                153.41130612346,
                -27.727634223827273
              ],
              [
                153.40333097035932,
                -27.72625101720862
              ],
              [
                153.3913680900678,
                -27.701836978607787
              ],
              [
                153.39226315550212,
                -27.687757923877975
              ],
              [
                153.39795981338867,
                -27.657891489382525
              ],
              [
                153.40007567000387,
                -27.654554833309984
              ],
              [
                153.40479581620335,
                -27.650567429215283
              ],
              [
                153.4094344196015,
                -27.645114790657935
              ],
              [
                153.41146898564168,
                -27.637139676165948
              ],
              [
                153.40967852048627,
                -27.628350371231747
              ],
              [
                153.4006453178142,
                -27.615004017870497
              ],
              [
                153.39795982184413,
                -27.606377838563102
              ],
              [
                153.39942465408623,
                -27.59238041662784
              ],
              [
                153.40919029086683,
                -27.56210700695572
              ],
              [
                153.41146889420352,
                -27.548028127857542
              ],
              [
                153.40943443628427,
                -27.531914960593113
              ],
              [
                153.39795983543348,
                -27.493096621328707
              ],
              [
                153.4025171467999,
                -27.478204091794566
              ],
              [
                153.42432703868127,
                -27.450453430882064
              ],
              [
                153.43213951412005,
                -27.435723554115302
              ],
              [
                153.4323836858281,
                -27.40642675403419
              ],
              [
                153.4340926443698,
                -27.392998956903156
              ],
              [
                153.44239339812688,
                -27.387302276328317
              ],
              [
                153.45850671657578,
                -27.390883094392077
              ],
              [
                153.46908613470683,
                -27.39918385372533
              ],
              [
                153.47730553461486,
                -27.408461195060234
              ],
              [
                153.4873152880709,
                -27.415215723915374
              ]
            ]
          ],
          [
            [
              [
                153.41146897589323,
                -27.339532232320828
              ],
              [
                153.4121199641686,
                -27.322686397475408
              ],
              [
                153.40658615025515,
                -27.29501722500078
              ],
              [
                153.39747152161203,
                -27.269138209005785
              ],
              [
                153.38738038208936,
                -27.257582233459267
              ],
              [
                153.376475430008,
                -27.24781659833455
              ],
              [
                153.36947677240946,
                -27.225518521174592
              ],
              [
                153.36378013965623,
                -27.16334399720369
              ],
              [
                153.36996501738045,
                -27.10271569653144
              ],
              [
                153.3659773857651,
                -27.080498895397366
              ],
              [
                153.36052495130085,
                -27.06601331730387
              ],
              [
                153.3631291239671,
                -27.05527114703521
              ],
              [
                153.38363692051303,
                -27.044122016821532
              ],
              [
                153.41830489152792,
                -27.037855745877643
              ],
              [
                153.43962649149017,
                -27.02255623165901
              ],
              [
                153.45134526857174,
                -27.0170224456563
              ],
              [
                153.46273849773021,
                -27.020603175036577
              ],
              [
                153.46900477805724,
                -27.037041985311824
              ],
              [
                153.46607504709576,
                -27.06015385668705
              ],
              [
                153.42579189170763,
                -27.18043392323103
              ],
              [
                153.41822352700115,
                -27.22283299789716
              ],
              [
                153.41830491240646,
                -27.271254235019207
              ],
              [
                153.42115321475922,
                -27.283135733512154
              ],
              [
                153.43018639031615,
                -27.308689050944917
              ],
              [
                153.43213950738976,
                -27.322442287490965
              ],
              [
                153.43165123170107,
                -27.339043862551403
              ],
              [
                153.42920982678575,
                -27.35442472522582
              ],
              [
                153.42302494097004,
                -27.358168239172787
              ],
              [
                153.41146897589323,
                -27.339532232320828
              ]
            ]
          ],
          [
            [
              [
                113.21664473362691,
                -26.06804780826171
              ],
              [
                113.22461998450333,
                -26.085381756216528
              ],
              [
                113.22510827670045,
                -26.108331016099758
              ],
              [
                113.21900475282509,
                -26.128838795719098
              ],
              [
                113.20704185768626,
                -26.139743728654114
              ],
              [
                113.19613690937952,
                -26.13600023752961
              ],
              [
                113.17725671339971,
                -26.125583615331145
              ],
              [
                113.1706846318992,
                -26.092617260320257
              ],
              [
                113.15569933537951,
                -26.05405940206155
              ],
              [
                113.13559003690435,
                -26.03346118462693
              ],
              [
                113.12769615905428,
                -26.023695567522466
              ],
              [
                113.08269843484057,
                -25.965497940714815
              ],
              [
                113.0461531999175,
                -25.94003675003327
              ],
              [
                113.01242575910956,
                -25.8451322523442
              ],
              [
                112.96452883932214,
                -25.794040612955143
              ],
              [
                112.95386804125566,
                -25.773044552506903
              ],
              [
                112.96290123576894,
                -25.763604416610224
              ],
              [
                112.96355227462513,
                -25.754489821773745
              ],
              [
                112.95479137090962,
                -25.697520567410848
              ],
              [
                112.91959906461562,
                -25.63155523473552
              ],
              [
                112.91984880951112,
                -25.577110746951877
              ],
              [
                112.9224586962379,
                -25.55897497790986
              ],
              [
                112.91944420992722,
                -25.52361420223013
              ],
              [
                112.9318139988093,
                -25.507012631108747
              ],
              [
                112.9460555363658,
                -25.49187591425248
              ],
              [
                112.95948326548174,
                -25.482517171460238
              ],
              [
                112.96900475058862,
                -25.49431730288571
              ],
              [
                112.98365318984301,
                -25.49309660855211
              ],
              [
                112.99838301210377,
                -25.489922795932628
              ],
              [
                113.00782311672786,
                -25.496189074323162
              ],
              [
                113.00652102536962,
                -25.50457120422049
              ],
              [
                113.00618193165991,
                -25.531650029696916
              ],
              [
                113.00606420312108,
                -25.552923025462828
              ],
              [
                113.02001149467687,
                -25.589134588017536
              ],
              [
                113.04337939558955,
                -25.629646878244564
              ],
              [
                113.0501812612147,
                -25.680761806858033
              ],
              [
                113.05128014268793,
                -25.716973561050906
              ],
              [
                113.07108423223777,
                -25.74684789446518
              ],
              [
                113.08976308245997,
                -25.795818915484094
              ],
              [
                113.11785410875643,
                -25.847127106902143
              ],
              [
                113.13754317485518,
                -25.885918914636445
              ],
              [
                113.11524498004556,
                -25.937758041546342
              ],
              [
                113.11557051305232,
                -25.963311470973867
              ],
              [
                113.1450301396838,
                -25.969008055062027
              ],
              [
                113.14039147424602,
                -25.96257904229795
              ],
              [
                113.13477624356905,
                -25.952243768593
              ],
              [
                113.13135827507055,
                -25.947930619455768
              ],
              [
                113.14470463147774,
                -25.946221644361202
              ],
              [
                113.15503990921499,
                -25.958672781098993
              ],
              [
                113.16456139863219,
                -25.97698334809015
              ],
              [
                113.17579186227765,
                -25.992771089338092
              ],
              [
                113.18327883251993,
                -26.00090907809564
              ],
              [
                113.19605553780558,
                -26.01897552931356
              ],
              [
                113.20337975723412,
                -26.02703217088052
              ],
              [
                113.20899499511732,
                -26.03655367012416
              ],
              [
                113.21216880863228,
                -26.05917731500571
              ],
              [
                113.21664473362691,
                -26.06804780826171
              ]
            ]
          ],
          [
            [
              [
                152.9624129552968,
                -25.269626555072186
              ],
              [
                152.99366295628872,
                -25.303969005948424
              ],
              [
                153.0063582670332,
                -25.327732023339053
              ],
              [
                152.99390709935884,
                -25.33847422378329
              ],
              [
                152.96371504044927,
                -25.29908619729635
              ],
              [
                152.95362389116087,
                -25.278496994791514
              ],
              [
                152.9624129552968,
                -25.269626555072186
              ]
            ]
          ],
          [
            [
              [
                113.05567467595797,
                -25.262790626751578
              ],
              [
                113.05128014200186,
                -25.239678636158192
              ],
              [
                113.07585696867082,
                -25.169854431594217
              ],
              [
                113.08301842567748,
                -25.1366513026809
              ],
              [
                113.07911217543398,
                -25.062432551728268
              ],
              [
                113.08838951899631,
                -25.02906666498497
              ],
              [
                113.11768639396908,
                -25.009454033875937
              ],
              [
                113.11060631558878,
                -25.044691663359913
              ],
              [
                113.11011803494083,
                -25.063083591764254
              ],
              [
                113.11426842478829,
                -25.070977471157256
              ],
              [
                113.10547936268202,
                -25.079847913735268
              ],
              [
                113.10303795735459,
                -25.10076262940704
              ],
              [
                113.1033634761948,
                -25.14039478681472
              ],
              [
                113.09766686370364,
                -25.156508073779374
              ],
              [
                113.07984459749574,
                -25.19052499995303
              ],
              [
                113.07618249016639,
                -25.205010683524304
              ],
              [
                113.07667076983866,
                -25.242282813289382
              ],
              [
                113.07471764192704,
                -25.260186447880397
              ],
              [
                113.06934655144676,
                -25.276462503658628
              ],
              [
                113.06316165644662,
                -25.276462503658628
              ],
              [
                113.05738365846925,
                -25.26726652800692
              ],
              [
                113.05567467595797,
                -25.262790626751578
              ]
            ]
          ],
          [
            [
              [
                113.15186607658462,
                -24.92693448119061
              ],
              [
                113.12956791813573,
                -24.95623143077815
              ],
              [
                113.12094157088201,
                -24.974053519152267
              ],
              [
                113.11768636094197,
                -24.995212365606232
              ],
              [
                113.11768639002847,
                -24.985772378081133
              ],
              [
                113.1164656679194,
                -24.977145999419825
              ],
              [
                113.11426843390913,
                -24.96892672676153
              ],
              [
                113.11085047398565,
                -24.96111425922933
              ],
              [
                113.13282311787691,
                -24.802341423852603
              ],
              [
                113.15186609502649,
                -24.75562921822817
              ],
              [
                113.15919027533407,
                -24.77564859538605
              ],
              [
                113.15845787930883,
                -24.801690364256764
              ],
              [
                113.13493896726692,
                -24.89202226984188
              ],
              [
                113.13599693141062,
                -24.917168839343265
              ],
              [
                113.15186607658462,
                -24.92693448119061
              ]
            ]
          ],
          [
            [
              [
                153.36996507355488,
                -24.989027701166734
              ],
              [
                153.3735457690273,
                -25.01181406008024
              ],
              [
                153.3657332692349,
                -25.02955494669153
              ],
              [
                153.35482832155145,
                -25.045342707621863
              ],
              [
                153.34945722654658,
                -25.060967704667895
              ],
              [
                153.34546959647636,
                -25.081638277464396
              ],
              [
                153.2674259754274,
                -25.255547779453963
              ],
              [
                153.16065514208174,
                -25.463148690546383
              ],
              [
                153.08350670383552,
                -25.66578540614852
              ],
              [
                153.08570396036188,
                -25.691338767516115
              ],
              [
                153.10173586597784,
                -25.72185635845079
              ],
              [
                153.09986413680213,
                -25.75774507165692
              ],
              [
                153.08326257162355,
                -25.78687918057459
              ],
              [
                153.05534916338928,
                -25.797133094219234
              ],
              [
                153.01628666467602,
                -25.754001586881568
              ],
              [
                152.99935955767103,
                -25.72861089788901
              ],
              [
                152.99732506993777,
                -25.712090763978622
              ],
              [
                153.0022078895819,
                -25.693047813547587
              ],
              [
                152.98422284047263,
                -25.645765850683322
              ],
              [
                152.98650150193583,
                -25.619561467057284
              ],
              [
                152.95826257237758,
                -25.611748973932254
              ],
              [
                152.94629967685594,
                -25.582940368231018
              ],
              [
                152.94825280477184,
                -25.552178657483907
              ],
              [
                152.96241295662756,
                -25.537692965946107
              ],
              [
                152.98585046316208,
                -25.52507905144725
              ],
              [
                152.99415123360293,
                -25.495700766519796
              ],
              [
                153.00074302907058,
                -25.43401456408505
              ],
              [
                153.0085555371092,
                -25.421644796022694
              ],
              [
                153.01807701350197,
                -25.413343992290223
              ],
              [
                153.02751711643594,
                -25.406833573235307
              ],
              [
                153.03484133927302,
                -25.399834886200065
              ],
              [
                153.0500594394447,
                -25.366387623539236
              ],
              [
                153.05836021746856,
                -25.355157145992433
              ],
              [
                153.0685327423269,
                -25.32903409668049
              ],
              [
                153.05616295633342,
                -25.27320728807293
              ],
              [
                153.06885826762192,
                -25.24846770200842
              ],
              [
                153.0622664748013,
                -25.23723724612109
              ],
              [
                153.05445397242514,
                -25.23349374923281
              ],
              [
                153.04542076762752,
                -25.232191661018618
              ],
              [
                153.02182050828284,
                -25.223402599917726
              ],
              [
                153.0159611319022,
                -25.223321215909294
              ],
              [
                153.0144149126429,
                -25.22161224567446
              ],
              [
                153.01441491289205,
                -25.21152110040512
              ],
              [
                153.02133222505773,
                -25.198174732348786
              ],
              [
                153.03834069210419,
                -25.183526303216155
              ],
              [
                153.1479598316448,
                -25.11419036195971
              ],
              [
                153.17872154940653,
                -25.087497652258556
              ],
              [
                153.20557701892685,
                -25.057305596784367
              ],
              [
                153.2260848320717,
                -25.02752044121106
              ],
              [
                153.2425236673579,
                -24.993259471630722
              ],
              [
                153.249196800139,
                -24.954847882781685
              ],
              [
                153.23959399167705,
                -24.913262763988826
              ],
              [
                153.22234138006874,
                -24.881524460657598
              ],
              [
                153.19410237856283,
                -24.84075276879788
              ],
              [
                153.16325936078476,
                -24.812432699569218
              ],
              [
                153.13721764956153,
                -24.817071238704578
              ],
              [
                153.1955672505539,
                -24.748711836593184
              ],
              [
                153.2050887674006,
                -24.745212586805785
              ],
              [
                153.2334090337644,
                -24.7214494278705
              ],
              [
                153.2724715496987,
                -24.69988372108659
              ],
              [
                153.28126058855983,
                -24.69353599189389
              ],
              [
                153.28614344417534,
                -24.73650487393122
              ],
              [
                153.28126059417633,
                -24.85857507171163
              ],
              [
                153.28492276034243,
                -24.876641648475946
              ],
              [
                153.30225671464189,
                -24.929457312710294
              ],
              [
                153.3118596143433,
                -24.94060650667842
              ],
              [
                153.32129966940772,
                -24.946384356406572
              ],
              [
                153.35889731272798,
                -24.976006711975824
              ],
              [
                153.36996507355488,
                -24.989027701166734
              ]
            ]
          ],
          [
            [
              [
                151.37232506386465,
                -23.820245042977483
              ],
              [
                151.38306725646015,
                -23.8401018290781
              ],
              [
                151.38835695842474,
                -23.864434474893027
              ],
              [
                151.38306724271652,
                -23.87957118505697
              ],
              [
                151.36264082264236,
                -23.871758727380968
              ],
              [
                151.35962972992758,
                -23.847832861986813
              ],
              [
                151.35206143483384,
                -23.83245221518743
              ],
              [
                151.32862387344488,
                -23.80291099829436
              ],
              [
                151.32260175761135,
                -23.77190520141529
              ],
              [
                151.3210555531888,
                -23.768731438063856
              ],
              [
                151.3263452397687,
                -23.757256741796088
              ],
              [
                151.33326258849914,
                -23.75017676539216
              ],
              [
                151.33952884980266,
                -23.75139741979537
              ],
              [
                151.34473715830265,
                -23.782403197924335
              ],
              [
                151.35181726005226,
                -23.796482048941527
              ],
              [
                151.37232506386465,
                -23.820245042977483
              ]
            ]
          ],
          [
            [
              [
                151.26986740853542,
                -23.666273777651497
              ],
              [
                151.28777098786776,
                -23.67913162893309
              ],
              [
                151.29615317023925,
                -23.707289252125122
              ],
              [
                151.2985132245803,
                -23.735446898096157
              ],
              [
                151.2976180629201,
                -23.748223658351137
              ],
              [
                151.29102622721953,
                -23.74993251434403
              ],
              [
                151.28679446784162,
                -23.754001562782882
              ],
              [
                151.28142336361367,
                -23.761895409979907
              ],
              [
                151.2773543768924,
                -23.766045876898094
              ],
              [
                151.2758894795879,
                -23.768975388814557
              ],
              [
                151.2736108937578,
                -23.772068035552067
              ],
              [
                151.26644944820552,
                -23.77613708663312
              ],
              [
                151.2633569570481,
                -23.775160382139095
              ],
              [
                151.22982832853594,
                -23.777276324884987
              ],
              [
                151.221853096995,
                -23.779473684849158
              ],
              [
                151.21387782824482,
                -23.77809019527349
              ],
              [
                151.2050887561749,
                -23.768731438063856
              ],
              [
                151.1941838129208,
                -23.75416439683413
              ],
              [
                151.1805119353693,
                -23.742852539453974
              ],
              [
                151.16895590335764,
                -23.72991294725727
              ],
              [
                151.1591903228987,
                -23.69361752211102
              ],
              [
                151.1473087611435,
                -23.67522542295178
              ],
              [
                151.10523522781006,
                -23.628025017409144
              ],
              [
                151.07886804837932,
                -23.608656552764486
              ],
              [
                151.0678817400465,
                -23.59807719165805
              ],
              [
                151.05420978744746,
                -23.578708442594554
              ],
              [
                151.02106651182606,
                -23.535602722879954
              ],
              [
                150.99787117321273,
                -23.506672828433718
              ],
              [
                150.97960737049314,
                -23.487385543497567
              ],
              [
                151.01607438476543,
                -23.47448149341952
              ],
              [
                151.02238120455365,
                -23.469327024832626
              ],
              [
                151.022370524056,
                -23.461605688068847
              ],
              [
                151.0181509097312,
                -23.453245640090344
              ],
              [
                151.0275171623464,
                -23.444512761206816
              ],
              [
                151.03687583141243,
                -23.4508602312544
              ],
              [
                151.04363038667208,
                -23.453545768995898
              ],
              [
                151.05225673063734,
                -23.451836926970245
              ],
              [
                151.06185956548129,
                -23.44890714032627
              ],
              [
                151.07129971149845,
                -23.447198298506283
              ],
              [
                151.07797282566474,
                -23.45077881491008
              ],
              [
                151.07911217286002,
                -23.45907967776446
              ],
              [
                151.07886800810277,
                -23.468356938119733
              ],
              [
                151.08155356860152,
                -23.474541879749115
              ],
              [
                151.09929444914877,
                -23.479912958740357
              ],
              [
                151.14185628137784,
                -23.487888162225143
              ],
              [
                151.1504012066029,
                -23.498711741187805
              ],
              [
                151.16065516616254,
                -23.503838874658275
              ],
              [
                151.1801864221765,
                -23.50725686388261
              ],
              [
                151.1914168712672,
                -23.51384859382419
              ],
              [
                151.17701253734356,
                -23.529066568645298
              ],
              [
                151.19507895509162,
                -23.533868040172557
              ],
              [
                151.21070399322846,
                -23.520684574404456
              ],
              [
                151.22494549748032,
                -23.50156011520431
              ],
              [
                151.23910567001033,
                -23.488864858886934
              ],
              [
                151.23878011860242,
                -23.516289886561317
              ],
              [
                151.22706137790894,
                -23.5614559340353
              ],
              [
                151.22559655163596,
                -23.5837541704778
              ],
              [
                151.22934008038598,
                -23.607517320000667
              ],
              [
                151.2378035632056,
                -23.634535352298183
              ],
              [
                151.25123135065567,
                -23.656996467421575
              ],
              [
                151.26986740853542,
                -23.666273777651497
              ]
            ]
          ],
          [
            [
              [
                149.72779383405455,
                -22.34050878791204
              ],
              [
                149.7361759904241,
                -22.339043927008326
              ],
              [
                149.74675541615346,
                -22.34685641869932
              ],
              [
                149.76628666946752,
                -22.36467869673678
              ],
              [
                149.75586997944572,
                -22.368747622821793
              ],
              [
                149.75375409205984,
                -22.376560117785562
              ],
              [
                149.75440513674184,
                -22.38689541457091
              ],
              [
                149.75196375812433,
                -22.398858404232325
              ],
              [
                149.73121178406114,
                -22.428155202588318
              ],
              [
                149.72478274787073,
                -22.439873955530352
              ],
              [
                149.7133895267036,
                -22.42929455699521
              ],
              [
                149.7102970559996,
                -22.42555098547519
              ],
              [
                149.71558676571584,
                -22.41521568286812
              ],
              [
                149.71810958286454,
                -22.404473609172154
              ],
              [
                149.71680747392543,
                -22.394300988757873
              ],
              [
                149.71029707186048,
                -22.38518645913428
              ],
              [
                149.71705163404133,
                -22.374200146373312
              ],
              [
                149.72250411210294,
                -22.350762664864558
              ],
              [
                149.72779383405455,
                -22.34050878791204
              ]
            ]
          ],
          [
            [
              [
                150.5366316883199,
                -22.275323106943347
              ],
              [
                150.54428146580665,
                -22.277439132149045
              ],
              [
                150.55250085378685,
                -22.282321897714695
              ],
              [
                150.55860435783418,
                -22.28899503119508
              ],
              [
                150.56080163071914,
                -22.295830994255514
              ],
              [
                150.5558374564647,
                -22.30632910843073
              ],
              [
                150.54656007624104,
                -22.31243249269826
              ],
              [
                150.53744549167283,
                -22.316338737005278
              ],
              [
                150.53345788610497,
                -22.319756794826876
              ],
              [
                150.53142337954043,
                -22.328301714764574
              ],
              [
                150.52637780521567,
                -22.335056266944974
              ],
              [
                150.51978602215013,
                -22.34050878791204
              ],
              [
                150.5129500734868,
                -22.34433361918403
              ],
              [
                150.49537196067382,
                -22.350844079418692
              ],
              [
                150.4822697275889,
                -22.344984635138562
              ],
              [
                150.47934005830845,
                -22.3319638665345
              ],
              [
                150.49187257467815,
                -22.316338737005278
              ],
              [
                150.47624757592664,
                -22.30494551250551
              ],
              [
                150.4713647890511,
                -22.3026669579436
              ],
              [
                150.4677840609714,
                -22.306247693926558
              ],
              [
                150.46607506609593,
                -22.30722421734897
              ],
              [
                150.46371502363976,
                -22.307793818465175
              ],
              [
                150.45777429431791,
                -22.310153937905035
              ],
              [
                150.46656335159776,
                -22.29371511874267
              ],
              [
                150.4825952683986,
                -22.274590827346298
              ],
              [
                150.4936629475519,
                -22.255059468532785
              ],
              [
                150.48845460435606,
                -22.237481309924014
              ],
              [
                150.4804793814586,
                -22.22958756542882
              ],
              [
                150.4758406927913,
                -22.22193776454619
              ],
              [
                150.4783634811381,
                -22.21624115912655
              ],
              [
                150.49187258078115,
                -22.21396245698857
              ],
              [
                150.50456792425385,
                -22.216729495367776
              ],
              [
                150.51140385922133,
                -22.224216466913145
              ],
              [
                150.51596114234223,
                -22.234144820459974
              ],
              [
                150.52263429794706,
                -22.24431726836597
              ],
              [
                150.52637781235129,
                -22.253106423051985
              ],
              [
                150.52759850507192,
                -22.263360287907812
              ],
              [
                150.52979574881377,
                -22.271742372439462
              ],
              [
                150.5366316883199,
                -22.275323106943347
              ]
            ]
          ],
          [
            [
              [
                149.9165145033698,
                -22.041924680166254
              ],
              [
                149.9103296270806,
                -22.07512787807552
              ],
              [
                149.90967858539372,
                -22.086602484530914
              ],
              [
                149.9128524160617,
                -22.10133231236674
              ],
              [
                149.9270125694677,
                -22.12102631278189
              ],
              [
                149.9300236160263,
                -22.134453967792663
              ],
              [
                149.92823327441445,
                -22.160088819919466
              ],
              [
                149.92156007728138,
                -22.19068770392811
              ],
              [
                149.90870200094028,
                -22.21640383773255
              ],
              [
                149.8885197148952,
                -22.226820526600317
              ],
              [
                149.87761476274463,
                -22.219984569682282
              ],
              [
                149.8774520132631,
                -22.212579012940544
              ],
              [
                149.88135828016198,
                -22.203790012989735
              ],
              [
                149.88233481366646,
                -22.192803576637232
              ],
              [
                149.87891686810173,
                -22.186211865751144
              ],
              [
                149.8740340528169,
                -22.18189870635595
              ],
              [
                149.86988367338878,
                -22.17555108923958
              ],
              [
                149.8680119352581,
                -22.162367520551847
              ],
              [
                149.8693953939803,
                -22.1422665891823
              ],
              [
                149.87403406107498,
                -22.118584934841543
              ],
              [
                149.88282310893223,
                -22.09693774298415
              ],
              [
                149.8960067018475,
                -22.08294034396902
              ],
              [
                149.88965903609133,
                -22.073174686602197
              ],
              [
                149.89356530417695,
                -22.061130482443406
              ],
              [
                149.90381920374045,
                -22.049574464942182
              ],
              [
                149.9165145033698,
                -22.041924680166254
              ]
            ]
          ],
          [
            [
              [
                150.29322351930998,
                -21.740899404259366
              ],
              [
                150.31771896514255,
                -21.734063480601858
              ],
              [
                150.32960044102992,
                -21.73447025026996
              ],
              [
                150.3410750813149,
                -21.740899404259366
              ],
              [
                150.36890710566703,
                -21.726739223417216
              ],
              [
                150.3588973324165,
                -21.74293385355633
              ],
              [
                150.35173587659773,
                -21.760674751439137
              ],
              [
                150.3427840387501,
                -21.771742403992604
              ],
              [
                150.32740317553493,
                -21.7688127002404
              ],
              [
                150.29322351583846,
                -21.747735328263442
              ],
              [
                150.29322351930998,
                -21.740899404259366
              ]
            ]
          ],
          [
            [
              [
                150.30005943872933,
                -21.67888761948652
              ],
              [
                150.2981063107042,
                -21.676690343142464
              ],
              [
                150.2976180459957,
                -21.675388320232553
              ],
              [
                150.2966414589667,
                -21.674086147123706
              ],
              [
                150.2932235060837,
                -21.672051698814855
              ],
              [
                150.29053795749707,
                -21.681084895863147
              ],
              [
                150.2861434163323,
                -21.684258689505864
              ],
              [
                150.28044681454023,
                -21.683282172272442
              ],
              [
                150.27271568872976,
                -21.67888761948652
              ],
              [
                150.26482182032024,
                -21.670668261963787
              ],
              [
                150.2574975895374,
                -21.66838957176023
              ],
              [
                150.2509871893034,
                -21.67107518166167
              ],
              [
                150.24610436073021,
                -21.67888761948652
              ],
              [
                150.24195398131877,
                -21.670668261963787
              ],
              [
                150.24195398984313,
                -21.663506835965805
              ],
              [
                150.24537193738118,
                -21.65715909941498
              ],
              [
                150.25163823315532,
                -21.65154393865631
              ],
              [
                150.24878991708658,
                -21.644219685615234
              ],
              [
                150.24756921970962,
                -21.6381161917456
              ],
              [
                150.24610437581185,
                -21.623630515157476
              ],
              [
                150.25163822981224,
                -21.623630515157476
              ],
              [
                150.26531010062394,
                -21.63844169739307
              ],
              [
                150.28842207457708,
                -21.648532823428837
              ],
              [
                150.30534915930227,
                -21.65976329514215
              ],
              [
                150.30005943872933,
                -21.67888761948652
              ]
            ]
          ],
          [
            [
              [
                115.46452883775125,
                -20.730157137642287
              ],
              [
                115.47046959676126,
                -20.746189058800137
              ],
              [
                115.46306400082939,
                -20.76384858021165
              ],
              [
                115.44027754239107,
                -20.79436615600448
              ],
              [
                115.43921959782732,
                -20.802341408152806
              ],
              [
                115.43995202204496,
                -20.811456003280878
              ],
              [
                115.43848717282187,
                -20.81902433607028
              ],
              [
                115.43043053830996,
                -20.82236095160818
              ],
              [
                115.42676842642513,
                -20.824883729150212
              ],
              [
                115.41537520099953,
                -20.836195596080877
              ],
              [
                115.41309655371624,
                -20.839450797641643
              ],
              [
                115.40805097089923,
                -20.85369228540548
              ],
              [
                115.39576256101817,
                -20.863702056020173
              ],
              [
                115.36524499079177,
                -20.876885688997007
              ],
              [
                115.35938561517634,
                -20.86451589391519
              ],
              [
                115.34750409631674,
                -20.854424709484743
              ],
              [
                115.3357039669916,
                -20.849704659865317
              ],
              [
                115.33041426597285,
                -20.853122688991913
              ],
              [
                115.32691490625423,
                -20.865899328207536
              ],
              [
                115.3181258524014,
                -20.872735311095525
              ],
              [
                115.30697676297413,
                -20.87053803893882
              ],
              [
                115.29639733598222,
                -20.856540642987724
              ],
              [
                115.30241946458491,
                -20.843194256874227
              ],
              [
                115.31055749345359,
                -20.80185315040547
              ],
              [
                115.32960045109296,
                -20.773370020300398
              ],
              [
                115.39942468074852,
                -20.69378023493472
              ],
              [
                115.42896568430716,
                -20.66912196930266
              ],
              [
                115.45118248080675,
                -20.66838954478915
              ],
              [
                115.4567163378841,
                -20.682224196287667
              ],
              [
                115.45704185911369,
                -20.71599698345695
              ],
              [
                115.46452883775125,
                -20.730157137642287
              ]
            ]
          ],
          [
            [
              [
                149.0940861369969,
                -20.418226832734998
              ],
              [
                149.0949813161506,
                -20.438734633589426
              ],
              [
                149.09839928590964,
                -20.453220313559687
              ],
              [
                149.1049910805339,
                -20.46550871626337
              ],
              [
                149.11508222957855,
                -20.47966888808558
              ],
              [
                149.09262129248603,
                -20.48609792472378
              ],
              [
                149.08179771938708,
                -20.500176680781312
              ],
              [
                149.07211347436754,
                -20.516208581707
              ],
              [
                149.0530705079093,
                -20.528090097735724
              ],
              [
                149.0486759748028,
                -20.5241838434087
              ],
              [
                149.0431421240409,
                -20.517510679070252
              ],
              [
                149.03931725570348,
                -20.509454040662565
              ],
              [
                149.03939863428823,
                -20.500746353127287
              ],
              [
                149.0451766304481,
                -20.494235940665142
              ],
              [
                149.06177819035312,
                -20.49439869346931
              ],
              [
                149.07056724939343,
                -20.48992276598005
              ],
              [
                149.08179772651883,
                -20.472263296680477
              ],
              [
                149.08594811171363,
                -20.455010669965105
              ],
              [
                149.08814538308673,
                -20.437595325998274
              ],
              [
                149.0940861369969,
                -20.418226832734998
              ]
            ]
          ],
          [
            [
              [
                149.06739342738686,
                -20.315199486361713
              ],
              [
                149.05909264349674,
                -20.30966562102542
              ],
              [
                149.05225670637924,
                -20.30348072456429
              ],
              [
                149.03939863378716,
                -20.28728606516453
              ],
              [
                149.02613366288335,
                -20.319268499311807
              ],
              [
                149.01889081776483,
                -20.32887133930863
              ],
              [
                149.00375410279005,
                -20.31161875110036
              ],
              [
                148.99105879327618,
                -20.31511810985663
              ],
              [
                148.98064212099385,
                -20.323825771127282
              ],
              [
                148.97120201567813,
                -20.32146573996298
              ],
              [
                148.9712020192633,
                -20.28101979103351
              ],
              [
                148.95346113205477,
                -20.29241301136184
              ],
              [
                148.94703209933172,
                -20.29412201215544
              ],
              [
                148.93995201920936,
                -20.293877863821766
              ],
              [
                148.93116295796796,
                -20.292168881800993
              ],
              [
                148.92701256578732,
                -20.28728606516453
              ],
              [
                148.93327884342597,
                -20.277601826600595
              ],
              [
                148.9640405617563,
                -20.25058359497073
              ],
              [
                148.96892337259558,
                -20.237725517411082
              ],
              [
                148.95004316483787,
                -20.23267994536265
              ],
              [
                148.95883222862895,
                -20.21152109840206
              ],
              [
                148.96314538077647,
                -20.186618754983545
              ],
              [
                148.96949303303577,
                -20.164483323276524
              ],
              [
                148.98487389475798,
                -20.151462500980106
              ],
              [
                148.98804772046432,
                -20.165297126962408
              ],
              [
                149.00212649758717,
                -20.190199475377216
              ],
              [
                149.00521894780186,
                -20.202243755080225
              ],
              [
                149.00407962363505,
                -20.22926197949449
              ],
              [
                149.0107527993055,
                -20.23691171427172
              ],
              [
                149.0295516282945,
                -20.239434500229322
              ],
              [
                149.02963301088482,
                -20.245049745401428
              ],
              [
                149.04623456878159,
                -20.274183843292725
              ],
              [
                149.06714928617194,
                -20.289239195598174
              ],
              [
                149.07341556259416,
                -20.299981384253712
              ],
              [
                149.06739342738686,
                -20.315199486361713
              ]
            ]
          ],
          [
            [
              [
                148.95753014452532,
                -20.143812760065757
              ],
              [
                148.95297285188488,
                -20.150485934547053
              ],
              [
                148.92335045788533,
                -20.17864349148129
              ],
              [
                148.92709394643626,
                -20.1578915357159
              ],
              [
                148.9251408217576,
                -20.151462500980106
              ],
              [
                148.9221297545807,
                -20.15276458328422
              ],
              [
                148.9158634772147,
                -20.157484633844543
              ],
              [
                148.91480553432456,
                -20.155857026342865
              ],
              [
                148.91488691450496,
                -20.153497001052386
              ],
              [
                148.91391035189935,
                -20.151543877604055
              ],
              [
                148.9090275407575,
                -20.151462500980106
              ],
              [
                148.90219160390907,
                -20.164971620509874
              ],
              [
                148.8943790998438,
                -20.16025155151708
              ],
              [
                148.888438346097,
                -20.154392181446898
              ],
              [
                148.88428795633848,
                -20.14690520339648
              ],
              [
                148.8818465501861,
                -20.137627863731975
              ],
              [
                148.88795006563197,
                -20.121840100551296
              ],
              [
                148.91586347682426,
                -20.089288018308157
              ],
              [
                148.91277103084528,
                -20.086602475327226
              ],
              [
                148.9085392597458,
                -20.081638281935994
              ],
              [
                148.90650475449993,
                -20.07537200496812
              ],
              [
                148.9090275401852,
                -20.068780206729016
              ],
              [
                148.92017662945892,
                -20.060804947806602
              ],
              [
                148.92611738404298,
                -20.06292083116916
              ],
              [
                148.93067467455379,
                -20.067966402242902
              ],
              [
                148.9370223321853,
                -20.068780206729016
              ],
              [
                148.94800865949327,
                -20.063734631005275
              ],
              [
                148.95443769637942,
                -20.05885182249332
              ],
              [
                148.95883222714514,
                -20.052015883571414
              ],
              [
                148.96371504036904,
                -20.041599218452593
              ],
              [
                148.9802352222894,
                -20.05689869713878
              ],
              [
                148.97120201848435,
                -20.076755464970446
              ],
              [
                148.95346113384704,
                -20.096856377397984
              ],
              [
                148.94385826857103,
                -20.113457939311868
              ],
              [
                148.94629967512975,
                -20.12029387851001
              ],
              [
                148.95606530020072,
                -20.134209894789198
              ],
              [
                148.95753014452532,
                -20.143812760065757
              ]
            ]
          ],
          [
            [
              [
                148.45045006298247,
                -19.96575285107342
              ],
              [
                148.47429449292008,
                -19.983086949416965
              ],
              [
                148.48096764402354,
                -20.00457122209234
              ],
              [
                148.47730553492443,
                -20.027113539701247
              ],
              [
                148.47022545737633,
                -20.04762135348594
              ],
              [
                148.46534264407967,
                -20.04338958131427
              ],
              [
                148.4609481128678,
                -20.04241301847752
              ],
              [
                148.45622806158187,
                -20.042575781298083
              ],
              [
                148.45045006636778,
                -20.041599218452593
              ],
              [
                148.45101972701485,
                -20.010349217058426
              ],
              [
                148.44939210496193,
                -19.99618898872132
              ],
              [
                148.44418377509425,
                -19.986260616092576
              ],
              [
                148.45045006298247,
                -19.96575285107342
              ]
            ]
          ],
          [
            [
              [
                146.86019940512665,
                -19.115980687109595
              ],
              [
                146.86394292955848,
                -19.105157258238375
              ],
              [
                146.868662974833,
                -19.102308924062797
              ],
              [
                146.87281338296194,
                -19.10735457030408
              ],
              [
                146.87452231507044,
                -19.119398627612092
              ],
              [
                146.87370850313133,
                -19.142998847510054
              ],
              [
                146.87134849020978,
                -19.153578327328
              ],
              [
                146.86703531609476,
                -19.16383214507149
              ],
              [
                146.85645589104269,
                -19.15129960089245
              ],
              [
                146.82007894389685,
                -19.175062644550735
              ],
              [
                146.79867594111147,
                -19.16383214507149
              ],
              [
                146.7937117560616,
                -19.150648579105916
              ],
              [
                146.78549241154292,
                -19.14072042128354
              ],
              [
                146.78028404076105,
                -19.132012590663454
              ],
              [
                146.7850040780031,
                -19.122816568010663
              ],
              [
                146.79835045469522,
                -19.117445561684157
              ],
              [
                146.8108830366801,
                -19.11842224486509
              ],
              [
                146.82243896595372,
                -19.116468878494747
              ],
              [
                146.83285568282858,
                -19.102308924062797
              ],
              [
                146.83773847825472,
                -19.107028909070895
              ],
              [
                146.84408611079647,
                -19.110284019233003
              ],
              [
                146.86019940512665,
                -19.115980687109595
              ]
            ]
          ],
          [
            [
              [
                146.31902106058388,
                -18.38298931721504
              ],
              [
                146.32593831878555,
                -18.391371235596587
              ],
              [
                146.3474226890553,
                -18.40439204915205
              ],
              [
                146.35303797030798,
                -18.41033299586371
              ],
              [
                146.35328206980134,
                -18.421644677906006
              ],
              [
                146.3470158394707,
                -18.426202157116634
              ],
              [
                146.3387150293732,
                -18.427992402207153
              ],
              [
                146.33326255296,
                -18.431410361265634
              ],
              [
                146.32032313510896,
                -18.464776391027062
              ],
              [
                146.31080159352652,
                -18.47869216999462
              ],
              [
                146.29167728562544,
                -18.492852495147545
              ],
              [
                146.27540123913795,
                -18.483168231683795
              ],
              [
                146.23951256306276,
                -18.474867433903004
              ],
              [
                146.22339931172522,
                -18.465508832104128
              ],
              [
                146.21461021919347,
                -18.441827069428985
              ],
              [
                146.2050887434526,
                -18.390313431514535
              ],
              [
                146.19922937575413,
                -18.37525812368908
              ],
              [
                146.17237390886305,
                -18.334730788485796
              ],
              [
                146.1626083025793,
                -18.32529076196063
              ],
              [
                146.1203719080608,
                -18.299248819541283
              ],
              [
                146.10824628747025,
                -18.289239180515843
              ],
              [
                146.0988875461548,
                -18.278090019721322
              ],
              [
                146.09302815722293,
                -18.26628983190361
              ],
              [
                146.09734132885353,
                -18.24521244343845
              ],
              [
                146.12183680616081,
                -18.245538106806958
              ],
              [
                146.17505940720397,
                -18.26628983190361
              ],
              [
                146.2174585653634,
                -18.2779274884985
              ],
              [
                146.2233992552109,
                -18.260837374533786
              ],
              [
                146.2189234055311,
                -18.22918073196689
              ],
              [
                146.22950280010136,
                -18.19801197742052
              ],
              [
                146.23536215962136,
                -18.22323977819066
              ],
              [
                146.24854580022608,
                -18.232598695512646
              ],
              [
                146.28825929084329,
                -18.23211020041957
              ],
              [
                146.30209395995004,
                -18.237237295829306
              ],
              [
                146.2976994447453,
                -18.250420954261507
              ],
              [
                146.28589931252003,
                -18.268243210986554
              ],
              [
                146.27808680237905,
                -18.28736751794505
              ],
              [
                146.27833095376673,
                -18.307387096014615
              ],
              [
                146.28419029328273,
                -18.322849189222545
              ],
              [
                146.30876714583857,
                -18.351983425343256
              ],
              [
                146.31641686286403,
                -18.35588958043808
              ],
              [
                146.3339950231199,
                -18.357598711027066
              ],
              [
                146.33936606442845,
                -18.36191164444973
              ],
              [
                146.3415633542346,
                -18.3731422148599
              ],
              [
                146.33790120264598,
                -18.38030349810625
              ],
              [
                146.32984461521593,
                -18.383558927167424
              ],
              [
                146.31902106058388,
                -18.38298931721504
              ]
            ]
          ],
          [
            [
              [
                139.56218509641104,
                -17.039239211112193
              ],
              [
                139.55404707279448,
                -17.05445729817629
              ],
              [
                139.55982505421738,
                -17.06617598634653
              ],
              [
                139.5703231163851,
                -17.074802357406423
              ],
              [
                139.57585696296766,
                -17.080824458653332
              ],
              [
                139.56934653392443,
                -17.100355653924776
              ],
              [
                139.55453536674216,
                -17.107110350998486
              ],
              [
                139.5206811967116,
                -17.10808689569035
              ],
              [
                139.514496277052,
                -17.11191165815179
              ],
              [
                139.51091555890937,
                -17.117445561500215
              ],
              [
                139.50538170382129,
                -17.121840087558358
              ],
              [
                139.4939070858376,
                -17.12175867128396
              ],
              [
                139.48536219021858,
                -17.117282879163717
              ],
              [
                139.48243248042843,
                -17.110609598577206
              ],
              [
                139.4817000500166,
                -17.10442466531268
              ],
              [
                139.48023522718245,
                -17.101250932571723
              ],
              [
                139.46265708757156,
                -17.100762585108722
              ],
              [
                139.44556724233806,
                -17.107517131959554
              ],
              [
                139.43392988216854,
                -17.121514572675153
              ],
              [
                139.43238365479496,
                -17.14283617236429
              ],
              [
                139.42505943579525,
                -17.14283617236429
              ],
              [
                139.4250594382981,
                -17.138116131727514
              ],
              [
                139.42351322622676,
                -17.135186497915353
              ],
              [
                139.42090905248224,
                -17.132745061277397
              ],
              [
                139.41822348781514,
                -17.129164247450863
              ],
              [
                139.4039819826105,
                -17.100681319043616
              ],
              [
                139.4096785718233,
                -17.088555550659574
              ],
              [
                139.42741948135316,
                -17.080336261374917
              ],
              [
                139.4492293786814,
                -17.06340918447262
              ],
              [
                139.47282961554671,
                -17.025567281971032
              ],
              [
                139.48951256883728,
                -17.01043060996176
              ],
              [
                139.4946395339297,
                -17.001071941235004
              ],
              [
                139.49390710871094,
                -16.985121405567316
              ],
              [
                139.5085555331136,
                -16.992771083375356
              ],
              [
                139.54883873424882,
                -17.02255623088009
              ],
              [
                139.56218509641104,
                -17.039239211112193
              ]
            ]
          ],
          [
            [
              [
                139.08920331778762,
                -16.827569254142873
              ],
              [
                139.1067000742918,
                -16.820245088359346
              ],
              [
                139.13331138130147,
                -16.81292077224214
              ],
              [
                139.15503989729945,
                -16.81292077224214
              ],
              [
                139.15805097378606,
                -16.827569254142873
              ],
              [
                139.1484481073761,
                -16.83464932101002
              ],
              [
                139.12191816110763,
                -16.836358313010304
              ],
              [
                139.11646570423014,
                -16.844659174121496
              ],
              [
                139.11394290263073,
                -16.85735441406102
              ],
              [
                139.10767663155085,
                -16.862481389774185
              ],
              [
                139.10108483793914,
                -16.859470337419534
              ],
              [
                139.0966902841599,
                -16.848077007822802
              ],
              [
                139.096039272803,
                -16.840264644792345
              ],
              [
                139.0966902877874,
                -16.83424238953953
              ],
              [
                139.09546960084555,
                -16.8300106927823
              ],
              [
                139.08920331778762,
                -16.827569254142873
              ]
            ]
          ],
          [
            [
              [
                139.7341414796319,
                -16.443291960903334
              ],
              [
                139.73951256477787,
                -16.45468514825462
              ],
              [
                139.74000085072979,
                -16.473321239514018
              ],
              [
                139.73731529088408,
                -16.492445528240278
              ],
              [
                139.73414148005423,
                -16.50546644175093
              ],
              [
                139.730967655469,
                -16.500095363774005
              ],
              [
                139.72242272234064,
                -16.48984140559806
              ],
              [
                139.71908612222623,
                -16.484307494740346
              ],
              [
                139.7086694794538,
                -16.495375316417228
              ],
              [
                139.70728601789114,
                -16.503838865127744
              ],
              [
                139.71021567546674,
                -16.511976748208994
              ],
              [
                139.71225019274837,
                -16.52190519077143
              ],
              [
                139.70769291726185,
                -16.52646255541265
              ],
              [
                139.69727622525315,
                -16.52450931330431
              ],
              [
                139.678233264345,
                -16.517836174188087
              ],
              [
                139.65650475781283,
                -16.519952098865726
              ],
              [
                139.63607831672277,
                -16.526625237962858
              ],
              [
                139.61996504311168,
                -16.537855741569015
              ],
              [
                139.61052494784317,
                -16.55315526140523
              ],
              [
                139.60043378360206,
                -16.54045986404462
              ],
              [
                139.58033287153705,
                -16.505303608981407
              ],
              [
                139.572764521991,
                -16.497979439041124
              ],
              [
                139.56983484785107,
                -16.49439877043103
              ],
              [
                139.56128991082855,
                -16.4874813818925
              ],
              [
                139.55250083864578,
                -16.483330948740562
              ],
              [
                139.54851320887735,
                -16.48772548083761
              ],
              [
                139.5456649021038,
                -16.49212001291046
              ],
              [
                139.52808680029054,
                -16.51230241374516
              ],
              [
                139.5190535761567,
                -16.513767157582553
              ],
              [
                139.49415122852653,
                -16.514743703544106
              ],
              [
                139.48707115535132,
                -16.517836174188087
              ],
              [
                139.4858504621825,
                -16.528415647301063
              ],
              [
                139.49439537608157,
                -16.53508878632092
              ],
              [
                139.50684653415095,
                -16.53866945473631
              ],
              [
                139.5178328915676,
                -16.539646150879385
              ],
              [
                139.52686609008762,
                -16.5453427438754
              ],
              [
                139.5246688302062,
                -16.556898762486625
              ],
              [
                139.51539146971675,
                -16.56585050831857
              ],
              [
                139.50407962903472,
                -16.563571901236184
              ],
              [
                139.49317466177064,
                -16.555596551065847
              ],
              [
                139.4829207628606,
                -16.55364345925215
              ],
              [
                139.47364342143962,
                -16.5573869603309
              ],
              [
                139.4665633566091,
                -16.566989886964226
              ],
              [
                139.4726668563721,
                -16.597914290041377
              ],
              [
                139.4728296284317,
                -16.60784273135607
              ],
              [
                139.4685978376479,
                -16.615410999027763
              ],
              [
                139.45622805686696,
                -16.632419509730482
              ],
              [
                139.45533287837515,
                -16.635837495087188
              ],
              [
                139.45875085954387,
                -16.641045889453547
              ],
              [
                139.45386801983122,
                -16.65292727135881
              ],
              [
                139.44467207717048,
                -16.66464612071918
              ],
              [
                139.43555747502214,
                -16.66985436461094
              ],
              [
                139.42505942805036,
                -16.665459833723087
              ],
              [
                139.40967856766432,
                -16.646172717191657
              ],
              [
                139.3977156998437,
                -16.642022435226863
              ],
              [
                139.38550865202694,
                -16.650974179847037
              ],
              [
                139.37183679136348,
                -16.688653282593094
              ],
              [
                139.3597111490793,
                -16.697198245098907
              ],
              [
                139.34131919319938,
                -16.700616079848587
              ],
              [
                139.31861411707857,
                -16.717543171626453
              ],
              [
                139.30209395654796,
                -16.72454197398068
              ],
              [
                139.23755945029663,
                -16.724867489189194
              ],
              [
                139.22632897913834,
                -16.72112398917176
              ],
              [
                139.22022545720606,
                -16.709893488957764
              ],
              [
                139.19011477646964,
                -16.671644773544923
              ],
              [
                139.17798914358082,
                -16.662367514001456
              ],
              [
                139.1842554073167,
                -16.683200789791343
              ],
              [
                139.18588301102156,
                -16.711602481401826
              ],
              [
                139.1819767715595,
                -16.7326800043458
              ],
              [
                139.17115317600212,
                -16.731377793315758
              ],
              [
                139.16325930087348,
                -16.745293830982366
              ],
              [
                139.15300541176407,
                -16.755954716389404
              ],
              [
                139.14486739838088,
                -16.75603613274013
              ],
              [
                139.14226320110998,
                -16.727308778138994
              ],
              [
                139.13672936511693,
                -16.70720795085081
              ],
              [
                139.13697351905523,
                -16.697198245098907
              ],
              [
                139.1412866475679,
                -16.69019944238286
              ],
              [
                139.1482853578135,
                -16.682224244088765
              ],
              [
                139.15503990421405,
                -16.67229580402594
              ],
              [
                139.15805098810327,
                -16.658949528800406
              ],
              [
                139.15951583696196,
                -16.635674812564055
              ],
              [
                139.16431726056197,
                -16.616306278685872
              ],
              [
                139.172618035588,
                -16.60035572975157
              ],
              [
                139.18482508184636,
                -16.58733496821399
              ],
              [
                139.20875083297963,
                -16.569105661280037
              ],
              [
                139.21615646138943,
                -16.556573247185344
              ],
              [
                139.21892337541158,
                -16.535821233324654
              ],
              [
                139.22185305240947,
                -16.52556727563434
              ],
              [
                139.22934004189133,
                -16.51824310589035
              ],
              [
                139.23943118016837,
                -16.513767157582553
              ],
              [
                139.25025476926004,
                -16.51230241374516
              ],
              [
                139.25831138073144,
                -16.506931185601477
              ],
              [
                139.27849367282636,
                -16.480238477959425
              ],
              [
                139.28785241539543,
                -16.470635700422005
              ],
              [
                139.3082788492846,
                -16.461195605337362
              ],
              [
                139.32943768419509,
                -16.457614786351318
              ],
              [
                139.37305748391333,
                -16.4576962027409
              ],
              [
                139.4875594516394,
                -16.4335263501696
              ],
              [
                139.54607180569786,
                -16.40227627496118
              ],
              [
                139.58269290751724,
                -16.395603134888677
              ],
              [
                139.60377038759827,
                -16.39837009059673
              ],
              [
                139.6132918768086,
                -16.40585709416324
              ],
              [
                139.61980229498272,
                -16.416680667654543
              ],
              [
                139.6305444751717,
                -16.429782848502093
              ],
              [
                139.64405357748547,
                -16.437758049740818
              ],
              [
                139.66041100096746,
                -16.441827066724887
              ],
              [
                139.6993921306301,
                -16.443291960903334
              ],
              [
                139.69727624590962,
                -16.44768649320946
              ],
              [
                139.6938582668403,
                -16.459405195846223
              ],
              [
                139.69190514188747,
                -16.46379972807066
              ],
              [
                139.71013430694535,
                -16.468845290950927
              ],
              [
                139.71794680690314,
                -16.4576962027409
              ],
              [
                139.72315513930388,
                -16.444512605907054
              ],
              [
                139.7341414796319,
                -16.443291960903334
              ]
            ]
          ],
          [
            [
              [
                136.67042076870868,
                -15.663181246523065
              ],
              [
                136.67595462959858,
                -15.678969041401826
              ],
              [
                136.6901147747961,
                -15.686944242675755
              ],
              [
                136.7047632138878,
                -15.69304776826557
              ],
              [
                136.71192467408216,
                -15.703545826363003
              ],
              [
                136.7076929098128,
                -15.71965913728339
              ],
              [
                136.69548587756495,
                -15.739922807000356
              ],
              [
                136.66358483469304,
                -15.778578396533707
              ],
              [
                136.65674889895737,
                -15.771172808927878
              ],
              [
                136.64291426326315,
                -15.762383743453073
              ],
              [
                136.62973066122197,
                -15.749118728967725
              ],
              [
                136.6196395179956,
                -15.732598560933393
              ],
              [
                136.61573327030146,
                -15.71404388457332
              ],
              [
                136.6218367834641,
                -15.692559495229801
              ],
              [
                136.63656660482943,
                -15.682305611322924
              ],
              [
                136.65455163309747,
                -15.675225539750437
              ],
              [
                136.67042076870868,
                -15.663181246523065
              ]
            ]
          ],
          [
            [
              [
                136.8006290980009,
                -15.64202237371899
              ],
              [
                136.8157658251352,
                -15.652927362951747
              ],
              [
                136.8302514957308,
                -15.668226809516813
              ],
              [
                136.83497154517457,
                -15.682386952607626
              ],
              [
                136.8212996749969,
                -15.689873955983987
              ],
              [
                136.8118595653318,
                -15.687107000353361
              ],
              [
                136.80307050856803,
                -15.672133068814027
              ],
              [
                136.7937931589219,
                -15.669366113237102
              ],
              [
                136.7800399068756,
                -15.672946857189054
              ],
              [
                136.77857506991134,
                -15.67978282978301
              ],
              [
                136.78858483423443,
                -15.702569280281072
              ],
              [
                136.7917586656818,
                -15.705987266679472
              ],
              [
                136.79420007309787,
                -15.710056283815456
              ],
              [
                136.79379316366183,
                -15.717054939250882
              ],
              [
                136.79078209327403,
                -15.722263260215154
              ],
              [
                136.7853296222788,
                -15.725844004364426
              ],
              [
                136.77344810858293,
                -15.731377840742558
              ],
              [
                136.75245201896536,
                -15.745782158825032
              ],
              [
                136.7414656861013,
                -15.749444244342783
              ],
              [
                136.73178144300783,
                -15.744398680932495
              ],
              [
                136.73414147320244,
                -15.720798441065229
              ],
              [
                136.7408960299081,
                -15.698825778535399
              ],
              [
                136.74293053706552,
                -15.67587657045263
              ],
              [
                136.73178144897167,
                -15.648858346070195
              ],
              [
                136.74805748469504,
                -15.64625414823759
              ],
              [
                136.78353926243224,
                -15.648695588399612
              ],
              [
                136.8006290980009,
                -15.64202237371899
              ]
            ]
          ],
          [
            [
              [
                137.07789147618595,
                -15.751234654014743
              ],
              [
                137.07950920065826,
                -15.758743664355588
              ],
              [
                137.08728490234975,
                -15.7627791838014
              ],
              [
                137.09441165460598,
                -15.76604582902389
              ],
              [
                137.10637861031185,
                -15.774224346638855
              ],
              [
                137.10018240837235,
                -15.803421063865054
              ],
              [
                137.09040339003445,
                -15.821780988172105
              ],
              [
                137.07289448332384,
                -15.846961038628574
              ],
              [
                137.04390858845247,
                -15.834202397275256
              ],
              [
                137.04216556755588,
                -15.817803676763207
              ],
              [
                137.0385848315484,
                -15.806410412740847
              ],
              [
                137.0333764930969,
                -15.796563384457214
              ],
              [
                137.0232039740017,
                -15.792250268023054
              ],
              [
                137.00749758989625,
                -15.791192305463122
              ],
              [
                137.00033613833907,
                -15.78704194673943
              ],
              [
                136.98585046434238,
                -15.750258107888246
              ],
              [
                136.98414147505935,
                -15.742608346378926
              ],
              [
                136.98511803666477,
                -15.720635683382014
              ],
              [
                136.98161868659452,
                -15.712009375995105
              ],
              [
                136.97331790106912,
                -15.711114171191936
              ],
              [
                136.96412194723868,
                -15.71257906543524
              ],
              [
                136.95777428940968,
                -15.710870072223166
              ],
              [
                136.9515080134095,
                -15.710870072223166
              ],
              [
                136.94817916812116,
                -15.729423546808018
              ],
              [
                136.9453518637316,
                -15.7287546405144
              ],
              [
                136.93970020868798,
                -15.7280956483949
              ],
              [
                136.93472486362776,
                -15.721324493124975
              ],
              [
                136.93832441876796,
                -15.699883741007117
              ],
              [
                136.9383244085928,
                -15.682875225638064
              ],
              [
                136.9430444741615,
                -15.667657195210936
              ],
              [
                136.9515080039353,
                -15.655694243369304
              ],
              [
                136.96396927121307,
                -15.640428970881041
              ],
              [
                136.97527102381645,
                -15.65601975871314
              ],
              [
                136.9831649058935,
                -15.664320550236825
              ],
              [
                136.98876590487572,
                -15.660716598142187
              ],
              [
                136.981575244733,
                -15.63425799924047
              ],
              [
                136.99213756030122,
                -15.630826644006717
              ],
              [
                136.99981295547687,
                -15.61517817419683
              ],
              [
                136.99475584356813,
                -15.592776125554897
              ],
              [
                137.0047306667285,
                -15.593682558784822
              ],
              [
                137.01596113684656,
                -15.593357043466428
              ],
              [
                137.02369225543964,
                -15.602634380310771
              ],
              [
                137.02738144181328,
                -15.627982478190296
              ],
              [
                137.0471761969539,
                -15.638768872702496
              ],
              [
                137.05769806067457,
                -15.629219759417985
              ],
              [
                137.06544705460342,
                -15.628508642856993
              ],
              [
                137.0669542121648,
                -15.64683397713164
              ],
              [
                137.0831927693015,
                -15.65219626780993
              ],
              [
                137.08196633345005,
                -15.686817987181554
              ],
              [
                137.08146585940955,
                -15.726175303000456
              ],
              [
                137.08224450567437,
                -15.741771800411145
              ],
              [
                137.07789147618595,
                -15.751234654014743
              ]
            ]
          ],
          [
            [
              [
                136.61573326871272,
                -15.538995048529204
              ],
              [
                136.60230553353682,
                -15.563653245523914
              ],
              [
                136.60035241116734,
                -15.611586201942291
              ],
              [
                136.5879012420402,
                -15.635186476531393
              ],
              [
                136.57667077170208,
                -15.631117459736682
              ],
              [
                136.55836021552452,
                -15.633884340081874
              ],
              [
                136.54688561233712,
                -15.62769947362774
              ],
              [
                136.5410262420388,
                -15.635186476531393
              ],
              [
                136.53492272829803,
                -15.638929978009008
              ],
              [
                136.51954185900917,
                -15.64202237371899
              ],
              [
                136.51417077261073,
                -15.639743766352623
              ],
              [
                136.50928795566497,
                -15.63681405321202
              ],
              [
                136.49854576833735,
                -15.62769947362774
              ],
              [
                136.51026451788758,
                -15.621189054337336
              ],
              [
                136.51221764627985,
                -15.609063420615131
              ],
              [
                136.5071720713708,
                -15.596286718890756
              ],
              [
                136.49854576921538,
                -15.587497655098769
              ],
              [
                136.51563561292346,
                -15.574314059608628
              ],
              [
                136.52149498737023,
                -15.567803640781085
              ],
              [
                136.52637779751487,
                -15.559502850291398
              ],
              [
                136.52662193871615,
                -15.548435142311293
              ],
              [
                136.52271568825458,
                -15.53972745793914
              ],
              [
                136.52491295771995,
                -15.53427500168821
              ],
              [
                136.54346764434118,
                -15.532159114747646
              ],
              [
                136.56511477871857,
                -15.526055590431938
              ],
              [
                136.58521569265935,
                -15.516371360509808
              ],
              [
                136.60279381765957,
                -15.516371360509808
              ],
              [
                136.61573326871272,
                -15.538995048529204
              ]
            ]
          ],
          [
            [
              [
                136.89568118621597,
                -15.587497655098769
              ],
              [
                136.88314863754348,
                -15.590915641029335
              ],
              [
                136.87387128656107,
                -15.597426022510195
              ],
              [
                136.8703719403962,
                -15.607679942931112
              ],
              [
                136.87525475176767,
                -15.621514569667536
              ],
              [
                136.8667098288877,
                -15.623955972201992
              ],
              [
                136.86133873532276,
                -15.626071859411732
              ],
              [
                136.84848066904786,
                -15.635186476531393
              ],
              [
                136.84791100894054,
                -15.6304664290686
              ],
              [
                136.8464461595655,
                -15.62761809479454
              ],
              [
                136.84424889401623,
                -15.62525807108182
              ],
              [
                136.8416447247682,
                -15.621514569667536
              ],
              [
                136.84791100715432,
                -15.619886993017863
              ],
              [
                136.84815514156145,
                -15.617120037613768
              ],
              [
                136.84164472527968,
                -15.608005458255676
              ],
              [
                136.83725019386821,
                -15.599297773156765
              ],
              [
                136.84009850168678,
                -15.594903241230055
              ],
              [
                136.8453882178495,
                -15.591729429322926
              ],
              [
                136.84848066521585,
                -15.587497655098769
              ],
              [
                136.84986412747085,
                -15.583591396212954
              ],
              [
                136.85482832448335,
                -15.57545340074757
              ],
              [
                136.85596764354085,
                -15.570000906659297
              ],
              [
                136.8535262380845,
                -15.56536223843044
              ],
              [
                136.84359785200343,
                -15.556573175017245
              ],
              [
                136.84164473041986,
                -15.553317984455461
              ],
              [
                136.8474227249105,
                -15.53582123687507
              ],
              [
                136.85743249155513,
                -15.520196240190058
              ],
              [
                136.869883662169,
                -15.507419540108044
              ],
              [
                136.88331139048915,
                -15.49814216700787
              ],
              [
                136.87468508904726,
                -15.522149331895653
              ],
              [
                136.87769615736084,
                -15.544121989523063
              ],
              [
                136.89568118621597,
                -15.587497655098769
              ]
            ]
          ],
          [
            [
              [
                124.41797936297466,
                -15.254082940853838
              ],
              [
                124.42286217637994,
                -15.246189067939637
              ],
              [
                124.43384850435619,
                -15.246514583049196
              ],
              [
                124.44548587256709,
                -15.25318775551051
              ],
              [
                124.45199629013658,
                -15.264743748784344
              ],
              [
                124.44727623673154,
                -15.274834886719699
              ],
              [
                124.43653405064309,
                -15.283868100687716
              ],
              [
                124.43181399956825,
                -15.292168886988179
              ],
              [
                124.44459069006645,
                -15.299411711652928
              ],
              [
                124.43165123843345,
                -15.308689062480454
              ],
              [
                124.4207462906715,
                -15.306410418844415
              ],
              [
                124.4099227232881,
                -15.30087656737871
              ],
              [
                124.39682050806681,
                -15.299411711652928
              ],
              [
                124.39307701761383,
                -15.302829677059044
              ],
              [
                124.38990318981482,
                -15.30917733521389
              ],
              [
                124.38510176148712,
                -15.315525012232976
              ],
              [
                124.3764754545784,
                -15.31926847414448
              ],
              [
                124.37281334396252,
                -15.317315345617756
              ],
              [
                124.34213301026857,
                -15.306247661267518
              ],
              [
                124.3361922544759,
                -15.300062760727911
              ],
              [
                124.33472741050859,
                -15.296807552916047
              ],
              [
                124.33472740892852,
                -15.291924731853689
              ],
              [
                124.38412519503822,
                -15.281182544480119
              ],
              [
                124.40796959762028,
                -15.272067970561537
              ],
              [
                124.41797936297466,
                -15.254082940853838
              ]
            ]
          ],
          [
            [
              [
                124.57569420893827,
                -15.332940374058978
              ],
              [
                124.60173587479376,
                -15.343845320223462
              ],
              [
                124.62794030114523,
                -15.38738372850225
              ],
              [
                124.65015709442926,
                -15.395114827414064
              ],
              [
                124.63542728243996,
                -15.404392198834714
              ],
              [
                124.54916425722789,
                -15.436293216970537
              ],
              [
                124.53126061203994,
                -15.440362232566764
              ],
              [
                124.52035566424622,
                -15.435967701732688
              ],
              [
                124.51498456974058,
                -15.423028245862739
              ],
              [
                124.51775149991035,
                -15.413262638834286
              ],
              [
                124.52523847630872,
                -15.409763275078541
              ],
              [
                124.5346785837913,
                -15.41545990415562
              ],
              [
                124.55437259381469,
                -15.389336857308393
              ],
              [
                124.56706790428758,
                -15.379327076949826
              ],
              [
                124.58253014628998,
                -15.373956001021446
              ],
              [
                124.57032311609863,
                -15.373711864621846
              ],
              [
                124.53777103133663,
                -15.36777109960706
              ],
              [
                124.52849368799228,
                -15.369724228337772
              ],
              [
                124.51710045853746,
                -15.378594667743611
              ],
              [
                124.50668378935418,
                -15.38144296332738
              ],
              [
                124.51417077143822,
                -15.36093516788659
              ],
              [
                124.49773196481738,
                -15.377618084583295
              ],
              [
                124.48568769381754,
                -15.377618084583295
              ],
              [
                124.47429446401232,
                -15.369235917989123
              ],
              [
                124.45883222943702,
                -15.36093516788659
              ],
              [
                124.47055097663011,
                -15.35100676689067
              ],
              [
                124.47299238124931,
                -15.340996987302207
              ],
              [
                124.47193443840166,
                -15.33228930616114
              ],
              [
                124.47266686612043,
                -15.326104442829012
              ],
              [
                124.4797469426608,
                -15.317966413494855
              ],
              [
                124.48707116145161,
                -15.313734641301432
              ],
              [
                124.4956160834681,
                -15.315850527393334
              ],
              [
                124.50668379312124,
                -15.326104442829012
              ],
              [
                124.50245201655756,
                -15.317152588037029
              ],
              [
                124.50171959743363,
                -15.308689062480454
              ],
              [
                124.50538170645457,
                -15.300388275877328
              ],
              [
                124.51417076792706,
                -15.291924731853689
              ],
              [
                124.4931746739272,
                -15.291924731853689
              ],
              [
                124.5044051453012,
                -15.279392192460902
              ],
              [
                124.55201256710973,
                -15.249444275376733
              ],
              [
                124.56869550982357,
                -15.244235939733972
              ],
              [
                124.56324303409106,
                -15.25652434178018
              ],
              [
                124.54957115846442,
                -15.297458583210439
              ],
              [
                124.55144290627072,
                -15.306247661267518
              ],
              [
                124.56128990943816,
                -15.306817312786853
              ],
              [
                124.57447350362932,
                -15.30999114188086
              ],
              [
                124.58220462466215,
                -15.317966413494855
              ],
              [
                124.57569420893827,
                -15.332940374058978
              ]
            ]
          ],
          [
            [
              [
                124.92823326587262,
                -14.973565344647383
              ],
              [
                124.9216414832636,
                -14.98398209503793
              ],
              [
                124.9260360082321,
                -14.991387652795144
              ],
              [
                124.93384849818287,
                -14.996026265934224
              ],
              [
                124.93816167525944,
                -14.997735402618462
              ],
              [
                124.93978925891058,
                -15.013929945477036
              ],
              [
                124.93628990992755,
                -15.026055596576635
              ],
              [
                124.9270125661232,
                -15.029229425719048
              ],
              [
                124.91146894593815,
                -15.018243096638209
              ],
              [
                124.90805097709544,
                -15.012627863557924
              ],
              [
                124.9001571180095,
                -14.995700902070041
              ],
              [
                124.8971460548895,
                -14.990980872863657
              ],
              [
                124.89063560349501,
                -14.98984134828732
              ],
              [
                124.87468510002195,
                -14.992120097015691
              ],
              [
                124.86988368488407,
                -14.990980872863657
              ],
              [
                124.8637801188397,
                -14.972588652266236
              ],
              [
                124.87142989604125,
                -14.956719729798591
              ],
              [
                124.88697347882064,
                -14.952813260919731
              ],
              [
                124.90398198167722,
                -14.970391620168805
              ],
              [
                124.90691163256697,
                -14.961032678189287
              ],
              [
                124.9113061691487,
                -14.95224364891141
              ],
              [
                124.91716554756081,
                -14.944105647921084
              ],
              [
                124.92457117432834,
                -14.936293311364356
              ],
              [
                124.92847739655957,
                -14.944105647921084
              ],
              [
                124.93189539184553,
                -14.954685229504602
              ],
              [
                124.93262780019259,
                -14.965427343130319
              ],
              [
                124.92823326587262,
                -14.973565344647383
              ]
            ]
          ],
          [
            [
              [
                135.76675385689924,
                -14.86820966525452
              ],
              [
                135.76450794802335,
                -14.890059508411163
              ],
              [
                135.7626788030795,
                -14.900901362117883
              ],
              [
                135.74657765651696,
                -14.897362017185724
              ],
              [
                135.72700816290683,
                -14.895597001371145
              ],
              [
                135.70520122656376,
                -14.91311286851365
              ],
              [
                135.6925526931337,
                -14.908794212610033
              ],
              [
                135.68724562628802,
                -14.90289199956074
              ],
              [
                135.6984738867496,
                -14.895193526267938
              ],
              [
                135.7039494310847,
                -14.887872090563024
              ],
              [
                135.71519354390495,
                -14.880022201797761
              ],
              [
                135.7207006514081,
                -14.867019068306035
              ],
              [
                135.71947861583965,
                -14.860126945099337
              ],
              [
                135.71050714143277,
                -14.858752185698778
              ],
              [
                135.70806049494877,
                -14.853040745425623
              ],
              [
                135.7151978540346,
                -14.850872855649607
              ],
              [
                135.7200882793346,
                -14.841026322092334
              ],
              [
                135.7278286453441,
                -14.834526859030507
              ],
              [
                135.7492227220553,
                -14.838466373628304
              ],
              [
                135.7606347670822,
                -14.849888953351465
              ],
              [
                135.76675385689924,
                -14.86820966525452
              ]
            ]
          ],
          [
            [
              [
                125.19507896251412,
                -14.470147335866676
              ],
              [
                125.20639081131534,
                -14.473565303672494
              ],
              [
                125.20875082654975,
                -14.481621877817432
              ],
              [
                125.2005314314864,
                -14.510430508384971
              ],
              [
                125.18189535804225,
                -14.534274870297942
              ],
              [
                125.17774499395352,
                -14.542168914251254
              ],
              [
                125.18140708288911,
                -14.552829599162637
              ],
              [
                125.19922936159072,
                -14.578301682447938
              ],
              [
                125.20492595335334,
                -14.593031364708018
              ],
              [
                125.19288169152304,
                -14.595879722228714
              ],
              [
                125.1696069647018,
                -14.611097901091986
              ],
              [
                125.16529383972708,
                -14.610772537592867
              ],
              [
                125.1613875755767,
                -14.607842763974093
              ],
              [
                125.15357505197713,
                -14.610935069128404
              ],
              [
                125.14698325741924,
                -14.61711997994433
              ],
              [
                125.14763431137797,
                -14.624118750284788
              ],
              [
                125.15162196288372,
                -14.631931380197447
              ],
              [
                125.14991295532681,
                -14.638441654897656
              ],
              [
                125.14454186626452,
                -14.643975538699678
              ],
              [
                125.13746180623235,
                -14.647637756094499
              ],
              [
                125.12712648426893,
                -14.628024915005918
              ],
              [
                125.12061605982407,
                -14.618340618837937
              ],
              [
                125.11345464674268,
                -14.614190506702116
              ],
              [
                125.10377036983031,
                -14.616468952507578
              ],
              [
                125.09644614490755,
                -14.619805505686921
              ],
              [
                125.09156334250306,
                -14.618584866788355
              ],
              [
                125.0896102456927,
                -14.607354568515934
              ],
              [
                125.0947371889544,
                -14.57919695774015
              ],
              [
                125.09644616578338,
                -14.549004851216536
              ],
              [
                125.10222417858063,
                -14.538995193713243
              ],
              [
                125.11524499395054,
                -14.542168914251254
              ],
              [
                125.12916098273674,
                -14.55136471258302
              ],
              [
                125.13746177316006,
                -14.559014508992059
              ],
              [
                125.1355086506511,
                -14.54127363904938
              ],
              [
                125.13892661102315,
                -14.509698065178398
              ],
              [
                125.13054445596535,
                -14.511162951593008
              ],
              [
                125.11557050082,
                -14.496840051959818
              ],
              [
                125.12281334642533,
                -14.481215098479563
              ],
              [
                125.14087976214344,
                -14.466973615941887
              ],
              [
                125.15788820819462,
                -14.456475464953416
              ],
              [
                125.15284265692807,
                -14.443780285445804
              ],
              [
                125.16065512934071,
                -14.437920740871906
              ],
              [
                125.17188559466555,
                -14.440606265314425
              ],
              [
                125.17774501095018,
                -14.4528135498893
              ],
              [
                125.17847743371713,
                -14.461032955488053
              ],
              [
                125.18140711342762,
                -14.466404004720053
              ],
              [
                125.18677817220302,
                -14.469333476788389
              ],
              [
                125.19507896251412,
                -14.470147335866676
              ]
            ]
          ],
          [
            [
              [
                136.80746503789513,
                -13.818536053462521
              ],
              [
                136.80811607094378,
                -13.812920765111842
              ],
              [
                136.81031334821742,
                -13.80828216625779
              ],
              [
                136.8139754796751,
                -13.804457425229574
              ],
              [
                136.81812584427755,
                -13.801364825759517
              ],
              [
                136.81169680354904,
                -13.808851776580902
              ],
              [
                136.80909266867616,
                -13.813409260045649
              ],
              [
                136.80746503789513,
                -13.818536053462521
              ]
            ]
          ],
          [
            [
              [
                136.28687583787013,
                -13.705824421832466
              ],
              [
                136.288259299818,
                -13.718845242515563
              ],
              [
                136.29004967840845,
                -13.724541945558325
              ],
              [
                136.28858483172897,
                -13.728610933365143
              ],
              [
                136.2800399342443,
                -13.736504962082135
              ],
              [
                136.26872807563896,
                -13.740492534180568
              ],
              [
                136.25798586073105,
                -13.739434429081978
              ],
              [
                136.24952232713866,
                -13.742282780716993
              ],
              [
                136.24512780895355,
                -13.757582343855876
              ],
              [
                136.26042727456363,
                -13.758070538304935
              ],
              [
                136.26758874878064,
                -13.7665341777808
              ],
              [
                136.27222742166515,
                -13.778903974012463
              ],
              [
                136.28003990800684,
                -13.791761965052169
              ],
              [
                136.2614038202758,
                -13.793552211782176
              ],
              [
                136.25416099504224,
                -13.806084840365946
              ],
              [
                136.2511499574737,
                -13.823663147363277
              ],
              [
                136.24512777723032,
                -13.83953202308473
              ],
              [
                136.2360945874457,
                -13.847263222006427
              ],
              [
                136.22266688649557,
                -13.85320417409102
              ],
              [
                136.20850672608182,
                -13.855889694757662
              ],
              [
                136.19743902149116,
                -13.85320417409102
              ],
              [
                136.20484457208383,
                -13.846367948323447
              ],
              [
                136.2055769995878,
                -13.840264465100288
              ],
              [
                136.20557704409933,
                -13.835381918921772
              ],
              [
                136.20679770901683,
                -13.83074301941612
              ],
              [
                136.21111086024288,
                -13.825941588735198
              ],
              [
                136.20232179999272,
                -13.812920765111842
              ],
              [
                136.18628990093114,
                -13.773125854505466
              ],
              [
                136.1770125812345,
                -13.763848657628339
              ],
              [
                136.15349369910115,
                -13.7706845817604
              ],
              [
                136.15113367395233,
                -13.794040706695792
              ],
              [
                136.1565047474697,
                -13.821221573927682
              ],
              [
                136.15650473124506,
                -13.83953202308473
              ],
              [
                136.12305749834204,
                -13.824883783872192
              ],
              [
                136.11670984365995,
                -13.816664390813896
              ],
              [
                136.11475668933505,
                -13.723565256301766
              ],
              [
                136.15162193532748,
                -13.74089931280229
              ],
              [
                136.16488691591707,
                -13.74236419652708
              ],
              [
                136.17017663649932,
                -13.726657855264866
              ],
              [
                136.17335044275166,
                -13.707126473842278
              ],
              [
                136.18238364099275,
                -13.686455872850413
              ],
              [
                136.19532311779346,
                -13.669610313082174
              ],
              [
                136.2111108795379,
                -13.661390922692325
              ],
              [
                136.2202254466198,
                -13.662530142990354
              ],
              [
                136.23422287558745,
                -13.666436599111499
              ],
              [
                136.2470809075705,
                -13.6720515853155
              ],
              [
                136.25269616042524,
                -13.678480729576531
              ],
              [
                136.25798586456708,
                -13.69003666595692
              ],
              [
                136.26978601677226,
                -13.697198252248814
              ],
              [
                136.281504748577,
                -13.701755434217473
              ],
              [
                136.28687583787013,
                -13.705824421832466
              ]
            ]
          ],
          [
            [
              [
                136.95150802424422,
                -14.181573262694638
              ],
              [
                136.94752035899467,
                -14.183851705936739
              ],
              [
                136.9431258720631,
                -14.18238712117722
              ],
              [
                136.9396265230625,
                -14.18238712117722
              ],
              [
                136.9372664834841,
                -14.189060220025436
              ],
              [
                136.93775473675467,
                -14.196221513917335
              ],
              [
                136.94288169164875,
                -14.207207852892079
              ],
              [
                136.94410241751885,
                -14.212985978130412
              ],
              [
                136.94776450980032,
                -14.215508669240528
              ],
              [
                136.95460046025616,
                -14.223890901657704
              ],
              [
                136.95883222129305,
                -14.232679913325857
              ],
              [
                136.9546004482355,
                -14.236748905837338
              ],
              [
                136.94125412482796,
                -14.241957420602665
              ],
              [
                136.93799889517774,
                -14.25400156673001
              ],
              [
                136.94214929033194,
                -14.26775484643219
              ],
              [
                136.95150799424275,
                -14.277764496855188
              ],
              [
                136.93946373883227,
                -14.273858335747269
              ],
              [
                136.9329533176789,
                -14.276543859058313
              ],
              [
                136.9319767485385,
                -14.283298375370732
              ],
              [
                136.93726645540087,
                -14.291436361462106
              ],
              [
                136.9245711859976,
                -14.282403401201694
              ],
              [
                136.91358482816932,
                -14.279961825155588
              ],
              [
                136.9057723137482,
                -14.285251455966167
              ],
              [
                136.9030867649451,
                -14.29892332083048
              ],
              [
                136.86784914487518,
                -14.27988040924487
              ],
              [
                136.85157308716745,
                -14.275567168566871
              ],
              [
                136.83545981375752,
                -14.285251455966167
              ],
              [
                136.8244735235259,
                -14.274102583475786
              ],
              [
                136.80494226561177,
                -14.267836262340428
              ],
              [
                136.76286867680875,
                -14.26482507545717
              ],
              [
                136.74561607998237,
                -14.25807055945675
              ],
              [
                136.73308353576581,
                -14.256117478994112
              ],
              [
                136.72193445365363,
                -14.261000330382446
              ],
              [
                136.68051189677817,
                -14.285251455966167
              ],
              [
                136.639414924857,
                -14.280206072887845
              ],
              [
                136.46078535889657,
                -14.216403943688494
              ],
              [
                136.45533289255397,
                -14.213067394027606
              ],
              [
                136.43775474771664,
                -14.198418841774213
              ],
              [
                136.42676843783883,
                -14.195245124047622
              ],
              [
                136.4160262332674,
                -14.19638434570507
              ],
              [
                136.38070723287157,
                -14.206801073839761
              ],
              [
                136.35718836972939,
                -14.22551861879314
              ],
              [
                136.3413192117298,
                -14.230075806208397
              ],
              [
                136.3379012499206,
                -14.231540691566835
              ],
              [
                136.3298446223554,
                -14.233086992831753
              ],
              [
                136.3240666216803,
                -14.229587611232663
              ],
              [
                136.3278100988899,
                -14.216403943688494
              ],
              [
                136.33521568910294,
                -14.208754154064419
              ],
              [
                136.35816491771146,
                -14.196547177492869
              ],
              [
                136.36817468643653,
                -14.189060220025436
              ],
              [
                136.39828536317313,
                -14.17603938556892
              ],
              [
                136.41130619896546,
                -14.165785489990169
              ],
              [
                136.42139731415486,
                -14.139336743540971
              ],
              [
                136.43083745705212,
                -14.129571344152957
              ],
              [
                136.43734785153336,
                -14.12037525528999
              ],
              [
                136.4336043522184,
                -14.109958529328164
              ],
              [
                136.4223738717668,
                -14.088555467494606
              ],
              [
                136.415537956342,
                -14.057305593155403
              ],
              [
                136.40967860280767,
                -13.997247125242927
              ],
              [
                136.41098068059296,
                -13.964939151881902
              ],
              [
                136.426280143146,
                -13.908461190941352
              ],
              [
                136.4301864104281,
                -13.877129913584167
              ],
              [
                136.4250594383507,
                -13.864515867243608
              ],
              [
                136.41504968418684,
                -13.848890937720371
              ],
              [
                136.40723715420629,
                -13.83269609794722
              ],
              [
                136.40967857990125,
                -13.818536053462521
              ],
              [
                136.42457115924998,
                -13.810316660516333
              ],
              [
                136.43995204268234,
                -13.816827222459741
              ],
              [
                136.46420329819364,
                -13.83953202308473
              ],
              [
                136.4721785645499,
                -13.833428539951939
              ],
              [
                136.49775952324947,
                -13.834098192630766
              ],
              [
                136.51216935179139,
                -13.834081669123654
              ],
              [
                136.525669213076,
                -13.818323651296396
              ],
              [
                136.51954188562627,
                -13.804457425229574
              ],
              [
                136.5301453284884,
                -13.785955905642023
              ],
              [
                136.53614341633929,
                -13.790297081174776
              ],
              [
                136.54810629476705,
                -13.810723439198155
              ],
              [
                136.5610457557521,
                -13.819756689957977
              ],
              [
                136.57406660639592,
                -13.798028279278192
              ],
              [
                136.579112184957,
                -13.802911125491994
              ],
              [
                136.5947371664496,
                -13.812269738961598
              ],
              [
                136.59473718374264,
                -13.784356430320887
              ],
              [
                136.6080835135336,
                -13.792250159536506
              ],
              [
                136.6227319746107,
                -13.787774392522937
              ],
              [
                136.62859136397944,
                -13.77629986960574
              ],
              [
                136.61573328428366,
                -13.763848657628339
              ],
              [
                136.6084090545129,
                -13.771254192037965
              ],
              [
                136.60303797907855,
                -13.754327213496063
              ],
              [
                136.60075931494288,
                -13.73691174070047
              ],
              [
                136.59351648731547,
                -13.724704777172493
              ],
              [
                136.5740665842754,
                -13.723565256301766
              ],
              [
                136.58073977763675,
                -13.713474202760752
              ],
              [
                136.5825301282825,
                -13.704359538218766
              ],
              [
                136.5782983890827,
                -13.697930694044302
              ],
              [
                136.56723065344505,
                -13.6954891212545
              ],
              [
                136.5722762510568,
                -13.686211925875746
              ],
              [
                136.5800887371768,
                -13.681898691024752
              ],
              [
                136.59009849398097,
                -13.681084833453502
              ],
              [
                136.60206139317665,
                -13.681898691024752
              ],
              [
                136.6155705155102,
                -13.684747042321051
              ],
              [
                136.61841881285187,
                -13.688734613992844
              ],
              [
                136.61646568395798,
                -13.692803601498948
              ],
              [
                136.61573325744098,
                -13.6954891212545
              ],
              [
                136.61670983435874,
                -13.69980235622568
              ],
              [
                136.6149194461711,
                -13.71184648751403
              ],
              [
                136.6157332504055,
                -13.715996891019397
              ],
              [
                136.62094160766125,
                -13.717706022086025
              ],
              [
                136.62614995210916,
                -13.715101918012968
              ],
              [
                136.62964927871073,
                -13.711358293112031
              ],
              [
                136.62940513362284,
                -13.709242383472537
              ],
              [
                136.63404381856188,
                -13.705987253440334
              ],
              [
                136.63786868835902,
                -13.69980235622568
              ],
              [
                136.64421635152493,
                -13.696465810454407
              ],
              [
                136.6567488860733,
                -13.702406460216501
              ],
              [
                136.6744897698319,
                -13.674899936554564
              ],
              [
                136.67709395129413,
                -13.664808884021657
              ],
              [
                136.68181401423163,
                -13.657403351242547
              ],
              [
                136.70655359171107,
                -13.65593846777374
              ],
              [
                136.71827234349385,
                -13.647719077611441
              ],
              [
                136.7253524296251,
                -13.664320689666667
              ],
              [
                136.72413169135964,
                -13.68718831462977
              ],
              [
                136.7141219384183,
                -13.707289305450578
              ],
              [
                136.68433679211125,
                -13.720472957785859
              ],
              [
                136.67807049231422,
                -13.731133621703023
              ],
              [
                136.6765242867399,
                -13.743747664446019
              ],
              [
                136.68051191337406,
                -13.754001550247642
              ],
              [
                136.69174238933005,
                -13.761651331943803
              ],
              [
                136.70337975152768,
                -13.763604410187103
              ],
              [
                136.71485437497284,
                -13.763116215732357
              ],
              [
                136.72559656529594,
                -13.763848657628339
              ],
              [
                136.71892338615552,
                -13.7706845817604
              ],
              [
                136.70460045500064,
                -13.791761965052169
              ],
              [
                136.71265709135702,
                -13.806817282328746
              ],
              [
                136.71485436690696,
                -13.818617469285762
              ],
              [
                136.7185164846579,
                -13.829034188368443
              ],
              [
                136.73178142314893,
                -13.83953202308473
              ],
              [
                136.74496505542191,
                -13.844170922678625
              ],
              [
                136.79721115759457,
                -13.85320417409102
              ],
              [
                136.81421961562043,
                -13.849704795579525
              ],
              [
                136.8283797669634,
                -13.840020518046577
              ],
              [
                136.83806397933222,
                -13.825860172910673
              ],
              [
                136.8416447135373,
                -13.808770360759354
              ],
              [
                136.83936610579138,
                -13.801039462906026
              ],
              [
                136.83366949190582,
                -13.79762150060744
              ],
              [
                136.82601972540093,
                -13.79794686345854
              ],
              [
                136.81918380443727,
                -13.800225605132237
              ],
              [
                136.82496177252628,
                -13.794366069544399
              ],
              [
                136.82715905649016,
                -13.791192354749821
              ],
              [
                136.84164474679963,
                -13.75017680965932
              ],
              [
                136.85621178219967,
                -13.757419512230515
              ],
              [
                136.8867293818033,
                -13.753594771614763
              ],
              [
                136.90308679399675,
                -13.757582343855876
              ],
              [
                136.90886478084988,
                -13.764336852083822
              ],
              [
                136.91684003039947,
                -13.777927284644573
              ],
              [
                136.92335045567833,
                -13.79314543311529
              ],
              [
                136.92432700664875,
                -13.805352398404281
              ],
              [
                136.9157007260673,
                -13.817315416970272
              ],
              [
                136.88575278365607,
                -13.845798337954257
              ],
              [
                136.87525477550548,
                -13.860040099532897
              ],
              [
                136.85596763525083,
                -13.915215701373956
              ],
              [
                136.82276453110677,
                -13.90520605952099
              ],
              [
                136.79135173370793,
                -13.917738390725352
              ],
              [
                136.76832114205956,
                -13.944593902361357
              ],
              [
                136.75977625528756,
                -13.977308953490613
              ],
              [
                136.76303143643779,
                -13.996840045965484
              ],
              [
                136.77076254951152,
                -14.004978026456218
              ],
              [
                136.78158613847503,
                -14.0093726801896
              ],
              [
                136.79379318081808,
                -14.017754908492511
              ],
              [
                136.79721112030848,
                -14.018731297950902
              ],
              [
                136.80567467353157,
                -14.023695562418792
              ],
              [
                136.81080164342916,
                -14.02939226926934
              ],
              [
                136.8040470688207,
                -14.031914959274557
              ],
              [
                136.7949324745303,
                -14.033135596351556
              ],
              [
                136.78785241411688,
                -14.036797808030817
              ],
              [
                136.78296960825733,
                -14.043064125675249
              ],
              [
                136.78028405180694,
                -14.05185313353292
              ],
              [
                136.76490317949677,
                -14.045505399895864
              ],
              [
                136.75440513001234,
                -14.050957859437677
              ],
              [
                136.74968511085828,
                -14.063734742835248
              ],
              [
                136.7522892547378,
                -14.079196848211724
              ],
              [
                136.7415470767415,
                -14.066989875431995
              ],
              [
                136.72950282049732,
                -14.061700247421438
              ],
              [
                136.71680750069672,
                -14.063653326967211
              ],
              [
                136.70460044549705,
                -14.072930530038494
              ],
              [
                136.70980881399947,
                -14.08505638754403
              ],
              [
                136.70923914147278,
                -14.099297856427038
              ],
              [
                136.7046004823457,
                -14.126885821807797
              ],
              [
                136.71607509143217,
                -14.165948321765857
              ],
              [
                136.71827231424737,
                -14.17839924467071
              ],
              [
                136.72339928463765,
                -14.185479422912573
              ],
              [
                136.7363387557013,
                -14.189141635917872
              ],
              [
                136.7521264918619,
                -14.190199441665696
              ],
              [
                136.78060959649773,
                -14.187188555786863
              ],
              [
                136.78419030321535,
                -14.186211865511012
              ],
              [
                136.78223716795745,
                -14.180596572432133
              ],
              [
                136.78028404094533,
                -14.164808799765055
              ],
              [
                136.78923589896854,
                -14.14950952300829
              ],
              [
                136.81055746254168,
                -14.159112091091071
              ],
              [
                136.87183677324973,
                -14.207940295529422
              ],
              [
                136.88070721276486,
                -14.20859132227176
              ],
              [
                136.8925887167177,
                -14.198907036712543
              ],
              [
                136.90121502917555,
                -14.188083529745144
              ],
              [
                136.90837647307416,
                -14.17693435950294
              ],
              [
                136.9135848528149,
                -14.163832409969881
              ],
              [
                136.91675868135997,
                -14.14739361129623
              ],
              [
                136.9243270403612,
                -14.14739361129623
              ],
              [
                136.9349064361381,
                -14.15520593112267
              ],
              [
                136.94890382857565,
                -14.15447348857924
              ],
              [
                136.9641219520747,
                -14.149997717888708
              ],
              [
                136.97885178036964,
                -14.14739361129623
              ],
              [
                136.96957440513563,
                -14.15520593112267
              ],
              [
                136.9619246782183,
                -14.164971631540348
              ],
              [
                136.95150802424422,
                -14.181573262694638
              ]
            ]
          ],
          [
            [
              [
                136.13591553735804,
                -13.434828236277133
              ],
              [
                136.1354273021767,
                -13.407973052980655
              ],
              [
                136.12233688903495,
                -13.39338791606214
              ],
              [
                136.11898849428567,
                -13.374200235908127
              ],
              [
                136.09498133352722,
                -13.360446982578633
              ],
              [
                136.11784915336705,
                -13.36223722779387
              ],
              [
                136.13402492629976,
                -13.386394573174282
              ],
              [
                136.14840704494767,
                -13.389896051441289
              ],
              [
                136.16334067487486,
                -13.41155354372548
              ],
              [
                136.1810001797603,
                -13.439060053289813
              ],
              [
                136.184336802898,
                -13.44573344192067
              ],
              [
                136.1889754630591,
                -13.45175550452744
              ],
              [
                136.19776450065314,
                -13.454847801406343
              ],
              [
                136.2031356059171,
                -13.461195527174375
              ],
              [
                136.19743900314162,
                -13.476495081768585
              ],
              [
                136.17017664251316,
                -13.455987321673323
              ],
              [
                136.17017663414055,
                -13.476495081768585
              ],
              [
                136.15455162401275,
                -13.472914290164788
              ],
              [
                136.15642336360574,
                -13.489353065007725
              ],
              [
                136.16334068604723,
                -13.512790592495278
              ],
              [
                136.14926284550828,
                -13.535072677949863
              ],
              [
                136.14295642482801,
                -13.560450366563362
              ],
              [
                136.13036718443988,
                -13.547318692369965
              ],
              [
                136.13307411424492,
                -13.530693350406178
              ],
              [
                136.14657058858268,
                -13.513210289301544
              ],
              [
                136.14027905012207,
                -13.50271095942006
              ],
              [
                136.13233485383964,
                -13.495294012765264
              ],
              [
                136.12410713010922,
                -13.47208420985937
              ],
              [
                136.13591553735804,
                -13.434828236277133
              ]
            ]
          ],
          [
            [
              [
                136.8169555220748,
                -12.076077032032355
              ],
              [
                136.82200381851573,
                -12.084448870501944
              ],
              [
                136.82424320390552,
                -12.104028124335628
              ],
              [
                136.82146134912512,
                -12.120831736824472
              ],
              [
                136.82935632206164,
                -12.132256811488016
              ],
              [
                136.8209741504527,
                -12.13795335114239
              ],
              [
                136.8129988853812,
                -12.136162958603505
              ],
              [
                136.8074650353877,
                -12.126560121647547
              ],
              [
                136.79706917791188,
                -12.108354568213704
              ],
              [
                136.79910509127734,
                -12.084558526219434
              ],
              [
                136.8169555220748,
                -12.076077032032355
              ]
            ]
          ],
          [
            [
              [
                132.3875431729151,
                -12.071872711688025
              ],
              [
                132.41187583797623,
                -12.083672718320937
              ],
              [
                132.4157820894563,
                -12.110284058240664
              ],
              [
                132.4057723403702,
                -12.13298925162453
              ],
              [
                132.38754315634264,
                -12.133396029288713
              ],
              [
                132.33985435664064,
                -12.098565316756833
              ],
              [
                132.34457441344026,
                -12.085870038644163
              ],
              [
                132.35775800058505,
                -12.077813347691192
              ],
              [
                132.37403404715843,
                -12.07341885729016
              ],
              [
                132.3875431729151,
                -12.071872711688025
              ]
            ]
          ],
          [
            [
              [
                136.29021243189834,
                -11.975681218679853
              ],
              [
                136.31625409654447,
                -11.9873999590554
              ],
              [
                136.302744981389,
                -12.013278856924355
              ],
              [
                136.26929772541814,
                -12.038995074282514
              ],
              [
                136.23560631814328,
                -12.05071381521191
              ],
              [
                136.2182723319745,
                -12.05413176881855
              ],
              [
                136.20801843213903,
                -12.062188459620685
              ],
              [
                136.19874108132495,
                -12.071384368216851
              ],
              [
                136.1843367912895,
                -12.078057594534638
              ],
              [
                136.1694442120527,
                -12.078383106779329
              ],
              [
                136.15105227839598,
                -12.074476809635183
              ],
              [
                136.13550866381908,
                -12.067315390080063
              ],
              [
                136.12916100180715,
                -12.057549722434285
              ],
              [
                136.13404381784218,
                -12.047946886088091
              ],
              [
                136.13493899008986,
                -12.037774290742917
              ],
              [
                136.13282311769956,
                -12.027276333458392
              ],
              [
                136.12916099522164,
                -12.016696810433416
              ],
              [
                136.14437910263783,
                -12.024102476542039
              ],
              [
                136.15365643873716,
                -12.031914920323242
              ],
              [
                136.1618758450352,
                -12.034763265024713
              ],
              [
                136.17359460293267,
                -12.026950821226626
              ],
              [
                136.19060306982357,
                -12.006280268925607
              ],
              [
                136.20004316572877,
                -11.999932555200006
              ],
              [
                136.21111087524272,
                -12.002373971997622
              ],
              [
                136.20834394483686,
                -12.006117437705614
              ],
              [
                136.2049259767694,
                -12.015801689356694
              ],
              [
                136.20386803462196,
                -12.0258114533094
              ],
              [
                136.2080184287635,
                -12.030368774770913
              ],
              [
                136.21745852744877,
                -12.029229406850723
              ],
              [
                136.2332462994144,
                -12.024590819995327
              ],
              [
                136.24203536010663,
                -12.02353286769118
              ],
              [
                136.25977623167725,
                -12.01604578597515
              ],
              [
                136.27947025325864,
                -11.983086884564884
              ],
              [
                136.29021243189834,
                -11.975681218679853
              ]
            ]
          ],
          [
            [
              [
                136.46420331073782,
                -11.893731304129618
              ],
              [
                136.47055097189968,
                -11.86825933619347
              ],
              [
                136.4718530571524,
                -11.839613512153026
              ],
              [
                136.4777938222952,
                -11.814222960674856
              ],
              [
                136.49854576196014,
                -11.798109581845809
              ],
              [
                136.49691816306583,
                -11.816501545971608
              ],
              [
                136.47803795043586,
                -11.865817919620172
              ],
              [
                136.47836347615905,
                -11.875583585936123
              ],
              [
                136.4817814409079,
                -11.882419492308209
              ],
              [
                136.48324629040516,
                -11.889418229917183
              ],
              [
                136.47803796072395,
                -11.89983492078655
              ],
              [
                136.47266687218809,
                -11.905450194055776
              ],
              [
                136.46908612357518,
                -11.906507996058052
              ],
              [
                136.46648195999347,
                -11.902764530611401
              ],
              [
                136.46420331073782,
                -11.893731304129618
              ]
            ]
          ],
          [
            [
              [
                136.60523521947653,
                -11.746026281580797
              ],
              [
                136.61850020115804,
                -11.735446910685363
              ],
              [
                136.62370852071555,
                -11.736586128176297
              ],
              [
                136.6223250561412,
                -11.74521242604313
              ],
              [
                136.61573327450748,
                -11.756524387152906
              ],
              [
                136.59571374609067,
                -11.774183910889608
              ],
              [
                136.58659915173163,
                -11.784356354232754
              ],
              [
                136.58155357495593,
                -11.798109581845809
              ],
              [
                136.56128990376433,
                -11.793633676689756
              ],
              [
                136.5280054016449,
                -11.798516509626626
              ],
              [
                136.51954186754742,
                -11.790704067062189
              ],
              [
                136.52898197163313,
                -11.776543911731494
              ],
              [
                136.53711999483272,
                -11.773125958759682
              ],
              [
                136.55713951156636,
                -11.777032104891843
              ],
              [
                136.57016034295495,
                -11.773207224144059
              ],
              [
                136.5842391266076,
                -11.764336829566904
              ],
              [
                136.60523521947653,
                -11.746026281580797
              ]
            ]
          ],
          [
            [
              [
                135.95590563559188,
                -11.707164454728666
              ],
              [
                135.9515281066241,
                -11.683485435129727
              ],
              [
                135.98086524548415,
                -11.661368183184978
              ],
              [
                136.0240506694076,
                -11.640872183290877
              ],
              [
                136.05520549736144,
                -11.650047810676337
              ],
              [
                136.02156043658542,
                -11.687457074064527
              ],
              [
                136.00604533142274,
                -11.708677853469885
              ],
              [
                135.98617698856708,
                -11.716368923358889
              ],
              [
                135.95590563559188,
                -11.707164454728666
              ]
            ]
          ],
          [
            [
              [
                132.61980228477788,
                -11.646661102286096
              ],
              [
                132.64112388585465,
                -11.644707879135936
              ],
              [
                132.64551843232886,
                -11.65016047062909
              ],
              [
                132.6477156831965,
                -11.667168818870834
              ],
              [
                132.64584393662804,
                -11.678887557069942
              ],
              [
                132.6406356148894,
                -11.691176054281424
              ],
              [
                132.6337996788569,
                -11.701918256123578
              ],
              [
                132.62720787857776,
                -11.708754161813397
              ],
              [
                132.61003664571,
                -11.71550865193194
              ],
              [
                132.58383222621583,
                -11.720147388087266
              ],
              [
                132.55884850672908,
                -11.719170851583462
              ],
              [
                132.54468834657803,
                -11.708754161813397
              ],
              [
                132.5281681552739,
                -11.691664247419688
              ],
              [
                132.51197351387393,
                -11.67058692186758
              ],
              [
                132.50879966956433,
                -11.649590711694765
              ],
              [
                132.5310164654464,
                -11.63298914112461
              ],
              [
                132.54517662241926,
                -11.631605676916104
              ],
              [
                132.55689538769826,
                -11.635674804165538
              ],
              [
                132.56804447388384,
                -11.641859685326073
              ],
              [
                132.57935632077644,
                -11.646661102286096
              ],
              [
                132.59197024592294,
                -11.648614175224775
              ],
              [
                132.61980228477788,
                -11.646661102286096
              ]
            ]
          ],
          [
            [
              [
                136.42335046404966,
                -11.509535467780184
              ],
              [
                136.45313561185858,
                -11.489353114438021
              ],
              [
                136.46851647832122,
                -11.476006816474055
              ],
              [
                136.47803796129162,
                -11.461114223277715
              ],
              [
                136.48340904629381,
                -11.484470282191955
              ],
              [
                136.47486412887315,
                -11.505954684050435
              ],
              [
                136.45736738016257,
                -11.523858302318601
              ],
              [
                136.40251712931294,
                -11.554782857053533
              ],
              [
                136.3923445891653,
                -11.557305538614033
              ],
              [
                136.38917077809708,
                -11.56243261775853
              ],
              [
                136.3756616587911,
                -11.59205497415499
              ],
              [
                136.32520591829896,
                -11.614678594328806
              ],
              [
                136.31617272188825,
                -11.624118747171924
              ],
              [
                136.31031334466124,
                -11.626153235682239
              ],
              [
                136.30534914782825,
                -11.624688355886388
              ],
              [
                136.30005943228517,
                -11.620863475431266
              ],
              [
                136.29761802726708,
                -11.616387570678775
              ],
              [
                136.28467857949946,
                -11.624769771477968
              ],
              [
                136.27328535888125,
                -11.639092756898771
              ],
              [
                136.25855553548337,
                -11.652113543570927
              ],
              [
                136.23218834325098,
                -11.660332913320616
              ],
              [
                136.23047936348337,
                -11.652113543570927
              ],
              [
                136.19564863406742,
                -11.680433852496506
              ],
              [
                136.17701255820668,
                -11.688246294601125
              ],
              [
                136.18197675563752,
                -11.6827938532222
              ],
              [
                136.18295332932402,
                -11.678155267367178
              ],
              [
                136.18287193700814,
                -11.673109603555519
              ],
              [
                136.19019615060398,
                -11.646416855508946
              ],
              [
                136.19849693586858,
                -11.639580950024948
              ],
              [
                136.21159915206735,
                -11.63616299729095
              ],
              [
                136.23218834466257,
                -11.626153235682239
              ],
              [
                136.24268640031673,
                -11.612481424859732
              ],
              [
                136.2536727163465,
                -11.59189214297413
              ],
              [
                136.26685631267102,
                -11.572930572208442
              ],
              [
                136.2834578799086,
                -11.564711202771335
              ],
              [
                136.28630618507202,
                -11.573663012090165
              ],
              [
                136.30201257336194,
                -11.591078437709797
              ],
              [
                136.31950930594365,
                -11.602959856473694
              ],
              [
                136.327810093592,
                -11.595472926823023
              ],
              [
                136.33253014038496,
                -11.587090726129398
              ],
              [
                136.36817466882016,
                -11.544203336876386
              ],
              [
                136.37110435462006,
                -11.547621289478682
              ],
              [
                136.37566165156613,
                -11.55046963338841
              ],
              [
                136.3796492876938,
                -11.53606538311998
              ],
              [
                136.39380943360902,
                -11.524834838738059
              ],
              [
                136.42335046404966,
                -11.509535467780184
              ]
            ]
          ],
          [
            [
              [
                130.5367944698422,
                -11.705010696800015
              ],
              [
                130.54859459266885,
                -11.701429912769512
              ],
              [
                130.57496179081605,
                -11.715427386550067
              ],
              [
                130.61988365663598,
                -11.74911872232854
              ],
              [
                130.63160241452928,
                -11.762383756513584
              ],
              [
                130.6350203781197,
                -11.768161710295782
              ],
              [
                130.63282311361118,
                -11.787530210644583
              ],
              [
                130.6281844312095,
                -11.804619975710539
              ],
              [
                130.61736087781685,
                -11.81316500852054
              ],
              [
                130.57325279680637,
                -11.830987213820777
              ],
              [
                130.52100669906181,
                -11.82952233386745
              ],
              [
                130.49634850735234,
                -11.839043903373947
              ],
              [
                130.47046959568652,
                -11.824802332041457
              ],
              [
                130.4387313113886,
                -11.81161871298338
              ],
              [
                130.40593510176762,
                -11.801853197262304
              ],
              [
                130.37598716827597,
                -11.798109581845809
              ],
              [
                130.3601180337242,
                -11.793715092288348
              ],
              [
                130.336924666538,
                -11.774590688451582
              ],
              [
                130.32105553198033,
                -11.770196198952872
              ],
              [
                130.30632571068261,
                -11.772556199789491
              ],
              [
                130.2815861330242,
                -11.78232186555943
              ],
              [
                130.23511804267764,
                -11.78972753052079
              ],
              [
                130.14698326768982,
                -11.824802332041457
              ],
              [
                130.11890709020082,
                -11.827813357327983
              ],
              [
                130.08423912220263,
                -11.827813357327983
              ],
              [
                130.05347741551049,
                -11.822849258920137
              ],
              [
                130.03711997988688,
                -11.811211785199445
              ],
              [
                130.0240991584351,
                -11.795179972210695
              ],
              [
                130.01832116856022,
                -11.78525162538625
              ],
              [
                130.01661216792237,
                -11.777032104891843
              ],
              [
                130.02295983650822,
                -11.762383756513584
              ],
              [
                130.03150475480268,
                -11.759209900146447
              ],
              [
                130.0540470721812,
                -11.763360293039982
              ],
              [
                130.06959068460358,
                -11.755629116013735
              ],
              [
                130.07154381643903,
                -11.73674895936834
              ],
              [
                130.06430096860132,
                -11.691338735256391
              ],
              [
                130.07154381892516,
                -11.671156530594281
              ],
              [
                130.08814538313183,
                -11.673597946902754
              ],
              [
                130.118988472263,
                -11.694512591510682
              ],
              [
                130.1456811838158,
                -11.69939542418658
              ],
              [
                130.16732832763793,
                -11.692640934123151
              ],
              [
                130.18539472108145,
                -11.676527556348763
              ],
              [
                130.20150800961997,
                -11.653497007792447
              ],
              [
                130.1946720758774,
                -11.631117483791682
              ],
              [
                130.18409263713386,
                -11.547295777336036
              ],
              [
                130.19410240572026,
                -11.53386806350766
              ],
              [
                130.19857831148454,
                -11.519952006431105
              ],
              [
                130.19849693862034,
                -11.506605708325807
              ],
              [
                130.19410240810373,
                -11.495212483101342
              ],
              [
                130.18572025692868,
                -11.486423505217372
              ],
              [
                130.17546634624216,
                -11.483575161373457
              ],
              [
                130.1629337842114,
                -11.485121306462544
              ],
              [
                130.14698326903851,
                -11.489027602302256
              ],
              [
                130.17058353893844,
                -11.447035485586664
              ],
              [
                130.18100019092194,
                -11.434340061849053
              ],
              [
                130.19353274794642,
                -11.424411716575765
              ],
              [
                130.2177840525488,
                -11.40960053919764
              ],
              [
                130.22828210468958,
                -11.399672193993904
              ],
              [
                130.2587996834812,
                -11.348890950609114
              ],
              [
                130.2697860107851,
                -11.338148750144393
              ],
              [
                130.2895613894825,
                -11.333103086936697
              ],
              [
                130.30860436838515,
                -11.332940405982518
              ],
              [
                130.32699629536683,
                -11.33017347784308
              ],
              [
                130.3449813228807,
                -11.31707127699478
              ],
              [
                130.34994551146207,
                -11.339450798632493
              ],
              [
                130.36011803655077,
                -11.366387640330242
              ],
              [
                130.37378991402574,
                -11.393731409916171
              ],
              [
                130.39918053428167,
                -11.43303801332892
              ],
              [
                130.39861087628591,
                -11.444512653909822
              ],
              [
                130.38648521525852,
                -11.468519736966957
              ],
              [
                130.38347416152288,
                -11.484307601230956
              ],
              [
                130.3864852180233,
                -11.519707909879974
              ],
              [
                130.39682050700057,
                -11.534600503378226
              ],
              [
                130.44556725617952,
                -11.567152618965409
              ],
              [
                130.4616805386267,
                -11.59205497415499
              ],
              [
                130.46501712715408,
                -11.620049770156779
              ],
              [
                130.46290124072593,
                -11.650079055036567
              ],
              [
                130.45679772518776,
                -11.676690387535844
              ],
              [
                130.44800865525107,
                -11.694512591510682
              ],
              [
                130.44800865103642,
                -11.701348497174967
              ],
              [
                130.45883222592846,
                -11.697686447769984
              ],
              [
                130.46583092935361,
                -11.693291958450214
              ],
              [
                130.47315514119504,
                -11.68971117444074
              ],
              [
                130.48552492853239,
                -11.688246294601125
              ],
              [
                130.49773196304437,
                -11.690036686603781
              ],
              [
                130.5301212912959,
                -11.699802351945655
              ],
              [
                130.5367944698422,
                -11.705010696800015
              ]
            ]
          ],
          [
            [
              [
                131.53736412392368,
                -11.413262588190385
              ],
              [
                131.53891034521618,
                -11.446058798979532
              ],
              [
                131.5366317044463,
                -11.463067296074962
              ],
              [
                131.53044680680546,
                -11.474786033310602
              ],
              [
                131.51937910825416,
                -11.478773744723831
              ],
              [
                131.49675540862268,
                -11.471123984249655
              ],
              [
                131.48267662480694,
                -11.474786033310602
              ],
              [
                131.4710392683641,
                -11.493340825870728
              ],
              [
                131.46094810832673,
                -11.526950742754638
              ],
              [
                131.4582625610816,
                -11.562188370990196
              ],
              [
                131.4690047595948,
                -11.5858700931288
              ],
              [
                131.46900474652315,
                -11.578383013318355
              ],
              [
                131.47396894094547,
                -11.600192928093934
              ],
              [
                131.45582115200497,
                -11.60808678550134
              ],
              [
                131.43238365083198,
                -11.607028833458534
              ],
              [
                131.4205835285744,
                -11.601983320023997
              ],
              [
                131.4177352293282,
                -11.59661229445119
              ],
              [
                131.39698327785547,
                -11.582126628327332
              ],
              [
                131.38656660143204,
                -11.577813404615137
              ],
              [
                131.37810306310112,
                -11.584079701210875
              ],
              [
                131.32593835175408,
                -11.681898732330499
              ],
              [
                131.3029891258021,
                -11.701104400604626
              ],
              [
                131.29314212829752,
                -11.72405368432081
              ],
              [
                131.28199303715155,
                -11.727797149370971
              ],
              [
                131.26872805263562,
                -11.727959830349006
              ],
              [
                131.25733483418742,
                -11.729180613644411
              ],
              [
                131.22877037069242,
                -11.744886913870827
              ],
              [
                131.21485435435332,
                -11.756280140362195
              ],
              [
                131.20899498707612,
                -11.766778245993184
              ],
              [
                131.2015080132789,
                -11.775160447422433
              ],
              [
                131.0989689520082,
                -11.82838311631648
              ],
              [
                130.97999108669376,
                -11.926446257085317
              ],
              [
                130.96119224750802,
                -11.933851772501436
              ],
              [
                130.94141687251434,
                -11.927911137129772
              ],
              [
                130.9221297553593,
                -11.90048594519156
              ],
              [
                130.89486737512885,
                -11.877862171319057
              ],
              [
                130.86003664941097,
                -11.859958549902217
              ],
              [
                130.80844159737217,
                -11.84270595306761
              ],
              [
                130.76042727676162,
                -11.814060129475726
              ],
              [
                130.75277753184216,
                -11.811211785199445
              ],
              [
                130.73519940895184,
                -11.807793832159541
              ],
              [
                130.7125757103007,
                -11.799493046173012
              ],
              [
                130.6906030686614,
                -11.78834406620136
              ],
              [
                130.6745711528865,
                -11.777032104891843
              ],
              [
                130.6735132095052,
                -11.77288171196673
              ],
              [
                130.68197676627187,
                -11.767266589364146
              ],
              [
                130.68067467618698,
                -11.763360293039982
              ],
              [
                130.67546633830486,
                -11.760511948846142
              ],
              [
                130.6642358667811,
                -11.758396044602954
              ],
              [
                130.66032962826736,
                -11.756524387152906
              ],
              [
                130.6128035740371,
                -11.716566604029069
              ],
              [
                130.58228599713703,
                -11.697930544339892
              ],
              [
                130.57471765161276,
                -11.689548493465887
              ],
              [
                130.56373131548983,
                -11.672133067074665
              ],
              [
                130.55844159431942,
                -11.667168818870834
              ],
              [
                130.53785241682428,
                -11.661553696574815
              ],
              [
                130.51490318620364,
                -11.657891497027563
              ],
              [
                130.49659265350186,
                -11.64950944631554
              ],
              [
                130.48894290065468,
                -11.629571188400815
              ],
              [
                130.48585045211803,
                -11.562188370990196
              ],
              [
                130.48210696108688,
                -11.544203336876386
              ],
              [
                130.47852622963043,
                -11.54070396868981
              ],
              [
                130.46607506740284,
                -11.53362396695527
              ],
              [
                130.46168054406454,
                -11.529961917819007
              ],
              [
                130.43775476248877,
                -11.499200194542064
              ],
              [
                130.43034916152524,
                -11.484307601230956
              ],
              [
                130.4077254589926,
                -11.37468842482359
              ],
              [
                130.40626061061138,
                -11.354912999991138
              ],
              [
                130.4041447222188,
                -11.350030167932319
              ],
              [
                130.39958744211498,
                -11.34677504670501
              ],
              [
                130.39486738102786,
                -11.342461823315974
              ],
              [
                130.3927514891508,
                -11.334405135423332
              ],
              [
                130.3935653082922,
                -11.323663085206183
              ],
              [
                130.3958439395078,
                -11.3140601021144
              ],
              [
                130.4001570923113,
                -11.305108293494033
              ],
              [
                130.40626061344875,
                -11.296563412591661
              ],
              [
                130.38038170064885,
                -11.269138227998775
              ],
              [
                130.37012780389267,
                -11.252048466315836
              ],
              [
                130.36597741403628,
                -11.23235445753841
              ],
              [
                130.36744225350373,
                -11.20427824898743
              ],
              [
                130.3728133493509,
                -11.183770460046498
              ],
              [
                130.38314863787238,
                -11.167901331422602
              ],
              [
                130.40015709363936,
                -11.153252835691458
              ],
              [
                130.43637128998643,
                -11.202732028890038
              ],
              [
                130.5065210207212,
                -11.277032084622327
              ],
              [
                130.51612389444912,
                -11.296563412591661
              ],
              [
                130.5257267601466,
                -11.289320580178
              ],
              [
                130.53492272605436,
                -11.280043259481511
              ],
              [
                130.54517663042057,
                -11.272393499388873
              ],
              [
                130.55844160229924,
                -11.269952083399449
              ],
              [
                130.5735783126948,
                -11.275323108449577
              ],
              [
                130.58716881157636,
                -11.286797748598318
              ],
              [
                130.59636478728137,
                -11.30152766017826
              ],
              [
                130.59880619289413,
                -11.31707127699478
              ],
              [
                130.5905054094077,
                -11.333265918104136
              ],
              [
                130.56202232766307,
                -11.361097880550156
              ],
              [
                130.55844160303445,
                -11.379164329201831
              ],
              [
                130.5661727182998,
                -11.394626530710509
              ],
              [
                130.57781008944303,
                -11.397067946766382
              ],
              [
                130.59001711803,
                -11.392185114656227
              ],
              [
                130.5988061784836,
                -11.385918818464498
              ],
              [
                130.63892662615686,
                -11.343845287389254
              ],
              [
                130.65845787110752,
                -11.331312695161527
              ],
              [
                130.6683048867578,
                -11.344984654924396
              ],
              [
                130.6538192135088,
                -11.377536768576414
              ],
              [
                130.65772546057335,
                -11.38404716129542
              ],
              [
                130.668304879027,
                -11.392185114656227
              ],
              [
                130.6916610094445,
                -11.422784155930401
              ],
              [
                130.69556724890188,
                -11.434340061849053
              ],
              [
                130.7236434263327,
                -11.384698185546581
              ],
              [
                130.78467858145234,
                -11.368422128659798
              ],
              [
                130.84546960486554,
                -11.360284175347614
              ],
              [
                130.87322023911818,
                -11.334405135423332
              ],
              [
                130.88803144717264,
                -11.313164981336955
              ],
              [
                130.92090904990786,
                -11.309340101265535
              ],
              [
                130.95386803967196,
                -11.316338837170369
              ],
              [
                130.96859784717483,
                -11.327569230659284
              ],
              [
                130.97510827792223,
                -11.3361142618292
              ],
              [
                131.00326582490413,
                -11.34742607095028
              ],
              [
                131.00977623560033,
                -11.354912999991138
              ],
              [
                131.01872806084654,
                -11.400567314789694
              ],
              [
                131.02328534694348,
                -11.413262588190385
              ],
              [
                131.02947024558367,
                -11.399834874950741
              ],
              [
                131.04883874701596,
                -11.315036788688694
              ],
              [
                131.06177819299802,
                -11.30592214890005
              ],
              [
                131.0794376887763,
                -11.30022546148717
              ],
              [
                131.09913171373915,
                -11.290459947700368
              ],
              [
                131.13453210057475,
                -11.257745078573798
              ],
              [
                131.15308678877764,
                -11.249281538217872
              ],
              [
                131.16114342726186,
                -11.266534131058568
              ],
              [
                131.16293378333333,
                -11.288832236893256
              ],
              [
                131.16822351062703,
                -11.310153956672227
              ],
              [
                131.17660566466108,
                -11.329034110311653
              ],
              [
                131.21794681941728,
                -11.39104589732114
              ],
              [
                131.21924890174816,
                -11.399672193993904
              ],
              [
                131.23080487886799,
                -11.3908016505666
              ],
              [
                131.2286889885831,
                -11.371026225654875
              ],
              [
                131.21583093183446,
                -11.338148750144393
              ],
              [
                131.21509849804607,
                -11.32789474278052
              ],
              [
                131.21656335571998,
                -11.306736004306195
              ],
              [
                131.2158309254515,
                -11.296563412591661
              ],
              [
                131.21241294962374,
                -11.29607506930627
              ],
              [
                131.20582115709573,
                -11.296156484889378
              ],
              [
                131.19890383784718,
                -11.295098532948884
              ],
              [
                131.195160358744,
                -11.290459947700368
              ],
              [
                131.19581140268926,
                -11.28427506723304
              ],
              [
                131.20093834521253,
                -11.273370035742275
              ],
              [
                131.20533288264093,
                -11.246514610121105
              ],
              [
                131.21485435963393,
                -11.226169502021886
              ],
              [
                131.2299910827467,
                -11.208103128994502
              ],
              [
                131.24984785047835,
                -11.19475675676816
              ],
              [
                131.27442467653103,
                -11.189629828310672
              ],
              [
                131.29200279861172,
                -11.197523684846084
              ],
              [
                131.3024194648232,
                -11.215996985546937
              ],
              [
                131.30502363193784,
                -11.242608314511944
              ],
              [
                131.30079186602538,
                -11.246677366179311
              ],
              [
                131.29281660224115,
                -11.258721614924834
              ],
              [
                131.2902124407709,
                -11.271416963035636
              ],
              [
                131.30144289901568,
                -11.277439012323198
              ],
              [
                131.31519615597546,
                -11.272637595923896
              ],
              [
                131.32129967377216,
                -11.261976811202699
              ],
              [
                131.32488040544666,
                -11.250258074567624
              ],
              [
                131.3313094389374,
                -11.242608314511944
              ],
              [
                131.34343509536876,
                -11.240980753930966
              ],
              [
                131.35181724935623,
                -11.246189022898054
              ],
              [
                131.35938561407826,
                -11.252862246607622
              ],
              [
                131.36939537811546,
                -11.256280198940894
              ],
              [
                131.38200930886484,
                -11.253838782957907
              ],
              [
                131.4021916005606,
                -11.243829022501217
              ],
              [
                131.41431725193615,
                -11.242608314511944
              ],
              [
                131.4277449857213,
                -11.249688390810276
              ],
              [
                131.4368595788393,
                -11.264906570471522
              ],
              [
                131.43978926770535,
                -11.28427506723304
              ],
              [
                131.43490644225986,
                -11.303399317312442
              ],
              [
                131.45582116327438,
                -11.309747028968848
              ],
              [
                131.46045982505495,
                -11.33098718304005
              ],
              [
                131.46070397988044,
                -11.357517247190977
              ],
              [
                131.4698999360634,
                -11.382256769498623
              ],
              [
                131.47461998851193,
                -11.390557554025316
              ],
              [
                131.4801538394141,
                -11.395684482674971
              ],
              [
                131.48267662497597,
                -11.389092674351497
              ],
              [
                131.50318444204197,
                -11.379164329201831
              ],
              [
                131.5179142645748,
                -11.380629208871909
              ],
              [
                131.52784263869768,
                -11.386651258300764
              ],
              [
                131.53370201529464,
                -11.397393458893063
              ],
              [
                131.53736412392368,
                -11.413262588190385
              ]
            ]
          ],
          [
            [
              [
                136.76368508131912,
                -11.040070531859195
              ],
              [
                136.74715157379012,
                -11.093376181971875
              ],
              [
                136.73363812933857,
                -11.137651912865916
              ],
              [
                136.72008810724188,
                -11.174425318203895
              ],
              [
                136.71648196943673,
                -11.206231396781739
              ],
              [
                136.70818118165403,
                -11.209567933510884
              ],
              [
                136.70460046023047,
                -11.211602496888453
              ],
              [
                136.7024031902536,
                -11.211358325248996
              ],
              [
                136.6800244332142,
                -11.223023961434592
              ],
              [
                136.66873688549467,
                -11.256050222452222
              ],
              [
                136.63911015059963,
                -11.28616685293701
              ],
              [
                136.62712648844146,
                -11.330254743213489
              ],
              [
                136.61186710963565,
                -11.334231488901565
              ],
              [
                136.58994783151033,
                -11.377764642085245
              ],
              [
                136.54286118336708,
                -11.429655360974902
              ],
              [
                136.53529012022815,
                -11.443169146526397
              ],
              [
                136.52461452696497,
                -11.44696428450211
              ],
              [
                136.52228602233544,
                -11.439487719991535
              ],
              [
                136.51614946050344,
                -11.43427577057462
              ],
              [
                136.50928947751493,
                -11.43730316857773
              ],
              [
                136.49409793898428,
                -11.455346334554742
              ],
              [
                136.4780194043848,
                -11.44793391108636
              ],
              [
                136.4947652782834,
                -11.43512552697524
              ],
              [
                136.50005077173728,
                -11.422372120965113
              ],
              [
                136.48243584634824,
                -11.412721069398607
              ],
              [
                136.49764347261103,
                -11.398424672898662
              ],
              [
                136.52961290474585,
                -11.376562485400312
              ],
              [
                136.5605574854986,
                -11.354912999991138
              ],
              [
                136.56373131070268,
                -11.34587977570797
              ],
              [
                136.58033288447342,
                -11.327406549705309
              ],
              [
                136.57887627647537,
                -11.303700494885055
              ],
              [
                136.58565270726794,
                -11.284945919619318
              ],
              [
                136.61670728297238,
                -11.236104831786715
              ],
              [
                136.6538717760316,
                -11.186454996153241
              ],
              [
                136.68802878279607,
                -11.1775960194931
              ],
              [
                136.70004434350705,
                -11.140086569220847
              ],
              [
                136.70986852129883,
                -11.120558396100085
              ],
              [
                136.71126870606133,
                -11.096581432291936
              ],
              [
                136.7229109992664,
                -11.086358294058067
              ],
              [
                136.73103541210932,
                -11.079236083043753
              ],
              [
                136.73477589227363,
                -11.064228427497234
              ],
              [
                136.71866713603808,
                -11.05083609013123
              ],
              [
                136.7386173812596,
                -11.029717684489121
              ],
              [
                136.7424422502605,
                -11.032810124657113
              ],
              [
                136.74561607776076,
                -11.034356344741072
              ],
              [
                136.74887128689676,
                -11.03541429665743
              ],
              [
                136.7522892594308,
                -11.037204688378392
              ],
              [
                136.75603274562795,
                -11.026788000376817
              ],
              [
                136.7624617890212,
                -11.01930107159268
              ],
              [
                136.76368508131912,
                -11.040070531859195
              ]
            ]
          ],
          [
            [
              [
                132.4894311879251,
                -11.160088815385073
              ],
              [
                132.49382571296005,
                -11.150648663681535
              ],
              [
                132.50196373715997,
                -11.14690519927728
              ],
              [
                132.51099693842386,
                -11.144626539381315
              ],
              [
                132.51734459243195,
                -11.139580951421534
              ],
              [
                132.51791425834153,
                -11.127211190720317
              ],
              [
                132.51148522502203,
                -11.086846637332403
              ],
              [
                132.50709069485276,
                -11.078220341050365
              ],
              [
                132.49537194520533,
                -11.073907192909918
              ],
              [
                132.4870711565791,
                -11.063571845383633
              ],
              [
                132.48023522294733,
                -11.05103932865782
              ],
              [
                132.47266686733346,
                -11.040215788071476
              ],
              [
                132.4681095721264,
                -11.029961856126214
              ],
              [
                132.4824324864486,
                -11.032159100433674
              ],
              [
                132.50114993642447,
                -11.039971616434396
              ],
              [
                132.5105086602016,
                -11.047051692629934
              ],
              [
                132.5180770167397,
                -11.040785396713613
              ],
              [
                132.5346785851054,
                -11.037774372127165
              ],
              [
                132.55128014635588,
                -11.032403272070779
              ],
              [
                132.5589298863146,
                -11.019789339760381
              ],
              [
                132.5605574856261,
                -11.000176671718709
              ],
              [
                132.56666100582564,
                -10.982110298854753
              ],
              [
                132.57886803460033,
                -10.970147390743941
              ],
              [
                132.59929446331978,
                -10.968356999018312
              ],
              [
                132.59546960040313,
                -10.981622030686303
              ],
              [
                132.582286003329,
                -10.999688403550689
              ],
              [
                132.57935631414807,
                -11.01262784798016
              ],
              [
                132.5813908224799,
                -11.025648707985665
              ],
              [
                132.58627363222308,
                -11.039239176629783
              ],
              [
                132.59929446247415,
                -11.063897357495327
              ],
              [
                132.59302818647436,
                -11.063897357495327
              ],
              [
                132.59945722948814,
                -11.073011997049374
              ],
              [
                132.6062117831085,
                -11.085544513778546
              ],
              [
                132.61133873995763,
                -11.09840261773032
              ],
              [
                132.61353600857706,
                -11.108819305740662
              ],
              [
                132.6106063163139,
                -11.122735286515875
              ],
              [
                132.60368899671676,
                -11.124607018714936
              ],
              [
                132.59449303371684,
                -11.124607018714936
              ],
              [
                132.58570397160608,
                -11.132745046844757
              ],
              [
                132.58204185908966,
                -11.153415591747947
              ],
              [
                132.59693443784803,
                -11.158786691826037
              ],
              [
                132.61841881298042,
                -11.161553619894256
              ],
              [
                132.63404381909558,
                -11.17376069967768
              ],
              [
                132.61255943682215,
                -11.185723532729742
              ],
              [
                132.61255944407674,
                -11.198988564467298
              ],
              [
                132.62142988068675,
                -11.217705961704393
              ],
              [
                132.62720787480941,
                -11.24602626683986
              ],
              [
                132.62183678756858,
                -11.27206798727111
              ],
              [
                132.6007593179905,
                -11.315687812929488
              ],
              [
                132.5992944697986,
                -11.344984654924396
              ],
              [
                132.56519616443958,
                -11.310804980912359
              ],
              [
                132.5608830050829,
                -11.276787988087113
              ],
              [
                132.54997806068184,
                -11.246270438480476
              ],
              [
                132.53451581831632,
                -11.218926669689495
              ],
              [
                132.49301191274313,
                -11.166924719975984
              ],
              [
                132.4894311879251,
                -11.160088815385073
              ]
            ]
          ],
          [
            [
              [
                142.25538170332607,
                -10.666680568200738
              ],
              [
                142.278819203429,
                -10.690524970083205
              ],
              [
                142.28256269860123,
                -10.701348586311052
              ],
              [
                142.28305097300756,
                -10.714532127868733
              ],
              [
                142.28003991010038,
                -10.718926691782128
              ],
              [
                142.2734481103071,
                -10.718357008008725
              ],
              [
                142.26343835151326,
                -10.716241179190444
              ],
              [
                142.2529403012273,
                -10.71721771556826
              ],
              [
                142.23031660190725,
                -10.726006768277337
              ],
              [
                142.2177840523361,
                -10.728122672196935
              ],
              [
                142.20606529971238,
                -10.73308684475981
              ],
              [
                142.1967879601087,
                -10.744724241176801
              ],
              [
                142.19027753927364,
                -10.758477466358869
              ],
              [
                142.18702233645055,
                -10.769626594524079
              ],
              [
                142.15316816921214,
                -10.755629197731801
              ],
              [
                142.14551842725487,
                -10.749200145534648
              ],
              [
                142.13656660042386,
                -10.730645428718084
              ],
              [
                142.1219181634997,
                -10.70956795528213
              ],
              [
                142.11231529839478,
                -10.684340089427765
              ],
              [
                142.11817467798622,
                -10.653497026462352
              ],
              [
                142.12077884014508,
                -10.64788175441704
              ],
              [
                142.12354577199903,
                -10.64365002158657
              ],
              [
                142.12777753831745,
                -10.640801677763124
              ],
              [
                142.14576256542944,
                -10.639092701510478
              ],
              [
                142.14966881464497,
                -10.636488529336388
              ],
              [
                142.15235436259832,
                -10.6320126248366
              ],
              [
                142.15967858403144,
                -10.625664988002894
              ],
              [
                142.17701256641115,
                -10.616306251241735
              ],
              [
                142.1801863926451,
                -10.615411055314983
              ],
              [
                142.18230227807624,
                -10.609958576821263
              ],
              [
                142.1932072258393,
                -10.59148527482501
              ],
              [
                142.2122501979223,
                -10.597588815183016
              ],
              [
                142.2293400380716,
                -10.619805581805554
              ],
              [
                142.25538170332607,
                -10.666680568200738
              ]
            ]
          ],
          [
            [
              [
                142.26221764627394,
                -10.577813426991712
              ],
              [
                142.29428144483467,
                -10.573174728776864
              ],
              [
                142.31885826792472,
                -10.5886369685045
              ],
              [
                142.32520592435927,
                -10.61239999295025
              ],
              [
                142.30307050697033,
                -10.632500893037644
              ],
              [
                142.27442467331585,
                -10.640801677763124
              ],
              [
                142.25367272013904,
                -10.625420816348537
              ],
              [
                142.24732506519774,
                -10.599786059666005
              ],
              [
                142.26221764627394,
                -10.577813426991712
              ]
            ]
          ],
          [
            [
              [
                142.29346764436622,
                -10.138929949035923
              ],
              [
                142.3144637379942,
                -10.148614190951134
              ],
              [
                142.33204186360766,
                -10.169691670019494
              ],
              [
                142.34050540595052,
                -10.190850526834422
              ],
              [
                142.33423912875298,
                -10.200453380965453
              ],
              [
                142.31666100507084,
                -10.213474225806848
              ],
              [
                142.28980553612087,
                -10.26018646517328
              ],
              [
                142.27572675876252,
                -10.255629163054945
              ],
              [
                142.26368248758004,
                -10.246514577556306
              ],
              [
                142.24854576800925,
                -10.24032967687107
              ],
              [
                142.2336531917489,
                -10.23837656614581
              ],
              [
                142.22120201903343,
                -10.242120050273218
              ],
              [
                142.21062259241145,
                -10.232110287379562
              ],
              [
                142.20118248739786,
                -10.220391529046806
              ],
              [
                142.19483483248464,
                -10.207289324990496
              ],
              [
                142.19320722589796,
                -10.193617436909442
              ],
              [
                142.20386803465874,
                -10.1884091101838
              ],
              [
                142.21111087400965,
                -10.183038027336275
              ],
              [
                142.21436608120243,
                -10.176527595409096
              ],
              [
                142.21322675960224,
                -10.157647398986324
              ],
              [
                142.2143660818861,
                -10.153252862056105
              ],
              [
                142.23170006613208,
                -10.141859634094848
              ],
              [
                142.254161004147,
                -10.13795338421882
              ],
              [
                142.29346764436622,
                -10.138929949035923
              ]
            ]
          ],
          [
            [
              [
                142.1901147794564,
                -10.080987233460416
              ],
              [
                142.19752037928436,
                -10.092461849371269
              ],
              [
                142.19776451895356,
                -10.102146091612438
              ],
              [
                142.1901147797927,
                -10.143731376280611
              ],
              [
                142.18295332088613,
                -10.153252862056105
              ],
              [
                142.17595462253692,
                -10.160821218165982
              ],
              [
                142.1670027996564,
                -10.182061453160683
              ],
              [
                142.15479576972416,
                -10.188083597977617
              ],
              [
                142.14291425855473,
                -10.185642181322452
              ],
              [
                142.13868248860018,
                -10.172539976963213
              ],
              [
                142.1246850928678,
                -10.158298442188782
              ],
              [
                142.10987389401055,
                -10.147556248086875
              ],
              [
                142.09913170752557,
                -10.135674742364591
              ],
              [
                142.09701582061382,
                -10.118584890786009
              ],
              [
                142.1421004572005,
                -10.050388280679758
              ],
              [
                142.15723717479776,
                -10.052992444305167
              ],
              [
                142.169606967237,
                -10.060153905983308
              ],
              [
                142.1901147794564,
                -10.080987233460416
              ]
            ]
          ],
          [
            [
              [
                115.66000412266041,
                -32.14983494384715
              ],
              [
                115.66374757601328,
                -32.173109594474894
              ],
              [
                115.67847739573038,
                -32.21648524969156
              ],
              [
                115.6805119367333,
                -32.23935317519288
              ],
              [
                115.66456141685232,
                -32.23463312590043
              ],
              [
                115.66000411752678,
                -32.23251722230699
              ],
              [
                115.6569930661217,
                -32.20940528086587
              ],
              [
                115.64942464979305,
                -32.1843400412824
              ],
              [
                115.64722741999661,
                -32.16269299110584
              ],
              [
                115.66000412266041,
                -32.14983494384715
              ]
            ]
          ],
          [
            [
              [
                115.49210732539757,
                -31.995648989617287
              ],
              [
                115.52460702421597,
                -31.99380648613695
              ],
              [
                115.54260985510358,
                -32.000031113286106
              ],
              [
                115.55219218891156,
                -32.00620348478482
              ],
              [
                115.5316546193582,
                -32.01832433173357
              ],
              [
                115.51475903811358,
                -32.025362184812
              ],
              [
                115.49073095603373,
                -32.01909743797997
              ],
              [
                115.45939989116046,
                -32.02297933971399
              ],
              [
                115.44014224254187,
                -32.0218339464522
              ],
              [
                115.45829636913736,
                -32.009712492653264
              ],
              [
                115.4823663822996,
                -32.01088551626375
              ],
              [
                115.49210732539757,
                -31.995648989617287
              ]
            ]
          ],
          [
            [
              [
                113.67961754212436,
                -28.452241396649715
              ],
              [
                113.70335148440161,
                -28.44842068079297
              ],
              [
                113.71147269957261,
                -28.43909750330978
              ],
              [
                113.72021319531524,
                -28.428123517252892
              ],
              [
                113.73518383393859,
                -28.427570746973824
              ],
              [
                113.74953911074896,
                -28.42757585409065
              ],
              [
                113.73206282095401,
                -28.4429398527188
              ],
              [
                113.71520981833376,
                -28.46214887458323
              ],
              [
                113.7020911573582,
                -28.47201758912821
              ],
              [
                113.69334438832884,
                -28.483538287409836
              ],
              [
                113.68459831318718,
                -28.48627658805468
              ],
              [
                113.68148320608888,
                -28.468161130940196
              ],
              [
                113.67961754212436,
                -28.452241396649715
              ]
            ]
          ],
          [
            [
              [
                146.65113362617313,
                -18.74578202104958
              ],
              [
                146.68344162868112,
                -18.74358500279074
              ],
              [
                146.68425537548555,
                -18.75204831468118
              ],
              [
                146.6740015244552,
                -18.764336954822983
              ],
              [
                146.6630965415762,
                -18.76816168266728
              ],
              [
                146.65447023520542,
                -18.770196169853225
              ],
              [
                146.63754315657758,
                -18.76816168266728
              ],
              [
                146.62501061773074,
                -18.763441684287468
              ],
              [
                146.61695400278944,
                -18.762302467543215
              ],
              [
                146.60279380345133,
                -18.76189538982756
              ],
              [
                146.58285566110237,
                -18.764743732104485
              ],
              [
                146.57016037421508,
                -18.760837588613455
              ],
              [
                146.57056723307082,
                -18.745212412599926
              ],
              [
                146.58277428046708,
                -18.71770596949289
              ],
              [
                146.58204187918633,
                -18.703383137108545
              ],
              [
                146.5766707749961,
                -18.68808361649942
              ],
              [
                146.58130941171083,
                -18.68222409731244
              ],
              [
                146.59229580117193,
                -18.689711327432935
              ],
              [
                146.60132897484067,
                -18.698418889601793
              ],
              [
                146.6111759760077,
                -18.703220305947863
              ],
              [
                146.62232509177036,
                -18.715915728191302
              ],
              [
                146.63412520521186,
                -18.73650485357981
              ],
              [
                146.65113362617313,
                -18.74578202104958
              ]
            ]
          ],
          [
            [
              [
                142.75456791217752,
                -9.369805661520612
              ],
              [
                142.77100670225866,
                -9.373711804400974
              ],
              [
                142.78256269876437,
                -9.386325803799638
              ],
              [
                142.7680770272317,
                -9.398207363758356
              ],
              [
                142.75228925703234,
                -9.408379798386795
              ],
              [
                142.7419539578787,
                -9.419203256735203
              ],
              [
                142.73178143953473,
                -9.424899940223064
              ],
              [
                142.7138778072004,
                -9.42864355232663
              ],
              [
                142.6416121703849,
                -9.428399305746382
              ],
              [
                142.62859133951204,
                -9.424981355750015
              ],
              [
                142.61215255160374,
                -9.416273799881598
              ],
              [
                142.6012475962768,
                -9.39950941136071
              ],
              [
                142.61231528713353,
                -9.383233215394121
              ],
              [
                142.63746179200473,
                -9.37395605099051
              ],
              [
                142.66480552439816,
                -9.374281412683517
              ],
              [
                142.6936141398119,
                -9.37957131912805
              ],
              [
                142.7194930183334,
                -9.377617947270778
              ],
              [
                142.75456791217752,
                -9.369805661520612
              ]
            ]
          ],
          [
            [
              [
                142.2068790988449,
                -9.240166896119009
              ],
              [
                142.2801212883097,
                -9.261651284571668
              ],
              [
                142.28419029596213,
                -9.27752040421028
              ],
              [
                142.27914471500537,
                -9.28704181582721
              ],
              [
                142.26059004735953,
                -9.290215819970195
              ],
              [
                142.222178566068,
                -9.291110789996612
              ],
              [
                142.18083744736734,
                -9.284763382560323
              ],
              [
                142.15088952096121,
                -9.271416942896321
              ],
              [
                142.16423587928986,
                -9.250746409523611
              ],
              [
                142.2068790988449,
                -9.240166896119009
              ]
            ]
          ],
          [
            [
              [
                96.86312909617617,
                -12.181735877618985
              ],
              [
                96.86939537189409,
                -12.18792076103446
              ],
              [
                96.84522545433141,
                -12.197686429743829
              ],
              [
                96.83057702551531,
                -12.179945635226034
              ],
              [
                96.82341555342109,
                -12.150974142066833
              ],
              [
                96.82154381273585,
                -12.126560121647547
              ],
              [
                96.82837975073566,
                -12.126560121647547
              ],
              [
                96.82837975509496,
                -12.136325789840267
              ],
              [
                96.82984459160078,
                -12.144463746586634
              ],
              [
                96.83521569590418,
                -12.16057712943486
              ],
              [
                96.83130943965686,
                -12.171482015748238
              ],
              [
                96.83619224729209,
                -12.182061389891935
              ],
              [
                96.84766686930296,
                -12.187188471076654
              ],
              [
                96.86312909617617,
                -12.181735877618985
              ]
            ]
          ],
          [
            [
              [
                96.90219160850025,
                -12.199965165901975
              ],
              [
                96.89234459141966,
                -12.19589603711234
              ],
              [
                96.8896590450584,
                -12.192803595378585
              ],
              [
                96.88851972880101,
                -12.187432567729205
              ],
              [
                96.90007572057382,
                -12.186781543180306
              ],
              [
                96.90902753328702,
                -12.182061389891935
              ],
              [
                96.91456139105658,
                -12.17351650499083
              ],
              [
                96.91618899585988,
                -12.16179776288314
              ],
              [
                96.92107180805641,
                -12.17351650499083
              ],
              [
                96.92017662966713,
                -12.184991150566093
              ],
              [
                96.91391034634503,
                -12.194512572382667
              ],
              [
                96.90219160850025,
                -12.199965165901975
              ]
            ]
          ],
          [
            [
              [
                105.70411217455676,
                -10.430840748205084
              ],
              [
                105.71469160330393,
                -10.437188423093007
              ],
              [
                105.71265709558894,
                -10.450941649769948
              ],
              [
                105.71143639452042,
                -10.469903258605045
              ],
              [
                105.70630944057534,
                -10.49423593043677
              ],
              [
                105.70630943973057,
                -10.514255453390183
              ],
              [
                105.69792728066733,
                -10.528985291143435
              ],
              [
                105.69988040438253,
                -10.553399340406546
              ],
              [
                105.69459068986124,
                -10.564873943855146
              ],
              [
                105.67872154952225,
                -10.566013273904371
              ],
              [
                105.67351321661125,
                -10.549086191845719
              ],
              [
                105.66724694144276,
                -10.533298439738738
              ],
              [
                105.66407311169175,
                -10.51848722397464
              ],
              [
                105.64926191657267,
                -10.513116160870752
              ],
              [
                105.62818444242659,
                -10.508965768314049
              ],
              [
                105.60499108077038,
                -10.510023682798218
              ],
              [
                105.58497155050884,
                -10.516371357459992
              ],
              [
                105.5817977231867,
                -10.504815375750058
              ],
              [
                105.5922957685403,
                -10.49846770105719
              ],
              [
                105.59961998656244,
                -10.480564044516367
              ],
              [
                105.59424889538953,
                -10.466729439988624
              ],
              [
                105.59424889538164,
                -10.454034127923508
              ],
              [
                105.60718834799107,
                -10.458428654698306
              ],
              [
                105.62712649740529,
                -10.468926684587666
              ],
              [
                105.65455162952014,
                -10.469903258605045
              ],
              [
                105.66928144549367,
                -10.456231372535374
              ],
              [
                105.6852319673473,
                -10.440362241753089
              ],
              [
                105.70411217455676,
                -10.430840748205084
              ]
            ]
          ],
          [
            [
              [
                154.39128666415706,
                -21.030043261168696
              ],
              [
                154.38851972858325,
                -21.02906667090792
              ],
              [
                154.39128666085708,
                -21.028741165855926
              ],
              [
                154.39128666415706,
                -21.030043261168696
              ]
            ]
          ],
          [
            [
              [
                123.59701582368727,
                -12.42831798724742
              ],
              [
                123.59774824016793,
                -12.438571851681287
              ],
              [
                123.57561281944315,
                -12.436781458625957
              ],
              [
                123.57504316869516,
                -12.426609009852713
              ],
              [
                123.59701582368727,
                -12.42831798724742
              ]
            ]
          ]
        ]
      }
    }
  ]
};

export default australiaShape;
